/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * LoanType
 * TODO
 */
export enum SharedMortgageSeSpecMortgageLeftToLiveOutcomeLoanType {
  UNSECURED_LOAN = "UNSECURED_LOAN",
  MORTGAGE = "MORTGAGE",
}

/** Responsibility */
export enum SharedMortgageSeSpecCommonDefinitionsResponsibility {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
  GUARANTOR = "GUARANTOR",
}

/**
 * PropertyType
 * Real estate type
 */
export enum SharedMortgageSeSpecCommonDefinitionsPropertyType {
  CONDOMINIUM = "CONDOMINIUM",
  HOUSE = "HOUSE",
  VACATION_HOME = "VACATION_HOME",
}

/** Responsibility */
export enum SharedMortgageNoSpecCommonDefinitionsResponsibility {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
}

/** DeactivationReason */
export enum SharedMortgageModelsApplicationDeactivationReason {
  CUSTOMER_NOT_REACHABLE = "CUSTOMER_NOT_REACHABLE",
  CUSTOMER_NOT_INTERESTED = "CUSTOMER_NOT_INTERESTED",
  NO_IMPROVEMENT = "NO_IMPROVEMENT",
  NEGATIVE_CALCULATION = "NEGATIVE_CALCULATION",
  LOAN_TO_VALUE_TOO_HIGH = "LOAN_TO_VALUE_TOO_HIGH",
  INSECURE_EMPLOYMENT = "INSECURE_EMPLOYMENT",
  CREDIT_RATING_TOO_LOW = "CREDIT_RATING_TOO_LOW",
  TOO_SMALL_BRF = "TOO_SMALL_BRF",
  HOUS_IN_POOR_CONTITION = "HOUS_IN_POOR_CONTITION",
  RED_MUNICIPALITY = "RED_MUNICIPALITY",
  FIXED_INTEREST_1_YEAR = "FIXED_INTEREST_1_YEAR",
  FIXED_INTEREST_3_YEAR = "FIXED_INTEREST_3_YEAR",
  FIXED_INTEREST_5_YEAR = "FIXED_INTEREST_5_YEAR",
  AGRICULTURAL_PROPERTY = "AGRICULTURAL_PROPERTY",
  MIDDLE_OF_SALES = "MIDDLE_OF_SALES",
  TOO_SMALL_CASH_CONTRIBUTION = "TOO_SMALL_CASH_CONTRIBUTION",
  INCOME_REQUIREMENTS_NOT_MET = "INCOME_REQUIREMENTS_NOT_MET",
  NOT_COMMUNICABLE = "NOT_COMMUNICABLE",
  ONGOING_COMPETITOR = "ONGOING_COMPETITOR",
  ONGOING_DIVORCE = "ONGOING_DIVORCE",
  CONSTRUCTION_CREDIT = "CONSTRUCTION_CREDIT",
  BLANCO_APPLICATION = "BLANCO_APPLICATION",
  DUPLICATE = "DUPLICATE",
  OTHER = "OTHER",
}

/** Status */
export enum SharedModelsStatusStatus {
  LEAD = "LEAD",
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

/** BankStatus */
export enum SharedModelsStatusBankStatus {
  NEW = "NEW",
  ONGOING = "ONGOING",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  DISBURSED = "DISBURSED",
}

/** ImportStatus */
export enum SharedModelsProspectsProspectsUpsertJobsImportStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  PARTIALLY_FAILED = "PARTIALLY_FAILED",
  FAILED = "FAILED",
}

/**
 * ContactType
 * The type of contact, e.g. a phone number or an email address.
 */
export enum SharedModelsProspectsProspectsContactType {
  Phone = "phone",
  Mail = "mail",
}

/** NotificationType */
export enum SharedModelsNotificationsNotificationType {
  OFFER = "OFFER",
  REJECTION = "REJECTION",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  INVITE = "INVITE",
  BANK_COMMENT = "BANK_COMMENT",
  BROKER_COMMENT = "BROKER_COMMENT",
  SIGN_STATUS = "SIGN_STATUS",
  FIRST_INVITE = "FIRST_INVITE",
  DISBURSED = "DISBURSED",
  DEACTIVATED = "DEACTIVATED",
  APPLICATION_CREATED = "APPLICATION_CREATED",
  BOOKING_CHANGED = "BOOKING_CHANGED",
  AUTOINVITE_COMPLETED = "AUTOINVITE_COMPLETED",
  FIRST_BANK_ANSWER = "FIRST_BANK_ANSWER",
}

/** LoanType */
export enum SharedModelsLoanLoanType {
  CREDIT_CARD = "CREDIT_CARD",
  UNSECURED_LOAN = "UNSECURED_LOAN",
  CAR_LOAN = "CAR_LOAN",
  CHECK_CREDIT = "CHECK_CREDIT",
  OTHER = "OTHER",
  STUDENT_LOAN = "STUDENT_LOAN",
  INSTALLMENT = "INSTALLMENT",
  TOP_MORTGAGE_LOAN = "TOP_MORTGAGE_LOAN",
  MEMBER_LOAN = "MEMBER_LOAN",
  MORTGAGE = "MORTGAGE",
}

/** LoanType */
export enum SharedModelsExternalCreditScoreLoanType {
  CSN_STUDENT_LOAN = "CSN_STUDENT_LOAN",
  CSN_STUDENT_MEANS = "CSN_STUDENT_MEANS",
  CSN_INSTALLMENT_LOAN = "CSN_INSTALLMENT_LOAN",
  CSN_INSTALLMENT_LOAN_2022 = "CSN_INSTALLMENT_LOAN_2022",
}

/** EmailStatus */
export enum SharedModelsEmailEmailStatusEmailStatus {
  VERIFIED = "VERIFIED",
  INVALID = "INVALID",
  PRE_VALIDATION_FAILED = "PRE_VALIDATION_FAILED",
  HARD_BOUNCE = "HARD_BOUNCE",
  SOFT_BOUNCE = "SOFT_BOUNCE",
  SPAM = "SPAM",
  REJECT = "REJECT",
}

/** PropertyType */
export enum SharedModelsApplicationPropertyType {
  HOUSE = "HOUSE",
  CONDOMINIUM = "CONDOMINIUM",
  VACATION_HOME = "VACATION_HOME",
  RENTING = "RENTING",
}

/**
 * HousingType
 * The form of housing in which the applicant resides
 */
export enum SharedBlancoSeSpecPrivateUnsecuredLoanApplicationCreatedHousingType {
  RENTED = "RENTED",
  OWN_APARTMENT = "OWN_APARTMENT",
  OWN_HOUSE = "OWN_HOUSE",
  LIVE_IN = "LIVE_IN",
}

/**
 * HousingType
 * The form of housing in which the applicant resides
 */
export enum SharedBlancoNoSpecPrivateUnsecuredLoanApplicationCreatedHousingType {
  COOPERATIVE = "COOPERATIVE",
  LODGER = "LODGER",
  OTHER = "OTHER",
  OWN_APARTMENT = "OWN_APARTMENT",
  OWN_HOUSE = "OWN_HOUSE",
  PARENTS = "PARENTS",
  RENTED = "RENTED",
}

/** DeactivationReason */
export enum SharedBlancoModelsApplicationDeactivationReason {
  Other = "other",
  Moved = "moved",
  FailedCreditCheck = "failedCreditCheck",
  HighRent = "highRent",
  MiddleRent = "middleRent",
  LowRent = "lowRent",
  NoUC = "noUC",
  CallInSix = "callInSix",
  PossibleCreditCard = "possibleCreditCard",
  SentSB = "sentSB",
  Dontcall = "dontcall",
  HighRentBid = "highRentBid",
  HighRentNoBid = "highRentNoBid",
  NoReach = "noReach",
  Duplicate = "duplicate",
  MemberOrCarLoan = "memberOrCarLoan",
  Double = "double",
  UcAlreadyProtected = "ucAlreadyProtected",
  UcNoInterest = "ucNoInterest",
  UcNoTOC = "ucNoTOC",
  UcTooExpensive = "ucTooExpensive",
  UcTookLoanProtection = "ucTookLoanProtection",
  UcTryAgainLater = "ucTryAgainLater",
  PpmNoTime = "ppmNoTime",
  PpmNoInterest = "ppmNoInterest",
  PpmAlreadyHappy = "ppmAlreadyHappy",
  OtherApplicationDisbursed = "otherApplicationDisbursed",
}

/** BankStatus */
export enum SharedApplication2CommonBankStatus {
  NEW = "NEW",
  FILTERED_OUT = "FILTERED_OUT",
  FILTERS_SUCCESS = "FILTERS_SUCCESS",
  ONGOING = "ONGOING",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  DISBURSED = "DISBURSED",
}

/** NotificationType */
export enum ModelsNotificationsNotificationTypesNotificationType {
  SMS_RECEIVED = "SMS_RECEIVED",
  EMAIL_RECEIVED = "EMAIL_RECEIVED",
  OFFER_RECEIVED = "OFFER_RECEIVED",
  BANK_MESSAGE_RECEIVED = "BANK_MESSAGE_RECEIVED",
  INTERNAL_COMMENT_RECEIVED = "INTERNAL_COMMENT_RECEIVED",
  GENERAL_MESSAGE_RECEIVED = "GENERAL_MESSAGE_RECEIVED",
  APPLICATION_ASSIGNED = "APPLICATION_ASSIGNED",
  LEAD_ASSIGNED = "LEAD_ASSIGNED",
  LEAD_COMMENT_RECEIVED = "LEAD_COMMENT_RECEIVED",
  APPLICATION_DISBURSED = "APPLICATION_DISBURSED",
  INSURANCE_SCHEDULED_CANCELLATION = "INSURANCE_SCHEDULED_CANCELLATION",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  APPLICATION_REJECTED = "APPLICATION_REJECTED",
  MEETING_REMINDER = "MEETING_REMINDER",
  CUSTOMER_PORTAL_LOGIN = "CUSTOMER_PORTAL_LOGIN",
  INSURANCE_ACTIVATED = "INSURANCE_ACTIVATED",
  OP_POA_RECEIVED = "OP_POA_RECEIVED",
  OP_RESPONSE_RECEIVED = "OP_RESPONSE_RECEIVED",
  MORTGAGE_COI_FLAGGED = "MORTGAGE_COI_FLAGGED",
  CUSTOMER_DOCUMENT_RECEIVED = "CUSTOMER_DOCUMENT_RECEIVED",
}

/**
 * ApplicationSource
 * Which backend an application/offer was sourced from — tells the frontend which
 * accept endpoint to call during the v2→v3 transition.
 */
export enum ModelsMyPagesApplicationApplicationSource {
  V2 = "v2",
  V3 = "v3",
}

/** EmailStatus */
export enum ModelsEmailCommonEmailStatus {
  RECEIVED = "RECEIVED",
  READ = "READ",
  REPLIED = "REPLIED",
  ARCHIVED = "ARCHIVED",
  SENT = "SENT",
  FAILED = "FAILED",
}

/** ImportStatus */
export enum ModelsDialMaker2SourcesSheetImportStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** ContactType */
export enum ModelsDialMaker2CampaignDataModelsContactType {
  Phone = "phone",
  Mail = "mail",
  Sms = "sms",
}

/** ApplicationSource */
export enum ModelsApplicationMappingApplicationMappingApplicationSource {
  BLANCO = "BLANCO",
  KH_BLANCO = "KH_BLANCO",
  LOG_BLANCO = "LOG_BLANCO",
  HL_BLANCO = "HL_BLANCO",
  WINBACK = "WINBACK",
  DIRECT = "DIRECT",
  RECOMMENDATION = "RECOMMENDATION",
  AFFILIATE_PARTNER = "AFFILIATE_PARTNER",
  TF_AGENCY = "TF_AGENCY",
  AFFILIATE_API = "AFFILIATE_API",
  ONLINE_LEAD = "ONLINE_LEAD",
  OTHER = "OTHER",
  LIKVIDUM = "LIKVIDUM",
  GEOFY = "GEOFY",
  TRYGGA = "TRYGGA",
  KOLL = "KOLL",
  PAMIND = "PÅMIND",
  NSTART = "NSTART",
  SVENSKLANEFORMEDLING = "SVENSK_LÅNEFÖRMEDLING",
  KABOLAN = "KA_BOLÅN",
  PREMIUM = "PREMIUM",
  PLUS1 = "PLUS1",
  FINANSVALPEN = "FINANSVALPEN",
  AXO = "AXO",
  ENKLARE = "ENKLARE",
}

/** AffiliateStatus */
export enum ModelsAffiliatePartnerApplicationAffiliateStatus {
  APP_CREATED = "APP_CREATED",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  OFFER_SIGNED = "OFFER_SIGNED",
  APP_DISBURSED = "APP_DISBURSED",
  APP_DEACTIVATED = "APP_DEACTIVATED",
  LEAD_CREATED = "LEAD_CREATED",
  LEAD_DEACTIVATED = "LEAD_DEACTIVATED",
  APP_NOT_CREATED = "APP_NOT_CREATED",
  SUBMITTED = "SUBMITTED",
}

/** AffiliateStatus */
export enum ModelsAffiliateAffiliateAffiliateStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

/** ZrmTextMessageDirection */
export enum ZrmTextMessageDirection {
  Incoming = "incoming",
  Outgoing = "outgoing",
}

/** ZhatterToolName */
export enum ZhatterToolName {
  GetCustomerDetails = "get_customer_details",
  VerifyCustomerData = "verify_customer_data",
  GetDebtRegister = "get_debt_register",
  GetPropertyValuation = "get_property_valuation",
  GetCustomerInsurances = "get_customer_insurances",
  GetAvailableInsurances = "get_available_insurances",
  CreateInsurance = "create_insurance",
  GetCustomerApplications = "get_customer_applications",
  GetMyCreditScore = "get_my_credit_score",
  GetApplicationOffers = "get_application_offers",
  AcceptOffer = "accept_offer",
  GetCreditCardOffers = "get_credit_card_offers",
  AcceptCreditCardOffer = "accept_credit_card_offer",
  SubmitCreditCardApplication = "submit_credit_card_application",
  GetFullCustomerProfile = "get_full_customer_profile",
  GetFullApplicationDetails = "get_full_application_details",
  PrepareApplication = "prepare_application",
  SubmitApplication = "submit_application",
  RedirectToApplicationForm = "redirect_to_application_form",
}

/** ZhatterSSEEvent */
export enum ZhatterSSEEvent {
  Token = "token",
  ToolCall = "tool_call",
  ToolResult = "tool_result",
  Action = "action",
  Done = "done",
  Error = "error",
  Session = "session",
}

/** ZhatterActionType */
export enum ZhatterActionType {
  GrConsent = "gr_consent",
  GrCredits = "gr_credits",
  GrCta = "gr_cta",
  Offers = "offers",
  ConfirmApplication = "confirm_application",
  InsuranceSuggestions = "insurance_suggestions",
  InsuranceSignupOptions = "insurance_signup_options",
  InsuranceSignupUrl = "insurance_signup_url",
  ApplicationFormRedirect = "application_form_redirect",
}

/** ZProduct */
export enum ZProduct {
  MO = "MO",
  UL = "UL",
  CC = "CC",
  LI = "LI",
  ZL = "ZL",
  AI = "AI",
  OP = "OP",
}

/** ZOffice */
export enum ZOffice {
  ST = "ST",
  UP = "UP",
}

/** ZEmploymentType */
export enum ZEmploymentType {
  FU = "FU",
  PA = "PA",
  UN = "UN",
}

/** ZDepartment */
export enum ZDepartment {
  HL = "HL",
  KA = "KA",
  SK = "SK",
  SP = "SP",
  KH = "KH",
  ON = "ON",
}

/** ZCountry */
export enum ZCountry {
  SE = "SE",
  NO = "NO",
  FI = "FI",
}

/**
 * ValueState
 * ``degraded`` is *not* a state but a flag on the line: a value can be both final and
 * degraded.
 */
export enum ValueState {
  Provisional = "provisional",
  Final = "final",
  Seeded = "seeded",
}

/**
 * ValueFactor
 * The factors of ``v_t = amount x product(multipliers)``.
 *
 * ``RATE_IMPROVEMENT`` is the only one that is a *comparison* rather than a lookup: does
 * the best bid at D beat what the customer already pays? It joined after version 1 was
 * seeded, which is why it is the one factor a stored document may be missing (see
 * :data:`NEUTRAL_OPTIONAL_FACTORS`).
 */
export enum ValueFactor {
  Bid = "bid",
  Credit = "credit",
  Insurance = "insurance",
  Remarks = "remarks",
  RateImprovement = "rate_improvement",
}

/** UpsertCampaignStatus */
export enum UpsertCampaignStatus {
  Created = "created",
  AlreadyExists = "already exists",
  Error = "error",
}

/** UnitOfAmount */
export enum UnitOfAmount {
  SEK = "SEK",
  THOUSAND_SEK = "THOUSAND_SEK",
}

/** TvDashboard */
export enum TvDashboard {
  Mb = "mb",
  Kh = "kh",
  CallsMap = "calls_map",
  WebTraffic = "web_traffic",
  LiveMap = "live_map",
}

/** Touch */
export enum Touch {
  FIRST = "FIRST",
  LAST = "LAST",
}

/** TodoKind */
export enum TodoKind {
  LEAD = "LEAD",
  MEETING = "MEETING",
  FOLLOW_UP = "FOLLOW_UP",
}

/** TemplateEvent */
export enum TemplateEvent {
  OnlineInsuranceReminder1 = "online_insurance_reminder_1",
  OnlineInsuranceReminder2 = "online_insurance_reminder_2",
  Missing2Payments = "missing_2_payments",
  MandateCancelled = "mandate_cancelled",
  SwishPaymentSms = "swish_payment_sms",
  InsuranceInvite = "insurance_invite",
  TooManyApplications = "too_many_applications",
  OnlineTooManyApplicationsNoBid = "online_too_many_applications_no_bid",
  OnlineTooManyApplicationsNotRejectedBids = "online_too_many_applications_not_rejected_bids",
  MainApplicantConfirmation = "main_applicant_confirmation",
  FirstOfferOnline = "first_offer_online",
  OnlineReminderToAccept1 = "online_reminder_to_accept_1",
  OnlineReminderToAccept2 = "online_reminder_to_accept_2",
  OnlineReminderToAccept3 = "online_reminder_to_accept_3",
  OnlineReminderToAccept4 = "online_reminder_to_accept_4",
  OnlineReminderToAccept5 = "online_reminder_to_accept_5",
  OnlineReminderToAccept6 = "online_reminder_to_accept_6",
  OnlineReminderToAccept7 = "online_reminder_to_accept_7",
  OnlineAcceptedOffer1 = "online_accepted_offer_1",
  OnlineAcceptedOffer2 = "online_accepted_offer_2",
  OnlineAcceptedOffer3 = "online_accepted_offer_3",
  OnlineAcceptedOffer4 = "online_accepted_offer_4",
  OnlineAcceptedOffer5 = "online_accepted_offer_5",
  OnlineLateRejection1 = "online_late_rejection_1",
  OnlineAcceptedOfferInsuranceCheck = "online_accepted_offer_insurance_check",
  ApplicationCreated = "application_created",
  ApplicationCreatedReoccurringCustomer = "application_created_reoccurring_customer",
  BookingReminder1H = "booking_reminder_1h",
  SevenDaysBeforeCreditCheckExpires = "seven_days_before_credit_check_expires",
  Disbursement = "disbursement",
  SelfServiceApplicationCreated = "self_service_application_created",
  SelfServiceApplicationCreatedReoccurringCustomer = "self_service_application_created_reoccurring_customer",
  SelfServiceFirstOffer = "self_service_first_offer",
  SelfServiceReminderToAccept1 = "self_service_reminder_to_accept_1",
  SelfServiceReminderToAccept2 = "self_service_reminder_to_accept_2",
  SelfServiceReminderToAccept3 = "self_service_reminder_to_accept_3",
  SelfServiceReminderToAccept4 = "self_service_reminder_to_accept_4",
  SelfServiceReminderToAccept5 = "self_service_reminder_to_accept_5",
  SelfServiceReminderToAccept6 = "self_service_reminder_to_accept_6",
  SelfServiceReminderToAccept7 = "self_service_reminder_to_accept_7",
  ExternalSigningLink = "external_signing_link",
  CoApplicantConfirmation = "co_applicant_confirmation",
  FirstOffer = "first_offer",
  BlancoToCcConversion = "blanco_to_cc_conversion",
  NoAccept = "no_accept",
  BlancoAppCreation = "blanco_app_creation",
  LateDenial = "late_denial",
  CcLateDenialNextOffer = "cc_late_denial_next_offer",
  ReminderToAccept1 = "reminder_to_accept_1",
  ReminderToAccept2 = "reminder_to_accept_2",
  ReminderToAccept3 = "reminder_to_accept_3",
  FullRejection = "full_rejection",
  FailedAutoInvite = "failed_auto_invite",
  AgentAppNoOffers = "agent_app_no_offers",
  OnlineFirst = "online_first",
  OnlineFirstFollowUp = "online_first_follow_up",
  FirstInvite = "first_invite",
  NoBids = "no_bids",
  Gr = "gr",
  FullLeadCreated = "full_lead_created",
  MainApplicantConfirmationPamind = "main_applicant_confirmation_pamind",
  OnlineAcceptedOffer6 = "online_accepted_offer_6",
  OnlineSignedAcceptedOffer = "online_signed_accepted_offer",
  OnlineLateRejection2 = "online_late_rejection_2",
  SecondOfferOnline = "second_offer_online",
  BookingReminder15Min = "booking_reminder_15_min",
  BookingConfirmation = "booking_confirmation",
  ExternalMortgageInterestConfirmation = "external_mortgage_interest_confirmation",
  Test = "test",
  Marketing = "marketing",
  AutoReply = "auto_reply",
}

/** TelavoxLineStatus */
export enum TelavoxLineStatus {
  Up = "up",
  Down = "down",
  Ringing = "ringing",
}

/** TelavoxDirection */
export enum TelavoxDirection {
  In = "in",
  Out = "out",
  Unknown = "unknown",
}

/** TakeoverReason */
export enum TakeoverReason {
  MortgageTakeover = "mortgage_takeover",
  MortgageAuto = "mortgage_auto",
}

/** SverkerClearanceID */
export enum SverkerClearanceID {
  Value1 = "1",
  Value2 = "2",
  Value3 = "3",
  Value5 = "5",
  Value6 = "6",
  Value9 = "9",
  Value10 = "10",
}

/**
 * SverkerBookingType
 * Whether a Sverker booking is a real appointment or a planned follow-up.
 *
 * Here rather than in applications-manager because both ends of the wire need the
 * vocabulary: the migrator sets it on `ZrmBookingEvent` and ZRM reads it off the same
 * field. apps-mgr imports this rather than keeping a second copy.
 */
export enum SverkerBookingType {
  Booked = "booked",
  Planned = "planned",
}

/** Substatus */
export enum Substatus {
  DRAFT = "DRAFT",
  UNKNOWN = "UNKNOWN",
  OFFERED = "OFFERED",
  ACCEPTED = "ACCEPTED",
  DISBURSED = "DISBURSED",
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

/** SubmissionStatus */
export enum SubmissionStatus {
  Error = "error",
  AppCreated = "app_created",
  AppNotAllowed = "app_not_allowed",
}

/** Status */
export enum StatusInput {
  LEAD = "LEAD",
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

/**
 * SourceType
 * The source of the prospect, e.g. a form submission, an import, etc.
 */
export enum SourceType {
  Online = "online",
  File = "file",
  EmailSubscription = "email_subscription",
  ExternalSource = "external_source",
}

/** SnippetEventType */
export enum SnippetEventType {
  CREATED = "CREATED",
  UPDATED = "UPDATED",
  DELETED = "DELETED",
  RESTORED = "RESTORED",
}

/** SnippetContext */
export enum SnippetContext {
  SMS = "SMS",
  EMAIL = "EMAIL",
  COMMENT = "COMMENT",
}

/** SkipReason */
export enum SkipReason {
  CancelledInZrm = "cancelled_in_zrm",
  PastWithoutCopy = "past_without_copy",
  NotInSnapshot = "not_in_snapshot",
  NoCustomer = "no_customer",
  DifferentCustomers = "different_customers",
}

/** SkaOverrideSource */
export enum SkaOverrideSource {
  OnlineFirst = "online_first",
  Online = "online",
  Manual = "manual",
}

/** Situation */
export enum Situation {
  SOLD = "SOLD",
  WILL_SELL = "WILL_SELL",
  ONLY_BUY = "ONLY_BUY",
}

/** SheetType */
export enum SheetType {
  XLSX = "XLSX",
  CSV = "CSV",
}

/** ShareNameConsent */
export enum ShareNameConsent {
  NO_CONSENT = "NO_CONSENT",
  INITIALS_ONLY = "INITIALS_ONLY",
  FULL_NAMES = "FULL_NAMES",
}

/** SearchType */
export enum SearchType {
  APPLICATION_ID = "APPLICATION_ID",
  PORTAL_APP_ID = "PORTAL_APP_ID",
  PERSONAL_DATA = "PERSONAL_DATA",
  EXTERNAL_ID = "EXTERNAL_ID",
}

/** SearchScope */
export enum SearchScope {
  All = "all",
  Customer = "customer",
  Application = "application",
  Handler = "handler",
  MyNotifications = "my_notifications",
}

/**
 * ScopeAxis
 * How a row is scoped. `lead_id` is intentionally absent in v1 — mortgage-lead
 * sources are deferred (their `applicant.customer_id` is CSFLE-encrypted/unindexed).
 */
export enum ScopeAxis {
  AppLabel = "app_label",
  InsuranceId = "insurance_id",
}

/** SSEEvent */
export enum SSEEvent {
  Meetings = "meetings",
  Customers = "customers",
  Applications = "applications",
  OpApplications = "op_applications",
  Insurances = "insurances",
  InsuranceList = "insurance_list",
  InsurancesRules = "insurances_rules",
  CoApplicantInsuranceList = "co_applicant_insurance_list",
  CoApplicantInsuranceRules = "co_applicant_insurance_rules",
  Pagination = "pagination",
  Messages = "messages",
  ApplicationsHistory = "applications_history",
  FullApplicationsHistory = "full_applications_history",
  OpApplicationsHistory = "op_applications_history",
  Aml = "aml",
  OpAml = "op_aml",
  CoApplicant = "co_applicant",
  Comments = "comments",
  Outcomes = "outcomes",
  Calls = "calls",
  ApplicationSummary = "application_summary",
  ActiveUsers = "active_users",
  Done = "done",
  Error = "error",
  Zenscriptions = "zenscriptions",
  BankIdVerified = "bank_id_verified",
  MessageSuggestions = "message_suggestions",
  ApplicationMapper = "application_mapper",
  MultipleApplicationMappers = "multiple_application_mappers",
  InviteZRay = "invite_z_ray",
  Todomaker = "todomaker",
  TodomakerLead = "todomaker_lead",
  SkaImpact = "ska_impact",
  DialmakerLeads = "dialmaker_leads",
  CustomerLogins = "customer_logins",
  CoApplicantCustomerLogins = "co_applicant_customer_logins",
  CaseDocuments = "case_documents",
  LeftToLiveEstimate = "left_to_live_estimate",
  DisbursalDates = "disbursal_dates",
}

/**
 * RoutingRule
 * Which row of the plan's rule table decided. Logged by routing.route_inbound and stored on center items.
 */
export enum RoutingRule {
  ACTIVE_OWNER = "ACTIVE_OWNER",
  ACTIVE_OWNER_QUIT = "ACTIVE_OWNER_QUIT",
  ONLINE_APP = "ONLINE_APP",
  IN_DISTRIBUTION = "IN_DISTRIBUTION",
  ACTIVE_NO_OWNER = "ACTIVE_NO_OWNER",
  RECENTLY_DEACTIVATED_OWNER = "RECENTLY_DEACTIVATED_OWNER",
  RECENTLY_DEACTIVATED_OWNER_QUIT = "RECENTLY_DEACTIVATED_OWNER_QUIT",
  INSURANCE_SELLER = "INSURANCE_SELLER",
  INSURANCE_SELLER_QUIT = "INSURANCE_SELLER_QUIT",
  NOTHING_MATCHED = "NOTHING_MATCHED",
  UNKNOWN_SENDER = "UNKNOWN_SENDER",
  RECENT_SENDER = "RECENT_SENDER",
  ROUTING_FAILED = "ROUTING_FAILED",
}

/** RoleType */
export enum RoleType {
  EmployeeAdmin = "employee:admin",
  PartnerAdmin = "partner:admin",
  MortgageAdmin = "mortgage:admin",
  LegalAdmin = "legal:admin",
  ZensumSakerReadSalesStats = "zensum-saker:read:sales-stats",
  ZakerInsuranceCreate = "zaker:insurance:create",
  Admin = "admin",
  ImpersonateCustomer = "impersonate-customer",
  REMOTE_ACCESS = "REMOTE_ACCESS",
  READ_BLANCO_SALES_STATS = "READ_BLANCO_SALES_STATS",
  READ_MORTGAGE_SALES_STATS = "READ_MORTGAGE_SALES_STATS",
  InsuranceAdmin = "insurance:admin",
  OnlineAdmin = "online:admin",
  MbAdmin = "mb:admin",
  KdltAdmin = "kdlt:admin",
  DataAdmin = "data:admin",
  TemplateAdmin = "template:admin",
  AffiliateAdmin = "affiliate:admin",
  Developer = "developer",
  FiltersRead = "filters:read",
  FiltersAdmin = "filters:admin",
  TmCampaignAdmin = "tm-campaign:admin",
  TmCampaignRead = "tm-campaign:read",
  DialmakerAdmin = "dialmaker:admin",
  TeamLead = "team-lead",
  MailmakerAdmin = "mailmaker:admin",
  LeadtakerAdmin = "leadtaker:admin",
  ComplianceAdmin = "compliance:admin",
  FinanceRead = "finance:read",
  MoveToZrm = "move-to-zrm",
}

/** ReprocessStatus */
export enum ReprocessStatus {
  Success = "success",
  Failure = "failure",
  Pending = "pending",
}

/** RelationshipStatus */
export enum RelationshipStatus {
  Spouse = "spouse",
  Child = "child",
  Parent = "parent",
  Partner = "partner",
}

/** RateType */
export enum RateType {
  Fixed = "fixed",
  Flexible = "flexible",
  Mixed = "mixed",
}

/** Product */
export enum Product {
  Blanco = "blanco",
  Mortgage = "mortgage",
  CreditCard = "credit_card",
  OccupationalPension = "occupational_pension",
}

/**
 * ProcessCampaignType
 * Process campaigns. Every member below is in active use.
 *
 * Fifteen aspirational names were removed on 2026-08-19. Nothing had ever created them:
 * `validate_process` rejects each one for every product, so a campaign carrying one could not exist.
 * Verified against production first — all 17 PROCESS campaigns and every lead carried only the values
 * below. Their only consumer was `process_applications.py`, which had no importers and moved leads into
 * those impossible campaigns, so it was removed with them.
 */
export enum ProcessCampaignType {
  LATE_REJECTED = "LATE_REJECTED",
  OFFERED_NO_ACCEPT = "OFFERED_NO_ACCEPT",
  ACCEPTED_NOT_DISBURSED = "ACCEPTED_NOT_DISBURSED",
  ABOUT_TO_BE_CANCELED = "ABOUT_TO_BE_CANCELED",
  CANCELED = "CANCELED",
  FREE_FOR_ALL = "FREE_FOR_ALL",
  FREE_FOR_ALL_ACCEPTED = "FREE_FOR_ALL_ACCEPTED",
  ONLINE_FIRST_COI = "ONLINE_FIRST_COI",
  ONLINE_FIRST_COI_ZRM_ONLY = "ONLINE_FIRST_COI_ZRM_ONLY",
  SELF_SERVICE_NOT_INVITED = "SELF_SERVICE_NOT_INVITED",
  SELF_SERVICE_INVITE_FAILED = "SELF_SERVICE_INVITE_FAILED",
  SELF_SERVICE_NO_OFFERS = "SELF_SERVICE_NO_OFFERS",
  SELF_SERVICE_NO_ACCEPT = "SELF_SERVICE_NO_ACCEPT",
  SELF_SERVICE_NO_ACCEPT_INSURANCE = "SELF_SERVICE_NO_ACCEPT_INSURANCE",
  SELF_SERVICE_NOT_SIGNED = "SELF_SERVICE_NOT_SIGNED",
  SELF_SERVICE_NOT_DISBURSED = "SELF_SERVICE_NOT_DISBURSED",
  SELF_SERVICE_LATE_DENIED = "SELF_SERVICE_LATE_DENIED",
  SELF_SERVICE_DISBURSED_INSURANCE = "SELF_SERVICE_DISBURSED_INSURANCE",
}

/**
 * PolicyPreference
 * Determines which leads to include
 */
export enum PolicyPreference {
  INCLUDE = "INCLUDE",
  EXCLUDE = "EXCLUDE",
  DONTCARE = "DONTCARE",
}

/** PhoneNumberType */
export enum PhoneNumberType {
  Home = "home",
  Day = "day",
  Work = "work",
  Other = "other",
}

/** PersonStatus */
export enum PersonStatus {
  INITIALIZED = "INITIALIZED",
  WEBSITE_VISIT = "WEBSITE_VISIT",
  LEAD_CREATED = "LEAD_CREATED",
  APPLICATION_CREATED = "APPLICATION_CREATED",
  INVITE = "INVITE",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  OFFER = "OFFER",
  DISBURSED = "DISBURSED",
  DISCARDED = "DISCARDED",
  INSURANCE_CREATED = "INSURANCE_CREATED",
  BANK_ID_LOGIN = "BANK_ID_LOGIN",
  GR_SHARED = "GR_SHARED",
  GR_SHARED_NEW = "GR_SHARED_NEW",
  GR_SHARED_NEW_DEBT = "GR_SHARED_NEW_DEBT",
  EV_SHARED = "EV_SHARED",
  EV_SHARED_NEW = "EV_SHARED_NEW",
  MY_CREDIT_SCORE = "MY_CREDIT_SCORE",
  MY_CREDIT_SCORE_NEW = "MY_CREDIT_SCORE_NEW",
}

/** PaymentProvider */
export enum PaymentProvider {
  Trustly = "Trustly",
  GoCardless = "Go Cardless",
  AXA = "AXA",
  Vipps = "Vipps",
  Avtalegiro = "Avtalegiro",
}

/** PageType */
export enum PageType {
  Today = "today",
  Old = "old",
  NextShift = "next_shift",
  ALL_ACTIVE = "ALL_ACTIVE",
  ALL_ONLINE = "ALL_ONLINE",
  ALL_UNASSIGNED = "ALL_UNASSIGNED",
}

/**
 * OwnerSource
 * How this record came to be. ``planner`` and ``button`` are the only two that open a
 * case by a distribution decision, which is what the rotation key counts.
 */
export enum OwnerSource {
  Planner = "planner",
  Button = "button",
  Adopted = "adopted",
  Manual = "manual",
  Override = "override",
  MortgageTakeover = "mortgage_takeover",
  MortgageAuto = "mortgage_auto",
  Seed = "seed",
}

/** OverrideType */
export enum OverrideType {
  CLOSE_DAY = "CLOSE_DAY",
  CLOSE_HOURS = "CLOSE_HOURS",
  ADD_HOURS = "ADD_HOURS",
  SET_CAPACITY = "SET_CAPACITY",
}

/** OutcomeType */
export enum OutcomeType {
  SUCCESS = "SUCCESS",
  CALL_BACK = "CALL_BACK",
  NO_CONTACT = "NO_CONTACT",
  FAILURE = "FAILURE",
  DISCARD = "DISCARD",
}

/** Outcome */
export enum Outcome {
  Converted = "converted",
  MergedWithDifferences = "merged_with_differences",
  Skipped = "skipped",
  Failed = "failed",
}

/**
 * OriginState
 * Whether the application's first owner could be read off its history.
 *
 * ``ambiguous`` is more than one record that first held the application — legitimate after a
 * partial supersede recovery, which copies applications without naming the record it copied
 * them from. The row then says so instead of guessing a first owner.
 */
export enum OriginState {
  Resolved = "resolved",
  Ambiguous = "ambiguous",
}

/** OnlineFormEventType */
export enum OnlineFormEventType {
  ERROR = "ERROR",
  CLICK = "CLICK",
  NAVIGATION = "NAVIGATION",
  SUBMISSION = "SUBMISSION",
  UPDATE = "UPDATE",
  SHOW = "SHOW",
  ADD_CUSTOMER_IDENTITY = "ADD_CUSTOMER_IDENTITY",
  REQUEST_DATA = "REQUEST_DATA",
  CHAT = "CHAT",
  COMPARE_DEBT = "COMPARE_DEBT",
}

/** OnlineFormEventSubType */
export enum OnlineFormEventSubType {
  VALIDATION = "VALIDATION",
  BUTTON = "BUTTON",
  START = "START",
  FORWARD = "FORWARD",
  BACKWARD = "BACKWARD",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  EXPOSED = "EXPOSED",
  LOADED = "LOADED",
  MESSAGE_SENT = "MESSAGE_SENT",
  ACTION_CLICKED = "ACTION_CLICKED",
  APPLY_STARTED = "APPLY_STARTED",
  SESSION_RESUMED = "SESSION_RESUMED",
  CONSENT_SUBMITTED = "CONSENT_SUBMITTED",
  CONSENT_FAILED = "CONSENT_FAILED",
  CTA_CLICKED = "CTA_CLICKED",
  FORM_OPENED = "FORM_OPENED",
  SEE_ALL_CREDITS_CLICKED = "SEE_ALL_CREDITS_CLICKED",
}

/** OfferStatus */
export enum OfferStatus {
  Approved = "approved",
  Created = "created",
  Edited = "edited",
  Rejected = "rejected",
  Ongoing = "ongoing",
}

/** OfferHistoryKind */
export enum OfferHistoryKind {
  ACCEPT_REQUESTED = "ACCEPT_REQUESTED",
  ACCEPT_CONFIRMED = "ACCEPT_CONFIRMED",
  ACCEPT_FAILED = "ACCEPT_FAILED",
  SUPERSEDED = "SUPERSEDED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

/**
 * OfferCondition
 * A condition the bank attached to its offer (OpenBroker ``condition``, NO only).
 *
 * The offer can be accepted while the condition is open, but the bank will not disburse until it
 * is fulfilled -- so the customer has to be told before accepting. Plus1 is the first bank to use
 * it: it requires a co-applicant before paying out.
 *
 * Mirrors the enum in the NO PrivateUnsecuredLoan spec.
 */
export enum OfferCondition {
  CO_APPLICANT_NEEDED = "CO_APPLICANT_NEEDED",
}

/** OPStatus */
export enum OPStatus {
  CREATED = "CREATED",
  REGISTERED = "REGISTERED",
  DEACTIVATED = "DEACTIVATED",
  PENDING = "PENDING",
  WAITING_FOR_POA = "WAITING_FOR_POA",
  POA_RECEIVED = "POA_RECEIVED",
  RESPONSE_RECEIVED = "RESPONSE_RECEIVED",
}

/** OPDeactivationReason */
export enum OPDeactivationReason {
  NoAnswer = "no_answer",
  NotInterested = "not_interested",
  NotRelevant = "not_relevant",
  NonTransferablePolicies = "non_transferable_policies",
  TransferablePolicyAmountTooLow = "transferable_policy_amount_too_low",
}

/** NotificationType */
export enum NotificationTypeOutput {
  SMS_RECEIVED = "SMS_RECEIVED",
  EMAIL_RECEIVED = "EMAIL_RECEIVED",
  OFFER_RECEIVED = "OFFER_RECEIVED",
  BANK_MESSAGE_RECEIVED = "BANK_MESSAGE_RECEIVED",
  INTERNAL_COMMENT_RECEIVED = "INTERNAL_COMMENT_RECEIVED",
  GENERAL_MESSAGE_RECEIVED = "GENERAL_MESSAGE_RECEIVED",
  APPLICATION_ASSIGNED = "APPLICATION_ASSIGNED",
  LEAD_ASSIGNED = "LEAD_ASSIGNED",
  LEAD_COMMENT_RECEIVED = "LEAD_COMMENT_RECEIVED",
  APPLICATION_DISBURSED = "APPLICATION_DISBURSED",
  INSURANCE_SCHEDULED_CANCELLATION = "INSURANCE_SCHEDULED_CANCELLATION",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  APPLICATION_REJECTED = "APPLICATION_REJECTED",
  MEETING_REMINDER = "MEETING_REMINDER",
  CUSTOMER_PORTAL_LOGIN = "CUSTOMER_PORTAL_LOGIN",
  INSURANCE_ACTIVATED = "INSURANCE_ACTIVATED",
  OP_POA_RECEIVED = "OP_POA_RECEIVED",
  OP_RESPONSE_RECEIVED = "OP_RESPONSE_RECEIVED",
  MORTGAGE_COI_FLAGGED = "MORTGAGE_COI_FLAGGED",
  CUSTOMER_DOCUMENT_RECEIVED = "CUSTOMER_DOCUMENT_RECEIVED",
}

/** NotificationEvent */
export enum NotificationEvent {
  CREATED = "CREATED",
  RECEIVED = "RECEIVED",
  READ = "READ",
  UNREAD = "UNREAD",
  DELETED = "DELETED",
}

/** NotificationDelivery */
export enum NotificationDelivery {
  OFF = "OFF",
  SILENT = "SILENT",
  TOAST = "TOAST",
  PUSH = "PUSH",
}

/** NoContactOutcomes */
export enum NoContactOutcomes {
  NotConnected = "not_connected",
  Busy = "busy",
  AnsweringMachine = "answering_machine",
  NoAnswer = "no_answer",
}

/** MortgageStatus */
export enum MortgageStatus {
  PENDING_APPLICATION_SIGN = "PENDING_APPLICATION_SIGN",
  PENDING_DOCUMENTS = "PENDING_DOCUMENTS",
  DOCUMENT_REVIEW = "DOCUMENT_REVIEW",
  PENDING_ACCEPT = "PENDING_ACCEPT",
  PENDING_LOAN_ARRANGEMENT = "PENDING_LOAN_ARRANGEMENT",
  PENDING_PROMISSORY_NOTE_GENERATION = "PENDING_PROMISSORY_NOTE_GENERATION",
  PENDING_PROMISSORY_NOTE_SIGN = "PENDING_PROMISSORY_NOTE_SIGN",
  PENDING_DISBURSMENT = "PENDING_DISBURSMENT",
  DISBURSED = "DISBURSED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
}

/** MortgagePropertyType */
export enum MortgagePropertyType {
  HOUSE = "HOUSE",
  CONDOMINIUM = "CONDOMINIUM",
  VACATION_HOME = "VACATION_HOME",
}

/** MortgageLoanType */
export enum MortgageLoanType {
  REFINANCE = "REFINANCE",
  PRE_APPROVAL = "PRE_APPROVAL",
  BUY = "BUY",
  BUY_AND_SELL = "BUY_AND_SELL",
}

/** MonoDocumentType */
export enum MonoDocumentType {
  PAYSLIP = "PAYSLIP",
  TAX_RETURN = "TAX_RETURN",
  EMPLOYMENT_CONTRACT = "EMPLOYMENT_CONTRACT",
  PURCHASE_CONTRACT = "PURCHASE_CONTRACT",
  VALUATION = "VALUATION",
  PROPERTY_PROSPECTUS = "PROPERTY_PROSPECTUS",
  LOAN_DOCUMENT = "LOAN_DOCUMENT",
  ID_DOCUMENT = "ID_DOCUMENT",
  BANK_STATEMENT = "BANK_STATEMENT",
  OTHER = "OTHER",
}

/** MetadataSource */
export enum MetadataSource {
  GR_CONSENT = "GR_CONSENT",
  ONLINE_SUBMISSION_CONSENTS = "ONLINE_SUBMISSION_CONSENTS",
  MY_PAGES_CONSENTS = "MY_PAGES_CONSENTS",
  MY_PAGES_INSURANCE_TERMS_ACCEPTED = "MY_PAGES_INSURANCE_TERMS_ACCEPTED",
  MY_CREDIT_SCORE = "MY_CREDIT_SCORE",
  OTHER = "OTHER",
}

/** MessengerEnterBehavior */
export enum MessengerEnterBehavior {
  Send = "send",
  NewLine = "new_line",
}

/** MessageType */
export enum MessageType {
  SMS = "SMS",
  EMAIL = "EMAIL",
}

/**
 * MeetingSubject
 * A lower number is a higher priority. Steps of 10 leave room for a new subject between two others.
 *
 * Do not remove or renumber a member: stored meetings keep the number and must still validate.
 */
export enum MeetingSubject {
  Value10 = 10,
  Value20 = 20,
  Value30 = 30,
  Value40 = 40,
}

/** MaritalStatus */
export enum MaritalStatus {
  Unmarried = "unmarried",
  Married = "married",
  Divorced = "divorced",
  WidowWidower = "widow/widower",
  Deceased = "deceased",
  ChildUnder18Years = "child under 18 years",
  PreviouslyMarried = "previously married",
  RegisteredPartnership = "registered partnership",
  Partner = "partner",
}

/** ManualApplicationState */
export enum ManualApplicationState {
  AwaitingInvites = "awaiting_invites",
  NotInvited = "not_invited",
  BiddingInProgress = "bidding_in_progress",
  Offered = "offered",
  BiddingComplete = "bidding_complete",
  Rejected = "rejected",
  BidsExpired = "bids_expired",
  Accepted = "accepted",
  LateRejected = "late_rejected",
  PendingToBeSent = "pending_to_be_sent",
  Signed = "signed",
  SignedAccordingToCustomer = "signed_according_to_customer",
  Disbursed = "disbursed",
  DisbursedAccordingToCustomer = "disbursed_according_to_customer",
}

/** MainContact */
export enum MainContact {
  Applicant = "applicant",
  CoApplicant = "coApplicant",
  Guarantor = "guarantor",
}

/**
 * LoginResponseType
 * How the post-login redirect hands the session to the frontend: always a single-use code.
 */
export enum LoginResponseType {
  Code = "code",
}

/** LoginEntryPoint */
export enum LoginEntryPoint {
  MY_PAGES = "MY_PAGES",
  ONLINE_FORM = "ONLINE_FORM",
  GR_FIRST = "GR_FIRST",
  EV_FIRST = "EV_FIRST",
  CAR_EVAL = "CAR_EVAL",
  CREDIT_SCORE = "CREDIT_SCORE",
  COMPARE_DEBT = "COMPARE_DEBT",
  CHAT = "CHAT",
}

/** LoanType */
export enum LoanTypeInput {
  CREDIT_CARD = "CREDIT_CARD",
  UNSECURED_LOAN = "UNSECURED_LOAN",
  CAR_LOAN = "CAR_LOAN",
  CHECK_CREDIT = "CHECK_CREDIT",
  OTHER = "OTHER",
  STUDENT_LOAN = "STUDENT_LOAN",
  INSTALLMENT = "INSTALLMENT",
  TOP_MORTGAGE_LOAN = "TOP_MORTGAGE_LOAN",
  MEMBER_LOAN = "MEMBER_LOAN",
  MORTGAGE = "MORTGAGE",
}

/** LoanPurposeSE */
export enum LoanPurposeSE {
  Refinance = "refinance",
  HomeRemodelling = "homeRemodelling",
  HealthcareExpenses = "healthcareExpenses",
  DivorceProceeding = "divorceProceeding",
  HomeDownpayment = "homeDownpayment",
  Investment = "investment",
  Education = "education",
  Travel = "travel",
  Car = "car",
  Other = "other",
  DriversLicense = "driversLicense",
  Wedding = "wedding",
  Relocation = "relocation",
  Interior = "interior",
  Consumption = "consumption",
  DebtCollection = "debtCollection",
  LoanOnBehalfOfOther = "loan-on-behalf-of-other",
  InvestmentAbroad = "investment-abroad",
}

/** LoanPurposeNO */
export enum LoanPurposeNO {
  Refinance = "refinance",
  HomeRemodelling = "homeRemodelling",
  HealthcareExpenses = "healthcareExpenses",
  DivorceProceeding = "divorceProceeding",
  HomeDownpayment = "homeDownpayment",
  Investment = "investment",
  Education = "education",
  Travel = "travel",
  Car = "car",
  Other = "other",
  DriversLicense = "driversLicense",
  Wedding = "wedding",
  Relocation = "relocation",
  Interior = "interior",
  Consumption = "consumption",
  DebtCollection = "debtCollection",
}

/** LoanPurpose */
export enum LoanPurpose {
  Refinance = "refinance",
  HomeRemodelling = "homeRemodelling",
  HealthcareExpenses = "healthcareExpenses",
  DivorceProceeding = "divorceProceeding",
  HomeDownpayment = "homeDownpayment",
  Investment = "investment",
  Education = "education",
  Travel = "travel",
  Car = "car",
  Other = "other",
  DriversLicense = "driversLicense",
  Wedding = "wedding",
  Relocation = "relocation",
  Interior = "interior",
  Consumption = "consumption",
  DebtCollection = "debtCollection",
  LoanOnBehalfOfOther = "loan-on-behalf-of-other",
  InvestmentAbroad = "investment-abroad",
}

/** ListSortBy */
export enum ListSortBy {
  MeetingStart = "meeting_start",
  CreatedAt = "created_at",
  SubjectPriority = "subject_priority",
}

/** LegacyApplicantsRelationship */
export enum LegacyApplicantsRelationship {
  Family = "family",
  Friend = "friend",
  Colleague = "colleague",
  Other = "other",
}

/** LeftToLiveFields */
export enum LeftToLiveFields {
  ExistingMortgage = "existing_mortgage",
  BuyingInfo = "buying_info",
  BooliValuation = "booli_valuation",
  GuarantorEmployer = "guarantor_employer",
  CoApplicantEmployer = "co_applicant_employer",
  MainApplicantEmployer = "main_applicant_employer",
  LoanPurpose = "loan_purpose",
  MortgageLoanAmount = "mortgage_loan_amount",
  NewMortgageLoan = "new_mortgage_loan",
  Property = "property",
  Applicant = "applicant",
  Municipality = "municipality",
  ExistingLoanAmount = "existing_loan_amount",
  ExistingLoanRefinance = "existing_loan_refinance",
  ExistingLoanResponsibility = "existing_loan_responsibility",
  ExistingLoanType = "existing_loan_type",
}

/**
 * LeftToLiveEstimateWarning
 * Something in the case the advisor should check; the estimate is given all the same.
 */
export enum LeftToLiveEstimateWarning {
  RefinanceExceedsDesiredLoan = "refinance_exceeds_desired_loan",
  HousingCountedOnce = "housing_counted_once",
}

/**
 * LeftToLiveEstimateSource
 * Where the figure on a line comes from.
 */
export enum LeftToLiveEstimateSource {
  NationalBudget = "national_budget",
  Zensum = "zensum",
  Case = "case",
  Advisor = "advisor",
}

/**
 * LeftToLiveEstimateMissingInput
 * An input the case lacks; the estimate lists it so the advisor can fill it in.
 */
export enum LeftToLiveEstimateMissingInput {
  Income = "income",
  Housing = "housing",
  LoanMonthlyPayment = "loan_monthly_payment",
}

/**
 * LeftToLiveEstimateLineKey
 * The lines of an estimate in the order they are shown: income, then the thirteen cost lines, with the household
 * costs as the four SIFO household lines.
 */
export enum LeftToLiveEstimateLineKey {
  Income = "income",
  Adults = "adults",
  Children = "children",
  EverydayItems = "everyday_items",
  HouseholdGoods = "household_goods",
  Furniture = "furniture",
  MediaLeisure = "media_leisure",
  Car = "car",
  Childcare = "childcare",
  Electricity = "electricity",
  Insurance = "insurance",
  Housing = "housing",
  ExistingLoans = "existing_loans",
  NewLoan = "new_loan",
}

/** LeadStatus */
export enum LeadStatus {
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
  FAILED = "FAILED",
  DEACTIVATED = "DEACTIVATED",
  DISCARD = "DISCARD",
}

/**
 * Language
 * Supported languages for application summary.
 */
export enum Language {
  En = "en",
  Sv = "sv",
  Nb = "nb",
}

/**
 * Lane
 * The 12 UI categories (design) + `score` (backend-only, not a v1 UI chip).
 */
export enum Lane {
  Identity = "identity",
  Application = "application",
  Aml = "aml",
  Comm = "comm",
  Call = "call",
  Meeting = "meeting",
  Web = "web",
  Lead = "lead",
  Bankid = "bankid",
  Insurance = "insurance",
  Doc = "doc",
  Audit = "audit",
  Score = "score",
}

/** KDLTEvent */
export enum KDLTEvent {
  CUSTOMER_CREATED = "CUSTOMER_CREATED",
  CUSTOMER_UPDATED = "CUSTOMER_UPDATED",
  UC_ID_CHECK = "UC_ID_CHECK",
  UC_CREDIT_CHECK = "UC_CREDIT_CHECK",
  EXPERIAN_ID_CHECK = "EXPERIAN_ID_CHECK",
  EXPERIAN_CREDIT_CHECK = "EXPERIAN_CREDIT_CHECK",
  CM1_PEP_CHECK = "CM1_PEP_CHECK",
  GJELDSREGISTERET_CREDITS = "GJELDSREGISTERET_CREDITS",
  GJELDSREGISTERET_CONSENT = "GJELDSREGISTERET_CONSENT",
  CUSTOMER_DELETED = "CUSTOMER_DELETED",
  CUSTOMER_ACCESSED = "CUSTOMER_ACCESSED",
  PEP_SANCTION_WHITELISTING = "PEP_SANCTION_WHITELISTING",
  DOCUMENT_ADDED = "DOCUMENT_ADDED",
  PROPERTY_EV_CHECK = "PROPERTY_EV_CHECK",
  MANUALLY_BLOCKED = "MANUALLY_BLOCKED",
  CUSTOMER_CLUSTER = "CUSTOMER_CLUSTER",
  EXTERNAL_BLOCK_CHECK = "EXTERNAL_BLOCK_CHECK",
  DATA_FACTORY_CHECK = "DATA_FACTORY_CHECK",
  DATA_FACTORY_ID_CHECK = "DATA_FACTORY_ID_CHECK",
  NO_DIREKT_ASSIGNMENT = "NO_DIREKT_ASSIGNMENT",
  UC_CREDIT_SCORE = "UC_CREDIT_SCORE",
  EXPERIAN_CREDIT_SCORE = "EXPERIAN_CREDIT_SCORE",
  CM1_DEACTIVATED = "CM1_DEACTIVATED",
}

/** JobType */
export enum JobType {
  Scheduled = "scheduled",
  Failed = "failed",
  Started = "started",
  Finished = "finished",
}

/** IntentionOfExcessAmount */
export enum IntentionOfExcessAmount {
  BUYING_PROPERTY = "BUYING_PROPERTY",
  REPAYMENT_OTHER_LOANS = "REPAYMENT_OTHER_LOANS",
  RENOVATION_OF_PROPERTY = "RENOVATION_OF_PROPERTY",
  BUYING_CAPITAL_GOODS = "BUYING_CAPITAL_GOODS",
  OTHER_CONSUMPTION = "OTHER_CONSUMPTION",
}

/** IntegrationAction */
export enum IntegrationAction {
  INVITE = "INVITE",
  SEND_INVITES = "SEND_INVITES",
  AUTO_INVITE = "AUTO_INVITE",
  COMMENTS = "COMMENTS",
  DOCUMENTS = "DOCUMENTS",
  ACCEPT = "ACCEPT",
  CANCEL = "CANCEL",
}

/** InsuranceType */
export enum InsuranceType {
  AXA_ZS_SE = "AXA_ZS_SE",
  AXA_ZS_NO = "AXA_ZS_NO",
  Z8 = "Z8",
  Z6 = "Z6",
  Z1 = "Z1",
  AXA_O1_SE = "AXA_O1_SE",
  EVL_L1_NO = "EVL_L1_NO",
  EVL_L2_SE = "EVL_L2_SE",
}

/** InsuranceSubstatus */
export enum InsuranceSubstatus {
  WAITING_FOR_CUSTOMER_ACCEPTANCE = "WAITING_FOR_CUSTOMER_ACCEPTANCE",
  WAITING_FOR_BANK = "WAITING_FOR_BANK",
  INACTIVE_MANDATE = "INACTIVE_MANDATE",
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  PENDING_CANCELLATION = "PENDING_CANCELLATION",
  SCHEDULED_CANCELLATION = "SCHEDULED_CANCELLATION",
  DISCARDED = "DISCARDED",
}

/** InsuranceStatus */
export enum InsuranceStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** InsuranceGroup */
export enum InsuranceGroup {
  SAFETY_INSURANCE = "SAFETY_INSURANCE",
  ACCIDENT_INSURANCE = "ACCIDENT_INSURANCE",
  LIFE_INSURANCE = "LIFE_INSURANCE",
}

/** InsuranceEventType */
export enum InsuranceEventType {
  INSURANCE_CREATED = "INSURANCE_CREATED",
  INSURANCE_SIGNUP_URL = "INSURANCE_SIGNUP_URL",
  INSURANCE_UPDATED = "INSURANCE_UPDATED",
  INSURANCE_CANCELLED = "INSURANCE_CANCELLED",
  INSURANCE_PREMIUM_CHANGED = "INSURANCE_PREMIUM_CHANGED",
  PAYMENT_DAY_ADJUSTED = "PAYMENT_DAY_ADJUSTED",
  INSURANCE_PAYMENT_PROVIDER_CHANGED = "INSURANCE_PAYMENT_PROVIDER_CHANGED",
  INSURANCE_PENDING_CANCELLATION = "INSURANCE_PENDING_CANCELLATION",
  CUSTOMER_ACCEPTED_TERMS = "CUSTOMER_ACCEPTED_TERMS",
  CUSTOMER_REQUESTED_SIGNUP_DATA = "CUSTOMER_REQUESTED_SIGNUP_DATA",
  GO_CARDLESS_MANDATE_CREATED = "GO_CARDLESS_MANDATE_CREATED",
  GO_CARDLESS_MANDATE_SUBMITTED = "GO_CARDLESS_MANDATE_SUBMITTED",
  GO_CARDLESS_ACCOUNT_INFO = "GO_CARDLESS_ACCOUNT_INFO",
  GO_CARDLESS_MANDATE_ACQUIRED = "GO_CARDLESS_MANDATE_ACQUIRED",
  GO_CARDLESS_MANDATE_CANCELLED = "GO_CARDLESS_MANDATE_CANCELLED",
  GO_CARDLESS_SUBSCRIPTION_CREATED = "GO_CARDLESS_SUBSCRIPTION_CREATED",
  GO_CARDLESS_SUBSCRIPTION_SUBMITTED = "GO_CARDLESS_SUBSCRIPTION_SUBMITTED",
  GO_CARDLESS_SUBSCRIPTION_CANCELLED = "GO_CARDLESS_SUBSCRIPTION_CANCELLED",
  GO_CARDLESS_PAYMENT_CREATED = "GO_CARDLESS_PAYMENT_CREATED",
  GO_CARDLESS_PAYMENT_CONFIRMED = "GO_CARDLESS_PAYMENT_CONFIRMED",
  GO_CARDLESS_PAYMENT_FAILED = "GO_CARDLESS_PAYMENT_FAILED",
  GO_CARDLESS_PAYMENT_CANCELLED = "GO_CARDLESS_PAYMENT_CANCELLED",
  GO_CARDLESS_PAYMENT_RESUBMISSION_REQUESTED = "GO_CARDLESS_PAYMENT_RESUBMISSION_REQUESTED",
  GO_CARDLESS_REFUND_CREATED = "GO_CARDLESS_REFUND_CREATED",
  GO_CARDLESS_REFUND_PAID = "GO_CARDLESS_REFUND_PAID",
  TRUSTLY_INITIATED = "TRUSTLY_INITIATED",
  TRUSTLY_ACCOUNT_INFO = "TRUSTLY_ACCOUNT_INFO",
  TRUSTLY_MANDATE_ACQUIRED = "TRUSTLY_MANDATE_ACQUIRED",
  TRUSTLY_MANDATE_CANCELLED = "TRUSTLY_MANDATE_CANCELLED",
  TRUSTLY_MANDATE_CANCEL_INITIATED = "TRUSTLY_MANDATE_CANCEL_INITIATED",
  TRUSTLY_MANDATE_CANCEL_FAILED = "TRUSTLY_MANDATE_CANCEL_FAILED",
  TRUSTLY_MANDATE_IMPORT_FAILED = "TRUSTLY_MANDATE_IMPORT_FAILED",
  GO_CARDLESS_MANDATE_FAILED = "GO_CARDLESS_MANDATE_FAILED",
  TRUSTLY_MANDATE_SIGNUP_CANCELLED = "TRUSTLY_MANDATE_SIGNUP_CANCELLED",
  TRUSTLY_UNKNOWN_EVENT = "TRUSTLY_UNKNOWN_EVENT",
  SCRIVE_SIGNATURE = "SCRIVE_SIGNATURE",
  TRUSTLY_CHARGE_INITIATED = "TRUSTLY_CHARGE_INITIATED",
  TRUSTLY_PENDING_CHARGE = "TRUSTLY_PENDING_CHARGE",
  TRUSTLY_ACCOUNT_CHARGED = "TRUSTLY_ACCOUNT_CHARGED",
  TRUSTLY_CHARGE_CANCELLED = "TRUSTLY_CHARGE_CANCELLED",
  TRUSTLY_CHARGE_INITIATION_FAILED = "TRUSTLY_CHARGE_INITIATION_FAILED",
  TRUSTLY_CHARGE_REFUNDED = "TRUSTLY_CHARGE_REFUNDED",
  TRUSTLY_CHARGE_REFUND_FAILED = "TRUSTLY_CHARGE_REFUND_FAILED",
  TRUSTLY_REFUND_INITIATED = "TRUSTLY_REFUND_INITIATED",
  TRUSTLY_REFUND_INITIATION_FAILED = "TRUSTLY_REFUND_INITIATION_FAILED",
  TRUSTLY_CANCEL_ORDER_INITIATED = "TRUSTLY_CANCEL_ORDER_INITIATED",
  TRUSTLY_CANCEL_ORDER_FAILED = "TRUSTLY_CANCEL_ORDER_FAILED",
  INVITATION_EMAIL_SENT = "INVITATION_EMAIL_SENT",
  INVITATION_EMAIL_SENT_AGAIN = "INVITATION_EMAIL_SENT_AGAIN",
  INVITATION_EMAIL_REMINDER_SENT = "INVITATION_EMAIL_REMINDER_SENT",
  SIGNUP_CONFIRMATION_EMAIL_SENT = "SIGNUP_CONFIRMATION_EMAIL_SENT",
  SIGNUP_CONFIRMATION_EMAIL_SENT_AGAIN = "SIGNUP_CONFIRMATION_EMAIL_SENT_AGAIN",
  FAILED_TO_CHARGE_EMAIL_SENT = "FAILED_TO_CHARGE_EMAIL_SENT",
  FAILED_TO_CHARGE_EMAIL_SENT_AGAIN = "FAILED_TO_CHARGE_EMAIL_SENT_AGAIN",
  AVTALEGIRO_PAYMENT_NOTICE_EMAIL_SENT = "AVTALEGIRO_PAYMENT_NOTICE_EMAIL_SENT",
  MANDATE_CANCELLED_EMAIL_SENT = "MANDATE_CANCELLED_EMAIL_SENT",
  MANDATE_CANCELLED_EMAIL_SENT_AGAIN = "MANDATE_CANCELLED_EMAIL_SENT_AGAIN",
  NEW_MANDATE_ACCOUNT_INFO_RECEIVED_EMAIL_SENT = "NEW_MANDATE_ACCOUNT_INFO_RECEIVED_EMAIL_SENT",
  NEW_MANDATE_ACCOUNT_INFO_RECEIVED_EMAIL_SENT_AGAIN = "NEW_MANDATE_ACCOUNT_INFO_RECEIVED_EMAIL_SENT_AGAIN",
  CANCEL_EMAIL_UNPAID_PREMIUM_SENT = "CANCEL_EMAIL_UNPAID_PREMIUM_SENT",
  CANCEL_EMAIL_UNPAID_PREMIUM_SENT_AGAIN = "CANCEL_EMAIL_UNPAID_PREMIUM_SENT_AGAIN",
  CANCEL_EMAIL_CUSTOMER_AGE_SENT = "CANCEL_EMAIL_CUSTOMER_AGE_SENT",
  CANCEL_EMAIL_CUSTOMER_AGE_SENT_AGAIN = "CANCEL_EMAIL_CUSTOMER_AGE_SENT_AGAIN",
  CANCEL_EMAIL_MANDATE_CANCELLED_SENT = "CANCEL_EMAIL_MANDATE_CANCELLED_SENT",
  CANCEL_EMAIL_MANDATE_CANCELLED_SENT_AGAIN = "CANCEL_EMAIL_MANDATE_CANCELLED_SENT_AGAIN",
  CANCEL_EMAIL_GENERIC_SENT = "CANCEL_EMAIL_GENERIC_SENT",
  CANCEL_EMAIL_GENERIC_SENT_AGAIN = "CANCEL_EMAIL_GENERIC_SENT_AGAIN",
  NEW_MANDATE_ACQUIRED_EMAIL_SENT = "NEW_MANDATE_ACQUIRED_EMAIL_SENT",
  NEW_MANDATE_ACQUIRED_EMAIL_SENT_AGAIN = "NEW_MANDATE_ACQUIRED_EMAIL_SENT_AGAIN",
  MOVE_MANDATE_EMAIL_SENT = "MOVE_MANDATE_EMAIL_SENT",
  MOVE_MANDATE_SMS_SENT = "MOVE_MANDATE_SMS_SENT",
  REQUEST_NEW_MANDATE_EMAIL_SENT = "REQUEST_NEW_MANDATE_EMAIL_SENT",
  REQUEST_NEW_MANDATE_LINK_CREATED = "REQUEST_NEW_MANDATE_LINK_CREATED",
  WINBACK_FEEDBACK = "WINBACK_FEEDBACK",
  VIPPS_INITIATED = "VIPPS_INITIATED",
  VIPPS_MANDATE_ACQUIRED = "VIPPS_MANDATE_ACQUIRED",
  VIPPS_MANDATE_EXPIRED = "VIPPS_MANDATE_EXPIRED",
  VIPPS_MANDATE_FAILED = "VIPPS_MANDATE_FAILED",
  VIPPS_MANDATE_CANCELLED = "VIPPS_MANDATE_CANCELLED",
  VIPPS_CHARGE_INITIATED = "VIPPS_CHARGE_INITIATED",
  VIPPS_CHARGE_PENDING = "VIPPS_CHARGE_PENDING",
  VIPPS_CHARGE_CANCELLED = "VIPPS_CHARGE_CANCELLED",
  VIPPS_ACCOUNT_CHARGED = "VIPPS_ACCOUNT_CHARGED",
  VIPPS_CHARGE_FAILED = "VIPPS_CHARGE_FAILED",
  VIPPS_CHARGE_REFUNDED = "VIPPS_CHARGE_REFUNDED",
  CUSTOMER_DECEASED = "CUSTOMER_DECEASED",
  WARNING_BEFORE_CANCELLATION = "WARNING_BEFORE_CANCELLATION",
  YEARLY_RENEWAL_LETTER_SENT = "YEARLY_RENEWAL_LETTER_SENT",
  YEARLY_RENEWAL_LETTER_SENT_AGAIN = "YEARLY_RENEWAL_LETTER_SENT_AGAIN",
  BLUE_BUTTON_CANCELLATION_QUEUED = "BLUE_BUTTON_CANCELLATION_QUEUED",
  BLUE_BUTTON_CANCELLATION_REMOVED = "BLUE_BUTTON_CANCELLATION_REMOVED",
  SWISH_PAYMENT_SMS_SENT = "SWISH_PAYMENT_SMS_SENT",
  SWISH_PAYMENT_INITIATED = "SWISH_PAYMENT_INITIATED",
  SWISH_PAYMENT_CONFIRMED = "SWISH_PAYMENT_CONFIRMED",
  SWISH_PAYMENT_FAILED = "SWISH_PAYMENT_FAILED",
  SWISH_REFUND_INITIATED = "SWISH_REFUND_INITIATED",
  SWISH_REFUND_CONFIRMED = "SWISH_REFUND_CONFIRMED",
  SWISH_REFUND_FAILED = "SWISH_REFUND_FAILED",
  AVTALEGIRO_INITIATED = "AVTALEGIRO_INITIATED",
  AVTALEGIRO_MANDATE_ACQUIRED = "AVTALEGIRO_MANDATE_ACQUIRED",
  AVTALEGIRO_MANDATE_CANCELLED = "AVTALEGIRO_MANDATE_CANCELLED",
  AVTALEGIRO_MANDATE_FAILED = "AVTALEGIRO_MANDATE_FAILED",
  AVTALEGIRO_CHARGE_INITIATED = "AVTALEGIRO_CHARGE_INITIATED",
  AVTALEGIRO_CHARGE_FAILED = "AVTALEGIRO_CHARGE_FAILED",
  AVTALEGIRO_CHARGE_CANCELLED = "AVTALEGIRO_CHARGE_CANCELLED",
  AVTALEGIRO_PENDING_CHARGE = "AVTALEGIRO_PENDING_CHARGE",
  AVTALEGIRO_OCR_PAYMENT_REJECTED = "AVTALEGIRO_OCR_PAYMENT_REJECTED",
  AVTALEGIRO_OCR_PAYMENT_RETURNED = "AVTALEGIRO_OCR_PAYMENT_RETURNED",
  AVTALEGIRO_OCR_AMOUNT_MISMATCH = "AVTALEGIRO_OCR_AMOUNT_MISMATCH",
  AVTALEGIRO_ACCOUNT_CHARGED = "AVTALEGIRO_ACCOUNT_CHARGED",
  AVTALEGIRO_CHARGE_REFUNDED = "AVTALEGIRO_CHARGE_REFUNDED",
  INVOICE_GENERATED = "INVOICE_GENERATED",
  INVOICE_PAID = "INVOICE_PAID",
  INVOICE_CHARGE_FAILED = "INVOICE_CHARGE_FAILED",
}

/** InstallmentChargePeriod */
export enum InstallmentChargePeriod {
  YEARLY = "YEARLY",
  QUARTERLY = "QUARTERLY",
  HALF_YEARLY = "HALF_YEARLY",
  MONTHLY = "MONTHLY",
}

/** IncomingInsuranceEvent */
export enum IncomingInsuranceEvent {
  MANDATE_CANCELLED = "MANDATE_CANCELLED",
  SCHEDULED_CANCELLATION = "SCHEDULED_CANCELLATION",
  SWISH_PAYMENT_SMS = "SWISH_PAYMENT_SMS",
}

/** IncomeType */
export enum IncomeType {
  Rent = "rent",
  Other = "other",
  Employment = "employment",
  Partner = "partner",
}

/** IncomeAndTaxationIncomeCode */
export enum IncomeAndTaxationIncomeCode {
  PERSON_IS_NOT_ZEROTAXED = "PERSON_IS_NOT_ZEROTAXED",
  AUTOMATIC_ZEROTAXED = "AUTOMATIC_ZEROTAXED",
  MANUAL_ZEROTAXED = "MANUAL_ZEROTAXED",
  NO_TAXATION_DETAILS_FROM_SKV = "NO_TAXATION_DETAILS_FROM_SKV",
}

/** InboundChannel */
export enum InboundChannel {
  SMS = "SMS",
  EMAIL = "EMAIL",
}

/** ImportStatus */
export enum ImportStatusInput {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** IDKollenAuthStatusResponse */
export enum IDKollenAuthStatusResponse {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** HousingTypeSE */
export enum HousingTypeSE {
  RENTED = "RENTED",
  CONDOMINIUM = "CONDOMINIUM",
  LIVE_IN = "LIVE_IN",
  OWN_HOUSE = "OWN_HOUSE",
}

/** HousingTypeNO */
export enum HousingTypeNO {
  RENTED = "RENTED",
  OWN_HOUSE = "OWN_HOUSE",
  PARENTS = "PARENTS",
  CONDOMINIUM = "CONDOMINIUM",
  OWN_APARTMENT = "OWN_APARTMENT",
}

/** HeimdallTrackingType */
export enum HeimdallTrackingType {
  Apps = "apps",
  Customers = "customers",
  Insurances = "insurances",
  Leads = "leads",
}

/**
 * HTTPStatus
 * HTTP status codes and reason phrases
 *
 * Status codes from the following RFCs are all observed:
 *
 *     * RFC 9110: HTTP Semantics, obsoletes 7231, which obsoleted 2616
 *     * RFC 6585: Additional HTTP Status Codes
 *     * RFC 3229: Delta encoding in HTTP
 *     * RFC 4918: HTTP Extensions for WebDAV, obsoletes 2518
 *     * RFC 5842: Binding Extensions to WebDAV
 *     * RFC 7238: Permanent Redirect
 *     * RFC 2295: Transparent Content Negotiation in HTTP
 *     * RFC 2774: An HTTP Extension Framework
 *     * RFC 7725: An HTTP Status Code to Report Legal Obstacles
 *     * RFC 7540: Hypertext Transfer Protocol Version 2 (HTTP/2)
 *     * RFC 2324: Hyper Text Coffee Pot Control Protocol (HTCPCP/1.0)
 *     * RFC 8297: An HTTP Status Code for Indicating Hints
 *     * RFC 8470: Using Early Data in HTTP
 */
export enum HTTPStatus {
  Value100 = 100,
  Value101 = 101,
  Value102 = 102,
  Value103 = 103,
  Value200 = 200,
  Value201 = 201,
  Value202 = 202,
  Value203 = 203,
  Value204 = 204,
  Value205 = 205,
  Value206 = 206,
  Value207 = 207,
  Value208 = 208,
  Value226 = 226,
  Value300 = 300,
  Value301 = 301,
  Value302 = 302,
  Value303 = 303,
  Value304 = 304,
  Value305 = 305,
  Value307 = 307,
  Value308 = 308,
  Value400 = 400,
  Value401 = 401,
  Value402 = 402,
  Value403 = 403,
  Value404 = 404,
  Value405 = 405,
  Value406 = 406,
  Value407 = 407,
  Value408 = 408,
  Value409 = 409,
  Value410 = 410,
  Value411 = 411,
  Value412 = 412,
  Value413 = 413,
  Value4131 = 413,
  Value414 = 414,
  Value4142 = 414,
  Value415 = 415,
  Value416 = 416,
  Value4163 = 416,
  Value417 = 417,
  Value418 = 418,
  Value421 = 421,
  Value422 = 422,
  Value4224 = 422,
  Value423 = 423,
  Value424 = 424,
  Value425 = 425,
  Value426 = 426,
  Value428 = 428,
  Value429 = 429,
  Value431 = 431,
  Value451 = 451,
  Value500 = 500,
  Value501 = 501,
  Value502 = 502,
  Value503 = 503,
  Value504 = 504,
  Value505 = 505,
  Value506 = 506,
  Value507 = 507,
  Value508 = 508,
  Value510 = 510,
  Value511 = 511,
}

/** GoalType */
export enum GoalType {
  BLANCO = "BLANCO",
  MORTGAGE = "MORTGAGE",
  INITIAL_BLANCO = "INITIAL_BLANCO",
  BLANCO_MB = "BLANCO_MB",
  BUDGET_HL = "BUDGET_HL",
  BUDGET_KA = "BUDGET_KA",
  BUDGET_SK = "BUDGET_SK",
  BUDGET_SP = "BUDGET_SP",
  NATIVE_BUDGET = "NATIVE_BUDGET",
}

/** Gender */
export enum Gender {
  Male = "male",
  Female = "female",
  Other = "other",
}

/** FilteringReason */
export enum FilteringReason {
  BLOCK_LIST = "BLOCK_LIST",
  ALREADY_CONSUMED = "ALREADY_CONSUMED",
  EXTRACTION_LIMIT = "EXTRACTION_LIMIT",
}

/**
 * ExtendedProduct
 * Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed
 */
export enum ExtendedProduct {
  Blanco = "blanco",
  Mortgage = "mortgage",
  CreditCard = "credit_card",
  LoanInsurance = "loan_insurance",
  LifeInsurance = "life_insurance",
  AccidentInsurance = "accident_insurance",
  OccupationalPension = "occupational_pension",
}

/** EnqueuedJobStatus */
export enum EnqueuedJobStatus {
  Success = "success",
  Failure = "failure",
  Pending = "pending",
  InProgress = "in_progress",
}

/**
 * EndedOfferReason
 * Why an offer the bank no longer stands behind ended. The customer still sees it, but cannot accept it.
 */
export enum EndedOfferReason {
  WITHDRAWN = "WITHDRAWN",
  DENIED_AFTER_ACCEPTANCE = "DENIED_AFTER_ACCEPTANCE",
  REPLACED = "REPLACED",
}

/** EmploymentTypeSE */
export enum EmploymentTypeSE {
  Full = "full",
  Trial = "trial",
  Retired = "retired",
  Hourly = "hourly",
  EarlyRetired = "earlyRetired",
  Project = "project",
  SelfEmployed = "selfEmployed",
  CompanyOwner = "companyOwner",
  NoWork = "noWork",
}

/** EmploymentTypeNO */
export enum EmploymentTypeNO {
  Full = "full",
  SelfEmployed = "selfEmployed",
  Retired = "retired",
  TemporarilyDischarged = "temporarilyDischarged",
  Other = "other",
  Disabled = "disabled",
  Trial = "trial",
  Hourly = "hourly",
  Student = "student",
  NoWork = "noWork",
  StandIn = "standIn",
  Project = "project",
  NorwegianSickLeave = "norwegianSickLeave",
}

/** EmploymentType */
export enum EmploymentType {
  Full = "full",
  Trial = "trial",
  Retired = "retired",
  Hourly = "hourly",
  EarlyRetired = "earlyRetired",
  Project = "project",
  SelfEmployed = "selfEmployed",
  CompanyOwner = "companyOwner",
  NoWork = "noWork",
  TemporarilyDischarged = "temporarilyDischarged",
  Student = "student",
  StandIn = "standIn",
  NorwegianSickLeave = "norwegianSickLeave",
  Disabled = "disabled",
  Other = "other",
}

/** EmailStatusSource */
export enum EmailStatusSource {
  MANDRILL = "MANDRILL",
  EMAIL_LIST_VERIFY = "EMAIL_LIST_VERIFY",
}

/** EmailStatus */
export enum EmailStatusOutput {
  VERIFIED = "VERIFIED",
  INVALID = "INVALID",
  PRE_VALIDATION_FAILED = "PRE_VALIDATION_FAILED",
  HARD_BOUNCE = "HARD_BOUNCE",
  SOFT_BOUNCE = "SOFT_BOUNCE",
  SPAM = "SPAM",
  REJECT = "REJECT",
}

/** EducationType */
export enum EducationType {
  ElementarySchool = "elementarySchool",
  HighSchool = "highSchool",
  Value1YearUniversity = "1yearUniversity",
  Value2YearsUniversity = "2yearsUniversity",
  Value3YearsUniversity = "3yearsUniversity",
  MoreThan3YearsUniversity = "moreThan3yearsUniversity",
}

/** DynamicMetaParamsValues */
export enum DynamicMetaParamsValues {
  AbandonedFormId = "abandoned_form_id",
}

/** DynamicMetaParamsPlacement */
export enum DynamicMetaParamsPlacement {
  Path = "path",
  Query = "query",
}

/** DraftCheck */
export enum DraftCheck {
  AddedNumber = "added_number",
  MissingFact = "missing_fact",
  NotAnExample = "not_an_example",
}

/**
 * DocumentType
 * Document type
 */
export enum DocumentType {
  AMORTIZATION_PLAN = "AMORTIZATION_PLAN",
  PETITION_FOR_DIVORCE = "PETITION_FOR_DIVORCE",
  CERTIFICATE_OF_EMPLOYMENT = "CERTIFICATE_OF_EMPLOYMENT",
  DIVISION_OF_PROPERTY_AGREEMENT = "DIVISION_OF_PROPERTY_AGREEMENT",
  VERIFY_ESCROW_AGREEMENT = "VERIFY_ESCROW_AGREEMENT",
  FINANCIAL_FORECASTING_FOR_TENANT_OWNERSHIP_ASSOCIATION = "FINANCIAL_FORECASTING_FOR_TENANT_OWNERSHIP_ASSOCIATION",
  POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",
  PHYSICAL_MORTGAGE_DEEDS = "PHYSICAL_MORTGAGE_DEEDS",
  INTERMEDIATION_AGREEMENT_INCLUDING_STARTING_PRICE = "INTERMEDIATION_AGREEMENT_INCLUDING_STARTING_PRICE",
  DEED_OF_GIFT = "DEED_OF_GIFT",
  PURCHASE_AGREEMENT = "PURCHASE_AGREEMENT",
  CONTRACTORS_AGREEMENT = "CONTRACTORS_AGREEMENT",
  APARTMENT_CERTIFICATE = "APARTMENT_CERTIFICATE",
  COLLATERAL_OBJECT_DESCRIPTION = "COLLATERAL_OBJECT_DESCRIPTION",
  PENSION_PROJECTION = "PENSION_PROJECTION",
  PENSION_SPECIFICATION = "PENSION_SPECIFICATION",
  AUDITORS_CERTIFICATE = "AUDITORS_CERTIFICATE",
  LATEST_APPROVED_INCOME_STATEMENT_AND_NE3_APPENDIX = "LATEST_APPROVED_INCOME_STATEMENT_AND_NE3_APPENDIX",
  LATEST_APPROVED_INCOME_STATEMENT_AND_NE_APPENDIX = "LATEST_APPROVED_INCOME_STATEMENT_AND_NE_APPENDIX",
  FINAL_INVOICE = "FINAL_INVOICE",
  SALES_AGREEMENT = "SALES_AGREEMENT",
  INFORMATION_TO_CONTACT_PERSON = "INFORMATION_TO_CONTACT_PERSON",
  TENURE_AGREEMENT = "TENURE_AGREEMENT",
  VALUATION = "VALUATION",
  VALUATION_OF_COMPLETED_PROPERTY = "VALUATION_OF_COMPLETED_PROPERTY",
  VALUATION_FROM_INDEPENDENT_BROKER = "VALUATION_FROM_INDEPENDENT_BROKER",
  TRANSFER_AGREEMENT = "TRANSFER_AGREEMENT",
  VALUATION_CERTIFICATE = "VALUATION_CERTIFICATE",
  CASH_DEPOSIT_DOCUMENTATION = "CASH_DEPOSIT_DOCUMENTATION",
  PRELIMINARY_SETTLEMENT_NOTE = "PRELIMINARY_SETTLEMENT_NOTE",
  ORIGINAL_BILL_OF_PURCHASE = "ORIGINAL_BILL_OF_PURCHASE",
  TITLE_DEED = "TITLE_DEED",
  FINAL_SERVEYING_PROTOCOL = "FINAL_SERVEYING_PROTOCOL",
  FINAL_CLEARANCE = "FINAL_CLEARANCE",
  INVOICES = "INVOICES",
  STATEMENT_OF_ACCOUNT = "STATEMENT_OF_ACCOUNT",
  PAYSLIP = "PAYSLIP",
  ANNUAL_REPORT_HOUSING_SOCIETY = "ANNUAL_REPORT_HOUSING_SOCIETY",
  ANNUAL_REPORT_SELF_EMPLOYED = "ANNUAL_REPORT_SELF_EMPLOYED",
  SPOUSE_CONSENT = "SPOUSE_CONSENT",
  OTHER_INCOME_CERTIFICATES = "OTHER_INCOME_CERTIFICATES",
  ESTATE_INVENTORY = "ESTATE_INVENTORY",
  LOAN_TERMS_OPTIONS = "LOAN_TERMS_OPTIONS",
  INSTRUMENT_OF_DEBT = "INSTRUMENT_OF_DEBT",
  KNOW_YOUR_CUSTOMER_QUESTIONS = "KNOW_YOUR_CUSTOMER_QUESTIONS",
  COPY_OF_IDENTIFICATION_CARD = "COPY_OF_IDENTIFICATION_CARD",
  INCOME_TAX_RETURN = "INCOME_TAX_RETURN",
  ENERGY_DECLARATION = "ENERGY_DECLARATION",
  OTHER = "OTHER",
}

/** Direction */
export enum Direction {
  INCOMING = "INCOMING",
  OUTGOING = "OUTGOING",
}

/** DeliveryStatus */
export enum DeliveryStatus {
  DELIVERY_PENDING = "DELIVERY_PENDING",
  DELIVERY_SUCCESS_COMPLETED = "DELIVERY_SUCCESS_COMPLETED",
  DELIVERY_SUCCESS_SKIPPED = "DELIVERY_SUCCESS_SKIPPED",
  DELIVERY_FAILURE_RETRYABLE = "DELIVERY_FAILURE_RETRYABLE",
  DELIVERY_FAILURE_FINAL = "DELIVERY_FAILURE_FINAL",
  DATA_FAILURE_RETRYABLE = "DATA_FAILURE_RETRYABLE",
  DATA_FAILURE_FINAL = "DATA_FAILURE_FINAL",
}

/** DefaultSearchTab */
export enum DefaultSearchTab {
  Navigation = "navigation",
  Cases = "cases",
  Mortgages = "mortgages",
  Leads = "leads",
  CreditCardApplications = "creditCardApplications",
  Insurances = "insurances",
  InternalUsers = "internal_users",
  Customers = "customers",
}

/** DefaultCalendarView */
export enum DefaultCalendarView {
  DayGridMonth = "dayGridMonth",
  AppViewWeek = "appViewWeek",
  AppViewDay = "appViewDay",
}

/** CustomerLoginProvider */
export enum CustomerLoginProvider {
  BANK_ID = "BANK_ID",
  VIPPS = "VIPPS",
}

/** CustomerCancellationRequestReason */
export enum CustomerCancellationRequestReason {
  NO_LONGER_QUALIFIED = "NO_LONGER_QUALIFIED",
  SIGNED_UP_FOR_ANOTHER_INSURANCE = "SIGNED_UP_FOR_ANOTHER_INSURANCE",
  INSURANCE_TO_EXPENSIVE = "INSURANCE_TO_EXPENSIVE",
  DID_NOT_TAKE_THE_LOAN = "DID_NOT_TAKE_THE_LOAN",
  NO_MORE_LOANS = "NO_MORE_LOANS",
  BLUE_BUTTON = "BLUE_BUTTON",
  OTHER = "OTHER",
}

/** Currency */
export enum Currency {
  EUR = "EUR",
  SEK = "SEK",
  NOK = "NOK",
}

/**
 * CreditorProduct
 * Which credit product the bank's offer actually is (OpenBroker ``creditorProduct``).
 *
 * Introduced for the unsecured-loan flow: Bank Norwegian answers an unsecured-loan application
 * with either an unsecured loan or its Credit Line product, and handlers and customers need to
 * tell the two apart. Credit Line is a new product of its own -- not a credit card.
 *
 * It is not limited to that flow, though: NO mortgages (MONO) are brokered over the same NO
 * PrivateUnsecuredLoan schema, so those offers carry it too and use ``MORTGAGE_LOAN``.
 *
 * Mirrors the enum in the NO PrivateUnsecuredLoan spec. Only the values a bank can send are
 * listed: ``None`` on an offer already means "the source never told us", so there is no
 * UNSPECIFIED member.
 */
export enum CreditorProduct {
  UNSECURED_LOAN = "UNSECURED_LOAN",
  CREDIT_CARD = "CREDIT_CARD",
  CREDIT_LINE = "CREDIT_LINE",
  MORTGAGE_LOAN = "MORTGAGE_LOAN",
}

/** CreditTypeSE */
export enum CreditTypeSE {
  CREDITCARD = "CREDITCARD",
  INSTALLMENT = "INSTALLMENT",
  CARLOAN = "CARLOAN",
  TOPLOAN = "TOPLOAN",
  PRIVATELOAN = "PRIVATELOAN",
  MEMBERLOAN = "MEMBERLOAN",
  CHECKCREDIT = "CHECKCREDIT",
  UNKNOWN = "UNKNOWN",
  MORTGAGE = "MORTGAGE",
}

/** CreditTypeNO */
export enum CreditTypeNO {
  CREDITCARD = "CREDITCARD",
  CARLOAN = "CARLOAN",
  PRIVATELOAN = "PRIVATELOAN",
  CHECKCREDIT = "CHECKCREDIT",
  UNKNOWN = "UNKNOWN",
  STUDENTLOAN = "STUDENTLOAN",
  MORTGAGE = "MORTGAGE",
}

/** CreditType */
export enum CreditType {
  CREDIT_CARD = "CREDIT_CARD",
  CHARGE_CARD = "CHARGE_CARD",
  INSTALLMENTS = "INSTALLMENTS",
  LOAN_WITHOUT_SECURITY = "LOAN_WITHOUT_SECURITY",
  LOAN_WITH_SECURITY = "LOAN_WITH_SECURITY",
  HOUSING_CREDIT_HOUSES = "HOUSING_CREDIT_HOUSES",
  HOUSING_CREDIT_TENANT_OWNERS_RIGHT = "HOUSING_CREDIT_TENANT_OWNERS_RIGHT",
  LEASING = "LEASING",
}

/** CreditResponsibility */
export enum CreditResponsibility {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
  GUARANTOR = "GUARANTOR",
}

/** Country */
export enum Country {
  SE = "SE",
  NO = "NO",
}

/** ConvertToBlancoStatus */
export enum ConvertToBlancoStatus {
  Success = "success",
  Failure = "failure",
  InProgress = "in_progress",
  NotEligible = "not_eligible",
  Enqueued = "enqueued",
}

/**
 * ContactSource
 * Source of customer contact for cancellation
 */
export enum ContactSource {
  PHONE = "PHONE",
  SMS = "SMS",
  EMAIL = "EMAIL",
  VOICEMAIL = "VOICEMAIL",
}

/**
 * ConsentsPolicyPreference
 * Determines which leads to include
 */
export enum ConsentsPolicyPreference {
  INCLUDE_ONLY_WITH = "INCLUDE_ONLY_WITH",
  INCLUDE_ONLY_WITHOUT = "INCLUDE_ONLY_WITHOUT",
  INCLUDE_ALL = "INCLUDE_ALL",
  EXCLUDE_ONLY_WITHOUT = "EXCLUDE_ONLY_WITHOUT",
}

/** ComplaintType */
export enum ComplaintType {
  BANKRUPTCY = "BANKRUPTCY",
  DEFAULT_JUDGEMENT = "DEFAULT_JUDGEMENT",
  REPOSSESSION_WITH_GOODS = "REPOSSESSION_WITH_GOODS",
  REPOSSESSION_WITHOUT_GOODS = "REPOSSESSION_WITHOUT_GOODS",
  SEIZURE_ATTEMPT_DEBT_UNPAID = "SEIZURE_ATTEMPT_DEBT_UNPAID",
  UNPAID_TAX_MOVED_TO_S_E_A = "UNPAID_TAX_MOVED_TO_S_E_A",
  VAT_MOVED_TO_S_E_A = "VAT_MOVED_TO_S_E_A",
  EXCISE_DUTY = "EXCISE_DUTY",
  ORDER_TO_PAY_DECISION = "ORDER_TO_PAY_DECISION",
  TRADING_PROHIBITION = "TRADING_PROHIBITION",
  COMPANY_RECONSTRUCTION_STARTED = "COMPANY_RECONSTRUCTION_STARTED",
  COMPANY_RECONSTRUCTION_ENDED = "COMPANY_RECONSTRUCTION_ENDED",
  SEIZURE_ASSETS_MISSING = "SEIZURE_ASSETS_MISSING",
  ADDITIONAL_TAX = "ADDITIONAL_TAX",
  ROAD_TAX = "ROAD_TAX",
  CUSTOM_DUTY_MOVED_TO_S_E_A = "CUSTOM_DUTY_MOVED_TO_S_E_A",
  DEPT_RESTRUCTURING_STARTED = "DEPT_RESTRUCTURING_STARTED",
  DEPT_RESTRUCTURING_APPROVEDBY_S_E_A_OR_COURT = "DEPT_RESTRUCTURING_APPROVEDBY_S_E_A_OR_COURT",
  OVERLOAD_FEE_MOVED_TO_S_E_A = "OVERLOAD_FEE_MOVED_TO_S_E_A",
  EXCEMPTIONFEE_FOR_EXHAUST_MOVED_TO_S_E_A = "EXCEMPTIONFEE_FOR_EXHAUST_MOVED_TO_S_E_A",
  EXCISE_DUTY_MOVED_TO_S_E_A = "EXCISE_DUTY_MOVED_TO_S_E_A",
  ORDNANCE_SURVEY_EXPENSE_MOVED_TO_S_E_A = "ORDNANCE_SURVEY_EXPENSE_MOVED_TO_S_E_A",
  STUDYGRANTSFEE_MOVED_TO_S_E_A = "STUDYGRANTSFEE_MOVED_TO_S_E_A",
  WITHHOLDING_TAXES_MOVED_TO_S_E_A = "WITHHOLDING_TAXES_MOVED_TO_S_E_A",
  TAX_ACCOUNT_MOVED_TO_S_E_A = "TAX_ACCOUNT_MOVED_TO_S_E_A",
  ROADE_FEE_MOVED_TO_S_E_A = "ROADE_FEE_MOVED_TO_S_E_A",
  MOTOR_VEHICLE_SALE_TAX_MOVED_TO_S_E_A = "MOTOR_VEHICLE_SALE_TAX_MOVED_TO_S_E_A",
  TRANSPORT_SURCHARGE_MOVED_TO_S_E_A = "TRANSPORT_SURCHARGE_MOVED_TO_S_E_A",
  PARKING_PENALTY_MOVED_TO_S_E_A = "PARKING_PENALTY_MOVED_TO_S_E_A",
  LAND_AND_ENVIRONMENTAL_COURT_FEE_MOVED_TO_S_E_A = "LAND_AND_ENVIRONMENTAL_COURT_FEE_MOVED_TO_S_E_A",
  DELAY_FEE_ABL_MOVED_TO_S_E_A = "DELAY_FEE_ABL_MOVED_TO_S_E_A",
  BUILDING_AND_SPECIAL_FEE_MOVED_TO_S_E_A = "BUILDING_AND_SPECIAL_FEE_MOVED_TO_S_E_A",
  ILLEGAL_BUILDING_FEE_MOVED_TO_S_E_A = "ILLEGAL_BUILDING_FEE_MOVED_TO_S_E_A",
  PRICE_REGULATION_FEE_MOVED_TO_S_E_A = "PRICE_REGULATION_FEE_MOVED_TO_S_E_A",
  SPECIAL_FEE_ABL_MOVED_TO_S_E_A = "SPECIAL_FEE_ABL_MOVED_TO_S_E_A",
  TV_FEE_MOVED_TO_S_E_A = "TV_FEE_MOVED_TO_S_E_A",
  ALIMONY_MOVED_TO_S_E_A = "ALIMONY_MOVED_TO_S_E_A",
  VARIOUS_GOVERNMENT_CLAIMS_MOVED_TO_S_E_A = "VARIOUS_GOVERNMENT_CLAIMS_MOVED_TO_S_E_A",
  FINANCIAL_AID_MOVED_TO_S_E_A = "FINANCIAL_AID_MOVED_TO_S_E_A",
  VARIOUS_OTHER_CLAIMS_MOVED_TO_S_E_A = "VARIOUS_OTHER_CLAIMS_MOVED_TO_S_E_A",
  EU_TAX_OR_FEE_MOVED_TO_S_E_A = "EU_TAX_OR_FEE_MOVED_TO_S_E_A",
  CONGESTION_TAX_MOVED_TO_S_E_A = "CONGESTION_TAX_MOVED_TO_S_E_A",
  MISSUSED_BANK_ACCOUNT = "MISSUSED_BANK_ACCOUNT",
  MISSUSED_CREDIT = "MISSUSED_CREDIT",
  MISSUSED_CREDITCARD_CREDIT = "MISSUSED_CREDITCARD_CREDIT",
  TAX_ARR_INFRASTR_CHARGE = "TAX_ARR_INFRASTR_CHARGE",
  ARREARS_RECLAIMS_ETC = "ARREARS_RECLAIMS_ETC",
  ARREARS_GOVERNMENTAL_RECLAIMS = "ARREARS_GOVERNMENTAL_RECLAIMS",
  SANCTION_FEE_TRAFFIC = "SANCTION_FEE_TRAFFIC",
  RECLAIM_OF_STUDENT_GRANTS = "RECLAIM_OF_STUDENT_GRANTS",
  SANCTION_FEE_RECLAIMS = "SANCTION_FEE_RECLAIMS",
  OUTSTANDING_CLAIMS = "OUTSTANDING_CLAIMS",
  NON_NORDIC_TAXES = "NON_NORDIC_TAXES",
  NORDIC_TAX = "NORDIC_TAX",
}

/** ComplaintKind */
export enum ComplaintKind {
  VOLUNTARY = "VOLUNTARY",
  INVOLUNTARY = "INVOLUNTARY",
}

/** CheckProblem */
export enum CheckProblem {
  Missing = "missing",
  Added = "added",
}

/** CheckKind */
export enum CheckKind {
  Number = "number",
  Url = "url",
  Email = "email",
  Phone = "phone",
}

/**
 * ChannelOrigin
 * The channel an event came through, when it is the bank portal.
 *
 * Stamped by apps-mgr's portal writers only: v4 bank add-offer on every portal offer, and the
 * portal's accept, cancel, reject and disburse writes on pairs the portal owns. `None` means every
 * other source: the bank's integration, the Sverker router, the Sverker migrator, legacy endpoints.
 */
export enum ChannelOrigin {
  BANK_PORTAL = "BANK_PORTAL",
}

/** Channel */
export enum Channel {
  Inbound = "inbound",
  Outbound = "outbound",
  Online = "online",
}

/** CenterStatus */
export enum CenterStatus {
  HELD = "HELD",
  OPEN = "OPEN",
  DONE = "DONE",
}

/**
 * CenterReason
 * Why an item is in the messaging center, shown to the KH.
 */
export enum CenterReason {
  ONLINE_APP = "ONLINE_APP",
  OWNER_QUIT = "OWNER_QUIT",
  NO_OWNER = "NO_OWNER",
  UNKNOWN_SENDER = "UNKNOWN_SENDER",
  HOLD_TIMEOUT = "HOLD_TIMEOUT",
  HOLD_ENDED = "HOLD_ENDED",
  ROUTING_FAILED = "ROUTING_FAILED",
}

/** CaseDocumentSource */
export enum CaseDocumentSource {
  AGENT_UPLOAD = "AGENT_UPLOAD",
  EMAIL_ATTACHMENT = "EMAIL_ATTACHMENT",
  BANK_UPLOAD = "BANK_UPLOAD",
  CUSTOMER_UPLOAD = "CUSTOMER_UPLOAD",
}

/** CaseChatSourceStatus */
export enum CaseChatSourceStatus {
  Ok = "ok",
  Failed = "failed",
  Skipped = "skipped",
  Refused = "refused",
}

/** CaseChatAnswerOutcome */
export enum CaseChatAnswerOutcome {
  Complete = "complete",
  Partial = "partial",
}

/** CancellationTrigger */
export enum CancellationTrigger {
  CUSTOMER_REQUEST = "CUSTOMER_REQUEST",
  MANDATE_CANCELLED = "MANDATE_CANCELLED",
  BY_AXA = "BY_AXA",
  END_OF_INSURANCE_LIFETIME = "END_OF_INSURANCE_LIFETIME",
  BECAUSE_OF_CUSTOMER_AGE = "BECAUSE_OF_CUSTOMER_AGE",
  FAILED_PAYMENTS = "FAILED_PAYMENTS",
  DECEASED_CUSTOMER = "DECEASED_CUSTOMER",
  SCHEDULED_CANCELLATION = "SCHEDULED_CANCELLATION",
  OTHER = "OTHER",
}

/** CancelReason */
export enum CancelReason {
  BETTER_INTEREST_OTHER_BANK = "BETTER_INTEREST_OTHER_BANK",
  OFFERED_AMOUNT_TOO_LOW = "OFFERED_AMOUNT_TOO_LOW",
  NO_DEAL = "NO_DEAL",
  OTHER_REASON = "OTHER_REASON",
}

/** CampaignType */
export enum CampaignType {
  COLD = "COLD",
  POOL = "POOL",
  PROCESS = "PROCESS",
}

/** CallNowSources */
export enum CallNowSources {
  IncomingSms = "incoming_sms",
  BankIdLogin = "bank_id_login",
  UrlTrackerTrigger = "url_tracker_trigger",
  WebsiteVisit = "website_visit",
  WebsiteVisitInsurance = "website_visit_insurance",
}

/** CTATags */
export enum CTATags {
  MISSING_2_PAYMENTS = "MISSING_2_PAYMENTS",
  MISSING_3_PAYMENTS = "MISSING_3_PAYMENTS",
  AUTOMATICALLY_CANCELED = "AUTOMATICALLY_CANCELED",
  INACTIVE_MANDATE = "INACTIVE_MANDATE",
  SCHEDULED_CANCELLATION = "SCHEDULED_CANCELLATION",
}

/** BlockField */
export enum BlockField {
  Phone = "phone",
  Pni = "pni",
  Email = "email",
}

/** BlancoStatusLabel */
export enum BlancoStatusLabel {
  Approved = "approved",
  Disbursed = "disbursed",
  PaidAcc2Client = "paid_acc_2_client",
  Created = "created",
  Deactivated = "deactivated",
  SentDebenture = "sent_debenture",
  SignedDebenture = "signed_debenture",
  SignedDebentureAcc2Client = "signed_debenture_acc_2_client",
  AwaitingDebentureSend = "awaiting_debenture_send",
  Edited = "edited",
  Addon = "addon",
  NewResponse = "new_response",
  NotSwedcust = "not_swedcust",
  GoingToReturn = "going_to_return",
}

/** BankSubstatus */
export enum BankSubstatus {
  LATE_DENIAL = "LATE_DENIAL",
  ACCEPT_REJECTED = "ACCEPT_REJECTED",
  DISBURSEMENT_CONFIRMED = "DISBURSEMENT_CONFIRMED",
  CONTRACT_SIGNED = "CONTRACT_SIGNED",
  CONTRACT_SENT_TO_CUSTOMER = "CONTRACT_SENT_TO_CUSTOMER",
  TEMPORARY_ERROR = "TEMPORARY_ERROR",
  ERROR = "ERROR",
  INTERNAL_CANCELLATION = "INTERNAL_CANCELLATION",
  REAPPLIED = "REAPPLIED",
}

/** BankIDPurpose */
export enum BankIDPurpose {
  SHARE_GR = "SHARE_GR",
  SHARE_EV = "SHARE_EV",
}

/** BankEventType */
export enum BankEventType {
  INVITE_REQUESTED = "INVITE_REQUESTED",
  INVITE_FILTERS_SUCCESS = "INVITE_FILTERS_SUCCESS",
  INVITE_FILTERED_OUT = "INVITE_FILTERED_OUT",
  INVITE_APP_INVALID = "INVITE_APP_INVALID",
  INVITE_SEND_FAILED = "INVITE_SEND_FAILED",
  INVITE_SEND_FAILED_TRANSIENT = "INVITE_SEND_FAILED_TRANSIENT",
  INVITE_SEND_SUCCESS = "INVITE_SEND_SUCCESS",
  INVITE_POSTPONED = "INVITE_POSTPONED",
  SEND_POSTPONED = "SEND_POSTPONED",
  INVITE_CANCELLED = "INVITE_CANCELLED",
  INVITE_DENIED = "INVITE_DENIED",
  INVITE_SENT = "INVITE_SENT",
  OFFER = "OFFER",
  ACCEPT_REQUESTED = "ACCEPT_REQUESTED",
  ACCEPT_SEND_FAILED = "ACCEPT_SEND_FAILED",
  ACCEPT_SEND_FAILED_TRANSIENT = "ACCEPT_SEND_FAILED_TRANSIENT",
  ACCEPT_SEND_SUCCESS = "ACCEPT_SEND_SUCCESS",
  ACCEPT_APP_INVALID = "ACCEPT_APP_INVALID",
  ACCEPT = "ACCEPT",
  ACCEPT_WITHDRAWN = "ACCEPT_WITHDRAWN",
  MESSAGE = "MESSAGE",
  STATUS_UPDATE = "STATUS_UPDATE",
  DOCUMENT_INFO = "DOCUMENT_INFO",
  COMMENT_TO_BANK_ADDED = "COMMENT_TO_BANK_ADDED",
  COMMENT_ADDED = "COMMENT_ADDED",
  COMMENT_TO_BANK_SEND_SUCCESS = "COMMENT_TO_BANK_SEND_SUCCESS",
  COMMENT_TO_BANK_SEND_FAILED_TRANSIENT = "COMMENT_TO_BANK_SEND_FAILED_TRANSIENT",
  COMMENT_TO_BANK_SEND_FAILED = "COMMENT_TO_BANK_SEND_FAILED",
  DISBURSEMENT = "DISBURSEMENT",
  DEBENTURE_SIGNED = "DEBENTURE_SIGNED",
  CANCEL_REQUESTED = "CANCEL_REQUESTED",
  CANCEL_SEND_FAILED = "CANCEL_SEND_FAILED",
  CANCEL_SEND_FAILED_TRANSIENT = "CANCEL_SEND_FAILED_TRANSIENT",
  CANCEL_SEND_SUCCESS = "CANCEL_SEND_SUCCESS",
  REJECTION = "REJECTION",
  DOCUMENT_TO_BANK_ADDED = "DOCUMENT_TO_BANK_ADDED",
  DOCUMENT_TO_BANK_SEND_SUCCESS = "DOCUMENT_TO_BANK_SEND_SUCCESS",
  DOCUMENT_TO_BANK_SEND_FAILED = "DOCUMENT_TO_BANK_SEND_FAILED",
  DEACTIVATED = "DEACTIVATED",
  REACTIVATED = "REACTIVATED",
  SIGN_STATUS = "SIGN_STATUS",
  SIGN_REQUEST = "SIGN_REQUEST",
  SIGN_SEND_FAILED = "SIGN_SEND_FAILED",
  SIGN_SEND_FAILED_TRANSIENT = "SIGN_SEND_FAILED_TRANSIENT",
  SIGN_SEND_SUCCESS = "SIGN_SEND_SUCCESS",
  LEFT_TO_LIVE = "LEFT_TO_LIVE",
}

/** BankCommentSender */
export enum BankCommentSender {
  BROKER = "BROKER",
  BANK = "BANK",
  INTEGRATION = "INTEGRATION",
}

/** BankCommentOrigin */
export enum BankCommentOrigin {
  BROKER = "BROKER",
  BANK_PORTAL = "BANK_PORTAL",
  BANK = "BANK",
  BANKING_ADVISOR = "BANKING_ADVISOR",
  INTEGRATION = "INTEGRATION",
}

/**
 * BalconyType
 * Balcony type
 */
export enum BalconyType {
  BALCONY = "BALCONY",
  PATIO = "PATIO",
  NONE = "NONE",
}

/**
 * AssignmentSource
 * Which subsystem holds the lock on a lead via ``assigned_to``.
 *
 * Dialmaker assigns leads when an agent dials them; todomaker (KH work queue)
 * claims a lead when a handler expands its row. The discriminator keeps the two
 * pools disjoint: the stale-lock cron and the one-at-a-time release only ever act
 * on ``TODOMAKER`` locks, and dialmaker's available-pool filter excludes them.
 *
 * ``CASE_VIEW`` is "Lock to me" on a Dial Maker lead in the case view. Anyone may press it, including
 * people who never open Dial Maker, so the stale-lock cron releases these too, on their own cutoff
 * (``CASE_VIEW_STALE_LOCK_MINUTES``). An outcome recorded in Dial Maker resets the source as usual.
 */
export enum AssignmentSource {
  Dialmaker = "dialmaker",
  Todomaker = "todomaker",
  CaseView = "case_view",
}

/**
 * ApplyingWith
 * Who applicant applies with
 */
export enum ApplyingWith {
  PARENT = "PARENT",
  SPOUSE = "SPOUSE",
  ALONE = "ALONE",
  COHABITANT = "COHABITANT",
}

/** ApplicationSource */
export enum ApplicationSourceInput {
  BLANCO = "BLANCO",
  KH_BLANCO = "KH_BLANCO",
  LOG_BLANCO = "LOG_BLANCO",
  HL_BLANCO = "HL_BLANCO",
  WINBACK = "WINBACK",
  DIRECT = "DIRECT",
  RECOMMENDATION = "RECOMMENDATION",
  AFFILIATE_PARTNER = "AFFILIATE_PARTNER",
  TF_AGENCY = "TF_AGENCY",
  AFFILIATE_API = "AFFILIATE_API",
  ONLINE_LEAD = "ONLINE_LEAD",
  OTHER = "OTHER",
  LIKVIDUM = "LIKVIDUM",
  GEOFY = "GEOFY",
  TRYGGA = "TRYGGA",
  KOLL = "KOLL",
  PAMIND = "PÅMIND",
  NSTART = "NSTART",
  SVENSKLANEFORMEDLING = "SVENSK_LÅNEFÖRMEDLING",
  KABOLAN = "KA_BOLÅN",
  PREMIUM = "PREMIUM",
  PLUS1 = "PLUS1",
  FINANSVALPEN = "FINANSVALPEN",
  AXO = "AXO",
  ENKLARE = "ENKLARE",
}

/** ApplicationReview */
export enum ApplicationReview {
  TryAgainLater = "tryAgainLater",
  EitherOr = "eitherOr",
  LikingZensum = "likingZensum",
  DislikesZensum = "dislikesZensum",
  GoodCase = "goodCase",
  OkayCase = "okayCase",
  BadCase = "badCase",
  CreditNotes = "creditNotes",
  MostHappy = "mostHappy",
  Happy = "happy",
  KindaSortaHappy = "kindaSortaHappy",
  Other = "other",
}

/** ApplicationOrigin */
export enum ApplicationOrigin {
  Freja = "freja",
  Zrm = "zrm",
  Online = "online",
  ZensumPay = "zensum_pay",
}

/** ApplicationMapperTags */
export enum ApplicationMapperTags {
  MORTGAGE_COI = "MORTGAGE_COI",
  HIGH_PRIO = "HIGH_PRIO",
}

/** ApplicantRole */
export enum ApplicantRole {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  GUARANTOR = "GUARANTOR",
}

/** AppStateLabel */
export enum AppStateLabel {
  LATE_DENIAL = "LATE_DENIAL",
}

/** AppState */
export enum AppState {
  DRAFT = "DRAFT",
  COMPLETE = "COMPLETE",
  OFFERED = "OFFERED",
  ACCEPTED = "ACCEPTED",
  DISBURSED = "DISBURSED",
}

/** ApiType */
export enum ApiType {
  TDD = "TDD",
  MDD = "MDD",
}

/** AmortizationRule */
export enum AmortizationRule {
  FI2018 = "FI2018",
  FI2016 = "FI2016",
  SKB70 = "SKB70",
  OTHER = "OTHER",
}

/** AmortizationPlan */
export enum AmortizationPlan {
  FIXED_RATE = "FIXED_RATE",
  STRAIGHT_LINE = "STRAIGHT_LINE",
}

/** AffiliateSituation */
export enum AffiliateSituation {
  SOLD = "SOLD",
  WILL_SELL = "WILL_SELL",
  ONLY_BUY = "ONLY_BUY",
}

/** AffiliateResponsibilitySE */
export enum AffiliateResponsibilitySE {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
  GUARANTOR = "GUARANTOR",
}

/** AffiliateResponsibilityNO */
export enum AffiliateResponsibilityNO {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  SHARED = "SHARED",
}

/** AffiliateRateType */
export enum AffiliateRateType {
  FIXED = "FIXED",
  FLEXIBLE = "FLEXIBLE",
  MIXED = "MIXED",
}

/** AffiliatePropertyType */
export enum AffiliatePropertyType {
  CONDOMINIUM = "CONDOMINIUM",
  HOUSE = "HOUSE",
  VACATION_HOME = "VACATION_HOME",
}

/** AffiliateProduct */
export enum AffiliateProduct {
  Mortgage = "mortgage",
  CreditCard = "credit_card",
  BlancoRefinance = "blanco_refinance",
  BlancoNewLoan = "blanco_new_loan",
  NonApplicationRelated = "non_application_related",
}

/** AffiliateNetworkCallbackStatus */
export enum AffiliateNetworkCallbackStatus {
  SENT = "SENT",
  FAILED = "FAILED",
  PENDING = "PENDING",
  DUPLICATE = "DUPLICATE",
  NOT_SENT = "NOT_SENT",
  IGNORED = "IGNORED",
}

/** AffiliateMortgageRelationshipStatus */
export enum AffiliateMortgageRelationshipStatus {
  SPOUSE = "SPOUSE",
  CHILD = "CHILD",
  PARENT = "PARENT",
  PARTNER = "PARTNER",
}

/** AffiliateMortgageLoanType */
export enum AffiliateMortgageLoanType {
  REFINANCE = "REFINANCE",
  PRE_APPROVAL = "PRE_APPROVAL",
  BUY = "BUY",
}

/** AffiliateMaritalStatus */
export enum AffiliateMaritalStatus {
  UNMARRIED = "UNMARRIED",
  MARRIED = "MARRIED",
  PARTNER = "PARTNER",
}

/** AffiliateLoanType */
export enum AffiliateLoanType {
  CREDIT_CARD = "CREDIT_CARD",
  UNSECURED_LOAN = "UNSECURED_LOAN",
  CAR_LOAN = "CAR_LOAN",
  CHECK_CREDIT = "CHECK_CREDIT",
  OTHER = "OTHER",
  STUDENT_LOAN = "STUDENT_LOAN",
  INSTALLMENT = "INSTALLMENT",
  TOP_MORTGAGE_LOAN = "TOP_MORTGAGE_LOAN",
  MEMBER_LOAN = "MEMBER_LOAN",
  MORTGAGE = "MORTGAGE",
}

/** AffiliateIncomeType */
export enum AffiliateIncomeType {
  RENT = "RENT",
  OTHER = "OTHER",
  EMPLOYMENT = "EMPLOYMENT",
  PARTNER = "PARTNER",
}

/** AffiliateHousingType */
export enum AffiliateHousingType {
  RENTED = "RENTED",
  OWN_APARTMENT = "OWN_APARTMENT",
  OWN_HOUSE = "OWN_HOUSE",
  LIVE_IN = "LIVE_IN",
}

/** AffiliateBlancoPurposeForNewLoan */
export enum AffiliateBlancoPurposeForNewLoan {
  CAR_BOAT_OR_MC = "CAR_BOAT_OR_MC",
  CONSUMPTION = "CONSUMPTION",
  PROPERTY_RENOVATION = "PROPERTY_RENOVATION",
  LOAN_FOR_SOMEBODY_ELSE = "LOAN_FOR_SOMEBODY_ELSE",
  INVESTMENT = "INVESTMENT",
  EDUCATION = "EDUCATION",
  HEALTH_CARE = "HEALTH_CARE",
  DEBT_COLLECTION = "DEBT_COLLECTION",
  INVESTMENT_ABROAD = "INVESTMENT_ABROAD",
  DIVORCE = "DIVORCE",
  BUY_PROPERTY = "BUY_PROPERTY",
}

/** AffiliateApplyingWith */
export enum AffiliateApplyingWith {
  PARENT = "PARENT",
  SPOUSE = "SPOUSE",
  ALONE = "ALONE",
  COHABITANT = "COHABITANT",
}

/** AffiliateApplicantRole */
export enum AffiliateApplicantRole {
  MAIN_APPLICANT = "MAIN_APPLICANT",
  CO_APPLICANT = "CO_APPLICANT",
  GUARANTOR = "GUARANTOR",
}

/** ActorKind */
export enum ActorKind {
  System = "system",
  Agent = "agent",
  Customer = "customer",
  Bank = "bank",
}

/** Action */
export enum Action {
  CREATED = "CREATED",
  UPDATE = "UPDATE",
  CUSTOMER_ADDED = "CUSTOMER_ADDED",
  FIRST_TIME_CUSTOMER = "FIRST_TIME_CUSTOMER",
  INTERNAL_COMMENT_ADDED = "INTERNAL_COMMENT_ADDED",
  ACTIVATED = "ACTIVATED",
  HANDLER_ASSIGNED = "HANDLER_ASSIGNED",
  HANDLER_UNASSIGNED = "HANDLER_UNASSIGNED",
  FIRST_OFFER_RECEIVED = "FIRST_OFFER_RECEIVED",
  OFFER_RECEIVED = "OFFER_RECEIVED",
  CANCELED = "CANCELED",
  PROPERTY_ADDED = "PROPERTY_ADDED",
  DOCUMENT_ATTACHED = "DOCUMENT_ATTACHED",
  VERIFIED_BANK_ID = "VERIFIED_BANK_ID",
  AML_REVIEW = "AML_REVIEW",
  DEACTIVATED = "DEACTIVATED",
  TAGS = "TAGS",
  MORTGAGE_REVIEWER_ASSIGNED = "MORTGAGE_REVIEWER_ASSIGNED",
  FREE_FOR_ALL = "FREE_FOR_ALL",
  FREE_FOR_ALL_ACCEPTED = "FREE_FOR_ALL_ACCEPTED",
  SELF_SERVICE = "SELF_SERVICE",
  OFFER_ACCEPTED = "OFFER_ACCEPTED",
  MANUAL_APPLICATION_STATE = "MANUAL_APPLICATION_STATE",
  ORIGIN_RESOLVED = "ORIGIN_RESOLVED",
  MOVED_TO_ZRM = "MOVED_TO_ZRM",
}

/** AMLRiskLevel */
export enum AMLRiskLevel {
  Medium = "medium",
  High = "high",
  Unknown = "unknown",
}

/** AMLReviewStatus */
export enum AMLReviewStatus {
  Approved = "approved",
  Rejected = "rejected",
  NotReviewed = "not_reviewed",
}

/** AMLBlancoPurpose */
export enum AMLBlancoPurpose {
  RefinanceLoan = "refinance_loan",
  NewLoan = "new_loan",
  RefinanceAndNewLoan = "refinance_and_new_loan",
}

export type BankMortgageApplication =
  | ({
      country: "NO";
    } & BankApplicationMONO)
  | ({
      country: "SE";
    } & BankApplicationMOSE);

export type BankBlancoApplication =
  | ({
      country: "NO";
    } & BankApplicationULNO)
  | ({
      country: "SE";
    } & BankApplicationULSE);

/** AML */
export interface AML {
  channel?: Channel | null;
  /** Comment */
  comment?: string | AMLComment | null;
  review_status: AMLReviewStatus;
  risk_level: AMLRiskLevel;
  /** Is Identity Checked */
  is_identity_checked?: boolean | null;
  /** Is Pep Or Sanctioned */
  is_pep_or_sanctioned?: boolean | null;
}

/** AMLBlancoResponse */
export interface AMLBlancoResponse {
  channel?: Channel | null;
  /** Comment */
  comment?: string | AMLComment | null;
  review_status: AMLReviewStatus;
  risk_level: AMLRiskLevel;
  /** Is Identity Checked */
  is_identity_checked?: boolean | null;
  /** Is Pep Or Sanctioned */
  is_pep_or_sanctioned?: boolean | null;
  /** Purpose */
  purpose?: string | null;
  /** Purpose When New Loan */
  purpose_when_new_loan?: string | null;
}

/** AMLComment */
export interface AMLComment {
  /** User Id */
  user_id: string;
  /** Comment */
  comment: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Comment Id */
  comment_id: string;
  /**
   * Action
   * @default "AML_COMMENT"
   */
  action?: string;
}

/** AMLInsertion */
export interface AMLInsertion {
  channel?: Channel | null;
  /** Comment */
  comment?: string | null;
}

/** AMLOPResponse */
export interface AMLOPResponse {
  channel?: Channel | null;
  /** Comment */
  comment?: string | AMLComment | null;
  review_status: AMLReviewStatus;
  risk_level: AMLRiskLevel;
  /** Is Identity Checked */
  is_identity_checked?: boolean | null;
  /** Is Pep Or Sanctioned */
  is_pep_or_sanctioned?: boolean | null;
  /**
   * Purpose
   * @default "Consolidation of pension policies"
   */
  purpose?: string;
}

/** AMLResponse */
export interface AMLResponse {
  /**
   * Event
   * @default "aml"
   */
  event?: "aml";
  data: AMLBlancoResponse;
}

/** AMLReviewPayload */
export interface AMLReviewPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  review_status: AMLReviewStatus;
  /** Comment */
  comment: string;
}

/**
 * AbsenceData
 * A one-off absence as a half-open [start_at, end_at) interval in UTC.
 */
export interface AbsenceData {
  /** User Id */
  user_id: string;
  /**
   * Start At
   * @format date-time
   */
  start_at: string;
  /**
   * End At
   * @format date-time
   */
  end_at: string;
  /** Comment */
  comment?: string | null;
}

/** AbsenceDoc */
export interface AbsenceDoc {
  /** User Id */
  user_id: string;
  /**
   * Start At
   * @format date-time
   */
  start_at: string;
  /**
   * End At
   * @format date-time
   */
  end_at: string;
  /** Comment */
  comment?: string | null;
  /**
   * Absence Id
   * @format uuid
   */
  absence_id: string;
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Updated By */
  updated_by: string;
}

/** AcceptOffer */
export interface AcceptOffer {
  product: Product;
  country: Country;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
  /**
   * Synchronous
   * @default true
   */
  synchronous?: boolean;
}

/**
 * AcceptOfferAndInformResult
 * The outcome of each half of the gesture, reported separately.
 *
 * The accept cannot be undone, so a failed SMS must not surface as a failed request: the handler
 * needs to see that the offer went through and that only the message is left to retry. Telling them
 * the whole thing failed would invite a second accept.
 */
export interface AcceptOfferAndInformResult {
  offer: CreditorOfferCreditCardOfferDataCreditCardTerms;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Sms Sent */
  sms_sent: boolean;
  /** Sms Error */
  sms_error?: string | null;
}

/** AcceptOfferPayloadV2 */
export interface AcceptOfferPayloadV2 {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
  /** Bank Account Number */
  bank_account_number?: string | null;
  /** Bank Clearing Number */
  bank_clearing_number?: string | null;
}

/** AcceptOfferRequest */
export interface AcceptOfferRequest {
  /** Application Id */
  application_id: string;
  /** Offer Id */
  offer_id: string;
  /** Session Id */
  session_id?: string | null;
}

/** AcceptOfferResponse */
export interface AcceptOfferResponse {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
  /** Bank Name */
  bank_name?: string | null;
}

/** AcceptTermsResponse */
export interface AcceptTermsResponse {
  /**
   * Psp Iframe
   * The URL to the Payment Service Provider iframe
   */
  psp_iframe?: string | null;
  /**
   * Psp External Url
   * The URL to the Payment Service Provider external page
   */
  psp_external_url?: string | null;
}

/** AcceptTermsResponseCustomer */
export interface AcceptTermsResponseCustomer {
  /**
   * Psp Iframe
   * The URL to the Payment Service Provider iframe
   */
  psp_iframe?: string | null;
  /**
   * Psp External Url
   * The URL to the Payment Service Provider external page
   */
  psp_external_url?: string | null;
  currency: Currency;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  /** Signup Date */
  signup_date?: string | null;
  /** Signup Url */
  signup_url?: string | null;
  /** Insurance Id */
  insurance_id: string;
  /** Encrypted Insurance Id */
  encrypted_insurance_id?: string | null;
  insurance_type: InsuranceType;
  /** Insured Amount */
  insured_amount: number;
  /** Premium Amount */
  premium_amount: number;
  status: InsuranceStatus;
  substatus: InsuranceSubstatus;
  last_charge?: LastCharge | null;
  mandate?: MandateStatus | null;
  insurance_group: InsuranceGroup;
  payment_service_provider?: PaymentProvider | null;
}

/** AcceptedLoans */
export interface AcceptedLoans {
  /** Amount */
  amount: number;
  /** Sum */
  sum: number;
  /** Accepted Per Meeting */
  accepted_per_meeting: number;
  /** Number Of Meetings */
  number_of_meetings: number;
  currency: Currency;
}

/** Account */
export interface Account {
  /** Account Number */
  account_number: string;
  /** Clearing Number */
  clearing_number?: string | null;
  /** Bank Id */
  bank_id?: number | null;
  /** Bank Name */
  bank_name?: string | null;
}

/** ActionPayload */
export interface ActionPayload {
  /** Notification Ids */
  notification_ids: string[];
  action: NotificationEvent;
}

/** ActiveUsersResponse */
export interface ActiveUsersResponse {
  /**
   * Event
   * @default "active_users"
   */
  event?: "active_users";
  /** Data */
  data: string[];
}

/** Actor */
export interface Actor {
  kind: ActorKind;
  /** Id */
  id?: string | null;
  /** Label */
  label?: string | null;
}

/** AddOfferPayload */
export interface AddOfferPayload {
  /** Bank Id */
  bank_id: number;
  /** Label */
  label: string;
  /** use only for events, it's not a model that should be used together with application */
  offer: BlancoOfferData;
}

/** AdditionalCostPerPerson */
export interface AdditionalCostPerPerson {
  /** Number Of People */
  number_of_people: number;
  /** Cost */
  cost: number;
}

/** Address */
export interface Address {
  /** Basicareaname */
  BasicAreaName?: string | null;
  /** Basicareanumber */
  BasicAreaNumber?: string | null;
  /** Concatenatedaddress */
  ConcatenatedAddress?: string | null;
  /** Fulladdress */
  FullAddress?: string | null;
  /** Municipality */
  Municipality?: string | null;
  /** Postcode */
  Postcode?: string | null;
  /** Postcodearea */
  PostcodeArea?: string | null;
  /** Rest */
  Rest?: string | null;
  /** Streetletter */
  StreetLetter?: string | null;
  /** Streetname */
  StreetName?: string | null;
  /** Streetnumber */
  StreetNumber?: string | null;
}

/** Affiliate */
export interface Affiliate {
  /** Name */
  name: string;
  /** Website */
  website?: string | null;
  /** Affiliate Parent */
  affiliate_parent?: string | null;
  /** Partner Url */
  partner_url?: string[] | null;
  country?: Country | null;
  /** Webhook Url */
  webhook_url?: string | null;
  /** Network */
  network?: boolean | null;
  publisher_data?: PublisherData | null;
  /** Affiliate Id */
  affiliate_id: string;
  /** Creator */
  creator: string;
  status: ModelsAffiliateAffiliateAffiliateStatus;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Deactivated At */
  deactivated_at?: string | null;
  /** Campaign */
  campaign?: ModelsAffiliateAffiliateCampaign[] | null;
}

/** AffiliateApiLeadSource */
export interface AffiliateApiLeadSource {
  /**
   * Type
   * @default "AFFILIATE_API"
   */
  type?: "AFFILIATE_API";
  /** External Id */
  external_id?: string | null;
  /** Submission Id */
  submission_id?: string | null;
  /** Affiliate Id */
  affiliate_id?: string | null;
  /** Sub Affiliate Id */
  sub_affiliate_id?: string | null;
}

/** AffiliateBlancoLoan */
export interface AffiliateBlancoLoan {
  /** Amount */
  amount?: number | null;
  loan_type?: AffiliateLoanType | null;
  /** Responsibility */
  responsibility?: AffiliateResponsibilitySE | AffiliateResponsibilityNO | null;
  /** Creditor Id */
  creditor_id?: number | null;
  /** Refinance */
  refinance?: boolean | null;
  /** Monthly Payment */
  monthly_payment?: number | null;
  /** Rate */
  rate?: number | null;
}

/** AffiliateBlancoLoanForMortgage */
export interface AffiliateBlancoLoanForMortgage {
  /** Amount */
  amount?: number | null;
  loan_type?: AffiliateLoanType | null;
  /** Responsibility */
  responsibility?: AffiliateResponsibilitySE | AffiliateResponsibilityNO | null;
  /** Creditor Id */
  creditor_id?: number | null;
  [key: string]: any;
}

/** AffiliateBuyingInfo */
export interface AffiliateBuyingInfo {
  /** Property Price */
  property_price?: number | null;
  /** Buying Date */
  buying_date?: string | null;
  /** New Production */
  new_production?: boolean | null;
}

/** AffiliateCallback */
export interface AffiliateCallback {
  status: ModelsAffiliatePartnerApplicationAffiliateStatus;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Submission Id */
  submission_id: string;
  /** External Id */
  external_id?: string | null;
  /**
   * Message
   * Optional message
   */
  message?: string | null;
  /** Success */
  success?: boolean | null;
}

/** AffiliateCar */
export interface AffiliateCar {
  /** Monthly Cost */
  monthly_cost?: number | null;
}

/** AffiliateCars */
export interface AffiliateCars {
  /** Owned */
  owned?: number | null;
  /** Leased */
  leased?: AffiliateCar[] | null;
}

/** AffiliateCreateBlancoApplication */
export interface AffiliateCreateBlancoApplication {
  /**
   * External Id
   * Can be any string. The given value be sent back as part of the webhook request
   */
  external_id: string;
  country: Country;
  /**
   * Book Meeting At
   * Time slot when to book meeting with customer. Has to be a available slot based on the response from the /bookings endpoint
   * @format date-time
   */
  book_meeting_at: string;
  /** Applicants */
  applicants: OptionalAffiliateApplicantBlanco[];
  /**
   * Current Loans
   * Current loan situation
   */
  current_loans: AffiliateBlancoLoan[];
  /** Children In The Household */
  children_in_the_household: number;
  /** Children In The Household Full Time */
  children_in_the_household_full_time: number;
  /**
   * Desired Payback Time
   * The time customer would like to pay back loan (in months)
   */
  desired_payback_time?: number | null;
  /**
   * Desired Amount
   * Total desired amount customer wants to borrow. This is refinance and new loan amounts
   */
  desired_amount: number;
  /** Used when customer wants to borrow money for purpose different than refinancing existing loans */
  new_loan?: AffiliateNewLoan | null;
  [key: string]: any;
}

/** AffiliateCreditor */
export interface AffiliateCreditor {
  /** Name */
  name: string;
  /** Creditor Id */
  creditor_id: number;
}

/** AffiliateData */
export interface AffiliateData {
  /** Name */
  name: string;
  /** Website */
  website?: string | null;
  /** Affiliate Parent */
  affiliate_parent?: string | null;
  /** Partner Url */
  partner_url?: string[] | null;
  country?: Country | null;
  /** Webhook Url */
  webhook_url?: string | null;
  /** Network */
  network?: boolean | null;
  publisher_data?: PublisherData | null;
}

/** AffiliateEmployer */
export interface AffiliateEmployer {
  /**
   * Name
   * Name of the employer.
   */
  name: string;
  /** Type */
  type:
    | "FULL"
    | "TRIAL"
    | "HOURLY"
    | "PROJECT"
    | "SELF_EMPLOYED"
    | "COMPANY_OWNER";
  /**
   * Start Date
   * @format date
   */
  start_date: string;
  /**
   * End Date
   * Used in cases when the type is PROJECT
   */
  end_date?: string | null;
  /**
   * Phone
   * Employer phone number
   */
  phone?: string | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Profession */
  profession?: string | null;
}

/** AffiliateIncome */
export interface AffiliateIncome {
  /** Amount */
  amount: number | null;
  type: AffiliateIncomeType | null;
  /** Name */
  name: string | null;
}

/** AffiliateLeadCreationPayload */
export interface AffiliateLeadCreationPayload {
  desired_mortgage_loan?: AffiliateNewMortgageLoan | null;
  current_mortgage_loan?: AffiliateRefinanceInfo | null;
  buying_info?: AffiliateBuyingInfo | null;
  /** Other Loans */
  other_loans?: AffiliateBlancoLoanForMortgage[] | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: AffiliateOtherProperty[] | null;
  co_applicant_relationship_to_main_applicant?: AffiliateMortgageRelationshipStatus | null;
  cars?: AffiliateCars | null;
  /** External Id */
  external_id?: string | null;
  /** Applicants */
  applicants: OptionalAffiliateApplicant[];
  property?: AffiliateProperty | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Comment */
  comment?: string | null;
  /** @default "SE" */
  country?: Country;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Sub Affiliate Id */
  sub_affiliate_id?: string | null;
}

/** AffiliateNetworkCallbackEvent */
export interface AffiliateNetworkCallbackEvent {
  /** Affiliate Network Id */
  affiliate_network_id: string;
  callback_trigger: PersonStatus;
  /** Callback Url */
  callback_url: string;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string | null;
  /** Customer Id */
  customer_id: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: AffiliateNetworkCallbackStatus;
  /** Publisher Id */
  publisher_id: string;
  /** Application Origin */
  application_origin?: string | null;
  product?: Product | null;
  /** Zid */
  zid?: string | null;
  /** Ignored Reason */
  ignored_reason?: string | null;
}

/** AffiliateNewLoan */
export interface AffiliateNewLoan {
  /** Desired Amount */
  desired_amount: number;
  loan_purpose: AffiliateBlancoPurposeForNewLoan;
  [key: string]: any;
}

/** AffiliateNewMortgageLoan */
export interface AffiliateNewMortgageLoan {
  /** Mortgage Loan Amount */
  mortgage_loan_amount?: number | null;
  /** Down Payment */
  down_payment?: number | null;
  /** Down Payment Loan Amount */
  down_payment_loan_amount?: number | null;
  /** Bridge Loan Amount */
  bridge_loan_amount?: number | null;
  /** Disbursement Date */
  disbursement_date?: string | null;
  applying_with?: AffiliateApplyingWith | null;
  loan_purpose?: AffiliateMortgageLoanType | null;
  buying_situation?: AffiliateSituation | null;
  /** Private Loan Amount */
  private_loan_amount?: number | null;
}

/** AffiliateNotEmployed */
export interface AffiliateNotEmployed {
  /** Type */
  type: "RETIRED" | "EARLY_RETIRED" | "NO_WORK";
  /**
   * Start Date
   * @format date
   */
  start_date: string;
}

/** AffiliateOptionsResponse */
export interface AffiliateOptionsResponse {
  /**
   * Responsibility
   * List of possible loan responsibilities
   */
  responsibility: EnumDescription[];
  /**
   * Marital Status
   * List of possible marital statuses
   */
  marital_status: EnumDescription[];
  /**
   * Income Type
   * List of possible income types
   */
  income_type?: EnumDescription[] | null;
  /**
   * Employer Type
   * List of possible employer types
   */
  employer_type: EnumDescription[];
  /**
   * Housing Type
   * List of possible housing types
   */
  housing_type: EnumDescription[];
  /**
   * Loan Type
   * List of possible loan types
   */
  loan_type: EnumDescription[];
  /**
   * Property Type
   * List of possible property types
   */
  property_type: EnumDescription[];
  /**
   * Co Applicant Relationship To Main Applicant
   * List of possible co-applicant relationships
   */
  co_applicant_relationship_to_main_applicant: EnumDescription[];
  /**
   * Loan Purpose
   * List of possible loan purposes
   */
  loan_purpose: EnumDescription[];
  /**
   * Applying With
   * List of possible applying with types
   */
  applying_with: EnumDescription[];
  /**
   * Situation
   * List of possible situation types
   */
  situation: EnumDescription[];
  /**
   * Rate Type
   * List of possible rate types
   */
  rate_type: EnumDescription[];
  /**
   * Currently Living In
   * List of possible current housing types
   */
  currently_living_in: EnumDescription[];
  /** Creditors */
  creditors: AffiliateCreditor[];
}

/** AffiliateOtherProperty */
export interface AffiliateOtherProperty {
  /**
   * Monthly Cost
   * @default 0
   */
  monthly_cost?: number | null;
  /** Mortgage Amount */
  mortgage_amount?: number | null;
  property_type: AffiliatePropertyType;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Property Ownership Share */
  property_ownership_share?: number | null;
  /** Loan Ownership Share */
  loan_ownership_share?: number | null;
}

/** AffiliateProperty */
export interface AffiliateProperty {
  property_type: AffiliatePropertyType;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Housing Monthly Cost */
  housing_monthly_cost?: number | null;
  /** Square Meters */
  square_meters?: number | null;
  address?: AffiliatePropertyAddress | null;
}

/** AffiliatePropertyAddress */
export interface AffiliatePropertyAddress {
  /** Street address of property  */
  street_address?: NonEmptyString | null;
  /** City of the property */
  city?: NonEmptyString | null;
  /** Postal code of the property */
  postal_code?: NonEmptyString | null;
  /** Municipality of the property (Sweden's municipalities) */
  municipality_code?: NonEmptyString | null;
}

/** AffiliateRatePart */
export interface AffiliateRatePart {
  rate_type: AffiliateRateType;
  /** Amount */
  amount?: number | null;
  /** Rate */
  rate?: number | null;
  /** Monthly Payment */
  monthly_payment?: number | null;
  /** Until */
  until?: string | null;
  /** Loan Number */
  loan_number?: string | null;
  /** Condition Rollover Date */
  condition_rollover_date?: string | null;
  /** Monthly Amortisation */
  monthly_amortisation?: number | null;
}

/** AffiliateRefinanceInfo */
export interface AffiliateRefinanceInfo {
  /** Current Creditor Id */
  current_creditor_id?: number | null;
  /** Amount */
  amount?: number | null;
  /** Rate */
  rate?: number | null;
  /** Monthly Payment */
  monthly_payment?: number | null;
  /** Rate Parts */
  rate_parts?: AffiliateRatePart[] | null;
  rate_type?: AffiliateRateType | null;
  /** Ownership Share Of Loan */
  ownership_share_of_loan?: number | null;
}

/** AffiliateResponse */
export interface AffiliateResponse {
  /** Submission Id */
  submission_id: string;
}

/** AgentAiStatus */
export interface AgentAiStatus {
  /** Sms */
  sms: boolean;
  /** Sms Languages */
  sms_languages: string[];
  /** Play Bank Sms */
  play_bank_sms: boolean;
  /** Case Chat */
  case_chat: boolean;
}

/** AllDisbursedLoans */
export interface AllDisbursedLoans {
  /** Amount */
  amount: number;
  /** Sum */
  sum: number;
  /** Average Sum */
  average_sum: number;
  currency: Currency;
}

/** AllInsurances */
export interface AllInsurances {
  /** Seller Id */
  seller_id?: string[] | null;
  /** Total Premium Amount */
  total_premium_amount: number;
  /** Total Count */
  total_count: number;
  /** Total Insured Amount */
  total_insured_amount: number;
  /** Cancelled Insurances Within Period */
  cancelled_insurances_within_period: number;
  currency?: Currency | null;
}

/** AllOptionalZoordinates */
export interface AllOptionalZoordinates {
  Product?: ZProduct | null;
  Country?: ZCountry | null;
  Office?: ZOffice | null;
  EmploymentType?: ZEmploymentType | null;
  Department?: ZDepartment | null;
}

/** Apartment */
export interface Apartment {
  /** Apartment Number */
  apartment_number: string;
}

/** ApiLeadSource */
export interface ApiLeadSource {
  /**
   * Type
   * @default "ZRM_API"
   */
  type?: "ZRM_API";
}

/**
 * AppBase
 * Application model returned by apps-mgr
 */
export interface AppBase {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: SharedModelsStatusStatus | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: SharedMortgageSeSpecCommonDefinitionsCars | null;
  brokerage?: Brokerage | null;
  product: Product;
  country: Country;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Offers */
  offers?: Offer[] | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  [key: string]: any;
}

/** AppPrefsPayload */
export interface AppPrefsPayload {
  /** New App Options */
  new_app_options: NewAppOption[];
  /** New App Checklist */
  new_app_checklist: string[];
}

/** ApplicantDocument */
export interface ApplicantDocument {
  /** Document Id */
  document_id: string;
  /** Document Type */
  document_type: string | DocumentType;
}

/** ApplicantNO */
export interface ApplicantNO {
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /** Pni */
  pni: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: PhoneNumberOutput[] | null;
  /** Sverker Id */
  sverker_id?: number | null;
  /** Children */
  children?: number | null;
  /** Citizen */
  citizen?: number | null;
  education?: EducationType | null;
  /** Monthly Partner Income */
  monthly_partner_income?: number | null;
  /** Immigrated At */
  immigrated_at?: string | null;
  /** Fullname */
  fullname?: string | null;
  /** Documents */
  documents?: ApplicantDocument[] | null;
  /** Verified Credits */
  verified_credits?: boolean | null;
  /** Housing Since */
  housing_since?: string | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Deceased Date */
  deceased_date?: string | null;
  /** Emigrated */
  emigrated?: boolean | null;
  /** Is Sanction */
  is_sanction?: boolean | null;
  /** Is Rca */
  is_rca?: boolean | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  /** Last Credit Check */
  last_credit_check?: string | null;
  /** Last Externally Verified Credits */
  last_externally_verified_credits?: string | null;
  /** Last Property Valuation */
  last_property_valuation?: string | null;
  /** Pep Quality */
  pep_quality?: boolean | null;
  /**
   * Cluster
   * A cluster is a group of customers displayed with a color
   */
  cluster?: string | null;
  /**
   * Is Blocked
   * Indicates if the customer is blocked
   * @default false
   */
  is_blocked?: boolean;
  /** Current email verification status, set only by EMAIL_VERIFICATION events */
  email_verification?: EmailVerification | null;
  /**
   * Zrm Only
   * Customer is handled in ZRM only (not in Sverker; derived)
   * @default false
   */
  zrm_only?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: EmployerNO | null;
  /** Ev Estate */
  ev_estate?: EvEstate[] | null;
  /** Ev Estates */
  ev_estates?: EvProperty[] | null;
  /** Ev Checked At */
  ev_checked_at?: string | null;
  /** Citizenship Iso Codes */
  citizenship_iso_codes?: string[] | null;
  /** Grunnkrets */
  grunnkrets?: string | null;
  /**
   * Cars In The Household
   * Number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Externally Verified Credits */
  externally_verified_credits?: ExternallyVerifiedCreditOutput[] | null;
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  credit_check?: CreditCheckNO | null;
  external_block_check?: ExternalBlockCheckNO | null;
  block_list?: BlockList | null;
  gender?: Gender | null;
  /** Blocked Credit Check Timestamp */
  blocked_credit_check_timestamp?: string | null;
  /**
   * Gr Consent
   * @default false
   */
  gr_consent?: boolean;
  /** Last Externally Verified Credits Consent */
  last_externally_verified_credits_consent?: string | null;
}

/** ApplicantSE */
export interface ApplicantSE {
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /** Pni */
  pni: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: PhoneNumberOutput[] | null;
  /** Sverker Id */
  sverker_id?: number | null;
  /** Children */
  children?: number | null;
  /** Citizen */
  citizen?: number | null;
  education?: EducationType | null;
  /** Monthly Partner Income */
  monthly_partner_income?: number | null;
  /** Immigrated At */
  immigrated_at?: string | null;
  /** Fullname */
  fullname?: string | null;
  /** Documents */
  documents?: ApplicantDocument[] | null;
  /** Verified Credits */
  verified_credits?: boolean | null;
  /** Housing Since */
  housing_since?: string | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Deceased Date */
  deceased_date?: string | null;
  /** Emigrated */
  emigrated?: boolean | null;
  /** Is Sanction */
  is_sanction?: boolean | null;
  /** Is Rca */
  is_rca?: boolean | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  /** Last Credit Check */
  last_credit_check?: string | null;
  /** Last Externally Verified Credits */
  last_externally_verified_credits?: string | null;
  /** Last Property Valuation */
  last_property_valuation?: string | null;
  /** Pep Quality */
  pep_quality?: any;
  /**
   * Cluster
   * A cluster is a group of customers displayed with a color
   */
  cluster?: string | null;
  /**
   * Is Blocked
   * Indicates if the customer is blocked
   * @default false
   */
  is_blocked?: boolean;
  /** Current email verification status, set only by EMAIL_VERIFICATION events */
  email_verification?: EmailVerification | null;
  /**
   * Zrm Only
   * Customer is handled in ZRM only (not in Sverker; derived)
   * @default false
   */
  zrm_only?: boolean;
  housing_type?: HousingTypeSE | null;
  employer?: EmployerSE | null;
  /** Census Registration Year */
  census_registration_year?: string | null;
  /** Credit Regulation Information */
  credit_regulation_information?: CreditRegulationInformation[] | null;
  /** Credit Regulations */
  credit_regulations?: CreditRegulation[] | null;
  /** Case Collection */
  case_collection?: CaseCollectionItem[] | null;
  /** Current Section Of Case */
  current_section_of_case?: CurrentSectionOfCaseItem[] | null;
  /** Current Frame */
  current_frame?: CurrentFrameItem[] | null;
  /** Html */
  html?: string | null;
  /** Last Queries */
  last_queries?: LastQuery[] | null;
  /** Notes */
  notes?: Note[] | null;
  /** Tax */
  tax?: TaxItem[] | null;
  /** Tax Thousands */
  tax_thousands?: TaxThousand[] | null;
  /** Fraudster */
  fraudster?: boolean | null;
  /** Investigation Barrier */
  investigation_barrier?: boolean | null;
  /** Uc Interall */
  uc_interall?: string | null;
  /** Date Of Birth */
  date_of_birth?: string | null;
  /** Prenup Text */
  prenup_text?: string | null;
  /** Uc Internal 2 */
  uc_internal_2?: null;
  /** Parish */
  parish?: string | null;
  /** Parish Code */
  parish_code?: string | null;
  /** Blocked */
  blocked?: boolean | null;
  /** Protected Address */
  protected_address?: boolean | null;
  /** Protected Identity */
  protected_identity?: boolean | null;
  /** Marital Status Date */
  marital_status_date?: string | null;
  /** Minor */
  minor?: string | null;
  /** Lost Id Documents */
  lost_id_documents?: boolean | null;
  /** County */
  county?: string | null;
  /** County Code */
  county_code?: string | null;
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  credit_check?: CreditCheckSE | null;
  block_list?: BlockList | null;
  gender?: Gender | null;
}

/**
 * Application
 * Application model in ZRM
 */
export interface Application {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: SharedModelsStatusStatus | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: SharedMortgageSeSpecCommonDefinitionsCars | null;
  brokerage?: Brokerage | null;
  product: Product;
  country: Country;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Offers */
  offers?: Offer[] | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  meta?: ApplicationMapping | null;
}

/** ApplicationAssigned */
export interface ApplicationAssigned {
  /** Type */
  type: "APPLICATION_ASSIGNED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: ApplicationAssignedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** ApplicationAssignedData */
export interface ApplicationAssignedData {
  /** Application Id */
  application_id: string;
  product?: Product | null;
}

/** ApplicationContext */
export interface ApplicationContext {
  /** Application Id */
  application_id: string;
  /** Active */
  active: boolean | null;
  /** Owner Id */
  owner_id: string | null;
  /** Owner Name */
  owner_name: string | null;
}

export type ApplicationCreatedResponse = CreatedResponseOut;

export type ApplicationCreatedResponseExt = CreatedResponseOut;

/** ApplicationDisbursed */
export interface ApplicationDisbursed {
  /** Type */
  type: "APPLICATION_DISBURSED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: ApplicationDisbursedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** ApplicationDisbursedData */
export interface ApplicationDisbursedData {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  product?: Product | null;
}

/** ApplicationFormPayload */
export interface ApplicationFormPayload {
  product: Product;
  country: Country;
}

/** ApplicationHistory */
export interface ApplicationHistory {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  state: AppState;
  /**
   * Main Applicant Id
   * @format uuid
   */
  main_applicant_id: string;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
}

/** ApplicationMapperResponse */
export interface ApplicationMapperResponse {
  /**
   * Event
   * @default "application_mapper"
   */
  event?: "application_mapper";
  data?: ApplicationMapping | null;
}

/** ApplicationMapping */
export interface ApplicationMapping {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Creator Id */
  creator_id?: string | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** Events */
  events?: ModelsApplicationMappingApplicationMappingEvent[] | null;
  /** Documents */
  documents?: DocumentAssignation[] | null;
  source?: ModelsApplicationMappingApplicationMappingApplicationSource | null;
  /** Lead Id */
  lead_id?: string | null;
  aml: AML;
  /** Bank Id Verifications */
  bank_id_verifications?: BankIDSigned[] | null;
  /**
   * Created From Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  created_from_id?: string | null;
  /** Created From Creator Id */
  created_from_creator_id?: string | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
  /** Tags */
  tags?: string[] | null;
  /** Mortgage Reviewer Id */
  mortgage_reviewer_id?: string | null;
  /**
   * Free For All
   * @default false
   */
  free_for_all?: boolean;
  /**
   * Free For All Accepted
   * @default false
   */
  free_for_all_accepted?: boolean;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  manual_application_state?: ManualApplicationState | null;
  /**
   * Online
   * @default false
   */
  online?: boolean;
  resolved_origin?: ResolvedOrigin | null;
  /**
   * Moved To Zrm
   * @default false
   */
  moved_to_zrm?: boolean;
  /** Internal Comments */
  internal_comments: (
    | ModelsApplicationMappingCommentsInternalComment
    | BankIDSigned
  )[];
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  product: Product;
  country: Country;
}

/** ApplicationMappingWithNamesInComments */
export interface ApplicationMappingWithNamesInComments {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Creator Id */
  creator_id?: string | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** Events */
  events?: ModelsApplicationMappingApplicationMappingEvent[] | null;
  /** Documents */
  documents?: DocumentAssignation[] | null;
  source?: ModelsApplicationMappingApplicationMappingApplicationSource | null;
  /** Lead Id */
  lead_id?: string | null;
  aml: AML;
  /** Bank Id Verifications */
  bank_id_verifications?: BankIDSigned[] | null;
  /**
   * Created From Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  created_from_id?: string | null;
  /** Created From Creator Id */
  created_from_creator_id?: string | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
  /** Tags */
  tags?: string[] | null;
  /** Mortgage Reviewer Id */
  mortgage_reviewer_id?: string | null;
  /**
   * Free For All
   * @default false
   */
  free_for_all?: boolean;
  /**
   * Free For All Accepted
   * @default false
   */
  free_for_all_accepted?: boolean;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  manual_application_state?: ManualApplicationState | null;
  /**
   * Online
   * @default false
   */
  online?: boolean;
  resolved_origin?: ResolvedOrigin | null;
  /**
   * Moved To Zrm
   * @default false
   */
  moved_to_zrm?: boolean;
  /** Internal Comments */
  internal_comments: (InternalCommentWithName | BankIDSignedWithNames)[];
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  product: Product;
  country: Country;
}

/** ApplicationMilestones */
export interface ApplicationMilestones {
  /**
   * Version
   * @default 1
   */
  version?: number;
  /** First Autoinvite Timestamp */
  first_autoinvite_timestamp?: string | null;
  /** All Invites Requested Timestamp */
  all_invites_requested_timestamp?: string | null;
}

/** ApplicationQuery */
export interface ApplicationQuery {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
}

/** ApplicationRejected */
export interface ApplicationRejected {
  /** Type */
  type: "APPLICATION_REJECTED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: ApplicationRejectedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** ApplicationRejectedData */
export interface ApplicationRejectedData {
  /** Application Id */
  application_id: string;
  product?: Product | null;
}

/** ApplicationResponse */
export interface ApplicationResponse {
  /**
   * Event
   * @default "applications"
   */
  event?: "applications";
  /** Data */
  data: (
    | (
        | ({
            country: "NO";
          } & RawBlancoApplicationNO)
        | ({
            country: "SE";
          } & RawBlancoApplicationSE)
      )
    | RawCreditCardApplicationNO
    | (
        | ({
            country: "NO";
          } & RawMortgageApplicationNO)
        | ({
            country: "SE";
          } & RawMortgageApplicationSE)
      )
  )[];
}

/** ApplicationSummaryResponse */
export interface ApplicationSummaryResponse {
  /**
   * Event
   * @default "application_summary"
   */
  event?: "application_summary";
  /** Data */
  data: string;
  /** Expired */
  expired: boolean;
}

/** ApplicationWithNamesInComments */
export interface ApplicationWithNamesInComments {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: SharedModelsStatusStatus | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: SharedMortgageSeSpecCommonDefinitionsCars | null;
  brokerage?: Brokerage | null;
  product: Product;
  country: Country;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Offers */
  offers?: Offer[] | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  meta: ApplicationMappingWithNamesInComments;
}

/** ApplicationsHistoryResponse */
export interface ApplicationsHistoryResponse {
  /**
   * Event
   * @default "applications_history"
   */
  event?: "applications_history";
  /** Data */
  data: ApplicationHistory[];
}

/** AppsSearchResult */
export interface AppsSearchResult {
  /** Search Types */
  search_types: Partial<Record<any, SearchType[]>>;
  /** Apps */
  apps: AppBase[];
}

/** AssignApplicationPayload */
export interface AssignApplicationPayload {
  /** Handler Id */
  handler_id: string;
}

/** AssignHandlerToMeetingPayload */
export interface AssignHandlerToMeetingPayload {
  /** Meeting Id */
  meeting_id: string;
  /** Handler Id */
  handler_id: string;
  /** Expected Previous Handler */
  expected_previous_handler?: string | null;
  /** Snapshot Revision */
  snapshot_revision?: string | null;
}

/**
 * AssignOwnerManualPayload
 * A named handler: a KA's first choice, or a change of owner (``source = manual``).
 */
export interface AssignOwnerManualPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * Distribution Op Id
   * @minLength 1
   * @maxLength 200
   */
  distribution_op_id: string;
  /** Expected Previous Owner Id */
  expected_previous_owner_id: string | null;
  /** Handler Id */
  handler_id: string;
}

/**
 * AssignOwnerPayload
 * The assign button. ``reassign`` re-ranks a case that already has an owner.
 */
export interface AssignOwnerPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * Distribution Op Id
   * @minLength 1
   * @maxLength 200
   */
  distribution_op_id: string;
  /** Expected Previous Owner Id */
  expected_previous_owner_id: string | null;
  /**
   * Reassign
   * @default false
   */
  reassign?: boolean;
}

/** Assignee */
export interface Assignee {
  /** Handler Id */
  handler_id?: string | null;
  /** Name */
  name?: string | null;
}

/** Attributes */
export interface Attributes {
  /** Usablearea */
  UsableArea?: number | null;
  /** Internalusablearea */
  InternalUsableArea?: number | null;
  /** Primaryarea */
  PrimaryArea?: number | null;
  /** Grossarea */
  GrossArea?: number | null;
  /** Floorarea */
  FloorArea?: number | null;
  /** Plotarea */
  PlotArea?: number | null;
  /** Buildyear */
  BuildYear?: number | null;
  /** Numberofrooms */
  NumberOfRooms?: number | null;
  /** Numberofbedrooms */
  NumberOfBedrooms?: number | null;
  /** Floor */
  Floor?: number | null;
  /** Numberoffloors */
  NumberOfFloors?: number | null;
  /** Estatetype */
  EstateType?: string | null;
  /** Estatesubtype */
  EstateSubType?: string | null;
  /** Realestateownership */
  RealEstateOwnership?: string | null;
  /** Plotownership */
  PlotOwnership?: string | null;
  /** Citydistrict */
  CityDistrict?: string | null;
}

/** Autoinvite */
export interface Autoinvite {
  /** Started At */
  started_at?: string | null;
  /** Completed At */
  completed_at?: string | null;
  /** Status */
  status: string;
  /** Events */
  events: TimelineEvent[];
}

/**
 * AvailabilityWindow
 * A contiguous block when an employee is working AND free, tagged with its service line.
 */
export interface AvailabilityWindow {
  /**
   * Window Start
   * @format date-time
   */
  window_start: string;
  /**
   * Window End
   * @format date-time
   */
  window_end: string;
  product: Product;
  country: Country;
}

/** Available */
export interface Available {
  /** Available */
  available: ModelsDialMaker2CampaignAggregateCampaign[];
  /** Joined Campaigns */
  joined_campaigns: JoinedCampaignExt[];
}

/** AvailableBookings */
export interface AvailableBookings {
  /** Available Slots */
  available_slots: Slots[];
}

/** Balance */
export interface Balance {
  /**
   * Date
   * Date
   */
  date?: string | null;
  /**
   * Amount
   * Amount in SEK
   */
  amount?: number | null;
}

/** Bank */
export interface Bank {
  /** Bank Id */
  bank_id: number;
  country: Country;
  /** Name */
  name: string;
}

/** BankAPIDrivenKALP */
export interface BankAPIDrivenKALP {
  /** Bank Id */
  bank_id: number;
  country: Country;
  /** Name */
  name: string;
  /** Api Driven */
  api_driven: true;
}

/** BankAccount */
export interface BankAccount {
  /** Clearing Number */
  clearing_number?: string | null;
  /** Account Number */
  account_number: string;
}

/** BankApplicant */
export interface BankApplicant {
  /** Customer */
  customer:
    | ({
        country: "NO";
      } & LimitedApplicantNO)
    | ({
        country: "SE";
      } & LimitedApplicantSE);
  role: ApplicantRole;
}

/** BankApplicationCCNO */
export interface BankApplicationCCNO {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /** Active */
  active: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankCreditCardOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  /**
   * Product
   * @default "credit_card"
   */
  product?: "credit_card";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: CreditCardApplicationData;
  /** Applicant */
  applicant:
    | ({
        country: "NO";
      } & ApplicantNO)
    | ({
        country: "SE";
      } & ApplicantSE);
}

/** BankApplicationMONO */
export interface BankApplicationMONO {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "mortgage"
   */
  product?: "mortgage";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data NO */
  data: BlancoApplicationDataNO;
  applicant: ApplicantNO;
  co_applicant?: ApplicantNO | null;
}

/** BankApplicationMOSE */
export interface BankApplicationMOSE {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /** Active */
  active: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankMortgageOffer[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  /**
   * Product
   * @default "mortgage"
   */
  product?: "mortgage";
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: MortgageApplicationSEData;
  mortgage_status?: MortgageStatus | null;
  /** Applicant */
  applicant:
    | ({
        country: "NO";
      } & ApplicantNO)
    | ({
        country: "SE";
      } & ApplicantSE);
  /** Co Applicant */
  co_applicant?:
    | (
        | ({
            country: "NO";
          } & ApplicantNO)
        | ({
            country: "SE";
          } & ApplicantSE)
      )
    | null;
  /** Guarantor */
  guarantor?:
    | (
        | ({
            country: "NO";
          } & ApplicantNO)
        | ({
            country: "SE";
          } & ApplicantSE)
      )
    | null;
  property?: Property | null;
}

/** BankApplicationULNO */
export interface BankApplicationULNO {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "blanco"
   */
  product?: "blanco";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data NO */
  data: BlancoApplicationDataNO;
  applicant: ApplicantNO;
  co_applicant?: ApplicantNO | null;
}

/** BankApplicationULSE */
export interface BankApplicationULSE {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "blanco"
   */
  product?: "blanco";
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data SE */
  data: BlancoApplicationDataSE;
  applicant: ApplicantSE;
  co_applicant?: ApplicantSE | null;
}

/** BankApplicationsPayload */
export interface BankApplicationsPayload {
  product: Product;
  country: Country;
  /** Bank Ids */
  bank_ids: number[];
  /** Bank Statuses */
  bank_statuses?: SharedApplication2CommonBankStatus[] | null;
}

/** BankBaseApp */
export interface BankBaseApp {
  product: Product;
  country: Country;
  /** Applicants */
  applicants: BankApplicant[];
  /** Application Id */
  application_id: string;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  /**
   * Date Updated
   * @format date-time
   */
  date_updated: string;
  status: SharedModelsStatusStatus;
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Property */
  property?: SharedModelsPropertyCondominium | House | VacationHome | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: SharedMortgageSeSpecCommonDefinitionsCars | null;
  bank_status: SharedModelsStatusBankStatus;
}

/**
 * BankCaseDocument
 * A case document as a bank portal user sees it. Nothing about other banks, Zensum users, the customer, the
 * storage or the AppLabel.
 */
export interface BankCaseDocument {
  /** Document Id */
  document_id: string;
  document_type: MonoDocumentType;
  /** Filename */
  filename: string;
  /** Content Type */
  content_type: string;
  /** File Size */
  file_size: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Uploaded By Bank
   * Uploaded through the portal by the reader's own bank
   */
  uploaded_by_bank: boolean;
}

/** BankComment */
export interface BankCommentInput {
  /** Comment */
  comment: string;
  /** Application Id */
  application_id: string;
  /** Bank Id */
  bank_id: number;
}

/** BankComment */
export interface BankCommentOutput {
  /**
   * Event Id
   * @format uuid
   */
  event_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Comment */
  comment: string;
  origin: BankCommentOrigin;
  /** User Name */
  user_name?: string | null;
  /** User Id */
  user_id?: string | null;
  /**
   * Reported User Id
   * Author ID asserted by the caller; not verified
   */
  reported_user_id?: string | null;
  /**
   * User Name Source
   * Caller-supplied display name; not token-verified
   */
  user_name_source?: "caller" | null;
  /** Message Id */
  message_id?: string | null;
  delivery_status?: DeliveryStatus | null;
  sender: BankCommentSender;
}

/** BankCommentV2 */
export interface BankCommentV2 {
  /**
   * Comment
   * @minLength 1
   */
  comment: string;
  /** Application Id */
  application_id: string;
  /** Bank Id */
  bank_id: number;
  /**
   * Idempotency Key
   * @format uuid4
   */
  idempotency_key: string;
}

/** BankCommunication */
export interface BankCommunication {
  /** Events */
  events: (
    | BankCommunicationEventOffer
    | BankCommunicationEvent
    | BankCommunicationEventDocumentInfo
    | BankCommunicationEventCommentAdded
    | BankCommunicationEventBankMessage
    | BankCommunicationEventInvalidInvite
    | BankCommunicationEventDocumentSent
    | BankCommunicationEventLeftToLive
  )[];
  /** Bank Id */
  bank_id: number;
  /** Bank Name */
  bank_name?: string | null;
  /** Actions */
  actions: IntegrationAction[];
  /** Encoded App Id */
  encoded_app_id: string;
  /** Last External Id */
  last_external_id?: string | null;
}

/** BankCommunicationData */
export type BankCommunicationData = Record<string, any>;

/** BankCommunicationDataCommentAdded */
export interface BankCommunicationDataCommentAdded {
  /** Comment */
  comment: string;
  /** User Name */
  user_name?: string | null;
  /** User Name Shown To Bank */
  user_name_shown_to_bank?: string | null;
  /** Reported User Id */
  reported_user_id?: string | null;
}

/** BankCommunicationDataDocumentInfo */
export interface BankCommunicationDataDocumentInfo {
  /** Documents */
  documents: DocRequest[];
}

/** BankCommunicationDataDocumentSent */
export interface BankCommunicationDataDocumentSent {
  /** Document Id */
  document_id: string;
  /** Customer Id */
  customer_id: string;
}

/** BankCommunicationDataInvalidInvite */
export interface BankCommunicationDataInvalidInvite {
  /** Messages */
  messages: string[];
}

/** BankCommunicationDataOffer */
export interface BankCommunicationDataOffer {
  /** Comment */
  comment?: string | null;
  /**
   * Offeredamount
   * @exclusiveMin 0
   */
  offeredAmount: number;
  currency: Currency;
  /** Bindingperiodmonth */
  bindingPeriodMonth: number;
  /** Interestrate */
  interestRate: number;
  /** Discount */
  discount: number;
  amortizationRule: AmortizationRule;
  /** Monthlyamortization */
  monthlyAmortization: number;
  /** Invoicefee */
  invoiceFee?: number | null;
  /** Setupfee */
  setupFee?: number | null;
  /** Autogirofee */
  autogiroFee?: number | null;
  /** Amortizationlength */
  amortizationLength?: number | null;
  /** Firstmonthlypayment */
  firstMonthlyPayment: number;
}

/** BankCommunicationEvent */
export interface BankCommunicationEvent {
  direction: Direction;
  /** Event Id */
  event_id: string;
  type: BankEventType;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankCommunicationData;
  /** User Id */
  user_id?: string | null;
}

/** BankCommunicationEventBankMessage */
export interface BankCommunicationEventBankMessage {
  direction: Direction;
  /** Event Id */
  event_id: string;
  /** Type */
  type: "MESSAGE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankCommunicationDataCommentAdded;
  /** User Id */
  user_id?: string | null;
}

/** BankCommunicationEventCommentAdded */
export interface BankCommunicationEventCommentAdded {
  direction: Direction;
  /** Event Id */
  event_id: string;
  /** Type */
  type: "COMMENT_TO_BANK_ADDED" | "COMMENT_ADDED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankCommunicationDataCommentAdded;
  /** User Id */
  user_id?: string | null;
}

/** BankCommunicationEventDocumentInfo */
export interface BankCommunicationEventDocumentInfo {
  direction: Direction;
  /** Event Id */
  event_id: string;
  /** Type */
  type: "DOCUMENT_INFO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankCommunicationDataDocumentInfo;
  /** User Id */
  user_id?: string | null;
}

/** BankCommunicationEventDocumentSent */
export interface BankCommunicationEventDocumentSent {
  direction: Direction;
  /** Event Id */
  event_id: string;
  /** Type */
  type: "DOCUMENT_TO_BANK_ADDED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankCommunicationDataDocumentSent;
  /** User Id */
  user_id?: string | null;
}

/** BankCommunicationEventInvalidInvite */
export interface BankCommunicationEventInvalidInvite {
  direction: Direction;
  /** Event Id */
  event_id: string;
  /** Type */
  type: "INVITE_APP_INVALID";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankCommunicationDataInvalidInvite;
  /** User Id */
  user_id?: string | null;
}

/** BankCommunicationEventLeftToLive */
export interface BankCommunicationEventLeftToLive {
  direction: Direction;
  /** Event Id */
  event_id: string;
  /** Type */
  type: "LEFT_TO_LIVE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: LeftToLiveResponse;
  /** User Id */
  user_id?: string | null;
}

/** BankCommunicationEventOffer */
export interface BankCommunicationEventOffer {
  direction: Direction;
  /** Event Id */
  event_id: string;
  /** Type */
  type: "OFFER";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankCommunicationDataOffer;
  /** User Id */
  user_id?: string | null;
}

/** BankDisbursePayload */
export interface BankDisbursePayload {
  /** Mortgage Amount */
  mortgage_amount?: number | null;
  /** Bridge Loan Amount */
  bridge_loan_amount?: number | null;
  /** Disburse Date */
  disburse_date?: string | null;
  /** Application Id */
  application_id: string;
}

/**
 * BankEvent
 * Generic fallback bank event for types without a dedicated typed sub-model.
 *
 * `BankEvents.events` is a discriminated union; other members pin `type` to a
 * `Literal[...]` and carry a strongly-typed `data` payload (offer, invalid invite/accept,
 * document info, etc.). `BankEvent` accepts any `BankEventType` with the permissive
 * `BankEventData` (`extra='allow'`, no required fields), so it would happily swallow
 * *any* event — including OFFER / INVALID / ACCEPT_INVALID — and bury their typed
 * payload as untyped extras if the dedicated sub-model failed to validate.
 *
 * The `validate_type` guard rejects those types here, forcing them to be parsed by their
 * dedicated sub-models instead and preserving the API's typed contract. Add a new type
 * to the exclusion list whenever you introduce a sub-model with required `data` fields.
 */
export interface BankEvent {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  type: BankEventType;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventData;
  /** User Id */
  user_id?: string | null;
}

/** BankEventCommentAdded */
export interface BankEventCommentAdded {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "COMMENT_TO_BANK_ADDED" | "COMMENT_ADDED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataCommentAdded;
  /** User Id */
  user_id?: string | null;
}

/** BankEventData */
export type BankEventData = Record<string, any>;

/** BankEventDataCommentAdded */
export interface BankEventDataCommentAdded {
  /** Comment */
  comment: string;
  /** User Name */
  user_name?: string | null;
  /** User Name Shown To Bank */
  user_name_shown_to_bank?: string | null;
}

/** BankEventDataDocumentInfo */
export interface BankEventDataDocumentInfo {
  /** Documents */
  documents: DocRequest[];
}

/** BankEventDataDocumentSent */
export interface BankEventDataDocumentSent {
  /** Document Id */
  document_id: string;
  /** Customer Id */
  customer_id: string;
}

/** BankEventDataInvalidAccept */
export interface BankEventDataInvalidAccept {
  /** Messages */
  messages: string[];
}

/** BankEventDataInvalidInvite */
export interface BankEventDataInvalidInvite {
  /** Messages */
  messages: string[];
}

/** BankEventDataOffer[CreditCardOfferData] */
export interface BankEventDataOfferCreditCardOfferData {
  offer: CreditCardOfferData;
}

/** BankEventDataOffer[MortgageOfferExt] */
export interface BankEventDataOfferMortgageOfferExt {
  offer: MortgageOfferExt;
}

/** BankEventDocumentInfo */
export interface BankEventDocumentInfo {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "DOCUMENT_INFO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataDocumentInfo;
  /** User Id */
  user_id?: string | null;
}

/** BankEventDocumentSent */
export interface BankEventDocumentSent {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "DOCUMENT_TO_BANK_ADDED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataDocumentSent;
  /** User Id */
  user_id?: string | null;
}

/** BankEventInvalidAccept */
export interface BankEventInvalidAccept {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "ACCEPT_APP_INVALID";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataInvalidAccept;
  /** User Id */
  user_id?: string | null;
}

/** BankEventInvalidInvite */
export interface BankEventInvalidInvite {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "INVITE_APP_INVALID";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataInvalidInvite;
  /** User Id */
  user_id?: string | null;
}

/** BankEventMessage */
export interface BankEventMessage {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "MESSAGE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataCommentAdded;
  /** User Id */
  user_id?: string | null;
}

/** BankEventOffer[CreditCardOfferData] */
export interface BankEventOfferCreditCardOfferData {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "OFFER";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataOfferCreditCardOfferData;
  /** User Id */
  user_id?: string | null;
}

/** BankEventOffer[MortgageOfferExt] */
export interface BankEventOfferMortgageOfferExt {
  direction: Direction;
  /**
   * Event Id
   * @format uuid4
   */
  event_id: string;
  /** Type */
  type: "OFFER";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: BankEventDataOfferMortgageOfferExt;
  /** User Id */
  user_id?: string | null;
}

/** BankEvents[CreditCardOfferData] */
export interface BankEventsCreditCardOfferData {
  /** Events */
  events: (
    | BankEventOfferCreditCardOfferData
    | BankEvent
    | BankEventDocumentInfo
    | BankEventCommentAdded
    | BankEventMessage
    | BankEventInvalidInvite
    | BankEventInvalidAccept
    | BankEventDocumentSent
  )[];
  /** Bank Id */
  bank_id: number;
  /** Bank Name */
  bank_name?: string | null;
  /** Actions */
  actions: IntegrationAction[];
  /** Encoded App Id */
  encoded_app_id: string;
  /** Last External Id */
  last_external_id?: string | null;
}

/** BankEvents[MortgageOfferExt] */
export interface BankEventsMortgageOfferExt {
  /** Events */
  events: (
    | BankEventOfferMortgageOfferExt
    | BankEvent
    | BankEventDocumentInfo
    | BankEventCommentAdded
    | BankEventMessage
    | BankEventInvalidInvite
    | BankEventInvalidAccept
    | BankEventDocumentSent
  )[];
  /** Bank Id */
  bank_id: number;
  /** Bank Name */
  bank_name?: string | null;
  /** Actions */
  actions: IntegrationAction[];
  /** Encoded App Id */
  encoded_app_id: string;
  /** Last External Id */
  last_external_id?: string | null;
}

/** BankIDLoginResponse */
export interface BankIDLoginResponse {
  /** Token */
  token: string;
}

/** BankIDPayload */
export interface BankIDPayload {
  /** Customer Id */
  customer_id?: string | null;
  /** Pni */
  pni?: string | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
}

/** BankIDSigned */
export interface BankIDSigned {
  /** User Id */
  user_id: string;
  /**
   * Comment
   * @default "identified with Bank ID"
   */
  comment?: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Comment Id */
  comment_id: string;
  /** Action */
  action: "VERIFIED_BANK_ID";
  /** Customer Id */
  customer_id: string;
}

/** BankIDSignedWithNames */
export interface BankIDSignedWithNames {
  /** User Id */
  user_id: string;
  /**
   * Comment
   * @default "identified with Bank ID"
   */
  comment?: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Comment Id */
  comment_id: string;
  /** Action */
  action: "VERIFIED_BANK_ID";
  /** Customer Id */
  customer_id: string;
  /** User Name */
  user_name: string;
  /** User Avatar */
  user_avatar: string;
  /** Customer Name */
  customer_name: string;
}

/** BankIDVerifiedResponse */
export interface BankIDVerifiedResponse {
  /**
   * Event
   * @default "bank_id_verified"
   */
  event?: "bank_id_verified";
  data: InternalBankIDEvent | null;
}

/** BankKALP */
export interface BankKALP {
  /**
   * Current Property Interest
   * The current mortgage the customer has
   */
  current_property_interest: number;
  /** Current Property Amortization */
  current_property_amortization: number;
  /** Other Properties To Keep Interest */
  other_properties_to_keep_interest: number;
  /** Other Properties To Keep Amortization */
  other_properties_to_keep_amortization: number;
  /** Other Properties To Keep Fixed Monthly Running Cost */
  other_properties_to_keep_fixed_monthly_running_cost: Partial<
    Record<SharedModelsApplicationPropertyType, number | null>
  >;
  /** Other Properties To Keep Additional Monthly Running Cost */
  other_properties_to_keep_additional_monthly_running_cost: Partial<
    Record<SharedModelsApplicationPropertyType, number | null>
  >;
  /** Other Loans Interest */
  other_loans_interest: number;
  /**
   * Other Loans Amortization Terms In Months
   * 96 months is 8 years
   */
  other_loans_amortization_terms_in_months: number;
  /** Other Loans Type Exclude */
  other_loans_type_exclude: SharedModelsLoanLoanType[];
  /** Other Properties To Keep Amortization Property Types */
  other_properties_to_keep_amortization_property_types: SharedModelsApplicationPropertyType[];
  /** Cost Per Person */
  cost_per_person: CostPerPerson[];
  /** Additional Cost Per Person In Household */
  additional_cost_per_person_in_household: AdditionalCostPerPerson[];
  /** Child Benefit */
  child_benefit: ChildBenefit[];
  /** Property Tax Per Property */
  property_tax_per_property: Partial<
    Record<SharedModelsApplicationPropertyType, number | null>
  >;
  tax_deductions: TaxDeduction;
  cars?: ModelsMortgageKALPCars | null;
  /** Bank Id */
  bank_id: number;
  country: Country;
  /** Name */
  name: string;
  /** Api Driven */
  api_driven: false;
}

/** BankMessageReceived */
export interface BankMessageReceived {
  /** Type */
  type: "BANK_MESSAGE_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: BankMessageReceivedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** BankMessageReceivedData */
export interface BankMessageReceivedData {
  /** Application Id */
  application_id: string;
  /** Bank Id */
  bank_id: number;
  product?: Product | null;
  /** Bank Name */
  bank_name?: string | null;
}

/**
 * BankMilestones
 * When each thing first happened to one bank on one application.
 *
 * The five invite fields are five different questions, kept apart because the answers
 * genuinely differ: a bank can be asked and never reached, refused before anything left
 * the building, reached without the integration being involved, or still awaited. Nothing
 * here collapses them, because every collapse loses a case some caller needs - and a
 * caller that reconstructs "invited" from the raw fields gets it wrong silently.
 */
export interface BankMilestones {
  /** First Invite Request Timestamp */
  first_invite_request_timestamp?: string | null;
  /** First Invite Portal Only Request Timestamp */
  first_invite_portal_only_request_timestamp?: string | null;
  /** First Invite Filters Passed Timestamp */
  first_invite_filters_passed_timestamp?: string | null;
  /** First Invite Filtered Out Timestamp */
  first_invite_filtered_out_timestamp?: string | null;
  /** First Invite Sent Timestamp */
  first_invite_sent_timestamp?: string | null;
  /** First Invite Delivered Timestamp */
  first_invite_delivered_timestamp?: string | null;
  /** First Invite Outcome Timestamp */
  first_invite_outcome_timestamp?: string | null;
  /** First Invite Finished Timestamp */
  first_invite_finished_timestamp?: string | null;
  /** First Offer Timestamp */
  first_offer_timestamp?: string | null;
  /** First Rejection Timestamp */
  first_rejection_timestamp?: string | null;
}

/** BankOffer */
export interface BankOffer {
  /** Comment */
  comment?: string | null;
  /**
   * Offeredamount
   * @exclusiveMin 0
   */
  offeredAmount: number;
  currency: Currency;
  /** Bindingperiodmonth */
  bindingPeriodMonth: number;
  /** Interestrate */
  interestRate: number;
  /** Discount */
  discount: number;
  amortizationRule: AmortizationRule;
  /** Monthlyamortization */
  monthlyAmortization: number;
  /** Invoicefee */
  invoiceFee?: number | null;
  /** Setupfee */
  setupFee?: number | null;
  /** Autogirofee */
  autogiroFee?: number | null;
  /** Amortizationlength */
  amortizationLength?: number | null;
}

/** BankOfferPayload */
export interface BankOfferPayload {
  /** Bank Id */
  bank_id: number;
  /** Bank Reference Id */
  bank_reference_id?: string | null;
  offer: BankOffer;
  /** Application Id */
  application_id: string;
}

/** BankRejectPayload */
export interface BankRejectPayload {
  /** Application Id */
  application_id: string;
  /** Reason */
  reason: string;
}

/** BankUserWithBankNames */
export interface BankUserWithBankNames {
  /** User Id */
  user_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Username
   * @format email
   */
  username: string;
  /**
   * Deactivated
   * @default false
   */
  deactivated?: boolean;
  /** Banks */
  banks: Integration[];
}

/** Bank[BlancoOfferData] */
export interface BankBlancoOfferData {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Id */
  id: number;
  status: SharedApplication2CommonBankStatus;
  /** Bank Label */
  bank_label?: string | null;
  sub_status?: BankSubstatus | null;
  /**
   * Has Responded
   * @default false
   */
  has_responded?: boolean;
  /** Last Response Timestamp */
  last_response_timestamp?: string | null;
  /** Last Invite Request Timestamp */
  last_invite_request_timestamp?: string | null;
  /**
   * When each thing first happened to one bank on one application.
   *
   * The five invite fields are five different questions, kept apart because the answers
   * genuinely differ: a bank can be asked and never reached, refused before anything left
   * the building, reached without the integration being involved, or still awaited. Nothing
   * here collapses them, because every collapse loses a case some caller needs - and a
   * caller that reconstructs "invited" from the raw fields gets it wrong silently.
   */
  milestones?: BankMilestones;
  /**
   * Offers
   * @default []
   */
  offers?: BaseOfferBlancoOfferData[];
  /** Offer History */
  offer_history?: OfferHistoryEntryBlancoOfferData[];
  /** Comments */
  comments?: BankCommentOutput[];
  /** Invite Error */
  invite_error?: string | null;
  delivery_status?: DeliveryStatus | null;
}

/** Bank[CreditCardOfferData] */
export interface BankCreditCardOfferData {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Id */
  id: number;
  status: SharedApplication2CommonBankStatus;
  /** Bank Label */
  bank_label?: string | null;
  sub_status?: BankSubstatus | null;
  /**
   * Has Responded
   * @default false
   */
  has_responded?: boolean;
  /** Last Response Timestamp */
  last_response_timestamp?: string | null;
  /** Last Invite Request Timestamp */
  last_invite_request_timestamp?: string | null;
  /**
   * When each thing first happened to one bank on one application.
   *
   * The five invite fields are five different questions, kept apart because the answers
   * genuinely differ: a bank can be asked and never reached, refused before anything left
   * the building, reached without the integration being involved, or still awaited. Nothing
   * here collapses them, because every collapse loses a case some caller needs - and a
   * caller that reconstructs "invited" from the raw fields gets it wrong silently.
   */
  milestones?: BankMilestones;
  /**
   * Offers
   * @default []
   */
  offers?: BaseOfferCreditCardOfferData[];
  /** Offer History */
  offer_history?: OfferHistoryEntryCreditCardOfferData[];
  /** Comments */
  comments?: BankCommentOutput[];
  /** Invite Error */
  invite_error?: string | null;
  delivery_status?: DeliveryStatus | null;
}

/** Bank[MortgageOffer] */
export interface BankMortgageOffer {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Id */
  id: number;
  status: SharedApplication2CommonBankStatus;
  /** Bank Label */
  bank_label?: string | null;
  sub_status?: BankSubstatus | null;
  /**
   * Has Responded
   * @default false
   */
  has_responded?: boolean;
  /** Last Response Timestamp */
  last_response_timestamp?: string | null;
  /** Last Invite Request Timestamp */
  last_invite_request_timestamp?: string | null;
  /**
   * When each thing first happened to one bank on one application.
   *
   * The five invite fields are five different questions, kept apart because the answers
   * genuinely differ: a bank can be asked and never reached, refused before anything left
   * the building, reached without the integration being involved, or still awaited. Nothing
   * here collapses them, because every collapse loses a case some caller needs - and a
   * caller that reconstructs "invited" from the raw fields gets it wrong silently.
   */
  milestones?: BankMilestones;
  /**
   * Offers
   * @default []
   */
  offers?: BaseOfferMortgageOffer[];
  /** Offer History */
  offer_history?: OfferHistoryEntryMortgageOffer[];
  /** Comments */
  comments?: BankCommentOutput[];
  /** Invite Error */
  invite_error?: string | null;
  delivery_status?: DeliveryStatus | null;
}

/** BanksToExcludeInsuranceOfferingFor */
export interface BanksToExcludeInsuranceOfferingFor {
  /** Se */
  SE: number[];
  /** No */
  NO: number[];
}

/**
 * BareApplicantWithRole
 * Used to store applicant data in the application object in MongoDB
 */
export interface BareApplicantWithRole {
  /**
   * Customer Id
   * @format uuid4
   */
  customer_id: string;
  role: ApplicantRole;
}

/** BaseComment */
export interface BaseComment {
  /** Comment */
  comment: string;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Bank Id */
  bank_id: number;
}

/** BaseFormPreferencePayload */
export interface BaseFormPreferencePayload {
  /** Form Id */
  form_id: string;
  product: Product;
  country: Country;
}

/** BaseOffer[BlancoOfferData] */
export interface BaseOfferBlancoOfferData {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Ids */
  ids?: string[];
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** use only for events, it's not a model that should be used together with application */
  data: BlancoOfferData;
  /**
   * Accepted
   * @default false
   */
  accepted?: boolean;
  /** Broker Id */
  broker_id?: string | null;
  /** Broker Ids */
  broker_ids?: string[];
  /** External Id */
  external_id?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Accepted At */
  accepted_at?: string | null;
  /** Disbursed At */
  disbursed_at?: string | null;
  /** Error */
  error?: string | null;
  origin?: ChannelOrigin | null;
}

/** BaseOffer[CreditCardOfferData] */
export interface BaseOfferCreditCardOfferData {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Ids */
  ids?: string[];
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: CreditCardOfferData;
  /**
   * Accepted
   * @default false
   */
  accepted?: boolean;
  /** Broker Id */
  broker_id?: string | null;
  /** Broker Ids */
  broker_ids?: string[];
  /** External Id */
  external_id?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Accepted At */
  accepted_at?: string | null;
  /** Disbursed At */
  disbursed_at?: string | null;
  /** Error */
  error?: string | null;
  origin?: ChannelOrigin | null;
}

/** BaseOffer[MortgageOffer] */
export interface BaseOfferMortgageOffer {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Ids */
  ids?: string[];
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: MortgageOffer;
  /**
   * Accepted
   * @default false
   */
  accepted?: boolean;
  /** Broker Id */
  broker_id?: string | null;
  /** Broker Ids */
  broker_ids?: string[];
  /** External Id */
  external_id?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Accepted At */
  accepted_at?: string | null;
  /** Disbursed At */
  disbursed_at?: string | null;
  /** Error */
  error?: string | null;
  origin?: ChannelOrigin | null;
}

/** BasicSubmissionReview */
export interface BasicSubmissionReview {
  /** Submission Id */
  submission_id: string;
  /** Handled */
  handled?: boolean | null;
  /**
   * Reviews
   * @default []
   */
  reviews?: Reviewer[];
  /**
   * Success
   * @default false
   */
  success?: boolean;
  /**
   * Ongoing
   * @default false
   */
  ongoing?: boolean;
  /**
   * Submission Timestamp
   * @format date-time
   */
  submission_timestamp: string;
  /** Raw Data */
  raw_data: Record<string, any>;
  country: Country;
  product: Product;
  /** Request Id */
  request_id: string;
  /** @default {} */
  checklist?: Checklist;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Version
   * @default 1
   */
  version?: number | null;
}

/** BigQueryCampaignSource */
export interface BigQueryCampaignSource {
  /**
   * Type
   * @default "BIG_QUERY"
   */
  type?: "BIG_QUERY";
  /** Query */
  query: string;
  /**
   * Mapping
   * @default {}
   */
  mapping?: Record<string, string>;
  /** Imported At */
  imported_at?: string | null;
}

/** BlancoAMLPatchPayload */
export interface BlancoAMLPatchPayload {
  channel?: Channel | null;
  purpose?: AMLBlancoPurpose | null;
  purpose_when_new_loan?: LoanPurpose | null;
  country?: Country | null;
  /** Comment */
  comment?: string | null;
}

/** BlancoAMLReviewPayload */
export interface BlancoAMLReviewPayload {
  /** Comment */
  comment?: string | null;
  aml_review: AMLReviewStatus;
  country: Country;
}

/**
 * BlancoApplicationDataNO
 * Model for application data NO
 */
export interface BlancoApplicationDataNO {
  /** Desired Loan */
  desired_loan: number;
  /** New Loan */
  new_loan?: number | null;
  /** Desired Payback Time */
  desired_payback_time: number;
  /** Bidded Payback Time */
  bidded_payback_time: number;
  /**
   * Sum Loan
   * @default 0
   */
  sum_loan?: number;
  /** Created At */
  created_at?: string | null;
  /** Return At */
  return_at?: string | null;
  /** First Meeting */
  first_meeting?: string | null;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean;
  /**
   * Partial Refinance
   * @default true
   */
  partial_refinance?: boolean;
  /**
   * Refinance Amount
   * @default 0
   */
  refinance_amount?: number;
  /**
   * Refinance Percent
   * @default 0
   */
  refinance_percent?: number;
  /** @default "freja" */
  origin?: ApplicationOrigin;
  /** Priority */
  priority?: number | null;
  /** Auto Invite Start */
  auto_invite_start?: string | null;
  /** Creator */
  creator?: string | null;
  /** Handler */
  handler?: string | null;
  /**
   * Sverker Locked
   * @default false
   */
  sverker_locked?: boolean;
  sverker_status?: BlancoStatusLabel | null;
  /** Application Score */
  application_score?: number | null;
  /** Last Gr Event Id */
  last_gr_event_id?: string | null;
  /** Last Gr Synced At */
  last_gr_synced_at?: string | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
  /**
   * Applicant Id
   * @format uuid
   */
  applicant_id: string;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
  /**
   * Offers
   * @default []
   */
  offers?: BlancoOfferApp[];
  /**
   * Disbursed Loans
   * @default []
   */
  disbursed_loans?: DisbursedLoan[];
  /**
   * Disbursed Banks
   * @default []
   */
  disbursed_banks?: DisbursedBank[];
  /** Credits */
  credits: CreditNO[];
  loan_purpose?: LoanPurposeNO | null;
  legacy_relationship?: LegacyApplicantsRelationship | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  ska_override?: SkaOverride | null;
}

/**
 * BlancoApplicationDataSE
 * Model for application data SE
 */
export interface BlancoApplicationDataSE {
  /** Desired Loan */
  desired_loan: number;
  /** New Loan */
  new_loan?: number | null;
  /** Desired Payback Time */
  desired_payback_time: number;
  /** Bidded Payback Time */
  bidded_payback_time: number;
  /**
   * Sum Loan
   * @default 0
   */
  sum_loan?: number;
  /** Created At */
  created_at?: string | null;
  /** Return At */
  return_at?: string | null;
  /** First Meeting */
  first_meeting?: string | null;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean;
  /**
   * Partial Refinance
   * @default true
   */
  partial_refinance?: boolean;
  /**
   * Refinance Amount
   * @default 0
   */
  refinance_amount?: number;
  /**
   * Refinance Percent
   * @default 0
   */
  refinance_percent?: number;
  /** @default "freja" */
  origin?: ApplicationOrigin;
  /** Priority */
  priority?: number | null;
  /** Auto Invite Start */
  auto_invite_start?: string | null;
  /** Creator */
  creator?: string | null;
  /** Handler */
  handler?: string | null;
  /**
   * Sverker Locked
   * @default false
   */
  sverker_locked?: boolean;
  sverker_status?: BlancoStatusLabel | null;
  /** Application Score */
  application_score?: number | null;
  /** Last Gr Event Id */
  last_gr_event_id?: string | null;
  /** Last Gr Synced At */
  last_gr_synced_at?: string | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
  /**
   * Applicant Id
   * @format uuid
   */
  applicant_id: string;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
  /**
   * Offers
   * @default []
   */
  offers?: BlancoOfferApp[];
  /**
   * Disbursed Loans
   * @default []
   */
  disbursed_loans?: DisbursedLoan[];
  /**
   * Disbursed Banks
   * @default []
   */
  disbursed_banks?: DisbursedBank[];
  /** Credits */
  credits: CreditSE[];
  loan_purpose?: LoanPurposeSE | null;
}

/** BlancoApplicationDataSlim */
export interface BlancoApplicationDataSlim {
  /** Desired Loan */
  desired_loan: number;
  /** New Loan */
  new_loan?: number | null;
  /** Desired Payback Time */
  desired_payback_time: number;
  /** Bidded Payback Time */
  bidded_payback_time: number;
  /**
   * Sum Loan
   * @default 0
   */
  sum_loan?: number;
  /** Created At */
  created_at?: string | null;
  /** Return At */
  return_at?: string | null;
  /** First Meeting */
  first_meeting?: string | null;
  /**
   * Is Deactivated
   * @default false
   */
  is_deactivated?: boolean;
  /**
   * Partial Refinance
   * @default true
   */
  partial_refinance?: boolean;
  /**
   * Refinance Amount
   * @default 0
   */
  refinance_amount?: number;
  /**
   * Refinance Percent
   * @default 0
   */
  refinance_percent?: number;
  /** @default "freja" */
  origin?: ApplicationOrigin;
  /** Priority */
  priority?: number | null;
  /** Auto Invite Start */
  auto_invite_start?: string | null;
  /** Creator */
  creator?: string | null;
  /** Handler */
  handler?: string | null;
  /**
   * Sverker Locked
   * @default false
   */
  sverker_locked?: boolean;
  sverker_status?: BlancoStatusLabel | null;
  /** Application Score */
  application_score?: number | null;
  /** Last Gr Event Id */
  last_gr_event_id?: string | null;
  /** Last Gr Synced At */
  last_gr_synced_at?: string | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  app_label: string;
  /** Offers */
  offers: BlancoOfferApp[];
  /** Disbursed Loans */
  disbursed_loans: DisbursedLoan[];
  /** Disbursed Banks */
  disbursed_banks: DisbursedBank[];
  /** Return At Exact */
  return_at_exact: number;
  /** Main Applicant Pni */
  main_applicant_pni: string;
  /** Co Applicant Pni */
  co_applicant_pni?: string | null;
}

/** BlancoApplicationNO */
export interface BlancoApplicationNO {
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "blanco"
   */
  product?: "blanco";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data NO */
  data: BlancoApplicationDataNO;
  applicant: ApplicantNO;
  co_applicant?: ApplicantNO | null;
}

/** BlancoGoal */
export interface BlancoGoal {
  type_event: GoalType;
  /** User Id */
  user_id?: string[] | null;
  country: Country;
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Sent Loans
   * Count of sent loans
   */
  sent_loans: number;
  /**
   * Return Rate
   * A procent of the return rate of sent loans between 1-100
   */
  return_rate: number;
  /**
   * Disbursed Loans Count
   * The count of disbursed loans
   */
  disbursed_loans_count: number;
  /**
   * Working Days
   * Working days of the handler for chosen month
   */
  working_days: number;
  /**
   * Sent Loans Per Day
   * Count of sent loans per day
   */
  sent_loans_per_day: number;
  /**
   * Disbursed Amount
   * The amount of all disbursed loans in the chosen currency
   */
  disbursed_amount: number;
  /**
   * Sent Loans Amount
   * The amount of all sent loans in chosen currency
   */
  sent_loans_amount: number;
  /**
   * Signed Insurances
   * The count of signed insurances
   */
  signed_insurances: number;
  /**
   * Total Premium
   * The total premium of all signed insurances
   */
  total_premium: number;
  /**
   * Average Loan Amount
   * Average loan amount for chosen period, usually set from previous months
   */
  average_loan_amount: number;
  /**
   * Average Premium
   * Average premium of the insurances, usually set from previous months
   */
  average_premium: number;
  /**
   * Mortgage Leads
   * Amount of leads sent to Mortgage
   */
  mortgage_leads?: number | null;
}

/** BlancoGoalMb */
export interface BlancoGoalMb {
  type_event: GoalType;
  /** User Id */
  user_id?: string[] | null;
  country: Country;
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Applications
   * Number of created applications
   */
  applications: number;
  /**
   * Working Days
   * Working days of the handler for chosen month
   */
  working_days: number;
  /**
   * Disbursed Loans Count
   * Number of disbursed loans
   */
  disbursed_loans_count: number;
  /**
   * Disbursed Loans Amount
   * The amount of disbursed loans
   */
  disbursed_loans_amount: number;
  /**
   * Co Applicant Percentage
   * The percentage of applications sent with a co-applicant
   */
  co_applicant_percentage: number | null;
  /**
   * Average Loan Amount
   * Average loan amount for chosen period, usually set from previous months
   */
  average_loan_amount: number;
  /**
   * Applications Per Day
   * Count of created applications per day
   */
  applications_per_day: number;
  /**
   * Gr Percentage
   * Percent of applications that have GR
   */
  gr_percentage: number | null;
  /**
   * Disbursement Rate
   * Percent of sent applications that get disbursed
   */
  disbursement_rate: number;
}

/** BlancoGoalMbPayload */
export interface BlancoGoalMbPayload {
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /** User Ids */
  user_ids?: string[] | null;
  /**
   * Applications
   * Number of created applications
   */
  applications: number;
  /**
   * Working Days
   * Working days of the handler for chosen month, example: 20
   */
  working_days: number;
  /**
   * Disbursed Loans Count
   * Number of disbursed loans
   */
  disbursed_loans_count: number;
  /**
   * Disbursed Loans Amount
   * The amount of disbursed loans
   */
  disbursed_loans_amount: number;
  /**
   * Co Applicant Percentage
   * The percentage of applications sent with a co-applicant
   */
  co_applicant_percentage: number;
  /**
   * Average Loan Amount
   * Average loan amount for chosen period, usually set from previous months
   */
  average_loan_amount: number;
  /**
   * Applications Per Day
   * Count of created applications per day
   */
  applications_per_day: number;
  /**
   * Gr Percentage
   * Percent of applications that have GR
   */
  gr_percentage: number | null;
  /**
   * Disbursement Rate
   * Percent of sent applications that get disbursed
   */
  disbursement_rate: number;
}

/** BlancoGoalPayload */
export interface BlancoGoalPayload {
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /** User Ids */
  user_ids?: string[] | null;
  /**
   * Sent Loans
   * The count of sent loans
   */
  sent_loans: number;
  /**
   * Return Rate
   * A procent of the return rate of sent loans between 1-100
   */
  return_rate: number;
  /**
   * Working Days
   * Working days of the handler for chosen month, example: 20
   */
  working_days: number;
  /**
   * Signed Insurances
   * The count of signed insurances
   */
  signed_insurances: number;
  /**
   * Average Premium
   * An amount in the local currency
   */
  average_premium: number;
  /**
   * Sent Loans Per Day
   * Count of sent loans per day
   */
  sent_loans_per_day: number;
  /**
   * Disbursed Amount
   * The amount of all disbursed loans in the chosen currency
   */
  disbursed_amount: number;
  /**
   * Average Loan Amount
   * Average loan amount for chosen period, usually set from previous months
   */
  average_loan_amount: number;
  /**
   * Disbursed Loans Count
   * The count of disbursed loans
   */
  disbursed_loans_count: number;
  /**
   * Sent Loans Amount
   * The amount of all sent loans in chosen currency
   */
  sent_loans_amount: number;
  /**
   * Total Premium
   * The total premium of all signed insurances
   */
  total_premium: number;
  /**
   * Mortgage Leads
   * The amount of leads sent to mortgage
   */
  mortgage_leads?: number | null;
}

/** BlancoLoan */
export interface BlancoLoan {
  /**
   * Desired Amount
   * @default 0
   */
  desired_amount?: number | null;
  /** Loan Purpose */
  loan_purpose?: LoanPurposeNO | LoanPurposeSE | null;
}

/**
 * BlancoOfferApp
 * This is the real blanco offer class
 */
export interface BlancoOfferApp {
  /** Comment */
  comment?: string | null;
  amortizationRule?: AmortizationPlan | null;
  /** Offeredamount */
  offeredAmount: number;
  /** Minofferedamount */
  minOfferedAmount?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /** Termfee */
  termFee: number;
  /** Arrangementfee */
  arrangementFee: number;
  /** Invoicefee */
  invoiceFee: number;
  /** Customerurl */
  customerUrl?: string | null;
  creditorProduct?: CreditorProduct | null;
  condition?: OfferCondition | null;
  /** Ratepercent */
  ratePercent: number;
  /** Effectiveratepercent */
  effectiveRatePercent: number;
  /** Need More Info */
  need_more_info?: boolean | null;
  status?: OfferStatus | null;
  /** Invite Id */
  invite_id?: string | null;
  /** Totalrepaymentamount */
  totalRepaymentAmount?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Bank Id */
  bank_id: number;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
  /** Application Id */
  application_id: number;
  /** External Offer Id */
  external_offer_id?: string | null;
  /** Sverker Offer Id */
  sverker_offer_id?: number | null;
  /** Accepted At */
  accepted_at?: string | null;
  /** Disbursed At */
  disbursed_at?: string | null;
  /**
   * Total Cost
   * Total the customer pays over the loan: principal + interest + fees.
   *
   * Uses the bank-quoted ``totalRepaymentAmount`` when the integration supplied it,
   * otherwise derives the figure. Safe when fields needed by the calculation are
   * missing/None — returns ``0`` when the term is unknown, and treats other missing
   * inputs (amount, rate, fees) as ``0``.
   */
  total_cost: number;
  /**
   * Total Fees Amount
   * Arrangement fee plus the recurring monthly fees (term + invoice) over the whole term.
   */
  total_fees_amount: number;
  /**
   * Total Interest Amount
   * Interest only, derived as total_cost - principal - fees.
   *
   * Returns 0 when the term is unknown so we never emit a negative ``total_cost`` artefact.
   */
  total_interest_amount: number;
}

/**
 * BlancoOfferData
 * use only for events, it's not a model that should be used together with application
 */
export interface BlancoOfferData {
  /** Comment */
  comment?: string | null;
  amortizationRule?: AmortizationPlan | null;
  /** Offeredamount */
  offeredAmount: number;
  /** Minofferedamount */
  minOfferedAmount?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /** Termfee */
  termFee: number;
  /** Arrangementfee */
  arrangementFee: number;
  /** Invoicefee */
  invoiceFee: number;
  /** Customerurl */
  customerUrl?: string | null;
  creditorProduct?: CreditorProduct | null;
  condition?: OfferCondition | null;
  /** Ratepercent */
  ratePercent: number;
  /** Effectiveratepercent */
  effectiveRatePercent: number;
  /** Need More Info */
  need_more_info?: boolean | null;
  status?: OfferStatus | null;
  /** Invite Id */
  invite_id?: string | null;
  /** Totalrepaymentamount */
  totalRepaymentAmount?: number | null;
  /**
   * Total Cost
   * Total the customer pays over the loan: principal + interest + fees.
   *
   * Uses the bank-quoted ``totalRepaymentAmount`` when the integration supplied it,
   * otherwise derives the figure. Safe when fields needed by the calculation are
   * missing/None — returns ``0`` when the term is unknown, and treats other missing
   * inputs (amount, rate, fees) as ``0``.
   */
  total_cost: number;
  /**
   * Total Fees Amount
   * Arrangement fee plus the recurring monthly fees (term + invoice) over the whole term.
   */
  total_fees_amount: number;
  /**
   * Total Interest Amount
   * Interest only, derived as total_cost - principal - fees.
   *
   * Returns 0 when the term is unknown so we never emit a negative ``total_cost`` artefact.
   */
  total_interest_amount: number;
}

/** BlancoPatchDataNO */
export interface BlancoPatchDataNO {
  /** Desired Loan */
  desired_loan?: number;
  /** Desired Payback Time */
  desired_payback_time?: number;
  /** Bidded Payback Time */
  bidded_payback_time?: number;
  /** New Loan */
  new_loan?: number | null;
  /** Priority */
  priority?: number | null;
  /** Creator */
  creator?: string;
  /** Handler */
  handler?: string;
  /** Application Score */
  application_score?: number | null;
  /** Auto Invite Start */
  auto_invite_start?: string | null;
  /** Credits */
  credits?: CreditNO[] | null;
  loan_purpose?: LoanPurposeNO | null;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
}

/** BlancoPatchDataSE */
export interface BlancoPatchDataSE {
  /** Desired Loan */
  desired_loan?: number;
  /** Desired Payback Time */
  desired_payback_time?: number;
  /** Bidded Payback Time */
  bidded_payback_time?: number;
  /** New Loan */
  new_loan?: number | null;
  /** Priority */
  priority?: number | null;
  /** Creator */
  creator?: string;
  /** Handler */
  handler?: string;
  /** Application Score */
  application_score?: number | null;
  /** Auto Invite Start */
  auto_invite_start?: string | null;
  /** Credits */
  credits?: CreditSE[] | null;
  loan_purpose?: LoanPurposeSE | null;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
}

/** BlancoPatchPayloadNO */
export interface BlancoPatchPayloadNO {
  /**
   * Product
   * @default "blanco"
   */
  product?: "blanco";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  data: BlancoPatchDataNO;
}

/** BlancoPatchPayloadSE */
export interface BlancoPatchPayloadSE {
  /**
   * Product
   * @default "blanco"
   */
  product?: "blanco";
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  data: BlancoPatchDataSE;
}

/** BlockCustomerFieldManuallyPayload */
export interface BlockCustomerFieldManuallyPayload {
  country: Country;
  /** Reason */
  reason: string;
  field: BlockField;
  /** Blocked */
  blocked: boolean;
  /** Values */
  values: string[];
}

/** BlockCustomerFieldManuallyResponse */
export interface BlockCustomerFieldManuallyResponse {
  /** Result */
  result: BlockCustomerFieldManuallyResponseModel[];
}

/** BlockCustomerFieldManuallyResponseModel */
export interface BlockCustomerFieldManuallyResponseModel {
  /** Value */
  value: string;
  /** Blocked */
  blocked?: boolean | null;
}

/** BlockList */
export interface BlockList {
  /** Pni */
  pni?: boolean | null;
  /** Phone Number */
  phone_number?: boolean | null;
  /** Email */
  email?: boolean | null;
}

/** Body_activate_campaign_dialmaker_campaign_activate_post */
export interface BodyActivateCampaignDialmakerCampaignActivatePost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
}

/** Body_activate_campaign_v2_dialmaker_campaign_v2_activate_post */
export interface BodyActivateCampaignV2DialmakerCampaignV2ActivatePost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
}

/** Body_admin_dialmaker_admin_outcomes_post */
export interface BodyAdminDialmakerAdminOutcomesPost {
  /** Campaign Ids */
  campaign_ids: string[];
  /** User Ids */
  user_ids?: string[] | null;
}

/** Body_call_back_dialmaker_card_outcome_call_back_post */
export interface BodyCallBackDialmakerCardOutcomeCallBackPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** When */
  when?: string | null;
  /** Comment */
  comment?: string | null;
  /**
   * Personal Callback
   * @default true
   */
  personal_callback?: boolean;
  /**
   * Get Next
   * @default true
   */
  get_next?: boolean;
}

/** Body_call_back_dialmaker_card_outcome_later_post */
export interface BodyCallBackDialmakerCardOutcomeLaterPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** When */
  when?: string | null;
  /** Comment */
  comment?: string | null;
  /**
   * Personal Callback
   * @default true
   */
  personal_callback?: boolean;
  /**
   * Get Next
   * @default true
   */
  get_next?: boolean;
}

/** Body_call_discards_dialmaker_card_outcome_discard_post */
export interface BodyCallDiscardsDialmakerCardOutcomeDiscardPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Outcome */
  outcome: string;
  /**
   * Get Next
   * @default true
   */
  get_next?: boolean;
  /** Comment */
  comment?: string | null;
}

/** Body_call_failure_dialmaker_card_outcome_failure_post */
export interface BodyCallFailureDialmakerCardOutcomeFailurePost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Outcome */
  outcome: string;
  /**
   * Get Next
   * @default true
   */
  get_next?: boolean;
  /** Comment */
  comment?: string | null;
}

/** Body_call_no_contact_dialmaker_card_outcome_no_contact_post */
export interface BodyCallNoContactDialmakerCardOutcomeNoContactPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Outcome */
  outcome: string;
  /**
   * Get Next
   * @default true
   */
  get_next?: boolean;
  /** Comment */
  comment?: string | null;
}

/** Body_call_success_dialmaker_card_outcome_success_post */
export interface BodyCallSuccessDialmakerCardOutcomeSuccessPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Comment */
  comment?: string | null;
  /**
   * Get Next
   * @default true
   */
  get_next?: boolean;
}

/** Body_car_eval_with_consent_my_pages_car_eval_with_consent_post */
export interface BodyCarEvalWithConsentMyPagesCarEvalWithConsentPost {
  /** Phone Number */
  phone_number?: string | null;
  /** Email */
  email?: string | null;
  /** Marketing Consent */
  marketing_consent?: boolean | null;
}

/** Body_claim_todomaker_claim_post */
export interface BodyClaimTodomakerClaimPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
}

/** Body_create_url_url_tracker_url_post */
export interface BodyCreateUrlUrlTrackerUrlPost {
  /** Url Name */
  url_name: string;
  /**
   * Target Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  target_url: string;
  utm_tags?: UtmTags | null;
  /** Meta Params */
  meta_params?: DynamicMetaParams[] | null;
}

/** Body_create_utm_tags_preset_url_tracker_utm_tags_preset_post */
export interface BodyCreateUtmTagsPresetUrlTrackerUtmTagsPresetPost {
  /** Utm Source */
  utm_source: string;
  /** Utm Medium */
  utm_medium: string;
  /** Utm Campaign */
  utm_campaign: string;
  /** Preset Name */
  preset_name: string;
}

/** Body_customer_applications_dialmaker_card_customer_applications_post */
export interface BodyCustomerApplicationsDialmakerCardCustomerApplicationsPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
}

/** Body_deactivate_application_op_deactivate__label__post */
export interface BodyDeactivateApplicationOpDeactivateLabelPost {
  reason?: OPDeactivationReason | null;
}

/** Body_deactivate_campaign_dialmaker_campaign_deactivate_post */
export interface BodyDeactivateCampaignDialmakerCampaignDeactivatePost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
}

/** Body_deactivate_campaign_v2_dialmaker_campaign_v2_deactivate_post */
export interface BodyDeactivateCampaignV2DialmakerCampaignV2DeactivatePost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
}

/** Body_debt_register_with_consent_my_pages_debt_register_with_consent_post */
export interface BodyDebtRegisterWithConsentMyPagesDebtRegisterWithConsentPost {
  /** Phone Number */
  phone_number: string | null;
  /** Email */
  email: string | null;
  /** Marketing Consent */
  marketing_consent: boolean | null;
}

/** Body_delete_extraction_dialmaker_campaign_extraction_delete */
export interface BodyDeleteExtractionDialmakerCampaignExtractionDelete {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /**
   * Extraction Id
   * @format uuid
   */
  extraction_id: string;
  /**
   * Force
   * Force unextract already assigned extractions
   * @default false
   */
  force?: boolean;
}

/** Body_delete_extraction_v2_dialmaker_campaign_v2_extraction_delete */
export interface BodyDeleteExtractionV2DialmakerCampaignV2ExtractionDelete {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /**
   * Extraction Id
   * @format uuid
   */
  extraction_id: string;
  /**
   * Force
   * Force unextract already assigned extractions
   * @default false
   */
  force?: boolean;
}

/** Body_elk46_call_webhook_message_elk46_call_post */
export interface BodyElk46CallWebhookMessageElk46CallPost {
  /** To */
  to: string;
  /** Callid */
  callid: string;
}

/** Body_ev_states_with_consent_my_pages_eiendomsverdie_with_consent_post */
export interface BodyEvStatesWithConsentMyPagesEiendomsverdieWithConsentPost {
  /** Phone Number */
  phone_number: string | null;
  /** Email */
  email: string | null;
  /** Marketing Consent */
  marketing_consent: boolean | null;
}

/** Body_export_and_extract_leads_url_dialmaker_campaign_export_post */
export interface BodyExportAndExtractLeadsUrlDialmakerCampaignExportPost {
  /**
   * Campaign Id
   * Campaign ID to export leads from
   * @format uuid
   */
  campaign_id: string;
  /**
   * Leads Count
   * Number of leads to extract and export
   */
  leads_count: number;
}

/** Body_export_and_extract_leads_url_download_dialmaker_campaign_extraction_export_post */
export interface BodyExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost {
  /**
   * Extraction Id
   * Extraction ID to export leads from
   * @format uuid
   */
  extraction_id: string;
}

/** Body_extract_campaigns_dialmaker_campaign_extract_post */
export interface BodyExtractCampaignsDialmakerCampaignExtractPost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Number Of Leads */
  number_of_leads: number;
}

/** Body_extract_campaigns_v2_dialmaker_campaign_v2_extract_post */
export interface BodyExtractCampaignsV2DialmakerCampaignV2ExtractPost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Number Of Leads */
  number_of_leads: number;
}

/** Body_find_campaigns_dialmaker_campaign_find_post */
export interface BodyFindCampaignsDialmakerCampaignFindPost {
  filter?: Filter | null;
  order?: Order | null;
}

/** Body_get_applications_v2_bank_v2_applications_post */
export interface BodyGetApplicationsV2BankV2ApplicationsPost {
  body: BankApplicationsPayload;
  params: Params;
}

/** Body_get_mail_statistics_dialmaker_campaign_mail_statistics_post */
export interface BodyGetMailStatisticsDialmakerCampaignMailStatisticsPost {
  /** Campaign Ids */
  campaign_ids: string[];
  /** Percentage */
  percentage: boolean;
  /**
   * Start
   * @format date-time
   */
  start: string;
  /**
   * End
   * @format date-time
   */
  end: string;
}

/** Body_get_outcomes_dialmaker_card_outcomes_post */
export interface BodyGetOutcomesDialmakerCardOutcomesPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
}

/** Body_get_sms_statistics_dialmaker_campaign_sms_statistics_post */
export interface BodyGetSmsStatisticsDialmakerCampaignSmsStatisticsPost {
  /** Campaign Ids */
  campaign_ids: string[];
  /** Percentage */
  percentage: boolean;
  /**
   * Start
   * @format date-time
   */
  start: string;
  /**
   * End
   * @format date-time
   */
  end: string;
}

/** Body_get_variables_template_variables_dialmaker_mail_template_variables_post */
export interface BodyGetVariablesTemplateVariablesDialmakerMailTemplateVariablesPost {
  /** Template Slug */
  template_slug: string;
  /** Campaign Id */
  campaign_id?: string | null;
}

/** Body_import_from_file_leadtaker_import_from__file_id__post */
export interface BodyImportFromFileLeadtakerImportFromFileIdPost {
  /**
   * Lead Mapping
   * @default {"phone_mapping":"phone","email_mapping":"email","fullname_mapping":"fullname","first_name_mapping":"first_name","last_name_mapping":"last_name","gender_mapping":"gender","date_of_birth_mapping":"date_of_birth","street_address_mapping":"street_address","post_code_mapping":"post_code","city_mapping":"city","country_mapping":"country","housing_type_mapping":"housing_type","current_bank_mapping":"current_bank","got_loans_mapping":"got_loans","loan_sum_mapping":"loan_sum","got_car_mapping":"got_car"}
   */
  lead_mapping?: Record<string, string>;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /**
   * "Model for given consents by customer.
   * It can have 3 states: True, False or None.
   * If None, it means that customer didn't provide consent yet.
   * If False, it means that customer explicitly refused to give consent or have withdrawn it.
   * If True, it means that customer gave consent.
   * @default {}
   */
  consents?: Consents;
}

/** Body_import_leads_dialmaker_campaign_import_post */
export interface BodyImportLeadsDialmakerCampaignImportPost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /**
   * Source Id
   * Source ID to import from, e.g. sheet or query id for campaign source
   */
  source_id?: string | null;
}

/** Body_join_campaign_dialmaker_campaigns_join_post */
export interface BodyJoinCampaignDialmakerCampaignsJoinPost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Color */
  color: number;
}

/** Body_leave_campaign_dialmaker_campaigns_leave_post */
export interface BodyLeaveCampaignDialmakerCampaignsLeavePost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
}

/** Body_lock_dialmaker_card_lock_post */
export interface BodyLockDialmakerCardLockPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /**
   * Force
   * @default false
   */
  force?: boolean;
}

/** Body_lock_from_case_view_dialmaker_card_lock_from_case_view_post */
export interface BodyLockFromCaseViewDialmakerCardLockFromCaseViewPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
}

/** Body_outcome_call_back_todomaker_outcome_call_back_post */
export interface BodyOutcomeCallBackTodomakerOutcomeCallBackPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** When */
  when?: string | null;
  /** Comment */
  comment?: string | null;
}

/** Body_outcome_discard_todomaker_outcome_discard_post */
export interface BodyOutcomeDiscardTodomakerOutcomeDiscardPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Outcome */
  outcome: string;
  /** Comment */
  comment?: string | null;
}

/** Body_outcome_failure_todomaker_outcome_failure_post */
export interface BodyOutcomeFailureTodomakerOutcomeFailurePost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Outcome */
  outcome: string;
  /** Comment */
  comment?: string | null;
}

/** Body_outcome_no_contact_todomaker_outcome_no_contact_post */
export interface BodyOutcomeNoContactTodomakerOutcomeNoContactPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Outcome */
  outcome: string;
  /** Comment */
  comment?: string | null;
}

/** Body_outcome_options_todomaker_outcomes_post */
export interface BodyOutcomeOptionsTodomakerOutcomesPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
}

/** Body_outcome_postpone_todomaker_outcome_postpone_post */
export interface BodyOutcomePostponeTodomakerOutcomePostponePost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Comment */
  comment?: string | null;
}

/** Body_outcome_success_todomaker_outcome_success_post */
export interface BodyOutcomeSuccessTodomakerOutcomeSuccessPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Comment */
  comment?: string | null;
}

/** Body_pause_campaign_dialmaker_campaigns_pause_post */
export interface BodyPauseCampaignDialmakerCampaignsPausePost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
}

/** Body_play_campaign_dialmaker_campaigns_play_post */
export interface BodyPlayCampaignDialmakerCampaignsPlayPost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
}

/** Body_prospects_online_subscription_leadtaker_prospects_online_subscription_post */
export interface BodyProspectsOnlineSubscriptionLeadtakerProspectsOnlineSubscriptionPost {
  /** Redirect Url */
  redirect_url: string;
  /** Email */
  email: string;
  country: Country | null;
  /** Name */
  name?: string | null;
}

/** Body_register_op_register_post */
export interface BodyRegisterOpRegisterPost {
  /** Ssn */
  ssn: string;
  /** Email */
  email: string;
  /** Phone */
  phone: string;
  /** Filling Id */
  filling_id?: string | null;
}

/** Body_release_todomaker_release_post */
export interface BodyReleaseTodomakerReleasePost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
}

/** Body_save_outcomes_dialmaker_misc_outcomes_post */
export interface BodySaveOutcomesDialmakerMiscOutcomesPost {
  outcomes: Outcomes;
}

/** Body_search_dialmaker_card_search_post */
export interface BodySearchDialmakerCardSearchPost {
  /** Search */
  search: string;
}

/** Body_set_campaign_paused_todomaker_campaigns_pause_post */
export interface BodySetCampaignPausedTodomakerCampaignsPausePost {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Paused */
  paused: boolean;
}

/** Body_set_campaign_sellers_todomaker_admin_campaigns__campaign_id__sellers_put */
export interface BodySetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersPut {
  /** Seller Ids */
  seller_ids: string[];
}

/** Body_simulate_sms_elk46_simulator_post */
export interface BodySimulateSmsElk46SimulatorPost {
  /** Message */
  message: string;
  /** From */
  from: string;
  /** To */
  to: string;
}

/** Body_slack_callback_slack_callback_post */
export interface BodySlackCallbackSlackCallbackPost {
  /** Payload */
  payload: any;
}

/** Body_stats_dialmaker_admin_outcomes_users_post */
export interface BodyStatsDialmakerAdminOutcomesUsersPost {
  /** User Ids */
  user_ids: string[];
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * End Date
   * @format date-time
   */
  end_date: string;
}

/** Body_store_events_form_analytics_store_events_post */
export interface BodyStoreEventsFormAnalyticsStoreEventsPost {
  /** Event List */
  event_list: OnlineFormsEvent[];
}

/** Body_store_form_form_abandoned__post */
export interface BodyStoreFormFormAbandonedPost {
  form: OnlineFormsAbandoned;
}

/** Body_submission_jotform_webhook__form_id__post */
export interface BodySubmissionJotformWebhookFormIdPost {
  /**
   * Submissionid
   * @default ""
   */
  submissionID?: string;
}

/** Body_update_dialmaker_card_update_post */
export interface BodyUpdateDialmakerCardUpdatePost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  data: UpdateLeadData;
}

/** Body_update_utm_tags_preset_url_tracker_utm_tags_preset__preset_name__put */
export interface BodyUpdateUtmTagsPresetUrlTrackerUtmTagsPresetPresetNamePut {
  /** Utm Source */
  utm_source: string;
  /** Utm Medium */
  utm_medium: string;
  /** Utm Campaign */
  utm_campaign: string;
}

/** Body_upload_attachment_dialmaker_campaign_image_upload_post */
export interface BodyUploadAttachmentDialmakerCampaignImageUploadPost {
  /** File */
  file: File | Blob;
}

/** Body_upload_attachment_email_customers_attachments_upload_post */
export interface BodyUploadAttachmentEmailCustomersAttachmentsUploadPost {
  /** File */
  file: File | Blob;
}

/** Body_upload_attachment_message_attachments_upload_post */
export interface BodyUploadAttachmentMessageAttachmentsUploadPost {
  /** File */
  file: File | Blob;
  /** File Name */
  file_name: string;
}

/** Body_upload_case_document_case_documents__application_id__post */
export interface BodyUploadCaseDocumentCaseDocumentsApplicationIdPost {
  /** File */
  file: File | Blob;
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /** @default "OTHER" */
  document_type?: MonoDocumentType;
}

/** Body_upload_case_document_for_bank_bank_v2_application__application_id__documents_post */
export interface BodyUploadCaseDocumentForBankBankV2ApplicationApplicationIdDocumentsPost {
  /** File */
  file: File | Blob;
  /** @default "OTHER" */
  document_type?: MonoDocumentType;
}

/** Body_upload_dialmaker_sheet__campaign_id__upload_with_preview_post */
export interface BodyUploadDialmakerSheetCampaignIdUploadWithPreviewPost {
  /** File */
  file: File | Blob;
}

/** Body_upload_file_api_file_storage_upload_post */
export interface BodyUploadFileApiFileStorageUploadPost {
  /**
   * Key
   * Storage path, e.g. customers/abc/doc.pdf
   */
  key: string;
  /** File */
  file: File | Blob;
}

/** Body_upload_leadtaker_upload_csv_post */
export interface BodyUploadLeadtakerUploadCsvPost {
  /** File */
  file: File | Blob;
}

/** Body_upload_my_case_document_my_pages_case_documents__application_id__post */
export interface BodyUploadMyCaseDocumentMyPagesCaseDocumentsApplicationIdPost {
  /** File */
  file: File | Blob;
  /** @default "OTHER" */
  document_type?: MonoDocumentType;
}

/** Body_view_dialmaker_card_view_post */
export interface BodyViewDialmakerCardViewPost {
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
}

/** BookableSlot */
export interface BookableSlot {
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * End Date
   * @format date-time
   */
  end_date: string;
  /**
   * Available Slots
   * @default 0
   */
  available_slots?: number | null;
}

/** BookableSlotV2 */
export interface BookableSlotV2 {
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * End Date
   * @format date-time
   */
  end_date: string;
  /** Available Slots */
  available_slots?: number | null;
  /** Handler Ids */
  handler_ids?: string[] | null;
}

/** BookedMeetingRow */
export interface BookedMeetingRow {
  /** Meeting Id */
  meeting_id: string;
  /** Application Id */
  application_id: string;
  /** Customer Id */
  customer_id: string;
  /** Customer Name */
  customer_name?: string | null;
  /**
   * Booked At
   * @format date-time
   */
  booked_at: string;
  /** Booked By */
  booked_by?: string | null;
  /** Booked By Department */
  booked_by_department?: string | null;
  /** First Meeting */
  first_meeting: boolean;
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Status */
  status: "active" | "cancelled" | "no_answer" | "done";
  /** Rescheduled */
  rescheduled: boolean;
  /**
   * Offers Count
   * @default 0
   */
  offers_count?: number;
  /** Best Rate */
  best_rate?: number | null;
  /** Previous Application Id */
  previous_application_id?: string | null;
  /** Previous Best Rate */
  previous_best_rate?: number | null;
  /** Gr Avg Rate */
  gr_avg_rate?: number | null;
  /**
   * Gr State
   * @default "no_data"
   */
  gr_state?: "ok" | "no_data" | "no_debt" | "no_rate";
  /** Gr Fetched At */
  gr_fetched_at?: string | null;
  /** First Call At */
  first_call_at?: string | null;
  /** First Call By */
  first_call_by?: string | null;
  /** First Call Answered */
  first_call_answered?: boolean | null;
  /**
   * Call Attempts
   * @default 0
   */
  call_attempts?: number;
  /** Call Status */
  call_status: "on_time" | "late" | "pending" | "not_called";
  kh_comment?: KhComment | null;
}

/** BookedMeetings */
export interface BookedMeetings {
  /**
   * Day
   * @format date
   */
  day: string;
  /** Rows */
  rows: BookedMeetingRow[];
}

/** BookingPayload */
export interface BookingPayload {
  /**
   * Timeid
   * @format date-time
   */
  timeId: string;
  /** Phonenumber */
  phoneNumber: string;
  /**
   * Email
   * @format email
   */
  email: string;
}

/** BooliPropertySearchResult */
export interface BooliPropertySearchResult {
  /** Id */
  id: string;
  /** Streetguid */
  streetGuid: string;
  /** Streetname */
  streetName: string;
  /** Streetnumber */
  streetNumber: string;
  /** Postaddress */
  postAddress?: string | null;
  /** Postcode */
  postCode: string;
  /** Longitude */
  longitude: number;
  /** Latitude */
  latitude: number;
  /**
   * Housingcoopid
   * @default ""
   */
  housingCoopId?: string;
  /** Hasresidences */
  hasResidences: boolean;
}

/** BooliSearchPayload */
export interface BooliSearchPayload {
  country: Country;
  /** Street Name */
  street_name: string;
  /** Post Code */
  post_code: string;
  /** Street Number */
  street_number?: string | null;
}

/** BooliValuationPayload */
export interface BooliValuationPayload {
  /** Property Id */
  property_id: string;
  /** Living Area */
  living_area: number;
}

/** Break */
export interface BreakInput {
  /**
   * Start Time
   * @format time
   */
  start_time: string;
  /**
   * End Time
   * @format time
   */
  end_time: string;
}

/** Break */
export interface BreakOutput {
  /** Start Time */
  start_time: string;
  /** End Time */
  end_time: string;
}

/** Brokerage */
export interface Brokerage {
  /** Agency */
  agency?: string | null;
  /** Broker */
  broker?: string | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
}

/** Budget */
export interface Budget {
  type_event: GoalType;
  /** User Id */
  user_id?: string[] | null;
  country: Country;
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Applications
   * Budget of applications created
   */
  applications: number;
  /**
   * Average Loan Amount
   * Budget of average loan amount
   */
  average_loan_amount: number;
  /**
   * Disbursed Loans Count
   * Budget of number of disbursed loans
   */
  disbursed_loans_count: number;
  /**
   * Disbursed Loans Amount
   * Budget of the amount of disbursed loans in countries currency
   */
  disbursed_loans_amount: number;
  /**
   * Disbursement Rate
   * Budget of disbursement rate
   */
  disbursement_rate: number;
}

/** BudgetPayload */
export interface BudgetPayload {
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /** User Ids */
  user_ids?: string[] | null;
  /**
   * Applications
   * Budget of applications created
   */
  applications: number;
  /**
   * Average Loan Amount
   * Budget of average loan amount
   */
  average_loan_amount: number;
  /**
   * Disbursed Loans Count
   * Budget of number of disbursed loans
   */
  disbursed_loans_count: number;
  /**
   * Disbursed Loans Amount
   * Budget of the amount of disbursed loans in countries currency
   */
  disbursed_loans_amount: number;
  /**
   * Disbursement Rate
   * Budget of disbursement rate
   */
  disbursement_rate: number;
}

/** BuyingInfo */
export interface BuyingInfo {
  /** Property Price */
  property_price?: number | null;
  /** Buying Date */
  buying_date?: string | null;
  /** New Production */
  new_production?: boolean | null;
  /** First Owner */
  first_owner?: boolean | null;
  /** Down Payment */
  down_payment?: number | null;
}

/**
 * CCApplicationRequest
 * Request model for the /cc-application endpoint, extending the CC payload with online form metadata.
 */
export interface CCApplicationRequest {
  country: Country;
  data: OptionalCreditCardApplicationDataCreate;
  /** Model used only for mapping jotform data to Applicant model, allowing some more fields to be optional */
  applicant: OptionalCreateApplicantNO;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
}

/** Cadastre */
export interface Cadastre {
  /** Bnr */
  BNr?: number | null;
  /** Fnr */
  FNr?: number | null;
  /** Gnr */
  GNr?: number | null;
  /** Knr */
  KNr?: number | null;
  /** Snr */
  SNr?: number | null;
}

/**
 * CalendarMeeting
 * One active meeting, v1 or v2, in one shape.
 *
 * A v1 booking made on a lead carries the lead id and no application; ``booked`` and
 * ``quick_create`` are unknown (null) for every v1 meeting. ``quick_create`` is v2's
 * ``first_meeting``: created by quick create, not "the case's first meeting".
 */
export interface CalendarMeeting {
  /** Meeting Id */
  meeting_id: string;
  /** Handler Id */
  handler_id: string;
  /**
   * Start
   * @format date-time
   */
  start: string;
  /**
   * End
   * @format date-time
   */
  end: string;
  /** Version */
  version: 1 | 2;
  /** Application Ids */
  application_ids: string[];
  /** Lead Id */
  lead_id: string | null;
  /** Customer Id */
  customer_id: string | null;
  /** Booked */
  booked: boolean | null;
  /** Quick Create */
  quick_create: boolean | null;
  /** Product */
  product: string | null;
  /** Case Owner Handler Id */
  case_owner_handler_id: string | null;
  /** Is Owner */
  is_owner: boolean | null;
  /** Score */
  score: number | null;
}

/** CallOutcomeCallBack */
export interface CallOutcomeCallBack {
  /** User Id */
  user_id?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Type
   * @default "CALL_BACK"
   */
  type?: "CALL_BACK";
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Comment */
  comment?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** When */
  when?: string | null;
  /**
   * Personal Callback
   * @default false
   */
  personal_callback?: boolean;
  /**
   * Postponed
   * @default false
   */
  postponed?: boolean;
}

/** CallOutcomeDiscard */
export interface CallOutcomeDiscard {
  /** User Id */
  user_id?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Type
   * @default "DISCARD"
   */
  type?: "DISCARD";
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Comment */
  comment?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Outcome */
  outcome: string;
}

/** CallOutcomeFailure */
export interface CallOutcomeFailure {
  /** User Id */
  user_id?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Type
   * @default "FAILURE"
   */
  type?: "FAILURE";
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Comment */
  comment?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Outcome */
  outcome: string;
}

/** CallOutcomeNoContact */
export interface CallOutcomeNoContact {
  /** User Id */
  user_id?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Type
   * @default "NO_CONTACT"
   */
  type?: "NO_CONTACT";
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Comment */
  comment?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Outcome */
  outcome: string;
  /** Closed */
  closed?: boolean | null;
}

/** CallOutcomeSuccess */
export interface CallOutcomeSuccess {
  /** User Id */
  user_id?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Type
   * @default "SUCCESS"
   */
  type?: "SUCCESS";
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Comment */
  comment?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
}

/** CallingOrder */
export interface CallingOrder {
  /**
   * H00
   * @default 0
   */
  h00?: number;
  /**
   * H01
   * @default 0
   */
  h01?: number;
  /**
   * H02
   * @default 0
   */
  h02?: number;
  /**
   * H03
   * @default 0
   */
  h03?: number;
  /**
   * H04
   * @default 0
   */
  h04?: number;
  /**
   * H05
   * @default 0
   */
  h05?: number;
  /**
   * H06
   * @default 0
   */
  h06?: number;
  /**
   * H07
   * @default 0
   */
  h07?: number;
  /**
   * H08
   * @default 0
   */
  h08?: number;
  /**
   * H09
   * @default 0
   */
  h09?: number;
  /**
   * H10
   * @default 0
   */
  h10?: number;
  /**
   * H11
   * @default 0
   */
  h11?: number;
  /**
   * H12
   * @default 0
   */
  h12?: number;
  /**
   * H13
   * @default 0
   */
  h13?: number;
  /**
   * H14
   * @default 0
   */
  h14?: number;
  /**
   * H15
   * @default 0
   */
  h15?: number;
  /**
   * H16
   * @default 0
   */
  h16?: number;
  /**
   * H17
   * @default 0
   */
  h17?: number;
  /**
   * H18
   * @default 0
   */
  h18?: number;
  /**
   * H19
   * @default 0
   */
  h19?: number;
  /**
   * H20
   * @default 0
   */
  h20?: number;
  /**
   * H21
   * @default 0
   */
  h21?: number;
  /**
   * H22
   * @default 0
   */
  h22?: number;
  /**
   * H23
   * @default 0
   */
  h23?: number;
  /** Timezone */
  timezone: string;
}

/** CallsResponse */
export interface CallsResponse {
  /**
   * Event
   * @default "calls"
   */
  event?: "calls";
  /** Data */
  data: SSECall[];
}

/** CampaignData */
export interface CampaignData {
  url_target: Product;
  /** Valid To */
  valid_to?: string | null;
  /** Url */
  url?: string | null;
}

/** CampaignExport */
export interface CampaignExport {
  /**
   * Export Id
   * @format uuid
   */
  export_id: string;
  /**
   * Extraction Id
   * @format uuid
   */
  extraction_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/** CampaignExtraction */
export interface CampaignExtraction {
  /**
   * Extraction Id
   * @format uuid
   */
  extraction_id: string;
  /** Extracted By */
  extracted_by?: string | null;
  /**
   * Leads Count
   * @min 0
   */
  leads_count: number;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/** CampaignExtractionsStats */
export interface CampaignExtractionsStats {
  /** Already Extracted */
  already_extracted: number;
  /** Without Outcome */
  without_outcome: number;
  /** Exported Without Outcome */
  exported_without_outcome: number;
  /** Available To Call */
  available_to_call: number;
  /** Left To Extract */
  left_to_extract?: number | null;
}

/** CampaignMailOverview */
export interface CampaignMailOverview {
  /** Currently In Campaign */
  currently_in_campaign: number;
}

/** CampaignMailSchedule */
export interface CampaignMailSchedule {
  /** Batches */
  batches: MailScheduleBatch[];
  /**
   * Schedule Created At
   * @format date-time
   */
  schedule_created_at: string;
}

/** CampaignMailStats */
export interface CampaignMailStats {
  /**
   * Total Opens
   * @default 0
   */
  total_opens?: number;
  /**
   * Total Clicks
   * @default 0
   */
  total_clicks?: number;
  /**
   * Unique Opens
   * @default 0
   */
  unique_opens?: number;
  /**
   * Unique Clicks
   * @default 0
   */
  unique_clicks?: number;
  /**
   * Sent
   * @default 0
   */
  sent?: number;
  /**
   * Hard Bounce
   * @default 0
   */
  hard_bounce?: number;
  /**
   * Soft Bounce
   * @default 0
   */
  soft_bounce?: number;
  /**
   * Spam
   * @default 0
   */
  spam?: number;
  /**
   * Unsubscribed
   * @default 0
   */
  unsubscribed?: number;
  /**
   * Redirects
   * @default 0
   */
  redirects?: number;
  /**
   * Unique Redirects
   * @default 0
   */
  unique_redirects?: number;
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Mailings */
  mailings: CampaignMailingStats[];
  /** Last Sent */
  last_sent?: string | null;
}

/** CampaignMailingStats */
export interface CampaignMailingStats {
  /**
   * Total Opens
   * @default 0
   */
  total_opens?: number;
  /**
   * Total Clicks
   * @default 0
   */
  total_clicks?: number;
  /**
   * Unique Opens
   * @default 0
   */
  unique_opens?: number;
  /**
   * Unique Clicks
   * @default 0
   */
  unique_clicks?: number;
  /**
   * Sent
   * @default 0
   */
  sent?: number;
  /**
   * Hard Bounce
   * @default 0
   */
  hard_bounce?: number;
  /**
   * Soft Bounce
   * @default 0
   */
  soft_bounce?: number;
  /**
   * Spam
   * @default 0
   */
  spam?: number;
  /**
   * Unsubscribed
   * @default 0
   */
  unsubscribed?: number;
  /**
   * Redirects
   * @default 0
   */
  redirects?: number;
  /**
   * Unique Redirects
   * @default 0
   */
  unique_redirects?: number;
  /**
   * Mailing Id
   * @format uuid
   */
  mailing_id: string;
  /** Batches */
  batches: MailBatchStats[];
  /**
   * Last Sent
   * @format date-time
   */
  last_sent: string;
}

/** CampaignOngoingExtraction */
export interface CampaignOngoingExtraction {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /**
   * Job Id
   * @format uuid
   */
  job_id: string;
  /** Job Status */
  job_status?: string | null;
  /**
   * Extraction Id
   * @format uuid
   */
  extraction_id: string;
  /** Leads Count */
  leads_count: number;
  /** User Id */
  user_id: string;
  /**
   * Unextraction
   * @default false
   */
  unextraction?: boolean;
  /** Scheduled At */
  scheduled_at?: string | null;
}

/**
 * CampaignSellers
 * The sellers an admin has assigned to a Dial Maker campaign for todomaker.
 */
export interface CampaignSellers {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Seller Ids */
  seller_ids: string[];
}

/** CampaignSmsSchedule */
export interface CampaignSmsSchedule {
  /** Batches */
  batches: SmsScheduleBatch[];
  /**
   * Schedule Created At
   * @format date-time
   */
  schedule_created_at: string;
}

/** CampaignSmsSendStats */
export interface CampaignSmsSendStats {
  /**
   * Sent
   * @default 0
   */
  sent?: number;
  /**
   * Clicks
   * @default 0
   */
  clicks?: number;
  /**
   * Unique Clicks
   * @default 0
   */
  unique_clicks?: number;
  /**
   * Unsubscribed
   * @default 0
   */
  unsubscribed?: number;
  /**
   * Redirects
   * @default 0
   */
  redirects?: number;
  /**
   * Unique Redirects
   * @default 0
   */
  unique_redirects?: number;
  /**
   * Sms Batch Id
   * @format uuid
   */
  sms_batch_id: string;
  /** Batches */
  batches: SmsBatchStats[];
  /**
   * Last Sent
   * @format date-time
   */
  last_sent: string;
}

/** CampaignSmsStats */
export interface CampaignSmsStats {
  /**
   * Sent
   * @default 0
   */
  sent?: number;
  /**
   * Clicks
   * @default 0
   */
  clicks?: number;
  /**
   * Unique Clicks
   * @default 0
   */
  unique_clicks?: number;
  /**
   * Unsubscribed
   * @default 0
   */
  unsubscribed?: number;
  /**
   * Redirects
   * @default 0
   */
  redirects?: number;
  /**
   * Unique Redirects
   * @default 0
   */
  unique_redirects?: number;
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Sms Sends */
  sms_sends: CampaignSmsSendStats[];
  /** Last Sent */
  last_sent?: string | null;
}

/** CampaignStats */
export interface CampaignStats {
  /** Active */
  active: number;
}

/** CanSignUp */
export interface CanSignUp {
  /** Id */
  id?: string | null;
  /** Active */
  active: boolean;
  /** Cansignup */
  canSignup: boolean;
  /**
   * Pni
   * Not stored as pni in db but as a hash
   */
  pni?: string | null;
  /** Registeredcustomer */
  registeredCustomer: boolean;
  /** Timestamp */
  timestamp?: string | null;
}

/** CanSignupResponse */
export interface CanSignupResponse {
  /** Blanco */
  blanco: boolean;
  /** Mortgage */
  mortgage: boolean;
  /** Credit Card */
  credit_card: boolean;
  /** Insurance */
  insurance: InsuranceTerms[];
}

/** CancelOfferByOfferIdPayload */
export interface CancelOfferByOfferIdPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
}

/** CancelOfferPayload */
export interface CancelOfferPayload {
  reason: CancelReason;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Bank Id */
  bank_id: number;
  /**
   * Synchronous
   * @default true
   */
  synchronous?: boolean;
}

/** Car */
export interface Car {
  /** Monthlycost */
  monthlyCost?: number | null;
}

/** CarCost */
export interface CarCost {
  /**
   * Actual Cost
   * @default false
   */
  actual_cost?: boolean;
  /** Fixed Cost */
  fixed_cost: number;
}

/**
 * CarEvalResponse
 * Car Evaluation (Bilverdi) — the customer's owned vehicles + valuation/stats,
 * plus the fleet aggregate (combined value + range) for the hero. Mirrors the
 * shared movables wire model, with the authenticated customer attached.
 */
export interface CarEvalResponse {
  /**
   * Status
   * @default "ready"
   */
  status?: "ready" | "processing" | "failed";
  /** Combined fleet value + range for the household hero */
  fleet?: FleetSummary;
  /**
   * Cars
   * The customer's owned vehicles with valuation and technical stats
   */
  cars?: Vehicle[];
  customer: ApplicantNO;
}

/** Cars */
export interface CarsInput {
  /** Owned */
  owned?: number | null;
  /** Leased */
  leased?: Car[] | null;
}

/**
 * CaseChatAnswerEvent
 * `event: answer`, once, as the last event of a stream that went well.
 */
export interface CaseChatAnswerEvent {
  /**
   * Type
   * @default "answer"
   */
  type?: "answer";
  /** Turn Id */
  turn_id: string;
  /** Answer */
  answer: string;
  outcome: CaseChatAnswerOutcome;
  /** Sources */
  sources: CaseChatSource[];
}

/**
 * CaseChatErrorEvent
 * `event: error`, as the last event of a stream that failed: the HTTP status it stands for and a sentence the
 * agent can read. 429 busy or limit, 502 model error or no usable answer, 503 a store, Redis or the case read down,
 * 504 out of time.
 */
export interface CaseChatErrorEvent {
  /**
   * Type
   * @default "error"
   */
  type?: "error";
  /** Status */
  status: number;
  /** Detail */
  detail: string;
}

/** CaseChatFeedbackRequest */
export interface CaseChatFeedbackRequest {
  /** Rating */
  rating: "up" | "down";
}

/**
 * CaseChatProgressEvent
 * `event: progress`, as each tool starts.
 */
export interface CaseChatProgressEvent {
  /**
   * Type
   * @default "progress"
   */
  type?: "progress";
  /** Tool */
  tool: string;
}

/** CaseChatRequest */
export interface CaseChatRequest {
  /**
   * Message
   * @minLength 1
   * @maxLength 1000
   */
  message: string;
  /**
   * Turns
   * @maxItems 6
   */
  turns?: CaseChatTurn[];
}

/**
 * CaseChatSource
 * One read the answer rests on.
 */
export interface CaseChatSource {
  /** Tool */
  tool: string;
  /** Application Id */
  application_id?: string | null;
  /** Fetched At */
  fetched_at?: string | null;
  status: CaseChatSourceStatus;
}

/**
 * CaseChatTurn
 * An earlier question and answer of the same case chat, sent back by the client.
 */
export interface CaseChatTurn {
  /**
   * Question
   * @maxLength 1000
   */
  question: string;
  /**
   * Answer
   * @maxLength 6000
   */
  answer: string;
}

/** CaseCollectionItem */
export interface CaseCollectionItem {
  /** Uc Type Template Descition */
  uc_type_template_descition?: string | null;
  /** Year */
  year?: string | null;
}

/**
 * CaseDialmakerLead
 * A PENDING lead in an ordinary Dial Maker campaign, for the case view.
 *
 * Readable by every department the case view is open to, so it carries no contact data and no
 * call history: only "queued in this campaign, held by them since then, next attempt then".
 */
export interface CaseDialmakerLead {
  /** Lead Id */
  lead_id: string;
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Campaign Name */
  campaign_name: string;
  /** Held By */
  held_by?: string | null;
  /** Held Since */
  held_since?: string | null;
  /**
   * Is Mine
   * @default false
   */
  is_mine?: boolean;
  /** Call At */
  call_at?: string | null;
  /**
   * Is Personal Callback
   * @default false
   */
  is_personal_callback?: boolean;
  /**
   * Can Lock
   * @default false
   */
  can_lock?: boolean;
}

/**
 * CaseDocument
 * One file of a customer, a row in `case_documents`. The agent sees it on every MONO case of the customer; a bank
 * sees it on the application an agent shared it on. The bytes are in S3 at `storage_key`.
 */
export interface CaseDocument {
  /** Document Id */
  document_id: string;
  /**
   * Application label
   * The origin application: where the file was uploaded or saved
   */
  application_id: string;
  /**
   * Customer Id
   * The customer the file belongs to, an applicant or co-applicant of the origin application
   */
  customer_id: string;
  /** @default "OTHER" */
  document_type?: MonoDocumentType;
  /**
   * Filename
   * NFC-normalised; its extension matches content_type
   */
  filename: string;
  /**
   * Content Type
   * The canonical type of the extension, never the client one
   */
  content_type: string;
  /** File Size */
  file_size: number;
  /**
   * Storage Key
   * S3 key of the file
   */
  storage_key: string;
  source: CaseDocumentSource;
  /** Email Id */
  email_id?: string | null;
  /** Attachment Id */
  attachment_id?: string | null;
  /**
   * Uploaded By
   * Auth0 user id, 'bank_user:<id>' or 'customer:<customer_id>'
   */
  uploaded_by: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Shares
   * One per bank and application
   */
  shares?: DocumentShare[];
  /** Deleted At */
  deleted_at?: string | null;
  /** Deleted By */
  deleted_by?: string | null;
}

/**
 * CaseDocumentsResponse
 * The documents of the open MONO case changed. A ping with no data: the client re-reads the list by REST
 * (`GET /case-documents/{application_id}`), the only source of the documents.
 */
export interface CaseDocumentsResponse {
  /**
   * Event
   * @default "case_documents"
   */
  event?: "case_documents";
  /** Data */
  data?: null;
}

/**
 * CaseOwner
 * One customer's case and its owner. Exactly one record per case is ``is_active``.
 */
export interface CaseOwner {
  /** Owner Id */
  owner_id: string;
  /** Case Key */
  case_key: string;
  /** Customer Id */
  customer_id?: string | null;
  country: Country;
  /** Application Ids */
  application_ids?: string[];
  /** Owner Handler Id */
  owner_handler_id: string;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /**
   * How this record came to be. ``planner`` and ``button`` are the only two that open a
   * case by a distribution decision, which is what the rotation key counts.
   */
  source: OwnerSource;
  /** Actor Id */
  actor_id?: string | null;
  /**
   * Decided At
   * @format date-time
   */
  decided_at?: string;
  /** Founding Week */
  founding_week: string;
  /** Founding Day */
  founding_day: string;
  /** Value Lines */
  value_lines?: ValueLine[];
  /** Rotation Days */
  rotation_days?: string[];
  /**
   * V T Total
   * @default 0
   */
  v_t_total?: number;
  /**
   * Booleans rather than a list, because the accumulators filter on
   * ``owner_flags.out_of_pool`` and an index cannot be built on set membership.
   */
  owner_flags?: OwnerFlags;
  /**
   * Revision
   * @default 0
   */
  revision?: number;
  /** Supersedes */
  supersedes?: string[];
  /** Superseded By */
  superseded_by?: string | null;
  takeover_reason?: TakeoverReason | null;
  /**
   * Has Mortgage Twin
   * @default false
   */
  has_mortgage_twin?: boolean;
}

/** Cases */
export interface Cases {
  /** Date */
  date?: string | null;
  /**
   * Numberofpubliccases
   * Number of public cases at The Swedish Enforcement Agency. Known as 'Allmänna mål' in swedish
   */
  numberOfPublicCases?: number | null;
  /**
   * Numberofprivatecases
   * Number of private cases at The Swedish Enforcement Agency. Known as 'Enskilda mål' in swedish
   */
  numberOfPrivateCases?: number | null;
  /**
   * Numberofcases
   * Total number of cases. (Public + Private)
   */
  numberOfCases?: number | null;
  /**
   * Sumpubliccases
   * The aggregated sum for public cases in sek
   */
  sumPublicCases?: number | null;
  /**
   * Sumprivatecases
   * The aggregated sum for private cases in sek
   */
  sumPrivateCases?: number | null;
  /**
   * Sumcases
   * The aggregated sum for all cases in sek
   */
  sumCases?: number | null;
  /**
   * Summarytext
   * A summary text explaining the current state of cases at The Swedish Enforcement Agency
   */
  summaryText?: string | null;
  /** History */
  history?: HistoricalCase[] | null;
}

/** Checklist */
export interface Checklist {
  status?: SubmissionStatus | null;
  form_validation?: ModelsOnlineLoanApplicationStatus | null;
  get_customers?: ModelsOnlineLoanApplicationStatus | null;
  has_recent_app_check?: ModelsOnlineLoanApplicationStatus | null;
  has_recent_app_email?: ModelsOnlineLoanApplicationStatus | null;
  has_recent_app_sms?: ModelsOnlineLoanApplicationStatus | null;
  created_application?: ModelsOnlineLoanApplicationStatus | null;
  not_using_test_pni?: ModelsOnlineLoanApplicationStatus | null;
  quick_application?: ModelsOnlineLoanApplicationStatus | null;
  parsed_application?: ModelsOnlineLoanApplicationStatus | null;
  gr_data_wait?: ModelsOnlineLoanApplicationStatus | null;
  sms_blanco_app_creation?: ModelsOnlineLoanApplicationStatus | null;
  converted_to_blanco_model?: ModelsOnlineLoanApplicationStatus | null;
  created_blanco_application?: ModelsOnlineLoanApplicationStatus | null;
}

/** ChildBenefit */
export interface ChildBenefit {
  /** Number Of Children */
  number_of_children: number;
  /** Benefit */
  benefit: number;
}

/** ClaimAmount */
export interface ClaimAmount {
  /** Value */
  Value?: number | null;
  /** Currency */
  Currency?: string | null;
}

/** CoApplicantCustomerLoginsResponse */
export interface CoApplicantCustomerLoginsResponse {
  /**
   * Event
   * @default "co_applicant_customer_logins"
   */
  event?: "co_applicant_customer_logins";
  data: CustomerLogins;
}

/** CoApplicantInsuranceListResponse */
export interface CoApplicantInsuranceListResponse {
  /**
   * Event
   * @default "co_applicant_insurance_list"
   */
  event?: "co_applicant_insurance_list";
  /** Data */
  data: Insurance[];
}

/** CoApplicantInsuranceRulesResponse */
export interface CoApplicantInsuranceRulesResponse {
  /**
   * Event
   * @default "co_applicant_insurance_rules"
   */
  event?: "co_applicant_insurance_rules";
  data: RulesResponse;
}

/** CoApplicantResponse */
export interface CoApplicantResponse {
  /**
   * Event
   * @default "co_applicant"
   */
  event?: "co_applicant";
  /** Data */
  data:
    | (
        | ({
            country: "NO";
          } & ApplicantNO)
        | ({
            country: "SE";
          } & ApplicantSE)
      )
    | null;
}

/** CommentPayload */
export interface CommentPayload {
  /**
   * Comment
   * @minLength 1
   * @maxLength 999
   */
  comment: string;
}

/** CommentResponse */
export interface CommentResponse {
  /**
   * Event
   * @default "comments"
   */
  event?: "comments";
  /** Data */
  data: InternalCommentSSE[];
}

/** CommonMeeting */
export interface CommonMeeting {
  /** Meeting Id */
  meeting_id: string;
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Handler Id */
  handler_id?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /** Customer Name */
  customer_name?: string | null;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  /** Application Ids */
  application_ids?: string[] | null;
  /** Handler Name */
  handler_name?: string | null;
}

/** CompanyInfo */
export interface CompanyInfo {
  /** Name */
  name: string;
  /** Response In Import Date */
  response_in_import_date?: string | null;
}

/** CompanyMortgageRates */
export interface CompanyMortgageRates {
  /** Companyname */
  companyName: string;
  /** Rates */
  rates: Record<string, number>;
}

/** ComplaintDetails */
export interface ComplaintDetails {
  /**
   * Sumcomplaint
   * The sum of the complaint in sek
   */
  sumComplaint?: number | null;
  /**
   * Creditor
   * The organisation or person to whom the money is owed.
   */
  creditor?: string | null;
  /** Used in Norway for voluntary/involuntary, but can be extended */
  complaintKind?: ComplaintKind | null;
  complaintType?: ComplaintType | null;
  /**
   * Complaintdate
   * The date this complaint was filed.
   */
  complaintDate?: string | null;
  /**
   * Complainttextline1
   * Field containing arbitrary information about the complaint
   */
  complaintTextLine1?: string | null;
  /**
   * Complainttextline2
   * Field containing arbitrary information about the complaint. Contains information if it doesn't fit in the previous field.
   */
  complaintTextLine2?: string | null;
  /**
   * Complainttextline3
   * Field containing arbitrary information about the complaint. Contains information if it doesn't fit in the previous field.
   */
  complaintTextLine3?: string | null;
  /**
   * Complainttextline4
   * Field containing arbitrary information about the complaint. Contains information if it doesn't fit in the previous field.
   */
  complaintTextLine4?: string | null;
  /**
   * Complainttextline5
   * Field containing arbitrary information about the complaint. Contains information if it doesn't fit in the previous field.
   */
  complaintTextLine5?: string | null;
}

/** Complaints */
export interface Complaints {
  /**
   * Numberofcomplaints
   * The total number of complaints
   */
  numberOfComplaints?: number | null;
  /**
   * Sumcomplaints
   * The aggregated sum of all complaints in sek
   */
  sumComplaints?: number | null;
  /** Complaintdetails */
  complaintDetails?: ComplaintDetails[] | null;
}

/**
 * ComplianceCallAgent
 * Advisor identity written onto the zenscription by the zenscriber pipeline.
 * Tolerant — the field is absent until the zenscriber-side call-agent wiring ships.
 */
export interface ComplianceCallAgent {
  /** User Id */
  user_id?: string | null;
  /** Full Name */
  full_name?: string | null;
  /** Departments */
  departments?: string[];
  /** Country */
  country?: string | null;
}

/** ComplianceCheck */
export interface ComplianceCheck {
  /** Credit Check Permission */
  credit_check_permission?: boolean | null;
  /** Insurance Inquiry */
  insurance_inquiry?: boolean | null;
  /** Mortgage Inquiry */
  mortgage_inquiry?: boolean | null;
  /** Purpose Stated */
  purpose_stated?: boolean | null;
  /** Promises Made */
  promises_made?: boolean | null;
  /** Next Steps Explained */
  next_steps_explained?: boolean | null;
  /** Customer Preferences */
  customer_preferences?: boolean | null;
  /** Recording Disclosure */
  recording_disclosure?: boolean | null;
}

/** ComplianceData */
export interface ComplianceData {
  /** Status */
  status?: string | null;
  /** Role Used */
  role_used?: string | null;
  /** Checked At */
  checked_at?: string | null;
  /** Rules Version */
  rules_version?: string | number | null;
  /** Flags */
  flags?: ComplianceFlag[];
  /** Evaluated Rules */
  evaluated_rules?: string[];
}

/** ComplianceFlag */
export interface ComplianceFlag {
  /** Rule Id */
  rule_id: string;
  /** Group */
  group?: string | null;
  /** Category */
  category?: string | null;
  /** Severity */
  severity?: string | null;
  /** Archetype */
  archetype?: string | null;
  /**
   * Evidence Quote
   * @default ""
   */
  evidence_quote?: string;
  /** Speaker */
  speaker?: string | null;
  /** Grounded */
  grounded?: boolean | null;
  /**
   * Role Provisional
   * @default false
   */
  role_provisional?: boolean;
  /**
   * Speaker Unresolved
   * @default false
   */
  speaker_unresolved?: boolean;
  /** Votes Confirm */
  votes_confirm?: number | null;
  /** Votes Total */
  votes_total?: number | null;
  /** Confidence */
  confidence?: number | null;
  /** Stage */
  stage?: string | null;
  /**
   * Reasoning
   * @default ""
   */
  reasoning?: string;
  /** Missing Elements */
  missing_elements?: string[];
  /** Missing Element Texts */
  missing_element_texts?: string[];
}

/**
 * ComplianceManualFlag
 * A violation the AI missed, reported by the human reviewer. Stored in its own
 * collection (`zenscriptions_compliance_manual_flags`) for the same reason reviews are —
 * the batch `$set`s the whole `compliance` subdocument on re-run and must never wipe
 * human input. Stamped with the batch version it corrects (`rules_version`/`checked_at`),
 * so manual flags vs AI flags per version measure the detector's RECALL — the half of
 * the picture dismissals (precision) cannot see.
 */
export interface ComplianceManualFlag {
  /** Recorded Call Key */
  recorded_call_key: string;
  /** Rule Id */
  rule_id: string;
  /**
   * Evidence Quote
   * @default ""
   */
  evidence_quote?: string;
  /**
   * Comment
   * @default ""
   */
  comment?: string;
  /** Reported By */
  reported_by: string;
  /**
   * Reported At
   * @format date-time
   */
  reported_at: string;
  /** Checked At */
  checked_at?: string | null;
  /** Rules Version */
  rules_version?: string | number | null;
}

/** ComplianceManualFlagPayload */
export interface ComplianceManualFlagPayload {
  /**
   * Checked At
   * @format date-time
   */
  checked_at: string;
  /**
   * Rule Id
   * @minLength 1
   * @maxLength 200
   */
  rule_id: string;
  /**
   * Evidence Quote
   * @maxLength 4000
   * @default ""
   */
  evidence_quote?: string;
  /**
   * Comment
   * @maxLength 2000
   * @default ""
   */
  comment?: string;
}

/** ComplianceQueuePage */
export interface ComplianceQueuePage {
  /** Items */
  items: ZenscriptionWithCompliance[];
  /** Total */
  total: number;
  /** Open Total */
  open_total: number;
}

/**
 * ComplianceReviewDecision
 * One human decision about one flag. Stored append-only in `zenscriptions_compliance_reviews`
 * (a disciplinary record keeps every decision); a call shows the latest one per flag.
 */
export interface ComplianceReviewDecision {
  /** Recorded Call Key */
  recorded_call_key: string;
  /** Rule Id */
  rule_id: string;
  /**
   * Evidence Quote
   * @default ""
   */
  evidence_quote?: string;
  /** Flag Key */
  flag_key: string;
  /** Verdict */
  verdict: "confirmed" | "dismissed";
  /** Dismiss Reason */
  dismiss_reason?:
    | "customer_said_it"
    | "wrong_context"
    | "wrong_rule"
    | "transcription_error"
    | "other"
    | null;
  /** Reviewed By */
  reviewed_by: string;
  /**
   * Reviewed At
   * @format date-time
   */
  reviewed_at: string;
  /**
   * Comment
   * @default ""
   */
  comment?: string;
  /** Checked At */
  checked_at?: string | null;
  /**
   * Stale
   * @default false
   */
  stale?: boolean;
}

/** ComplianceReviewPayload */
export interface ComplianceReviewPayload {
  /**
   * Checked At
   * @format date-time
   */
  checked_at: string;
  /** Rule Id */
  rule_id: string;
  /**
   * Evidence Quote
   * @default ""
   */
  evidence_quote?: string;
  /** Verdict */
  verdict: "confirmed" | "dismissed";
  /** Dismiss Reason */
  dismiss_reason?:
    | "customer_said_it"
    | "wrong_context"
    | "wrong_rule"
    | "transcription_error"
    | "other"
    | null;
  /**
   * Comment
   * @maxLength 2000
   * @default ""
   */
  comment?: string;
}

/** Condominium */
export interface CondominiumInput {
  organizationNumber?: NonEmptyString | null;
  /** Organizationname */
  organizationName?: string | null;
  apartmentNumber?: NonEmptyString | null;
  /** Floor */
  floor?: number | null;
  /** Elevator */
  elevator?: boolean | null;
  balconyType?: BalconyType | null;
}

/** Config */
export interface Config {
  /** Opening Hours */
  opening_hours: ValueListItem[];
  customer_support_phone: ValueListItem;
  /**
   * Customer Support Email
   * @format email
   */
  customer_support_email: string;
  /**
   * Blanco Form Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  blanco_form_url: string;
  /**
   * Credit Card Form Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  credit_card_form_url: string;
  /**
   * Mortgage Form Url
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  mortgage_form_url: string;
  /** Office Address */
  office_address: string;
  customer_support_sms: ValueListItem;
}

/**
 * Consents
 * "Model for given consents by customer.
 * It can have 3 states: True, False or None.
 * If None, it means that customer didn't provide consent yet.
 * If False, it means that customer explicitly refused to give consent or have withdrawn it.
 * If True, it means that customer gave consent.
 */
export interface Consents {
  /** Email Marketing */
  email_marketing?: boolean | null;
  /** Sms Marketing */
  sms_marketing?: boolean | null;
  /** Call Marketing */
  call_marketing?: boolean | null;
  /** Customer Club Marketing */
  customer_club_marketing?: boolean | null;
}

/** ConsentsPayload */
export interface ConsentsPayload {
  consents?: Consents | null;
  /**
   * Dismissed Consents Popup
   * @default false
   */
  dismissed_consents_popup?: boolean;
}

/** ContactFormPayload */
export interface ContactFormPayload {
  /** Givenname */
  givenName: string;
  /** Lastname */
  lastName: string;
  /** Phonenumber */
  phoneNumber: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Message */
  message: string;
}

/** Conversation */
export interface Conversation {
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Application Id Or Lead Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id_or_lead_id?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Pni */
  pni?: string | null;
  /** Open */
  open: boolean;
}

/** ConvertPayload */
export interface ConvertPayload {
  /** Lead Id */
  lead_id: string;
}

/** ConvertResult */
export interface ConvertResult {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
}

/** CostPerPerson */
export interface CostPerPerson {
  /** Cost */
  cost: number;
  /** From And Including Age */
  from_and_including_age: number;
  /** To And Including Age */
  to_and_including_age: number;
}

/**
 * CountBand
 * The hard count filter in front of the value keys.
 *
 * A handler is selectable while ``cases(handler) - mean <= max(abs_floor, rel * mean)``;
 * an empty band is ignored rather than blocking the decision. The absolute floor is what
 * stops the band from biting on a Monday morning, when the mean is 1.
 */
export interface CountBand {
  /**
   * Abs Floor
   * @min 0
   * @default 2
   */
  abs_floor?: number;
  /**
   * Rel
   * @min 0
   * @max 1
   * @default 0.1
   */
  rel?: number;
}

/** CreateAndUpdateEmployeeRequest */
export interface CreateAndUpdateEmployeeRequest {
  /** Email */
  email?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Zoordinates */
  zoordinates: Zoordinates[];
  /** Phone Number */
  phone_number?: string | null;
  /** Telavox Ids */
  telavox_ids?: string[] | null;
  /** Sverker Usernames */
  sverker_usernames?: SverkerUsername[] | null;
  /** Roles */
  roles: RoleType[];
}

/** CreateApplicantNO */
export interface CreateApplicantNO {
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /** Pni */
  pni: string;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: SharedModelsPhonePhoneNumber[] | null;
  /** Sverker Id */
  sverker_id?: number | null;
  /** Children */
  children?: number | null;
  /** Citizen */
  citizen?: number | null;
  education?: EducationType | null;
  /** Monthly Partner Income */
  monthly_partner_income?: number | null;
  /** Immigrated At */
  immigrated_at?: string | null;
  /** Fullname */
  fullname?: string | null;
  /** Documents */
  documents?: ApplicantDocument[] | null;
  /** Verified Credits */
  verified_credits?: boolean | null;
  /** Housing Since */
  housing_since?: string | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Deceased Date */
  deceased_date?: string | null;
  /** Emigrated */
  emigrated?: boolean | null;
  /** Is Sanction */
  is_sanction?: boolean | null;
  /** Is Rca */
  is_rca?: boolean | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  /** Last Credit Check */
  last_credit_check?: string | null;
  /** Last Externally Verified Credits */
  last_externally_verified_credits?: string | null;
  /** Last Property Valuation */
  last_property_valuation?: string | null;
  /** Pep Quality */
  pep_quality?: boolean | null;
  /**
   * Cluster
   * A cluster is a group of customers displayed with a color
   */
  cluster?: string | null;
  /**
   * Is Blocked
   * Indicates if the customer is blocked
   * @default false
   */
  is_blocked?: boolean;
  /** Current email verification status, set only by EMAIL_VERIFICATION events */
  email_verification?: EmailVerification | null;
  /**
   * Zrm Only
   * Customer is handled in ZRM only (not in Sverker; derived)
   * @default false
   */
  zrm_only?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: OptionalEmployerNO | null;
  /** Ev Estate */
  ev_estate?: EvEstate[] | null;
  /** Ev Estates */
  ev_estates?: EvProperty[] | null;
  /** Ev Checked At */
  ev_checked_at?: string | null;
  /** Citizenship Iso Codes */
  citizenship_iso_codes?: string[] | null;
  /** Grunnkrets */
  grunnkrets?: string | null;
  /**
   * Cars In The Household
   * Number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Externally Verified Credits */
  externally_verified_credits?: ExternallyVerifiedCreditInput[] | null;
}

/**
 * CreateApplicationPayloadExt
 * Create application payload extended with fields for ZRM
 */
export interface CreateApplicationPayloadExt {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: StatusInput | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: CarsInput | null;
  brokerage?: Brokerage | null;
  product: Product;
  country: Country;
  /** Internal Comment */
  internal_comment?: string | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  source?: ApplicationSourceInput | null;
  aml?: AMLInsertion | null;
}

/** CreateCampaignData */
export interface CreateCampaignData {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Source */
  source:
    | ({
        type: "BIG_QUERY";
      } & BigQueryCampaignSource)
    | ({
        type: "PROCESS";
      } & ProcessCampaignSource)
    | ({
        type: "SHEET";
      } & SheetCampaignSourceInput);
  /** File Id */
  file_id?: string | null;
  exclusion_rules: ExclusionRules;
  /** Daily Extraction Limit */
  daily_extraction_limit?: number | null;
  /**
   * Auto Extraction
   * Time of auto extraction in HH:MM format
   */
  auto_extraction?: string | null;
  /** Comment Template */
  comment_template?: string | null;
  sms_template?: SmsTemplate | null;
  sms_policy?: SendPolicy | null;
  /** Test Phone Numbers */
  test_phone_numbers?: string[] | null;
  mail_policy?: SendPolicy | null;
  template?: EmailTemplate | null;
  /**
   * Amount Of Bcc Mails
   * @default 1
   */
  amount_of_bcc_mails?: number;
  retry_policy?: RetryPolicy | null;
  /** Auto Dial */
  auto_dial?: boolean | null;
  /** Personal Callbacks */
  personal_callbacks?: boolean | null;
  /** No Contact Outcomes */
  no_contact_outcomes?: string[] | null;
  /** Failure Outcomes */
  failure_outcomes?: string[] | null;
  /** Discard Outcomes */
  discard_outcomes?: string[] | null;
  /**
   * Show Call History
   * @default true
   */
  show_call_history?: boolean | null;
  /**
   * Todomaker
   * @default false
   */
  todomaker?: boolean;
  type: CampaignType;
  country: Country;
  /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
  product: ExtendedProduct;
  department?: ZDepartment | null;
  contact_type: ModelsDialMaker2CampaignDataModelsContactType;
  /**
   * Is Prospect Campaign
   * @default false
   */
  is_prospect_campaign?: boolean;
}

/**
 * CreateCreditCardApplicationApplicantPayloadExt
 * Create application and applicant payload extended with fields for ZRM
 */
export interface CreateCreditCardApplicationApplicantPayloadExt {
  country: Country;
  data: CreditCardApplicationDataCreate;
  applicant: CreateApplicantNO;
  /** Internal Comment */
  internal_comment?: string | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  source?: ApplicationSourceInput | null;
  aml?: AMLInsertion | null;
}

/**
 * CreateCreditCardApplicationPayloadExt
 * Create application payload extended with fields for ZRM
 */
export interface CreateCreditCardApplicationPayloadExt {
  country: Country;
  data: CreditCardApplicationData;
  /** Internal Comment */
  internal_comment?: string | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  source?: ApplicationSourceInput | null;
  aml?: AMLInsertion | null;
}

/**
 * CreateCreditCardApplicationPayloadWithApplicant
 * Payload to send to apps-mgr - create application and applicant
 */
export interface CreateCreditCardApplicationPayloadWithApplicant {
  country: Country;
  data: CreditCardApplicationDataCreate;
  applicant: CreateApplicantNO;
}

/** CreateCustomerPayload */
export interface CreateCustomerPayload {
  /** Reason */
  reason: string;
  country: Country;
  /** Pni */
  pni: string;
  data: CustomerData;
}

/** CreateInsuranceCustomer */
export interface CreateInsuranceCustomer {
  insurance_type: InsuranceType;
  /** Insured Amount */
  insured_amount: number;
  /** Premium Amount */
  premium_amount: number;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Phone Number */
  phone_number: string;
  payment_provider?: PaymentProvider | null;
  /** Success Url */
  success_url: string;
  /** Fail Url */
  fail_url: string;
}

/** CreateInsuranceCustomerV1 */
export interface CreateInsuranceCustomerV1 {
  insuranceType: InsuranceType;
  /** Insuredamount */
  insuredAmount: number;
  /** Premium */
  premium: number;
  /** Pni */
  pni: string;
  /** Email */
  email: string;
  /** Phonenumber */
  phoneNumber: string;
  customerProduct?: Product | null;
  payment_provider?: PaymentProvider | null;
}

/** CreateLeadPayload */
export interface CreateLeadPayload {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: StatusInput | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: CarsInput | null;
  brokerage?: Brokerage | null;
  /** Applicant */
  applicant:
    | ({
        country: "NO";
      } & LimitedApplicantNO)
    | ({
        country: "SE";
      } & LimitedApplicantSE);
  /** Co Applicant */
  co_applicant?:
    | (
        | ({
            country: "NO";
          } & LimitedApplicantNO)
        | ({
            country: "SE";
          } & LimitedApplicantSE)
      )
    | null;
  property?: ExternalPropertyInput | null;
  /** Comment */
  comment: string;
  source: ApplicationSourceInput;
  product: Product;
  country: Country;
  [key: string]: any;
}

/** CreateMeetingPayload */
export interface CreateMeetingPayload {
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
}

/** CreateMeetingPayloadV2 */
export interface CreateMeetingPayloadV2 {
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject: string | null;
  /** Customer Id */
  customer_id: string;
  /** Application Ids */
  application_ids?: string[] | null;
  /** Priority */
  priority?: number | null;
  subject_priority?: MeetingSubject | null;
  /**
   * Booked
   * @default true
   */
  booked?: boolean;
  /** Recommended Time */
  recommended_time?: string | null;
  /** Assign Apps To Handler */
  assign_apps_to_handler?: string[] | null;
}

/** CreateTMCampaign */
export interface CreateTMCampaign {
  /** Query */
  query: string;
  country: Country;
  product: Product;
  department: ZDepartment;
  /** Description */
  description: string;
  /**
   * Ignore Days Since Last Extraction
   * Number of days since last extraction to ignore customer_id
   * @default 30
   */
  ignore_days_since_last_extraction?: number;
}

/** CreateUser */
export interface CreateUser {
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Username
   * @format email
   */
  username: string;
  /** Banks */
  banks: IntegrationId[];
}

/** CreateUserResp */
export interface CreateUserResp {
  /** Token */
  token: string;
}

/** CreditCardApplicationData */
export interface CreditCardApplicationData {
  /** Desired Credit Limit */
  desired_credit_limit: number;
  /** Car */
  car: boolean;
  /**
   * Student Loans Amount
   * @default 0
   */
  student_loans_amount?: number;
  /**
   * Student Loans Monthly Payment
   * @default 0
   */
  student_loans_monthly_payment?: number;
  /**
   * Car Boat Mc Loans Amount
   * @default 0
   */
  car_boat_mc_loans_amount?: number;
  /**
   * Car Boat Mc Loans Monthly Payment
   * @default 0
   */
  car_boat_mc_loans_monthly_payment?: number;
  /**
   * Total Consumer Loans Amount
   * @default 0
   */
  total_consumer_loans_amount?: number;
  /**
   * Total Consumer Loans Monthly Payment
   * @default 0
   */
  total_consumer_loans_monthly_payment?: number;
  /**
   * Mortgage Loans Amount
   * @default 0
   */
  mortgage_loans_amount?: number;
  /**
   * Mortgage Loans Monthly Payment
   * @default 0
   */
  mortgage_loans_monthly_payment?: number;
  /**
   * Credit Card Debt Amount
   * @default 0
   */
  credit_card_debt_amount?: number;
  /**
   * Credit Card Debt Monthly Payment
   * @default 0
   */
  credit_card_debt_monthly_payment?: number;
  /**
   * Children In The Household Fulltime
   * @default 0
   */
  children_in_the_household_fulltime?: number;
  /** Application Score */
  application_score?: number | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
  /**
   * Applicant Id
   * @format uuid
   */
  applicant_id: string;
}

/** CreditCardApplicationDataCreate */
export interface CreditCardApplicationDataCreate {
  /** Desired Credit Limit */
  desired_credit_limit: number;
  /** Car */
  car: boolean;
  /**
   * Student Loans Amount
   * @default 0
   */
  student_loans_amount?: number;
  /**
   * Student Loans Monthly Payment
   * @default 0
   */
  student_loans_monthly_payment?: number;
  /**
   * Car Boat Mc Loans Amount
   * @default 0
   */
  car_boat_mc_loans_amount?: number;
  /**
   * Car Boat Mc Loans Monthly Payment
   * @default 0
   */
  car_boat_mc_loans_monthly_payment?: number;
  /**
   * Total Consumer Loans Amount
   * @default 0
   */
  total_consumer_loans_amount?: number;
  /**
   * Total Consumer Loans Monthly Payment
   * @default 0
   */
  total_consumer_loans_monthly_payment?: number;
  /**
   * Mortgage Loans Amount
   * @default 0
   */
  mortgage_loans_amount?: number;
  /**
   * Mortgage Loans Monthly Payment
   * @default 0
   */
  mortgage_loans_monthly_payment?: number;
  /**
   * Credit Card Debt Amount
   * @default 0
   */
  credit_card_debt_amount?: number;
  /**
   * Credit Card Debt Monthly Payment
   * @default 0
   */
  credit_card_debt_monthly_payment?: number;
  /**
   * Children In The Household Fulltime
   * @default 0
   */
  children_in_the_household_fulltime?: number;
  /** Application Score */
  application_score?: number | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
}

/** CreditCardApplicationExtended */
export interface CreditCardApplicationExtended {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  data: CreditCardApplicationData;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** @default "COMPLETE" */
  state?: AppState;
  /** Created At */
  created_at?: string | null;
  /** Applicant */
  applicant:
    | ({
        country: "NO";
      } & ApplicantNO)
    | ({
        country: "SE";
      } & ApplicantSE);
}

/** CreditCardApplicationWithNamesInComments */
export interface CreditCardApplicationWithNamesInComments {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  data: CreditCardApplicationData;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** @default "COMPLETE" */
  state?: AppState;
  /** Created At */
  created_at?: string | null;
  /** Applicant */
  applicant:
    | ({
        country: "NO";
      } & ApplicantNO)
    | ({
        country: "SE";
      } & ApplicantSE);
  meta: ApplicationMappingWithNamesInComments;
}

/** CreditCardBankEventsResponse */
export interface CreditCardBankEventsResponse {
  /** Bank Events */
  bank_events: BankEventsCreditCardOfferData[];
}

/** CreditCardOfferData */
export interface CreditCardOfferData {
  /** Comment */
  comment?: string | null;
  /** @default "FIXED_RATE" */
  amortizationRule?: AmortizationPlan;
  /**
   * Offeredamount
   * @default 0
   */
  offeredAmount?: number;
  /** Minofferedamount */
  minOfferedAmount?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /**
   * Termfee
   * @default 0
   */
  termFee?: number;
  /**
   * Arrangementfee
   * @default 0
   */
  arrangementFee?: number;
  /**
   * Invoicefee
   * @default 0
   */
  invoiceFee?: number;
  /** Customerurl */
  customerUrl?: string | null;
  creditorProduct?: CreditorProduct | null;
  condition?: OfferCondition | null;
  /** Ratepercent */
  ratePercent?: number | null;
}

/** CreditCardPatchPayload */
export interface CreditCardPatchPayload {
  /**
   * Product
   * @default "credit_card"
   */
  product?: "credit_card";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  data: OptionalCreditCardApplicationDataCreate;
}

/**
 * CreditCardTerms
 * General terms for credit card offers.
 */
export interface CreditCardTerms {
  /** Withdrawal Fee */
  withdrawal_fee: string;
  /** Currency Surcharge */
  currency_surcharge: number;
  /** Annual Fee */
  annual_fee: number;
  /** Apr */
  apr: number;
  /**
   * Apr Calculation Description
   * @default ""
   */
  apr_calculation_description?: string;
  /** Grace Period Days */
  grace_period_days: number;
  /**
   * Purchase Fee
   * @default 0
   */
  purchase_fee?: number;
  /**
   * E Invoice Fee
   * @default 0
   */
  e_invoice_fee?: number;
}

/** CreditCheckNO */
export interface CreditCheckNO {
  /** Earnedincome */
  earnedIncome: number;
  /** Mostrecentnotedate */
  mostRecentNoteDate?: string | null;
  /**
   * Creditnotes
   * @default 0
   */
  creditNotes?: number;
  /**
   * Expired
   * @default false
   */
  expired?: boolean;
  /** Expiration Date */
  expiration_date?: string | null;
  /** Debt Equity Ratio */
  debt_equity_ratio?: number | null;
  /** Debt Equtiy Year */
  debt_equtiy_year?: number | null;
  remarks?: Debt | null;
  /** Cdg2 Risk */
  cdg2_risk?: number | null;
  /** Cdg2 Score */
  cdg2_score?: number | null;
}

/** CreditCheckSE */
export interface CreditCheckSE {
  /** Earnedincome */
  earnedIncome: number;
  /** Mostrecentnotedate */
  mostRecentNoteDate?: string | null;
  /**
   * Creditnotes
   * @default 0
   */
  creditNotes?: number;
  /**
   * Expired
   * @default false
   */
  expired?: boolean;
  /** Expiration Date */
  expiration_date?: string | null;
  /** Riskassessment */
  riskAssessment?: number | null;
  /**
   * Kfmdebt
   * @default 0
   */
  kfmDebt?: number;
  /** Kfmdebtpublic */
  kfmDebtPublic?: number | null;
  /** Kfmdebtprivate */
  kfmDebtPrivate?: number | null;
  /**
   * Numprevious
   * @default 0
   */
  numPrevious?: number;
  /** Score */
  score?: number | null;
  /** Inquiries */
  inquiries?: number | null;
  /** Issuers */
  issuers?: string[] | null;
}

/** CreditDetails */
export interface CreditDetails {
  creditType?: CreditType | null;
  /**
   * Creditor
   * The organization the lends the money.
   */
  creditor?: string | null;
  /** Creditnumber */
  creditNumber?: string | null;
  /**
   * Grantedcredit
   * The amount that was granted by the creditor
   */
  grantedCredit?: number | null;
  /**
   * Usedcredit
   * The amount used by the individual
   */
  usedCredit?: number | null;
  /**
   * Fromdate
   * The date this mortgage/credit/loan was first reported to UC
   */
  fromDate?: string | null;
  /**
   * Todate
   * The date this credit was closed.
   */
  toDate?: string | null;
  /**
   * Updatedatdate
   * Timestamp when the information was reported to UC
   */
  updatedAtDate?: string | null;
}

/** CreditNO */
export interface CreditNO {
  /**
   * Credit Id
   * @format uuid
   */
  credit_id?: string;
  /** Sum */
  sum: number;
  /** Monthly Payment */
  monthly_payment: number;
  /** Bank Id */
  bank_id: number;
  /** Liable */
  liable?: string | null;
  /** Rate */
  rate: number;
  /** Refinance Amount */
  refinance_amount?: number | null;
  /** Monthly Amortisation */
  monthly_amortisation?: number | null;
  responsibility?: CreditResponsibility | null;
  /** Monthly Administrative Fee */
  monthly_administrative_fee?: number | null;
  type: CreditTypeNO;
  /** Property Ids */
  property_ids?: string[] | null;
}

/** CreditRegulation */
export interface CreditRegulation {
  /** Accounting Controlls Summary */
  accounting_controlls_summary?: string | null;
  /** Allow Casuation Storage */
  allow_casuation_storage?: string | null;
  /** Cause Table */
  cause_table?: string | null;
  /** Risk */
  risk?: string | null;
  /** Risk Applicant */
  risk_applicant?: string | null;
  /** Risk Applicant 2 */
  risk_applicant_2?: string | null;
  /** Template Description */
  template_description?: string | null;
  /** Uc Internal Information */
  uc_internal_information?: string | null;
  /** Year */
  year?: string | null;
}

/** CreditRegulationInformation */
export interface CreditRegulationInformation {
  /** Account Number */
  account_number?: string | null;
  /** Decision Template */
  decision_template?: string | null;
  /** No Decimals */
  no_decimals?: string | null;
  /** Order Template */
  order_template?: string | null;
  /** Template Name */
  template_name?: string | null;
  /** Template Response */
  template_response?: string | null;
  /** Year */
  year?: string | null;
}

/** CreditReport */
export interface CreditReport {
  /**
   * Personid
   * The social security number of the requested individual
   */
  personId: string;
  /**
   * Timestamp
   * The timestamp when the credit score was checked
   * @format date-time
   */
  timestamp: string;
  /**
   * Creditscore
   * A calculated credit score. The score ranges from 0.1 to 99.9. The score represents the likelihood to receive a complaint/payment note within 12 months.
   */
  creditScore?: number | null;
  complaints?: Complaints | null;
}

/** CreditReportExperian */
export interface CreditReportExperian {
  /**
   * Personid
   * The social security number of the requested individual
   */
  personId: string;
  /**
   * Timestamp
   * The timestamp when the credit score was checked
   * @format date-time
   */
  timestamp: string;
  /**
   * Creditscore
   * A calculated credit score. The score ranges from 0.1 to 99.9. The score represents the likelihood to receive a complaint/payment note within 12 months.
   */
  creditScore?: number | null;
  complaints?: Complaints | null;
  /** Riskclass */
  riskClass?: number | null;
}

/** CreditReportUc */
export interface CreditReportUc {
  /**
   * Personid
   * The social security number of the requested individual
   */
  personId: string;
  /**
   * Timestamp
   * The timestamp when the credit score was checked
   * @format date-time
   */
  timestamp: string;
  /**
   * Creditscore
   * A calculated credit score. The score ranges from 0.1 to 99.9. The score represents the likelihood to receive a complaint/payment note within 12 months.
   */
  creditScore?: number | null;
  complaints?: Complaints | null;
  credits?: Credits | null;
  /**
   * Csnloans
   * Information about the csnLoans.
   */
  csnLoans?: CsnLoans[] | null;
  /** Information about the Income and Taxation. */
  incomeAndTaxation?: IncomeAndTaxation | null;
  cases?: Cases | null;
  /**
   * Riskforecasthistory
   * Information about the historical risk forecast is not available in the API as for now
   */
  riskForecastHistory?: RiskForecast[] | null;
}

/** CreditSE */
export interface CreditSE {
  /**
   * Credit Id
   * @format uuid
   */
  credit_id?: string;
  /** Sum */
  sum: number;
  /** Monthly Payment */
  monthly_payment: number;
  /** Bank Id */
  bank_id: number;
  /** Liable */
  liable?: string | null;
  /** Rate */
  rate: number;
  /** Refinance Amount */
  refinance_amount?: number | null;
  /** Monthly Amortisation */
  monthly_amortisation?: number | null;
  responsibility?: CreditResponsibility | null;
  /** Monthly Administrative Fee */
  monthly_administrative_fee?: number | null;
  type: CreditTypeSE;
}

/** CreditSummary */
export interface CreditSummary {
  /** Date */
  date?: string | null;
  usedCredits?: UsedCredits | null;
  grantedCredits?: GrantedCredits | null;
  NumberOfCredits?: NumberOfCreditsModel | null;
  /** Numberofcreditors */
  numberOfCreditors?: number | null;
  unitOfAmount?: UnitOfAmount | null;
}

/** CreditorOffer[CreditCardOfferData, CreditCardTerms] */
export interface CreditorOfferCreditCardOfferDataCreditCardTerms {
  country: Country;
  /** Bank Id */
  bank_id: number;
  /** Creditor Name */
  creditor_name: string;
  /**
   * Offer Id
   * @format uuid4
   */
  offer_id: string;
  offer: CreditCardOfferData;
  /** General terms for credit card offers. */
  terms: CreditCardTerms;
  /** Acceptable */
  acceptable: boolean;
  /**
   * Is Accepted
   * @default false
   */
  is_accepted?: boolean;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** App Identifier */
  app_identifier: string;
}

/** Credits */
export interface Credits {
  /** Date */
  date?: string | null;
  usedCredits?: UsedCredits | null;
  grantedCredits?: GrantedCredits | null;
  NumberOfCredits?: NumberOfCreditsModel | null;
  /** Numberofcreditors */
  numberOfCreditors?: number | null;
  unitOfAmount?: UnitOfAmount | null;
  /** Creditdetails */
  creditDetails?: CreditDetails[] | null;
  /**
   * Credithistory
   * Historical information about the credits at different point in time. The history goes 12 month back. But only every second month is presented.
   */
  creditHistory?: CreditSummary[] | null;
}

/** CsnLoans */
export interface CsnLoans {
  /** Type of Student loan */
  loanType?: SharedModelsExternalCreditScoreLoanType | null;
  /**
   * Repaymentperiod
   * Remaining repayment period in years
   */
  repaymentPeriod?: number | null;
  /**
   * Balance
   * List of Balance information
   */
  balance?: Balance[] | null;
}

/**
 * CurrentCredits
 * The credits the new loan pays off: their monthly payments as the credits hold them, and everything left to pay
 * on them. The frontend sends them only when the comparison is like for like (loans only, no card or check credit,
 * each paid off in full by a new loan that covers them), for the saving in the SMS. A credit's monthly fee is not
 * added where the credit holds it apart, so the saving is never overstated.
 */
export interface CurrentCredits {
  /**
   * Monthly Payment
   * @min 1
   * @max 1000000
   */
  monthly_payment: number;
  /**
   * Total Cost
   * @min 1
   * @max 100000000
   */
  total_cost: number;
}

/** CurrentFrameItem */
export interface CurrentFrameItem {
  /** Frame Information */
  frame_information?: string | null;
  /** Uc Divisions */
  uc_divisions?: string | null;
  /** Uc Post Type Current */
  uc_post_type_current?: string | null;
  /** Uc Quick Choice */
  uc_quick_choice?: null;
  /** Year */
  year?: string | null;
}

/** CurrentSectionOfCaseItem */
export interface CurrentSectionOfCaseItem {
  /** Additional Order */
  additional_order?: string | null;
  /** Editor Program */
  editor_program?: string | null;
  /** Order Date */
  order_date?: string | null;
  /** Person Name Stored */
  person_name_stored?: string | null;
  /** Report Language */
  report_language?: string | null;
  /** Subscriber Name */
  subscriber_name?: string | null;
  /** Uc Archive */
  uc_archive?: string | null;
  /** Uc Divisions 1 */
  uc_divisions_1?: string | null;
  /** Uc Divisions 2 */
  uc_divisions_2?: string | null;
  /** Uc Divisions 3 */
  uc_divisions_3?: string | null;
  /** Uc Divisions 4 */
  uc_divisions_4?: string | null;
  /** Uc Divisions 5 */
  uc_divisions_5?: string | null;
  /** Uc Divisions 6 */
  uc_divisions_6?: string | null;
  /** Uc Divisions 7 */
  uc_divisions_7?: string | null;
  /** Uc Divisions 8 */
  uc_divisions_8?: string | null;
  /** Uc More Info */
  uc_more_info?: string | null;
  /** Uc Role */
  uc_role?: string | null;
  /** Uc Type */
  uc_type?: string | null;
  /** Uc Type Internal */
  uc_type_internal?: string | null;
  /** Uc Type Text */
  uc_type_text?: string | null;
  /** Year */
  year?: string | null;
}

/**
 * CustomSchedule
 * Persisted CUSTOM document.
 */
export interface CustomSchedule {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Mode
   * @default "CUSTOM"
   */
  mode?: "CUSTOM";
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Updated By */
  updated_by: string;
  /** User Id */
  user_id: string;
  /**
   * Slots
   * @default []
   */
  slots?: ModelsScheduleEmployeeScheduleScheduleSlotOutput[];
}

/**
 * CustomScheduleData
 * Works exactly `slots`; no operating-hours fallback (op-hours bounds are an advisory only).
 */
export interface CustomScheduleData {
  /** User Id */
  user_id: string;
  /**
   * Slots
   * @default []
   */
  slots?: ModelsScheduleEmployeeScheduleScheduleSlotInput[];
  /**
   * Mode
   * @default "CUSTOM"
   */
  mode?: "CUSTOM";
}

/** CustomerApplication */
export interface CustomerApplication {
  country: Country;
  product: Product;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Is Deactivated */
  is_deactivated: boolean;
  /** Date Created */
  date_created?: string | null;
  /**
   * Which backend an application/offer was sourced from — tells the frontend which
   * accept endpoint to call during the v2→v3 transition.
   * @default "v2"
   */
  source?: ModelsMyPagesApplicationApplicationSource;
  /** Offers */
  offers?: CustomerOffer[] | null;
  /** Credits */
  credits: CreditSE[] | CreditNO[];
  applicant: CustomerCustomer;
  co_applicant?: CustomerCustomer | null;
}

/** CustomerApplicationV2 */
export interface CustomerApplicationV2 {
  country: Country;
  product: Product;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Is Deactivated */
  is_deactivated: boolean;
  /** Date Created */
  date_created?: string | null;
  /**
   * Which backend an application/offer was sourced from — tells the frontend which
   * accept endpoint to call during the v2→v3 transition.
   * @default "v2"
   */
  source?: ModelsMyPagesApplicationApplicationSource;
  /**
   * Offers
   * @default []
   */
  offers?: CustomerOfferV2[];
}

/** CustomerApplicationV3 */
export interface CustomerApplicationV3 {
  country: Country;
  product: Product;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Is Deactivated */
  is_deactivated: boolean;
  /** Date Created */
  date_created?: string | null;
  /**
   * Which backend an application/offer was sourced from — tells the frontend which
   * accept endpoint to call during the v2→v3 transition.
   * @default "v3"
   */
  source?: ModelsMyPagesApplicationApplicationSource;
  /**
   * Offers
   * @default []
   */
  offers?: CustomerOfferV3[];
}

/**
 * CustomerCaseDocument
 * A document the customer uploaded, as My Pages shows it. Nothing about Zensum users, banks, the other applicant
 * or the storage.
 */
export interface CustomerCaseDocument {
  /** Document Id */
  document_id: string;
  document_type: MonoDocumentType;
  /** Filename */
  filename: string;
  /** File Size */
  file_size: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** CustomerCompliancePage */
export interface CustomerCompliancePage {
  /** Items */
  items: ZenscriptionWithCompliance[];
  /** Analyzed Total */
  analyzed_total: number;
  /** Flagged Total */
  flagged_total: number;
}

/** CustomerContextSlim */
export interface CustomerContextSlim {
  /** Customer Ids */
  customer_ids: string[];
  currency?: Currency | null;
  /** Dialmaker Outcome */
  dialmaker_outcome:
    | (
        | ({
            type: "CALL_BACK";
          } & CallOutcomeCallBack)
        | ({
            type: "DISCARD";
          } & CallOutcomeDiscard)
        | ({
            type: "FAILURE";
          } & CallOutcomeFailure)
        | ({
            type: "NO_CONTACT";
          } & CallOutcomeNoContact)
        | ({
            type: "SUCCESS";
          } & CallOutcomeSuccess)
      )
    | null;
  meeting: CommonMeeting | null;
  /** Applications */
  applications: SlimApplication[];
  mortgage_lead: SlimMortgageLead | null;
  /** Insurances */
  insurances: SlimInsurance[];
  /** Customers */
  customers: SlimCustomer[];
  lars_magnus_calls: SSECall | null;
  user_info: SlimEmployee | null;
  dm_campaign: SlimDMCampaign | null;
  dm_lead: SlimDMLead | null;
  /**
   * Messages
   * @default []
   */
  messages?: SlimMessage[];
  /**
   * Op Applications
   * @default []
   */
  op_applications?: OPApplicationHistory[];
}

/** CustomerCustomer */
export interface CustomerCustomer {
  /** Customer Id */
  customer_id?: string | null;
  country: Country;
  /** Pni */
  pni: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Sverker Id */
  sverker_id?: number | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  bank_account?: Account | null;
  /** Employer */
  employer?: Record<string, any> | null;
}

/** CustomerData */
export interface CustomerData {
  /** Phone Number */
  phone_number?: string | null;
  /** Email */
  email?: string | null;
  account?: Account | null;
  /**
   * Children
   * @min 0
   * @default 0
   */
  children?: number;
  /**
   * Cars In The Household
   * NORWAY only
   */
  cars_in_the_household?: number | null;
  /** Employer */
  employer?: EmployerSE | EmployerNO | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  /** Monthly Partner Income */
  monthly_partner_income?: number | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  /** Housing Type */
  housing_type?: HousingTypeSE | HousingTypeNO | null;
  /** Paying Child Support */
  paying_child_support?: number | null;
  /** Receiving Child Support */
  receiving_child_support?: number | null;
  /** Marital status of a person */
  marital_status?: MaritalStatus | null;
  /** Official marital status of a person */
  registered_marital_status?: MaritalStatus | null;
  education?: EducationType | null;
  /** Citizen */
  citizen?: number | null;
  /** Immigrated At */
  immigrated_at?: string | null;
}

/** CustomerDocument */
export interface CustomerDocument {
  /**
   * Name
   * Name of the document
   */
  name: string;
  /**
   * Mime Type
   * MIME type of the document
   */
  mime_type: string;
  /**
   * Document Type
   * The type of document you're uploading, will be used as key on the customer
   */
  document_type: string;
  /**
   * Customer Id
   * ID of the customer to attach the document to
   * @format uuid
   */
  customer_id: string;
  /**
   * Data
   * Base64 encoded data of the document
   */
  data: string;
  /**
   * Document Id
   * ID of the document
   * @format uuid
   */
  document_id: string;
  /**
   * Timestamp
   * Document creation time
   * @format date-time
   */
  timestamp: string;
}

/** CustomerDocumentReceived */
export interface CustomerDocumentReceived {
  /** Type */
  type: "CUSTOMER_DOCUMENT_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  /**
   * A customer uploaded a document to the case in My Pages. No filename and nothing about the customer: a filename
   * can hold a name or a PNI.
   */
  data: CustomerDocumentReceivedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/**
 * CustomerDocumentReceivedData
 * A customer uploaded a document to the case in My Pages. No filename and nothing about the customer: a filename
 * can hold a name or a PNI.
 */
export interface CustomerDocumentReceivedData {
  /** Application Id */
  application_id: string;
  product?: Product | null;
}

/**
 * CustomerFilter
 * The customer identifier found in the query (`services/search/identifier.py`) and what became of it.
 *
 * `applied`: the hits are only these customers' texts. `not_found`: KDLT knows nobody by it, and `unavailable`: the
 * lookup failed or timed out; in both cases nothing is filtered, and when the query was only the identifier,
 * nothing is searched. The identifier is never searched as text.
 */
export interface CustomerFilter {
  /** Kind */
  kind: "pni" | "phone" | "email";
  /** Status */
  status: "applied" | "not_found" | "unavailable";
  /** Customers */
  customers?: FilterCustomer[];
  /** Text */
  text: string;
}

/** CustomerHTTPRequestMetadata */
export interface CustomerHTTPRequestMetadata {
  /** Ip */
  ip?: string | null;
  /** Url */
  url?: string | null;
  /** Origin */
  origin?: string | null;
  /** User Agent */
  user_agent?: string | null;
  /** @default "OTHER" */
  source?: MetadataSource;
  /** Bankid */
  bankid?: Record<string, any> | null;
  /** Filling Id */
  filling_id?: string | null;
}

/**
 * CustomerHeader
 * Returned by the orchestrator after its single audited KDLT read (so the FE
 * header needs no second access_events write).
 */
export interface CustomerHeader {
  /** Customer Id */
  customer_id: string;
  /** Name */
  name?: string | null;
  /** Country */
  country?: string | null;
  /** Product */
  product?: string | null;
  /** Avatar */
  avatar?: string | null;
}

/** CustomerIDGetCustomerPayload */
export interface CustomerIDGetCustomerPayload {
  /** Reason */
  reason: string;
  /** Customer Id */
  customer_id: string;
}

/** CustomerIDsGetCustomerPayload */
export interface CustomerIDsGetCustomerPayload {
  /** Reason */
  reason: string;
  /** Customer Ids */
  customer_ids: string[];
}

/**
 * CustomerLogin
 * One successful customer login, as the case view shows it.
 *
 * Built from a `bank_id_logins` row without decrypting anything, so it never carries the PNI (`sub`), the
 * customer_id, the impersonator's id, names, phone, email or `meta`.
 */
export interface CustomerLogin {
  /** Id */
  id: string;
  /**
   * Ts
   * @format date-time
   */
  ts: string;
  provider: CustomerLoginProvider;
  country: Country;
  purpose: BankIDPurpose | null;
  entry_point: LoginEntryPoint | null;
  /** Landing Path */
  landing_path: string | null;
  /** Impersonated */
  impersonated: boolean;
  /** Impersonator Name */
  impersonator_name: string | null;
}

/** CustomerLogins */
export interface CustomerLogins {
  /** Items */
  items: CustomerLogin[];
  /** Total */
  total: number;
  /** Last 30D */
  last_30d: number;
  /** Last Login At */
  last_login_at: string | null;
}

/**
 * CustomerLoginsResponse
 * Successful BankID/Vipps logins of the case's MAIN applicant. Distinct from
 * BANK_ID_VERIFIED, which is an AGENT-initiated identity check.
 */
export interface CustomerLoginsResponse {
  /**
   * Event
   * @default "customer_logins"
   */
  event?: "customer_logins";
  data: CustomerLogins;
}

/**
 * CustomerMortgageApplication
 * A MONO application where the logged-in customer is the applicant or co-applicant.
 */
export interface CustomerMortgageApplication {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** CustomerOffer */
export interface CustomerOffer {
  /** Comment */
  comment?: string | null;
  amortizationRule?: AmortizationPlan | null;
  /** Offeredamount */
  offeredAmount: number;
  /** Minofferedamount */
  minOfferedAmount?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /** Termfee */
  termFee: number;
  /** Arrangementfee */
  arrangementFee: number;
  /** Invoicefee */
  invoiceFee: number;
  /** Customerurl */
  customerUrl?: string | null;
  creditorProduct?: CreditorProduct | null;
  condition?: OfferCondition | null;
  /** Ratepercent */
  ratePercent: number;
  /** Effectiveratepercent */
  effectiveRatePercent: number;
  /** Need More Info */
  need_more_info?: boolean | null;
  status?: OfferStatus | null;
  /** Invite Id */
  invite_id?: string | null;
  /** Totalrepaymentamount */
  totalRepaymentAmount?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Bank Id */
  bank_id: number;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
  /** Application Id */
  application_id: number;
  /** External Offer Id */
  external_offer_id?: string | null;
  /** Sverker Offer Id */
  sverker_offer_id?: number | null;
  /** Accepted At */
  accepted_at?: string | null;
  /** Disbursed At */
  disbursed_at?: string | null;
  /**
   * Total Cost
   * Total the customer pays over the loan: principal + interest + fees.
   *
   * Uses the bank-quoted ``totalRepaymentAmount`` when the integration supplied it,
   * otherwise derives the figure. Safe when fields needed by the calculation are
   * missing/None — returns ``0`` when the term is unknown, and treats other missing
   * inputs (amount, rate, fees) as ``0``.
   */
  total_cost: number;
  /**
   * Total Fees Amount
   * Arrangement fee plus the recurring monthly fees (term + invoice) over the whole term.
   */
  total_fees_amount: number;
  /**
   * Total Interest Amount
   * Interest only, derived as total_cost - principal - fees.
   *
   * Returns 0 when the term is unknown so we never emit a negative ``total_cost`` artefact.
   */
  total_interest_amount: number;
}

/** CustomerOfferV2 */
export interface CustomerOfferV2 {
  /** Comment */
  comment?: string | null;
  amortizationRule?: AmortizationPlan | null;
  /** Offeredamount */
  offeredAmount: number;
  /** Minofferedamount */
  minOfferedAmount?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /** Termfee */
  termFee: number;
  /** Arrangementfee */
  arrangementFee: number;
  /** Invoicefee */
  invoiceFee: number;
  /** Customerurl */
  customerUrl?: string | null;
  creditorProduct?: CreditorProduct | null;
  condition?: OfferCondition | null;
  /** Ratepercent */
  ratePercent: number;
  /** Effectiveratepercent */
  effectiveRatePercent: number;
  /** Need More Info */
  need_more_info?: boolean | null;
  status?: OfferStatus | null;
  /** Invite Id */
  invite_id?: string | null;
  /** Totalrepaymentamount */
  totalRepaymentAmount?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Bank Id */
  bank_id: number;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** External Offer Id */
  external_offer_id?: string | null;
  /** Sverker Offer Id */
  sverker_offer_id?: number | null;
  /** Accepted At */
  accepted_at?: string | null;
  /** Disbursed At */
  disbursed_at?: string | null;
  /**
   * Acceptable
   * @default true
   */
  acceptable?: boolean;
  ended_reason?: EndedOfferReason | null;
  currency?: Currency | null;
  /**
   * Total Cost
   * Total the customer pays over the loan: principal + interest + fees.
   *
   * Uses the bank-quoted ``totalRepaymentAmount`` when the integration supplied it,
   * otherwise derives the figure. Safe when fields needed by the calculation are
   * missing/None — returns ``0`` when the term is unknown, and treats other missing
   * inputs (amount, rate, fees) as ``0``.
   */
  total_cost: number;
  /**
   * Total Fees Amount
   * Arrangement fee plus the recurring monthly fees (term + invoice) over the whole term.
   */
  total_fees_amount: number;
  /**
   * Total Interest Amount
   * Interest only, derived as total_cost - principal - fees.
   *
   * Returns 0 when the term is unknown so we never emit a negative ``total_cost`` artefact.
   */
  total_interest_amount: number;
}

/**
 * CustomerOfferV3
 * v3 customer-facing offer. Acceptance goes through apps-mgr v4 keyed by the UUID
 * ``offer_id`` (the new offer model), so the legacy Sverker-only id is dropped from the response.
 */
export interface CustomerOfferV3 {
  /** Comment */
  comment?: string | null;
  amortizationRule?: AmortizationPlan | null;
  /** Offeredamount */
  offeredAmount: number;
  /** Minofferedamount */
  minOfferedAmount?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /** Termfee */
  termFee: number;
  /** Arrangementfee */
  arrangementFee: number;
  /** Invoicefee */
  invoiceFee: number;
  /** Customerurl */
  customerUrl?: string | null;
  creditorProduct?: CreditorProduct | null;
  condition?: OfferCondition | null;
  /** Ratepercent */
  ratePercent: number;
  /** Effectiveratepercent */
  effectiveRatePercent: number;
  /** Need More Info */
  need_more_info?: boolean | null;
  status?: OfferStatus | null;
  /** Invite Id */
  invite_id?: string | null;
  /** Totalrepaymentamount */
  totalRepaymentAmount?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Bank Id */
  bank_id: number;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Accepted At */
  accepted_at?: string | null;
  /** Disbursed At */
  disbursed_at?: string | null;
  /**
   * Acceptable
   * @default true
   */
  acceptable?: boolean;
  ended_reason?: EndedOfferReason | null;
  currency?: Currency | null;
  /**
   * Total Cost
   * Total the customer pays over the loan: principal + interest + fees.
   *
   * Uses the bank-quoted ``totalRepaymentAmount`` when the integration supplied it,
   * otherwise derives the figure. Safe when fields needed by the calculation are
   * missing/None — returns ``0`` when the term is unknown, and treats other missing
   * inputs (amount, rate, fees) as ``0``.
   */
  total_cost: number;
  /**
   * Total Fees Amount
   * Arrangement fee plus the recurring monthly fees (term + invoice) over the whole term.
   */
  total_fees_amount: number;
  /**
   * Total Interest Amount
   * Interest only, derived as total_cost - principal - fees.
   *
   * Returns 0 when the term is unknown so we never emit a negative ``total_cost`` artefact.
   */
  total_interest_amount: number;
}

/** CustomerPortalLogin */
export interface CustomerPortalLogin {
  /** Type */
  type: "CUSTOMER_PORTAL_LOGIN";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: CustomerPortalLoginData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** CustomerPortalLoginData */
export interface CustomerPortalLoginData {
  /** Customer Id */
  customer_id: string;
  product?: Product | null;
}

/** CustomerResponse */
export interface CustomerResponse {
  /**
   * Event
   * @default "customers"
   */
  event?: "customers";
  /** Data */
  data: (
    | ({
        country: "NO";
      } & ApplicantNO)
    | ({
        country: "SE";
      } & ApplicantSE)
  )[];
}

/** DMLead */
export interface DMLead {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Version */
  version: number;
  data: LeadData;
  /** Campaign Id */
  campaign_id?: string | null;
  /** Extraction Id */
  extraction_id?: string | null;
  /** Extraction of this lead */
  extraction: LeadExtractionOutput | null;
  /** Extracted At */
  extracted_at?: string | null;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Export Id */
  export_id?: string | null;
  /** Exported At */
  exported_at?: string | null;
  status: LeadStatus;
  /** Call Outcomes */
  call_outcomes: (
    | ({
        type: "CALL_BACK";
      } & CallOutcomeCallBack)
    | ({
        type: "DISCARD";
      } & CallOutcomeDiscard)
    | ({
        type: "FAILURE";
      } & CallOutcomeFailure)
    | ({
        type: "NO_CONTACT";
      } & CallOutcomeNoContact)
    | ({
        type: "SUCCESS";
      } & CallOutcomeSuccess)
  )[];
  /** Assigned To */
  assigned_to?: string | null;
  /** Assigned At */
  assigned_at?: string | null;
  /**
   * Which subsystem holds the lock on a lead via ``assigned_to``.
   *
   * Dialmaker assigns leads when an agent dials them; todomaker (KH work queue)
   * claims a lead when a handler expands its row. The discriminator keeps the two
   * pools disjoint: the stale-lock cron and the one-at-a-time release only ever act
   * on ``TODOMAKER`` locks, and dialmaker's available-pool filter excludes them.
   *
   * ``CASE_VIEW`` is "Lock to me" on a Dial Maker lead in the case view. Anyone may press it, including
   * people who never open Dial Maker, so the stale-lock cron releases these too, on their own cutoff
   * (``CASE_VIEW_STALE_LOCK_MINUTES``). An outcome recorded in Dial Maker resets the source as usual.
   * @default "dialmaker"
   */
  assignment_source?: AssignmentSource;
  retry_policy?: RetryPolicy | null;
  /** Call At */
  call_at?: string | null;
  personal_callback?: PersonalCallback | null;
  last_call_outcome?: OutcomeType | null;
  /** Last Call Outcome At */
  last_call_outcome_at?: string | null;
  call_now_source?: CallNowSources | null;
  /** Deactivation Reason */
  deactivation_reason?: string | null;
}

/** DMLeadCampaignData */
export interface DMLeadCampaignData {
  /** Campaign Name */
  campaign_name?: string | null;
  /** Image Id */
  image_id?: string | null;
  /** Campaign Color */
  campaign_color?: number | null;
  /** Auto Dial */
  auto_dial?: boolean | null;
  /** Show Call History */
  show_call_history?: boolean | null;
}

/** DMLeadExt */
export interface DMLeadExt {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Version */
  version: number;
  data: LeadData;
  /** Campaign Id */
  campaign_id?: string | null;
  /** Extraction Id */
  extraction_id?: string | null;
  /** Extraction of this lead */
  extraction: LeadExtractionOutput | null;
  /** Extracted At */
  extracted_at?: string | null;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Export Id */
  export_id?: string | null;
  /** Exported At */
  exported_at?: string | null;
  status: LeadStatus;
  /** Call Outcomes */
  call_outcomes: (
    | ({
        type: "CALL_BACK";
      } & CallOutcomeCallBack)
    | ({
        type: "DISCARD";
      } & CallOutcomeDiscard)
    | ({
        type: "FAILURE";
      } & CallOutcomeFailure)
    | ({
        type: "NO_CONTACT";
      } & CallOutcomeNoContact)
    | ({
        type: "SUCCESS";
      } & CallOutcomeSuccess)
  )[];
  /** Assigned To */
  assigned_to?: string | null;
  /** Assigned At */
  assigned_at?: string | null;
  /**
   * Which subsystem holds the lock on a lead via ``assigned_to``.
   *
   * Dialmaker assigns leads when an agent dials them; todomaker (KH work queue)
   * claims a lead when a handler expands its row. The discriminator keeps the two
   * pools disjoint: the stale-lock cron and the one-at-a-time release only ever act
   * on ``TODOMAKER`` locks, and dialmaker's available-pool filter excludes them.
   *
   * ``CASE_VIEW`` is "Lock to me" on a Dial Maker lead in the case view. Anyone may press it, including
   * people who never open Dial Maker, so the stale-lock cron releases these too, on their own cutoff
   * (``CASE_VIEW_STALE_LOCK_MINUTES``). An outcome recorded in Dial Maker resets the source as usual.
   * @default "dialmaker"
   */
  assignment_source?: AssignmentSource;
  retry_policy?: RetryPolicy | null;
  /** Call At */
  call_at?: string | null;
  personal_callback?: PersonalCallback | null;
  last_call_outcome?: OutcomeType | null;
  /** Last Call Outcome At */
  last_call_outcome_at?: string | null;
  call_now_source?: CallNowSources | null;
  /** Deactivation Reason */
  deactivation_reason?: string | null;
  campaign_data?: DMLeadCampaignData | null;
}

/**
 * DRule
 * When an application's value is frozen.
 *
 * ``D = min(t_completed + cap, max(t_completed, first_offer) + settle)``.
 */
export interface DRule {
  /**
   * Cap Minutes
   * @min 1
   * @default 10
   */
  cap_minutes?: number;
  /**
   * Settle Minutes
   * @min 0
   * @default 1
   */
  settle_minutes?: number;
  /**
   * Fallback Created Cap Minutes
   * @min 1
   * @default 10
   */
  fallback_created_cap_minutes?: number;
  /**
   * Open Set Horizon Hours
   * @min 1
   * @max 2160
   * @default 72
   */
  open_set_horizon_hours?: number;
}

/**
 * DRunCounters
 * What one D-trigger sweep saw.
 *
 * Two reconciliations, and every application the sweep touched is inside both:
 *
 * * ``counted() == polled`` — every application that got an answer lands in exactly one of
 *   the outcome counters (``not_due`` … ``errors``), so the stored document adds up without
 *   a join.
 * * ``open_set == open_set_accounted()`` — every *candidate the read produced* is either
 *   polled, ``unanswered`` (in budget, no status row: the batch raised, or apps-mgr returned
 *   nothing for it) or ``truncated`` (never asked, beyond the batch budget). Without it a run
 *   whose every batch raised reported ``polled: 0`` and looked like an empty open set.
 *
 * ``batches``, ``batches_failed`` and ``truncated`` describe the poll itself.
 * ``snapshots_written_total``, ``no_autoinvite``, ``late_reconstructed``, ``re_decided``,
 * ``inherited_out_of_pool``, ``rekey_merged``, ``has_mortgage_twin`` and ``mortgage_pending``
 * are counted on top of an outcome rather than instead of one — a snapshot is written on the
 * horizon branch *and* on the FINALIZED and INHERITED ones, and a case re-decided because its
 * owner left the pool is still ``deferred_no_planner`` — so none of them can be an outcome
 * bucket without breaking the first reconciliation.
 */
export interface DRunCounters {
  /**
   * Open Set
   * @default 0
   */
  open_set?: number;
  /**
   * Polled
   * @default 0
   */
  polled?: number;
  /**
   * Unanswered
   * @default 0
   */
  unanswered?: number;
  /**
   * Truncated
   * @default 0
   */
  truncated?: number;
  /**
   * Batches
   * @default 0
   */
  batches?: number;
  /**
   * Batches Failed
   * @default 0
   */
  batches_failed?: number;
  /**
   * Open Set Read Failed
   * @default 0
   */
  open_set_read_failed?: number;
  /**
   * Settings Read Failed
   * @default 0
   */
  settings_read_failed?: number;
  /**
   * Not Due
   * @default 0
   */
  not_due?: number;
  /**
   * Pending Autoinvite
   * @default 0
   */
  pending_autoinvite?: number;
  /**
   * Waiting For Booking
   * @default 0
   */
  waiting_for_booking?: number;
  /**
   * Snapshot At Horizon
   * @default 0
   */
  snapshot_at_horizon?: number;
  /**
   * Deferred Supersede
   * @default 0
   */
  deferred_supersede?: number;
  /**
   * Finalized
   * @default 0
   */
  finalized?: number;
  /**
   * Inherited
   * @default 0
   */
  inherited?: number;
  /**
   * Deferred No Planner
   * @default 0
   */
  deferred_no_planner?: number;
  /**
   * Deferred Unarmed
   * @default 0
   */
  deferred_unarmed?: number;
  /**
   * Deferred Lease
   * @default 0
   */
  deferred_lease?: number;
  /**
   * Planned
   * @default 0
   */
  planned?: number;
  /**
   * Skipped Has Handler
   * @default 0
   */
  skipped_has_handler?: number;
  /**
   * Waiting For Mortgage Coi
   * @default 0
   */
  waiting_for_mortgage_coi?: number;
  /**
   * Waiting For Offer
   * @default 0
   */
  waiting_for_offer?: number;
  /**
   * Lock Unavailable
   * @default 0
   */
  lock_unavailable?: number;
  /**
   * Errors
   * @default 0
   */
  errors?: number;
  /**
   * Snapshots Written Total
   * @default 0
   */
  snapshots_written_total?: number;
  /**
   * No Autoinvite
   * @default 0
   */
  no_autoinvite?: number;
  /**
   * Late Reconstructed
   * @default 0
   */
  late_reconstructed?: number;
  /**
   * Re Decided
   * @default 0
   */
  re_decided?: number;
  /**
   * Inherited Out Of Pool
   * @default 0
   */
  inherited_out_of_pool?: number;
  /**
   * Rekey Merged
   * @default 0
   */
  rekey_merged?: number;
  /**
   * Has Mortgage Twin
   * @default 0
   */
  has_mortgage_twin?: number;
  /**
   * Mortgage Pending
   * @default 0
   */
  mortgage_pending?: number;
  /**
   * Supersedes Repaired
   * @default 0
   */
  supersedes_repaired?: number;
  /**
   * Supersede Markers Unreadable
   * @default 0
   */
  supersede_markers_unreadable?: number;
  /**
   * Decisions Completed
   * @default 0
   */
  decisions_completed?: number;
  /**
   * Decisions Reverted
   * @default 0
   */
  decisions_reverted?: number;
  /**
   * Decisions Evidence Mismatch
   * @default 0
   */
  decisions_evidence_mismatch?: number;
  /**
   * Decisions Unresolved
   * @default 0
   */
  decisions_unresolved?: number;
  /**
   * Decisions Stalled
   * @default 0
   */
  decisions_stalled?: number;
  /**
   * Collisions
   * @default 0
   */
  collisions?: number;
  /**
   * Band Excluded Any
   * @default 0
   */
  band_excluded_any?: number;
  /**
   * Band Empty Ignored
   * @default 0
   */
  band_empty_ignored?: number;
  /**
   * Band Changed Pool
   * @default 0
   */
  band_changed_pool?: number;
  /**
   * Absent Excluded
   * @default 0
   */
  absent_excluded?: number;
  /**
   * Short Circuited Mortgage
   * @default 0
   */
  short_circuited_mortgage?: number;
  /** Rate Improvement Levels */
  rate_improvement_levels?: Record<string, number>;
}

/** DashboardPayload */
export interface DashboardPayload {
  /** User Ids */
  user_ids?: string[] | null;
  /** Sverker Usernames */
  sverker_usernames?: string[] | null;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * End Date
   * @format date-time
   */
  end_date: string;
}

/** Data */
export interface DataInput {
  /** Meeting Id */
  meeting_id?: string | null;
}

/** Data */
export interface DataOutput {
  /** Handler Id */
  handler_id?: string | null;
  /** Creator Id */
  creator_id?: string | null;
  /** Property Id */
  property_id?: string | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** Internal Comment */
  internal_comment?: string | null;
  document?: DocumentAssignation | null;
  /** Customer Id */
  customer_id?: string | null;
  /** Customer Ids */
  customer_ids?: string[] | null;
  /** External Id */
  external_id?: string | null;
  source?: ModelsApplicationMappingApplicationMappingApplicationSource | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
  /**
   * Created From Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  created_from_id?: string | null;
  /** Created From Creator Id */
  created_from_creator_id?: string | null;
  /**
   * Converted From Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  converted_from_id?: string | null;
  /** Lead Id */
  lead_id?: string | null;
  aml?: AMLInsertion | null;
  aml_review?: AMLReviewPayload | null;
  /** Tags */
  tags?: string[] | null;
  /** Mortgage Reviewer Id */
  mortgage_reviewer_id?: string | null;
  /** Free For All */
  free_for_all?: boolean | null;
  /** Free For All Accepted */
  free_for_all_accepted?: boolean | null;
  /** Self Service */
  self_service?: boolean | null;
  /** Mortgage Coi */
  mortgage_coi?: boolean | null;
  /** Accept Actor */
  accept_actor?: string | null;
  /** Accepted Offer Id */
  accepted_offer_id?: string | null;
  /** Accept Request Event Id */
  accept_request_event_id?: string | null;
  manual_application_state?: ManualApplicationState | null;
  /** Online */
  online?: boolean | null;
  resolved_origin?: ResolvedOrigin | null;
  [key: string]: any;
}

/** DayOverride */
export interface DayOverride {
  type: OverrideType;
  /** Date */
  date: string;
  product?: Product | null;
  country?: Country | null;
  /** From Time */
  from_time?: string | null;
  /** To Time */
  to_time?: string | null;
  /** Slots Per Hour */
  slots_per_hour?: number | null;
  /** Comment */
  comment?: string | null;
  /**
   * Override Id
   * @format uuid
   */
  override_id: string;
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Updated By */
  updated_by: string;
}

/**
 * DayOverrideData
 * A one-time, single-day override.
 *
 * Scope is a flexible target via nullable axes (None = wildcard): {global} | {country} |
 * {product, country}. Org-wide closings (holiday/all-hands) are product-agnostic (product is None)
 * and also suppress employee availability; everything product-specific is booker-only.
 */
export interface DayOverrideData {
  type: OverrideType;
  /**
   * Date
   * @format date
   */
  date: string;
  product?: Product | null;
  country?: Country | null;
  /** From Time */
  from_time?: string | null;
  /** To Time */
  to_time?: string | null;
  /** Slots Per Hour */
  slots_per_hour?: number | null;
  /** Comment */
  comment?: string | null;
}

/** DaySlotDoc */
export interface DaySlotDoc {
  /**
   * Day
   * @min 0
   * @max 6
   */
  day: number;
  product: Product;
  country: Country;
  /**
   * Starts At
   * @format date-time
   */
  starts_at: string;
  /** Ends At */
  ends_at?: string | null;
  /** Slots */
  slots: ModelsAdvisorScheduleModelScheduleSlot[];
  /** Id */
  id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id: string;
  /** Request Id */
  request_id: string;
}

/** DaySlotDocPayload */
export interface DaySlotDocPayload {
  /**
   * Day
   * @min 0
   * @max 6
   */
  day: number;
  product: Product;
  country: Country;
  /**
   * Starts At
   * @format date-time
   */
  starts_at: string;
  /** Ends At */
  ends_at?: string | null;
  /** Slots */
  slots: ModelsAdvisorScheduleModelScheduleSlot[];
}

/** DeactivatePayload */
export interface DeactivatePayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  review: DeactivationReview;
}

/** DeactivateUserPayload */
export interface DeactivateUserPayload {
  /** User Id */
  user_id: string;
}

/** DeactivationReview */
export interface DeactivationReview {
  reason: SharedBlancoModelsApplicationDeactivationReason;
  review: ApplicationReview;
}

/** DeactivationReviewsPayload */
export interface DeactivationReviewsPayload {
  country: Country;
}

/** DeactivationReviewsResponse */
export interface DeactivationReviewsResponse {
  /** Reviews */
  reviews: DeactivationReview[];
}

/** Debt */
export interface Debt {
  /** Debt */
  debt?: DebtItem[] | null;
}

/** DebtItem */
export interface DebtItem {
  /** Date */
  date?: string | null;
  /** Type */
  type?: string | null;
  /** Source */
  source?: string | null;
  /** Status */
  status?: string | null;
  /** Saksnr */
  saksnr?: string | null;
  /** Amount */
  amount?: number | null;
  /** Oppgjort */
  oppgjort?: string | null;
  /** Creditor */
  creditor?: string | null;
  /** Art */
  art?: string | null;
  /** Amount Percentage */
  amount_percentage?: number | null;
  /** Currency */
  currency?: string | null;
  /** Code */
  code?: string | null;
}

/** DebtRegisterCompareResponse */
export interface DebtRegisterCompareResponse {
  personal?: Personal;
  peer?: Peer;
}

/** DefaultLanguageResponse */
export interface DefaultLanguageResponse {
  /** Language */
  language?: string | null;
  /** Source */
  source?: "last_translation" | "incoming" | null;
}

/** DialCampaignData */
export interface DialCampaignData {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Source */
  source:
    | ({
        type: "BIG_QUERY";
      } & BigQueryCampaignSource)
    | ({
        type: "PROCESS";
      } & ProcessCampaignSource)
    | ({
        type: "SHEET";
      } & SheetCampaignSourceOutput);
  /** File Id */
  file_id?: string | null;
  exclusion_rules: ExclusionRules;
  /** Daily Extraction Limit */
  daily_extraction_limit?: number | null;
  /**
   * Auto Extraction
   * Time of auto extraction in HH:MM format
   */
  auto_extraction?: string | null;
  /** Comment Template */
  comment_template?: string | null;
  retry_policy: RetryPolicy;
  /** Auto Dial */
  auto_dial?: boolean | null;
  /** Personal Callbacks */
  personal_callbacks?: boolean | null;
  /** No Contact Outcomes */
  no_contact_outcomes?: string[] | null;
  /** Failure Outcomes */
  failure_outcomes?: string[] | null;
  /** Discard Outcomes */
  discard_outcomes?: string[] | null;
  /**
   * Show Call History
   * @default true
   */
  show_call_history?: boolean | null;
  /**
   * Todomaker
   * @default false
   */
  todomaker?: boolean;
  type: CampaignType;
  country: Country;
  /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
  product: ExtendedProduct;
  department?: ZDepartment | null;
  /**
   * Contact Type
   * @default "phone"
   */
  contact_type?: "phone";
  /**
   * Is Prospect Campaign
   * @default false
   */
  is_prospect_campaign?: boolean;
}

/**
 * DialmakerLeadsResponse
 * The customer's PENDING leads in ordinary Dial Maker campaigns, shown under the todomaker lead in
 * the same panel. An empty list means none; a failed read is an error event, never `[]`.
 */
export interface DialmakerLeadsResponse {
  /**
   * Event
   * @default "dialmaker_leads"
   */
  event?: "dialmaker_leads";
  /** Data */
  data: CaseDialmakerLead[];
}

/**
 * DisbursalDatesResponse
 * When each application on a page of the Disbursed list was paid out, by label. No date: no label.
 */
export interface DisbursalDatesResponse {
  /**
   * Event
   * @default "disbursal_dates"
   */
  event?: "disbursal_dates";
  /** Data */
  data: Record<string, string>;
}

/** DisbursedBank */
export interface DisbursedBank {
  /** Bank Id */
  bank_id: number;
  /**
   * Disbursed Date
   * @format date-time
   */
  disbursed_date: string;
  /** Amount */
  amount: number;
}

/** DisbursedLoan */
export interface DisbursedLoan {
  /** Bank Id */
  bank_id: number;
  /**
   * Disbursed Date
   * @format date-time
   */
  disbursed_date: string;
  /** Amount */
  amount: number;
  /** Monthly Payment */
  monthly_payment: number;
  /** Payback Time */
  payback_time: number;
  /** Rate */
  rate: number;
  /** Apr */
  apr: number;
}

/** DisbursementPayload */
export interface DisbursementPayload {
  /** Label */
  label: string;
  /** Bank Id */
  bank_id: number;
  /** External Offer Id */
  external_offer_id?: string | null;
  /** Amount */
  amount?: number | null;
  /** Timestamp */
  timestamp?: string | null;
  /** Offer Id */
  offer_id?: string | null;
  /** Bridgeloanamount */
  bridgeLoanAmount?: number | null;
}

/** Discount */
export interface Discount {
  /** Occupational Pension In Banks */
  occupational_pension_in_banks?: number[] | null;
}

/** Distrainment */
export interface Distrainment {
  /** Registrationtimestamp */
  RegistrationTimestamp?: string | null;
  /** Claimamounts */
  ClaimAmounts?: ClaimAmount[] | null;
  /** Defendants */
  Defendants?: DistrainmentParty[] | null;
  /** Plaintiffs */
  Plaintiffs?: DistrainmentParty[] | null;
  /** Additionaltext */
  AdditionalText?: string | null;
  /** Iscustomerdefendant */
  IsCustomerDefendant?: boolean | null;
}

/** DistrainmentParty */
export interface DistrainmentParty {
  /** Identity */
  Identity?: string | null;
  /** Name */
  Name?: string | null;
}

/** Distrainments */
export interface Distrainments {
  /** Count */
  Count?: number | null;
  /** Totalclaimamount */
  TotalClaimAmount?: number | null;
  /** Hasnonnokclaims */
  HasNonNokClaims?: boolean | null;
  /** Latestregistrationtimestamp */
  LatestRegistrationTimestamp?: string | null;
  /** Items */
  Items?: Distrainment[] | null;
}

/**
 * DistributedApplication
 * One application's value line, as its owner record holds it now.
 */
export interface DistributedApplication {
  /** Application Id */
  application_id: string;
  /** Customer Id */
  customer_id: string | null;
  /** Owner Id */
  owner_id: string;
  /** Case Key */
  case_key: string;
  /** Handler Id */
  handler_id: string;
  /** Handler Name */
  handler_name: string | null;
  /** In Pool */
  in_pool: boolean;
  /**
   * How this record came to be. ``planner`` and ``button`` are the only two that open a
   * case by a distribution decision, which is what the rotation key counts.
   */
  source: OwnerSource;
  /**
   * Owned Since
   * @format date-time
   */
  owned_since: string;
  /**
   * Whether the application's first owner could be read off its history.
   *
   * ``ambiguous`` is more than one record that first held the application — legitimate after a
   * partial supersede recovery, which copies applications without naming the record it copied
   * them from. The row then says so instead of guessing a first owner.
   */
  origin_state: OriginState;
  /** Origin Owner Id */
  origin_owner_id: string | null;
  /** First Handler Id */
  first_handler_id: string | null;
  /** First Handler Name */
  first_handler_name: string | null;
  first_source: OwnerSource | null;
  /** Auto */
  auto: boolean | null;
  /** Moved */
  moved: boolean | null;
  /**
   * Joined At
   * @format date-time
   */
  joined_at: string;
  /** Accounting Day */
  accounting_day: string;
  /** Accounting Week */
  accounting_week: string;
  /** Score */
  score: number;
  /** Amount */
  amount: number;
  /**
   * ``degraded`` is *not* a state but a flag on the line: a value can be both final and
   * degraded.
   */
  value_state: ValueState;
  /** Degraded */
  degraded: boolean;
  /** Out Of Pool */
  out_of_pool: boolean;
  /** Counts In Totals */
  counts_in_totals: boolean;
}

/** DistributionCalendar */
export interface DistributionCalendar {
  /** Enabled */
  enabled: boolean;
  /**
   * Date From
   * @format date
   */
  date_from: string;
  /**
   * Date To
   * @format date
   */
  date_to: string;
  /** Handlers */
  handlers: HandlerCalendar[];
}

/**
 * DistributionDashboard
 * Rows and totals from one read, so the two can never disagree.
 */
export interface DistributionDashboard {
  /** Enabled */
  enabled: boolean;
  /**
   * Date From
   * @format date
   */
  date_from: string;
  /**
   * Date To
   * @format date
   */
  date_to: string;
  /** Rows */
  rows: DistributedApplication[];
  /** Handlers */
  handlers: HandlerTotal[];
}

/** DocRequest */
export interface DocRequest {
  /** Customer Id */
  customer_id?: string | null;
  /** Type */
  type: DocumentType | string;
  /** Status */
  status: "RECEIVED" | "REQUESTED" | "APPROVED" | "DECLINED" | "WITHDRAWN";
  /** Document Id */
  document_id?: string | null;
  /** Comment */
  comment?: string | null;
}

/** Document */
export interface Document {
  /** Document Id */
  document_id: string;
  /** Customer Id */
  customer_id: string;
}

/** DocumentAssignation */
export interface DocumentAssignation {
  /** Customer Id */
  customer_id: string;
  /** Document Id */
  document_id: string;
}

/** DocumentCreate */
export interface DocumentCreate {
  /**
   * Name
   * Name of the document
   */
  name: string;
  /**
   * Mime Type
   * MIME type of the document
   */
  mime_type: string;
  /**
   * Document Type
   * The type of document you're uploading, will be used as key on the customer
   */
  document_type: string;
  /**
   * Customer Id
   * ID of the customer to attach the document to
   * @format uuid
   */
  customer_id: string;
  /**
   * Data
   * Base64 encoded data of the document
   */
  data: string;
}

/** DocumentMeta */
export interface DocumentMeta {
  /**
   * Name
   * Name of the document
   */
  name: string;
  /**
   * Mime Type
   * MIME type of the document
   */
  mime_type: string;
  /**
   * Document Type
   * The type of document you're uploading, will be used as key on the customer
   */
  document_type: string;
  /**
   * Document Id
   * ID of the document
   * @format uuid
   */
  document_id: string;
  /**
   * Customer Id
   * ID of the customer to attach the document to
   * @format uuid
   */
  customer_id: string;
  /**
   * Timestamp
   * Document creation time
   * @format date-time
   */
  timestamp: string;
}

/** DocumentShare */
export interface DocumentShare {
  /** Bank Id */
  bank_id: number;
  /**
   * Application Id
   * The application the bank sees the document on. None on a share written without one, which counts for the document's own application_id
   */
  application_id?: string | null;
  /**
   * Shared At
   * @format date-time
   */
  shared_at: string;
  /** Shared By */
  shared_by: string;
}

/** DocumentToBank */
export interface DocumentToBank {
  /** Documents */
  documents: Document[];
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Bank Id */
  bank_id: number;
}

/** DoneBody */
export interface DoneBody {
  /**
   * Seen Message Count
   * The message_count of the item as the client last read it
   * @min 1
   */
  seen_message_count: number;
}

/** DownloadInfo */
export interface DownloadInfo {
  /**
   * Downloaded At
   * @format date-time
   */
  downloaded_at: string;
  /** File Path */
  file_path: string;
  /** File Size */
  file_size: number;
  /** Duration Seconds */
  duration_seconds?: number | null;
}

/** DraftWarning */
export interface DraftWarning {
  check: DraftCheck;
  /** Value */
  value: string;
}

/** DuplicateApplicationPayload */
export interface DuplicateApplicationPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * Swap Applicants
   * @default false
   */
  swap_applicants?: boolean;
}

/** DuplicateFormPreferencePayload */
export interface DuplicateFormPreferencePayload {
  /** Form Id */
  form_id: string;
  product: Product;
  country: Country;
  /** Copy From Preference Id */
  copy_from_preference_id: string;
}

/** DynamicMetaParams */
export interface DynamicMetaParams {
  /**
   * Name
   * Name of the tag and what keyword to replace or to be used as key in query parameter
   */
  name: string;
  /**
   * Where to place the meta tag, either in the path or as a query parameter
   * @default "query"
   */
  placement?: DynamicMetaParamsPlacement;
  value_name: DynamicMetaParamsValues;
}

/** EditUser */
export interface EditUser {
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Username
   * @format email
   */
  username: string;
  /** Banks */
  banks: IntegrationId[];
}

/** Elk46CallResponse */
export interface Elk46CallResponse {
  /** Connect */
  connect: string;
}

/** Email */
export interface Email {
  country?: Country | null;
  /**
   * Email
   * @format email
   */
  email: string;
}

/**
 * EmailDetail
 * Full email content including decrypted body.
 */
export interface EmailDetail {
  /** Email Id */
  email_id: string;
  /** Customer Id */
  customer_id: string | null;
  /** Thread Id */
  thread_id: string;
  /** Lead Id */
  lead_id?: string | null;
  /** Application Id */
  application_id?: string | null;
  /** Direction */
  direction: string;
  /** From Email */
  from_email: string;
  /** To Email */
  to_email: string;
  /** Subject */
  subject: string;
  /** Body Html */
  body_html?: string | null;
  /** Body Text */
  body_text?: string | null;
  /** Attachments */
  attachments?: Record<string, any>[];
  /** Mandrill Id */
  mandrill_id?: string | null;
  /** In Reply To */
  in_reply_to?: string | null;
  /** References */
  references?: string[];
  /** Status */
  status: string;
  /** Agent Id */
  agent_id?: string | null;
  /** Country */
  country?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Read At */
  read_at?: string | null;
  /** Request Id */
  request_id?: string | null;
}

/** EmailGetCustomerPayload */
export interface EmailGetCustomerPayload {
  /** Reason */
  reason: string;
  /**
   * Email
   * @format email
   */
  email: string;
}

/** EmailReceived */
export interface EmailReceived {
  /** Type */
  type: "EMAIL_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: EmailReceivedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** EmailReceivedData */
export interface EmailReceivedData {
  /** Thread Id */
  thread_id: string;
  /** Email Id */
  email_id: string;
  /** Customer Id */
  customer_id?: string | null;
  /** Application Id */
  application_id?: string | null;
  product?: Product | null;
  /** From Email */
  from_email?: string | null;
  /** Subject */
  subject?: string | null;
  /** Messaging Center Item Id */
  messaging_center_item_id?: string | null;
}

/**
 * EmailSummary
 * Lightweight email representation for list views — no body content.
 */
export interface EmailSummary {
  /** Email Id */
  email_id: string;
  /** Customer Id */
  customer_id?: string | null;
  /** Thread Id */
  thread_id: string;
  /** Direction */
  direction: string;
  /** From Email */
  from_email: string;
  /** To Email */
  to_email: string;
  /** Subject */
  subject: string;
  /** Status */
  status: string;
  /**
   * Attachments Count
   * @default 0
   */
  attachments_count?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Read At */
  read_at?: string | null;
  /** Agent Id */
  agent_id?: string | null;
  /** Lead Id */
  lead_id?: string | null;
  /** Application Id */
  application_id?: string | null;
}

/** EmailTemplate */
export interface EmailTemplate {
  event: TemplateEvent;
  product: ExtendedProduct | null;
  country: Country;
  /** @default "EMAIL" */
  message_type?: MessageType;
  /**
   * Timestamp
   * @format date-time
   * @default "2026-11-02T12:01:32.153860Z"
   */
  timestamp?: string;
  /** Comment */
  comment?: string | null;
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean | null;
  /** Name */
  name?: string | null;
  /** Use Tracking Urls */
  use_tracking_urls?: boolean | null;
  /** Link Vars */
  link_vars?: string[] | null;
  /** Link Vars Checked At */
  link_vars_checked_at?: string | null;
  /**
   * Allow Reply
   * @default true
   */
  allow_reply?: boolean | null;
  /** Mandrill Name */
  mandrill_name: string | null;
  /** Subject */
  subject: string;
  /**
   * Use Comment Subject
   * @default false
   */
  use_comment_subject?: boolean | null;
  /** From Name */
  from_name?: string | null;
  /** From Email */
  from_email?: string | null;
  /** Reply To */
  reply_to?: string | null;
  /** Attachment Ids */
  attachment_ids?: string[] | null;
  /** Template Text Body */
  template_text_body?: string | null;
}

/**
 * EmailVerification
 * The customer's current email verification status, aggregated from EMAIL_VERIFICATION events.
 *
 * A customer has at most one status at a time; a newer event replaces the whole object.
 */
export interface EmailVerification {
  status: EmailStatusOutput;
  source: EmailStatusSource;
  /**
   * Detail
   * Raw signal: EmailListVerify token or Mandrill status
   */
  detail?: string | null;
  /**
   * Email
   * The address this verdict applies to
   */
  email: string;
  /**
   * Verified At
   * When the signal occurred
   * @format date-time
   */
  verified_at: string;
  /**
   * Exhausted Attempts
   * True if the verification was retried and failed 3 times in a row
   * @default false
   */
  exhausted_attempts?: boolean;
}

/** Employee */
export interface Employee {
  /** Email */
  email?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Zoordinates */
  zoordinates: Zoordinates[];
  /** Phone Number */
  phone_number?: string | null;
  /** Telavox Ids */
  telavox_ids?: string[] | null;
  /** Sverker Usernames */
  sverker_usernames?: SverkerUsername[] | null;
  /** Roles */
  roles: RoleType[];
  /** User Id */
  user_id: string;
  /** Avatar */
  avatar: string;
  /**
   * Deactivated
   * @default false
   */
  deactivated?: boolean;
  /** Last Login */
  last_login?: string | null;
  /** Created At */
  created_at?: string | null;
}

/** EmployerNO */
export interface EmployerNO {
  /** Name */
  name: string;
  type: EmploymentTypeNO;
  /**
   * Start Date
   * @format date
   */
  start_date: string;
  /** End Date */
  end_date?: string | null;
  /** Phone */
  phone?: string | null;
  /** Retirement Age */
  retirement_age?: number | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Profession */
  profession?: string | null;
  /** Monthly Other Income */
  monthly_other_income?: number | null;
}

/** EmployerSE */
export interface EmployerSE {
  /** Name */
  name: string;
  type: EmploymentTypeSE;
  /**
   * Start Date
   * @format date
   */
  start_date: string;
  /** End Date */
  end_date?: string | null;
  /** Phone */
  phone?: string | null;
  /** Retirement Age */
  retirement_age?: number | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Profession */
  profession?: string | null;
  /** Monthly Other Income */
  monthly_other_income?: number | null;
}

/** EmptyModel */
export type EmptyModel = object;

/** EnqueuedSubmissionJobResult */
export interface EnqueuedSubmissionJobResult {
  /** Submission Id */
  submission_id: string;
  status: EnqueuedJobStatus;
  checklist?: Checklist | null;
}

/** EnumDescription */
export interface EnumDescription {
  /**
   * Value
   * The value of the enum
   */
  value: string | number;
  /**
   * En Label
   * The English label of the enum
   */
  en_label: string;
  /**
   * Sv Label
   * The Swedish label of the enum
   */
  sv_label: string;
  /**
   * Nb Label
   * The Norwegian label of the enum
   */
  nb_label: string;
}

/** EstateTypeType */
export interface EstateTypeType {
  /** Description */
  Description?: string | null;
  /** Key */
  Key?: string | null;
}

/** EvCheckPayload */
export interface EvCheckPayload {
  /** Pnis */
  pnis: string[];
  /** Reason */
  reason: string;
}

/** EvEstate */
export interface EvEstate {
  /** External Id */
  external_id?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Number */
  municipality_number?: number | null;
  /** Cadastralunitnumber */
  cadastralUnitNumber?: number | null;
  /** Unitnumber */
  unitNumber?: number | null;
  /** Leaseholdunitnumber */
  leaseholdUnitNumber?: number | null;
  /** Sectionnumber */
  sectionNumber?: number | null;
  /** Apartmentreference */
  apartmentReference?: string | null;
  /** Organizationnumber */
  organizationNumber?: string | null;
  /** Estimatedvalue */
  estimatedValue?: number | null;
  /** Commondebt */
  commonDebt?: number | null;
  /** Estatetype */
  estateType?: string | null;
  address?: EvEstateAddress | null;
}

/** EvEstateAddress */
export interface EvEstateAddress {
  /** Streetname */
  streetName?: string | null;
  /** Streetnumber */
  streetNumber?: number | null;
  /** Streetletter */
  streetLetter?: string | null;
  /** Postcodearea */
  postCodeArea?: string | null;
  /** Postcode */
  postCode?: string | null;
}

/** EvFirstResponse */
export interface EvFirstResponse {
  /**
   * Properties
   * Properties that has been mapped and formatted to be customer facing
   */
  properties: (PartialHouse | PartialCondominium | PartialVacationHome)[];
  customer: ApplicantNO;
}

/** EvPartialCommon */
export interface EvPartialCommon {
  /** Area Market Score */
  area_market_score?: number | null;
  /** Municipality Score */
  municipality_score?: number | null;
  /** Net Value Estimate */
  net_value_estimate?: number | null;
  /** Last Known Common Debt */
  last_known_common_debt?: number | null;
  /** Cadastral Unit Number */
  cadastral_unit_number?: number | null;
  /** Unit Number */
  unit_number?: number | null;
  /** Leasehold Unit Number */
  leasehold_unit_number?: number | null;
  /** Section Number */
  section_number?: number | null;
}

/** EvProperty */
export interface EvProperty {
  info: Info;
  /** Mortgages */
  mortgages?: Mortgage[] | null;
  value?: Value | null;
  price_index?: PriceIndex | null;
  attributes?: Attributes | null;
  ownership?: Ownership | null;
  distrainments?: Distrainments | null;
  /** Source */
  source?: "SOAP" | "REST" | null;
}

/** EventData */
export interface EventData {
  trigger?: CancellationTrigger | null;
  /** Mailid */
  mailId?: string | null;
  /** Rejectreason */
  rejectReason?: string | null;
  /** Successful */
  successful?: boolean | null;
  /** Signupurl */
  signupUrl?: string | null;
  /** Amount */
  amount?: string | null;
  /**
   * Winbacked
   * If the insurance has been winbacked
   */
  winbacked?: boolean | null;
  /**
   * Response
   * If the customer responded for a winbackable insurance
   */
  response?: boolean | null;
  /**
   * Comment
   * The comment for the winbackable insurance
   */
  comment?: string | null;
  /** Newmandateurl */
  newMandateUrl?: string | null;
  /** Handled */
  handled?: boolean | null;
  contactSource?: ContactSource | null;
  /** Reason */
  reason?: string | null;
  /** Scheduleddate */
  scheduledDate?: string | null;
  /** Queuedat */
  queuedAt?: string | null;
  /** Winbackableat */
  winbackableAt?: string | null;
  /** Removedat */
  removedAt?: string | null;
  /**
   * Note
   * Free text note from agent
   */
  note?: string | null;
  [key: string]: any;
}

/** EventsResponse */
export interface EventsResponse {
  /** Integrations */
  integrations: BankCommunication[];
}

/** ExclusionRules */
export interface ExclusionRules {
  /**
   * Global Extraction Policy Days
   * days to exclude lead since last extraction
   * @default 30
   */
  global_extraction_policy_days?: number | null;
  /**
   * Local Extraction Policy Days
   * days to exclude lead for same campaign extraction
   * @default 30
   */
  local_extraction_policy_days?: number | null;
  /**
   * Global Contact Policy Days
   * days since customer was contacted in any campaign
   * @default 90
   */
  global_contact_policy_days?: number | null;
  /**
   * Local Contact Policy Days
   * days since customer was contacted in same campaign
   * @default 90
   */
  local_contact_policy_days?: number | null;
  /**
   * Local Contact Policy Hours
   * hours since customer was contacted in same campaign
   */
  local_contact_policy_hours?: number | null;
  /**
   * Global Contact Policy Hours
   * hours since customer was contacted in any campaign
   */
  global_contact_policy_hours?: number | null;
  /** Exclude Blocked Numbers */
  exclude_blocked_numbers?: boolean | null;
  /** Exclude Blocked Customers */
  exclude_blocked_customers?: boolean | null;
  /** Exclude Blocked Pnis */
  exclude_blocked_pnis?: boolean | null;
  reservation_register_policy?: PolicyPreference | null;
  marketing_consent_policy?: ConsentsPolicyPreference | null;
}

/** ExternalBlockCheckNO */
export interface ExternalBlockCheckNO {
  /** Email */
  email?: boolean | null;
  /** Phone */
  phone?: boolean | null;
  /** Humanitarian */
  humanitarian?: boolean | null;
}

/** ExternalProperty */
export interface ExternalPropertyInput {
  /** Estimatedvalue */
  estimatedValue?: number | null;
  /** Marketvalueuc */
  marketValueUC?: number | null;
  /** Marketvaluebooli */
  marketValueBooli?: number | null;
  propertyType?: SharedMortgageSeSpecCommonDefinitionsPropertyType | null;
  /** Otherowner */
  otherOwner?: boolean | null;
  /** Housecadastraldesignation */
  houseCadastralDesignation?: string | null;
  /** Housingmonthlycost */
  housingMonthlyCost?: number | null;
  /** Squaremeters */
  squareMeters?: number | null;
  /** Rooms */
  rooms?: number | null;
  /** Newproduction */
  newProduction?: boolean | null;
  /** Firstowner */
  firstOwner?: boolean | null;
  address: OptionalPropertyAddress;
  condominium?: CondominiumInput | null;
  /** External Id */
  external_id?: string | null;
}

/** ExternalProperty */
export interface ExternalPropertyOutput {
  /** Estimatedvalue */
  estimatedValue?: number | null;
  /** Marketvalueuc */
  marketValueUC?: number | null;
  /** Marketvaluebooli */
  marketValueBooli?: number | null;
  propertyType?: SharedMortgageSeSpecCommonDefinitionsPropertyType | null;
  /** Otherowner */
  otherOwner?: boolean | null;
  /** Housecadastraldesignation */
  houseCadastralDesignation?: string | null;
  /** Housingmonthlycost */
  housingMonthlyCost?: number | null;
  /** Squaremeters */
  squareMeters?: number | null;
  /** Rooms */
  rooms?: number | null;
  /** Newproduction */
  newProduction?: boolean | null;
  /** Firstowner */
  firstOwner?: boolean | null;
  address: OptionalPropertyAddress;
  condominium?: SharedMortgageSeSpecCommonDefinitionsCondominium | null;
  /** External Id */
  external_id?: string | null;
}

/**
 * ExternalSourcePayload
 * External source payload model used to pass the data from external source.
 */
export interface ExternalSourcePayload {
  /** External source id, must be valid id from allowed external sources to prospects be upserted */
  source_id: string;
  country: Country;
  /** Prospects */
  prospects: ProspectDataExtended[];
  /** Global consents for all prospects (if not provided, then consents from each prospect will be used) */
  global_consents?: Consents | null;
  /** Global valid until for all prospects (if not provided, then valid until from each prospect will be used) */
  global_valid_until?: string | null;
}

/**
 * ExternalSourceResponse
 * External source response model used to pass the data from external source.
 */
export interface ExternalSourceResponse {
  /** Total number of prospects provided in the request */
  provided_prospects: number;
  /** Total number of prospects which were successfully upserted */
  validated: number;
  /**
   * Insertion status of the prospects. Possible values: NOT_STARTED, IN_PROGRESS, PARTIALLY_FAILED, FAILED, COMPLETED. Indicates whether the insertion is finished, in progress, partially failed, failed, or completed.
   * @default "NOT_STARTED"
   */
  insertion_status?: SharedModelsProspectsProspectsUpsertJobsImportStatus;
  /** Total number of prospects which were successfully inserted */
  inserted: number;
  /**
   * List of failed prospects which were not upserted with error message
   * @default []
   */
  validation_failed?: ProspectsFailed[];
}

/** ExternallyVerifiedCredit */
export interface ExternallyVerifiedCreditInput {
  /**
   * Balance
   * Current balance of the credit excluding interest bearing and non-interest bearing balance.E.g for a blanco loan with a defined repayment time
   */
  balance?: number | null;
  /** Credittype */
  creditType?: string | null;
  /** Creditlimit */
  creditLimit?: number | null;
  /** @default "NOK" */
  currency?: Currency | null;
  /** Dataold */
  dataOld?: boolean | null;
  /** Financialinstitutionid */
  financialInstitutionId?: string | null;
  /** Financialinstitutionname */
  financialInstitutionName?: string | null;
  /** Gjeldsregisteret Type */
  gjeldsregisteret_type?: string | null;
  /** Hascoborrower */
  hasCoBorrower?: boolean | null;
  /** How often a charge occur. It is defined in Gjeldsregisteret documentation and api,however it is ALWAYS MONTHLY according to Gjeldsregisteret representatives... */
  installmentChargePeriod?: InstallmentChargePeriod | null;
  /**
   * Installmentcharges
   * Monthly fees for the credit
   */
  installmentCharges?: number | null;
  /**
   * Noninterestbearingbalance
   * Non-interest bearing balance of the credit, e.g for a credit card
   */
  nonInterestBearingBalance?: number | null;
  /**
   * Interestbearingbalance
   * Interest bearing balance of the credit, e.g for a credit card
   */
  interestBearingBalance?: number | null;
  /** Iscoborrower */
  isCoBorrower?: boolean | null;
  /** Nominalinterestrate */
  nominalInterestRate?: number | null;
  /**
   * Originalbalance
   * Original balance of the credit when it was taken
   */
  originalBalance?: number | null;
  /** Processedtime */
  processedTime?: string | null;
  /** Receivedtime */
  receivedTime?: string | null;
  /**
   * Terms
   * Number of terms left for the credit
   */
  terms?: number | null;
}

/** ExternallyVerifiedCredit */
export interface ExternallyVerifiedCreditOutput {
  /**
   * Balance
   * Current balance of the credit excluding interest bearing and non-interest bearing balance.E.g for a blanco loan with a defined repayment time
   */
  balance?: number | null;
  /** Credittype */
  creditType?: string | null;
  /** Creditlimit */
  creditLimit?: number | null;
  /** @default "NOK" */
  currency?: Currency | null;
  /** Dataold */
  dataOld?: boolean | null;
  /** Financialinstitutionid */
  financialInstitutionId?: string | null;
  /** Financialinstitutionname */
  financialInstitutionName?: string | null;
  /** Gjeldsregisteret Type */
  gjeldsregisteret_type?: string | null;
  /** Hascoborrower */
  hasCoBorrower?: boolean | null;
  /** How often a charge occur. It is defined in Gjeldsregisteret documentation and api,however it is ALWAYS MONTHLY according to Gjeldsregisteret representatives... */
  installmentChargePeriod?: InstallmentChargePeriod | null;
  /**
   * Installmentcharges
   * Monthly fees for the credit
   */
  installmentCharges?: number | null;
  /**
   * Noninterestbearingbalance
   * Non-interest bearing balance of the credit, e.g for a credit card
   */
  nonInterestBearingBalance?: number | null;
  /**
   * Interestbearingbalance
   * Interest bearing balance of the credit, e.g for a credit card
   */
  interestBearingBalance?: number | null;
  /** Iscoborrower */
  isCoBorrower?: boolean | null;
  /** Nominalinterestrate */
  nominalInterestRate?: number | null;
  /**
   * Originalbalance
   * Original balance of the credit when it was taken
   */
  originalBalance?: number | null;
  /** Processedtime */
  processedTime?: string | null;
  /** Receivedtime */
  receivedTime?: string | null;
  /**
   * Terms
   * Number of terms left for the credit
   */
  terms?: number | null;
  /** Monthly Payment */
  monthly_payment: number;
  /** Total Debt */
  total_debt: number;
}

/** ExternallyVerifiedCreditWithRole */
export interface ExternallyVerifiedCreditWithRole {
  /**
   * Balance
   * Current balance of the credit excluding interest bearing and non-interest bearing balance.E.g for a blanco loan with a defined repayment time
   */
  balance?: number | null;
  /** Credittype */
  creditType?: string | null;
  /** Creditlimit */
  creditLimit?: number | null;
  /** @default "NOK" */
  currency?: Currency | null;
  /** Dataold */
  dataOld?: boolean | null;
  /** Financialinstitutionid */
  financialInstitutionId?: string | null;
  /** Financialinstitutionname */
  financialInstitutionName?: string | null;
  /** Gjeldsregisteret Type */
  gjeldsregisteret_type?: string | null;
  /** Hascoborrower */
  hasCoBorrower?: boolean | null;
  /** How often a charge occur. It is defined in Gjeldsregisteret documentation and api,however it is ALWAYS MONTHLY according to Gjeldsregisteret representatives... */
  installmentChargePeriod?: InstallmentChargePeriod | null;
  /**
   * Installmentcharges
   * Monthly fees for the credit
   */
  installmentCharges?: number | null;
  /**
   * Noninterestbearingbalance
   * Non-interest bearing balance of the credit, e.g for a credit card
   */
  nonInterestBearingBalance?: number | null;
  /**
   * Interestbearingbalance
   * Interest bearing balance of the credit, e.g for a credit card
   */
  interestBearingBalance?: number | null;
  /** Iscoborrower */
  isCoBorrower?: boolean | null;
  /** Nominalinterestrate */
  nominalInterestRate?: number | null;
  /**
   * Originalbalance
   * Original balance of the credit when it was taken
   */
  originalBalance?: number | null;
  /** Processedtime */
  processedTime?: string | null;
  /** Receivedtime */
  receivedTime?: string | null;
  /**
   * Terms
   * Number of terms left for the credit
   */
  terms?: number | null;
  role: ApplicantRole;
  /** Monthly Payment */
  monthly_payment: number;
  /** Total Debt */
  total_debt: number;
}

/**
 * FactorHealth
 * How complete the value model's inputs were, per factor.
 *
 * ``degraded`` is the snapshot flag — at least one factor fell to its ``missing`` level —
 * and ``missing_by_factor`` the breakdown behind it, derived from the snapshot's own stored
 * fields rather than a second set of counters that could disagree with the evidence. The
 * rate-improvement factor is deliberately outside ``degraded`` (absent for most of the
 * population, it would swamp the flag), so its level distribution stands on its own.
 */
export interface FactorHealth {
  /**
   * Snapshots
   * @default 0
   */
  snapshots?: number;
  /**
   * Degraded
   * @default 0
   */
  degraded?: number;
  /** Missing By Factor */
  missing_by_factor?: Record<string, number>;
  /** Rate Improvement Levels */
  rate_improvement_levels?: Record<string, number>;
}

/**
 * FactorMultipliers
 * One factor: its levels, the numbers, and how a raw value becomes a level.
 */
export interface FactorMultipliers {
  /**
   * The factors of ``v_t = amount x product(multipliers)``.
   *
   * ``RATE_IMPROVEMENT`` is the only one that is a *comparison* rather than a lookup: does
   * the best bid at D beat what the customer already pays? It joined after version 1 was
   * seeded, which is why it is the one factor a stored document may be missing (see
   * :data:`NEUTRAL_OPTIONAL_FACTORS`).
   */
  factor: ValueFactor;
  /** Source Field */
  source_field: string;
  /** Source Fields */
  source_fields?: string[] | null;
  /** Cohort */
  cohort: string;
  /** Fitted On */
  fitted_on: string;
  /** Levels */
  levels: Record<string, number>;
  /** Cut Points */
  cut_points?: number[] | null;
  /**
   * Sentinel Max
   * @default 0
   */
  sentinel_max?: number;
  /** Bucket Edges */
  bucket_edges?: number[] | null;
  /** Pp Thresholds */
  pp_thresholds?: number[] | null;
}

/** FailedVariable */
export interface FailedVariable {
  /** Name */
  name: string;
  /** Amount */
  amount: number;
}

/** FieldMapping */
export interface FieldMapping {
  /** Lead Field */
  lead_field: string;
  /** Jotform Field */
  jotform_field: string;
  /** Options Map */
  options_map?: [string, string][] | null;
}

/** FieldMappingExt */
export interface FieldMappingExt {
  /** Lead Field */
  lead_field: string;
  /** Jotform Field */
  jotform_field: string;
  /** Options Map */
  options_map?: [string, string][] | null;
  /** Error */
  error?: string | null;
}

/**
 * FileDetails
 * File details model used to pass the file details from external source.
 */
export interface FileDetails {
  /** File ID of the uploaded file */
  file_id: string;
  /** File name of the uploaded file */
  file_name: string;
  /** File size of the uploaded file in bytes */
  file_size: number;
  /**
   * Date when file was uploaded
   * @format date-time
   */
  uploaded_at: string;
  /** Date when data from file was imported */
  imported_at?: string | null;
  /** Total number of prospects which were successfully inserted */
  inserted_count: number;
  /** True if phone numbers were mapped */
  phone?: boolean | null;
  /** True if emails were mapped */
  email?: boolean | null;
  /**
   * Insertion ID of the file
   * ID of the insertion job created for the file, used to track the import status
   */
  insertion_id?: string | null;
  /**
   * Country of the prospects
   * Country of the prospects, used to determine the country code for phone numbers
   */
  country?: Country | null;
  /**
   * Import status of the file
   * Import status of the file, can be NOT_STARTED, IN_PROGRESS, COMPLETED, PARTIALLY_FAILED, FAILED
   */
  import_status?: SharedModelsProspectsProspectsUpsertJobsImportStatus | null;
  /**
   * Number of insertion jobs created for the file
   * Number of insertion jobs created for the file
   */
  inserted_in_jobs?: number | null;
  /**
   * Total number of jobs scheduled for the file
   * Total number of jobs scheduled for the file, can be used to calculate progress
   */
  total_jobs?: number | null;
  /**
   * Date until the prospects from the file are valid
   * Date until prospects from the file are valid, after this date the prospects will be anonymized
   */
  valid_until?: string | null;
  /**
   * Results of the insertion job
   * Results of the insertion job, contains number of inserted prospects in given job
   */
  results?: Record<string, number> | null;
}

/** Filter */
export interface Filter {
  product?: ExtendedProduct | null;
  country?: Country | null;
  department?: ZDepartment | null;
  /** Active */
  active?: boolean | null;
  /** Creator Id */
  creator_id?: string | null;
  /** Campaign Ids */
  campaign_ids?: string[] | null;
  /** Extraction Id */
  extraction_id?: string | null;
  /** Exported Extraction Id */
  exported_extraction_id?: string | null;
  /** Reservation Register Policy */
  reservation_register_policy?: PolicyPreference[] | null;
  /** Campaign Types */
  campaign_types?: CampaignType[] | null;
  contact_type?: ModelsDialMaker2CampaignDataModelsContactType | null;
  /** Process */
  process?: ProcessCampaignType[] | null;
  /** Auto Extraction Enabled */
  auto_extraction_enabled?: boolean | null;
}

/** FilterCustomer */
export interface FilterCustomer {
  /** Customer Id */
  customer_id: string;
  /** Name */
  name: string;
}

/** FilteringResult */
export interface FilteringResult {
  /** Reason */
  reason: string;
  /** Number Of Leads Before Filtering */
  number_of_leads_before_filtering: number;
  /** Number Of Leads After Filtering */
  number_of_leads_after_filtering: number;
  filtering_reason: FilteringReason;
}

/** FleetSummary */
export interface FleetSummary {
  /**
   * Vehicle Count
   * @default 0
   */
  vehicle_count?: number;
  /**
   * Combined Average Value Nok
   * @default 0
   */
  combined_average_value_nok?: number;
  combined_range_nok?: MoneyRange;
}

/** Form */
export interface Form {
  /** Name */
  name: string;
  /** Form Id */
  form_id: string;
  /** Preferences */
  preferences: string[];
}

/** FormApplicationSubmissionResult */
export interface FormApplicationSubmissionResult {
  /** Ok */
  ok: boolean;
  /** Submission Id */
  submission_id: string;
}

/** FormCredit */
export interface FormCredit {
  /**
   * Amount
   * @exclusiveMin 0
   */
  amount: number;
  /**
   * Bankname
   * Bank ID
   */
  bankName: number;
  /**
   * Loantype
   * Loan type ID
   */
  loanType: number;
  /**
   * Monthlycost
   * @min 0
   */
  monthlyCost: number;
  /** Rate */
  rate?: number | null;
  /** Owner */
  owner?: string | null;
}

/** FormMapping */
export interface FormMapping {
  /** Lead Fields */
  lead_fields: LeadField[];
  /** Jotform Fields */
  jotform_fields: JotformField[];
  /** Mapping */
  mapping: FieldMappingExt[];
}

/** FormPreference */
export interface FormPreference {
  /** Form Preference Id */
  form_preference_id: string;
  /** Jotform Id */
  jotform_id: string;
  product: Product;
  country: Country;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Deactivation Date */
  deactivation_date?: string | null;
  /**
   * Mapping
   * @default []
   */
  mapping?: FieldMapping[];
}

/** FormPreferenceExt */
export interface FormPreferenceExt {
  /** Form Preference Id */
  form_preference_id: string;
  /** Jotform Id */
  jotform_id: string;
  product: Product;
  country: Country;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Deactivation Date */
  deactivation_date?: string | null;
  /**
   * Mapping
   * @default []
   */
  mapping?: FieldMappingExt[];
  /**
   * Valid
   * @default false
   */
  valid?: boolean;
  /** Unmapped */
  unmapped?: string[] | null;
  /**
   * Form Name
   * @default ""
   */
  form_name?: string;
  /**
   * Has Webhook
   * @default false
   */
  has_webhook?: boolean;
}

/** FormPreferencePayload */
export interface FormPreferencePayload {
  /** Form Id */
  form_id: string;
  product: Product;
  country: Country;
  /** Mapping */
  mapping: FieldMapping[];
}

/** FormWebhookPayload */
export interface FormWebhookPayload {
  /** Preference Id */
  preference_id: string;
}

/** FreeForAllPayload */
export interface FreeForAllPayload {
  /** Free For All */
  free_for_all: boolean;
}

/** FullApplicationsHistoryResponse */
export interface FullApplicationsHistoryResponse {
  /**
   * Event
   * @default "full_applications_history"
   */
  event?: "full_applications_history";
  /** Data */
  data: (
    | (
        | ({
            country: "NO";
          } & RawBlancoApplicationNO)
        | ({
            country: "SE";
          } & RawBlancoApplicationSE)
      )
    | RawCreditCardApplicationNO
    | (
        | ({
            country: "NO";
          } & RawMortgageApplicationNO)
        | ({
            country: "SE";
          } & RawMortgageApplicationSE)
      )
  )[];
  /**
   * Origin By Label
   * @default {}
   */
  origin_by_label?: Record<string, ResolvedOrigin>;
  /**
   * Manual State By Label
   * @default {}
   */
  manual_state_by_label?: Record<string, ManualApplicationState>;
}

/** GeneralMessage */
export interface GeneralMessage {
  /** Type */
  type: "GENERAL_MESSAGE_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: GeneralMessageData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** GeneralMessageData */
export interface GeneralMessageData {
  /** Message */
  message: string;
  product?: Product | null;
}

/** GetApplicationMessagesPayload */
export interface GetApplicationMessagesPayload {
  /**
   * Limit
   * @exclusiveMin 0
   * @exclusiveMax 101
   * @default 50
   */
  limit?: number;
  /**
   * Page
   * @min 0
   * @default 0
   */
  page?: number;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
}

/** GetApplicationPayload */
export interface GetApplicationPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
}

/** GetApplications */
export interface GetApplications {
  /**
   * Page
   * @min 0
   */
  page: number;
  /**
   * Limit
   * @min 0
   */
  limit: number;
  product?: Product | null;
  country?: Country | null;
  /** Bank Statuses */
  bank_statuses?: SharedModelsStatusBankStatus[] | null;
  /** Loan Purposes */
  loan_purposes?: MortgageLoanType[] | null;
}

/** GetApplicationsByApplicantIdentifierPayload */
export interface GetApplicationsByApplicantIdentifierPayload {
  /**
   * Text
   * @default ""
   */
  text?: string;
}

/** GetApplicationsByCustomerIdentifierPayload */
export interface GetApplicationsByCustomerIdentifierPayload {
  country?: Country | null;
  product?: Product | null;
  /** Pni */
  pni?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Email */
  email?: string | null;
  pagination?: Pagination | null;
}

/** GetApplicationsByCustomerIdentifierPayloadV2 */
export interface GetApplicationsByCustomerIdentifierPayloadV2 {
  country?: Country | null;
  product?: Product | null;
  /** Customer Id */
  customer_id: string;
  /** Phone Number */
  phone_number?: string | null;
  /** Email */
  email?: string | null;
  pagination?: Pagination | null;
}

/** GetBanksPayload */
export interface GetBanksPayload {
  /** Bank Id */
  bank_id?: number | null;
  country?: Country | null;
}

/** GetBlancoAppsByPni */
export interface GetBlancoAppsByPni {
  /** Pni */
  pni: string;
}

/** GetLeads */
export interface GetLeads {
  /**
   * Page
   * @default 0
   */
  page?: number | null;
  /**
   * Limit
   * @default 25
   */
  limit?: number | null;
  product: Product;
  country: Country;
  /**
   * Include Handled
   * @default false
   */
  include_handled?: boolean | null;
  /**
   * Include Failed
   * @default false
   */
  include_failed?: boolean | null;
  /**
   * Unassigned Only
   * @default false
   */
  unassigned_only?: boolean | null;
}

/** GetMeetings */
export interface GetMeetings {
  /** Gt */
  gt?: string | null;
  /** Lt */
  lt?: string | null;
  /** Page */
  page?: number | null;
  /** Limit */
  limit?: number | null;
  product?: Product | null;
  country?: Country | null;
  /**
   * With Apps
   * If true, will return apps and leads
   * @default false
   */
  with_apps?: boolean | null;
  /**
   * With Customer Name
   * If true, will return customer name
   * @default false
   */
  with_customer_name?: boolean | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Application Ids */
  application_ids?: string[] | null;
  /** Handler Id */
  handler_id?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /** With Handler Name */
  with_handler_name?: boolean | null;
}

/** GetMessages */
export interface GetMessages {
  /** Customer Id */
  customer_id?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Pni */
  pni?: string | null;
}

/** GetMessagesPayload */
export interface GetMessagesPayload {
  /**
   * Limit
   * @exclusiveMin 0
   * @exclusiveMax 101
   * @default 50
   */
  limit?: number;
  /**
   * Page
   * @min 0
   * @default 0
   */
  page?: number;
}

/** GetMyApplicationsPayload */
export interface GetMyApplicationsPayload {
  country?: Country | null;
  product?: Product | null;
  /** Statuses */
  statuses?: StatusInput[] | null;
  /** Substatuses */
  substatuses?: Substatus[] | null;
  /** Loan Purposes */
  loan_purposes?: MortgageLoanType[] | null;
  /**
   * Unassigned Only
   * @default false
   */
  unassigned_only?: boolean | null;
}

/** GetMyLeads */
export interface GetMyLeads {
  /**
   * Page
   * @default 0
   */
  page?: number | null;
  /**
   * Limit
   * @default 25
   */
  limit?: number | null;
  product: Product;
  country: Country;
  /**
   * Include Handled
   * @default false
   */
  include_handled?: boolean | null;
}

/** GetMyMeetings */
export interface GetMyMeetings {
  /** Gt */
  gt?: string | null;
  /** Lt */
  lt?: string | null;
  /** Page */
  page?: number | null;
  /** Limit */
  limit?: number | null;
  product?: Product | null;
  country?: Country | null;
  /**
   * With Apps
   * If true, will return apps and leads
   * @default false
   */
  with_apps?: boolean | null;
  /**
   * With Customer Name
   * If true, will return customer name
   * @default false
   */
  with_customer_name?: boolean | null;
}

/** GetNameByPNIPayload */
export interface GetNameByPNIPayload {
  /** Pni */
  pni: string;
}

/** GetQuickCreatePayload */
export interface GetQuickCreatePayload {
  /** Abandoned Forms Id */
  abandoned_forms_id?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
}

/** GetRecentApplicationsPayload */
export interface GetRecentApplicationsPayload {
  country?: Country | null;
  product?: Product | null;
  /** Statuses */
  statuses?: StatusInput[] | null;
  /** Substatuses */
  substatuses?: Substatus[] | null;
  /** Loan Purposes */
  loan_purposes?: MortgageLoanType[] | null;
  /**
   * Unassigned Only
   * @default false
   */
  unassigned_only?: boolean | null;
}

/** GetRecentPayload */
export interface GetRecentPayload {
  product: Product;
  country: Country;
  state?: AppState | null;
}

/** GetTaxPayload */
export interface GetTaxPayload {
  /** Monthly Salary */
  monthly_salary: number;
  /** Key */
  key: string;
  country: Country;
}

/** GetTaxPayloadResponse */
export interface GetTaxPayloadResponse {
  /** Monthly Tax */
  monthly_tax: number;
}

/** GetTemplatePayload */
export interface GetTemplatePayload {
  message_type: MessageType;
  template_event: TemplateEvent;
  country: Country;
  product?: ExtendedProduct | null;
}

/** GetUserMessagesPayload */
export interface GetUserMessagesPayload {
  /**
   * Limit
   * @exclusiveMin 0
   * @exclusiveMax 101
   * @default 50
   */
  limit?: number;
  /**
   * Page
   * @min 0
   * @default 0
   */
  page?: number;
  /** Customer Id */
  customer_id: string;
}

/** GetUsersPayload */
export interface GetUsersPayload {
  /**
   * Limit
   * @default 50
   */
  limit?: number | null;
  /**
   * Page
   * @default 0
   */
  page?: number | null;
  /** Bank Id */
  bank_id?: number | null;
  /**
   * Without Deactivated
   * @default false
   */
  without_deactivated?: boolean | null;
}

/** GlobalHit */
export interface GlobalHit {
  /** Source */
  source: string;
  /**
   * Ts
   * @format date-time
   */
  ts: string;
  /** Document */
  document: Record<string, any>;
  /** Highlights */
  highlights: Highlight[];
  /** Url */
  url?: string | null;
}

/** GlobalSearchPage */
export interface GlobalSearchPage {
  /** Hits */
  hits: GlobalHit[];
  /** Next Cursor */
  next_cursor: string | null;
  /** Unavailable */
  unavailable?: string[];
  /** Degraded */
  degraded: string[];
  /** Counts */
  counts?: Record<string, SourceCount>;
  /**
   * Scope Empty
   * @default false
   */
  scope_empty?: boolean;
  customer_filter?: CustomerFilter | null;
}

/** GlobalSearchRequest */
export interface GlobalSearchRequest {
  /**
   * Query
   * @minLength 1
   * @maxLength 200
   */
  query: string;
  /** Since */
  since?: string | null;
  /** Until */
  until?: string | null;
  /**
   * Limit
   * @min 1
   * @max 100
   * @default 20
   */
  limit?: number;
  /** Cursor */
  cursor?: string | null;
  /** @default "all" */
  scope?: SearchScope;
  /** Customer Id */
  customer_id?: string | null;
  /** Application Id */
  application_id?: string | null;
  /** Handler Id */
  handler_id?: string | null;
  /** Agent Id */
  agent_id?: string | null;
  /** Sources */
  sources?:
    | ("zenscriptions" | "messages" | "comments" | "notifications")[]
    | null;
  /**
   * Identifier As Text
   * @default false
   */
  identifier_as_text?: boolean;
}

/** GoalPayload */
export interface GoalPayload {
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /** User Ids */
  user_ids?: string[] | null;
}

/** GrConsentRequest */
export interface GrConsentRequest {
  /** Session Id */
  session_id?: string | null;
}

/** GrConsentResponse */
export interface GrConsentResponse {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
}

/** GrCreditItem */
export interface GrCreditItem {
  /** Creditor */
  creditor: string;
  /** Type */
  type: string;
  /** Grtype */
  grType: string;
  /** Balance */
  balance: number;
  /** Monthly */
  monthly: number;
  /** Rate */
  rate: number;
  /** Original */
  original: number;
  /** Creditlimit */
  creditLimit: number;
  /** Interestbearingbalance */
  interestBearingBalance: number;
  /** Noninterestbearingbalance */
  nonInterestBearingBalance: number;
  /** Installmentcharges */
  installmentCharges: number;
  /** Hascoborrower */
  hasCoBorrower: boolean;
}

/** GrCreditsPayload */
export interface GrCreditsPayload {
  /** Credits */
  credits: GrCreditItem[];
  /** Totalbalance */
  totalBalance: number;
  /** Totalmonthly */
  totalMonthly: number;
  /** Count */
  count: number;
  /** Lastupdated */
  lastUpdated: string;
}

/** GrSyncResponse */
export interface GrSyncResponse {
  /** Outcome */
  outcome: "SYNCED" | "NOTHING_TO_SYNC";
  /** Reason */
  reason?: string | null;
  application: BlancoApplicationNO;
}

/** GrantedCredits */
export interface GrantedCredits {
  /**
   * Total
   * The total size of all granted mortgages/credits/loans etc together. CSN loans are not included.
   */
  total?: number | null;
  /**
   * Housingcreditshouses
   * The combined size of mortgages for house properties that has been granted
   */
  housingCreditsHouses?: number | null;
  /**
   * Housingcreditstenantownersright
   * The combined size of mortgages for tenant-owned flats that has been granted
   */
  housingCreditsTenantOwnersRight?: number | null;
  /**
   * Creditcard
   * The combined size of granted credits for credit cards/account credits
   */
  creditCard?: number | null;
  /**
   * Installments
   * The combined size of granted credits for installments/hire purchases
   */
  installments?: number | null;
  /**
   * Loanwithoutsecurity
   * The combined size of granted credits for loans without security
   */
  loanWithoutSecurity?: number | null;
}

/**
 * GuardBranchRow
 * One branch cell of the ownership guard's ledger
 * (`services/meeting_distribution/owner_guard.py`).
 *
 * ``decisions`` counts ledger rows — one per (case, branch, meeting, target handler) — and
 * ``attempts`` the presses behind them.
 */
export interface GuardBranchRow {
  /** Branch */
  branch: string;
  /**
   * Decisions
   * @default 0
   */
  decisions?: number;
  /**
   * Attempts
   * @default 0
   */
  attempts?: number;
}

/**
 * GuardCounts
 * The guard's outcomes over the window: (a) owner change, (b) handover, (c) refused.
 *
 * ``held`` rows can still show up from ledger lines written while a started meeting was let
 * through unread (``GuardBranch.HELD``).
 */
export interface GuardCounts {
  /** Rows */
  rows?: GuardBranchRow[];
  /**
   * Decisions
   * @default 0
   */
  decisions?: number;
  /**
   * Attempts
   * @default 0
   */
  attempts?: number;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HandledSubmission */
export interface HandledSubmission {
  /** Submission Id */
  submission_id: string;
  /** Handled */
  handled?: boolean | null;
  /**
   * Reviews
   * @default []
   */
  reviews?: Reviewer[];
}

/** HandlerCalendar */
export interface HandlerCalendar {
  /** Handler Id */
  handler_id: string;
  /** Name */
  name: string | null;
  /** In Pool */
  in_pool: boolean;
  /** Scheduled */
  scheduled: TimeWindow[] | null;
  /** Unavailable */
  unavailable: TimeWindow[];
  /** Meetings */
  meetings: CalendarMeeting[];
}

/**
 * HandlerLoad
 * A handler's meeting count before and after the plan, per Oslo day and for the week.
 */
export interface HandlerLoad {
  /** Day Before */
  day_before?: Record<string, number>;
  /** Day After */
  day_after?: Record<string, number>;
  /**
   * Week Before
   * @default 0
   */
  week_before?: number;
  /**
   * Week After
   * @default 0
   */
  week_after?: number;
}

/**
 * HandlerSyncCounters
 * Native mapper synchronization and bounded recovery outcomes per application.
 */
export interface HandlerSyncCounters {
  /**
   * Applications
   * @default 0
   */
  applications?: number;
  /**
   * Mapper Written
   * @default 0
   */
  mapper_written?: number;
  /**
   * Mapper Failed
   * @default 0
   */
  mapper_failed?: number;
  /**
   * Skipped Mode
   * @default 0
   */
  skipped_mode?: number;
  /**
   * Pending
   * @default 0
   */
  pending?: number;
  /**
   * Superseded
   * @default 0
   */
  superseded?: number;
  /**
   * Gave Up
   * @default 0
   */
  gave_up?: number;
  /**
   * Fenced Out
   * @default 0
   */
  fenced_out?: number;
}

/**
 * HandlerTotal
 * One KH's planner-accounted value over the period, and the auto-distributed part of it.
 *
 * Counted over ``counts_in_totals`` rows only. ``cases`` is the owner records that carry a
 * counted line in the period, not the planner's founding-week band. ``unknown_origin`` is the
 * counted rows whose first owner is ambiguous: they are in the planner-accounted figures and
 * in none of the ``auto_*`` ones.
 */
export interface HandlerTotal {
  /** Handler Id */
  handler_id: string;
  /** Name */
  name: string | null;
  /** In Pool */
  in_pool: boolean;
  /** Applications */
  applications: number;
  /** Cases */
  cases: number;
  /** Score Total */
  score_total: number;
  /** Amount Total */
  amount_total: number;
  /** Auto Applications */
  auto_applications: number;
  /** Auto Cases */
  auto_cases: number;
  /** Auto Score Total */
  auto_score_total: number;
  /** Auto Amount Total */
  auto_amount_total: number;
  /** Unknown Origin */
  unknown_origin: number;
  /** Provisional */
  provisional: number;
  /** Degraded */
  degraded: number;
}

/**
 * HandoverPayload
 * One meeting handed to somebody else; the case keeps its owner and its value.
 *
 * ``meeting_id`` is a plain ``str`` rather than ``Annotated[str, UUID4]``: pydantic keeps
 * the ``str`` schema and treats the ``UUID4`` in the metadata slot as inert, so the
 * annotation would only look like validation. ``set_meeting_handler`` parses it for real
 * and answers 422 on anything that is not a meeting id.
 *
 * ``expected_previous_owner_id`` is the same compare-and-set the other three carry, and it
 * is against the **case's owner record** even though this operation is addressed by
 * meeting: what the caller read before deciding to cover one appointment was who owns the
 * case, and a mark written against a case that has moved in the meantime exempts a meeting
 * from an owner who never held it. The expectation is required, including explicit null.
 */
export interface HandoverPayload {
  /**
   * Meeting Id
   * @minLength 1
   * @maxLength 64
   */
  meeting_id: string;
  /** Handler Id */
  handler_id: string;
  /**
   * Distribution Op Id
   * @minLength 1
   * @maxLength 200
   */
  distribution_op_id: string;
  /** Expected Previous Owner Id */
  expected_previous_owner_id: string | null;
}

/** HeimdallCounterPair */
export interface HeimdallCounterPair {
  /** Allowed Count */
  allowed_count: number;
  /** Current Count */
  current_count: number;
}

/** HeimdallReportingPayload */
export interface HeimdallReportingPayload {
  tracking_type: HeimdallTrackingType;
  /** Ids */
  ids: string[];
}

/** HeimdallReportingResponse */
export interface HeimdallReportingResponse {
  /** Rate Limit Exceeded */
  rate_limit_exceeded: boolean;
}

/** HeimdallResponse */
export interface HeimdallResponse {
  /** User Id */
  user_id: string;
  /** Date */
  date: string;
  apps: HeimdallCounterPair;
  leads: HeimdallCounterPair;
  customers: HeimdallCounterPair;
  insurances: HeimdallCounterPair;
}

/** HighPrioPayload */
export interface HighPrioPayload {
  /** High Prio */
  high_prio: boolean;
}

/** Highlight */
export interface Highlight {
  /** Path */
  path: string;
  /** Parts */
  parts: HighlightPart[];
}

/** HighlightPart */
export interface HighlightPart {
  /** Value */
  value: string;
  /** Type */
  type: "hit" | "text";
}

/** HistoricalCase */
export interface HistoricalCase {
  /**
   * Date
   * The date which the information was recorded.
   */
  date?: string | null;
  /**
   * Numberofcases
   * Total number of cases. (Public + Private)
   */
  numberOfCases?: number | null;
  /**
   * Sumpubliccases
   * The aggregated sum for public cases in sek
   */
  sumPublicCases?: number | null;
  /**
   * Sumprivatecases
   * The aggregated sum for private cases in sek
   */
  sumPrivateCases?: number | null;
  /**
   * Sumcases
   * The aggregated sum for all cases in sek
   */
  sumCases?: number | null;
}

/** House */
export interface House {
  /** Property Id */
  property_id: string;
  /** Value */
  value?: number | null;
  /** Booli Value */
  booli_value?: number | null;
  /** External Id */
  external_id?: string | null;
  /** Property Type */
  property_type: "HOUSE";
  country: Country;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Other Owner */
  other_owner?: boolean | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Latitude */
  latitude?: number | null;
  /** Longitude */
  longitude?: number | null;
  ev_partial?: EvPartialCommon | null;
  /** Estate Type */
  estate_type?: string | null;
  /** Cadastral Designation */
  cadastral_designation?: string | null;
  [key: string]: any;
}

/** HousingCooperatativeShareIdentificationType */
export interface HousingCooperatativeShareIdentificationType {
  /** Organizationnumber */
  OrganizationNumber?: string | null;
  /** Sharenumber */
  ShareNumber?: string | null;
}

/** IDCheckGetCustomerPayload */
export interface IDCheckGetCustomerPayload {
  /** Reason */
  reason: string;
  country?: Country | null;
  /** Pni */
  pni: string;
}

/** IDCheckedPerson */
export interface IDCheckedPerson {
  country: Country;
  /** Pni */
  pni: string;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  marital_status?: MaritalStatus | null;
  /** Is Blocked */
  is_blocked?: boolean | null;
  /**
   * Zrm Only
   * Customer is handled in ZRM only — Sverker must not process them
   * @default false
   */
  zrm_only?: boolean;
  /** Age */
  age?: number | null;
  block_list?: BlockList | null;
}

/** IDKollenCollectResponse */
export interface IDKollenCollectResponse {
  /** Id */
  id?: string | null;
  status: IDKollenAuthStatusResponse;
  /**
   * Refid
   * @default ""
   */
  refId?: string;
  /** Ssn */
  ssn?: string | null;
  /** Givenname */
  givenName?: string | null;
  /** Surname */
  surname?: string | null;
  /** Error */
  error?: string | null;
  /** Certstartdate */
  certStartDate?: string | null;
  /** Signresult */
  signResult?: Record<string, any> | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
}

/** IdentityTypeType */
export interface IdentityTypeType {
  /** Description */
  Description?: string | null;
  /** Key */
  Key?: string | null;
}

/** ImpersonateCustomerPayload */
export interface ImpersonateCustomerPayload {
  /** Pni */
  pni?: string | null;
  /** Customer Id */
  customer_id?: string | null;
}

/** Income */
export interface Income {
  /**
   * Amount
   * Monthly amount
   * @min 0
   * @default 0
   */
  amount?: number;
  /**
   * Yearly Amount
   * Yearly amount
   * @min 0
   * @default 0
   */
  yearly_amount?: number;
  currency?: Currency | null;
  type: IncomeType;
  /** Name */
  name: string;
}

/** IncomeAndTaxation */
export interface IncomeAndTaxation {
  /**
   * Taxationnotdetermined
   * True if assessment has not been possible to determine
   */
  taxationNotDetermined?: boolean | null;
  /**
   * Incomeandtaxationdetails
   * List of Income and taxation details
   */
  incomeAndTaxationDetails?: IncomeAndTaxationDetails[] | null;
}

/** IncomeAndTaxationDetails */
export interface IncomeAndTaxationDetails {
  /**
   * Incomeyear
   * Year of income
   */
  incomeYear?: string | null;
  incomeCode?: IncomeAndTaxationIncomeCode | null;
  /**
   * Updatedate
   * Date when assessment data has been submitted to UC
   */
  updateDate?: string | null;
  /**
   * Activebusinessactivityincome
   * Surplus from active business activities, amount in SEK. As of income year 2023 Swedish tax authority will note provide this information, therefore presented as 0.
   */
  activeBusinessActivityIncome?: number | null;
  /**
   * Passivebusinessactivityincome
   * Surplus from passive business activities, amount in SEK. As of income year 2023 Swedish tax authority will note provide this information, therefore presented as 0.
   */
  passiveBusinessActivityIncome?: number | null;
  /**
   * Employmentincome
   * Surplus from employment, amount in SEK. As of income year 2023 Swedish tax authority will note provide this information, therefore presented as 0.
   */
  employmentIncome?: number | null;
  /**
   * Capitalincome
   * Surplus from capital, amount in SEK
   */
  capitalIncome?: number | null;
  /**
   * Capitaldeficit
   * Capital deficit, amount in SEK
   */
  capitalDeficit?: number | null;
  /**
   * Generaldeductions
   * Deficit from active business activity that can be offset against earned income, amount in SEK
   */
  generalDeductions?: number | null;
  /**
   * Assessedearnedincome
   * Sum of assessed/earned income and surplus of business activities after general deductions, amount in SEK
   */
  assessedEarnedIncome?: number | null;
  /**
   * Finaltax
   * Final tax, amount in SEK
   */
  finalTax?: number | null;
  /**
   * Expansionreservetax
   * Expansion fund tax, amount in SEK
   */
  expansionReserveTax?: number | null;
  /**
   * Creditedexpansionreservetax
   * Credited expansion fund tax, amount in SEK
   */
  creditedExpansionReserveTax?: number | null;
  /**
   * Activebusinessactivitydeficiency
   * Capital deficit from active business activity, amount in SEK
   */
  activeBusinessActivityDeficiency?: number | null;
  /**
   * Passivebusinessactivitydeficiency
   * Capital deficit from passive business activity, amount in SEK
   */
  passiveBusinessActivityDeficiency?: number | null;
  /**
   * Aggregateincomeafterdeductionbeforetax
   * Sum of assessed/earned income and surplus or deficit, of capital. Amount in SEK
   */
  aggregateIncomeAfterDeductionBeforeTax?: number | null;
}

/** IncomingSMS */
export interface IncomingSMS {
  /** Message Id */
  message_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Sender */
  sender: string;
  /** Message */
  message: string;
  /** Customer Ids */
  customer_ids: string[];
  /** Application Id */
  application_id?: string | null;
  /** @default "SMS" */
  message_type?: MessageType;
  /** @default "INCOMING" */
  direction?: Direction;
  /** Phone Number */
  phone_number?: string | null;
}

/** Info */
export interface Info {
  Address: Address;
  Cadastre: Cadastre;
  /** Ev Addressid */
  EV_AddressID?: string | null;
  /** Ev Estateid */
  EV_EstateID?: string | null;
  HousingCooperatativeShareIdentification?: HousingCooperatativeShareIdentificationType | null;
}

/** Insurance */
export interface Insurance {
  /** Insuranceid */
  insuranceId: string;
  /** Encryptedinsuranceid */
  encryptedInsuranceId?: string | null;
  status: InsuranceStatus;
  substatus: InsuranceSubstatus;
  insuranceType: InsuranceType;
  insuranceGroup?: InsuranceGroup | null;
  mandate?: MandateStatus;
  /** Premiumamount */
  premiumAmount: number;
  /** Insuredamount */
  insuredAmount: number;
  /**
   * Customerid
   * @format uuid
   */
  customerId: string;
  /** Sellerid */
  sellerId?: string | null;
  /** Seller Name */
  seller_name?: string | null;
  /**
   * Datecreated
   * @format date-time
   */
  dateCreated: string;
  lastCharge?: LastCharge;
  /** Events */
  events?: SharedInsuranceInsuranceEvent[];
  /** Signupdate */
  signupDate?: string | null;
  /**
   * Totalcharged
   * @default 0
   */
  totalCharged?: number;
  /** Targetinitalchargedate */
  targetInitalChargeDate?: string | null;
  /** Gocardlesssubscriptionid */
  goCardlessSubscriptionId?: string | null;
  /**
   * Failedconsecutivemonthlypayments
   * @default 0
   */
  failedConsecutiveMonthlyPayments?: number;
  /**
   * Cancellationdate
   * The last date the insurance is active, e.g one month after last payment
   */
  cancellationDate?: string | null;
  currency: Currency;
  /** Cta Tags */
  cta_tags?: CTATags[];
  /**
   * Handled
   * If the insurance has been handled uin the winbackable state
   * @default false
   */
  handled?: boolean;
  /** Last Comment */
  last_comment?: string | null;
  /**
   * Deceased
   * If the customer is deceased
   * @default false
   */
  deceased?: boolean;
  /**
   * Deceased At
   * The date of a deceased event
   */
  deceased_at?: string | null;
  /** The payment service provider used for the insurance */
  payment_service_provider: PaymentProvider;
  /** The country of the insurance */
  country: Country;
  /**
   * Preferred Payment Day
   * Preferred day of month for payment
   */
  preferred_payment_day?: number | null;
  /** Blue button queued cancellation info from events */
  queuedCancellation?: QueuedCancellation | null;
  customerProduct?: Product | null;
  /** Customer */
  customer?:
    | (
        | ({
            country: "NO";
          } & ApplicantNO)
        | ({
            country: "SE";
          } & ApplicantSE)
      )
    | null;
}

/** InsuranceActivated */
export interface InsuranceActivated {
  /** Type */
  type: "INSURANCE_ACTIVATED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: InsuranceActivatedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** InsuranceActivatedData */
export interface InsuranceActivatedData {
  /** Insurance Id */
  insurance_id: string;
  /** Customer Id */
  customer_id: string;
  product?: Product | null;
}

/** InsuranceCancellationQueued */
export interface InsuranceCancellationQueued {
  /** Type */
  type: "INSURANCE_SCHEDULED_CANCELLATION";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: InsuranceCancellationQueuedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** InsuranceCancellationQueuedData */
export interface InsuranceCancellationQueuedData {
  /** Insurance Id */
  insurance_id: string;
  /** Customer Id */
  customer_id: string;
  product?: Product | null;
}

/** InsuranceContext */
export interface InsuranceContext {
  /** Insurance Id */
  insurance_id: string;
  /** Insurance Type */
  insurance_type: string;
  /** Seller Id */
  seller_id: string | null;
  /** Seller Name */
  seller_name: string | null;
}

/**
 * InsuranceCustomer
 * Model for Loan Insurance for what a customer can see
 * missing things like events, etc
 */
export interface InsuranceCustomer {
  currency: Currency;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  /** Signup Date */
  signup_date?: string | null;
  /** Signup Url */
  signup_url?: string | null;
  /** Insurance Id */
  insurance_id: string;
  /** Encrypted Insurance Id */
  encrypted_insurance_id?: string | null;
  insurance_type: InsuranceType;
  /** Insured Amount */
  insured_amount: number;
  /** Premium Amount */
  premium_amount: number;
  status: InsuranceStatus;
  substatus: InsuranceSubstatus;
  last_charge?: LastCharge | null;
  mandate?: MandateStatus | null;
  insurance_group: InsuranceGroup;
  payment_service_provider?: PaymentProvider | null;
}

/** InsuranceListResponse */
export interface InsuranceListResponse {
  /**
   * Event
   * @default "insurance_list"
   */
  event?: "insurance_list";
  /** Data */
  data: Insurance[];
}

/** InsuranceNotification */
export interface InsuranceNotification {
  type: IncomingInsuranceEvent;
  /** Insurance Id */
  insurance_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  country: Country;
  /** Customer Id */
  customer_id: string;
  rules: InsuranceTerms;
  /** Seller Id */
  seller_id?: string | null;
  /** Pay Now Link */
  pay_now_link?: string | null;
}

/** InsuranceResponse */
export interface InsuranceResponse {
  /**
   * Event
   * @default "insurances"
   */
  event?: "insurances";
  /** Data */
  data: CanSignUp[];
}

/** InsuranceRulesResponse */
export interface InsuranceRulesResponse {
  /**
   * Event
   * @default "insurances_rules"
   */
  event?: "insurances_rules";
  data: RulesResponse;
}

/** InsuranceTerms */
export interface InsuranceTerms {
  /**
   * Active Max Age
   * The age at which the insurance ceases to be valid
   */
  active_max_age: number;
  /** Can Create New */
  can_create_new: boolean;
  /** Can Request New Mandate */
  can_request_new_mandate: boolean;
  /** Can Update Insurance */
  can_update_insurance: boolean;
  /** Cancellation Withdrawal Period Days */
  cancellation_withdrawal_period_days: number;
  /** Countries Of Residence */
  countries_of_residence: Country[];
  country: Country;
  currency: Currency;
  /** Customer Can Self Sign Up */
  customer_can_self_sign_up: boolean;
  /** Employment Types */
  employment_types: string[];
  /** Internal Employment Types */
  internal_employment_types: (EmploymentTypeSE | EmploymentTypeNO)[];
  insurance_type: InsuranceType;
  insurance_group: InsuranceGroup;
  /** Insurer Code */
  insurer_code: string;
  /** Max Age */
  max_age: number;
  /**
   * Max Amount
   * The maximum amount that can be insured
   */
  max_amount?: number | null;
  /** Max Insured Rate Vs Monthly Gross Income */
  max_insured_rate_vs_monthly_gross_income: number;
  /** Min Age */
  min_age: number;
  /**
   * Min Amount
   * The minimum amount that can be insured
   */
  min_amount?: number | null;
  /** Min Months Full Time Employment Time */
  min_months_full_time_employment_time?: number | null;
  /** Min Months Employment Time */
  min_months_employment_time: number;
  /** Min Hours Of Work Per Week */
  min_hours_of_work_per_week: number;
  /** Min Months Employment Time For Self Employed */
  min_months_employment_time_for_self_employed?: number | null;
  /** Min Hours Of Work Per Week For Self Employed */
  min_hours_of_work_per_week_for_self_employed?: number | null;
  /** Payment Providers */
  payment_providers: string[];
  /**
   * Premium Rate
   * The rate of the premium insured amount * premium rate = premium amount
   */
  premium_rate?: number | null;
  /**
   * Usps
   * @default []
   */
  usps?: string[];
  /**
   * Terms
   * @default []
   */
  terms?: string[];
  /**
   * Static Premium
   * The premium amount for a static premium insurance e.g accident insurance
   */
  static_premium?: number | null;
  /**
   * Insured Amount
   * The amount that is insured for insurances with a fixed premium
   */
  insured_amount?: number | null;
  /**
   * Product Name
   * The name of the insurance product
   */
  product_name: string;
  /**
   * Auto Payment Attempts Limit
   * The maximum number of automatic payment attempts before giving up on charging an invoice
   */
  auto_payment_attempts_limit?: number | null;
}

/** Integration */
export interface Integration {
  /** Bank Id */
  bank_id: number;
  country: Country;
  product: Product;
  /** Name */
  name: string;
  /**
   * Actions
   * Allowed actions to be performed on this integration
   */
  actions: IntegrationAction[];
}

/** IntegrationId */
export interface IntegrationId {
  /** Bank Id */
  bank_id: number;
  country: Country;
  product: Product;
}

/** IntegrationQuery */
export interface IntegrationQuery {
  country?: Country | null;
  /** Bank Id */
  bank_id?: number | null;
  product?: Product | null;
}

/** InterimLead */
export interface InterimLead {
  /**
   * Id
   * @format uuid
   */
  id?: string;
  data: LeadData;
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** File Id */
  file_id?: string | null;
  /** Job Id */
  job_id?: string | null;
  /**
   * Lead Type
   * @default "COLD"
   */
  lead_type?: "COLD";
  /** Imported At */
  imported_at?: string | null;
  /** Extracted At */
  extracted_at?: string | null;
  /** Extraction Id */
  extraction_id?: string | null;
}

/** InterimLeadJob */
export interface InterimLeadJob {
  /**
   * Job Id
   * @format uuid
   */
  job_id: string;
  /**
   * Is Finished
   * @default false
   */
  is_finished?: boolean;
  /**
   * Is Failed
   * @default false
   */
  is_failed?: boolean;
}

/** InterimLeadsInsertion */
export interface InterimLeadsInsertion {
  /**
   * Not Normalized Count
   * @default 0
   */
  not_normalized_count?: number;
  /**
   * Duplicated Count
   * @default 0
   */
  duplicated_count?: number;
  /**
   * Inserted Count
   * @default 0
   */
  inserted_count?: number;
}

/** InternalBankIDEvent */
export interface InternalBankIDEvent {
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** User Id */
  user_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/** InternalCommentData */
export interface InternalCommentData {
  /** Application Id */
  application_id: string;
  /** From User Id */
  from_user_id?: string | null;
  product?: Product | null;
}

/** InternalCommentSSE */
export interface InternalCommentSSE {
  /** User Id */
  user_id: string;
  /** Comment */
  comment: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Comment Id */
  comment_id: string;
  /**
   * Action
   * @default "INTERNAL_COMMENT_ADDED"
   */
  action?: "INTERNAL_COMMENT_ADDED";
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
}

/** InternalCommentWithName */
export interface InternalCommentWithName {
  /** User Id */
  user_id: string;
  /** Comment */
  comment: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Comment Id */
  comment_id: string;
  /**
   * Action
   * @default "INTERNAL_COMMENT_ADDED"
   */
  action?: "INTERNAL_COMMENT_ADDED";
  /** User Name */
  user_name: string;
  /** User Avatar */
  user_avatar: string;
}

/** InviteChain */
export interface InviteChain {
  /** Manual */
  manual: boolean;
  /**
   * Re Invite
   * @default 0
   */
  re_invite?: number;
  /** Terminal Status */
  terminal_status: string;
  /** Events */
  events: TimelineEvent[];
}

/** InviteGroup */
export interface InviteGroup {
  /** Creditor Id */
  creditor_id: number;
  /** Creditor Name */
  creditor_name?: string | null;
  /** Grouped Invite Events */
  grouped_invite_events: InviteChain[];
  /** Response Status */
  response_status: string;
  /** Response Sub Status */
  response_sub_status?: string | null;
  /** Response Events */
  response_events: TimelineEvent[];
}

/** InvitePayloadBase */
export interface InvitePayloadBase {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Bank Id */
  bank_id: number;
  /** Comment */
  comment?: string | null;
  /**
   * Force
   * @default false
   */
  force?: boolean;
}

/**
 * ItemContext
 * Background for the right pane. Each part is None when its service could not be read.
 */
export interface ItemContext {
  /** Customer Name */
  customer_name: string | null;
  /** Customer Phone */
  customer_phone: string | null;
  /** Customer Email */
  customer_email: string | null;
  application: ApplicationContext | null;
  /** Insurances */
  insurances: InsuranceContext[] | null;
  /** Link */
  link: string | null;
  unknown_sender: UnknownSenderContext | null;
}

/** JoinedCampaignExt */
export interface JoinedCampaignExt {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /**
   * Joined At
   * @format date-time
   */
  joined_at: string;
  /** Playing */
  playing: boolean;
  /**
   * Color
   * @exclusiveMin 0
   * @max 16
   */
  color: number;
  stats: CampaignStats;
  /** Campaign Data */
  campaign_data: MailCampaignData | DialCampaignData | SmsCampaignData;
}

/** JotformCCApplication */
export interface JotformCCApplication {
  /** @default "NO" */
  country?: Country;
  data: OptionalCreditCardApplicationDataCreate;
  /** Model used only for mapping jotform data to Applicant model, allowing some more fields to be optional */
  applicant: OptionalCreateApplicantNO;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
}

/** JotformCCApplicationWithTracking */
export interface JotformCCApplicationWithTracking {
  /** @default "NO" */
  country?: Country;
  data: OptionalCreditCardApplicationDataCreate;
  /** Model used only for mapping jotform data to Applicant model, allowing some more fields to be optional */
  applicant: OptionalCreateApplicantNO;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
  /** X Zid */
  x_zid?: string | null;
  /** X S Zid */
  x_s_zid?: string | null;
  /** X Gid */
  x_gid?: string | null;
}

/** JotformField */
export interface JotformField {
  /** Name */
  name: string;
  /** Options */
  options?: string[] | null;
}

/** JotformLeadSource */
export interface JotformLeadSource {
  /**
   * Type
   * @default "JOTFORM"
   */
  type?: "JOTFORM";
  /** Form Id */
  form_id: string;
  /** Submission Id */
  submission_id: string;
  /** Error */
  error?: string | null;
}

/** KDLTCallbackPayload */
export interface KDLTCallbackPayload {
  event: KDLTEvent;
  /** Customer Id */
  customer_id: string;
  /** Event Id */
  event_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Data */
  data?: Record<string, any> | null;
  customer_http_request_metadata?: CustomerHTTPRequestMetadata | null;
}

/** KhComment */
export interface KhComment {
  /** Text */
  text: string;
  /** User Id */
  user_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/** KhDashboard */
export interface KhDashboard {
  totals: KhPeriodTotals;
  /** Handlers */
  handlers: KhHandlerRow[];
}

/** KhHandlerRow */
export interface KhHandlerRow {
  /** User Id */
  user_id: string;
  /** Name */
  name: string;
  today: KhTotals;
  week: KhTotals;
  month: KhTotals;
}

/** KhPeriodTotals */
export interface KhPeriodTotals {
  today: KhTotals;
  week: KhTotals;
  month: KhTotals;
}

/** KhTotals */
export interface KhTotals {
  /**
   * Utskick
   * @default 0
   */
  utskick?: number;
  /**
   * Utskick Volume
   * @default 0
   */
  utskick_volume?: number;
  /**
   * Helped
   * @default 0
   */
  helped?: number;
  /**
   * Helped Volume
   * @default 0
   */
  helped_volume?: number;
  /**
   * Tf
   * @default 0
   */
  tf?: number;
  /**
   * Tf Premium
   * @default 0
   */
  tf_premium?: number;
  /**
   * Lf
   * @default 0
   */
  lf?: number;
  /**
   * Lf Premium
   * @default 0
   */
  lf_premium?: number;
}

/** LLMProcessing */
export interface LLMProcessing {
  /** Processed At */
  processed_at?: string | null;
  /**
   * Results
   * @default []
   */
  results?: LLMResult[];
  /** Model */
  model?: string | null;
  /** Duration Seconds */
  duration_seconds?: number | null;
  /** Status */
  status?: string | null;
}

/** LLMResult */
export interface LLMResult {
  /** Key */
  key: string;
  /** Output */
  output: string | ComplianceCheck;
  /** Duration Seconds */
  duration_seconds?: number | null;
  /** Model */
  model?: string | null;
  /** Run At */
  run_at?: string | null;
}

/** LastCharge */
export interface LastCharge {
  /** Amount */
  amount?: number | null;
  /** Date */
  date?: string | null;
  /** Orderid */
  orderId?: string | null;
}

/** LastQuery */
export interface LastQuery {
  /** Issuer Business Type */
  issuer_business_type?: string | null;
  /** Issuer Name */
  issuer_name?: string | null;
  /** Query Date */
  query_date?: string | null;
  /** Uc Internal Information */
  uc_internal_information?: string | null;
  /** Year */
  year?: string | null;
}

/** LastSaleType */
export interface LastSaleType {
  /** Salesprice */
  SalesPrice?: number | null;
  /** Askingprice */
  AskingPrice?: number | null;
  /** Commondebt */
  CommonDebt?: number | null;
  /** Surveyorsvaluation */
  SurveyorsValuation?: number | null;
  /** Saledate */
  SaleDate?: string | null;
  /** Registrationdate */
  RegistrationDate?: string | null;
  /** Judicialtransferdate */
  JudicialTransferDate?: string | null;
  /** Judicialtransfertype */
  JudicialTransferType?: string | null;
  /** Isdeviantprice */
  IsDeviantPrice?: boolean | null;
  /** Deviantpricereason */
  DeviantPriceReason?: string | null;
  /** Issiteprice */
  IsSitePrice?: boolean | null;
  /** Estateagent */
  EstateAgent?: string | null;
}

/** LateRejectionPayload */
export interface LateRejectionPayload {
  /** Partner */
  partner: string;
  country: Country;
  /**
   * Rejection Date
   * @format date-time
   */
  rejection_date: string;
  product: Product;
  /** App Id */
  app_id?: number | null;
  /** Broker Id */
  broker_id?: string | null;
}

/** Lead */
export interface Lead {
  product: Product;
  country: Country;
  /** Lead Id */
  lead_id: string;
  /** Creator */
  creator?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Handled */
  handled: boolean;
  /**
   * Reprocessable
   * @default false
   */
  reprocessable?: boolean | null;
  /** Create Source */
  create_source?:
    | JotformLeadSource
    | ApiLeadSource
    | AffiliateApiLeadSource
    | null;
  /**
   * Create Sources
   * @default []
   */
  create_sources?: (
    | JotformLeadSource
    | ApiLeadSource
    | AffiliateApiLeadSource
  )[];
  /** Converted */
  converted?: string[] | null;
  data?: LeadCreationData | null;
  source?: ModelsApplicationMappingApplicationMappingApplicationSource | null;
  deactivation_reason?: SharedMortgageModelsApplicationDeactivationReason | null;
}

/** LeadAssigned */
export interface LeadAssigned {
  /** Type */
  type: "LEAD_ASSIGNED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: LeadAssignedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** LeadAssignedData */
export interface LeadAssignedData {
  /** Lead Id */
  lead_id: string;
  product?: Product | null;
}

/** LeadComment */
export interface LeadComment {
  /** Type */
  type: "LEAD_COMMENT_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: LeadCommentData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** LeadCommentData */
export interface LeadCommentData {
  /** Lead Id */
  lead_id: string;
  product?: Product | null;
}

/** LeadCreationData */
export interface LeadCreationData {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: SharedModelsStatusStatus | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: SharedMortgageSeSpecCommonDefinitionsCars | null;
  brokerage?: Brokerage | null;
  /** Applicant */
  applicant?:
    | (
        | ({
            country: "NO";
          } & LimitedApplicantNO)
        | ({
            country: "SE";
          } & LimitedApplicantSE)
      )
    | null;
  /** Co Applicant */
  co_applicant?:
    | (
        | ({
            country: "NO";
          } & LimitedApplicantNO)
        | ({
            country: "SE";
          } & LimitedApplicantSE)
      )
    | null;
  property?: ExternalPropertyOutput | null;
  /** Comment */
  comment?: string | null;
  /** Ip Address */
  ip_address?: string | null;
  [key: string]: any;
}

/** LeadData */
export interface LeadData {
  /** Phone */
  phone?: string | null;
  /** Other Phones */
  other_phones?: string[] | null;
  /** Pni */
  pni?: string | null;
  process_type?: ProcessCampaignType | null;
  process_subtype?: InsuranceSubstatus | null;
  /** Priority */
  priority?: number | null;
  /** Name */
  name?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /** Other Properties */
  other_properties?: Record<string, any> | null;
  /** Comment Vars */
  comment_vars?: Record<string, any> | null;
  /** Tags */
  tags?: Record<string, any> | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Comment */
  comment?: string | null;
  /** Customer Cluster */
  customer_cluster?: string | null;
  /**
   * Extraction Count
   * Number of times this customer/phone number was extracted.
   */
  extraction_count?: number | null;
  /** Sorting Order */
  sorting_order?: number | null;
  /** Mail */
  mail?: string | null;
  /** @default "phone" */
  contact_type?: ModelsDialMaker2CampaignDataModelsContactType;
  calling_order?: CallingOrder | null;
  raw_calling_order?: CallingOrder | null;
  /** Data Template Vars */
  data_template_vars?: Record<string, any> | null;
  /** Prospect Id */
  prospect_id?: string | null;
  /**
   * Abandoned Form Id
   * A prospect may have an abandoned application form
   */
  abandoned_form_id?: string | null;
}

/** LeadExtraction */
export interface LeadExtractionInput {
  /** Leads To Extract */
  leads_to_extract: number;
}

/** LeadExtraction */
export interface LeadExtractionOutput {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /**
   * Extraction Id
   * @format uuid
   */
  extraction_id: string;
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /**
   * Count
   * Number of times this customer/phone number was extracted.
   * @exclusiveMin 0
   * @default 1
   */
  count?: number;
}

/** LeadField */
export interface LeadField {
  /** Name */
  name: string;
  /** Options */
  options?: string[] | null;
}

/** LeadHandledPayload */
export interface LeadHandledPayload {
  /** Lead Id */
  lead_id: string;
  deactivation_reason: SharedMortgageModelsApplicationDeactivationReason;
}

/** LeadUpdatePayload */
export interface LeadUpdatePayload {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: StatusInput | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: CarsInput | null;
  brokerage?: Brokerage | null;
  /** Applicant */
  applicant?:
    | (
        | ({
            country: "NO";
          } & LimitedApplicantNO)
        | ({
            country: "SE";
          } & LimitedApplicantSE)
      )
    | null;
  /** Co Applicant */
  co_applicant?:
    | (
        | ({
            country: "NO";
          } & LimitedApplicantNO)
        | ({
            country: "SE";
          } & LimitedApplicantSE)
      )
    | null;
  property?: ExternalPropertyInput | null;
  /** Comment */
  comment?: string | null;
}

/**
 * LeftToLiveEstimateChangedResponse
 * Something the LeftToLive estimate of the open case is computed from changed: the household or an override,
 * or the customer in KDLT. A ping with no data: the client re-reads the estimate by REST
 * (`GET /left-to-live/{application_id}`), which computes it.
 */
export interface LeftToLiveEstimateChangedResponse {
  /**
   * Event
   * @default "left_to_live_estimate"
   */
  event?: "left_to_live_estimate";
  /** Data */
  data?: null;
}

/**
 * LeftToLiveEstimateHouseholdPatch
 * What the advisor changes on an application's estimate. A field left out stays as it is, and null resets it: the
 * seed from the case applies again (the main applicant's `cars_in_the_household` for the car). An override replaces
 * its line (a per-person rate for adults, children and childcare, else the line total) until it is reset with null.
 */
export interface LeftToLiveEstimateHouseholdPatch {
  /** Adults */
  adults?: number | null;
  /**
   * Adults Confirmed
   * true: the adults are the applicant count as it is now (until it changes); false withdraws it
   */
  adults_confirmed?: boolean | null;
  /** Children */
  children?: number | null;
  /** Car */
  car?: boolean | null;
  /**
   * Loans Confirmed
   * true: no loan is missing from the loan list as it is now (until it changes); false withdraws it
   */
  loans_confirmed?: boolean | null;
  /**
   * Overrides
   * Per line; never on `NON_OVERRIDABLE_LINES` (422)
   */
  overrides?: Partial<Record<LeftToLiveEstimateLineKey, number | null>>;
}

/** LeftToLiveEstimateLine */
export interface LeftToLiveEstimateLine {
  /**
   * The lines of an estimate in the order they are shown: income, then the thirteen cost lines, with the household
   * costs as the four SIFO household lines.
   */
  key: LeftToLiveEstimateLineKey;
  /** Label */
  label: string;
  /**
   * Amount
   * Kroner per month: income positive, costs negative; the lines add up to the total
   */
  amount: number;
  /**
   * Standard Amount
   * The amount without an override
   */
  standard_amount: number;
  /** advisor when the line is overridden */
  source: LeftToLiveEstimateSource;
  /**
   * Edited
   * The advisor overrode the line
   * @default false
   */
  edited?: boolean;
  /**
   * Estimated
   * Income only: part of it is estimated at 70% of gross
   * @default false
   */
  estimated?: boolean;
  /**
   * Persons
   * Per-person lines: how many people the rate is charged for
   */
  persons?: number | null;
  /**
   * Per Person
   * Per-person lines: the rate in use
   */
  per_person?: number | null;
  /**
   * Standard Per Person
   * Per-person lines: the rate without an override
   */
  standard_per_person?: number | null;
}

/**
 * LeftToLiveEstimateResponse
 * The estimate as the Case View card shows it: the lines, and the household and loan list behind them that the
 * advisor can correct or confirm (`PATCH /left-to-live/{application_id}/household`). A `*_from_advisor` flag says the
 * value in use is the advisor's, which null in the PATCH resets to the seed from the case (the main applicant's
 * `cars_in_the_household` for the car).
 */
export interface LeftToLiveEstimateResponse {
  /**
   * Edition Id
   * The standards' edition, e.g. 'SIFO-2026'
   */
  edition_id: string;
  /** Calculator Version */
  calculator_version: number;
  /**
   * Household Size
   * Adults plus children
   */
  household_size: number;
  /** Lines */
  lines: LeftToLiveEstimateLine[];
  /**
   * Total
   * Income minus the cost lines, negative when they exceed it; None without income
   */
  total: number | null;
  /** Missing Inputs */
  missing_inputs?: LeftToLiveEstimateMissingInput[];
  /** Warnings */
  warnings?: LeftToLiveEstimateWarning[];
  /**
   * Adults
   * Set by the advisor, else the number of applicants
   */
  adults: number;
  /**
   * Adults From Advisor
   * The adults are the advisor's, not the seed from the case
   */
  adults_from_advisor: boolean;
  /**
   * Adults Assumed
   * The adults are the applicant count, neither set nor confirmed for this count
   */
  adults_assumed: boolean;
  /**
   * Children
   * Set by the advisor, else the main applicant's children
   */
  children: number;
  /**
   * Children From Advisor
   * The children are the advisor's, not the seed from the case
   */
  children_from_advisor: boolean;
  /**
   * Car
   * Set by the advisor, else from the main applicant's `cars_in_the_household`
   */
  car: boolean;
  /**
   * Car From Advisor
   * The car is the advisor's answer, else the main applicant's `cars_in_the_household`
   */
  car_from_advisor: boolean;
  /**
   * Loans Unconfirmed
   * No loan counts as kept and the advisor has not confirmed this loan list as complete: ask them to
   */
  loans_unconfirmed: boolean;
}

/** LeftToLiveOutcome */
export interface LeftToLiveOutcome {
  /** Message */
  message?: string | null;
  /** Success */
  success?: boolean | null;
  /** Loans */
  loans?: LeftToLiveOutcomeLoan[] | null;
  /** Lefttoliveoriginalresult */
  leftToLiveOriginalResult?: number | null;
  /** Lefttolivevalue */
  leftToLiveValue?: number | null;
  /** Lefttolivebudget */
  leftToLiveBudget?: number | null;
  /** Lefttoliveresult */
  leftToLiveResult?: number | null;
  /** Requestedloanamount */
  requestedLoanAmount?: number | null;
  /** Loanamountadjusted */
  loanAmountAdjusted?: boolean | null;
  /** Offeredloanamount */
  offeredLoanAmount?: number | null;
  /** Debttoincomeratio */
  debtToIncomeRatio?: string | null;
}

/** LeftToLiveOutcomeLoan */
export interface LeftToLiveOutcomeLoan {
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Interestrate */
  interestRate?: string | null;
  /** Loanamount */
  loanAmount?: number | null;
  loanType?: SharedMortgageSeSpecMortgageLeftToLiveOutcomeLoanType | null;
  /** Monthlyamortization */
  monthlyAmortization?: number | null;
}

/** LeftToLiveResponse */
export interface LeftToLiveResponse {
  outcome?: LeftToLiveOutcome | null;
  pre_offer?: MortgageRates | null;
  /** Missing Required Fields */
  missing_required_fields?: LeftToLiveFields[] | null;
  /** Missing Optional Fields */
  missing_optional_fields?: LeftToLiveFields[] | null;
}

/** LegalDocumentTypeType */
export interface LegalDocumentTypeType {
  /** Description */
  Description?: string | null;
  /** Key */
  Key?: string | null;
}

/** LienTypeType */
export interface LienTypeType {
  /** Description */
  Description?: string | null;
  /** Key */
  Key?: string | null;
}

/** LimitedApplicantNO */
export interface LimitedApplicantNO {
  /** Zid */
  zid?: string | null;
  /** Maklarpartner */
  maklarpartner?: string | null;
  /** Session Zid */
  session_zid?: string | null;
  /** Gid */
  gid?: string | null;
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /** Pni */
  pni?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: PhoneNumberOutput[] | null;
  housing_type?: HousingTypeNO | null;
  employer?: OptionalEmployerNO | null;
  /** Customer Id */
  customer_id?: string | null;
}

/** LimitedApplicantSE */
export interface LimitedApplicantSE {
  /** Zid */
  zid?: string | null;
  /** Maklarpartner */
  maklarpartner?: string | null;
  /** Session Zid */
  session_zid?: string | null;
  /** Gid */
  gid?: string | null;
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /** Pni */
  pni?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: PhoneNumberOutput[] | null;
  housing_type?: HousingTypeSE | null;
  employer?: OptionalEmployerSE | null;
  /** Customer Id */
  customer_id?: string | null;
}

/** ListEmailsPayload */
export interface ListEmailsPayload {
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Unassigned
   * @default false
   */
  unassigned?: boolean;
  /** Thread Id */
  thread_id?: string | null;
  /** Application Id */
  application_id?: string | null;
  status?: ModelsEmailCommonEmailStatus | null;
  /**
   * Page
   * @min 0
   * @default 0
   */
  page?: number;
  /**
   * Limit
   * @min 1
   * @max 100
   * @default 50
   */
  limit?: number;
  /**
   * Include Body
   * If true, return EmailDetail[] with full body content instead of EmailSummary[].
   * @default false
   */
  include_body?: boolean;
}

/** Loan */
export interface Loan {
  currency: Currency;
  /**
   * Loan Id
   * @format uuid4
   */
  loan_id: string;
  /** Amount */
  amount?: number | null;
  /** Bank Id */
  bank_id?: number | null;
  /** Refinance */
  refinance?: boolean | null;
  /** Refinanceamount */
  refinanceAmount?: number | null;
  loan_type?: SharedModelsLoanLoanType | null;
  /** Monthly Payment */
  monthly_payment?: number | null;
  /** Rate */
  rate?: number | null;
  /** Monthly Amortisation */
  monthly_amortisation?: number | null;
  responsibility?: SharedMortgageSeSpecCommonDefinitionsResponsibility | null;
  /** Credit Limit */
  credit_limit?: number | null;
  /** Monthly Administrative Fee */
  monthly_administrative_fee?: number | null;
}

/** LoanAndExternallyVerifiedCredit */
export interface LoanAndExternallyVerifiedCredit {
  /** Externally Verified Credits */
  externally_verified_credits: ExternallyVerifiedCreditWithRole[];
  /** Loans */
  loans: Loan[];
}

/** LogEntry */
export interface LogEntry {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Logging level */
  level: 10 | 20 | 30 | 40 | 50;
  /**
   * Message
   * Message to be logged
   */
  message: string;
  /**
   * Tag
   * Something to group logs together by (e.g. feature or service name)
   */
  tag: string;
  /** Job Id */
  job_id: string | null;
  /** Request Id */
  request_id: string | null;
  [key: string]: any;
}

/** LogLine */
export interface LogLine {
  /** Ts */
  ts?: string | null;
  /** Level */
  level?: string | null;
  /** Service */
  service?: string | null;
  /** Line Info */
  line_info?: string | null;
  /** User Id */
  user_id?: string | null;
  /** Message */
  message: string;
}

/** LogSaverPayload */
export interface LogSaverPayload {
  /**
   * Since
   * @format date-time
   */
  since: string;
  /** Until */
  until?: string | null;
  /** Tag */
  tag: string;
}

/** Login */
export interface Login {
  /**
   * Username
   * @format email
   */
  username: string;
  /**
   * Password
   * @format password
   */
  password: string;
}

/** LoginPayload */
export interface LoginPayload {
  /** Pni */
  pni?: string | null;
  /** Callback Url */
  callback_url?: string | null;
  /** Callback Fail Url */
  callback_fail_url?: string | null;
  /** @default "SE" */
  country?: Country;
  /** @default "blanco" */
  product?: Product;
  purpose?: BankIDPurpose | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
  provider?: CustomerLoginProvider | null;
  entry_point?: LoginEntryPoint | null;
  /**
   * How the post-login redirect hands the session to the frontend: always a single-use code.
   * @default "code"
   */
  response_type?: LoginResponseType;
}

/** LoginResp */
export interface LoginResp {
  /** Session Id */
  session_id: string;
}

/** LogsResponse */
export interface LogsResponse {
  /** Root Request Id */
  root_request_id: string;
  /** Logs */
  logs?: LogLine[];
}

/** MailBatchStats */
export interface MailBatchStats {
  /**
   * Total Opens
   * @default 0
   */
  total_opens?: number;
  /**
   * Total Clicks
   * @default 0
   */
  total_clicks?: number;
  /**
   * Unique Opens
   * @default 0
   */
  unique_opens?: number;
  /**
   * Unique Clicks
   * @default 0
   */
  unique_clicks?: number;
  /**
   * Sent
   * @default 0
   */
  sent?: number;
  /**
   * Hard Bounce
   * @default 0
   */
  hard_bounce?: number;
  /**
   * Soft Bounce
   * @default 0
   */
  soft_bounce?: number;
  /**
   * Spam
   * @default 0
   */
  spam?: number;
  /**
   * Unsubscribed
   * @default 0
   */
  unsubscribed?: number;
  /**
   * Redirects
   * @default 0
   */
  redirects?: number;
  /**
   * Unique Redirects
   * @default 0
   */
  unique_redirects?: number;
  /**
   * Batch Id
   * @format uuid
   */
  batch_id: string;
  /** Mail Ids */
  mail_ids: string[];
  /**
   * Batch Sent
   * @format date-time
   */
  batch_sent: string;
}

/**
 * MailCampaignData
 * Complete data model for Mail campaigns, including both user-editable fields and system-managed state
 * Should only be used for read operations, for create/update use MailCampaignEditableData
 */
export interface MailCampaignData {
  /** Last Bq Sync */
  last_bq_sync?: string | null;
  /** Template Vars */
  template_vars?: string[] | null;
  /** Template Vars Checked At */
  template_vars_checked_at?: string | null;
  /** Template Updated At */
  template_updated_at?: string | null;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Source */
  source:
    | ({
        type: "BIG_QUERY";
      } & BigQueryCampaignSource)
    | ({
        type: "PROCESS";
      } & ProcessCampaignSource)
    | ({
        type: "SHEET";
      } & SheetCampaignSourceOutput);
  /** File Id */
  file_id?: string | null;
  exclusion_rules: ExclusionRules;
  /** Daily Extraction Limit */
  daily_extraction_limit?: number | null;
  /**
   * Auto Extraction
   * Time of auto extraction in HH:MM format
   */
  auto_extraction?: string | null;
  /** Comment Template */
  comment_template?: string | null;
  mail_policy?: SendPolicy | null;
  template?: EmailTemplate | null;
  /**
   * Amount Of Bcc Mails
   * @default 1
   */
  amount_of_bcc_mails?: number;
  type: CampaignType;
  country: Country;
  /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
  product: ExtendedProduct;
  department?: ZDepartment | null;
  /**
   * Contact Type
   * @default "mail"
   */
  contact_type?: "mail";
  /**
   * Is Prospect Campaign
   * @default false
   */
  is_prospect_campaign?: boolean;
  /**
   * Mailings
   * @default []
   */
  mailings?: MailingData[];
  /** Last Mailing At */
  last_mailing_at?: string | null;
  current_mailing_schedule?: CampaignMailSchedule | null;
}

/** MailScheduleBatch */
export interface MailScheduleBatch {
  /**
   * Time Slot
   * @format date-time
   */
  time_slot: string;
  /**
   * Leads Count
   * Number of leads scheduled for this time slot, not necessarily the number of leads actually sent
   * @min 0
   */
  leads_count: number;
  /**
   * Bcc
   * @default false
   */
  bcc?: boolean;
}

/** MailingData */
export interface MailingData {
  /**
   * Mailing Id
   * @format uuid
   */
  mailing_id: string;
  template: EmailTemplate;
  /** Template Vars */
  template_vars?: string[] | null;
  /**
   * Leads Count
   * @min 0
   */
  leads_count: number;
  /** Mail Times */
  mail_times: string[];
  /** Template Vars Checked At */
  template_vars_checked_at?: string | null;
  /** Template Links Vars */
  template_links_vars?: string[] | null;
}

/** MandateStatus */
export interface MandateStatus {
  /**
   * Acquired
   * @default false
   */
  acquired?: boolean;
  /** Accountid */
  accountId?: string | null;
  /**
   * Canceled
   * @default false
   */
  canceled?: boolean;
  /** Bank */
  bank?: string | null;
  /** Lastbankaccountdigits */
  lastBankAccountDigits?: string | null;
  api_type?: ApiType | null;
}

/** MandrillTemplate */
export interface MandrillTemplate {
  /** Slug */
  slug: string;
  /** Name */
  name: string;
  /** Labels */
  labels: string[];
  /** Code */
  code?: string | null;
  /** Subject */
  subject?: string | null;
  /** From Email */
  from_email?: string | null;
  /** From Name */
  from_name?: string | null;
  /** Text */
  text?: string | null;
  /** Publish Name */
  publish_name: string;
  /** Publish Code */
  publish_code?: string | null;
  /** Publish Subject */
  publish_subject?: string | null;
  /** Publish From Email */
  publish_from_email?: string | null;
  /** Publish From Name */
  publish_from_name?: string | null;
  /** Publish Text */
  publish_text?: string | null;
  /** Published At */
  published_at?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Is Broken Template */
  is_broken_template: boolean;
}

/** ManualStatePayload */
export interface ManualStatePayload {
  manual_application_state: ManualApplicationState;
}

/** MarkEmailReadPayload */
export interface MarkEmailReadPayload {
  /** Email Id */
  email_id: string;
}

/** MarketingCookies */
export interface MarketingCookies {
  /** Ga */
  _ga?: string | null;
  /** Ga 13Re18Dxbb */
  _ga_13RE18DXBB?: string | null;
  /** Zid */
  zid?: string | null;
  /** Szid */
  szid?: string | null;
  /** Fbp */
  _fbp?: string | null;
  /** Msclkid */
  msclkid?: string | null;
  [key: string]: any;
}

/** MarketingMailsSent */
export interface MarketingMailsSent {
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Norway */
  norway: number;
  /** Sweden */
  sweden: number;
  /** Total */
  total: number;
}

/** MbDashboard */
export interface MbDashboard {
  /** Monthly MB goals; None = not set. */
  goals: MbGoals;
  totals: MbPeriodTotals;
  /** Month-to-date ÷ worked days × working days in the month; None before the first working day. */
  runrate: MbRunrate;
  /** Apps By Weekday */
  apps_by_weekday: MbWeekday[];
  /** Sellers */
  sellers: MbSellerRow[];
}

/**
 * MbGoals
 * Monthly MB goals; None = not set.
 */
export interface MbGoals {
  /** Apps Day */
  apps_day?: number | null;
  /** Apps Week */
  apps_week?: number | null;
  /** Apps Month */
  apps_month?: number | null;
  /** Helped Month */
  helped_month?: number | null;
  /** Helped Volume Month */
  helped_volume_month?: number | null;
}

/** MbPeriodTotals */
export interface MbPeriodTotals {
  today: MbTotals;
  week: MbTotals;
  month: MbTotals;
}

/**
 * MbRunrate
 * Month-to-date ÷ worked days × working days in the month; None before the first working day.
 */
export interface MbRunrate {
  /** Apps */
  apps: number | null;
  /** Helped */
  helped: number | null;
  /** Helped Volume */
  helped_volume: number | null;
}

/** MbSellerRow */
export interface MbSellerRow {
  /** User Id */
  user_id: string;
  /** Name */
  name: string;
  /** Department */
  department: "KA" | "SK";
  today: MbTotals;
  month: MbTotals;
  /** Return Rate */
  return_rate: number | null;
  /** Helped Total */
  helped_total: number;
}

/** MbTotals */
export interface MbTotals {
  /**
   * Apps
   * @default 0
   */
  apps?: number;
  /**
   * Sameday
   * @default 0
   */
  sameday?: number;
  /**
   * Instant
   * @default 0
   */
  instant?: number;
  /**
   * Utskick
   * @default 0
   */
  utskick?: number;
  /**
   * Utskick Volume
   * @default 0
   */
  utskick_volume?: number;
  /**
   * Helped
   * @default 0
   */
  helped?: number;
  /**
   * Helped Volume
   * @default 0
   */
  helped_volume?: number;
  /**
   * Helped Mortgage
   * @default 0
   */
  helped_mortgage?: number;
  /**
   * Helped Mortgage Volume
   * @default 0
   */
  helped_mortgage_volume?: number;
}

/** MbWeekday */
export interface MbWeekday {
  /**
   * Date
   * @format date
   */
  date: string;
  /** Apps */
  apps: number;
}

/**
 * MeetingDistributionSettings
 * One version of the whole distribution configuration, per country.
 */
export interface MeetingDistributionSettings {
  country: Country;
  /** One fitted version of the whole value model. Never edited — superseded. */
  value_multipliers: ValueMultipliers;
  /**
   * The hard count filter in front of the value keys.
   *
   * A handler is selectable while ``cases(handler) - mean <= max(abs_floor, rel * mean)``;
   * an empty band is ignored rather than blocking the decision. The absolute floor is what
   * stops the band from biting on a Monday morning, when the mean is 1.
   */
  count_band?: CountBand;
  /**
   * When an application's value is frozen.
   *
   * ``D = min(t_completed + cap, max(t_completed, first_offer) + settle)``.
   */
  d_rule?: DRule;
  /**
   * Ka Change Until First Meeting
   * @default false
   */
  ka_change_until_first_meeting?: boolean;
  /**
   * Settings Version
   * @min 0
   * @default 0
   */
  settings_version?: number;
  /** User Id */
  user_id?: string | null;
  /** Timestamp */
  timestamp?: string | null;
}

/**
 * MeetingDistributionSettingsPayload
 * A settings version bump: only the sub-documents the team lead is changing.
 *
 * Everything left unset is carried forward from the stored version, so a band change
 * does not have to resend the multipliers (and cannot silently reset them). The
 * multipliers carry their own version, which the store requires to be newer than the
 * stored one. The KH pool is not here: it is the Employee scheduling roster.
 */
export interface MeetingDistributionSettingsPayload {
  value_multipliers?: ValueMultipliers | null;
  count_band?: CountBand | null;
  d_rule?: DRule | null;
  /** Ka Change Until First Meeting */
  ka_change_until_first_meeting?: boolean | null;
}

/** MeetingReminder */
export interface MeetingReminder {
  /** Type */
  type: "MEETING_REMINDER";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: MeetingReminderData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** MeetingReminderData */
export interface MeetingReminderData {
  /** Application Id */
  application_id?: string | null;
  /** Customer Ids */
  customer_ids: string[];
  product?: Product | null;
  /** Meeting Id */
  meeting_id?: string | null;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Customer Name */
  customer_name?: string | null;
}

/** MeetingV2 */
export interface MeetingV2 {
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject: string | null;
  /** Customer Id */
  customer_id: string;
  /** Application Ids */
  application_ids?: string[] | null;
  /** Priority */
  priority?: number | null;
  subject_priority?: MeetingSubject | null;
  /** Booked */
  booked: boolean;
  /** Recommended Time */
  recommended_time?: string | null;
  /** Assign Apps To Handler */
  assign_apps_to_handler?: string[] | null;
  /** Meeting Id */
  meeting_id: string;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  /** Customer Name */
  customer_name?: string | null;
  /**
   * First Meeting
   * @default false
   */
  first_meeting?: boolean;
  product?: Product | null;
  country?: Country | null;
}

/** MeetingWithApp */
export interface MeetingWithApp {
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Meeting Id */
  meeting_id: string;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  product: Product;
  country: Country;
  /** Customer Name */
  customer_name?: string | null;
  /** Handler Name */
  handler_name?: string | null;
  /** Application */
  application?: AppBase | Lead | null;
}

/** MeetingWithHandlerName */
export interface MeetingWithHandlerName {
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Meeting Id */
  meeting_id: string;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  product: Product;
  country: Country;
  /** Customer Name */
  customer_name?: string | null;
  /** Handler Name */
  handler_name?: string | null;
}

/** MeetingWithHandlerNameV2 */
export interface MeetingWithHandlerNameV2 {
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject: string | null;
  /** Customer Id */
  customer_id: string;
  /** Application Ids */
  application_ids?: string[] | null;
  /** Priority */
  priority?: number | null;
  subject_priority?: MeetingSubject | null;
  /** Booked */
  booked: boolean;
  /** Recommended Time */
  recommended_time?: string | null;
  /** Assign Apps To Handler */
  assign_apps_to_handler?: string[] | null;
  /** Meeting Id */
  meeting_id: string;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  /** Customer Name */
  customer_name?: string | null;
  /**
   * First Meeting
   * @default false
   */
  first_meeting?: boolean;
  product?: Product | null;
  country?: Country | null;
  /** Handler Name */
  handler_name?: string | null;
}

/** MeetingsResponse */
export interface MeetingsResponse {
  /**
   * Event
   * @default "meetings"
   */
  event?: "meetings";
  /** Data */
  data: MeetingWithHandlerNameV2[] | MeetingV2[];
}

/** MergeVar */
export interface MergeVar {
  /**
   * Rcpt
   * @format email
   */
  rcpt: string;
  /** Vars */
  vars: MergeVarContent[];
}

/** MergeVarContent */
export interface MergeVarContent {
  /** Name */
  name: string;
  /** Content */
  content?: string | number | boolean | null;
}

/** MessageResponse */
export interface MessageResponse {
  /**
   * Event
   * @default "messages"
   */
  event?: "messages";
  /** Data */
  data: SavedMessage[];
}

/** MessageSuggestionsResponse */
export interface MessageSuggestionsResponse {
  /**
   * Event
   * @default "message_suggestions"
   */
  event?: "message_suggestions";
  /** Data */
  data: string[];
}

/** MessagingCenterItemDetail */
export interface MessagingCenterItemDetail {
  /** Id */
  id: string;
  status: CenterStatus;
  /** Customer Id */
  customer_id: string | null;
  /** Customer Name */
  customer_name: string | null;
  /** Sender Display */
  sender_display: string | null;
  product: ExtendedProduct | null;
  country: Country;
  reason: CenterReason | null;
  rule: RoutingRule | null;
  /** Application Id */
  application_id: string | null;
  /** Message Count */
  message_count: number;
  /**
   * Last Message At
   * @format date-time
   */
  last_message_at: string;
  last_channel: InboundChannel;
  /** Claimed By */
  claimed_by: string | null;
  /** Claimed By Name */
  claimed_by_name: string | null;
  /** Claimed By Me */
  claimed_by_me: boolean;
  /** Claim Expires At */
  claim_expires_at: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Background for the right pane. Each part is None when its service could not be read. */
  context: ItemContext;
}

/**
 * MessagingCenterListItem
 * One row of the KH list. No message text: the page reads the conversation through the messenger.
 */
export interface MessagingCenterListItem {
  /** Id */
  id: string;
  status: CenterStatus;
  /** Customer Id */
  customer_id: string | null;
  /** Customer Name */
  customer_name: string | null;
  /** Sender Display */
  sender_display: string | null;
  product: ExtendedProduct | null;
  country: Country;
  reason: CenterReason | null;
  rule: RoutingRule | null;
  /** Application Id */
  application_id: string | null;
  /** Message Count */
  message_count: number;
  /**
   * Last Message At
   * @format date-time
   */
  last_message_at: string;
  last_channel: InboundChannel;
  /** Claimed By */
  claimed_by: string | null;
  /** Claimed By Name */
  claimed_by_name: string | null;
  /** Claimed By Me */
  claimed_by_me: boolean;
  /** Claim Expires At */
  claim_expires_at: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** MinimalApplicant */
export interface MinimalApplicant {
  role: ApplicantRole;
  /** Pni */
  pni: string;
}

/** MoneyRange */
export interface MoneyRange {
  /** Min */
  min?: number | null;
  /** Max */
  max?: number | null;
}

/** Mortgage */
export interface Mortgage {
  /** Document */
  Document?: string | null;
  /** Documentnumber */
  DocumentNumber?: string | null;
  /** Documentyear */
  DocumentYear?: string | null;
  /** Identityname */
  IdentityName?: string | null;
  /** Identitynumber */
  IdentityNumber?: string | null;
  IdentityType?: IdentityTypeType | null;
  /** Isregisteredelectronically */
  IsRegisteredElectronically?: boolean | null;
  /** Isuncertain */
  IsUncertain?: boolean | null;
  /** Legaldocumentnumber */
  LegalDocumentNumber?: string | null;
  LegalDocumentType?: LegalDocumentTypeType | null;
  LienType?: LienTypeType | null;
  /** Mortgageinfoastext */
  MortgageInfoAsText?: string | null;
  /** Numestatesmortgageapplyto */
  NumEstatesMortgageApplyTo?: string | null;
  /** Officenumber */
  OfficeNumber?: string | null;
  /** Priority */
  Priority?: string | null;
  /** Registereddate */
  RegisteredDate?: string | null;
  /** Share */
  Share?: number | null;
  UncertainReason?: UncertainReasonType | null;
  /** Value */
  Value?: number | null;
}

/** MortgageApplicationNO */
export interface MortgageApplicationNO {
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "mortgage"
   */
  product?: "mortgage";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data NO */
  data: BlancoApplicationDataNO;
  applicant: ApplicantNO;
  co_applicant?: ApplicantNO | null;
}

/** MortgageApplicationSEData */
export interface MortgageApplicationSEData {
  main_contact?: MainContact | null;
  /** Advisor Id */
  advisor_id?: string | null;
  /** Tags */
  tags?: string[] | null;
  /** Priority */
  priority?: number | null;
  /** Loans */
  loans?: Loan[] | null;
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: SharedMortgageSeSpecCommonDefinitionsCars | null;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  /** Bidded Payback Time */
  bidded_payback_time?: number | null;
  /** Applicant Id */
  applicant_id?: string | null;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
  /** Guarantor Id */
  guarantor_id?: string | null;
  /** Property Id */
  property_id?: string | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  brokerage?: Brokerage | null;
  discount?: Discount | null;
  /** Offers */
  offers?: Offer[] | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
}

/** MortgageBankEventsResponse */
export interface MortgageBankEventsResponse {
  /** Bank Events */
  bank_events: BankEventsMortgageOfferExt[];
}

/**
 * MortgageCoiDecisionResponse
 * The mortgage application a "Create" decision made, so the case view can open it rather than
 * announce it. Both fields stay None on "Do not create", which creates nothing.
 */
export interface MortgageCoiDecisionResponse {
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Customer Id */
  customer_id?: string | null;
}

/** MortgageCoiFlagged */
export interface MortgageCoiFlagged {
  /** Type */
  type: "MORTGAGE_COI_FLAGGED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: MortgageCoiFlaggedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** MortgageCoiFlaggedData */
export interface MortgageCoiFlaggedData {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Customer Id */
  customer_id: string;
  product?: Product | null;
}

/** MortgageDeactivatePayload */
export interface MortgageDeactivatePayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  reason: SharedMortgageModelsApplicationDeactivationReason;
}

/** MortgageDeactivationReviewsResponse */
export interface MortgageDeactivationReviewsResponse {
  /** Reasons */
  reasons: SharedMortgageModelsApplicationDeactivationReason[];
}

/** MortgageFormPayload */
export interface MortgageFormPayload {
  /** Givenname */
  givenName: string;
  /** Lastname */
  lastName: string;
  /** Phonenumber */
  phoneNumber: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Bankname */
  bankName: string;
  /** Loanamount */
  loanAmount: number;
}

/** MortgageGoal */
export interface MortgageGoal {
  type_event: GoalType;
  /** User Id */
  user_id?: string[] | null;
  country: Country;
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/** MortgageGrSyncResponse */
export interface MortgageGrSyncResponse {
  /** Outcome */
  outcome: "SYNCED" | "NOTHING_TO_SYNC";
  /** Reason */
  reason?: string | null;
  application: MortgageApplicationNO;
}

/** MortgageLeads */
export interface MortgageLeads {
  /** Amount */
  amount: number;
}

/** MortgageLoan */
export interface MortgageLoan {
  /** Bank Id */
  bank_id?: number | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Loan Amount */
  loan_amount?: number | null;
  /** Refinance */
  refinance?: boolean | null;
  /** Responsibility */
  responsibility?:
    | SharedMortgageSeSpecCommonDefinitionsResponsibility
    | SharedMortgageNoSpecCommonDefinitionsResponsibility
    | null;
  /** Rate */
  rate?: number | null;
}

/** MortgageOffer */
export interface MortgageOffer {
  /** Comment */
  comment?: string | null;
  /**
   * Offeredamount
   * @exclusiveMin 0
   */
  offeredAmount: number;
  currency: Currency;
  /** Bindingperiodmonth */
  bindingPeriodMonth: number;
  /** Interestrate */
  interestRate: number;
  /** Discount */
  discount: number;
  amortizationRule: AmortizationRule;
  /** Monthlyamortization */
  monthlyAmortization: number;
  /** Invoicefee */
  invoiceFee?: number | null;
  /** Setupfee */
  setupFee?: number | null;
  /** Autogirofee */
  autogiroFee?: number | null;
  /** Amortizationlength */
  amortizationLength?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Effectiveinterestrate */
  effectiveInterestRate?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Arrangementfee */
  arrangementFee?: number | null;
  /** Termfee */
  termFee?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /** Downpaymentloanamount */
  downPaymentLoanAmount?: number | null;
  /** Downpaymentloaninterestrate */
  downPaymentLoanInterestRate?: number | null;
  /** Bridgeloanamount */
  bridgeLoanAmount?: number | null;
  /** Bridgeloaninterestrate */
  bridgeLoanInterestRate?: number | null;
}

/** MortgageOfferExt */
export interface MortgageOfferExt {
  /** Comment */
  comment?: string | null;
  /**
   * Offeredamount
   * @exclusiveMin 0
   */
  offeredAmount: number;
  currency: Currency;
  /** Bindingperiodmonth */
  bindingPeriodMonth: number;
  /** Interestrate */
  interestRate: number;
  /** Discount */
  discount: number;
  amortizationRule: AmortizationRule;
  /** Monthlyamortization */
  monthlyAmortization: number;
  /** Invoicefee */
  invoiceFee?: number | null;
  /** Setupfee */
  setupFee?: number | null;
  /** Autogirofee */
  autogiroFee?: number | null;
  /** Amortizationlength */
  amortizationLength?: number | null;
  /** Maxofferedamount */
  maxOfferedAmount?: number | null;
  /** Mustrefinance */
  mustRefinance?: number | null;
  /** Effectiveinterestrate */
  effectiveInterestRate?: number | null;
  /** Monthlypayment */
  monthlyPayment?: number | null;
  /** Arrangementfee */
  arrangementFee?: number | null;
  /** Termfee */
  termFee?: number | null;
  /** Termmonths */
  termMonths?: number | null;
  /** Downpaymentloanamount */
  downPaymentLoanAmount?: number | null;
  /** Downpaymentloaninterestrate */
  downPaymentLoanInterestRate?: number | null;
  /** Bridgeloanamount */
  bridgeLoanAmount?: number | null;
  /** Bridgeloaninterestrate */
  bridgeLoanInterestRate?: number | null;
  /** Firstmonthlypayment */
  firstMonthlyPayment: number;
}

/** MortgagePatchPayloadNO */
export interface MortgagePatchPayloadNO {
  /**
   * Product
   * @default "mortgage"
   */
  product?: "mortgage";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  data: BlancoPatchDataNO;
}

/** MortgageRates */
export interface MortgageRates {
  /** Loanamount */
  loanAmount?: number | null;
  /** Marketvalue */
  marketValue?: number | null;
  /** Bindingperiodmonth */
  bindingPeriodMonth?: number | null;
  /** Interestrateafterdiscount */
  interestRateAfterDiscount?: string | null;
  /** Interestrate */
  interestRate?: string | null;
  /** Monthlyamortization */
  monthlyAmortization?: number | null;
}

/**
 * MortgageTakeoverCounters
 * One pass of the automatic handover to the mortgage handler.
 *
 * Written by the hourly re-check of the takeover queue, and used by the event consumers to
 * say in one word what they did.
 *
 * ``taken_over`` is a case leaving the blanco pool for the first time, ``rehandled`` a MONO
 * application whose handler changed after that. ``unchanged`` has to dominate once a queue
 * has drained; a run where it does not is writing records for nothing. It holds **two**
 * shapes, both decided on a read where both apps-mgr instances answered: the idempotent
 * repeat, and a case that has left the blanco pool while its MONO application names nobody —
 * kept where it is, so its row is cleared rather than re-checked for ever.
 *
 * ``still_pending`` is a row the pass could not resolve although both instances answered: the
 * MONO application exists, still has no handler, and the case is still in the blanco pool. It
 * comes back next hour — the takeover happens whenever the handler is set, however late — but
 * is charged a re-check (``recheck_attempts``), which moves it behind rows nobody has seen.
 * ``twin_gone`` is the queue's other exit: no active MONO application any more. A high one
 * means mortgage applications are created and withdrawn, not that the takeover is failing.
 *
 * ``errors`` is a row the pass could not decide about at all, because the re-check raised;
 * without a bucket of its own a pass that threw on every row would still reconcile.
 * ``recheck_failed`` is a row that took **no** exit because apps-mgr did not answer — a
 * failed instance is evidence of neither "no mortgage" nor "nobody is on the MONO
 * application" — so it stays queued rather than landing in ``twin_gone``, ``unchanged`` or
 * ``still_pending``. It is what separates a draining queue from a blind one.
 */
export interface MortgageTakeoverCounters {
  /**
   * Examined
   * @default 0
   */
  examined?: number;
  /**
   * Taken Over
   * @default 0
   */
  taken_over?: number;
  /**
   * Rehandled
   * @default 0
   */
  rehandled?: number;
  /**
   * Unchanged
   * @default 0
   */
  unchanged?: number;
  /**
   * Still Pending
   * @default 0
   */
  still_pending?: number;
  /**
   * Twin Gone
   * @default 0
   */
  twin_gone?: number;
  /**
   * Recheck Failed
   * @default 0
   */
  recheck_failed?: number;
  /**
   * No Case
   * @default 0
   */
  no_case?: number;
  /**
   * No Customer
   * @default 0
   */
  no_customer?: number;
  /**
   * Lock Unavailable
   * @default 0
   */
  lock_unavailable?: number;
  /**
   * Lost Race
   * @default 0
   */
  lost_race?: number;
  /**
   * Skipped
   * @default 0
   */
  skipped?: number;
  /**
   * Errors
   * @default 0
   */
  errors?: number;
  /**
   * Pending
   * @default 0
   */
  pending?: number;
  /**
   * Requires Attention
   * @default 0
   */
  requires_attention?: number;
}

/** MoveToZrmAccess */
export interface MoveToZrmAccess {
  /** Allowed */
  allowed: boolean;
}

/** MoveToZrmBody */
export interface MoveToZrmBody {
  /** Reason */
  reason?: string | null;
  /**
   * Dry Run
   * @default false
   */
  dry_run?: boolean;
  /** Labels */
  labels?: string[] | null;
}

/** MoveToZrmLabelResult */
export interface MoveToZrmLabelResult {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /** Eligible */
  eligible: boolean;
  /**
   * Reasons
   * @default []
   */
  reasons?: string[];
  /**
   * Warnings
   * @default []
   */
  warnings?: string[];
  /**
   * Open Offers
   * @min 0
   * @default 0
   */
  open_offers?: number;
}

/**
 * MoveToZrmMeeting
 * A meeting of the moved row (a Sverker booking, or a v1 meeting booked in ZRM) and what the move made of it.
 */
export interface MoveToZrmMeeting {
  /** Meeting Start */
  meeting_start?: string | null;
  outcome?: Outcome | null;
  reason?: SkipReason | null;
}

/**
 * MoveToZrmResult
 * apps-mgr's answer, plus what ZRM did with it.
 */
export interface MoveToZrmResult {
  /** Moved */
  moved: boolean;
  /** Already Moved */
  already_moved: boolean;
  /** Move Id */
  move_id?: string | null;
  /** Moved At */
  moved_at?: string | null;
  /** Labels */
  labels: MoveToZrmLabelResult[];
  /**
   * Bookings
   * @default []
   */
  bookings?: SverkerBookingSnapshot[];
  /** Return At */
  return_at?: string | null;
  /** Return At Exact */
  return_at_exact?: boolean | null;
  /** V1 Meetings */
  v1_meetings?: number | null;
  /** Post Commit Done */
  post_commit_done?: boolean | null;
  /**
   * Application Mappers
   * @default []
   */
  application_mappers?: ApplicationMapping[];
  /**
   * Meetings
   * @default []
   */
  meetings?: MoveToZrmMeeting[];
}

/** MultipleApplicationMapperResponse */
export interface MultipleApplicationMapperResponse {
  /**
   * Event
   * @default "multiple_application_mappers"
   */
  event?: "multiple_application_mappers";
  /** Data */
  data?: ApplicationMapping[] | null;
}

/** Municipality */
export interface Municipality {
  /** Id */
  id: string;
  /**
   * Key
   * Used to get the correct table
   */
  key: string;
  /** Description */
  description: string;
  /** Municipality Code */
  municipality_code: string;
  country: Country;
}

/** MyDisbursedLoans */
export interface MyDisbursedLoans {
  /** Amount */
  amount: number;
  /** Sum */
  sum: number;
  /** Average Sum */
  average_sum: number;
  currency: Currency;
  /** Average Rate */
  average_rate?: number | null;
  /** Average Year */
  average_year?: number | null;
  /** Average Disbursed Time */
  average_disbursed_time?: number | null;
}

/** MyStats */
export interface MyStats {
  accepted?: AcceptedLoans | null;
  disbursed?: MyDisbursedLoans | null;
  insurance?: AllInsurances | null;
  mortgage_leads?: MortgageLeads | null;
}

/** MyStatsMb */
export interface MyStatsMb {
  /** Applications */
  applications: number;
  /** Applications Per Day */
  applications_per_day: number;
  /** Sent Loans */
  sent_loans: number;
  /** Signed */
  signed: number;
  /** Disbursed */
  disbursed: number;
  /** Co Applicants */
  co_applicants: number;
  /** Disbursed Amount */
  disbursed_amount: number;
  /** Signed Amount */
  signed_amount: number;
  /** Sent Amount */
  sent_amount: number;
  /** Co Applicant Percentage */
  co_applicant_percentage: number;
  /** Disbursement Rate */
  disbursement_rate: number;
  /** Average Team Applications */
  average_team_applications: number;
  /** Average Team Disbursed */
  average_team_disbursed: number;
  currency: Currency;
}

/** NOApplicationForm */
export interface NOApplicationForm {
  /**
   * Example-Loan-Payback-Time
   * @min 0
   * @default 0
   */
  "example-loan-payback-time"?: number;
  /**
   * Loan-Amount-Text-Field
   * @min 0
   * @default 0
   */
  "loan-amount-text-field"?: number;
  /**
   * Total-Loan-Amount
   * @min 0
   * @default 0
   */
  "total-loan-amount"?: number;
  /**
   * Slider
   * @min 0
   * @default 0
   */
  slider?: number;
  /**
   * Refinance-Question
   * @default false
   */
  "refinance-question"?: boolean;
  /**
   * Refinance-Amount
   * @default 0
   */
  "refinance-amount"?: number;
  /** Original-Loan-Purpose */
  "original-loan-purpose"?: string | null;
  "marital-status"?: MaritalStatus | null;
  /**
   * Number-Of-Children
   * @default 0
   */
  "number-of-children"?: number | null;
  /**
   * Rent-Part
   * @default "0"
   */
  "rent-part"?: string | null;
  /** @default "other" */
  "employment-type"?: EmploymentType;
  /** Employer */
  employer?: string | null;
  /** Employed-Year */
  "employed-year"?: string | null;
  /** Employed-Month */
  "employed-month"?: string | null;
  /** Employed-To-Year */
  "employed-to-year"?: string | null;
  /** Employed-To-Month */
  "employed-to-month"?: string | null;
  /** Company-Industry */
  "company-industry"?: string | null;
  /** Email */
  email?: string | null;
  /**
   * Ssn
   * @default ""
   */
  ssn?: string;
  /**
   * Email-Marketing
   * @default false
   */
  "email-marketing"?: boolean;
  /**
   * Sms-Marketing
   * @default false
   */
  "sms-marketing"?: boolean;
  /**
   * Customer-Club-Marketing
   * @default false
   */
  "customer-club-marketing"?: boolean;
  /**
   * Applicant-Pep
   * @default false
   */
  "applicant-pep"?: boolean;
  /**
   * Ms-Enabled
   * @default false
   */
  "ms-enabled"?: boolean;
  "ms-marital-status"?: MaritalStatus | null;
  /** Ms-Number-Of-Children */
  "ms-number-of-children"?: string | null;
  /** Ms-Rent-Part */
  "ms-rent-part"?: number | null;
  "ms-employment-type"?: EmploymentType | null;
  /** Ms-Employer */
  "ms-employer"?: string | null;
  /** Ms-Employed-Year */
  "ms-employed-year"?: string | null;
  /** Ms-Employed-Month */
  "ms-employed-month"?: string | null;
  /** Ms-Employed-To-Year */
  "ms-employed-to-year"?: string | null;
  /** Ms-Employed-To-Month */
  "ms-employed-to-month"?: string | null;
  /** Ms-Company-Industry */
  "ms-company-industry"?: string | null;
  /** Ms-Email */
  "ms-email"?: string | null;
  /** Ms-Ssn */
  "ms-ssn"?: string | null;
  /**
   * Ms-Applicant-Pep
   * @default false
   */
  "ms-applicant-pep"?: boolean | null;
  /**
   * Is-New-Loan-Form
   * @default false
   */
  "is-new-loan-form"?: boolean | null;
  /**
   * Credits
   * @default []
   */
  credits?: FormCredit[] | null;
  /** @default "other" */
  "loan-purpose"?: LoanPurposeNO;
  /**
   * Norsk-Statsborger
   * @default false
   */
  "norsk-statsborger"?: boolean | null;
  /** Lived-In-Country-Since-Year */
  "lived-in-country-since-year"?: string | null;
  /** Lived-In-Country-Since-Month */
  "lived-in-country-since-month"?: string | null;
  "housing-status"?: SharedBlancoNoSpecPrivateUnsecuredLoanApplicationCreatedHousingType | null;
  "housing-type"?: HousingTypeNO | null;
  /** Phone-Number */
  "phone-number"?: string | null;
  /**
   * Salary-Yearly
   * @min 0
   * @default 0
   */
  "salary-yearly"?: number;
  /**
   * Other-Income
   * @min 0
   * @default 0
   */
  "other-income"?: number;
  /** Partners-Income-Amount */
  "partners-income-amount"?: number | null;
  /** Ms-Norsk-Statsborger */
  "ms-norsk-statsborger"?: boolean | null;
  /** Ms-Lived-In-Country-Since-Year */
  "ms-lived-in-country-since-year"?: string | null;
  /** Ms-Lived-In-Country-Since-Month */
  "ms-lived-in-country-since-month"?: string | null;
  "ms-housing-status"?: SharedBlancoNoSpecPrivateUnsecuredLoanApplicationCreatedHousingType | null;
  "ms-housing-type"?: HousingTypeNO | null;
  /** Ms-Phone-Number */
  "ms-phone-number"?: string | null;
  /**
   * Ms-Salary-Yearly
   * @min 0
   * @default 0
   */
  "ms-salary-yearly"?: number;
  /**
   * Ms-Other-Income
   * @min 0
   * @default 0
   */
  "ms-other-income"?: number;
}

/** Name */
export interface Name {
  /** Name */
  name: string;
}

/**
 * NativeBudget
 * Append-only in `goal_events`; the newest one for (product, country, kh, year, month) wins.
 */
export interface NativeBudget {
  /**
   * Accepts
   * @min 0
   */
  accepts: number;
  /**
   * Disbursed
   * @min 0
   */
  disbursed: number;
  /**
   * Disbursed Amount
   * In the currency of the country
   * @min 0
   */
  disbursed_amount: number;
  /**
   * Applications
   * Non-KH only: blanco applications created
   * @min 0
   * @default 0
   */
  applications?: number;
  /**
   * Mortgage Applications
   * Non-KH only: mortgage applications created
   * @min 0
   * @default 0
   */
  mortgage_applications?: number;
  /**
   * Sign Tf
   * KH only: signed Zensum Säker (safety) insurances
   * @min 0
   * @default 0
   */
  sign_tf?: number;
  /**
   * Sign Lf
   * KH only: signed life insurances
   * @min 0
   * @default 0
   */
  sign_lf?: number;
  type_event: GoalType;
  /** User Id */
  user_id?: string[] | null;
  country: Country;
  /**
   * Year
   * What year the goal is set for
   */
  year: number;
  /**
   * Month
   * Month from 1-12
   */
  month: number;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  product: Product;
  /** Kh */
  kh: boolean;
  /** Created By */
  created_by: string;
}

/** NativeBudgetPayload */
export interface NativeBudgetPayload {
  /**
   * Accepts
   * @min 0
   */
  accepts: number;
  /**
   * Disbursed
   * @min 0
   */
  disbursed: number;
  /**
   * Disbursed Amount
   * In the currency of the country
   * @min 0
   */
  disbursed_amount: number;
  /**
   * Applications
   * Non-KH only: blanco applications created
   * @min 0
   * @default 0
   */
  applications?: number;
  /**
   * Mortgage Applications
   * Non-KH only: mortgage applications created
   * @min 0
   * @default 0
   */
  mortgage_applications?: number;
  /**
   * Sign Tf
   * KH only: signed Zensum Säker (safety) insurances
   * @min 0
   * @default 0
   */
  sign_tf?: number;
  /**
   * Sign Lf
   * KH only: signed life insurances
   * @min 0
   * @default 0
   */
  sign_lf?: number;
  /** Year */
  year: number;
  /**
   * Month
   * @min 1
   * @max 12
   */
  month: number;
}

/**
 * NativeBudgetValues
 * The KH or the non-KH budget for one month, shown on Ponytail v2 (`/ponytail/native/budget`).
 *
 * Both have accepts, disbursed and disbursed amount; only non-KH has applications and mortgage applications, only
 * KH has sign TF / LF.
 */
export interface NativeBudgetValues {
  /**
   * Accepts
   * @min 0
   */
  accepts: number;
  /**
   * Disbursed
   * @min 0
   */
  disbursed: number;
  /**
   * Disbursed Amount
   * In the currency of the country
   * @min 0
   */
  disbursed_amount: number;
  /**
   * Applications
   * Non-KH only: blanco applications created
   * @min 0
   * @default 0
   */
  applications?: number;
  /**
   * Mortgage Applications
   * Non-KH only: mortgage applications created
   * @min 0
   * @default 0
   */
  mortgage_applications?: number;
  /**
   * Sign Tf
   * KH only: signed Zensum Säker (safety) insurances
   * @min 0
   * @default 0
   */
  sign_tf?: number;
  /**
   * Sign Lf
   * KH only: signed life insurances
   * @min 0
   * @default 0
   */
  sign_lf?: number;
}

/** NativeBudgetView */
export interface NativeBudgetView {
  budget: NativeBudgetValues | null;
  /** Sellers */
  sellers: number;
  per_seller: NativeBudgetValues | null;
}

/** NativeStats */
export interface NativeStats {
  /**
   * Apps
   * @default 0
   */
  apps?: number;
  /**
   * Apps Accepted
   * @default 0
   */
  apps_accepted?: number;
  /**
   * Accepted
   * @default 0
   */
  accepted?: number;
  /**
   * Accepted Volume
   * @default 0
   */
  accepted_volume?: number;
  /**
   * Accepted Total
   * @default 0
   */
  accepted_total?: number;
  /**
   * Accepted Now
   * @default 0
   */
  accepted_now?: number;
  /**
   * Signed Total
   * @default 0
   */
  signed_total?: number;
  /**
   * Signed Now
   * @default 0
   */
  signed_now?: number;
  /**
   * Signed
   * @default 0
   */
  signed?: number;
  /**
   * Signed Volume
   * @default 0
   */
  signed_volume?: number;
  /**
   * Disbursed
   * @default 0
   */
  disbursed?: number;
  /**
   * Disbursed Volume
   * @default 0
   */
  disbursed_volume?: number;
  /**
   * Apps Mortgage
   * @default 0
   */
  apps_mortgage?: number;
  /**
   * Disbursed Mortgage
   * @default 0
   */
  disbursed_mortgage?: number;
  /**
   * Disbursed Mortgage Volume
   * @default 0
   */
  disbursed_mortgage_volume?: number;
  /**
   * Tf
   * @default 0
   */
  tf?: number;
  /**
   * Tf Premium
   * @default 0
   */
  tf_premium?: number;
  /**
   * Lf
   * @default 0
   */
  lf?: number;
  /**
   * Lf Premium
   * @default 0
   */
  lf_premium?: number;
  /**
   * Assigned
   * @default 0
   */
  assigned?: number;
  /**
   * Pipe
   * @default 0
   */
  pipe?: number;
  /**
   * Pipe Volume
   * @default 0
   */
  pipe_volume?: number;
  /** Assigned Accept Rate */
  assigned_accept_rate?: number | null;
  /** Accept Disburse Rate */
  accept_disburse_rate?: number | null;
  /** Assigned Disburse Rate */
  assigned_disburse_rate?: number | null;
  /** Average Disbursed Volume */
  average_disbursed_volume?: number | null;
}

/**
 * NativeStatsView
 * Native ZRM applications only, per user. KH: attributed to the handler (blanco, or MONO with MO X-Zoordinates);
 * others: to the creator.
 */
export interface NativeStatsView {
  totals: NativeStats;
  /** Users */
  users: NativeUserStats[];
  currency: Currency;
}

/** NativeUserStats */
export interface NativeUserStats {
  /**
   * Apps
   * @default 0
   */
  apps?: number;
  /**
   * Apps Accepted
   * @default 0
   */
  apps_accepted?: number;
  /**
   * Accepted
   * @default 0
   */
  accepted?: number;
  /**
   * Accepted Volume
   * @default 0
   */
  accepted_volume?: number;
  /**
   * Accepted Total
   * @default 0
   */
  accepted_total?: number;
  /**
   * Accepted Now
   * @default 0
   */
  accepted_now?: number;
  /**
   * Signed Total
   * @default 0
   */
  signed_total?: number;
  /**
   * Signed Now
   * @default 0
   */
  signed_now?: number;
  /**
   * Signed
   * @default 0
   */
  signed?: number;
  /**
   * Signed Volume
   * @default 0
   */
  signed_volume?: number;
  /**
   * Disbursed
   * @default 0
   */
  disbursed?: number;
  /**
   * Disbursed Volume
   * @default 0
   */
  disbursed_volume?: number;
  /**
   * Apps Mortgage
   * @default 0
   */
  apps_mortgage?: number;
  /**
   * Disbursed Mortgage
   * @default 0
   */
  disbursed_mortgage?: number;
  /**
   * Disbursed Mortgage Volume
   * @default 0
   */
  disbursed_mortgage_volume?: number;
  /**
   * Tf
   * @default 0
   */
  tf?: number;
  /**
   * Tf Premium
   * @default 0
   */
  tf_premium?: number;
  /**
   * Lf
   * @default 0
   */
  lf?: number;
  /**
   * Lf Premium
   * @default 0
   */
  lf_premium?: number;
  /**
   * Assigned
   * @default 0
   */
  assigned?: number;
  /**
   * Pipe
   * @default 0
   */
  pipe?: number;
  /**
   * Pipe Volume
   * @default 0
   */
  pipe_volume?: number;
  /** Assigned Accept Rate */
  assigned_accept_rate?: number | null;
  /** Accept Disburse Rate */
  accept_disburse_rate?: number | null;
  /** Assigned Disburse Rate */
  assigned_disburse_rate?: number | null;
  /** Average Disbursed Volume */
  average_disbursed_volume?: number | null;
  /** User Id */
  user_id: string;
  /** Name */
  name: string;
  /** Return Rate */
  return_rate?: number | null;
  /** Accept Rate */
  accept_rate?: number | null;
}

/** NewAppOption */
export interface NewAppOption {
  /** Id */
  id: string;
  /** Options */
  options: string[];
}

/** NewMortgageLoan */
export interface NewMortgageLoan {
  /** Mortgage Loan Amount */
  mortgage_loan_amount?: number | null;
  /** Down Payment */
  down_payment?: number | null;
  /** Down Payment Loan Amount */
  down_payment_loan_amount?: number | null;
  /** Bridge Loan Amount */
  bridge_loan_amount?: number | null;
  /** Disbursement Date */
  disbursement_date?: string | null;
  applying_with?: ApplyingWith | null;
  loan_purpose?: MortgageLoanType | null;
  intention_of_excess_amount?: IntentionOfExcessAmount | null;
  /** Monthly Cost Of Excess Amount */
  monthly_cost_of_excess_amount?: number | null;
  /** Max Amount */
  max_amount?: boolean | null;
  situation?: Situation | null;
  /** Private Loan Amount */
  private_loan_amount?: number | null;
}

/** NewPartialProperty */
export interface NewPartialProperty {
  property_type: MortgagePropertyType;
  /** Country */
  country?: string | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
}

/**
 * NextOfferCandidate
 * The offer a handler should reach for, picked by the shared ranking rule.
 */
export interface NextOfferCandidate {
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
  /** Bank Id */
  bank_id: number;
  /** Creditor Name */
  creditor_name: string;
  /** Amount */
  amount?: number | null;
}

/**
 * NextOfferResult
 * What the Todomaker accept-and-inform button needs to render responsibly.
 *
 * `offer` is the ranked pick (None when nothing is left to accept). The client must
 * also require `late_denial_confirmed` before offering the action: the SMS behind it
 * opens with "the bank denied your application", and without a confirmed accept that
 * message would describe something that never happened.
 */
export interface NextOfferResult {
  offer?: NextOfferCandidate | null;
  /** Late Denial Confirmed */
  late_denial_confirmed: boolean;
}

/**
 * NonEmptyString
 * @minLength 1
 */
export type NonEmptyString = string;

/** Note */
export interface Note {
  /** Cause Description */
  cause_description?: string | null;
  /** Year */
  year?: string | null;
}

/** Notification */
export interface Notification {
  type: SharedModelsNotificationsNotificationType;
  /** State Labels */
  state_labels?: AppStateLabel[] | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  app_id: string;
  /**
   * When
   * @format date-time
   */
  when: string;
  product: Product;
  country: Country;
  /** Bank Id */
  bank_id?: number | null;
  /** Customer Ids */
  customer_ids?: string[] | null;
  /** Pni */
  pni?: string | null;
  /** Online */
  online?: boolean | null;
}

/**
 * NotificationRota
 * Who to notify about an application in this product+country that has no handler.
 *
 * Stored append-only, so the same model is both the written event and the read model
 * - the newest document for a key is the current rota and the older ones are its history.
 */
export interface NotificationRota {
  product: Product;
  country: Country;
  /** Recipient Ids */
  recipient_ids?: string[];
  /** User Id */
  user_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/** NotificationRotaPayload */
export interface NotificationRotaPayload {
  /** Recipient Ids */
  recipient_ids?: string[];
}

/** NumberOfCreditsModel */
export interface NumberOfCreditsModel {
  /**
   * Total
   * Total number of credits. CSN loans are not included.
   */
  total?: number | null;
  /**
   * Housingcreditshouses
   * Total number of mortgages for house properties
   */
  housingCreditsHouses?: number | null;
  /**
   * Housingcreditstenantownersright
   * Total number of mortgages for tenant-owned flats
   */
  housingCreditsTenantOwnersRight?: number | null;
  /**
   * Creditcard
   * Total number of credit cards/account credits.
   */
  creditCard?: number | null;
  /**
   * Installments
   * Total number of installments/hire purchases
   */
  installments?: number | null;
  /**
   * Loanwithoutsecurity
   * Total number of loans without security
   */
  loanWithoutSecurity?: number | null;
}

/** NumericStats */
export interface NumericStats {
  /**
   * Sum
   * @default 0
   */
  sum?: number;
  /**
   * Avg
   * @default 0
   */
  avg?: number;
  /**
   * Median
   * @default 0
   */
  median?: number;
  /**
   * Q1
   * @default 0
   */
  q1?: number;
  /**
   * Q3
   * @default 0
   */
  q3?: number;
}

/** OPAMLResponse */
export interface OPAMLResponse {
  /**
   * Event
   * @default "op_aml"
   */
  event?: "op_aml";
  data: AMLOPResponse;
}

/** OPAMLReviewPayload */
export interface OPAMLReviewPayload {
  aml_review: AMLReviewStatus;
  /** Comment */
  comment?: string | null;
}

/** OPApplicationHistory */
export interface OPApplicationHistory {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  state: OPStatus;
  /**
   * Main Applicant Id
   * @format uuid
   */
  main_applicant_id: string;
  deactivation_reason?: OPDeactivationReason | null;
}

/** OPApplicationListItem */
export interface OPApplicationListItem {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  state: OPStatus;
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  customer?: OPCustomerSummary | null;
  country: Country;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at?: string | null;
  /** Active */
  active: boolean;
  insurance?: CanSignUp | null;
  /**
   * Insurance Error
   * @default false
   */
  insurance_error?: boolean;
  /** Other Active Applications */
  other_active_applications?: OPRelatedApplication[];
  /**
   * Other Applications Error
   * @default false
   */
  other_applications_error?: boolean;
  /** Company Info */
  company_info?: CompanyInfo[] | null;
  deactivation_reason?: OPDeactivationReason | null;
}

/** OPCustomerSummary */
export interface OPCustomerSummary {
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Pni */
  pni?: string | null;
  country?: Country | null;
}

/** OPPoaReceived */
export interface OPPoaReceived {
  /** Type */
  type: "OP_POA_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: OPPoaReceivedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** OPPoaReceivedData */
export interface OPPoaReceivedData {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Customer Id */
  customer_id: string;
  product?: Product | null;
}

/** OPRelatedApplication */
export interface OPRelatedApplication {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  product: Product;
  country: Country;
  state: AppState;
  /** Active */
  active: boolean;
}

/** OPResponseReceived */
export interface OPResponseReceived {
  /** Type */
  type: "OP_RESPONSE_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: OPResponseReceivedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** OPResponseReceivedData */
export interface OPResponseReceivedData {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Customer Id */
  customer_id: string;
  product?: Product | null;
}

/** OTPValidation */
export interface OTPValidation {
  /**
   * Session Id
   * @format password
   * @minLength 32
   * @maxLength 32
   */
  session_id: string;
  /**
   * Otp
   * @format password
   */
  otp: string;
}

/** OTPValidationResp */
export interface OTPValidationResp {
  /** Token */
  token: string;
}

/** OccupationalPensionCreate */
export interface OccupationalPensionCreate {
  /**
   * Customer Id
   * ID of the customer applying for occupational pension
   */
  customer_id: string;
  country: Country;
  /** Source of the application, if any */
  source?: ApplicationSourceInput | null;
  /**
   * Source App Id
   * ID of application source, if any
   */
  source_app_id?: string | null;
}

/** OccupationalPensionResponse */
export interface OccupationalPensionResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
}

/** Offer */
export interface Offer {
  /** Id */
  id: string;
  /** Bank Id */
  bank_id: number;
  /** Status Id */
  status_id: number;
  /**
   * Rate
   * @default 0
   */
  rate?: number;
  /**
   * Sum
   * @default 0
   */
  sum?: number | null;
  /** Status Name */
  status_name: string;
  /** External Offer Id */
  external_offer_id?: string | null;
  /** Amortization Plan */
  amortization_plan: string;
  /**
   * Sum To Solve
   * @default 0
   */
  sum_to_solve?: number | null;
  /** Monthly Payment */
  monthly_payment: number;
  /**
   * Admin Fee
   * @default 0
   */
  admin_fee?: number | null;
  /**
   * Setup Fee
   * @default 0
   */
  setup_fee?: number | null;
  /**
   * Apr
   * @default 0
   */
  apr?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Need More Info
   * @default false
   */
  need_more_info?: boolean | null;
  /**
   * Payback Time
   * Payback time in months
   */
  payback_time: number;
  /**
   * Direct Debit Fee
   * @default 0
   */
  direct_debit_fee?: number;
  /**
   * Is Accepted
   * @default false
   */
  is_accepted?: boolean | null;
  [key: string]: any;
}

/** OfferAccepted */
export interface OfferAccepted {
  /** Type */
  type: "OFFER_ACCEPTED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: OfferAcceptedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** OfferAcceptedData */
export interface OfferAcceptedData {
  /** Application Id */
  application_id: string;
  /** Bank Id */
  bank_id: number;
  product?: Product | null;
}

/** OfferHistoryEntry[BlancoOfferData] */
export interface OfferHistoryEntryBlancoOfferData {
  /**
   * Snapshot Id
   * @format uuid
   */
  snapshot_id: string;
  kind: OfferHistoryKind;
  /**
   * Event Id
   * @format uuid
   */
  event_id: string;
  /** Event Type */
  event_type: string;
  /**
   * Occurred At
   * @format date-time
   */
  occurred_at: string;
  /** Revision Offer Id */
  revision_offer_id?: string | null;
  offer: BaseOfferBlancoOfferData;
  /** Accepted Snapshot Id */
  accepted_snapshot_id?: string | null;
  /** Reason */
  reason?: string | null;
}

/** OfferHistoryEntry[CreditCardOfferData] */
export interface OfferHistoryEntryCreditCardOfferData {
  /**
   * Snapshot Id
   * @format uuid
   */
  snapshot_id: string;
  kind: OfferHistoryKind;
  /**
   * Event Id
   * @format uuid
   */
  event_id: string;
  /** Event Type */
  event_type: string;
  /**
   * Occurred At
   * @format date-time
   */
  occurred_at: string;
  /** Revision Offer Id */
  revision_offer_id?: string | null;
  offer: BaseOfferCreditCardOfferData;
  /** Accepted Snapshot Id */
  accepted_snapshot_id?: string | null;
  /** Reason */
  reason?: string | null;
}

/** OfferHistoryEntry[MortgageOffer] */
export interface OfferHistoryEntryMortgageOffer {
  /**
   * Snapshot Id
   * @format uuid
   */
  snapshot_id: string;
  kind: OfferHistoryKind;
  /**
   * Event Id
   * @format uuid
   */
  event_id: string;
  /** Event Type */
  event_type: string;
  /**
   * Occurred At
   * @format date-time
   */
  occurred_at: string;
  /** Revision Offer Id */
  revision_offer_id?: string | null;
  offer: BaseOfferMortgageOffer;
  /** Accepted Snapshot Id */
  accepted_snapshot_id?: string | null;
  /** Reason */
  reason?: string | null;
}

/** OfferItem */
export interface OfferItem {
  /** Offer Id */
  offer_id: string;
  /** Application Id */
  application_id: string;
  /** Bank Name */
  bank_name: string;
  /** Bank Id */
  bank_id: number;
  /** Offeredamount */
  offeredAmount: number;
  /** Ratepercent */
  ratePercent: number;
  /** Effectiveratepercent */
  effectiveRatePercent: number;
  /** Monthlypayment */
  monthlyPayment: number;
  /** Termmonths */
  termMonths: number;
  /** Termfee */
  termFee: number;
  /** Arrangementfee */
  arrangementFee: number;
  /** Total Cost */
  total_cost: number;
  /** Total Fees Amount */
  total_fees_amount: number;
  /** Acceptable */
  acceptable: boolean;
  /** Currency */
  currency: string;
  /** Created At */
  created_at: string;
}

/** OfferReceived */
export interface OfferReceived {
  /** Type */
  type: "OFFER_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: OfferReceivedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** OfferReceivedData */
export interface OfferReceivedData {
  /** Application Id */
  application_id: string;
  product?: Product | null;
}

/** OffersPayload */
export interface OffersPayload {
  /** Offers */
  offers: OfferItem[];
  /** Application Id */
  application_id: string;
  /** Product */
  product: string;
  /** Country */
  country: string;
  /** Count */
  count: number;
}

/** OnlineFormEventData */
export interface OnlineFormEventData {
  event_type: OnlineFormEventType;
  event_subtype?: OnlineFormEventSubType | null;
  /** Event Meta */
  event_meta?: Record<string, any> | null;
  /** Application Id */
  application_id?: string | null;
  /** Form Id */
  form_id?: string | null;
  /** Session Id */
  session_id?: string | null;
  /** Device Id */
  device_id?: string | null;
  /** Device Meta */
  device_meta?: Record<string, any> | null;
  /** Customer Id */
  customer_id?: string | null;
  /** User Agent */
  user_agent?: string | null;
  /** Event Description */
  event_description?: string | null;
}

/**
 * OnlineFormRequest
 * What the customer asked for in the online form, as submitted. The application's own amounts move with GR syncs
 * and agent edits, so the case view shows these next to them.
 */
export interface OnlineFormRequest {
  /** Submission Id */
  submission_id: string;
  /**
   * Submitted At
   * @format date-time
   */
  submitted_at: string;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
  /** Desired Amount */
  desired_amount?: number | null;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  new_loan?: BlancoLoan | null;
}

/** OnlineFormsAbandoned */
export interface OnlineFormsAbandoned {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Filling Id */
  filling_id?: string | null;
  /** Restore Id */
  restore_id?: string | null;
  /** Domain */
  domain?: string | null;
  /** Uri */
  uri?: string | null;
  /** Ip */
  ip?: string | null;
  /** Zid */
  zid?: string | null;
  /** Git Sha */
  git_sha?: string | null;
  /** Form Type */
  form_type?: string | null;
  /** Form Url */
  form_url?: string | null;
  /** Data */
  data: Record<string, any>;
  /** Quick Application */
  quick_application?:
    | (
        | ({
            product: "blanco";
          } & OptionalQuickCreateBlancoApplicationInput)
        | ({
            product: "mortgage";
          } & OptionalQuickCreateMortgageApplicationInput)
      )
    | null;
}

/** OnlineFormsEvent */
export interface OnlineFormsEvent {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Filling Id */
  filling_id?: string | null;
  /** Submission Id */
  submission_id?: string | null;
  /** Domain */
  domain?: string | null;
  /** Uri */
  uri?: string | null;
  /** Ip */
  ip?: string | null;
  /** Zid */
  zid?: string | null;
  cookies?: MarketingCookies | null;
  /** Git Sha */
  git_sha?: string | null;
  data?: OnlineFormEventData | null;
}

/** OnlineFormsTestingPNIResponse */
export interface OnlineFormsTestingPNIResponse {
  /** Se */
  se: string[];
  /** No */
  no: string[];
}

/**
 * OperatingHoursData
 * Append payload — the full weekly schedule for one (product, country) service line.
 */
export interface OperatingHoursData {
  product: Product;
  country: Country;
  /** Weekly Schedule */
  weekly_schedule: WeeklyOpenCloseInput[];
  /** Meeting Length Minutes */
  meeting_length_minutes: number;
}

/**
 * OperatingHoursDoc
 * Persisted document. Append-only: the latest `timestamp` for a key wins; never updated in place.
 */
export interface OperatingHoursDoc {
  product: Product;
  country: Country;
  /** Weekly Schedule */
  weekly_schedule: WeeklyOpenCloseOutput[];
  /** Meeting Length Minutes */
  meeting_length_minutes: number;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Created By */
  created_by: string;
  /** Request Id */
  request_id: string;
}

/**
 * OperatingHoursViolation
 * Advisory: an explicit slot falls outside (or has no) operating hours for its service line.
 */
export interface OperatingHoursViolation {
  /** Weekday */
  weekday: number;
  product: Product;
  country: Country;
  /** Slot Start */
  slot_start: string;
  /** Slot End */
  slot_end: string;
  /** Reason */
  reason: string;
}

/** Option */
export interface Option {
  /** Id */
  id: string;
  /** Option */
  option: string;
}

/** OptionalAffiliateApplicant */
export interface OptionalAffiliateApplicant {
  /**
   * Pni
   * Personal national identifier fo the customer
   */
  pni: string;
  role?: AffiliateApplicantRole | null;
  /** Occupation */
  occupation?:
    | (
        | ({
            type: "COMPANY_OWNER";
          } & AffiliateEmployer)
        | ({
            type: "EARLY_RETIRED";
          } & AffiliateNotEmployed)
        | ({
            type: "FULL";
          } & AffiliateEmployer)
        | ({
            type: "HOURLY";
          } & AffiliateEmployer)
        | ({
            type: "NO_WORK";
          } & AffiliateNotEmployed)
        | ({
            type: "PROJECT";
          } & AffiliateEmployer)
        | ({
            type: "RETIRED";
          } & AffiliateNotEmployed)
        | ({
            type: "SELF_EMPLOYED";
          } & AffiliateEmployer)
        | ({
            type: "TRIAL";
          } & AffiliateEmployer)
      )
    | null;
  /** Incomes */
  incomes?: AffiliateIncome[] | null;
  /** Phone Number */
  phone_number: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** How does the person live */
  currently_living_in?: AffiliateHousingType | null;
  /** Marital status of a person */
  marital_status?: AffiliateMaritalStatus | null;
}

/** OptionalAffiliateApplicantBlanco */
export interface OptionalAffiliateApplicantBlanco {
  /**
   * Pni
   * Personal national identifier fo the customer
   */
  pni: string;
  role?: AffiliateApplicantRole | null;
  /** Occupation */
  occupation?:
    | (
        | ({
            type: "COMPANY_OWNER";
          } & AffiliateEmployer)
        | ({
            type: "EARLY_RETIRED";
          } & AffiliateNotEmployed)
        | ({
            type: "FULL";
          } & AffiliateEmployer)
        | ({
            type: "HOURLY";
          } & AffiliateEmployer)
        | ({
            type: "NO_WORK";
          } & AffiliateNotEmployed)
        | ({
            type: "PROJECT";
          } & AffiliateEmployer)
        | ({
            type: "RETIRED";
          } & AffiliateNotEmployed)
        | ({
            type: "SELF_EMPLOYED";
          } & AffiliateEmployer)
        | ({
            type: "TRIAL";
          } & AffiliateEmployer)
      )
    | null;
  /** Incomes */
  incomes?: AffiliateIncome[] | null;
  /** Phone Number */
  phone_number: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** How does the person live */
  currently_living_in: AffiliateHousingType;
  /** Marital status of a person */
  marital_status?: AffiliateMaritalStatus | null;
  /**
   * Currently Living In Cost
   * How much does the person pay for their housing, full SEK
   * @min 0
   */
  currently_living_in_cost: number;
}

/** OptionalApplicantNO */
export interface OptionalApplicantNO {
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /** Pni */
  pni?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: PhoneNumberOutput[] | null;
  /** Sverker Id */
  sverker_id?: number | null;
  /** Children */
  children?: number | null;
  /** Citizen */
  citizen?: number | null;
  education?: EducationType | null;
  /** Monthly Partner Income */
  monthly_partner_income?: number | null;
  /** Immigrated At */
  immigrated_at?: string | null;
  /** Fullname */
  fullname?: string | null;
  /** Documents */
  documents?: ApplicantDocument[] | null;
  /** Verified Credits */
  verified_credits?: boolean | null;
  /** Housing Since */
  housing_since?: string | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Deceased Date */
  deceased_date?: string | null;
  /** Emigrated */
  emigrated?: boolean | null;
  /** Is Sanction */
  is_sanction?: boolean | null;
  /** Is Rca */
  is_rca?: boolean | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  /** Last Credit Check */
  last_credit_check?: string | null;
  /** Last Externally Verified Credits */
  last_externally_verified_credits?: string | null;
  /** Last Property Valuation */
  last_property_valuation?: string | null;
  /** Pep Quality */
  pep_quality?: boolean | null;
  /**
   * Cluster
   * A cluster is a group of customers displayed with a color
   */
  cluster?: string | null;
  /**
   * Is Blocked
   * Indicates if the customer is blocked
   * @default false
   */
  is_blocked?: boolean;
  /** Current email verification status, set only by EMAIL_VERIFICATION events */
  email_verification?: EmailVerification | null;
  /**
   * Zrm Only
   * Customer is handled in ZRM only (not in Sverker; derived)
   * @default false
   */
  zrm_only?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: OptionalEmployerNO | null;
  /** Ev Estate */
  ev_estate?: EvEstate[] | null;
  /** Ev Estates */
  ev_estates?: EvProperty[] | null;
  /** Ev Checked At */
  ev_checked_at?: string | null;
  /** Citizenship Iso Codes */
  citizenship_iso_codes?: string[] | null;
  /** Grunnkrets */
  grunnkrets?: string | null;
  /**
   * Cars In The Household
   * Number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Externally Verified Credits */
  externally_verified_credits?: ExternallyVerifiedCreditOutput[] | null;
  /** Customer Id */
  customer_id?: string | null;
  credit_check?: CreditCheckNO | null;
  external_block_check?: ExternalBlockCheckNO | null;
}

/** OptionalApplicantSE */
export interface OptionalApplicantSE {
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /** Pni */
  pni?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: PhoneNumberOutput[] | null;
  /** Sverker Id */
  sverker_id?: number | null;
  /** Children */
  children?: number | null;
  /** Citizen */
  citizen?: number | null;
  education?: EducationType | null;
  /** Monthly Partner Income */
  monthly_partner_income?: number | null;
  /** Immigrated At */
  immigrated_at?: string | null;
  /** Fullname */
  fullname?: string | null;
  /** Documents */
  documents?: ApplicantDocument[] | null;
  /** Verified Credits */
  verified_credits?: boolean | null;
  /** Housing Since */
  housing_since?: string | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Deceased Date */
  deceased_date?: string | null;
  /** Emigrated */
  emigrated?: boolean | null;
  /** Is Sanction */
  is_sanction?: boolean | null;
  /** Is Rca */
  is_rca?: boolean | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  /** Last Credit Check */
  last_credit_check?: string | null;
  /** Last Externally Verified Credits */
  last_externally_verified_credits?: string | null;
  /** Last Property Valuation */
  last_property_valuation?: string | null;
  /** Pep Quality */
  pep_quality?: any;
  /**
   * Cluster
   * A cluster is a group of customers displayed with a color
   */
  cluster?: string | null;
  /**
   * Is Blocked
   * Indicates if the customer is blocked
   * @default false
   */
  is_blocked?: boolean;
  /** Current email verification status, set only by EMAIL_VERIFICATION events */
  email_verification?: EmailVerification | null;
  /**
   * Zrm Only
   * Customer is handled in ZRM only (not in Sverker; derived)
   * @default false
   */
  zrm_only?: boolean;
  housing_type?: HousingTypeSE | null;
  employer?: OptionalEmployerSE | null;
  /** Census Registration Year */
  census_registration_year?: string | null;
  /** Credit Regulation Information */
  credit_regulation_information?: CreditRegulationInformation[] | null;
  /** Credit Regulations */
  credit_regulations?: CreditRegulation[] | null;
  /** Case Collection */
  case_collection?: CaseCollectionItem[] | null;
  /** Current Section Of Case */
  current_section_of_case?: CurrentSectionOfCaseItem[] | null;
  /** Current Frame */
  current_frame?: CurrentFrameItem[] | null;
  /** Html */
  html?: string | null;
  /** Last Queries */
  last_queries?: LastQuery[] | null;
  /** Notes */
  notes?: Note[] | null;
  /** Tax */
  tax?: TaxItem[] | null;
  /** Tax Thousands */
  tax_thousands?: TaxThousand[] | null;
  /** Fraudster */
  fraudster?: boolean | null;
  /** Investigation Barrier */
  investigation_barrier?: boolean | null;
  /** Uc Interall */
  uc_interall?: string | null;
  /** Date Of Birth */
  date_of_birth?: string | null;
  /** Prenup Text */
  prenup_text?: string | null;
  /** Uc Internal 2 */
  uc_internal_2?: null;
  /** Parish */
  parish?: string | null;
  /** Parish Code */
  parish_code?: string | null;
  /** Blocked */
  blocked?: boolean | null;
  /** Protected Address */
  protected_address?: boolean | null;
  /** Protected Identity */
  protected_identity?: boolean | null;
  /** Marital Status Date */
  marital_status_date?: string | null;
  /** Minor */
  minor?: string | null;
  /** Lost Id Documents */
  lost_id_documents?: boolean | null;
  /** County */
  county?: string | null;
  /** County Code */
  county_code?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  credit_check?: CreditCheckSE | null;
}

/**
 * OptionalCreateApplicantNO
 * Model used only for mapping jotform data to Applicant model, allowing some more fields to be optional
 */
export interface OptionalCreateApplicantNO {
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /** Pni */
  pni: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Additional Phone Numbers */
  additional_phone_numbers?: string[] | null;
  /** Monthly Property Cost */
  monthly_property_cost?: number | null;
  marital_status?: MaritalStatus | null;
  /** Official marital status from ID check; should not be modified; marital_status has higher priority */
  registered_marital_status?: MaritalStatus | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Incomes */
  incomes?: Income[] | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
  account?: Account | null;
  /** Street Address */
  street_address?: string | null;
  /**
   * Paying Child Support
   * Number of children to pay child support for
   */
  paying_child_support?: number | null;
  /**
   * Receiving Child Support
   * Number of children to receive child support for
   */
  receiving_child_support?: number | null;
  consents?: Consents | null;
  /** Consents Popup Dismissed Timestamp */
  consents_popup_dismissed_timestamp?: string | null;
  /** Partner Pni */
  partner_pni?: string | null;
  /** Partner Name */
  partner_name?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Municipality */
  municipality?: string | null;
  /** Is Pep */
  is_pep?: boolean | null;
  /** Age */
  age?: number | null;
  /** Other Phones */
  other_phones?: PhoneNumberOutput[] | null;
  /** Sverker Id */
  sverker_id?: number | null;
  /** Children */
  children?: number | null;
  /** Citizen */
  citizen?: number | null;
  education?: EducationType | null;
  /** Monthly Partner Income */
  monthly_partner_income?: number | null;
  /** Immigrated At */
  immigrated_at?: string | null;
  /** Fullname */
  fullname?: string | null;
  /** Documents */
  documents?: ApplicantDocument[] | null;
  /** Verified Credits */
  verified_credits?: boolean | null;
  /** Housing Since */
  housing_since?: string | null;
  /** Deceased */
  deceased?: boolean | null;
  /** Deceased Date */
  deceased_date?: string | null;
  /** Emigrated */
  emigrated?: boolean | null;
  /** Is Sanction */
  is_sanction?: boolean | null;
  /** Is Rca */
  is_rca?: boolean | null;
  /** Date Created */
  date_created?: string | null;
  /** Date Updated */
  date_updated?: string | null;
  /** Last Credit Check */
  last_credit_check?: string | null;
  /** Last Externally Verified Credits */
  last_externally_verified_credits?: string | null;
  /** Last Property Valuation */
  last_property_valuation?: string | null;
  /** Pep Quality */
  pep_quality?: boolean | null;
  /**
   * Cluster
   * A cluster is a group of customers displayed with a color
   */
  cluster?: string | null;
  /**
   * Is Blocked
   * Indicates if the customer is blocked
   * @default false
   */
  is_blocked?: boolean;
  /** Current email verification status, set only by EMAIL_VERIFICATION events */
  email_verification?: EmailVerification | null;
  /**
   * Zrm Only
   * Customer is handled in ZRM only (not in Sverker; derived)
   * @default false
   */
  zrm_only?: boolean;
  housing_type?: HousingTypeNO | null;
  employer?: OptionalEmployerNO | null;
  /** Cars In The Household */
  cars_in_the_household?: number | null;
}

/** OptionalCreditCardApplicationDataCreate */
export interface OptionalCreditCardApplicationDataCreate {
  /** Desired Credit Limit */
  desired_credit_limit?: number | null;
  /** Car */
  car?: boolean | null;
  /** Student Loans Amount */
  student_loans_amount?: number | null;
  /** Student Loans Monthly Payment */
  student_loans_monthly_payment?: number | null;
  /** Car Boat Mc Loans Amount */
  car_boat_mc_loans_amount?: number | null;
  /** Car Boat Mc Loans Monthly Payment */
  car_boat_mc_loans_monthly_payment?: number | null;
  /** Total Consumer Loans Amount */
  total_consumer_loans_amount?: number | null;
  /** Total Consumer Loans Monthly Payment */
  total_consumer_loans_monthly_payment?: number | null;
  /** Mortgage Loans Amount */
  mortgage_loans_amount?: number | null;
  /** Mortgage Loans Monthly Payment */
  mortgage_loans_monthly_payment?: number | null;
  /** Credit Card Debt Amount */
  credit_card_debt_amount?: number | null;
  /** Credit Card Debt Monthly Payment */
  credit_card_debt_monthly_payment?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Application Score */
  application_score?: number | null;
  /**
   * Duplicate Of
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  duplicate_of?: string | null;
}

/** OptionalEmployerNO */
export interface OptionalEmployerNO {
  /** Name */
  name?: string | null;
  type?: EmploymentTypeNO | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  /** Phone */
  phone?: string | null;
  /** Retirement Age */
  retirement_age?: number | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Profession */
  profession?: string | null;
  /** Monthly Other Income */
  monthly_other_income?: number | null;
}

/** OptionalEmployerSE */
export interface OptionalEmployerSE {
  /** Name */
  name?: string | null;
  type?: EmploymentTypeSE | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  /** Phone */
  phone?: string | null;
  /** Retirement Age */
  retirement_age?: number | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Profession */
  profession?: string | null;
  /** Monthly Other Income */
  monthly_other_income?: number | null;
}

/** OptionalIncome */
export interface OptionalIncome {
  /**
   * Amount
   * Monthly amount
   * @min 0
   * @default 0
   */
  amount?: number;
  /**
   * Yearly Amount
   * Yearly amount
   * @min 0
   * @default 0
   */
  yearly_amount?: number;
  currency?: Currency | null;
  type?: IncomeType | null;
  /** Name */
  name?: string | null;
}

/** OptionalPropertyAddress */
export interface OptionalPropertyAddress {
  streetAddress?: NonEmptyString | null;
  city?: NonEmptyString | null;
  postalCode?: NonEmptyString | null;
  municipality?: NonEmptyString | null;
}

/** OptionalQuickApplicant */
export interface OptionalQuickApplicant {
  /**
   * Pni
   * Personal national identifier fo the customer
   */
  pni?: string | null;
  role?: ApplicantRole | null;
  employer?: OptionalQuickApplicantEmployer | null;
  /** Incomes */
  incomes?: (OptionalIncome | null)[] | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Email */
  email?: string | "" | null;
  /**
   * Housing Type
   * How does the person live
   */
  housing_type?: HousingTypeSE | HousingTypeNO | null;
  /**
   * Currently Living In Cost
   * How much does the person pay for their housing, full SEK
   */
  currently_living_in_cost?: number | null;
  /** Marital status of a person */
  marital_status?: MaritalStatus | null;
  education?: EducationType | null;
  /**
   * Immigrated At
   * NORWAY only - when immigrated to Norway
   */
  immigrated_at?: string | null;
  /**
   * Citizenship
   * NORWAY only - is applicant Norway citizen or not
   */
  citizenship?: boolean | null;
}

/** OptionalQuickApplicantEmployer */
export interface OptionalQuickApplicantEmployer {
  /** Name */
  name?: string | null;
  /** Type */
  type?: EmploymentType | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  /** Phone */
  phone?: string | null;
  /** Retirement Age */
  retirement_age?: number | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Profession */
  profession?: string | null;
  /** Monthly Other Income */
  monthly_other_income?: number | null;
}

/** OptionalQuickChildren */
export interface OptionalQuickChildren {
  /**
   * Childrenbelow18
   * Number of children under the age of 18
   */
  childrenBelow18?: number | null;
  /** Childrenbelow18Fulltime */
  childrenBelow18FullTime?: number | null;
  /** Receivingchildsupport */
  receivingChildSupport?: number | null;
  /** Payingchildsupport */
  payingChildSupport?: number | null;
}

/** OptionalQuickCreateBlancoApplication */
export interface OptionalQuickCreateBlancoApplicationInput {
  /** Product */
  product: "blanco";
  new_loan?: BlancoLoan | null;
  /** Sverker user when creating a legacy blanco app */
  sverker_user?: SverkerUsername | null;
  aml?: BlancoAMLPatchPayload | null;
  /**
   * Desired Amount
   * Desired loan amount
   */
  desired_amount?: number | null;
  country: Country;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Should Remind About Meeting */
  should_remind_about_meeting?: boolean | null;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  /** Applicants */
  applicants: OptionalQuickApplicant[];
  /** Loans */
  loans?: Loan[] | null;
  children?: OptionalQuickChildren | null;
  /**
   * Cars In The Household
   * NORWAY only - number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Internal Comment */
  internal_comment?: string | null;
  /** Comments */
  comments?: string[] | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  source?: ApplicationSourceInput | null;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  consents?: Consents | null;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
}

/** OptionalQuickCreateBlancoApplication */
export interface OptionalQuickCreateBlancoApplicationOutput {
  /** Product */
  product: "blanco";
  new_loan?: BlancoLoan | null;
  /** Sverker user when creating a legacy blanco app */
  sverker_user?: SverkerUsername | null;
  aml?: BlancoAMLPatchPayload | null;
  /**
   * Desired Amount
   * Desired loan amount
   */
  desired_amount?: number | null;
  country: Country;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Should Remind About Meeting */
  should_remind_about_meeting?: boolean | null;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  /** Applicants */
  applicants: OptionalQuickApplicant[];
  /** Loans */
  loans?: Loan[] | null;
  children?: OptionalQuickChildren | null;
  /**
   * Cars In The Household
   * NORWAY only - number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Internal Comment */
  internal_comment?: string | null;
  /** Comments */
  comments?: string[] | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  source?: ModelsApplicationMappingApplicationMappingApplicationSource | null;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  consents?: Consents | null;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
}

/** OptionalQuickCreateMortgageApplication */
export interface OptionalQuickCreateMortgageApplicationInput {
  /** Product */
  product: "mortgage";
  new_loan?: BlancoLoan | null;
  /**
   * Desired Amount
   * Desired loan amount
   */
  desired_amount?: number | null;
  country: Country;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Should Remind About Meeting */
  should_remind_about_meeting?: boolean | null;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  /** Applicants */
  applicants: OptionalQuickApplicant[];
  /** Loans */
  loans?: Loan[] | null;
  children?: OptionalQuickChildren | null;
  /**
   * Cars In The Household
   * NORWAY only - number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Internal Comment */
  internal_comment?: string | null;
  /** Comments */
  comments?: string[] | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  source?: ApplicationSourceInput | null;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  consents?: Consents | null;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
}

/** OptionalQuickCreateMortgageApplication */
export interface OptionalQuickCreateMortgageApplicationOutput {
  /** Product */
  product: "mortgage";
  new_loan?: BlancoLoan | null;
  /**
   * Desired Amount
   * Desired loan amount
   */
  desired_amount?: number | null;
  country: Country;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Should Remind About Meeting */
  should_remind_about_meeting?: boolean | null;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  /** Applicants */
  applicants: OptionalQuickApplicant[];
  /** Loans */
  loans?: Loan[] | null;
  children?: OptionalQuickChildren | null;
  /**
   * Cars In The Household
   * NORWAY only - number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Internal Comment */
  internal_comment?: string | null;
  /** Comments */
  comments?: string[] | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  source?: ModelsApplicationMappingApplicationMappingApplicationSource | null;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  consents?: Consents | null;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
}

/** Order */
export interface Order {
  /**
   * Created At
   * @default "desc"
   */
  created_at?: "asc" | "desc" | null;
  /**
   * Updated At
   * @default "desc"
   */
  updated_at?: "asc" | "desc" | null;
}

/**
 * OriginStruct
 * One application's dbt `source_struct` (map_application_origin.sql:731-921), as the case view needs it.
 *
 * Every value is a plain string (the `accept_actor` precedent), and the rating is read leniently: a value written
 * by an older or newer release must never make the mapper fail validation.
 */
export interface OriginStruct {
  /** Kind */
  kind: string;
  /** Rule */
  rule: string;
  /** Detail */
  detail?: string | null;
  /** Sales Direction */
  sales_direction?: string | null;
  /** Sales Channel */
  sales_channel?: string | null;
  /** Inbound Channel */
  inbound_channel?: string | null;
  /** Affiliate Id */
  affiliate_id?: string | null;
  /** Lead Id */
  lead_id?: string | null;
  /** Campaign Id */
  campaign_id?: string | null;
  /** Campaign Description */
  campaign_description?: string | null;
  /** Campaign Super Type */
  campaign_super_type?: string | null;
  /** Campaign */
  campaign?: string | null;
  /** Campaign Detail */
  campaign_detail?: string | null;
  /** Campaign Product */
  campaign_product?: string | null;
  /** Rating */
  rating?: number | null;
}

/** OtherProperty */
export interface OtherProperty {
  /** Monthly Cost */
  monthly_cost: number;
  /** Mortgage Amount */
  mortgage_amount?: number | null;
  property_type: SharedModelsApplicationPropertyType;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Property Ownership Share */
  property_ownership_share?: number | null;
  /** Loan Ownership Share */
  loan_ownership_share?: number | null;
  /** Interest Rate */
  interest_rate?: number | null;
  /** Monthly Amortization */
  monthly_amortization?: number | null;
  /** Lender */
  lender?: string | null;
}

/**
 * OutboundEmailAttachment
 * Agent-supplied attachment for an outbound email — base64-encoded file content.
 */
export interface OutboundEmailAttachment {
  /** Filename */
  filename: string;
  /**
   * Content Type
   * @default "application/octet-stream"
   */
  content_type?: string;
  /**
   * Content
   * Base64-encoded file content
   */
  content: string;
}

/** OutcomeCount */
export interface OutcomeCount {
  /** Users */
  users: UserOutcomeCount[];
  total: UserOutcomeCount;
}

/** Outcomes */
export interface Outcomes {
  /** No Contact */
  no_contact: string[];
  /** Failure */
  failure: string[];
  /** Discard */
  discard: string[];
}

/** OutcomesResponse */
export interface OutcomesResponse {
  /**
   * Event
   * @default "outcomes"
   */
  event?: "outcomes";
  /** Data */
  data: (
    | ({
        type: "CALL_BACK";
      } & CallOutcomeCallBack)
    | ({
        type: "DISCARD";
      } & CallOutcomeDiscard)
    | ({
        type: "FAILURE";
      } & CallOutcomeFailure)
    | ({
        type: "NO_CONTACT";
      } & CallOutcomeNoContact)
    | ({
        type: "SUCCESS";
      } & CallOutcomeSuccess)
  )[];
}

/**
 * OverrideOwnerPayload
 * A team lead's override.
 *
 * ``takeover_reason`` turns it into a takeover: the new record is ``out_of_pool`` and its
 * value lines are copied over unchanged, so the value stays readable on the case and stops
 * counting against the blanco pool.
 */
export interface OverrideOwnerPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * Distribution Op Id
   * @minLength 1
   * @maxLength 200
   */
  distribution_op_id: string;
  /** Expected Previous Owner Id */
  expected_previous_owner_id: string | null;
  /** Handler Id */
  handler_id: string;
  takeover_reason?: TakeoverReason | null;
}

/** Owner */
export interface Owner {
  /** Identity */
  Identity?: string | null;
  /** Identitytype */
  IdentityType?: string | null;
  /** Name */
  Name?: string | null;
  /** Role */
  Role?: string | null;
  /** Sharenumerator */
  ShareNumerator?: number | null;
  /** Sharedenominator */
  ShareDenominator?: number | null;
}

/**
 * OwnerFlags
 * Booleans rather than a list, because the accumulators filter on
 * ``owner_flags.out_of_pool`` and an index cannot be built on set membership.
 */
export interface OwnerFlags {
  /**
   * Stale Snapshot
   * @default false
   */
  stale_snapshot?: boolean;
  /**
   * Seeded Value
   * @default false
   */
  seeded_value?: boolean;
  /**
   * Out Of Pool
   * @default false
   */
  out_of_pool?: boolean;
  /**
   * No Customer Id
   * @default false
   */
  no_customer_id?: boolean;
  /**
   * Mortgage Pending
   * @default false
   */
  mortgage_pending?: boolean;
  /**
   * Re Decided
   * @default false
   */
  re_decided?: boolean;
  /**
   * Inherited Out Of Pool
   * @default false
   */
  inherited_out_of_pool?: boolean;
}

/** Ownership */
export interface Ownership {
  /** Sharenumerator */
  ShareNumerator?: number | null;
  /** Sharedenominator */
  ShareDenominator?: number | null;
  /** Role */
  Role?: string | null;
  /** Ownercount */
  OwnerCount?: number | null;
  /** Isownerfound */
  IsOwnerFound?: boolean | null;
  /** Owners */
  Owners?: Owner[] | null;
}

/**
 * OwnershipHealth
 * How much of the book the phase actually owns, and what is drifting.
 *
 * ``pool_meetings`` is the denominator every share here is taken over: future meetings in
 * the reconciliation's scope, held by a pool handler or by nobody. ``owned`` and ``unowned``
 * partition it, which is the identity :meth:`reconciles` asserts. ``collisions_real_book`` is
 * the share of meetings sharing a (handler, quarter) on the book as it is — read *beside*
 * ``p_owned`` and never on its own, since the expected level interpolates between the owned
 * and unowned regimes.
 *
 * The two snapshot buckets answer different questions. ``snapshots_awaiting_owner`` is a
 * level, not a fault: a snapshot with no owner record behind it is the *normal* end of the
 * wait for an application that reached the horizon unbooked. ``snapshots_orphaned`` is the
 * alarm and the discriminating subset of it — the label is on a **superseded** record and on
 * no active one, the only shape the INHERIT race can leave behind, with no steady state.
 * ``late_transfer_*`` is an owner change after the accounting week closed: allowed, the value
 * follows the owner, but it moves money between two already reported weeks.
 */
export interface OwnershipHealth {
  /**
   * Owned Cases
   * @default 0
   */
  owned_cases?: number;
  /**
   * Owned Meetings
   * @default 0
   */
  owned_meetings?: number;
  /**
   * Unowned Meetings
   * @default 0
   */
  unowned_meetings?: number;
  /**
   * Pool Meetings
   * @default 0
   */
  pool_meetings?: number;
  /**
   * Collisions Real Book
   * @default 0
   */
  collisions_real_book?: number;
  /**
   * Snapshots Awaiting Owner
   * @default 0
   */
  snapshots_awaiting_owner?: number;
  /**
   * Snapshots Orphaned
   * @default 0
   */
  snapshots_orphaned?: number;
  /**
   * Snapshots Checked
   * @default 0
   */
  snapshots_checked?: number;
  /**
   * Late Transfer Cases
   * @default 0
   */
  late_transfer_cases?: number;
  /**
   * Late Transfer Amount
   * @default 0
   */
  late_transfer_amount?: number;
  /**
   * Meetings Truncated
   * @default false
   */
  meetings_truncated?: boolean;
}

/** PNI */
export interface PNI {
  country?: Country | null;
  /** Pni */
  pni: string;
}

/** Page[Annotated[Union[BankBlancoApplication, BankMortgageApplication, BankApplicationCCNO], FieldInfo(annotation=NoneType, required=True, discriminator='product')]] */
export interface PageAnnotatedUnionBankBlancoApplicationBankMortgageApplicationBankApplicationCCNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorProduct {
  /** Items */
  items: (
    | ({
        product: "blanco";
      } & BankBlancoApplication)
    | ({
        product: "credit_card";
      } & BankApplicationCCNO)
    | ({
        product: "mortgage";
      } & BankMortgageApplication)
  )[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[CampaignExtraction] */
export interface PageCampaignExtraction {
  /** Items */
  items: CampaignExtraction[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[Campaign] */
export interface PageCampaign {
  /** Items */
  items: ModelsDialMaker2CampaignAggregateCampaign[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[CreditCardApplicationExtended] */
export interface PageCreditCardApplicationExtended {
  /** Items */
  items: CreditCardApplicationExtended[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[DMLead] */
export interface PageDMLead {
  /** Items */
  items: DMLead[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[FileDetails] */
export interface PageFileDetails {
  /** Items */
  items: FileDetails[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[InternalCommentSSE] */
export interface PageInternalCommentSSE {
  /** Items */
  items: InternalCommentSSE[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[OPApplicationListItem] */
export interface PageOPApplicationListItem {
  /** Items */
  items: OPApplicationListItem[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[Sheet] */
export interface PageSheet {
  /** Items */
  items: SheetOutput[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[URL] */
export interface PageURL {
  /** Items */
  items: URL[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Page[Union[Annotated[Union[RawBlancoApplicationSE, RawBlancoApplicationNO], FieldInfo(annotation=NoneType, required=True, discriminator='country')], RawCreditCardApplicationNO, Annotated[Union[RawMortgageApplicationSE, RawMortgageApplicationNO], FieldInfo(annotation=NoneType, required=True, discriminator='country')]]] */
export interface PageUnionAnnotatedUnionRawBlancoApplicationSERawBlancoApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountryRawCreditCardApplicationNOAnnotatedUnionRawMortgageApplicationSERawMortgageApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountry {
  /** Items */
  items: (
    | (
        | ({
            country: "NO";
          } & RawBlancoApplicationNO)
        | ({
            country: "SE";
          } & RawBlancoApplicationSE)
      )
    | RawCreditCardApplicationNO
    | (
        | ({
            country: "NO";
          } & RawMortgageApplicationNO)
        | ({
            country: "SE";
          } & RawMortgageApplicationSE)
      )
  )[];
  /** Total */
  total?: number | null;
  /** Page */
  page: number | null;
  /** Size */
  size: number | null;
  /** Pages */
  pages?: number | null;
}

/** Pagination */
export interface Pagination {
  /**
   * Page
   * @default 0
   */
  page?: number | null;
  /**
   * Limit
   * @default 50
   */
  limit?: number | null;
}

/** PaginationData */
export interface PaginationData {
  /** Target */
  target: "applications" | "meetings";
  /**
   * Total
   * @default 0
   */
  total?: number;
  /**
   * Page
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Pages
   * @min 1
   * @default 1
   */
  pages?: number;
}

/** PaginationResponse */
export interface PaginationResponse {
  /**
   * Event
   * @default "pagination"
   */
  event?: "pagination";
  data: PaginationData;
}

/** Params */
export interface Params {
  /**
   * Page
   * Page number
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Size
   * Page size
   * @min 1
   * @max 100000
   * @default 50
   */
  size?: number;
}

/** PartialCondominium */
export interface PartialCondominium {
  /** Property Type */
  property_type: "CONDOMINIUM";
  country: Country;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Other Owner */
  other_owner?: boolean | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** External Id */
  external_id?: string | null;
  /** Latitude */
  latitude?: number | null;
  /** Longitude */
  longitude?: number | null;
  ev_partial?: EvPartialCommon | null;
  /** Estate Type */
  estate_type?: string | null;
  /** Apartment Number */
  apartment_number?: string | null;
  /** Elevator */
  elevator?: boolean | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Organization Name */
  organization_name?: string | null;
  /** Organization Share Number */
  organization_share_number?: string | null;
  /** Floor */
  floor?: number | null;
  balcony_type?: BalconyType | null;
  /** Rooms */
  rooms?: number | null;
}

/** PartialHouse */
export interface PartialHouse {
  /** Property Type */
  property_type: "HOUSE";
  country: Country;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Other Owner */
  other_owner?: boolean | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** External Id */
  external_id?: string | null;
  /** Latitude */
  latitude?: number | null;
  /** Longitude */
  longitude?: number | null;
  ev_partial?: EvPartialCommon | null;
  /** Estate Type */
  estate_type?: string | null;
  /** Cadastral Designation */
  cadastral_designation?: string | null;
}

/** PartialProperty */
export interface PartialProperty {
  /** Property Id */
  property_id: string;
  property_type: MortgagePropertyType;
  /** Country */
  country?: string | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
}

/** PartialVacationHome */
export interface PartialVacationHome {
  /** Property Type */
  property_type: "VACATION_HOME";
  country: Country;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Other Owner */
  other_owner?: boolean | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** External Id */
  external_id?: string | null;
  /** Latitude */
  latitude?: number | null;
  /** Longitude */
  longitude?: number | null;
  ev_partial?: EvPartialCommon | null;
  /** Estate Type */
  estate_type?: string | null;
  /** Cadastral Designation */
  cadastral_designation?: string | null;
}

/** PayNowLink */
export interface PayNowLink {
  /** Link */
  link: string;
}

/** Peer */
export interface Peer {
  /**
   * People With Debts
   * @default 0
   */
  people_with_debts?: number;
  /**
   * Age Bucket
   * @default ""
   */
  age_bucket?: string;
  /**
   * Min Age
   * @default 0
   */
  min_age?: number;
  /** Max Age */
  max_age?: number | null;
  /**
   * Location Type
   * @default "bydel"
   */
  location_type?: string;
  /**
   * Location Code
   * @default ""
   */
  location_code?: string;
  /**
   * Location Name
   * @default ""
   */
  location_name?: string;
  /**
   * Snapshot Month
   * @default ""
   */
  snapshot_month?: string;
  credit_types?: PeerCreditTypes;
  totals?: PeerTotals;
}

/** PeerCreditTypeMetrics */
export interface PeerCreditTypeMetrics {
  /**
   * People
   * @default 0
   */
  people?: number;
  /**
   * Credits
   * @default 0
   */
  credits?: number;
  balance?: NumericStats;
  int_bal?: NumericStats | null;
  non_int_bal?: NumericStats | null;
}

/** PeerCreditTypes */
export interface PeerCreditTypes {
  repayment_loan?: PeerCreditTypeMetrics;
  other_unsecured?: PeerCreditTypeMetrics;
  charge_card?: PeerCreditTypeMetrics;
  credit_facility?: PeerCreditTypeMetrics;
}

/** PeerTotals */
export interface PeerTotals {
  /**
   * Avg Number Of Credits
   * @default 0
   */
  avg_number_of_credits?: number;
  /**
   * Median Number Of Credits
   * @default 0
   */
  median_number_of_credits?: number;
  total_balance?: NumericStats;
  int_balance?: NumericStats;
  non_int_balance?: NumericStats;
  credit_limit?: NumericStats;
}

/**
 * Person
 * These fields only appear in pipeline
 */
export interface Person {
  /** Zid */
  zid: string;
  /** Session Zid */
  session_zid?: string | null;
  /** Pni */
  pni?: string | File | Blob | null;
  /** Customer Id */
  customer_id?: string | null;
  /** Gid */
  gid?: string | null;
  /** Affiliate Id */
  affiliate_id?: string | null;
  product?: Product | null;
  affiliate_product?: AffiliateProduct | null;
  country?: Country | null;
  /** Landing Params */
  landing_params?: Record<string, any> | null;
  /** Landing Url */
  landing_url?: string | null;
  /** Cookie Consent */
  cookie_consent?: Record<string, any> | null;
  /** Google Session Id */
  google_session_id?: number | null;
  /** Ip Address */
  ip_address?: string | File | Blob | null;
  /** Email Key */
  email_key?: string | null;
  /** Request Data */
  request_data?: Record<string, any> | null;
  /** Sms Key */
  sms_key?: string | null;
  /** Url Record Key */
  url_record_key?: string | null;
  /** Insurance Type */
  insurance_type?: string | null;
  status: PersonStatus;
  /**
   * Last Activity
   * @format date-time
   */
  last_activity: string;
  /**
   * Initialized At
   * @format date-time
   */
  initialized_at: string;
  /** Last Application Created At */
  last_application_created_at?: string | null;
  /** Last Disbursed At */
  last_disbursed_at?: string | null;
}

/** Personal */
export interface Personal {
  /**
   * Total Unsecured Debt Nok
   * @default 0
   */
  total_unsecured_debt_nok?: number;
  /**
   * Interest Bearing Debt Nok
   * @default 0
   */
  interest_bearing_debt_nok?: number;
  /**
   * Non Interest Bearing Debt Nok
   * @default 0
   */
  non_interest_bearing_debt_nok?: number;
  /**
   * Total Credit Limit Nok
   * @default 0
   */
  total_credit_limit_nok?: number;
  /**
   * Number Of Creditors
   * @default 0
   */
  number_of_creditors?: number;
  /** Credit Card Utilization */
  credit_card_utilization?: number | null;
  /** Weighted Interest Rate */
  weighted_interest_rate?: number | null;
  /** By Credit Type */
  by_credit_type?: Record<string, PersonalCreditTypeTotals>;
}

/** PersonalCallback */
export interface PersonalCallback {
  /**
   * First At
   * @format date-time
   */
  first_at: string;
  /**
   * Last At
   * @format date-time
   */
  last_at: string;
  /**
   * Count
   * @exclusiveMin 0
   */
  count: number;
}

/** PersonalCreditTypeTotals */
export interface PersonalCreditTypeTotals {
  /**
   * Credits
   * @default 0
   */
  credits?: number;
  /**
   * Total Balance
   * @default 0
   */
  total_balance?: number;
  /**
   * Interest Bearing Balance
   * @default 0
   */
  interest_bearing_balance?: number;
  /**
   * Non Interest Bearing Balance
   * @default 0
   */
  non_interest_bearing_balance?: number;
}

/** PhoneGetCustomerPayload */
export interface PhoneGetCustomerPayload {
  /** Reason */
  reason: string;
  /** Phone Number */
  phone_number: string;
}

/** PhoneNumber */
export interface PhoneNumberOutput {
  /** Number */
  number: string;
  type: PhoneNumberType;
}

/**
 * PlanResult
 * A whole planning pass, replayable and diffable.
 *
 * ``snapshot_revision`` hashes the inputs the decision was made from — pool, candidates,
 * occupancy, schedule, settings and the Oslo run date — so a save can be rejected cheaply. Only
 * the fast reject: the save path re-plans under the lock and diffs, because a matching hash does
 * not mean a human did not edit the grid.
 */
export interface PlanResult {
  /**
   * Now
   * @format date-time
   */
  now: string;
  /** Snapshot Revision */
  snapshot_revision: string;
  /** Assignments */
  assignments?: Record<string, string>;
  /** Candidates */
  candidates?: PlannedCandidate[];
  /** Dropped Reasons */
  dropped_reasons?: Record<string, number>;
  /** Unassigned Reasons */
  unassigned_reasons?: Record<string, number>;
  /** Per Handler */
  per_handler?: Record<string, HandlerLoad>;
}

/**
 * PlannedCandidate
 * One candidate's outcome, which is what the run report is serialized from.
 */
export interface PlannedCandidate {
  /** Meeting Id */
  meeting_id: string;
  /** Previous Handler Id */
  previous_handler_id?: string | null;
  /** Target Handler Id */
  target_handler_id?: string | null;
  /** Unplaced Reason */
  unplaced_reason?: string | null;
  /** Day */
  day: string;
  /** Slots */
  slots?: string[];
}

/**
 * PlayBankFacts
 * Lekbanken's figures as the agent sees them. The backend checks the ranges and formats them; the only sum it
 * works out is the saving against `CurrentCredits`.
 */
export interface PlayBankFacts {
  /**
   * Amount
   * @min 1000
   * @max 10000000
   */
  amount: number;
  /**
   * Term Months
   * @min 1
   * @max 600
   */
  term_months: number;
  /**
   * Effective Rate
   * @min 0
   * @max 100
   */
  effective_rate: number;
  /**
   * Monthly Payment
   * @min 1
   * @max 1000000
   */
  monthly_payment: number;
  /**
   * Arrangement Fee
   * @min 0
   * @max 100000
   */
  arrangement_fee: number;
  /**
   * Monthly Fee
   * @min 0
   * @max 10000
   */
  monthly_fee: number;
  /**
   * Total Cost
   * @min 1
   * @max 100000000
   */
  total_cost: number;
}

/** PlayBankSmsRequest */
export interface PlayBankSmsRequest {
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * Lekbanken's figures as the agent sees them. The backend checks the ranges and formats them; the only sum it
   * works out is the saving against `CurrentCredits`.
   */
  facts: PlayBankFacts;
  current_credits?: CurrentCredits | null;
  /** Bank Id */
  bank_id?: number | null;
}

/** PlayBankSmsResponse */
export interface PlayBankSmsResponse {
  /** Draft Id */
  draft_id: string;
  /** Text */
  text: string;
  /** Language */
  language: string;
  /** Warnings */
  warnings: DraftWarning[];
  sms: SmsParts;
}

/** PniGetCustomerPayload */
export interface PniGetCustomerPayload {
  /** Reason */
  reason: string;
  country?: Country | null;
  /** Pni */
  pni: string;
}

/** PollResp */
export interface PollResp {
  /** Verified */
  verified: boolean;
  /** Timestamp */
  timestamp?: string | null;
}

/** PrefsResponse */
export interface PrefsResponse {
  /**
   * Statuses
   * @default ["LEAD","DRAFT","ACTIVE","DEACTIVATED"]
   */
  statuses?: SharedModelsStatusStatus[];
  /**
   * Substatuses
   * @default ["DRAFT","UNKNOWN","OFFERED","ACCEPTED","DISBURSED","ACTIVE","DEACTIVATED"]
   */
  substatuses?: Substatus[];
  /**
   * Countries
   * @default ["SE","NO"]
   */
  countries?: Country[];
  /**
   * Property Types
   * @default ["HOUSE","CONDOMINIUM","VACATION_HOME"]
   */
  property_types?: MortgagePropertyType[];
  /** New App Checklist */
  new_app_checklist: Partial<
    Record<Product, Partial<Record<Country, string[]>>>
  >;
  /** New App Options */
  new_app_options: Partial<
    Record<Product, Partial<Record<Country, NewAppOption[]>>>
  >;
  /**
   * Loan Types
   * @default ["CREDIT_CARD","UNSECURED_LOAN","CAR_LOAN","CHECK_CREDIT","OTHER","STUDENT_LOAN","INSTALLMENT","TOP_MORTGAGE_LOAN","MEMBER_LOAN","MORTGAGE"]
   */
  loan_types?: SharedModelsLoanLoanType[];
}

/** PresignedUrlResponse */
export interface PresignedUrlResponse {
  /** Url */
  url: string;
  /** Expires In */
  expires_in: number;
}

/** PreviousApplication */
export interface PreviousApplication {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Status */
  status?: Substatus | AppState | null;
  role?: ApplicantRole | null;
  /** Created At */
  created_at?: string | null;
  /** Completed At */
  completed_at?: string | null;
}

/** PreviousApplicationsList */
export interface PreviousApplicationsList {
  /** Mortgage */
  mortgage: PreviousApplication[];
  /** Blanco */
  blanco: PreviousApplication[];
  /** Credit Card */
  credit_card: PreviousApplication[];
}

/** PriceIndex */
export interface PriceIndex {
  /** Indexedtotalvalue */
  IndexedTotalValue?: number | null;
  /** Indexsincelastsale */
  IndexSinceLastSale?: number | null;
  /** Indexestimateprecisionqualitytype */
  IndexEstimatePrecisionQualityType?: string | null;
  LastSale?: LastSaleType | null;
}

/** ProcessCampaignSource */
export interface ProcessCampaignSource {
  /**
   * Type
   * @default "PROCESS"
   */
  type?: "PROCESS";
  country: Country;
  /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
  product: ExtendedProduct;
  /**
   * Process campaigns. Every member below is in active use.
   *
   * Fifteen aspirational names were removed on 2026-08-19. Nothing had ever created them:
   * `validate_process` rejects each one for every product, so a campaign carrying one could not exist.
   * Verified against production first — all 17 PROCESS campaigns and every lead carried only the values
   * below. Their only consumer was `process_applications.py`, which had no importers and moved leads into
   * those impossible campaigns, so it was removed with them.
   */
  process: ProcessCampaignType;
  /**
   * Priority
   * @default 100
   */
  priority?: number;
  substatus?: InsuranceSubstatus | null;
}

/** ProcessingStatus */
export interface ProcessingStatus {
  /** Completed At */
  completed_at?: string | null;
  /** Status */
  status?: string | null;
}

/** Property */
export interface Property {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Cadastral Designation */
  cadastral_designation?: string | null;
  /** City */
  city?: string | null;
  /** Country */
  country?: string | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  municipality?: NonEmptyString | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Other Owner */
  other_owner?: boolean | null;
  post_code?: NonEmptyString | null;
  /** Property Type */
  property_type?: string | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Street Address */
  street_address?: string | null;
  /** Value */
  value?: number | null;
  /** Booli Value */
  booli_value?: number | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Organization Name */
  organization_name?: string | null;
  /** Balcony Type */
  balcony_type?: string | null;
  /** Floor */
  floor?: number | null;
  /** Elevator */
  elevator?: boolean | null;
  /** Apartment Number */
  apartment_number?: string | null;
  /** Rooms */
  rooms?: number | null;
  ev_partial?: EvPartialCommon | null;
}

/** PropertyBeingSold */
export interface PropertyBeingSold {
  /** Selling Contract Signed */
  selling_contract_signed?: boolean | null;
  /** Property Price */
  property_price?: number | null;
  /** Existing Mortgage Amount */
  existing_mortgage_amount?: number | null;
  /** Real Estate Agent Fee */
  real_estate_agent_fee?: number | null;
}

/** PropertyInfo */
export interface PropertyInfo {
  property_type: MortgagePropertyType;
  /** Id */
  id: string;
  /** Apartments */
  apartments?: Apartment[] | null;
  /** Street Address */
  street_address: string;
  /** Post Code */
  post_code: string;
  /** City */
  city: string;
  country: Country;
  /** Municipality Code */
  municipality_code: string;
  /** Municipality */
  municipality: string;
  /** Organization Name */
  organization_name?: string | null;
  /** Organization Number */
  organization_number?: string | null;
  /** External Id */
  external_id?: string | null;
}

/** PropertySearchResult */
export interface PropertySearchResult {
  /** Id */
  id: string;
  /** Description */
  description: string;
}

/** PropertyValuation */
export interface PropertyValuation {
  property_type: MortgagePropertyType;
  /** Property Id */
  property_id: string;
  /** Living Area */
  living_area?: number | null;
  /** Apartment Number */
  apartment_number?: string | null;
  /** External Id */
  external_id?: string | null;
  /** Municipality */
  municipality: string;
  /** Municipality Code */
  municipality_code: string | null;
  /** Square Meter Living Area */
  square_meter_living_area: number;
  /** Latitude */
  latitude?: number | null;
  /** Longitude */
  longitude?: number | null;
  /** Value */
  value?: number | null;
  /** Booli Value */
  booli_value?: number | null;
  [key: string]: any;
}

/**
 * Prospect
 * Aggregated prospect model used to store information from all events gathered for given phone or email.
 * Prospects are our main data model for storing information about potential customers which will be used further in
 * dialmaker or mailmaker campaigns .
 */
export interface Prospect {
  /** Prospect data model used to store just personal contact information, either phone or email must be present. */
  data: ProspectData;
  consents?: Consents | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  source?: ProspectSource | null;
  country?: Country | null;
  /** Abandoned Form Id */
  abandoned_form_id?: string | null;
  contact_type?: SharedModelsProspectsProspectsContactType | null;
  /**
   * Valid Until
   * If specified prospect will not be used afterwards and will be anonymized
   */
  valid_until?: string | null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Soft Linked Customer Ids */
  soft_linked_customer_ids?: string[] | null;
  /** Hard Linked Customer Id */
  hard_linked_customer_id?: string | null;
  /**
   * Sources
   * @default []
   */
  sources?: ProspectSource[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at?: string | null;
}

/**
 * ProspectBase
 * Used for sending prospects to KDLT. It contains all the information needed to create a prospect in KDLT.
 */
export interface ProspectBase {
  /** Prospect data model used to store just personal contact information, either phone or email must be present. */
  data: ProspectData;
  consents?: Consents | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  source?: ProspectSource | null;
  country?: Country | null;
  /** Abandoned Form Id */
  abandoned_form_id?: string | null;
  contact_type?: SharedModelsProspectsProspectsContactType | null;
  /**
   * Valid Until
   * If specified prospect will not be used afterwards and will be anonymized
   */
  valid_until?: string | null;
}

/**
 * ProspectData
 * Prospect data model used to store just personal contact information, either phone or email must be present.
 */
export interface ProspectData {
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** Name */
  name?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  gender?: Gender | null;
  /** Date Of Birth */
  date_of_birth?: string | null;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  country?: Country | null;
  /** Housing Type */
  housing_type?: HousingTypeNO | HousingTypeSE | null;
  /** Current Bank */
  current_bank?: string | null;
  /** Got Loans */
  got_loans?: boolean | null;
  /** Loan Sum */
  loan_sum?: number | null;
  /** Got Car */
  got_car?: boolean | null;
}

/**
 * ProspectDataExtended
 * Prospect data model used to store just personal contact information with consents - for external sources,
 * either phone or email must be present.
 */
export interface ProspectDataExtended {
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** Name */
  name?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  gender?: Gender | null;
  /** Date Of Birth */
  date_of_birth?: string | null;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  country?: Country | null;
  /** Housing Type */
  housing_type?: HousingTypeNO | HousingTypeSE | null;
  /** Current Bank */
  current_bank?: string | null;
  /** Got Loans */
  got_loans?: boolean | null;
  /** Loan Sum */
  loan_sum?: number | null;
  /** Got Car */
  got_car?: boolean | null;
  consents?: Consents | null;
  /** Valid Until */
  valid_until?: string | null;
}

/**
 * ProspectMetadata
 * Prospect metadata model used to store additional information about the prospect.
 */
export interface ProspectMetadata {
  /** Ip */
  ip?: string | null;
  /** Url */
  url?: string | null;
  /** Origin */
  origin?: string | null;
  /** User Agent */
  user_agent?: string | null;
  /** Source File Name */
  source_file_name?: string | null;
  /** Prospect Cost */
  prospect_cost?: number | null;
}

/**
 * ProspectSource
 * Source of the prospect, e.g. a form submission, an import, etc. Aggregated prospect can have multiple sources.
 */
export interface ProspectSource {
  /** The source of the prospect, e.g. a form submission, an import, etc. */
  source: SourceType;
  /**
   * Prospect metadata model used to store additional information about the prospect.
   * @default {}
   */
  metadata?: ProspectMetadata;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp?: string;
}

/**
 * ProspectsFailed
 * Prospect data model used to return the failed prospects with error message.
 */
export interface ProspectsFailed {
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** Name */
  name?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  gender?: Gender | null;
  /** Date Of Birth */
  date_of_birth?: string | null;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  country?: Country | null;
  /** Housing Type */
  housing_type?: HousingTypeNO | HousingTypeSE | null;
  /** Current Bank */
  current_bank?: string | null;
  /** Got Loans */
  got_loans?: boolean | null;
  /** Loan Sum */
  loan_sum?: number | null;
  /** Got Car */
  got_car?: boolean | null;
  consents?: Consents | null;
  /** Valid Until */
  valid_until?: string | null;
  /** Error message for failed prospect */
  error: string;
}

/** ProspectsUpsertResponse */
export interface ProspectsUpsertResponse {
  /**
   * List of already upserted prospects
   * List of already upserted prospects
   */
  prospects: Prospect[];
  /** Insertion Jobs Finished */
  insertion_jobs_finished: number;
  /** Insertion Jobs Failed */
  insertion_jobs_failed: number;
  /** Insertion Jobs Pending */
  insertion_jobs_pending: number;
  /** Insertion Jobs Total */
  insertion_jobs_total: number;
  /**
   * Insertion ID
   * ID of the insertion
   * @format uuid
   */
  insertion_id: string;
  /**
   * Results of the insertion job
   * Results of the insertion job, contains number of inserted prospects
   */
  results?: Record<string, number> | null;
  /**
   * Total number of prospects
   * Total number of prospects
   */
  total?: number | null;
}

/** PublicApplicant */
export interface PublicApplicant {
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  country: Country;
}

/** PublisherData */
export interface PublisherData {
  /** Publisher Id */
  publisher_id: string;
  callback_trigger?: PersonStatus | null;
  touch: Touch;
  /** Callback Time Limit In Days */
  callback_time_limit_in_days: number;
  callback_trigger_blanco?: PersonStatus | null;
  callback_trigger_mortgage?: PersonStatus | null;
  callback_trigger_credit_card?: PersonStatus | null;
  /** Callback Trigger New Data */
  callback_trigger_new_data?:
    | "GR_SHARED_NEW"
    | "GR_SHARED_NEW_DEBT"
    | "EV_SHARED_NEW"
    | "MY_CREDIT_SCORE"
    | null;
}

/** QRCodeContent */
export interface QRCodeContent {
  /** Qr Code Content */
  qr_code_content: string;
  /** Verified */
  verified: boolean;
}

/**
 * QueuedCancellation
 * Queued cancellation information calculated from events. If this field exists, insurance is queued.
 */
export interface QueuedCancellation {
  reason?: CustomerCancellationRequestReason | null;
  contactSource?: ContactSource | null;
  /**
   * Scheduleddate
   * @format date-time
   */
  scheduledDate: string;
  /**
   * Queuedat
   * @format date-time
   */
  queuedAt: string;
  /** Winbackableat */
  winbackableAt?: string | null;
  /**
   * Note
   * Free text note from agent
   */
  note?: string | null;
}

/** QuickApplicant */
export interface QuickApplicant {
  /**
   * Pni
   * Personal national identifier fo the customer
   */
  pni: string;
  role: ApplicantRole;
  employer: QuickApplicantEmployer;
  /** Incomes */
  incomes: (Income | null)[];
  /** Phone Number */
  phone_number: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * Housing Type
   * How does the person live
   */
  housing_type: HousingTypeSE | HousingTypeNO;
  /**
   * Currently Living In Cost
   * How much does the person pay for their housing, full SEK
   * @min 0
   */
  currently_living_in_cost: number;
  /** Marital status of a person */
  marital_status: MaritalStatus;
  education?: EducationType | null;
  /**
   * Immigrated At
   * NORWAY only - when immigrated to Norway
   */
  immigrated_at?: string | null;
  /**
   * Citizenship
   * NORWAY only - is applicant Norway citizen or not
   */
  citizenship?: boolean | null;
  /** Net Monthly Income */
  net_monthly_income?: number | null;
}

/** QuickApplicantEmployer */
export interface QuickApplicantEmployer {
  /** Name */
  name: string | null;
  /** Type */
  type?: EmploymentType | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  /** Phone */
  phone?: string | null;
  /** Retirement Age */
  retirement_age?: number | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Profession */
  profession?: string | null;
  /** Monthly Other Income */
  monthly_other_income?: number | null;
}

/** QuickChildren */
export interface QuickChildren {
  /**
   * Childrenbelow18
   * @min 0
   * @max 10
   */
  childrenBelow18: number;
  /** Childrenbelow18Fulltime */
  childrenBelow18FullTime?: number | null;
  /** Receivingchildsupport */
  receivingChildSupport?: number | null;
  /** Payingchildsupport */
  payingChildSupport?: number | null;
}

/** QuickCreateBlancoApplication */
export interface QuickCreateBlancoApplication {
  /** Product */
  product: "blanco";
  new_loan?: BlancoLoan | null;
  /** Sverker user when creating a legacy blanco app */
  sverker_user?: SverkerUsername | null;
  aml?: BlancoAMLPatchPayload | null;
  /**
   * Desired Amount
   * Desired loan amount
   */
  desired_amount?: number | null;
  country: Country;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Should Remind About Meeting */
  should_remind_about_meeting?: boolean | null;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  /** Applicants */
  applicants: QuickApplicant[];
  /** Loans */
  loans: Loan[];
  children: QuickChildren;
  /**
   * Cars In The Household
   * NORWAY only - number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Internal Comment */
  internal_comment?: string | null;
  /** Comments */
  comments?: string[] | null;
  /** New App Options */
  new_app_options: Option[];
  /** New App Checklist */
  new_app_checklist: string[];
  source: ApplicationSourceInput;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  consents?: Consents | null;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
}

/** QuickCreateMortgageApplication */
export interface QuickCreateMortgageApplication {
  /** Product */
  product: "mortgage";
  new_loan?: BlancoLoan | null;
  /**
   * Desired Amount
   * Desired loan amount
   */
  desired_amount?: number | null;
  country: Country;
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Should Remind About Meeting */
  should_remind_about_meeting?: boolean | null;
  /**
   * Self Service
   * @default false
   */
  self_service?: boolean;
  /** Applicants */
  applicants: QuickApplicant[];
  /** Loans */
  loans: Loan[];
  children: QuickChildren;
  /**
   * Cars In The Household
   * NORWAY only - number of cars in the household
   */
  cars_in_the_household?: number | null;
  /** Internal Comment */
  internal_comment?: string | null;
  /** Comments */
  comments?: string[] | null;
  /** New App Options */
  new_app_options: Option[];
  /** New App Checklist */
  new_app_checklist: string[];
  source: ApplicationSourceInput;
  /** Desired Payback Time */
  desired_payback_time?: number | null;
  consents?: Consents | null;
  /** Form Type */
  form_type?: string | null;
  /** Form Mode */
  form_mode?: string | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
}

/** RatePart */
export interface RatePart {
  rate_type: RateType;
  /** Amount */
  amount?: number | null;
  /** Rate */
  rate?: number | null;
  /** Monthly Payment */
  monthly_payment?: number | null;
  /** Until */
  until?: string | null;
  /** Loannumber */
  loanNumber?: string | null;
  /** Conditionrolloverdate */
  conditionRolloverDate?: string | null;
  /** Monthlyamortisation */
  monthlyAmortisation?: number | null;
}

/** RawBlancoApplicationNO */
export interface RawBlancoApplicationNO {
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "blanco"
   */
  product?: "blanco";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data NO */
  data: BlancoApplicationDataNO;
  /** Moved To Zrm At */
  moved_to_zrm_at?: string | null;
}

/** RawBlancoApplicationSE */
export interface RawBlancoApplicationSE {
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "blanco"
   */
  product?: "blanco";
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data SE */
  data: BlancoApplicationDataSE;
}

/** RawCreditCardApplicationNO */
export interface RawCreditCardApplicationNO {
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /** Active */
  active: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankCreditCardOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  /**
   * Product
   * @default "credit_card"
   */
  product?: "credit_card";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: CreditCardApplicationData;
}

/** RawMortgageApplicationNO */
export interface RawMortgageApplicationNO {
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankBlancoOfferData[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  sverker_data?: SverkerAppData | null;
  /**
   * Product
   * @default "mortgage"
   */
  product?: "mortgage";
  /**
   * Country
   * @default "NO"
   */
  country?: "NO";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Creator */
  creator?: string | null;
  /** Model for application data NO */
  data: BlancoApplicationDataNO;
  /** Moved To Zrm At */
  moved_to_zrm_at?: string | null;
}

/** RawMortgageApplicationSE */
export interface RawMortgageApplicationSE {
  /**
   * App Id
   * @min 0
   */
  app_id: number;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   * @default "ULSE999999999"
   */
  label?: string;
  state: AppState;
  /** Active */
  active: boolean;
  milestones?: ApplicationMilestones | null;
  /** Banks */
  banks: BankMortgageOffer[];
  /**
   * Late Denial Offer Ids
   * @default []
   */
  late_denial_offer_ids?: string[];
  /**
   * Accept Denied Offer Ids
   * @default []
   */
  accept_denied_offer_ids?: string[];
  /**
   * Old Offers
   * @default []
   */
  old_offers?: string[];
  /**
   * Old Accepts
   * @default []
   */
  old_accepts?: string[];
  /**
   * Withdrawn Accept Offer Ids
   * @default []
   */
  withdrawn_accept_offer_ids?: string[];
  /**
   * Old Disbursements
   * @default []
   */
  old_disbursements?: string[];
  /** Offer History Version */
  offer_history_version?: number | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by?: string | null;
  /** Updated By */
  updated_by?: string | null;
  /** Application Score */
  application_score?: number | null;
  /**
   * Product
   * @default "mortgage"
   */
  product?: "mortgage";
  /**
   * Country
   * @default "SE"
   */
  country?: "SE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  data: MortgageApplicationSEData;
  mortgage_status?: MortgageStatus | null;
}

/** ReactivatePayload */
export interface ReactivatePayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Comment */
  comment: string;
}

/**
 * ReconcileCounters
 * One reconciliation's meetings, one bucket each.
 *
 * The skip bucket is the one named exemption — a meeting a team lead has handed over — plus
 * ``already_owner``, the ordinary steady state and not an exemption at all. Who holds a meeting
 * is not one, and neither is its start: every active meeting of an owned case, past or future,
 * follows its owner, whoever it is on.
 *
 * ``cases_failed`` sits *outside* the partition because it counts **cases** rather than
 * meetings — whole passes that fell over and so have no meetings to bucket at all; putting it
 * in a meeting bucket would make ``accounted()`` exceed ``considered``.
 */
export interface ReconcileCounters {
  /**
   * Considered
   * @default 0
   */
  considered?: number;
  /**
   * Written
   * @default 0
   */
  written?: number;
  /**
   * Already Owner
   * @default 0
   */
  already_owner?: number;
  /**
   * Handover
   * @default 0
   */
  handover?: number;
  /**
   * Conflicts
   * @default 0
   */
  conflicts?: number;
  /**
   * Failed
   * @default 0
   */
  failed?: number;
  /**
   * Retired
   * @default 0
   */
  retired?: number;
  /**
   * Stale Owner
   * @default 0
   */
  stale_owner?: number;
  /**
   * Cases Failed
   * @default 0
   */
  cases_failed?: number;
}

/**
 * Ref
 * Drill-down handle back to the source document.
 */
export interface Ref {
  /** Service */
  service: string;
  /** Collection */
  collection: string;
  /** Id */
  id: string;
}

/**
 * RefinanceInfo
 * In SE we can only refinance one existing mortgage so this object is the loan to be refinanced,
 * not used in NO
 */
export interface RefinanceInfo {
  /** Current Bank Id */
  current_bank_id: number;
  /** Amount */
  amount?: number | null;
  /** Rate */
  rate?: number | null;
  /** Monthly Payment */
  monthly_payment?: number | null;
  /** Rate Parts */
  rate_parts?: RatePart[] | null;
  rate_type?: RateType | null;
  /** Ownershipshareofloan */
  ownershipShareOfLoan?: number | null;
  /** Mortgagebank */
  mortgageBank?: string | null;
  /** Amortisationrulebeforemarch2018 */
  amortisationRuleBeforeMarch2018?: boolean | null;
}

/**
 * RefitFactorReport
 * One factor's before/after table and the censoring that produced its population.
 *
 * ``examined`` is every in-scope snapshot the run read, the ones the outcome join could not
 * answer for included (that exclusion is what a large ``censored_share`` most often means);
 * ``eligible`` is what survived this factor's exclusions; ``excluded`` names and counts each
 * one. The three always add up (:meth:`reconciles`) — a factor whose exclusions do not
 * account for the difference has dropped rows between the read and the fit.
 */
export interface RefitFactorReport {
  /**
   * The factors of ``v_t = amount x product(multipliers)``.
   *
   * ``RATE_IMPROVEMENT`` is the only one that is a *comparison* rather than a lookup: does
   * the best bid at D beat what the customer already pays? It joined after version 1 was
   * seeded, which is why it is the one factor a stored document may be missing (see
   * :data:`NEUTRAL_OPTIONAL_FACTORS`).
   */
  factor: ValueFactor;
  /**
   * Examined
   * @default 0
   */
  examined?: number;
  /**
   * Eligible
   * @default 0
   */
  eligible?: number;
  /**
   * Disbursed
   * @default 0
   */
  disbursed?: number;
  /** Base Rate */
  base_rate?: number | null;
  /** Excluded */
  excluded?: Record<string, number>;
  /** Rows */
  rows?: RefitLevelRow[];
}

/**
 * RefitLevelRow
 * One factor at one level: what was observed, and what the candidate says.
 *
 * ``lift`` is ``P(disbursed | level) / P(disbursed)`` on **this factor's own** eligible
 * population, not the run's overall one: the censoring differs per factor, so a lift taken
 * against another population's base rate would carry the difference between the two into
 * the multiplier.
 *
 * ``fitted`` is what the candidate carries and ``previous`` what is live, so the two columns
 * beside each other *are* the before/after table. ``floored`` marks the rows where the fit
 * produced less than the 0.10 floor and the product decision overrode the arithmetic, and
 * ``kept_reason`` why a row kept its previous number: "the fit did not move this level" and
 * "the fit had nothing to say about this level" must not be confused.
 */
export interface RefitLevelRow {
  /**
   * The factors of ``v_t = amount x product(multipliers)``.
   *
   * ``RATE_IMPROVEMENT`` is the only one that is a *comparison* rather than a lookup: does
   * the best bid at D beat what the customer already pays? It joined after version 1 was
   * seeded, which is why it is the one factor a stored document may be missing (see
   * :data:`NEUTRAL_OPTIONAL_FACTORS`).
   */
  factor: ValueFactor;
  /** Level */
  level: string;
  /**
   * N
   * @default 0
   */
  n?: number;
  /**
   * Disbursed
   * @default 0
   */
  disbursed?: number;
  /** Rate */
  rate?: number | null;
  /** Lift */
  lift?: number | null;
  /** Previous */
  previous: number;
  /** Fitted */
  fitted: number;
  /**
   * Floored
   * @default false
   */
  floored?: boolean;
  /**
   * Kept Previous
   * @default false
   */
  kept_previous?: boolean;
  /** Kept Reason */
  kept_reason?: string | null;
}

/**
 * RefitReport
 * One refit run, end to end.
 *
 * ``candidate`` is ``None`` when the run refused to propose one — too few counting weeks in
 * the window, no readable settings to bump, or an outcome join that answered for nothing.
 * The tables are still written: "the refit ran and could not fit" is a result, and a report
 * with no numbers would be indistinguishable from a job that never ran.
 *
 * ``weeks_covered`` is the ISO weeks the *eligible* population actually spans, which is how
 * the "at least four counting weeks" rule is read: a window that nominally covers six weeks
 * but has snapshots in three of them has three.
 */
export interface RefitReport {
  /**
   * Window Start
   * @format date-time
   */
  window_start: string;
  /**
   * Window End
   * @format date-time
   */
  window_end: string;
  /** Requested Weeks */
  requested_weeks: number;
  /** Maturity Days */
  maturity_days: number;
  /** Min Level N */
  min_level_n: number;
  /**
   * Snapshots Read
   * @default 0
   */
  snapshots_read?: number;
  /**
   * Out Of Scope
   * @default 0
   */
  out_of_scope?: number;
  /**
   * Outcomes Joined
   * @default 0
   */
  outcomes_joined?: number;
  /**
   * Outcome Unknown
   * @default 0
   */
  outcome_unknown?: number;
  /**
   * Disbursed
   * @default 0
   */
  disbursed?: number;
  /** Base Rate */
  base_rate?: number | null;
  /** Weeks Covered */
  weeks_covered?: string[];
  /**
   * Enough Weeks
   * @default false
   */
  enough_weeks?: boolean;
  /** Cut Points Before */
  cut_points_before?: number[];
  /** Cut Points After */
  cut_points_after?: number[];
  /**
   * Cut Points Adopted
   * @default false
   */
  cut_points_adopted?: boolean;
  /**
   * Valid Credit Scores
   * @default 0
   */
  valid_credit_scores?: number;
  /** Factors */
  factors?: RefitFactorReport[];
  candidate?: ValueMultipliers | null;
  /** Candidate Version */
  candidate_version?: number | null;
  /** Refused */
  refused?: string | null;
}

/** RejectionPayload */
export interface RejectionPayload {
  /** Label */
  label: string;
  /** Bank Id */
  bank_id: number;
  /** Reason */
  reason?: string | null;
  /** Offer Id */
  offer_id?: string | null;
}

/** RenderTemplatePayload */
export interface RenderTemplatePayload {
  /** Mandrill Name */
  mandrill_name: string;
  /** Template Content */
  template_content: MergeVarContent[];
  /** Merge Vars */
  merge_vars: MergeVarContent[];
}

/**
 * RenderedSnippet
 * Snippet shape returned to the client, body has been rendered with customer context.
 */
export interface RenderedSnippet {
  /**
   * Snippet Id
   * @format uuid
   */
  snippet_id: string;
  /**
   * Category Id
   * @format uuid
   */
  category_id: string;
  /** Title */
  title: string;
  /** Contexts */
  contexts: SnippetContext[];
  /** Body */
  body: string;
  /**
   * Failed Render
   * Some placeholder went unfilled and the body fell back to a tolerant render.
   */
  failed_render: boolean;
  /**
   * Requires Offer
   * The body references `offer___*` vars that only an agent-picked offer can fill. Gate the offer picker on this, not on `failed_render`.
   */
  requires_offer: boolean;
  /** Bank Id */
  bank_id?: number | null;
}

/** ReprocessResult */
export interface ReprocessResult {
  /** Lead Id */
  lead_id: string;
  status: ReprocessStatus;
  /** Error */
  error?: string | null;
  /** Details */
  details?: string | null;
}

/** ReprocessSubmissionPayload */
export interface ReprocessSubmissionPayload {
  /** Lead Ids */
  lead_ids: string[];
}

/** RequestInvitePayload */
export interface RequestInvitePayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /** Bank Id */
  bank_id: number;
}

/** RequestNewOTP */
export interface RequestNewOTP {
  /** Token */
  token: string;
}

/** ResetPasswordPayload */
export interface ResetPasswordPayload {
  /** User Id */
  user_id: string;
}

/**
 * ResolvedOrigin
 * An application's origin, evaluated from zrm and apps-mgr data the way dbt map_application_origin does it,
 * and stored on the mapper. The struct fields are the effective ones: the padding root's when padded.
 */
export interface ResolvedOrigin {
  /** Kind */
  kind: string;
  /** Rule */
  rule: string;
  /** Detail */
  detail?: string | null;
  /** Sales Direction */
  sales_direction?: string | null;
  /** Sales Channel */
  sales_channel?: string | null;
  /** Inbound Channel */
  inbound_channel?: string | null;
  /** Affiliate Id */
  affiliate_id?: string | null;
  /** Lead Id */
  lead_id?: string | null;
  /** Campaign Id */
  campaign_id?: string | null;
  /** Campaign Description */
  campaign_description?: string | null;
  /** Campaign Super Type */
  campaign_super_type?: string | null;
  /** Campaign */
  campaign?: string | null;
  /** Campaign Detail */
  campaign_detail?: string | null;
  /** Campaign Product */
  campaign_product?: string | null;
  /** Rating */
  rating?: number | null;
  /** Root Label */
  root_label?: string | null;
  /** Root Product */
  root_product?: string | null;
  /** Application Type */
  application_type?: string | null;
  own?: OriginStruct | null;
}

/**
 * ResolvedScope
 * Output of the scope resolver. v1 `policy='developer'` => full_scope=True.
 */
export interface ResolvedScope {
  /** Customer Id */
  customer_id: string;
  /**
   * Policy
   * @default "developer"
   */
  policy?: string;
  /**
   * Full Scope
   * @default true
   */
  full_scope?: boolean;
  /** App Labels */
  app_labels?: string[];
  /** Insurance Ids */
  insurance_ids?: string[];
  /** Scope Degraded */
  scope_degraded?: string[];
  /**
   * As Of
   * @format date-time
   */
  as_of: string;
}

/** Response */
export interface Response {
  /** Forwarded */
  forwarded: boolean;
}

/** ResubmitPayload */
export interface ResubmitPayload {
  /** Submission Id */
  submission_id: string;
  country: Country;
  /** Parsed Form */
  parsed_form:
    | (
        | ({
            product: "blanco";
          } & QuickCreateBlancoApplication)
        | ({
            product: "mortgage";
          } & QuickCreateMortgageApplication)
      )
    | CreateCreditCardApplicationPayloadWithApplicant;
}

/** RetryPolicy */
export interface RetryPolicy {
  /**
   * Retry Count
   * @default 5
   */
  retry_count?: number;
  /**
   * Retry Interval Minutes
   * @default 60
   */
  retry_interval_minutes?: number;
}

/** ReviewSubmissions */
export interface ReviewSubmissions {
  /**
   * Submission Ids
   * List of submission ids
   */
  submission_ids: string[];
  /**
   * Handled
   * Mark submissions as handled or not
   * @default true
   */
  handled?: boolean;
}

/** Reviewer */
export interface Reviewer {
  /** User Id */
  user_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/** RiskForecast */
export interface RiskForecast {
  /**
   * Scoremonth
   * Score month, in the format year-month
   */
  scoreMonth?: string | null;
  /**
   * Updatedate
   * Risk forecast score last update Date
   */
  updateDate?: string | null;
  /**
   * Riskforecastscore
   * Risk forecast score
   */
  riskForecastScore?: number | null;
}

/** RootModel[Union[EmailTemplate, SmsTemplate]] */
export type RootModelUnionEmailTemplateSmsTemplate =
  | EmailTemplate
  | SmsTemplate;

/** RootModel[Union[MyStats, MyStatsMb]] */
export type RootModelUnionMyStatsMyStatsMb = MyStats | MyStatsMb;

/** RootModel[Union[SummarizedView, MyStatsMb]] */
export type RootModelUnionSummarizedViewMyStatsMb = SummarizedView | MyStatsMb;

/** RqJobStatusResponse */
export interface RqJobStatusResponse {
  /** Job Id */
  job_id?: string | null;
  /** Queue */
  queue?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Description */
  description?: string | null;
  /** Exception Info */
  exception_info?: string | null;
  /** Retries Left */
  retries_left?: number | null;
  /** Retry Intervals */
  retry_intervals?: number[] | null;
  /** Retry At */
  retry_at?: string[] | null;
  /** Status */
  status?: string | null;
  /** Meta */
  meta?: Record<string, any> | null;
  /** Kwargs */
  kwargs?: Record<string, any> | null;
}

/** RulesResponse */
export interface RulesResponse {
  /** Rules */
  rules: InsuranceTerms[];
  /** Violated Rules */
  violated_rules: string[];
}

/**
 * RunContext
 * What the run was reading and deciding under.
 *
 * The pool *order* rather than the pool set: it is the last tiebreak, so naming only the
 * membership could not tell two incomparable runs apart. The pool is the Employee scheduling
 * roster, which keeps no versions, so the order itself is the record.
 */
export interface RunContext {
  country: Country;
  /**
   * Window Start
   * @format date-time
   */
  window_start: string;
  /**
   * Window End
   * @format date-time
   */
  window_end: string;
  /** Horizon End */
  horizon_end?: string | null;
  /** Pool Order */
  pool_order?: string[];
  /** Settings Version */
  settings_version?: number | null;
  /** Multipliers Version */
  multipliers_version?: number | null;
}

/**
 * RunHealth
 * The consolidated state section of one collector run.
 *
 * Carried on ``ops.DistributionRunReport.health`` so that a sweep is one document: the
 * counters of the passes and the state they ran against, read together or not at all.
 */
export interface RunHealth {
  /**
   * What the run was reading and deciding under.
   *
   * The pool *order* rather than the pool set: it is the last tiebreak, so naming only the
   * membership could not tell two incomparable runs apart. The pool is the Employee scheduling
   * roster, which keeps no versions, so the order itself is the record.
   */
  context: RunContext;
  /**
   * The guard's outcomes over the window: (a) owner change, (b) handover, (c) refused.
   *
   * ``held`` rows can still show up from ledger lines written while a started meeting was let
   * through unread (``GuardBranch.HELD``).
   */
  guard?: GuardCounts;
  /**
   * How much of the book the phase actually owns, and what is drifting.
   *
   * ``pool_meetings`` is the denominator every share here is taken over: future meetings in
   * the reconciliation's scope, held by a pool handler or by nobody. ``owned`` and ``unowned``
   * partition it, which is the identity :meth:`reconciles` asserts. ``collisions_real_book`` is
   * the share of meetings sharing a (handler, quarter) on the book as it is — read *beside*
   * ``p_owned`` and never on its own, since the expected level interpolates between the owned
   * and unowned regimes.
   *
   * The two snapshot buckets answer different questions. ``snapshots_awaiting_owner`` is a
   * level, not a fault: a snapshot with no owner record behind it is the *normal* end of the
   * wait for an application that reached the horizon unbooked. ``snapshots_orphaned`` is the
   * alarm and the discriminating subset of it — the label is on a **superseded** record and on
   * no active one, the only shape the INHERIT race can leave behind, with no steady state.
   * ``late_transfer_*`` is an owner change after the accounting week closed: allowed, the value
   * follows the owner, but it moves money between two already reported weeks.
   */
  ownership?: OwnershipHealth;
  /**
   * How complete the value model's inputs were, per factor.
   *
   * ``degraded`` is the snapshot flag — at least one factor fell to its ``missing`` level —
   * and ``missing_by_factor`` the breakdown behind it, derived from the snapshot's own stored
   * fields rather than a second set of counters that could disagree with the evidence. The
   * rate-improvement factor is deliberately outside ``degraded`` (absent for most of the
   * population, it would swamp the flag), so its level distribution stands on its own.
   */
  factors?: FactorHealth;
  /** Error */
  error?: string | null;
}

/**
 * RunReportDigest
 * A stored run report with the per-meeting halves left out — what an endpoint answers.
 *
 * ``outcomes``, ``errors`` and ``candidates`` are keyed by (or are a list of) meeting ids,
 * thousands of them on a real day. A reader of `/report/latest` is asking "what did the last
 * run do", which is counts, and shipping the ids over an endpoint would put meeting
 * identifiers into every browser cache and proxy log that touches the answer. So the three
 * are reduced to their sizes and ``counts`` carries the outcome histogram; the per-meeting
 * detail stays in ``meeting_distribution_runs``, where the run wrote it. Every sub-document
 * below is already counts-only by construction and is carried through unchanged.
 */
export interface RunReportDigest {
  /** Plan Id */
  plan_id: string;
  /** Run Id */
  run_id?: string | null;
  /** Mode */
  mode?: string | null;
  /** Created At */
  created_at?: string | null;
  /**
   * Planned
   * @default 0
   */
  planned?: number;
  /**
   * Moved
   * @default 0
   */
  moved?: number;
  /** Aborted */
  aborted?: string | null;
  /** Skipped */
  skipped?: string | null;
  /** Snapshot Revision */
  snapshot_revision?: string | null;
  /** Counts */
  counts?: Record<string, number>;
  /**
   * Outcomes Recorded
   * @default 0
   */
  outcomes_recorded?: number;
  /**
   * Errors Recorded
   * @default 0
   */
  errors_recorded?: number;
  /**
   * Candidates Seen
   * @default 0
   */
  candidates_seen?: number;
  /** Per Handler */
  per_handler?: Record<string, number>;
  /** Unassigned Reasons */
  unassigned_reasons?: Record<string, number>;
  /** Dropped Reasons */
  dropped_reasons?: Record<string, number>;
  /** Load After */
  load_after?: Record<string, Record<string, number>>;
  d_counters?: DRunCounters | null;
  reconciliation?: ReconcileCounters | null;
  handler_sync?: HandlerSyncCounters | null;
  mortgage_takeover?: MortgageTakeoverCounters | null;
  health?: RunHealth | null;
  refit?: RefitReport | null;
}

/** SEApplicationForm */
export interface SEApplicationForm {
  /**
   * Example-Loan-Payback-Time
   * @min 0
   * @default 0
   */
  "example-loan-payback-time"?: number;
  /**
   * Loan-Amount-Text-Field
   * @min 0
   * @default 0
   */
  "loan-amount-text-field"?: number;
  /**
   * Total-Loan-Amount
   * @min 0
   * @default 0
   */
  "total-loan-amount"?: number;
  /**
   * Slider
   * @min 0
   * @default 0
   */
  slider?: number;
  /**
   * Refinance-Question
   * @default false
   */
  "refinance-question"?: boolean;
  /**
   * Refinance-Amount
   * @default 0
   */
  "refinance-amount"?: number;
  /** Original-Loan-Purpose */
  "original-loan-purpose"?: string | null;
  "marital-status"?: MaritalStatus | null;
  /**
   * Number-Of-Children
   * @default 0
   */
  "number-of-children"?: number | null;
  /**
   * Rent-Part
   * @default "0"
   */
  "rent-part"?: string | null;
  /** @default "other" */
  "employment-type"?: EmploymentType;
  /** Employer */
  employer?: string | null;
  /** Employed-Year */
  "employed-year"?: string | null;
  /** Employed-Month */
  "employed-month"?: string | null;
  /** Employed-To-Year */
  "employed-to-year"?: string | null;
  /** Employed-To-Month */
  "employed-to-month"?: string | null;
  /** Company-Industry */
  "company-industry"?: string | null;
  /** Email */
  email?: string | null;
  /**
   * Ssn
   * @default ""
   */
  ssn?: string;
  /**
   * Email-Marketing
   * @default false
   */
  "email-marketing"?: boolean;
  /**
   * Sms-Marketing
   * @default false
   */
  "sms-marketing"?: boolean;
  /**
   * Customer-Club-Marketing
   * @default false
   */
  "customer-club-marketing"?: boolean;
  /**
   * Applicant-Pep
   * @default false
   */
  "applicant-pep"?: boolean;
  /**
   * Ms-Enabled
   * @default false
   */
  "ms-enabled"?: boolean;
  "ms-marital-status"?: MaritalStatus | null;
  /** Ms-Number-Of-Children */
  "ms-number-of-children"?: string | null;
  /** Ms-Rent-Part */
  "ms-rent-part"?: number | null;
  "ms-employment-type"?: EmploymentType | null;
  /** Ms-Employer */
  "ms-employer"?: string | null;
  /** Ms-Employed-Year */
  "ms-employed-year"?: string | null;
  /** Ms-Employed-Month */
  "ms-employed-month"?: string | null;
  /** Ms-Employed-To-Year */
  "ms-employed-to-year"?: string | null;
  /** Ms-Employed-To-Month */
  "ms-employed-to-month"?: string | null;
  /** Ms-Company-Industry */
  "ms-company-industry"?: string | null;
  /** Ms-Email */
  "ms-email"?: string | null;
  /** Ms-Ssn */
  "ms-ssn"?: string | null;
  /**
   * Ms-Applicant-Pep
   * @default false
   */
  "ms-applicant-pep"?: boolean | null;
  /**
   * Is-New-Loan-Form
   * @default false
   */
  "is-new-loan-form"?: boolean | null;
  /**
   * Credits
   * @default []
   */
  credits?: FormCredit[] | null;
  /** @default "other" */
  "loan-purpose"?: LoanPurpose;
  "housing-status"?: SharedBlancoSeSpecPrivateUnsecuredLoanApplicationCreatedHousingType | null;
  "housing-type"?: HousingTypeSE | null;
  /** Phone-Number */
  "phone-number"?: string | null;
  /**
   * Salary
   * @min 0
   * @default 0
   */
  salary?: number;
  "ms-housing-status"?: SharedBlancoSeSpecPrivateUnsecuredLoanApplicationCreatedHousingType | null;
  "ms-housing-type"?: HousingTypeSE | null;
  /** Ms-Phone-Number */
  "ms-phone-number"?: string | null;
  /** Ms-Salary */
  "ms-salary"?: number | null;
}

/** SMSReceived */
export interface SMSReceived {
  /** Type */
  type: "SMS_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: SMSReceivedData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** SMSReceivedData */
export interface SMSReceivedData {
  /** Application Id */
  application_id?: string | null;
  /** Suggested Application Id */
  suggested_application_id?: string | null;
  /** Suggested Customer Id */
  suggested_customer_id?: string | null;
  /** Customer Ids */
  customer_ids: string[];
  product?: Product | null;
  /** Sender Name */
  sender_name?: string | null;
  /** Message */
  message?: string | null;
  /** Messaging Center Item Id */
  messaging_center_item_id?: string | null;
}

/** SMSTrackingLink */
export interface SMSTrackingLink {
  /** Name */
  name: string;
  /** Conflict */
  conflict: boolean;
}

/** SMSTrackingLinksResponse */
export interface SMSTrackingLinksResponse {
  /** Tracking Links */
  tracking_links: SMSTrackingLink[];
}

/** SSECall */
export interface SSECall {
  direction: Direction;
  /** Duration In Seconds */
  duration_in_seconds: number;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id?: string | null;
}

/** SampleVars */
export interface SampleVars {
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /** Template Vars */
  template_vars: MergeVarContent[];
}

/** SaveEmailAttachmentRequest */
export interface SaveEmailAttachmentRequest {
  /**
   * Email Id
   * @format uuid
   */
  email_id: string;
  /**
   * Attachment Id
   * @format uuid
   */
  attachment_id: string;
  /**
   * Customer Id
   * The applicant or co-applicant the file is about
   * @format uuid
   */
  customer_id: string;
  /** @default "OTHER" */
  document_type?: MonoDocumentType;
}

/** SavePreviewAssignmentsPayload */
export interface SavePreviewAssignmentsPayload {
  /** Assignments */
  assignments: Record<string, string>;
  /** Expected Previous Handlers */
  expected_previous_handlers: Record<string, string | null>;
  /** Confirmed */
  confirmed: boolean;
  /**
   * Snapshot Revision
   * @pattern ^[0-9a-f]{64}$
   */
  snapshot_revision: string;
}

/** SavedAttachment */
export interface SavedAttachment {
  /** File Id */
  file_id: string;
  /** Name */
  name?: string | null;
}

/** SavedMessage */
export interface SavedMessage {
  message_type: MessageType;
  /** Message Id */
  message_id: string;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Prospect Id
   * Prospect ID for leads
   */
  prospect_id?: string | null;
  /** Insurance Id */
  insurance_id?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Request Id */
  request_id?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  direction: Direction;
  /** User Id */
  user_id?: string | null;
  country?: Country | null;
  product?: ExtendedProduct | null;
  event?: TemplateEvent | null;
  /** Send At */
  send_at?: string | null;
  /**
   * Message Tracking Key
   * optional unique key for url tracking
   */
  message_tracking_key?: string | null;
  /**
   * Allow Reply
   * optional flag to indicate if replies are allowed
   */
  allow_reply?: boolean | null;
  /** Message */
  message?: string | null;
  /** Sender */
  sender?: string | null;
  /** Template Name */
  template_name?: string | null;
  /** Template Vars */
  template_vars?: Record<string, any> | null;
  /** Customer Ids */
  customer_ids?: string[] | null;
}

/** SavedMessageWithName */
export interface SavedMessageWithName {
  message_type: MessageType;
  /** Message Id */
  message_id: string;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Prospect Id
   * Prospect ID for leads
   */
  prospect_id?: string | null;
  /** Insurance Id */
  insurance_id?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Request Id */
  request_id?: string | null;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  direction: Direction;
  /** User Id */
  user_id?: string | null;
  country?: Country | null;
  product?: ExtendedProduct | null;
  event?: TemplateEvent | null;
  /** Send At */
  send_at?: string | null;
  /**
   * Message Tracking Key
   * optional unique key for url tracking
   */
  message_tracking_key?: string | null;
  /**
   * Allow Reply
   * optional flag to indicate if replies are allowed
   */
  allow_reply?: boolean | null;
  /** Message */
  message?: string | null;
  /** Sender */
  sender?: string | null;
  /** Template Name */
  template_name?: string | null;
  /** Template Vars */
  template_vars?: Record<string, any> | null;
  /** Customer Ids */
  customer_ids?: string[] | null;
  /** Sender Name */
  sender_name: string;
}

/** ScheduleResponse */
export interface ScheduleResponse {
  /** Schedule */
  schedule:
    | ({
        mode: "CUSTOM";
      } & CustomSchedule)
    | ({
        mode: "STANDARD";
      } & StandardSchedule);
  /** Missing Zoordinates */
  missing_zoordinates: [Product, Country][];
}

/** Scope */
export interface Scope {
  /**
   * How a row is scoped. `lead_id` is intentionally absent in v1 — mortgage-lead
   * sources are deferred (their `applicant.customer_id` is CSFLE-encrypted/unindexed).
   */
  axis: ScopeAxis;
  /** Id */
  id: string;
}

/** SearchLeadsPayload */
export interface SearchLeadsPayload {
  /** Campaign Ids */
  campaign_ids?: string[] | null;
  country?: Country | null;
  product?: ExtendedProduct | null;
  department?: ZDepartment | null;
  /** User Ids */
  user_ids?: string[] | null;
  /** Start */
  start?: string | null;
  /** End */
  end?: string | null;
  /** Outcomes */
  outcomes?: OutcomeType[] | null;
  /** Failure Sub Outcomes */
  failure_sub_outcomes?: string[] | null;
  /** No Contact Sub Outcomes */
  no_contact_sub_outcomes?: NoContactOutcomes[] | null;
  status?: LeadStatus | null;
  /**
   * Order
   * @default "desc"
   */
  order?: "asc" | "desc";
  /** Search */
  search?: string | null;
  /**
   * Exclude Unextracted
   * @default true
   */
  exclude_unextracted?: boolean;
  /**
   * Exclude Null Campaign Id
   * @default true
   */
  exclude_null_campaign_id?: boolean;
}

/** SearchResultItem */
export interface SearchResultItem {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** State */
  state: AppState | OPStatus;
  /**
   * Main Applicant Id
   * @format uuid
   */
  main_applicant_id: string;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
  /** Applicant Name */
  applicant_name: string;
  manual_application_state?: ManualApplicationState | null;
}

/** SelfServicePayload */
export interface SelfServicePayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /** Self Service */
  self_service: boolean;
}

/** SellingInfo */
export interface SellingInfo {
  /** Property Being Sold */
  property_being_sold: PropertyBeingSold[];
}

/**
 * SendEmailPayload
 * Payload for sending an outbound email to a customer.
 */
export interface SendEmailPayload {
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Thread Id
   * Existing thread to reply to
   */
  thread_id?: string | null;
  /** To Email */
  to_email: string;
  /** Subject */
  subject: string;
  /** Body Html */
  body_html?: string | null;
  /** Body Text */
  body_text?: string | null;
  /**
   * In Reply To
   * email_id of the email being replied to
   */
  in_reply_to?: string | null;
  /** Lead Id */
  lead_id?: string | null;
  /** Application Id */
  application_id?: string | null;
  /** Country */
  country?: string | null;
  /**
   * Attachments
   * Inline base64-encoded attachments. Mutually combinable with attachment_ids.
   */
  attachments?: OutboundEmailAttachment[] | null;
  /**
   * Attachment Ids
   * Ids returned by prior POST /attachments/upload calls.
   */
  attachment_ids?: string[] | null;
}

/** SendEmailResponse */
export interface SendEmailResponse {
  /** Email Id */
  email_id: string;
  /** Thread Id */
  thread_id: string;
  /** Mandrill Id */
  mandrill_id?: string | null;
  /** Status */
  status: string;
}

/** SendPolicy */
export interface SendPolicy {
  /** Weekdays To Send */
  weekdays_to_send?: number[] | null;
  /** Spread Send Times */
  spread_send_times?: string[] | null;
  /**
   * Batch Size
   * @min 0
   * @default 30
   */
  batch_size?: number;
}

/** SendRawPayload */
export interface SendRawPayload {
  /**
   * Customer Id
   * When MessageType.SMS, pass either phone_number or customer_id
   */
  customer_id?: string | null;
  /**
   * Phone Number
   * Only for MessageType.SMS, pass either phone_number or customer_id
   */
  phone_number?: string | null;
  /**
   * Application Id Or Lead Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id_or_lead_id?: string | null;
  /** Message */
  message: string;
  data?: DataInput | null;
  /** Subject */
  subject?: string | null;
  /** Only for MessageType.SMS without customer_id */
  country?: Country | null;
  /**
   * Translation Id
   * Only for MessageType.SMS: the agent AI translation or Lekbanken SMS draft this SMS was made from
   */
  translation_id?: string | null;
}

/** SendTemplatePayload */
export interface SendTemplatePayload {
  /**
   * Customer Id
   * When MessageType.SMS, pass either phone_number or customer_id
   */
  customer_id?: string | null;
  /**
   * Phone Number
   * Only for MessageType.SMS, pass either phone_number or customer_id
   */
  phone_number?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  data?: DataInput | null;
  /** Only for MessageType.SMS without customer_id */
  country?: Country | null;
  /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
  product: ExtendedProduct;
}

/** SenderMessage */
export interface SenderMessage {
  /**
   * At
   * @format date-time
   */
  at: string;
  /** Text */
  text: string;
}

/** SentMarketingEmailResponse */
export interface SentMarketingEmailResponse {
  /** Email */
  email: string;
  /** Id */
  _id: string;
  /**
   * Lead Id
   * @format uuid
   */
  lead_id: string;
  /** Customer Id */
  customer_id?: string | null;
  /** Successfully Sent */
  successfully_sent: boolean;
}

/** SessionSummary */
export interface SessionSummary {
  /** Session Id */
  session_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Message Count */
  message_count: number;
  /** Product */
  product: string;
  /** Country */
  country: string;
  /** First Message */
  first_message?: string | null;
}

/** SetPassword */
export interface SetPassword {
  /**
   * Otp
   * @format password
   */
  otp: string;
  /** Token */
  token: string;
  /**
   * Password
   * @format password
   */
  password: string;
}

/** SetPasswordResp */
export interface SetPasswordResp {
  /** Success */
  success: true;
}

/** SetSkaOverridePayload */
export interface SetSkaOverridePayload {
  /**
   * Reason
   * @minLength 1
   * @maxLength 1000
   */
  reason: string;
}

/** ShareDocumentsPayload */
export interface ShareDocumentsPayload {
  /** Bank Id */
  bank_id: number;
  /**
   * Document Ids
   * @maxItems 100
   * @minItems 1
   */
  document_ids: string[];
}

/** ShareDocumentsResult */
export interface ShareDocumentsResult {
  /**
   * Newly Shared
   * Documents this call shared with the bank; one already shared counts 0
   */
  newly_shared: number;
  /**
   * Users Emailed
   * The bank's portal users told by email
   */
  users_emailed: number;
}

/** Sheet */
export interface SheetInput {
  /**
   * Uploaded At
   * @format date-time
   */
  uploaded_at: string;
  type: SheetType;
  /**
   * Name
   * @default ""
   */
  name?: string;
  /**
   * Sheet Id
   * @format uuid
   */
  sheet_id: string;
  /** Separator */
  separator?: string | null;
  /**
   * Mapping
   * @default {}
   */
  mapping?: Record<string, string>;
  uploaded_sheet_preview?: SheetPreviewBase | null;
  /** @default "NOT_STARTED" */
  import_status?: ImportStatusInput;
  import_details?: InterimLeadsInsertion | null;
  /** Import Error Msg */
  import_error_msg?: string | null;
  /** Imported At */
  imported_at?: string | null;
}

/** Sheet */
export interface SheetOutput {
  /**
   * Uploaded At
   * @format date-time
   */
  uploaded_at: string;
  type: SheetType;
  /**
   * Name
   * @default ""
   */
  name?: string;
  /**
   * Sheet Id
   * @format uuid
   */
  sheet_id: string;
  /** Separator */
  separator?: string | null;
  /**
   * Mapping
   * @default {}
   */
  mapping?: Record<string, string>;
  uploaded_sheet_preview?: SheetPreviewBase | null;
  /** @default "NOT_STARTED" */
  import_status?: ModelsDialMaker2SourcesSheetImportStatus;
  import_details?: InterimLeadsInsertion | null;
  /** Import Error Msg */
  import_error_msg?: string | null;
  /** Imported At */
  imported_at?: string | null;
}

/** SheetCampaignSource */
export interface SheetCampaignSourceInput {
  /**
   * Type
   * @default "SHEET"
   */
  type?: "SHEET";
  /**
   * Sheets
   * @default []
   */
  sheets?: SheetInput[];
}

/** SheetCampaignSource */
export interface SheetCampaignSourceOutput {
  /**
   * Type
   * @default "SHEET"
   */
  type?: "SHEET";
  /**
   * Sheets
   * @default []
   */
  sheets?: SheetOutput[];
}

/** SheetPreview */
export interface SheetPreview {
  /** Headers */
  headers: string[];
  /** Model Fields */
  model_fields: string[];
  /** Preview */
  preview: Record<string, string | Record<string, string | null> | null>[];
  /**
   * Sheet Id
   * Sheet ID which is needed in extraction endpoint.
   * @format uuid
   */
  sheet_id: string;
  /** File Name */
  file_name: string;
  file_type: SheetType;
  /**
   * Uploaded At
   * Date when file was uploaded.
   * @format date-time
   */
  uploaded_at: string;
}

/** SheetPreviewBase */
export interface SheetPreviewBase {
  /** Headers */
  headers: string[];
  /** Model Fields */
  model_fields: string[];
  /** Preview */
  preview: Record<string, string | Record<string, string | null> | null>[];
}

/**
 * SidebarCount
 * Agent sidebar badge counters. Lives in `models/` rather than `services/sidebar/` because both
 * `services.sidebar` (which computes and publishes it) and `services.notifications` (which streams
 * it) need the type, and the former already imports the latter.
 */
export interface SidebarCount {
  /**
   * Active
   * @default 0
   */
  active?: number;
  /**
   * Accepted
   * @default 0
   */
  accepted?: number;
  /**
   * Signed
   * @default 0
   */
  signed?: number;
  /**
   * Disbursed
   * @default 0
   */
  disbursed?: number;
  /**
   * Late Rejected
   * @default 0
   */
  late_rejected?: number;
  /**
   * Today
   * @default 0
   */
  today?: number;
  /**
   * Old
   * @default 0
   */
  old?: number;
  /**
   * Next Shift
   * @default 0
   */
  next_shift?: number;
  /**
   * Insurance Waiting For Customer Acceptance
   * @default 0
   */
  insurance_waiting_for_customer_acceptance?: number;
  /**
   * Insurance Waiting For Bank
   * @default 0
   */
  insurance_waiting_for_bank?: number;
  /**
   * Insurance Inactive Mandate
   * @default 0
   */
  insurance_inactive_mandate?: number;
  /**
   * Insurance Active
   * @default 0
   */
  insurance_active?: number;
  /**
   * Insurance Canceled
   * @default 0
   */
  insurance_canceled?: number;
  /**
   * Insurance Pending Cancellation
   * @default 0
   */
  insurance_pending_cancellation?: number;
  /**
   * Insurance Scheduled Cancellation
   * @default 0
   */
  insurance_scheduled_cancellation?: number;
  /**
   * Insurance Discarded
   * @default 0
   */
  insurance_discarded?: number;
  /**
   * Insurance Winbackable
   * @default 0
   */
  insurance_winbackable?: number;
  /** Mortgage Coi */
  mortgage_coi?: number | null;
  /** Mortgage Coi Mine */
  mortgage_coi_mine?: number | null;
  /** Messaging Center */
  messaging_center?: number | null;
}

/** SimulatedLead */
export interface SimulatedLead {
  /** Customerid */
  CustomerID?: string | null;
  /** Prospectid */
  ProspectID?: string | null;
  /** Referenceapplicationid */
  ReferenceApplicationID?: string | null;
  /**
   * Commentvars
   * @default {}
   */
  CommentVars?: Record<string, any>;
  /**
   * Tags
   * @default {}
   */
  Tags?: Record<string, any>;
  /**
   * Sortingorder
   * @default 0
   */
  SortingOrder?: number;
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
}

/** SimulatedLoginPayload */
export interface SimulatedLoginPayload {
  /** Pni */
  pni: string;
  /** Password */
  password: string;
  /** @default "BANK_ID" */
  provider?: CustomerLoginProvider;
  purpose?: BankIDPurpose | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
  entry_point?: LoginEntryPoint | null;
}

/**
 * SkaBlockedCreditor
 * A creditor (or a partner of one) that disbursed a loan to the customer recently: never invited, not even
 * manually, while the rules apply.
 */
export interface SkaBlockedCreditor {
  /** Bank Id */
  bank_id: number;
  /** Name */
  name: string;
}

/** SkaImpact */
export interface SkaImpact {
  /** Applies */
  applies: boolean;
  /** Online Origin */
  online_origin: boolean;
  ska_override?: SkaOverride | null;
  /**
   * Blocked Creditors
   * @default []
   */
  blocked_creditors?: SkaBlockedCreditor[];
  /**
   * Locked Credits
   * @default []
   */
  locked_credits?: SkaLockedCredit[];
}

/**
 * SkaImpactResponse
 * What the SKA rules block on a native NO blanco or NO mortgage application's invites, and the override in force.
 * `None` for any other application (`services.ska_override.service.supports_ska_override`).
 */
export interface SkaImpactResponse {
  /**
   * Event
   * @default "ska_impact"
   */
  event?: "ska_impact";
  data?: SkaImpact | null;
}

/**
 * SkaLockedCredit
 * A credit on the application that is a loan Zensum disbursed: autoinvite sends it with refinance_amount = 0.
 */
export interface SkaLockedCredit {
  /**
   * Credit Id
   * @format uuid
   */
  credit_id: string;
  /** Bank Id */
  bank_id: number;
  /** Bank Name */
  bank_name: string;
  /** Sum */
  sum: number;
  /** Disbursed Bank Id */
  disbursed_bank_id: number;
  /**
   * Disbursed Date
   * @format date-time
   */
  disbursed_date: string;
  /** Refinance After Months */
  refinance_after_months: number;
}

/**
 * SkaOverride
 * Turns the SKA rules off for this application's invites: a creditor that recently disbursed a loan to the
 * customer is invited anyway, and that loan stays open for refinancing (`events_out/invites/blanco.py` in
 * applications-manager). ZRM-only NO blanco and NO mortgage applications (ULNO, MONO), which share this data model
 * and that invite path.
 *
 * Write-once: set on create (online-first, online), by the ULNO/MONO `ska-override` endpoint (manual) or by
 * applications-manager's online backfill (online), and never cleared or replaced — nothing may turn an override off
 * once it is on.
 */
export interface SkaOverride {
  source: SkaOverrideSource;
  /**
   * Set At
   * @format date-time
   */
  set_at: string;
  /** Set By */
  set_by?: string | null;
  /** Reason */
  reason?: string | null;
}

/** SlimApplication */
export interface SlimApplication {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  id: string;
  product: Product;
  /**
   * Created
   * @format date-time
   */
  created: string;
  /** Offers */
  offers: SlimOffer[];
  /** Status */
  status: string;
  /** Requested Amount */
  requested_amount: number;
}

/** SlimCustomer */
export interface SlimCustomer {
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /** First Name */
  first_name: string | null;
  /** Last Name */
  last_name: string | null;
  /** Email */
  email: string | null;
  /** Phone Number */
  phone_number: string | null;
  country: Country | null;
  /** Age */
  age: number | null;
  /** Street Address */
  street_address: string | null;
  /** Post Code */
  post_code: string | null;
  /** City */
  city: string | null;
}

/** SlimDMCampaign */
export interface SlimDMCampaign {
  /** Id */
  id: string;
  /** Name */
  name: string | null;
  product: ExtendedProduct | null;
  country: Country | null;
  /** Description */
  description: string | null;
}

/** SlimDMLead */
export interface SlimDMLead {
  /** Id */
  id: string;
  /** Status */
  status?: string | null;
  /** Comment */
  comment?: string | null;
  /** Process Type */
  process_type?: string | null;
  /** Process Subtype */
  process_subtype?: string | null;
}

/** SlimEmployee */
export interface SlimEmployee {
  /** User Id */
  user_id: string;
  /** First Name */
  first_name: string | null;
  /** Last Name */
  last_name: string | null;
}

/** SlimInsurance */
export interface SlimInsurance {
  /** Id */
  id: string;
  status: InsuranceStatus;
  substatus: InsuranceSubstatus;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Premium Amount */
  premium_amount: number;
  insurance_type: InsuranceType;
  insurance_group: InsuranceGroup;
}

/** SlimMessage */
export interface SlimMessage {
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  direction: Direction;
  /** Message */
  message: string | null;
  /** Sender */
  sender: string | null;
}

/** SlimMortgageLead */
export interface SlimMortgageLead {
  /** Id */
  id: string;
  /**
   * Created
   * @format date-time
   */
  created: string;
  /** Status */
  status: string;
  /** Requested Amount */
  requested_amount: number | null;
}

/** SlimOffer */
export interface SlimOffer {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Created
   * @format date-time
   */
  created: string;
  /** Status */
  status: string;
  /** Amount */
  amount: number;
  /** Creditor */
  creditor: string;
}

/** Slots */
export interface Slots {
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
}

/** SmsBatchStats */
export interface SmsBatchStats {
  /**
   * Sent
   * @default 0
   */
  sent?: number;
  /**
   * Clicks
   * @default 0
   */
  clicks?: number;
  /**
   * Unique Clicks
   * @default 0
   */
  unique_clicks?: number;
  /**
   * Unsubscribed
   * @default 0
   */
  unsubscribed?: number;
  /**
   * Redirects
   * @default 0
   */
  redirects?: number;
  /**
   * Unique Redirects
   * @default 0
   */
  unique_redirects?: number;
  /**
   * Batch Id
   * @format uuid
   */
  batch_id: string;
  /**
   * Batch Sent
   * @format date-time
   */
  batch_sent: string;
}

/**
 * SmsCampaignData
 * Complete data model for SMS campaigns, including both user-editable fields and system-managed state
 * Should only be used for read operations, for create/update use SmsCampaignEditableData
 */
export interface SmsCampaignData {
  /** Last Bq Sync */
  last_bq_sync?: string | null;
  /** Template Vars */
  template_vars?: string[] | null;
  /** Template Vars Checked At */
  template_vars_checked_at?: string | null;
  /** Template Updated At */
  template_updated_at?: string | null;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Source */
  source:
    | ({
        type: "BIG_QUERY";
      } & BigQueryCampaignSource)
    | ({
        type: "PROCESS";
      } & ProcessCampaignSource)
    | ({
        type: "SHEET";
      } & SheetCampaignSourceOutput);
  /** File Id */
  file_id?: string | null;
  exclusion_rules: ExclusionRules;
  /** Daily Extraction Limit */
  daily_extraction_limit?: number | null;
  /**
   * Auto Extraction
   * Time of auto extraction in HH:MM format
   */
  auto_extraction?: string | null;
  /** Comment Template */
  comment_template?: string | null;
  sms_template?: SmsTemplate | null;
  sms_policy?: SendPolicy | null;
  /** Test Phone Numbers */
  test_phone_numbers?: string[] | null;
  type: CampaignType;
  country: Country;
  /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
  product: ExtendedProduct;
  department?: ZDepartment | null;
  /**
   * Contact Type
   * @default "sms"
   */
  contact_type?: "sms";
  /**
   * Is Prospect Campaign
   * @default false
   */
  is_prospect_campaign?: boolean;
  /**
   * Sms Sends
   * @default []
   */
  sms_sends?: SmsData[];
  /** Last Sms At */
  last_sms_at?: string | null;
  current_sms_schedule?: CampaignSmsSchedule | null;
}

/** SmsCampaignTemplateLink */
export interface SmsCampaignTemplateLink {
  /** Name */
  name: string;
  /** Conflict */
  conflict: boolean;
}

/** SmsCampaignTemplateVarsResponse */
export interface SmsCampaignTemplateVarsResponse {
  /**
   * Tracking Links
   * @default []
   */
  tracking_links?: SmsCampaignTemplateLink[];
  /**
   * Template Vars
   * @default []
   */
  template_vars?: string[];
}

/** SmsCampaignTestPayload */
export interface SmsCampaignTestPayload {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /**
   * Phone Numbers
   * @maxItems 10
   */
  phone_numbers: string[];
  /**
   * Template Vars
   * @default []
   */
  template_vars?: string[];
}

/** SmsData */
export interface SmsData {
  /**
   * Sms Batch Id
   * @format uuid
   */
  sms_batch_id: string;
  sms_template: SmsTemplate;
  /** Template Vars */
  template_vars?: string[] | null;
  /** Template Vars Checked At */
  template_vars_checked_at?: string | null;
  /** Template Links Vars */
  template_links_vars?: string[] | null;
  /**
   * Leads Count
   * @min 0
   */
  leads_count: number;
  /** Send Times */
  send_times: string[];
}

/** SmsParts */
export interface SmsParts {
  /** Encoding */
  encoding: "GSM-7" | "UCS-2";
  /** Segments */
  segments: number;
  /** Characters */
  characters: number;
}

/** SmsScheduleBatch */
export interface SmsScheduleBatch {
  /**
   * Time Slot
   * @format date-time
   */
  time_slot: string;
  /**
   * Leads Count
   * Number of leads scheduled for this time slot, not necessarily the number of leads actually sent
   * @min 0
   */
  leads_count: number;
  /**
   * Test Sms
   * @default false
   */
  test_sms?: boolean;
}

/** SmsStatsBucket */
export interface SmsStatsBucket {
  /**
   * Hour
   * @format date-time
   */
  hour: string;
  event?: TemplateEvent | null;
  product?: ExtendedProduct | null;
  country?: Country | null;
  /** Count */
  count: number;
  /** Char Count */
  char_count: number;
}

/** SmsStatsRequest */
export interface SmsStatsRequest {
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /**
   * End Date
   * @format date-time
   */
  end_date: string;
  /** Products */
  products?: ExtendedProduct[] | null;
  /** Countries */
  countries?: Country[] | null;
  /** Events */
  events?: TemplateEvent[] | null;
}

/** SmsTemplate */
export interface SmsTemplate {
  event: TemplateEvent;
  product: ExtendedProduct | null;
  country: Country;
  /** @default "SMS" */
  message_type?: MessageType;
  /**
   * Timestamp
   * @format date-time
   * @default "2026-11-02T12:01:32.153860Z"
   */
  timestamp?: string;
  /** Comment */
  comment?: string | null;
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean | null;
  /** Name */
  name?: string | null;
  /** Use Tracking Urls */
  use_tracking_urls?: boolean | null;
  /** Link Vars */
  link_vars?: string[] | null;
  /** Link Vars Checked At */
  link_vars_checked_at?: string | null;
  /**
   * Allow Reply
   * @default true
   */
  allow_reply?: boolean | null;
  /** Body */
  body: string;
}

/** SmsTemplateRenderPayload */
export interface SmsTemplateRenderPayload {
  /** Template Body */
  template_body: string;
  /**
   * Template Vars
   * @default []
   */
  template_vars?: string[];
  /**
   * Tracking Links
   * @default []
   */
  tracking_links?: string[];
  country: Country;
}

/** SmsTemplateRenderResponse */
export interface SmsTemplateRenderResponse {
  /** Rendered Text */
  rendered_text: string;
  /** Char Count */
  char_count: number;
  /** Segments */
  segments: number;
  /** Encoding */
  encoding: string;
  /** Chars Remaining */
  chars_remaining: number;
}

/** SmsTemplateStats */
export interface SmsTemplateStats {
  /** Last Sent At */
  last_sent_at?: string | null;
  /** Last Hour */
  last_hour: number;
  /** Last 24H */
  last_24h: number;
  /** Last 7D */
  last_7d: number;
}

/** SmsTemplateValidatePayload */
export interface SmsTemplateValidatePayload {
  /** Template Body */
  template_body: string;
  /**
   * Max Segments
   * @default 3
   */
  max_segments?: number;
  country: Country;
}

/** SmsTemplateValidateResponse */
export interface SmsTemplateValidateResponse {
  /** Is Valid */
  is_valid: boolean;
  /** Error */
  error?: string | null;
  /** Char Count */
  char_count: number;
  /** Segments */
  segments: number;
  /** Encoding */
  encoding: string;
  /** Single Limit */
  single_limit: number;
  /** Multi Limit */
  multi_limit: number;
  /** Chars Remaining */
  chars_remaining: number;
}

/**
 * Snippet
 * Materialized snippet view
 */
export interface Snippet {
  /**
   * Category Id
   * @format uuid
   */
  category_id: string;
  /**
   * Title
   * @minLength 1
   * @maxLength 120
   */
  title: string;
  /**
   * Body
   * @minLength 1
   */
  body: string;
  /**
   * Contexts
   * @minItems 1
   */
  contexts: SnippetContext[];
  country: Country;
  /**
   * Products
   * @minItems 1
   */
  products: ExtendedProduct[];
  /** Bank Id */
  bank_id?: number | null;
  /**
   * Snippet Id
   * @format uuid
   */
  snippet_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Updated By */
  updated_by: string;
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean;
}

/**
 * SnippetCategory
 * Stored category.
 */
export interface SnippetCategory {
  /**
   * Title
   * @minLength 1
   * @maxLength 50
   */
  title: string;
  /**
   * Color
   * @pattern ^#[0-9a-f]{6}$
   */
  color: string;
  /**
   * Category Id
   * @format uuid
   */
  category_id: string;
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Updated By */
  updated_by: string;
}

/**
 * SnippetCategoryData
 * Payload for creating/updating a category.
 */
export interface SnippetCategoryData {
  /**
   * Title
   * @minLength 1
   * @maxLength 50
   */
  title: string;
  /**
   * Color
   * @pattern ^#[0-9a-f]{6}$
   */
  color: string;
}

/**
 * SnippetData
 * Payload for creating/updating a snippet. Does not include metadata like id or timestamps.
 */
export interface SnippetData {
  /**
   * Category Id
   * @format uuid
   */
  category_id: string;
  /**
   * Title
   * @minLength 1
   * @maxLength 120
   */
  title: string;
  /**
   * Body
   * @minLength 1
   */
  body: string;
  /**
   * Contexts
   * @minItems 1
   */
  contexts: SnippetContext[];
  country: Country;
  /**
   * Products
   * @minItems 1
   */
  products: ExtendedProduct[];
  /** Bank Id */
  bank_id?: number | null;
}

/**
 * SnippetEvent
 * Append-only log entry. `data` carries the full snapshot for CREATED/UPDATED/DELETED/RESTORED.
 */
export interface SnippetEvent {
  /**
   * Event Id
   * @format uuid
   */
  event_id: string;
  event_type: SnippetEventType;
  /**
   * Snippet Id
   * @format uuid
   */
  snippet_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id: string;
  /** Payload for creating/updating a snippet. Does not include metadata like id or timestamps. */
  data: SnippetData;
}

/**
 * SourceCount
 * How many rows of one source match the search: exact below COUNT_THRESHOLD; at or above it `count` is the
 * threshold and `is_lower_bound` is true.
 */
export interface SourceCount {
  /** Count */
  count: number;
  /** Is Lower Bound */
  is_lower_bound: boolean;
}

/**
 * StandardBreakConflict
 * A window where an employee slot is open (working, no own break) during an operating-hours
 * standard break — i.e. the admin is opening bookable time over the service line's lunch/break.
 */
export interface StandardBreakConflict {
  /** Weekday */
  weekday: number;
  product: Product;
  country: Country;
  /** Open Start */
  open_start: string;
  /** Open End */
  open_end: string;
  /** Standard Break Start */
  standard_break_start: string;
  /** Standard Break End */
  standard_break_end: string;
}

/**
 * StandardSchedule
 * Persisted STANDARD document.
 */
export interface StandardSchedule {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Mode
   * @default "STANDARD"
   */
  mode?: "STANDARD";
  /**
   * Deleted
   * @default false
   */
  deleted?: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Updated By */
  updated_by: string;
  /** User Id */
  user_id: string;
  /**
   * Slots
   * @default []
   */
  slots?: ModelsScheduleEmployeeScheduleScheduleSlotOutput[];
  product: Product;
  country: Country;
  /**
   * Closed Weekdays
   * @default []
   */
  closed_weekdays?: number[];
}

/**
 * StandardScheduleData
 * Works the operating hours for `(product, country)` on every open day, except `closed_weekdays`.
 *
 * Each `slots` entry is a per-weekday override: any slot(s) on a weekday replace the operating-hours
 * derived hours for that weekday (and may carry a different product/country, e.g. Thu–Fri in another
 * country). Days without an override fall back to operating hours, so the schedule tracks op-hours changes.
 */
export interface StandardScheduleData {
  /** User Id */
  user_id: string;
  /**
   * Slots
   * @default []
   */
  slots?: ModelsScheduleEmployeeScheduleScheduleSlotInput[];
  /**
   * Mode
   * @default "STANDARD"
   */
  mode?: "STANDARD";
  product: Product;
  country: Country;
  /**
   * Closed Weekdays
   * @default []
   */
  closed_weekdays?: number[];
}

/** StatusType */
export interface StatusType {
  /** Description */
  Description?: string | null;
  /** Key */
  Key?: string | null;
}

/** StoredMessage */
export interface StoredMessage {
  /** Role */
  role: string;
  /** Content */
  content: string;
  /** Action */
  action?: string | null;
  /** Action Payload */
  action_payload?: Record<string, any> | null;
}

/** SubmissionReview */
export interface SubmissionReview {
  /** Submission Id */
  submission_id: string;
  /** Handled */
  handled?: boolean | null;
  /**
   * Reviews
   * @default []
   */
  reviews?: Reviewer[];
  /**
   * Success
   * @default false
   */
  success?: boolean;
  /**
   * Ongoing
   * @default false
   */
  ongoing?: boolean;
  /**
   * Submission Timestamp
   * @format date-time
   */
  submission_timestamp: string;
  /** Raw Data */
  raw_data: Record<string, any>;
  country: Country;
  product: Product;
  /** Request Id */
  request_id: string;
  /** @default {} */
  checklist?: Checklist;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Version
   * @default 1
   */
  version?: number | null;
  /** Parsed Form */
  parsed_form?: NOApplicationForm | SEApplicationForm | null;
  /** Quick Application */
  quick_application?:
    | (
        | ({
            product: "blanco";
          } & OptionalQuickCreateBlancoApplicationOutput)
        | ({
            product: "mortgage";
          } & OptionalQuickCreateMortgageApplicationOutput)
      )
    | null;
  parsed_application?: JotformCCApplication | null;
  /** Gid */
  gid?: string | null;
  /** Zid */
  zid?: string | null;
  /** Session Zid */
  session_zid?: string | null;
  /** Gid List */
  gid_list?: string | null;
  /** Google Session Id */
  google_session_id?: number | null;
  /** Affiliate Id */
  affiliate_id?: string | null;
  /** Http Request Metadata */
  http_request_metadata?: Record<string, any> | null;
  /** Cc Converted Blanco App Id */
  cc_converted_blanco_app_id?: string | null;
  cc_conversion_status?: ConvertToBlancoStatus | null;
}

/** SubmissionReviewResponse */
export interface SubmissionReviewResponse {
  /** Submissions */
  submissions: BasicSubmissionReview[];
  /** Next Cursor */
  next_cursor?: string | null;
  /** Prev Cursor */
  prev_cursor?: string | null;
}

/** SubscribeKeys */
export interface SubscribeKeys {
  /** P256Dh */
  p256dh: string;
  /** Auth */
  auth: string;
}

/** SubscribePayload */
export interface SubscribePayload {
  /** Endpoint */
  endpoint: string;
  keys: SubscribeKeys;
}

/** SummarizedView */
export interface SummarizedView {
  accepted?: AcceptedLoans | null;
  disbursed?: AllDisbursedLoans | null;
  insurance?: AllInsurances | null;
  mortgage_leads?: MortgageLeads | null;
}

/** Summary */
export interface Summary {
  /** Creditors Invited */
  creditors_invited: number;
  /** Offers Received */
  offers_received: number;
  /** Filtered Out */
  filtered_out: number;
  /** Send Failed */
  send_failed: number;
  /** Denied */
  denied: number;
  /** Pending */
  pending: number;
  /** Auto Invites */
  auto_invites: number;
  /** Manual Invites */
  manual_invites: number;
  /** Re Invites */
  re_invites: number;
}

/**
 * SummaryResponse
 * Response model for application summary.
 */
export interface SummaryResponse {
  /** Summary */
  summary: string;
  /** The language of the generated summary */
  language: Language;
  /**
   * Customer Id
   * The unique identifier of the customer
   * @format uuid
   */
  customer_id: string;
}

/** SverkerAppData */
export interface SverkerAppData {
  /** Created By */
  created_by?: string | null;
  /** Advisor Id */
  advisor_id?: string | null;
  /** Updated By */
  updated_by?: string | null;
}

/**
 * SverkerBookingSnapshot
 * One Sverker booking of the row, as it was when the row moved.
 */
export interface SverkerBookingSnapshot {
  /** Booking Row Id */
  booking_row_id: number;
  /**
   * Meeting Time
   * @format date-time
   */
  meeting_time: string;
  /** Is Exact */
  is_exact: boolean;
  /** Should Remind */
  should_remind: boolean;
  /** Reminder Sent */
  reminder_sent: boolean;
  /** Type */
  type?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** SverkerSearchApplicationResponse */
export interface SverkerSearchApplicationResponse {
  /** Id */
  id: number;
  /** Created At */
  created_at: string;
}

/** SverkerSearchResponse */
export interface SverkerSearchResponse {
  /** Applications */
  applications: SverkerSearchApplicationResponse[];
}

/** SverkerUsername */
export interface SverkerUsername {
  clearance_id?: SverkerClearanceID | null;
  /** Username */
  username: string;
}

/** TMCampaign */
export interface TMCampaign {
  /** Query */
  query: string;
  country: Country;
  product: Product;
  department: ZDepartment;
  /** Description */
  description: string;
  /**
   * Ignore Days Since Last Extraction
   * Number of days since last extraction to ignore customer_id
   * @default 30
   */
  ignore_days_since_last_extraction?: number;
  /** Campaign Id */
  campaign_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Created By */
  created_by: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Updated By */
  updated_by: string;
  /** Active */
  active: boolean;
}

/** TMCampaignList */
export interface TMCampaignList {
  /** Total */
  total: number;
  /** Data */
  data: TMCampaign[];
}

/** TMLead */
export interface TMLead {
  /** Customer Id */
  customer_id: string;
  /** Tags */
  tags?: Record<string, any> | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  app_id: string;
}

/** TMLeadsExtraction */
export interface TMLeadsExtraction {
  /** Leads */
  leads: TMLead[];
  /** Filtering Reasons */
  filtering_reasons: FilteringResult[];
  /** Campaign Id */
  campaign_id: string;
  /** Job Id */
  job_id: string;
  /**
   * Extraction Date
   * @format date-time
   */
  extraction_date: string;
  /** User Id */
  user_id?: string | null;
  /** Request Id */
  request_id: string;
}

/** TMLeadsJob */
export interface TMLeadsJob {
  /** Job Id */
  job_id: string;
  /**
   * Is Finished
   * @default false
   */
  is_finished?: boolean;
  /**
   * Is Failed
   * @default false
   */
  is_failed?: boolean;
}

/** TakeCreditCheck */
export interface TakeCreditCheck {
  /** Customer Id */
  customer_id: string;
  /** Reason */
  reason: string;
}

/** Tax */
export interface Tax {
  /** Id */
  id: string;
  /**
   * Key
   * Used to get the correct table
   */
  key: string;
  /** Description */
  description: string;
  /** Municipality Code */
  municipality_code: string;
  country: Country;
}

/** TaxDeduction */
export interface TaxDeduction {
  /** Lower */
  lower: number;
  /** Upper Yearly Limit */
  upper_yearly_limit: number;
  /** Upper */
  upper: number;
}

/** TaxItem */
export interface TaxItem {
  /** Assessed Income */
  assessed_income?: string | null;
  /** Assessed Wages */
  assessed_wages?: string | null;
  /** Capital Gains */
  capital_gains?: string | null;
  /** Final Tax */
  final_tax?: string | null;
  /** Income Year */
  income_year?: string | null;
  /** Remaining Tax */
  remaining_tax?: string | null;
  /** Total Income */
  total_income?: string | null;
  /** Year */
  year?: string | null;
}

/** TaxThousand */
export interface TaxThousand {
  /** Assessed Income Thousand */
  assessed_income_thousand?: string | null;
  /** Assessed Wages Thousand */
  assessed_wages_thousand?: string | null;
  /** Capital Gains Thousand */
  capital_gains_thousand?: string | null;
  /** Final Tax Thousand */
  final_tax_thousand?: string | null;
  /** Income Year */
  income_year?: string | null;
  /** Remaining Tax Thousand */
  remaining_tax_thousand?: string | null;
  /** Taxed Income */
  taxed_income?: string | null;
  /** Year */
  year?: string | null;
}

/** TelavoxExtension */
export interface TelavoxExtension {
  /**
   * Extension
   * The extension number
   */
  extension: string;
  /**
   * Name
   * The name of the user
   */
  name: string;
  /**
   * Email
   * The email of the user
   */
  email: string;
  /**
   * Mobile
   * The mobile number of the user
   */
  mobile?: string | null;
  /** The profile of the user */
  profile?: TelavoxExtensionProfile | null;
  /**
   * Calls
   * The current call of the user
   */
  calls?: TelavoxExtensionCall[] | null;
  /**
   * Extensione164
   * The extension number in E164 format
   */
  extensionE164?: string | null;
  /**
   * Mobilee164
   * The mobile number in E164 format
   */
  mobileE164?: string | null;
  /**
   * Keywords
   * Keywords for the user
   */
  keywords?: string[] | null;
}

/** TelavoxExtensionCall */
export interface TelavoxExtensionCall {
  /**
   * Callerid
   * The dialed number
   */
  callerid: string;
  direction: TelavoxDirection;
  linestatus: TelavoxLineStatus;
}

/** TelavoxExtensionProfile */
export interface TelavoxExtensionProfile {
  /**
   * Available
   * Is the user available for calls
   */
  available: boolean;
  /**
   * Name
   * Name of current status for telavox user
   */
  name: string;
  /**
   * Until
   * Time that the user is available until
   */
  until?: string | null;
  /**
   * Message
   * Message for current status set by user
   */
  message?: string | null;
}

/** TelavoxMismatch */
export interface TelavoxMismatch {
  /** No Id Set */
  no_id_set: TelavoxNoUserWithId[];
  /** No Name Match */
  no_name_match: TelavoxZrmMismatch[];
}

/** TelavoxNoUserWithId */
export interface TelavoxNoUserWithId {
  /** Telavox User */
  telavox_user: string;
  /** Telavox Id */
  telavox_id: string;
}

/** TelavoxZrmMismatch */
export interface TelavoxZrmMismatch {
  /** Full Name */
  full_name: string;
  /** Telavox Full Name */
  telavox_full_name: string;
  /** User Id */
  user_id: string;
}

/** TemplateDryRunResult */
export interface TemplateDryRunResult {
  /** Tested Leads */
  tested_leads: number;
  /** Populated Leads */
  populated_leads: number;
  errors: TemplateVarsPopulateErrors;
}

/** TemplateVariables */
export interface TemplateVariables {
  /** Template Vars */
  template_vars: string[];
  /** Link Vars */
  link_vars: string[];
  /**
   * Template Sample Vars
   * @default []
   */
  template_sample_vars?: SampleVars[];
}

/** TemplateVarsPopulateErrors */
export interface TemplateVarsPopulateErrors {
  /**
   * No Email
   * @default 0
   */
  no_email?: number;
  /**
   * Failed Vars
   * @default []
   */
  failed_vars?: FailedVariable[];
  /**
   * No Links
   * @default 0
   */
  no_links?: number;
  /**
   * Failed Links
   * @default []
   */
  failed_links?: FailedVariable[];
  /**
   * No Comment Subject
   * @default 0
   */
  no_comment_subject?: number;
}

/** TestSmsPayload */
export interface TestSmsPayload {
  /**
   * Phone Numbers
   * @maxItems 10
   */
  phone_numbers: string[];
  /** Text */
  text: string;
  country: Country;
}

/** TestSmsResponse */
export interface TestSmsResponse {
  /** Sent */
  sent: number;
  /** Failed */
  failed: number;
  /** Results */
  results: Record<string, any>[];
}

/** TestTemplatePayload */
export interface TestTemplatePayload {
  /** To */
  to: string[];
  /** Mandrill Name */
  mandrill_name: string;
  /** Global Merge Vars */
  global_merge_vars: MergeVarContent[];
  /** Merge Vars */
  merge_vars: MergeVar[];
  /**
   * From Email
   * @format email
   */
  from_email: string;
  /** From Name */
  from_name: string;
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Test With Real Data
   * @default false
   */
  test_with_real_data?: boolean;
}

/**
 * ThreadSummary
 * Summary of an email thread for the inbox view.
 */
export interface ThreadSummary {
  /** Thread Id */
  thread_id: string;
  /** Customer Id */
  customer_id: string;
  /** Subject */
  subject: string;
  /**
   * Last Email At
   * @format date-time
   */
  last_email_at: string;
  /** Email Count */
  email_count: number;
  /** Unread Count */
  unread_count: number;
  /** Last Direction */
  last_direction: string;
  /** Last From Email */
  last_from_email: string;
  /** Last Body Preview */
  last_body_preview: string;
}

/** TimeWindow */
export interface TimeWindow {
  /**
   * Start
   * @format date-time
   */
  start: string;
  /**
   * End
   * @format date-time
   */
  end: string;
}

/** TimelineEvent */
export interface TimelineEvent {
  /** Type */
  type: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Details */
  details?: Record<string, any> | null;
  /** Creditor Payload */
  creditor_payload?: Record<string, any> | null;
  /** Actor User Id */
  actor_user_id?: string | null;
  /**
   * Actor Is Customer
   * @default false
   */
  actor_is_customer?: boolean;
}

/**
 * TimelineResponse
 * Orchestrator response. A degraded contributor populates `degraded_sources`
 * and never silently advances `next_cursor`.
 */
export interface TimelineResponse {
  /** Events */
  events?: ServicesCustomerTimelineModelsEvent[];
  /** Next Cursor */
  next_cursor?: string | null;
  /** Degraded Sources */
  degraded_sources?: string[];
  /** Output of the scope resolver. v1 `policy='developer'` => full_scope=True. */
  scope: ResolvedScope;
  /**
   * Returned by the orchestrator after its single audited KDLT read (so the FE
   * header needs no second access_events write).
   */
  customer_header: CustomerHeader;
}

/**
 * TodoCustomerApplicationList
 * The customer's applications for one expanded row, in the raw apps-mgr shape.
 *
 * Deliberately NOT a projection. The row renders these with the case view's own
 * `ApplicationHistory` component, and both views read them from the same
 * `get_raw_applications_by_customer_ids` call — so a narrower model here would be a second
 * shape to keep in step with the first, for a payload that is one customer either way. It
 * would also drop `banks`/`data`, which is where the section reads the disbursed bank and
 * amount from.
 */
export interface TodoCustomerApplicationList {
  /** Items */
  items: (
    | (
        | ({
            country: "NO";
          } & RawBlancoApplicationNO)
        | ({
            country: "SE";
          } & RawBlancoApplicationSE)
      )
    | RawCreditCardApplicationNO
    | (
        | ({
            country: "NO";
          } & RawMortgageApplicationNO)
        | ({
            country: "SE";
          } & RawMortgageApplicationSE)
      )
  )[];
  /**
   * Origin By Label
   * @default {}
   */
  origin_by_label?: Record<string, ResolvedOrigin>;
  /** Total */
  total?: number | null;
}

/**
 * TodoCustomerLead
 * Whether a customer is already being worked, for the case view.
 *
 * Two levels of answer, and which one comes back depends on who is asking.
 *
 * The fields above ``is_mine`` are the compact answer, readable by anyone the case view is
 * open to — every department. They say "this case is taken, by them, since then" and nothing
 * more: no customer contact data, no escalation ``comment_vars``.
 *
 * The fields below it are the handler's own working context, and are filled ONLY when the
 * viewer is the handler holding the lead. That is the same rule the todomaker list follows,
 * and it is what lets someone resolve their own lead from the case view instead of walking
 * back to the queue. **Anything added down there widens what a non-KH reader could see if the
 * gate is ever got wrong — put it above the line only if it is safe for everyone.**
 */
export interface TodoCustomerLead {
  /** Lead Id */
  lead_id: string;
  /** Campaign Id */
  campaign_id?: string | null;
  /** Campaign Name */
  campaign_name?: string | null;
  process_type?: ProcessCampaignType | null;
  /** Held By */
  held_by?: string | null;
  /** Held Since */
  held_since?: string | null;
  /** On List Of */
  on_list_of?: string | null;
  /**
   * Is Mine
   * @default false
   */
  is_mine?: boolean;
  /** Priority */
  priority?: number | null;
  /**
   * Application Ids
   * @default []
   */
  application_ids?: string[];
  /** Last Call Outcome */
  last_call_outcome?: string | null;
  /** Last Call Outcome At */
  last_call_outcome_at?: string | null;
  /**
   * Call Outcomes
   * @default []
   */
  call_outcomes?: TodoLeadCallOutcome[];
}

/** TodoItem */
export interface TodoItem {
  /** Id */
  id: string;
  kind: TodoKind;
  /** Customer Id */
  customer_id?: string | null;
  /** Customer Name */
  customer_name?: string | null;
  /** Phone */
  phone?: string | null;
  /** Mail */
  mail?: string | null;
  /**
   * Other Phones
   * @default []
   */
  other_phones?: string[];
  contact_type?: ModelsDialMaker2CampaignDataModelsContactType | null;
  /** Priority */
  priority?: number | null;
  call_now_source?: CallNowSources | null;
  /** Call Now At */
  call_now_at?: string | null;
  /** Due At */
  due_at?: string | null;
  /** Prime Time Hour */
  prime_time_hour?: number | null;
  /** Status */
  status?: string | null;
  /**
   * Application Ids
   * @default []
   */
  application_ids?: string[];
  /** Campaign Id */
  campaign_id?: string | null;
  /** Campaign Name */
  campaign_name?: string | null;
  process_type?: ProcessCampaignType | null;
  /** Comment Vars */
  comment_vars?: Record<string, any> | null;
  /** Campaign Image Id */
  campaign_image_id?: string | null;
  product?: ExtendedProduct | null;
  country?: Country | null;
  manual_application_state?: ManualApplicationState | null;
  /** Offers Count */
  offers_count?: number | null;
  /** Requested Amount */
  requested_amount?: number | null;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
  /** Co Applicant Name */
  co_applicant_name?: string | null;
  last_call_outcome?: OutcomeType | null;
  /** Last Call Outcome At */
  last_call_outcome_at?: string | null;
  personal_callback?: PersonalCallback | null;
  /**
   * Call Outcomes
   * @default []
   */
  call_outcomes?: (
    | ({
        type: "CALL_BACK";
      } & CallOutcomeCallBack)
    | ({
        type: "DISCARD";
      } & CallOutcomeDiscard)
    | ({
        type: "FAILURE";
      } & CallOutcomeFailure)
    | ({
        type: "NO_CONTACT";
      } & CallOutcomeNoContact)
    | ({
        type: "SUCCESS";
      } & CallOutcomeSuccess)
  )[];
  /**
   * Acquirable
   * @default false
   */
  acquirable?: boolean;
  /** Distributed To */
  distributed_to?: string | null;
  /**
   * View Only
   * @default false
   */
  view_only?: boolean;
  /** Acquired By */
  acquired_by?: string | null;
  /** Acquired At */
  acquired_at?: string | null;
  /** Version */
  version?: number | null;
}

/**
 * TodoLeadCallOutcome
 * One recorded attempt on the lead — what happened and when.
 */
export interface TodoLeadCallOutcome {
  /** Type */
  type?: string | null;
  /** Timestamp */
  timestamp?: string | null;
}

/** TodoList */
export interface TodoList {
  /** Items */
  items: TodoItem[];
  pool?: TodoPoolPage | null;
  presence?: TodomakerPresence | null;
  /**
   * Distribution Enabled
   * @default false
   */
  distribution_enabled?: boolean;
}

/**
 * TodoOtherCase
 * A case the customer also has, in a campaign their lead is not sitting in.
 *
 * One lead per customer, so a case that loses the priority gate has no lead of its own. This is how the
 * handler on the lead hears about it. Built from `services.dial_maker2.open_cases`.
 */
export interface TodoOtherCase {
  /**
   * Process campaigns. Every member below is in active use.
   *
   * Fifteen aspirational names were removed on 2026-08-19. Nothing had ever created them:
   * `validate_process` rejects each one for every product, so a campaign carrying one could not exist.
   * Verified against production first — all 17 PROCESS campaigns and every lead carried only the values
   * below. Their only consumer was `process_applications.py`, which had no importers and moved leads into
   * those impossible campaigns, so it was removed with them.
   */
  process_type: ProcessCampaignType;
  /** Campaign Name */
  campaign_name: string;
  /** Case Ref */
  case_ref?: string | null;
  /** Reason */
  reason?: string | null;
  /** Since */
  since?: string | null;
  /**
   * First Seen
   * @format date-time
   */
  first_seen: string;
  /**
   * Last Seen
   * @format date-time
   */
  last_seen: string;
}

/** TodoOtherCaseList */
export interface TodoOtherCaseList {
  /** Items */
  items: TodoOtherCase[];
}

/**
 * TodoPoolCampaign
 * One campaign's share of the served pool page.
 */
export interface TodoPoolCampaign {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Rank */
  rank?: number | null;
  /** Total */
  total: number;
  /** Offset */
  offset: number;
  /** Count */
  count: number;
}

/**
 * TodoPoolPage
 * Which slice of the shared pool `items` carries.
 *
 * The pool is laid out campaign after campaign in rank order and cut into full pages of `size`, so a
 * campaign that does not fit in what is left of a page carries on at the top of the next one (`campaigns`
 * says which part of each campaign a page holds). The handler's own rows (claimed leads, callbacks, meetings)
 * are always sent in full and are not counted.
 */
export interface TodoPoolPage {
  /** Page */
  page: number;
  /** Pages */
  pages: number;
  /** Size */
  size: number;
  /** Total */
  total: number;
  /**
   * Campaigns
   * @default []
   */
  campaigns?: TodoPoolCampaign[];
}

/**
 * TodomakerCampaign
 * One campaign the handler is eligible for (admin-assigned), with the
 * handler's own focus state. A paused campaign's pool leads are hidden from
 * the handler's list; claimed leads, callbacks and meetings are unaffected.
 */
export interface TodomakerCampaign {
  /**
   * Campaign Id
   * @format uuid
   */
  campaign_id: string;
  /** Name */
  name: string;
  /**
   * Available Count
   * @default 0
   */
  available_count?: number;
  /**
   * Paused
   * @default false
   */
  paused?: boolean;
  /** Rank */
  rank?: number | null;
  /** Distributed To Me */
  distributed_to_me?: number | null;
  /** Received Today */
  received_today?: number | null;
}

/** TodomakerCampaignList */
export interface TodomakerCampaignList {
  /** Items */
  items: TodomakerCampaign[];
}

/**
 * TodomakerLeadResponse
 * Whether this customer has a pending process-campaign lead. `data` is null when there is
 * none — the panel is absent rather than empty, since that is the common case. A lead nobody has
 * claimed yet comes back with `held_by` null: "in the queue, not picked up" is still something a
 * reader about to call this customer needs to know.
 */
export interface TodomakerLeadResponse {
  /**
   * Event
   * @default "todomaker_lead"
   */
  event?: "todomaker_lead";
  data: TodoCustomerLead | null;
}

/**
 * TodomakerPresence
 * Whether the handler is checked in (services/todomaker/presence.py).
 */
export interface TodomakerPresence {
  /** Checked In */
  checked_in: boolean;
  /** Checked In At */
  checked_in_at?: string | null;
  /** Active Until */
  active_until?: string | null;
  /**
   * On Call
   * @default false
   */
  on_call?: boolean;
}

/** TokenExchangePayload */
export interface TokenExchangePayload {
  /**
   * Code
   * @minLength 16
   * @maxLength 128
   */
  code: string;
}

/** TokenResp */
export interface TokenResp {
  /** Token */
  token: string;
}

/** TranscriptTranslation */
export interface TranscriptTranslation {
  /** Text En */
  text_en: string;
}

/** Transcription */
export interface Transcription {
  /**
   * Transcribed At
   * @format date-time
   */
  transcribed_at: string;
  /** Text */
  text: string;
  /** Text En */
  text_en?: string | null;
  /** Duration Seconds */
  duration_seconds?: number | null;
  /** Duration Formatted */
  duration_formatted?: string | null;
  /** Engine */
  engine?: string | null;
  /** Language */
  language?: string | null;
  /** Whisper Model */
  whisper_model?: string | null;
  /** Align Model */
  align_model?: string | null;
  /** Status */
  status?: string | null;
}

/** TranscriptionLanguage */
export interface TranscriptionLanguage {
  /** Code */
  code: string;
  /** Align Model */
  align_model?: string | null;
  /** Whisper Model */
  whisper_model?: string | null;
  /** Based On Phone */
  based_on_phone?: string | null;
  /** Call Direction */
  call_direction?: "incoming" | "outgoing" | string | null;
}

/** TranslateIncomingRequest */
export interface TranslateIncomingRequest {
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /**
   * Message Id
   * @minLength 1
   * @maxLength 100
   */
  message_id: string;
}

/** TranslateIncomingResponse */
export interface TranslateIncomingResponse {
  /** Translation Id */
  translation_id: string;
  /** Translation */
  translation: string;
  /** Detected Source Language */
  detected_source_language: string | null;
  /** Warnings */
  warnings: TranslateWarning[];
}

/** TranslateRequest */
export interface TranslateRequest {
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id?: string | null;
  /**
   * Text
   * @minLength 1
   * @maxLength 1000
   */
  text: string;
  /**
   * Target Language
   * @maxLength 16
   */
  target_language: string;
  /** Source Language */
  source_language?: string | null;
  /** Message */
  message?: string | null;
  /**
   * Turns
   * @maxItems 6
   */
  turns?: TranslateTurn[];
}

/** TranslateResponse */
export interface TranslateResponse {
  /** Translation Id */
  translation_id: string;
  /** Reply */
  reply: string;
  /** Translation */
  translation: string;
  /** Back Translation */
  back_translation: string;
  /** Detected Source Language */
  detected_source_language: string | null;
  /** Warnings */
  warnings: TranslateWarning[];
  sms: SmsParts;
}

/**
 * TranslateTurn
 * An earlier call in the same translator session, sent back by the client.
 */
export interface TranslateTurn {
  /**
   * Message
   * @maxLength 200
   * @default ""
   */
  message?: string;
  /**
   * Reply
   * @maxLength 1000
   * @default ""
   */
  reply?: string;
  /**
   * Translation
   * @maxLength 2000
   */
  translation: string;
}

/** TranslateWarning */
export interface TranslateWarning {
  kind: CheckKind;
  problem: CheckProblem;
  /** Value */
  value: string;
}

/**
 * TvDashboardGoals
 * The goals of one dashboard in one country for one calendar month (`YYYY-MM`).
 */
export interface TvDashboardGoals {
  /** Apps Day */
  apps_day?: number | null;
  /** Apps Week */
  apps_week?: number | null;
  /** Apps Month */
  apps_month?: number | null;
  /** Helped Month */
  helped_month?: number | null;
  /** Helped Volume Month */
  helped_volume_month?: number | null;
  dashboard: TvDashboard;
  country: Country;
  /**
   * Month
   * @pattern ^\d{4}-(0[1-9]|1[0-2])$
   */
  month: string;
}

/** TvDashboardSnapshot */
export interface TvDashboardSnapshot {
  dashboard: TvDashboard;
  country: Country;
  /**
   * Generated At
   * @format date-time
   */
  generated_at: string;
  /** Timezone */
  timezone: string;
  /**
   * Today
   * @format date
   */
  today: string;
  /**
   * Week Start
   * @format date
   */
  week_start: string;
  /**
   * Month Start
   * @format date
   */
  month_start: string;
  /** Working Days In Month */
  working_days_in_month: number;
  /** Worked Days In Month */
  worked_days_in_month: number;
  mb?: MbDashboard | null;
  kh?: KhDashboard | null;
}

/** TvDevice */
export interface TvDevice {
  /** Id */
  id: string;
  /** Name */
  name: string;
  dashboard: TvDashboard;
  country: Country;
  /** Created By */
  created_by: string;
  /** Created By Name */
  created_by_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Last Seen At */
  last_seen_at?: string | null;
  /** Last Ip */
  last_ip?: string | null;
  /** Revoked At */
  revoked_at?: string | null;
  /** Revoked By */
  revoked_by?: string | null;
}

/** TvPairClaimRequest */
export interface TvPairClaimRequest {
  /**
   * Code
   * @maxLength 32
   */
  code: string;
  /**
   * Name
   * @minLength 1
   * @maxLength 80
   */
  name: string;
  country: Country;
}

/** TvPairPaired */
export interface TvPairPaired {
  /**
   * Status
   * @default "paired"
   */
  status?: "paired";
  /** Token */
  token: string;
  device: TvDevice;
}

/** TvPairPending */
export interface TvPairPending {
  /**
   * Status
   * @default "pending"
   */
  status?: "pending";
}

/** TvPairPollRequest */
export interface TvPairPollRequest {
  /**
   * Pairing Id
   * @maxLength 64
   */
  pairing_id: string;
  /**
   * Poll Secret
   * @maxLength 128
   */
  poll_secret: string;
}

/** TvPairPreviewRequest */
export interface TvPairPreviewRequest {
  /**
   * Code
   * @maxLength 32
   */
  code: string;
}

/** TvPairStartRequest */
export interface TvPairStartRequest {
  dashboard: TvDashboard;
}

/** TvPairStartResponse */
export interface TvPairStartResponse {
  /** Pairing Id */
  pairing_id: string;
  /** Poll Secret */
  poll_secret: string;
  /** Code */
  code: string;
  /**
   * Expires At
   * @format date-time
   */
  expires_at: string;
}

/** TvPairingPreview */
export interface TvPairingPreview {
  dashboard: TvDashboard;
  /** Requested Ip */
  requested_ip: string | null;
  /** User Agent */
  user_agent: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/**
 * URL
 * Non user editable fields
 */
export interface URL {
  /** Url Name */
  url_name: string;
  /** Target Url */
  target_url: string;
  /** Is Active */
  is_active: boolean;
  /** Path */
  path?: string | null;
  utm_tags?: UtmTags | null;
  /** Dynamic Meta Params */
  dynamic_meta_params?: DynamicMetaParams[] | null;
  /**
   * Require Signature
   * @default false
   */
  require_signature?: boolean;
  /** Key */
  key: string;
}

/**
 * UnauthenticatedInsurance
 * Model for Insurance details for what a customer can see
 */
export interface UnauthenticatedInsurance {
  /**
   * Model for Loan Insurance for what a customer can see
   * missing things like events, etc
   */
  insurance: InsuranceCustomer;
  customer: PublicApplicant;
  rules: InsuranceTerms;
}

/** UncertainReasonType */
export interface UncertainReasonType {
  /** Description */
  Description?: string | null;
  /** Key */
  Key?: string | null;
}

/**
 * UnknownSenderContext
 * A sender with no customer: the center is the only place a KH can read what they wrote.
 */
export interface UnknownSenderContext {
  channel: InboundChannel;
  /** Address */
  address: string | null;
  /** Messages */
  messages: SenderMessage[];
}

/** UnsubscribePayload */
export interface UnsubscribePayload {
  /** Endpoint */
  endpoint: string;
}

/** UpdateAndAssignPayloadV2 */
export interface UpdateAndAssignPayloadV2 {
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /** Application Ids */
  application_ids?: string[] | null;
  /** Priority */
  priority?: number | null;
  subject_priority?: MeetingSubject | null;
  /** Booked */
  booked?: boolean | null;
  /** Assign Apps To Handler */
  assign_apps_to_handler: string[];
}

/** UpdateApplicationPayloadExt */
export interface UpdateApplicationPayloadExt {
  loan?: NewMortgageLoan | null;
  refinance_info?: RefinanceInfo | null;
  buying_info?: BuyingInfo | null;
  selling_info?: SellingInfo | null;
  /** Applicants */
  applicants?: BareApplicantWithRole[] | null;
  /** Property Id */
  property_id?: string | null;
  /** Selected Property Ids */
  selected_property_ids?: string[] | null;
  discount?: Discount | null;
  /** Loans */
  loans?: Loan[] | null;
  /** Other Mortgages */
  other_mortgages?: MortgageLoan[] | null;
  status?: StatusInput | null;
  substatus?: Substatus | null;
  bank_status?: SharedModelsStatusBankStatus | null;
  /** Children In The Household */
  children_in_the_household?: number | null;
  /** Children In The Household Fulltime */
  children_in_the_household_fulltime?: number | null;
  /** Other Properties To Keep */
  other_properties_to_keep?: OtherProperty[] | null;
  co_relationship_to_main_applicant?: RelationshipStatus | null;
  guarantor_relationship_to_main_applicant?: RelationshipStatus | null;
  cars?: CarsInput | null;
  brokerage?: Brokerage | null;
  /** New App Options */
  new_app_options?: Option[] | null;
  /** New App Checklist */
  new_app_checklist?: string[] | null;
  /** Internal Comment */
  internal_comment?: string | null;
  source?: ApplicationSourceInput | null;
  aml?: AMLInsertion | null;
  /** Tags */
  tags?: string[] | null;
}

/** UpdateCampaignData */
export interface UpdateCampaignData {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Source */
  source:
    | ({
        type: "BIG_QUERY";
      } & BigQueryCampaignSource)
    | ({
        type: "PROCESS";
      } & ProcessCampaignSource)
    | ({
        type: "SHEET";
      } & SheetCampaignSourceInput);
  /** File Id */
  file_id?: string | null;
  exclusion_rules: ExclusionRules;
  /** Daily Extraction Limit */
  daily_extraction_limit?: number | null;
  /**
   * Auto Extraction
   * Time of auto extraction in HH:MM format
   */
  auto_extraction?: string | null;
  /** Comment Template */
  comment_template?: string | null;
  sms_template?: SmsTemplate | null;
  sms_policy?: SendPolicy | null;
  /** Test Phone Numbers */
  test_phone_numbers?: string[] | null;
  mail_policy?: SendPolicy | null;
  template?: EmailTemplate | null;
  /**
   * Amount Of Bcc Mails
   * @default 1
   */
  amount_of_bcc_mails?: number;
  retry_policy?: RetryPolicy | null;
  /** Auto Dial */
  auto_dial?: boolean | null;
  /** Personal Callbacks */
  personal_callbacks?: boolean | null;
  /** No Contact Outcomes */
  no_contact_outcomes?: string[] | null;
  /** Failure Outcomes */
  failure_outcomes?: string[] | null;
  /** Discard Outcomes */
  discard_outcomes?: string[] | null;
  /**
   * Show Call History
   * @default true
   */
  show_call_history?: boolean | null;
  /**
   * Todomaker
   * @default false
   */
  todomaker?: boolean;
}

/** UpdateCreditCardApplicationPayload */
export interface UpdateCreditCardApplicationPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  data: OptionalCreditCardApplicationDataCreate;
}

/** UpdateCustomerConsentsPayload */
export interface UpdateCustomerConsentsPayload {
  /** Reason */
  reason: string;
  /** Customer Id */
  customer_id: string;
  /**
   * "Model for given consents by customer.
   * It can have 3 states: True, False or None.
   * If None, it means that customer didn't provide consent yet.
   * If False, it means that customer explicitly refused to give consent or have withdrawn it.
   * If True, it means that customer gave consent.
   */
  consents: Consents;
}

/** UpdateCustomerPayload */
export interface UpdateCustomerPayload {
  /** Reason */
  reason: string;
  /** Customer Id */
  customer_id: string;
  data: CustomerData;
  /**
   * Incomes As Displayed
   * `data.incomes` was built from the rows the Case View shows, generated partner and other income included. A generated row missing from it was deleted by the agent, so its legacy source is cleared too. Callers that read the raw record must leave this false.
   * @default false
   */
  incomes_as_displayed?: boolean;
}

/** UpdateFormPreferencePayload */
export interface UpdateFormPreferencePayload {
  /** Form Id */
  form_id: string;
  product: Product;
  country: Country;
  /** Mapping */
  mapping: FieldMapping[];
  /** Preference Id */
  preference_id: string;
}

/** UpdateLeadData */
export interface UpdateLeadData {
  /** Phone */
  phone?: string | null;
  /** Other Phones */
  other_phones?: string[] | null;
  /** Pni */
  pni?: string | null;
  process_type?: ProcessCampaignType | null;
  process_subtype?: InsuranceSubstatus | null;
  /** Priority */
  priority?: number | null;
}

/** UpdateMeetingPayload */
export interface UpdateMeetingPayload {
  /** Meeting Start */
  meeting_start?: string | null;
  /** Meeting End */
  meeting_end?: string | null;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Customer Id */
  customer_id?: string | null;
}

/** UpdateURL */
export interface UpdateURL {
  /** Url Name */
  url_name: string;
  /** Target Url */
  target_url: string;
  /** Is Active */
  is_active: boolean;
  /** Path */
  path?: string | null;
  utm_tags?: UtmTags | null;
  /** Dynamic Meta Params */
  dynamic_meta_params?: DynamicMetaParams[] | null;
  /**
   * Require Signature
   * @default false
   */
  require_signature?: boolean;
}

/**
 * UploadAttachmentResponse
 * Returned from POST /attachments/upload — hand the attachment_id back to /send.
 */
export interface UploadAttachmentResponse {
  /** Attachment Id */
  attachment_id: string;
  /** Filename */
  filename: string;
  /** Content Type */
  content_type: string;
  /** File Size */
  file_size: number;
  /**
   * Expires At
   * @format date-time
   */
  expires_at: string;
}

/** UploadLeadsPayload */
export interface UploadLeadsPayload {
  /** Leads */
  leads: SimulatedLead[];
  /**
   * Dataset
   * @default "simulator"
   */
  dataset?: string;
}

/** UploadResponse */
export interface UploadResponse {
  /** Key */
  key: string;
  /** Etag */
  etag?: string | null;
  /** Version Id */
  version_id?: string | null;
}

/** UsedCredits */
export interface UsedCredits {
  /**
   * Total
   * The total size of all mortages/used credits/loans etc together. CSN loans are not included.
   */
  total?: number | null;
  /**
   * Housingcreditshouses
   * The combined size of the mortgages for house properties
   */
  housingCreditsHouses?: number | null;
  /**
   * Housingcreditstenantownersright
   * The combined size of the mortgages for tenant-owned flats
   */
  housingCreditsTenantOwnersRight?: number | null;
  /**
   * Creditcard
   * The combined size of used credits on credit cards and account credits
   */
  creditCard?: number | null;
  /**
   * Installments
   * The combined size of used credits for installments/hire purchases
   */
  installments?: number | null;
  /**
   * Loanwithoutsecurity
   * The combined size of loans without security
   */
  loanWithoutSecurity?: number | null;
}

/** UserCampaignsExt */
export interface UserCampaignsExt {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Version */
  version: number;
  /** User Id */
  user_id: string;
  /** Joined Campaigns */
  joined_campaigns: JoinedCampaignExt[];
}

/** UserOutcomeCount */
export interface UserOutcomeCount {
  /** User Id */
  user_id?: string | null;
  /** Campaign Id */
  campaign_id?: string | null;
  /**
   * Unique
   * Number of unique customers
   * @default 0
   */
  unique?: number | null;
  /**
   * All
   * Number of all outcomes excluding personal_callbacks
   * @default 0
   */
  all?: number;
  /**
   * First
   * Number of outcomes with first outcome set by user
   * @default 0
   */
  first?: number;
  /**
   * Success
   * Number of successful outcomes
   * @default 0
   */
  success?: number;
  /**
   * Call Back
   * Number of call back outcomes
   * @default 0
   */
  call_back?: number;
  /**
   * No Contact
   * Number of no contact outcomes
   * @default 0
   */
  no_contact?: number;
  /**
   * Failure
   * Number of failure outcomes
   * @default 0
   */
  failure?: number;
  /**
   * Discard
   * Number of discard outcomes
   * @default 0
   */
  discard?: number;
  /**
   * Unique Extracted In Period
   * Number of unique customers extracted in the period
   * @default 0
   */
  unique_extracted_in_period?: number | null;
}

/** UserSettings */
export interface UserSettings {
  /**
   * Compact
   * @default false
   */
  compact?: boolean | null;
  /**
   * Direction
   * @default "ltr"
   */
  direction?: "ltr" | "rtl" | null;
  /**
   * Responsivefontsizes
   * @default true
   */
  responsiveFontSizes?: boolean | null;
  /**
   * Roundedcorners
   * @default true
   */
  roundedCorners?: boolean | null;
  /** Theme */
  theme?: string | null;
  /** Zoordinates */
  zoordinates: string;
  /**
   * Debug
   * @default false
   */
  debug?: boolean | null;
  /** @default "NO_CONSENT" */
  shareNameConsent?: ShareNameConsent;
  sverkerUsername?: SverkerUsername | null;
  /** @default "dayGridMonth" */
  default_calender_view?: DefaultCalendarView | null;
  /** @default "cases" */
  default_search_tab?: DefaultSearchTab | null;
  /** Telavox Api Key */
  telavox_api_key?: string | null;
  /** Last Used Sverker Username */
  last_used_sverker_username?: string | null;
  /** Notification Preferences */
  notification_preferences?: Partial<
    Record<NotificationTypeOutput, NotificationDelivery>
  > | null;
  /** Ui Language */
  ui_language?: string | null;
  /** @default "new_line" */
  messenger_enter_behavior?: MessengerEnterBehavior | null;
  /**
   * Quick Create Confetti Enabled
   * @default true
   */
  quick_create_confetti_enabled?: boolean | null;
  /**
   * Dense Tables
   * @default true
   */
  dense_tables?: boolean | null;
  /** Case View Order */
  case_view_order?: string[] | null;
  /** Case View Collapsed */
  case_view_collapsed?: string[] | null;
  /** Meetings List Page Size */
  meetings_list_page_size?: number | null;
}

/** UtmTags */
export interface UtmTags {
  /** Utm Source */
  utm_source: string | null;
  /** Utm Medium */
  utm_medium: string | null;
  /** Utm Campaign */
  utm_campaign: string | null;
}

/** UtmTagsPreset */
export interface UtmTagsPreset {
  /** Utm Source */
  utm_source: string | null;
  /** Utm Medium */
  utm_medium: string | null;
  /** Utm Campaign */
  utm_campaign: string | null;
  /** Preset Name */
  preset_name: string;
}

/** VacationHome */
export interface VacationHome {
  /** Property Id */
  property_id: string;
  /** Value */
  value?: number | null;
  /** Booli Value */
  booli_value?: number | null;
  /** External Id */
  external_id?: string | null;
  /** Property Type */
  property_type: "VACATION_HOME";
  country: Country;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Other Owner */
  other_owner?: boolean | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Latitude */
  latitude?: number | null;
  /** Longitude */
  longitude?: number | null;
  ev_partial?: EvPartialCommon | null;
  /** Estate Type */
  estate_type?: string | null;
  /** Cadastral Designation */
  cadastral_designation?: string | null;
  [key: string]: any;
}

/** ValidatePayload */
export interface ValidatePayload {
  /** Form Id */
  form_id: string;
  product: Product;
  country: Country;
  /** Mapping */
  mapping: FieldMapping[];
  /**
   * Add Defaults
   * @default false
   */
  add_defaults?: boolean;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
  /** Input */
  input?: any;
  /** Context */
  ctx?: object;
}

/** ValidatorServiceResponseModel */
export interface ValidatorServiceResponseModel {
  /** Valid */
  valid: boolean;
  /** Formatted */
  formatted?: any;
}

/** ValuationPayload */
export interface ValuationPayload {
  /** Search Id */
  search_id: string;
  /** Apartment Number */
  apartment_number?: string | null;
  /** Living Area */
  living_area?: number | null;
}

/** ValuationPayloadV2 */
export interface ValuationPayloadV2 {
  /** External Id */
  external_id: string;
  /** Property Id */
  property_id: string;
  /** Apartment Number */
  apartment_number?: string | null;
  /** Living Area */
  living_area?: number | null;
}

/** Value */
export interface Value {
  /** Accuracylevel */
  AccuracyLevel?: string | null;
  /** Areamarketscore */
  AreaMarketScore?: number | null;
  /** Areavacationhomemarketscore */
  AreaVacationHomeMarketScore?: string | null;
  /** Customerapprovedvalue */
  CustomerApprovedValue?: string | null;
  /** Customermaxvalue */
  CustomerMaxValue?: string | null;
  EstateType?: EstateTypeType | null;
  /** Estimate */
  Estimate?: number | null;
  /** Estimatehaircut */
  EstimateHaircut?: string | null;
  /** Grossvalueestimate */
  GrossValueEstimate?: string | null;
  /** Haircutpercentage */
  HaircutPercentage?: string | null;
  /** Lastknowncommondebt */
  LastKnownCommondebt?: number | null;
  /** Lastknowncommondebtdate */
  LastKnownCommondebtDate?: string | null;
  /** Municipalityscore */
  MunicipalityScore?: number | null;
  /** Netvalueestimate */
  NetValueEstimate?: number | null;
  Status?: StatusType | null;
  /** Storedestimatedocumentationid */
  StoredEstimateDocumentationId?: string | null;
  /** Estimatetotalmarketvalue */
  EstimateTotalMarketValue?: number | null;
  /** Estimatenetmarketvaluerounded */
  EstimateNetMarketValueRounded?: number | null;
  /** Approvedtotalmarketvalue */
  ApprovedTotalMarketValue?: number | null;
  /** Approvednetmarketvalue */
  ApprovedNetMarketValue?: number | null;
  /** Estimateuncertaintylevel */
  EstimateUncertaintyLevel?: number | null;
  /** Estimateadjustmenttype */
  EstimateAdjustmentType?: string | null;
  /** Maxvaluelimit */
  MaxValueLimit?: number | null;
  /** Generalforeclosurediscount */
  GeneralForeclosureDiscount?: number | null;
}

/**
 * ValueLine
 * One application's contribution to its owner's week and day.
 *
 * ``accounting_week`` / ``accounting_day`` are the ISO week and Oslo day of *this*
 * application's first known pool meeting, frozen at its own D. Finalising a provisional
 * line never moves them.
 */
export interface ValueLine {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /**
   * V T
   * @default 0
   */
  v_t?: number;
  /**
   * V Amount
   * @default 0
   */
  v_amount?: number;
  /** Accounting Day */
  accounting_day: string;
  /** Accounting Week */
  accounting_week: string;
  /**
   * ``degraded`` is *not* a state but a flag on the line: a value can be both final and
   * degraded.
   * @default "provisional"
   */
  value_state?: ValueState;
  /**
   * Degraded
   * @default false
   */
  degraded?: boolean;
  /**
   * Inherited Out Of Pool
   * @default false
   */
  inherited_out_of_pool?: boolean;
  /** Snapshot Ref */
  snapshot_ref?: string | null;
  /** Multipliers Version */
  multipliers_version?: number | null;
  /**
   * Decided At
   * @format date-time
   */
  decided_at?: string;
}

/** ValueListItem */
export interface ValueListItem {
  /** Label Sv */
  label_sv?: string | null;
  /** Label Nb */
  label_nb?: string | null;
  /** Label En */
  label_en?: string | null;
  /** Value Sv */
  value_sv?: string | null;
  /** Value En */
  value_en?: string | null;
  /** Value Nb */
  value_nb?: string | null;
}

/**
 * ValueMultipliers
 * One fitted version of the whole value model. Never edited — superseded.
 */
export interface ValueMultipliers {
  /**
   * Version
   * @min 1
   */
  version: number;
  /** Cohort */
  cohort: string;
  /** Fitted On */
  fitted_on: string;
  /** Factors */
  factors: Partial<Record<ValueFactor, FactorMultipliers>>;
}

/** VapidPublicKeyResponse */
export interface VapidPublicKeyResponse {
  /** Public Key */
  public_key: string;
}

/** Vehicle */
export interface Vehicle {
  /** Registration Number */
  registration_number?: string | null;
  /** Brand */
  brand?: string | null;
  /** Model */
  model?: string | null;
  /** Variant */
  variant?: string | null;
  /** Year */
  year?: number | null;
  /** Status */
  status?: string | null;
  /** Ownership */
  ownership?: string | null;
  valuation?: VehicleValuation | null;
  technical?: VehicleTechnical | null;
  /**
   * Valuation Pending
   * @default false
   */
  valuation_pending?: boolean;
  /** Legal Foundations */
  legal_foundations?: Record<string, any> | null;
}

/** VehicleTechnical */
export interface VehicleTechnical {
  /** Vin */
  vin?: string | null;
  /** Colour Name */
  colour_name?: string | null;
  /** Fuel */
  fuel?: string | null;
  /** Power Hp */
  power_hp?: number | null;
  /** Engine Kw */
  engine_kw?: number | null;
  /** Transmission */
  transmission?: string | null;
  /** Drivetrain */
  drivetrain?: string | null;
  /** Emission Standard */
  emission_standard?: string | null;
  /** Co2 G Km */
  co2_g_km?: number | null;
  /** Seats */
  seats?: number | null;
  /** Doors */
  doors?: number | null;
  /** Next Eu Control */
  next_eu_control?: string | null;
}

/** VehicleValuation */
export interface VehicleValuation {
  /** Average Value Nok */
  average_value_nok?: number | null;
  range_nok?: MoneyRange;
  /** Dealer Price Nok */
  dealer_price_nok?: number | null;
  /** Calculated Kilometers */
  calculated_kilometers?: number | null;
  /** Average Kilometers */
  average_kilometers?: number | null;
}

/** WebsiteVisitPayload */
export interface WebsiteVisitPayload {
  /** Landing Url */
  landing_url?: string | null;
  /** Cookie Consent */
  cookie_consent?: string | null;
}

/** WeeklyOpenClose */
export interface WeeklyOpenCloseInput {
  /**
   * Weekday
   * @min 0
   * @max 6
   */
  weekday: number;
  /**
   * Open
   * @format time
   */
  open: string;
  /**
   * Close
   * @format time
   */
  close: string;
  /**
   * Breaks
   * @default []
   */
  breaks?: BreakInput[];
}

/** WeeklyOpenClose */
export interface WeeklyOpenCloseOutput {
  /**
   * Weekday
   * @min 0
   * @max 6
   */
  weekday: number;
  /** Open */
  open: string;
  /** Close */
  close: string;
  /**
   * Breaks
   * @default []
   */
  breaks?: BreakOutput[];
}

/** WithdrawAcceptPayload */
export interface WithdrawAcceptPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Offer Id
   * @format uuid
   */
  offer_id: string;
}

/** WorkingDays */
export interface WorkingDays {
  /** Working Days */
  working_days: number;
  /** Worked Days */
  worked_days: number;
}

/** WorkingResponse */
export interface WorkingResponse {
  /** User Ids */
  user_ids: string[];
}

/** ZMSConfig */
export interface ZMSConfig {
  config: Config;
  country: Country;
  /** User Id */
  user_id: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
}

/**
 * Zenscription
 * Typed representation of a Zenscription call transcription and metadata.
 *
 * Provides convenient access to transcription, LLM post-processing results
 * and associated customer context used during enrichment.
 */
export interface Zenscription {
  /** Recordedcallkey */
  recordedCallKey: string;
  country?: Country | null;
  /** Direction */
  direction?: "incoming" | "outgoing" | string | null;
  download?: DownloadInfo | null;
  /** Duration */
  duration?: string | null;
  /** Duration Seconds */
  duration_seconds?: number | null;
  /** Extensionkey */
  extensionKey?: string | null;
  /** Started */
  started?: string | null;
  transcription_language?: TranscriptionLanguage | null;
  transcription?: Transcription | null;
  llm?: LLMProcessing | null;
  processing?: ProcessingStatus | null;
}

/** ZenscriptionResponse */
export interface ZenscriptionResponse {
  /**
   * Event
   * @default "zenscriptions"
   */
  event?: "zenscriptions";
  /** Data */
  data: Zenscription[];
}

/**
 * ZenscriptionWithCompliance
 * Response model for the CO-gated `/compliance` endpoints ONLY.
 */
export interface ZenscriptionWithCompliance {
  /** Recordedcallkey */
  recordedCallKey: string;
  country?: Country | null;
  /** Direction */
  direction?: "incoming" | "outgoing" | string | null;
  download?: DownloadInfo | null;
  /** Duration */
  duration?: string | null;
  /** Duration Seconds */
  duration_seconds?: number | null;
  /** Extensionkey */
  extensionKey?: string | null;
  /** Started */
  started?: string | null;
  transcription_language?: TranscriptionLanguage | null;
  transcription?: Transcription | null;
  llm?: LLMProcessing | null;
  processing?: ProcessingStatus | null;
  agent?: ComplianceCallAgent | null;
  compliance?: ComplianceData | null;
  /** Reviews */
  reviews?: ComplianceReviewDecision[];
  /** Manual Flags */
  manual_flags?: ComplianceManualFlag[];
}

/** ZhatterActionData */
export interface ZhatterActionData {
  type: ZhatterActionType;
  /** Payload */
  payload?: GrCreditsPayload | OffersPayload | ApplicationFormPayload | null;
}

/** ZhatterActionResponse */
export interface ZhatterActionResponse {
  /**
   * Event
   * @default "action"
   */
  event?: "action";
  data: ZhatterActionData;
}

/** ZhatterDoneResponse */
export interface ZhatterDoneResponse {
  /**
   * Event
   * @default "done"
   */
  event?: "done";
  /** Data */
  data?: null;
}

/** ZhatterErrorResponse */
export interface ZhatterErrorResponse {
  /**
   * Event
   * @default "error"
   */
  event?: "error";
  /** Data */
  data: string;
}

/** ZhatterMessageRequest */
export interface ZhatterMessageRequest {
  /** Session Id */
  session_id?: string | null;
  /**
   * Message
   * @minLength 1
   * @maxLength 2000
   */
  message: string;
  country?: Country | null;
  product?: Product | null;
}

/** ZhatterSessionResponse */
export interface ZhatterSessionResponse {
  /**
   * Event
   * @default "session"
   */
  event?: "session";
  /** Data */
  data: string;
}

/** ZhatterTokenResponse */
export interface ZhatterTokenResponse {
  /**
   * Event
   * @default "token"
   */
  event?: "token";
  /** Data */
  data: string;
}

/** ZhatterToolCallData */
export interface ZhatterToolCallData {
  name: ZhatterToolName;
}

/** ZhatterToolCallResponse */
export interface ZhatterToolCallResponse {
  /**
   * Event
   * @default "tool_call"
   */
  event?: "tool_call";
  data: ZhatterToolCallData;
}

/** ZhatterToolResultData */
export interface ZhatterToolResultData {
  name: ZhatterToolName;
  /** Success */
  success: boolean;
}

/** ZhatterToolResultResponse */
export interface ZhatterToolResultResponse {
  /**
   * Event
   * @default "tool_result"
   */
  event?: "tool_result";
  data: ZhatterToolResultData;
}

/** Zoordinates */
export interface Zoordinates {
  Product: ZProduct;
  Country: ZCountry;
  Office: ZOffice;
  EmploymentType: ZEmploymentType;
  Department: ZDepartment;
}

/** ZrmAssignmentEvent */
export interface ZrmAssignmentEvent {
  /**
   * Event Type
   * @default "ASSIGNMENT"
   */
  event_type?: "ASSIGNMENT";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id?: string | null;
  zoordinates?: Zoordinates | null;
  sverker_data?: ZrmSverkerData | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Handler Id */
  handler_id: string;
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
}

/** ZrmBookingEvent */
export interface ZrmBookingEvent {
  /**
   * Event Type
   * @default "BOOKING"
   */
  event_type?: "BOOKING";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id?: string | null;
  zoordinates?: Zoordinates | null;
  sverker_data?: ZrmSverkerData | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Handler Id */
  handler_id?: string | null;
  /**
   * Meeting Id
   * @format uuid
   */
  meeting_id: string;
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
  /**
   * Meeting Subject
   * @default "Migrated from Sverker"
   */
  meeting_subject?: string;
  booking_type?: SverkerBookingType | null;
  /** Is Exact */
  is_exact?: boolean | null;
}

/** ZrmCreationEvent */
export interface ZrmCreationEvent {
  /**
   * Event Type
   * @default "CREATION"
   */
  event_type?: "CREATION";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id?: string | null;
  zoordinates?: Zoordinates | null;
  sverker_data?: ZrmSverkerData | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Handler Id */
  handler_id?: string | null;
  /**
   * Customer Id
   * @format uuid
   */
  customer_id: string;
}

/** ZrmInternalCommentEvent */
export interface ZrmInternalCommentEvent {
  /**
   * Event Type
   * @default "INTERNAL_COMMENT"
   */
  event_type?: "INTERNAL_COMMENT";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id?: string | null;
  zoordinates?: Zoordinates | null;
  sverker_data?: ZrmSverkerData | null;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Handler Id */
  handler_id?: string | null;
  /**
   * Event Id
   * @format uuid
   */
  event_id: string;
  /** Comment */
  comment: string;
  /** Customer Id */
  customer_id: string | null;
}

/** ZrmMigrationStats */
export interface ZrmMigrationStats {
  /**
   * Creation
   * @default false
   */
  creation?: boolean;
  /**
   * Meetings
   * @default 0
   */
  meetings?: number;
  /**
   * Assignments
   * @default 0
   */
  assignments?: number;
  /**
   * Comments
   * @default 0
   */
  comments?: number;
  /**
   * Text Messages
   * @default 0
   */
  text_messages?: number;
}

/** ZrmMigratorEvents */
export interface ZrmMigratorEvents {
  creation: ZrmCreationEvent;
  /** Assignments */
  assignments: ZrmAssignmentEvent[];
  /** Bookings */
  bookings: ZrmBookingEvent[];
  /** Comments */
  comments: ZrmInternalCommentEvent[];
  /** Text Messages */
  text_messages: ZrmTextMessageEvent[];
}

/** ZrmSverkerData */
export interface ZrmSverkerData {
  /** Version */
  version?: number | null;
  /** Row Id */
  row_id?: number | null;
  /** Source */
  source?: string | null;
  /** User Id */
  user_id?: string | null;
  /** Creator Id */
  creator_id?: string | null;
  /** Advisor Id */
  advisor_id?: string | null;
}

/** ZrmTextMessageEvent */
export interface ZrmTextMessageEvent {
  /**
   * Event Type
   * @default "TEXT_MESSAGE"
   */
  event_type?: "TEXT_MESSAGE";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id?: string | null;
  zoordinates?: Zoordinates | null;
  sverker_data?: ZrmSverkerData | null;
  /**
   * Event Id
   * @format uuid
   */
  event_id: string;
  /** Message */
  message: string;
  direction: ZrmTextMessageDirection;
  /** Customer Id */
  customer_id: string | null;
  /** Sender */
  sender: string;
  /** Recipient */
  recipient: string;
  country: Country;
}

/**
 * _CreatedResponseOut
 * The serialized shape, declared so the wrap serializer does not erase it.
 *
 * A ``mode='wrap'`` serializer returning ``dict[str, Any]`` replaces the **serialization**
 * JSON schema with a bare ``{"type": "object", "additionalProperties": true}``. FastAPI
 * builds response schemas in serialization mode, so every route aliasing this model — both
 * ZRM creation routes, the two credit-card creates via ``ApplicationCreatedResponseExt``,
 * and apps-mgr's v4 creates, duplicate and convert-to-mortgage — would publish an untyped
 * object, and the generated frontend client would flatten on its next regeneration.
 *
 * Annotating the return type restores it in full, so the opt-in identity contract below
 * costs nothing: ``co_applicant_id`` is ``NotRequired`` here because that is exactly what
 * the serializer does with it.
 */
export interface CreatedResponseOut {
  product: Product;
  country: Country;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Customer Id */
  customer_id?: string | null;
  /** Co Applicant Id */
  co_applicant_id?: string | null;
}

/** ScheduleSlot */
export interface ModelsAdvisorScheduleModelScheduleSlot {
  /**
   * Start
   * @format time
   */
  start: string;
  /**
   * End
   * @format time
   */
  end: string;
  /**
   * Available Slots Per Hour
   * @min 0
   */
  available_slots_per_hour: number;
}

/** Campaign */
export interface ModelsAffiliateAffiliateCampaign {
  url_target: Product;
  /** Valid To */
  valid_to?: string | null;
  /** Url */
  url?: string | null;
  /** Campaign Id */
  campaign_id: string;
}

/** Event */
export interface ModelsApplicationMappingApplicationMappingEvent {
  action: Action;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** User Id */
  user_id?: string | null;
  data: DataOutput;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Event Id */
  event_id: string;
  /** Request Id */
  request_id: string;
  zoordinates?: Zoordinates | null;
  /** Distribution Op Id */
  distribution_op_id?: string | null;
}

/** InternalComment */
export interface ModelsApplicationMappingCommentsInternalComment {
  /** User Id */
  user_id: string;
  /** Comment */
  comment: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Comment Id */
  comment_id: string;
  /**
   * Action
   * @default "INTERNAL_COMMENT_ADDED"
   */
  action?: "INTERNAL_COMMENT_ADDED";
}

/** Campaign */
export interface ModelsDialMaker2CampaignAggregateCampaign {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Version */
  version: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Created By */
  created_by: string;
  /** Updated By */
  updated_by?: string | null;
  /** Active */
  active: boolean;
  /** Data */
  data: DialCampaignData | MailCampaignData | SmsCampaignData;
  /** Extractions */
  extractions?: CampaignExtraction[];
  /** Exports */
  exports: CampaignExport[];
  /**
   * Is Prospect Campaign
   * @default false
   */
  is_prospect_campaign?: boolean;
}

/** Meeting */
export interface ModelsMeetingModelsMeeting {
  /**
   * Meeting Start
   * @format date-time
   */
  meeting_start: string;
  /**
   * Meeting End
   * @format date-time
   */
  meeting_end: string;
  /** Handler Id */
  handler_id?: string | null;
  /** Meeting Notes */
  meeting_notes?: string | null;
  /** Meeting Subject */
  meeting_subject?: string | null;
  /** Customer Id */
  customer_id?: string | null;
  /**
   * Application Id
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Meeting Id */
  meeting_id: string;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
  /**
   * Date Created
   * @format date-time
   */
  date_created: string;
  product: Product;
  country: Country;
  /** Customer Name */
  customer_name?: string | null;
}

/** Cars */
export interface ModelsMortgageKALPCars {
  per_leased: CarCost;
  per_owned: CarCost;
}

/** InternalComment */
export interface ModelsNotificationsNotificationInternalComment {
  /** Type */
  type: "INTERNAL_COMMENT_RECEIVED";
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  status: NotificationEvent;
  data: InternalCommentData;
  /** Notification Id */
  notification_id: string;
  /** User Id */
  user_id: string | null;
  delivery?: NotificationDelivery | null;
  /** Url */
  url?: string | null;
}

/** Status */
export interface ModelsOnlineLoanApplicationStatus {
  /** Success */
  success: boolean;
  /** Error */
  error?: string | null;
}

/** ScheduleSlot */
export interface ModelsScheduleEmployeeScheduleScheduleSlotInput {
  /**
   * Weekday
   * @min 0
   * @max 6
   */
  weekday: number;
  /**
   * Start Time
   * @format time
   */
  start_time: string;
  /**
   * End Time
   * @format time
   */
  end_time: string;
  product: Product;
  country: Country;
  /**
   * Breaks
   * @default []
   */
  breaks?: BreakInput[];
}

/** ScheduleSlot */
export interface ModelsScheduleEmployeeScheduleScheduleSlotOutput {
  /**
   * Weekday
   * @min 0
   * @max 6
   */
  weekday: number;
  /** Start Time */
  start_time: string;
  /** End Time */
  end_time: string;
  product: Product;
  country: Country;
  /**
   * Breaks
   * @default []
   */
  breaks?: BreakOutput[];
}

/** InviteZRayResponse */
export interface ModelsSseModelsInviteZRayResponse {
  /**
   * Event
   * @default "invite_z_ray"
   */
  event?: "invite_z_ray";
  data?: SharedApplication2InviteZRayInviteZRayResponse | null;
}

/** PhoneNumber */
export interface ModelsValidatorServicePayloadPhoneNumber {
  country?: Country | null;
  /** Phone Number */
  phone_number: string;
}

/** SearchPayload */
export interface RoutersApplicationApplicationPayloadSearchPayload {
  country?: Country | null;
  product?: Product | null;
  /** String */
  string: string;
  /**
   * Search Types
   * @default []
   */
  search_types?: SearchType[];
}

/** SearchPayload */
export interface RoutersBankPayloadsSearchPayload {
  country?: Country | null;
  product?: Product | null;
  /** String */
  string: string;
}

/** BankIDResp */
export interface RoutersBankIdModelsBankIDResp {
  /** Ticket Id */
  ticket_id: string;
}

/** BankIDResp */
export interface RoutersBankIdLoginPayloadBankIDResp {
  /** Autostart Token */
  autostart_token?: string | null;
  /** Ticket Id */
  ticket_id: string;
  /** Polling Endpoint */
  polling_endpoint?: string | null;
  /** Login Url */
  login_url?: string | null;
  /** Qr Code Content */
  qr_code_content?: string | null;
  /** Autostart Uri */
  autostart_uri?: string | null;
  /** Desktop Autostart Uri */
  desktop_autostart_uri?: string | null;
}

/** SignedUrl */
export interface RoutersDialMaker2PayloadsSignedUrl {
  /** Signed Url */
  signed_url: string;
}

/** SignedUrl */
export interface RoutersDialMakerPayloadsSignedUrl {
  /** Signed Url */
  signed_url: string;
  /** File Name */
  file_name: string;
}

/** SearchPayload */
export interface RoutersEmployeeModelsSearchPayload {
  /** String */
  string: string;
}

/** SearchPayload */
export interface RoutersLeadPayloadSearchPayload {
  /** String */
  string: string;
}

/** AcceptOfferPayload */
export interface RoutersMyPagesPayloadAcceptOfferPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Offer Id */
  offer_id: string;
  /** Bank Account Number */
  bank_account_number?: string | null;
  /** Bank Clearing Number */
  bank_clearing_number?: string | null;
}

/** SearchPayload */
export interface RoutersPropertyPayloadSearchPayload {
  country: Country;
  /** Search String */
  search_string: string;
}

/** Payload */
export interface RoutersZenscriberSupportRouterPayload {
  /** Phone Number */
  phone_number: string;
  /**
   * Call Start
   * @format date-time
   */
  call_start: string;
  /**
   * Call End
   * @format date-time
   */
  call_end: string;
}

/**
 * Event
 * One row on the unified per-customer timeline.
 */
export interface ServicesCustomerTimelineModelsEvent {
  /** Event Id */
  event_id: string;
  /** Customer Id */
  customer_id: string;
  /**
   * Ts
   * @format date-time
   */
  ts: string;
  /** Source */
  source: string;
  /** The 12 UI categories (design) + `score` (backend-only, not a v1 UI chip). */
  lane: Lane;
  /** Type */
  type: string;
  actor: Actor;
  /** Reason */
  reason?: string | null;
  /** Request Id */
  request_id?: string | null;
  /** Root Request Id */
  root_request_id?: string | null;
  /** Correlation Key */
  correlation_key?: string | null;
  scope?: Scope | null;
  /** Title */
  title: string;
  /** Summary */
  summary?: string | null;
  /** Source Payload */
  source_payload?: Record<string, any> | null;
  /** Drill-down handle back to the source document. */
  ref: Ref;
}

/** Meeting */
export interface ServicesSverkerResponsesMeeting {
  /**
   * Id
   * @format date-time
   */
  id: string;
  /** Time */
  time: string;
  /** Booked */
  booked: boolean;
  /** Format */
  format: string;
}

/** InviteZRayResponse */
export interface SharedApplication2InviteZRayInviteZRayResponse {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Invite Start */
  invite_start?: string | null;
  summary: Summary;
  autoinvite?: Autoinvite | null;
  /** Invites */
  invites: InviteGroup[];
}

/** Event */
export interface SharedInsuranceInsuranceEvent {
  /** Eventid */
  eventId: string;
  event: InsuranceEventType;
  data?: EventData;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Orderid */
  orderId?: string | null;
  /** Userid */
  userId?: string | null;
  /**
   * Type
   * The type of the event e.g charges, mandate, etc
   */
  type: string;
  /**
   * Response
   * If the customer responded for a winbackable insurance
   */
  response?: boolean | null;
  /**
   * Comment
   * The comment for the winbackable insurance
   */
  comment?: string | null;
}

/** Payload */
export interface SharedModelsApi2V4ApplicationCommentPayload {
  /**
   * Comment
   * @minLength 1
   */
  comment: string;
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  application_id: string;
  /** Bank Id */
  bank_id: number;
  /** User Name */
  user_name?: string | null;
  /**
   * Idempotency Key
   * @format uuid4
   */
  idempotency_key: string;
}

/** AcceptOfferPayload */
export interface SharedModelsApplicationAcceptOfferPayload {
  /**
   * Application label
   * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
   */
  label: string;
  /**
   * Offer Id
   * @format uuid4
   */
  offer_id: string;
  /**
   * Synchronous
   * @default false
   */
  synchronous?: boolean;
  /**
   * Resend
   * @default false
   */
  resend?: boolean;
}

/** PhoneNumber */
export interface SharedModelsPhonePhoneNumber {
  /** Number */
  number: string;
  type: PhoneNumberType;
}

/** Condominium */
export interface SharedModelsPropertyCondominium {
  /** Property Id */
  property_id: string;
  /** Value */
  value?: number | null;
  /** Booli Value */
  booli_value?: number | null;
  /** External Id */
  external_id?: string | null;
  /** Property Type */
  property_type: "CONDOMINIUM";
  country: Country;
  /** Street Address */
  street_address?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** City */
  city?: string | null;
  /** Other Owner */
  other_owner?: boolean | null;
  /** Monthly Cost */
  monthly_cost?: number | null;
  /** Square Meter Living Area */
  square_meter_living_area?: number | null;
  /** Municipality */
  municipality?: string | null;
  /** Municipality Code */
  municipality_code?: string | null;
  /** Estimated Value */
  estimated_value?: number | null;
  /** Latitude */
  latitude?: number | null;
  /** Longitude */
  longitude?: number | null;
  ev_partial?: EvPartialCommon | null;
  /** Estate Type */
  estate_type?: string | null;
  /** Apartment Number */
  apartment_number?: string | null;
  /** Elevator */
  elevator?: boolean | null;
  /** Organization Number */
  organization_number?: string | null;
  /** Organization Name */
  organization_name?: string | null;
  /** Organization Share Number */
  organization_share_number?: string | null;
  /** Floor */
  floor?: number | null;
  balcony_type?: BalconyType | null;
  /** Rooms */
  rooms?: number | null;
  [key: string]: any;
}

/** Cars */
export interface SharedMortgageSeSpecCommonDefinitionsCars {
  /** Owned */
  owned?: number | null;
  /** Leased */
  leased?: Car[] | null;
}

/** Condominium */
export interface SharedMortgageSeSpecCommonDefinitionsCondominium {
  organizationNumber?: NonEmptyString | null;
  /** Organizationname */
  organizationName?: string | null;
  apartmentNumber?: NonEmptyString | null;
  /** Floor */
  floor?: number | null;
  /** Elevator */
  elevator?: boolean | null;
  balconyType?: BalconyType | null;
}

export namespace Application {
  /**
   * No description
   * @tags Application
   * @name QuickCreateApplicationApplicationQuickCreatePost
   * @summary Quick Create Application
   * @request POST:/application/quick-create
   * @secure
   */
  export namespace QuickCreateApplicationApplicationQuickCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Legacy
       * @default true
       */
      legacy?: boolean;
    };
    export type RequestBody =
      | ({
          product: "mortgage";
        } & QuickCreateMortgageApplication)
      | ({
          product: "blanco";
        } & QuickCreateBlancoApplication);
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationCreatedResponse;
  }

  /**
   * No description
   * @tags Application
   * @name CreateApplicationApplicationCreatePost
   * @summary Create Application
   * @request POST:/application/create
   * @secure
   */
  export namespace CreateApplicationApplicationCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateApplicationPayloadExt;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationCreatedResponseExt;
  }

  /**
   * No description
   * @tags Application
   * @name UpdateApplicationApplicationUpdateApplicationIdPost
   * @summary Update Application
   * @request POST:/application/update/{application_id}
   * @secure
   */
  export namespace UpdateApplicationApplicationUpdateApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateApplicationPayloadExt;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationWithNamesInComments;
  }

  /**
   * No description
   * @tags Application
   * @name GetApplicationApplicationGetPost
   * @summary Get Application
   * @request POST:/application/get
   * @secure
   */
  export namespace GetApplicationApplicationGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationWithNamesInComments;
  }

  /**
   * No description
   * @tags Application
   * @name GetApplicationsApplicationGetsPost
   * @summary Get Applications
   * @request POST:/application/gets
   * @deprecated
   * @secure
   */
  export namespace GetApplicationsApplicationGetsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationsByCustomerIdentifierPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Application[];
  }

  /**
   * No description
   * @tags Application
   * @name GetApplicationsV2ApplicationV2GetsPost
   * @summary Get Applications V2
   * @request POST:/application/v2/gets
   * @secure
   */
  export namespace GetApplicationsV2ApplicationV2GetsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationsByCustomerIdentifierPayloadV2;
    export type RequestHeaders = {};
    export type ResponseBody = Application[];
  }

  /**
   * No description
   * @tags Application
   * @name GetApplicationsAssignedToMeApplicationGetMinePost
   * @summary Get Applications Assigned To Me
   * @request POST:/application/get/mine
   * @secure
   */
  export namespace GetApplicationsAssignedToMeApplicationGetMinePost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = GetMyApplicationsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Application[];
  }

  /**
   * No description
   * @tags Application
   * @name GetRecentApplicationsApplicationGetRecentPost
   * @summary Get Recent Applications
   * @request POST:/application/get/recent
   * @secure
   */
  export namespace GetRecentApplicationsApplicationGetRecentPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = GetRecentApplicationsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Application[];
  }

  /**
   * No description
   * @tags Application
   * @name SearchApplicationsApplicationSearchPost
   * @summary Search Applications
   * @request POST:/application/search
   * @secure
   */
  export namespace SearchApplicationsApplicationSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = RoutersApplicationApplicationPayloadSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Application[];
  }

  /**
   * No description
   * @tags Application
   * @name SearchApplications2ApplicationSearch2Post
   * @summary Search Applications2
   * @request POST:/application/search2
   * @secure
   */
  export namespace SearchApplications2ApplicationSearch2Post {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = RoutersApplicationApplicationPayloadSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AppsSearchResult;
  }

  /**
   * @description Duplicate an application. Works for every product apps-mgr serves, not just MOSE: this used to post to the legacy /v1/duplicate, which routed MOSE to the compat layer and everything else to a Flask handler that only ever understood mortgages. Returns apps-mgr's own response, ``customer_id`` included: with ``swap_applicants`` the duplicate's main applicant is a *different person* than the source's, and the caller has no other way to learn who. Narrowing this to the label alone left the case view opening the duplicate as the old main applicant, who is now the co-applicant, so it rendered the same person in both applicant slots.
   * @tags Application
   * @name DuplicateApplicationApplicationDuplicatePost
   * @summary Duplicate Application
   * @request POST:/application/duplicate
   * @secure
   */
  export namespace DuplicateApplicationApplicationDuplicatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DuplicateApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationCreatedResponse;
  }

  /**
   * No description
   * @tags Application
   * @name DeactivateApplicationApplicationDeactivateProductPost
   * @summary Deactivate Application
   * @request POST:/application/deactivate/{product}
   * @secure
   */
  export namespace DeactivateApplicationApplicationDeactivateProductPost {
    export type RequestParams = {
      product: Product;
    };
    export type RequestQuery = {};
    export type RequestBody = MortgageDeactivatePayload | DeactivatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application
   * @name ReactivateApplicationReactivatePost
   * @summary Reactivate
   * @request POST:/application/reactivate
   * @secure
   */
  export namespace ReactivateApplicationReactivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReactivatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application
   * @name GetBlancoAppsByPniApplicationGetBlancoByPniPost
   * @summary Get Blanco Apps By Pni
   * @request POST:/application/get/blanco/by_pni
   * @secure
   */
  export namespace GetBlancoAppsByPniApplicationGetBlancoByPniPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetBlancoAppsByPni;
    export type RequestHeaders = {};
    export type ResponseBody = BlancoApplicationDataSlim[];
  }

  /**
   * No description
   * @tags Application
   * @name GetQcApplicationQuickCreateGetPost
   * @summary Get Qc
   * @request POST:/application/quick-create/get
   * @secure
   */
  export namespace GetQcApplicationQuickCreateGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetQuickCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          product: "mortgage";
        } & OptionalQuickCreateMortgageApplicationOutput)
      | ({
          product: "blanco";
        } & OptionalQuickCreateBlancoApplicationOutput);
  }

  /**
   * No description
   * @tags Application V2
   * @name PatchApplicationFieldsApplicationV2PatchApplicationPost
   * @summary Patch Application Fields
   * @request POST:/application/v2/patch-application
   * @secure
   */
  export namespace PatchApplicationFieldsApplicationV2PatchApplicationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      | ({
          country: "NO";
        } & (
          | ({
              product: "blanco";
            } & BlancoPatchPayloadNO)
          | ({
              product: "credit_card";
            } & CreditCardPatchPayload)
          | ({
              product: "mortgage";
            } & MortgagePatchPayloadNO)
        ))
      | ({
          country: "SE";
        } & BlancoPatchPayloadSE);
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          product: "blanco";
        } & (
          | ({
              country: "SE";
            } & RawBlancoApplicationSE)
          | ({
              country: "NO";
            } & RawBlancoApplicationNO)
        ))
      | ({
          product: "credit_card";
        } & RawCreditCardApplicationNO)
      | ({
          product: "mortgage";
        } & (
          | ({
              country: "SE";
            } & RawMortgageApplicationSE)
          | ({
              country: "NO";
            } & RawMortgageApplicationNO)
        ));
  }

  /**
   * @description Queue copying `label`'s credits onto `targets` (ZRM-owned apps in the same customer's history). Slow, so it runs in a job; a refused sync is only logged, the case view gets an SSE ping per patched target.
   * @tags Application V2
   * @name SyncCreditsApplicationV2SyncCreditsLabelPost
   * @summary Sync Credits
   * @request POST:/application/v2/sync-credits/{label}
   * @secure
   */
  export namespace SyncCreditsApplicationV2SyncCreditsLabelPost {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = string[];
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application V2
   * @name DeactivateApplicationApplicationV2DeactivateLabelGet
   * @summary Deactivate Application
   * @request GET:/application/v2/deactivate/{label}
   * @secure
   */
  export namespace DeactivateApplicationApplicationV2DeactivateLabelGet {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application V2
   * @name ReactivateApplicationApplicationV2ReactivateLabelGet
   * @summary Reactivate Application
   * @request GET:/application/v2/reactivate/{label}
   * @secure
   */
  export namespace ReactivateApplicationApplicationV2ReactivateLabelGet {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application V2
   * @name DeactivateMultipleApplicationsApplicationV2DeactivateWithOptionsPost
   * @summary Deactivate Multiple Applications
   * @request POST:/application/v2/deactivate-with-options
   * @secure
   */
  export namespace DeactivateMultipleApplicationsApplicationV2DeactivateWithOptionsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = string[];
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application V2
   * @name MortgageCoiDecisionApplicationV2MortgageCoiApplicationIdPost
   * @summary Mortgage Coi Decision
   * @request POST:/application/v2/mortgage-coi/{application_id}
   * @secure
   */
  export namespace MortgageCoiDecisionApplicationV2MortgageCoiApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {
      /**
       * Create
       * True to create mortgage application, False to remove tag from tags
       */
      create: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MortgageCoiDecisionResponse;
  }

  /**
   * No description
   * @tags Application V2
   * @name GetMortgageCoiApplicationsApplicationV2MortgageCoiGet
   * @summary Get Mortgage Coi Applications
   * @request GET:/application/v2/mortgage-coi
   * @secure
   */
  export namespace GetMortgageCoiApplicationsApplicationV2MortgageCoiGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      PageUnionAnnotatedUnionRawBlancoApplicationSERawBlancoApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountryRawCreditCardApplicationNOAnnotatedUnionRawMortgageApplicationSERawMortgageApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountry;
  }

  /**
   * @description The queue rows the current user is the mortgage reviewer of.
   * @tags Application V2
   * @name GetMyMortgageCoiApplicationsApplicationV2MortgageCoiMineGet
   * @summary Get My Mortgage Coi Applications
   * @request GET:/application/v2/mortgage-coi/mine
   * @secure
   */
  export namespace GetMyMortgageCoiApplicationsApplicationV2MortgageCoiMineGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      PageUnionAnnotatedUnionRawBlancoApplicationSERawBlancoApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountryRawCreditCardApplicationNOAnnotatedUnionRawMortgageApplicationSERawMortgageApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountry;
  }

  /**
   * No description
   * @tags Application V2
   * @name SetManualApplicationStateApplicationV2ApplicationMapperApplicationIdManualStatePost
   * @summary Set Manual Application State
   * @request POST:/application/v2/application-mapper/{application_id}/manual-state
   * @secure
   */
  export namespace SetManualApplicationStateApplicationV2ApplicationMapperApplicationIdManualStatePost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ManualStatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application V2
   * @name ToggleFreeForAllApplicationV2ApplicationMapperApplicationIdFreeForAllPost
   * @summary Toggle Free For All
   * @request POST:/application/v2/application-mapper/{application_id}/free-for-all
   * @secure
   */
  export namespace ToggleFreeForAllApplicationV2ApplicationMapperApplicationIdFreeForAllPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = FreeForAllPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Route a case between self-service and advisor-led after creation. Quick-create seeds the flag; this flips it either way afterwards — e.g. a self-serving customer who turns out to need an advisor, or an advisor-led case handed back to My Pages.
   * @tags Application V2
   * @name SetSelfServiceApplicationV2SelfServicePost
   * @summary Set Self Service
   * @request POST:/application/v2/self-service
   * @secure
   */
  export namespace SetSelfServiceApplicationV2SelfServicePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SelfServicePayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Application V2
   * @name SetHighPrioApplicationV2ApplicationMapperApplicationIdHighPrioPost
   * @summary Set High Prio
   * @request POST:/application/v2/application-mapper/{application_id}/high-prio
   * @secure
   */
  export namespace SetHighPrioApplicationV2ApplicationMapperApplicationIdHighPrioPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = HighPrioPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Application V2
   * @name GetApplicationMapperTagsApplicationV2ApplicationMapperTagsGet
   * @summary Get Application Mapper Tags
   * @request GET:/application/v2/application-mapper-tags
   * @secure
   */
  export namespace GetApplicationMapperTagsApplicationV2ApplicationMapperTagsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationMapperTags[];
  }

  /**
   * No description
   * @tags Application V2
   * @name RequestInviteFromBankApplicationV2RequestInvitePost
   * @summary Request Invite From Bank
   * @request POST:/application/v2/request-invite
   * @secure
   */
  export namespace RequestInviteFromBankApplicationV2RequestInvitePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RequestInvitePayload;
    export type RequestHeaders = {};
    export type ResponseBody = EmptyModel;
  }

  /**
   * No description
   * @tags Application V2
   * @name AcceptOfferApplicationV2AcceptOfferPost
   * @summary Accept Offer
   * @request POST:/application/v2/accept-offer
   * @secure
   */
  export namespace AcceptOfferApplicationV2AcceptOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SharedModelsApplicationAcceptOfferPayload;
    export type RequestHeaders = {};
    export type ResponseBody = EmptyModel;
  }

  /**
   * No description
   * @tags Application V2
   * @name CancelOfferApplicationV2CancelOfferPost
   * @summary Cancel Offer
   * @request POST:/application/v2/cancel-offer
   * @secure
   */
  export namespace CancelOfferApplicationV2CancelOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CancelOfferByOfferIdPayload;
    export type RequestHeaders = {};
    export type ResponseBody = EmptyModel;
  }

  /**
   * @description The Case View's "Withdraw acceptance": apps-mgr takes the acceptance back internally, without telling the bank, and keeps the offer acceptable. Forwarded with the handler's token so the event is written as them; apps-mgr's refusals (not ZRM-only, not accepted, accept still being sent, ...) are passed through.
   * @tags Application V2
   * @name WithdrawAcceptApplicationV2WithdrawAcceptPost
   * @summary Withdraw Accept
   * @request POST:/application/v2/withdraw-accept
   * @secure
   */
  export namespace WithdrawAcceptApplicationV2WithdrawAcceptPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = WithdrawAcceptPayload;
    export type RequestHeaders = {};
    export type ResponseBody = EmptyModel;
  }

  /**
   * @description A handler turns the SKA rules off for this application, with a reason. Write-once: 409 when it already has an override (online-first or manual), 403 without access to the application's country and product, 422 for a blank reason or an application that is not native NO blanco or NO mortgage, 502/503 when apps-mgr refuses ZRM or does not answer. The case view reads the result over SSE: the `ska_impact` ping published here.
   * @tags Application V2
   * @name SetSkaOverrideApplicationV2SkaOverrideLabelPost
   * @summary Set Ska Override
   * @request POST:/application/v2/ska-override/{label}
   * @secure
   */
  export namespace SetSkaOverrideApplicationV2SkaOverrideLabelPost {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SetSkaOverridePayload;
    export type RequestHeaders = {};
    export type ResponseBody = SkaOverride;
  }

  /**
   * @description Whether the user has the `move-to-zrm` or `developer` role, so the case view shows the "Move to ZRM" button only to those who may use it. The move itself checks this again, with the access to each label.
   * @tags Application V2
   * @name MoveToZrmAccessApplicationV2MoveToZrmAccessGet
   * @summary Move To Zrm Access
   * @request GET:/application/v2/move-to-zrm-access
   * @secure
   */
  export namespace MoveToZrmAccessApplicationV2MoveToZrmAccessGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MoveToZrmAccess;
  }

  /**
   * @description Move a legacy Sverker NO application, with the other label of its Sverker row, to ZRM; one-way. `dry_run` previews it: every label of the row, whether it may move and why not, warnings, and the v1 meetings the move converts. The move itself needs the `reason` and the `labels` the preview showed; apps-mgr refuses it with 409 when the row's labels changed since. 200 is a dry run, this move, or a move made earlier (`already_moved`). A move's 200 also carries the moved labels' mappers, whether ZRM's own steps are done (`post_commit_done`), and every meeting of the row with its conversion outcome and, for a skipped one, the reason (`meetings`). 409 means nothing moved, with apps-mgr's typed reason in `detail`. 403 without the `move-to-zrm` or `developer` role, or without access to the country and product of any label that moves; 422 for a label that is not a legacy NO blanco or mortgage application or a move without reason and labels; 502/503 when apps-mgr refuses ZRM or does not answer.
   * @tags Application V2
   * @name MoveToZrmApplicationV2MoveToZrmLabelPost
   * @summary Move To Zrm
   * @request POST:/application/v2/move-to-zrm/{label}
   * @secure
   */
  export namespace MoveToZrmApplicationV2MoveToZrmLabelPost {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = MoveToZrmBody;
    export type RequestHeaders = {};
    export type ResponseBody = MoveToZrmResult;
  }

  /**
   * @description The case view's "Update Blanco Loans" for a ZRM-only ULNO or MONO application: apps-mgr merges the current Gjeldsregisteret loans into the credits (manual refinance edits preserved); on ULNO it also recalculates desired_loan, on MONO the mortgage's amount and term are left alone. Each product has its own apps-mgr route. Forwarded with the handler's token so the PATCHED event is written as them. apps-mgr's status and reason are passed through (409 = inactive / accepted / disbursed, 423 = a sync already holds the lock, 400 = not a ZRM-only application of that route's product, 404 = unknown label); the detail reads `Error in AppsMgr <path>: <reason>`.
   * @tags Application V2
   * @name SyncGrForAppApplicationV2SyncGrLabelPost
   * @summary Sync Gr For App
   * @request POST:/application/v2/sync-gr/{label}
   * @secure
   */
  export namespace SyncGrForAppApplicationV2SyncGrLabelPost {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = GrSyncResponse | MortgageGrSyncResponse;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name GetApplicationApplicationCcNoGetPost
   * @summary Get Application
   * @request POST:/application/cc/no/get
   * @secure
   */
  export namespace GetApplicationApplicationCcNoGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CreditCardApplicationWithNamesInComments;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name CreateApplicationApplicationCcNoCreatePost
   * @summary Create Application
   * @request POST:/application/cc/no/create
   * @secure
   */
  export namespace CreateApplicationApplicationCcNoCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCreditCardApplicationPayloadExt;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationCreatedResponseExt;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name UpdateApplicationApplicationCcNoUpdatePost
   * @summary Update Application
   * @request POST:/application/cc/no/update
   * @secure
   */
  export namespace UpdateApplicationApplicationCcNoUpdatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCreditCardApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = EmptyModel;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name UpdateAndGetApplicationApplicationCcNoUpdateAndGetPost
   * @summary Update And Get Application
   * @request POST:/application/cc/no/update-and-get
   * @secure
   */
  export namespace UpdateAndGetApplicationApplicationCcNoUpdateAndGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCreditCardApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CreditCardApplicationExtended;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name CreateApplicationApplicantApplicationCcNoCreateWithApplicantPost
   * @summary Create Application Applicant
   * @request POST:/application/cc/no/create-with-applicant
   * @secure
   */
  export namespace CreateApplicationApplicantApplicationCcNoCreateWithApplicantPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCreditCardApplicationApplicantPayloadExt;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationCreatedResponseExt;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name GetRecentApplicationsApplicationCcNoGetRecentPost
   * @summary Get Recent Applications
   * @request POST:/application/cc/no/get_recent
   * @secure
   */
  export namespace GetRecentApplicationsApplicationCcNoGetRecentPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = GetRecentPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PageCreditCardApplicationExtended;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name GetApplicationBankEventsApplicationCcNoBankEventsPost
   * @summary Get Application Bank Events
   * @request POST:/application/cc/no/bank-events
   * @secure
   */
  export namespace GetApplicationBankEventsApplicationCcNoBankEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApplicationQuery;
    export type RequestHeaders = {};
    export type ResponseBody = CreditCardBankEventsResponse;
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name SearchApplicationsApplicationCcNoSearchApplicationsPost
   * @summary Search Applications
   * @request POST:/application/cc/no/search_applications
   * @secure
   */
  export namespace SearchApplicationsApplicationCcNoSearchApplicationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationsByApplicantIdentifierPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CreditCardApplicationExtended[];
  }

  /**
   * No description
   * @tags CreditCard Application
   * @name AcceptOfferApplicationCcNoAcceptOfferPost
   * @summary Accept Offer
   * @request POST:/application/cc/no/accept_offer
   * @secure
   */
  export namespace AcceptOfferApplicationCcNoAcceptOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOffer;
    export type RequestHeaders = {};
    export type ResponseBody = CreditorOfferCreditCardOfferDataCreditCardTerms;
  }

  /**
   * @description Same body as /accept_offer, and additionally sends the customer the accepted-offer SMS. A 2xx here can still carry sms_sent=false. The offer is accepted either way, and only the message needs retrying. See the service for why that is not an error.
   * @tags CreditCard Application
   * @name AcceptOfferAndInformApplicationCcNoAcceptOfferAndInformPost
   * @summary Accept Offer And Inform
   * @request POST:/application/cc/no/accept_offer_and_inform
   * @secure
   */
  export namespace AcceptOfferAndInformApplicationCcNoAcceptOfferAndInformPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOffer;
    export type RequestHeaders = {};
    export type ResponseBody = AcceptOfferAndInformResult;
  }

  /**
   * @description The next-best remaining offer for the application, plus whether a genuine late denial (accept-confirmed from the bank events) stands behind it. Read-only. Feeds the Todomaker accept-and-inform button: the client must require both a non-null offer AND late_denial_confirmed before offering the action, because the SMS behind it claims a denial of an accepted offer.
   * @tags CreditCard Application
   * @name NextOfferApplicationCcNoNextOfferPost
   * @summary Next Offer
   * @request POST:/application/cc/no/next_offer
   * @secure
   */
  export namespace NextOfferApplicationCcNoNextOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = NextOfferResult;
  }

  /**
   * No description
   * @tags Mortgage SE Application
   * @name GetApplicationBankEventsApplicationMoSeBankEventsPost
   * @summary Get Application Bank Events
   * @request POST:/application/mo/se/bank-events
   * @secure
   */
  export namespace GetApplicationBankEventsApplicationMoSeBankEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApplicationQuery;
    export type RequestHeaders = {};
    export type ResponseBody = MortgageBankEventsResponse;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name InviteApplicationApplicationInvitePost
   * @summary Invite Application
   * @request POST:/application/invite
   * @secure
   */
  export namespace InviteApplicationApplicationInvitePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = InvitePayloadBase;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name InviteApplicationIdApplicationInviteApplicationIdPost
   * @summary Invite Application Id
   * @request POST:/application/invite/{application_id}
   * @secure
   */
  export namespace InviteApplicationIdApplicationInviteApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = InvitePayloadBase;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name GetAppEventsApplicationGetAppEventsApplicationIdGet
   * @summary Get App Events
   * @request GET:/application/get_app_events/{application_id}
   * @secure
   */
  export namespace GetAppEventsApplicationGetAppEventsApplicationIdGet {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name GetAppEventsOldApplicationGetAppEventsPost
   * @summary Get App Events Old
   * @request POST:/application/get_app_events
   * @secure
   */
  export namespace GetAppEventsOldApplicationGetAppEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name SendCommentToIntegrationApplicationCommentToBankPost
   * @summary Send Comment To Integration
   * @request POST:/application/comment_to_bank
   * @secure
   */
  export namespace SendCommentToIntegrationApplicationCommentToBankPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BaseComment;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name SendCommentV2ApplicationV2CommentPost
   * @summary Send Comment V2
   * @request POST:/application/v2/comment
   * @secure
   */
  export namespace SendCommentV2ApplicationV2CommentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SharedModelsApi2V4ApplicationCommentPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Response;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name AcceptOfferApplicationAcceptOfferPost
   * @summary Accept Offer
   * @request POST:/application/accept_offer
   * @secure
   */
  export namespace AcceptOfferApplicationAcceptOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOffer;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name CancelApplicationCancelPost
   * @summary Cancel
   * @request POST:/application/cancel
   * @secure
   */
  export namespace CancelApplicationCancelPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CancelOfferPayload;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }

  /**
   * No description
   * @tags Bank Communication
   * @name SendDocumentToIntegrationApplicationDocumentToBankPost
   * @summary Send Document To Integration
   * @request POST:/application/document_to_bank
   * @secure
   */
  export namespace SendDocumentToIntegrationApplicationDocumentToBankPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentToBank;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }

  /**
   * No description
   * @tags Application Meta
   * @name AssignApplicationToHandlerApplicationAssignApplicationIdPost
   * @summary Assign Application To Handler
   * @request POST:/application/assign/{application_id}
   * @secure
   */
  export namespace AssignApplicationToHandlerApplicationAssignApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = AssignApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Application Meta
   * @name ListInternalCommentsApplicationCommentApplicationIdGet
   * @summary List Internal Comments
   * @request GET:/application/comment/{application_id}
   * @secure
   */
  export namespace ListInternalCommentsApplicationCommentApplicationIdGet {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | BankIDSignedWithNames
      | InternalCommentWithName
    )[];
  }

  /**
   * No description
   * @tags Application Meta
   * @name AddInternalCommentApplicationCommentApplicationIdPost
   * @summary Add Internal Comment
   * @request POST:/application/comment/{application_id}
   * @secure
   */
  export namespace AddInternalCommentApplicationCommentApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {
      /** Customer Id */
      customer_id?: string | null;
    };
    export type RequestBody = CommentPayload;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | BankIDSignedWithNames
      | InternalCommentWithName
    )[];
  }

  /**
   * No description
   * @tags Application Meta
   * @name GetPagedCommentsApplicationCommentPagedCustomerIdPost
   * @summary Get Paged Comments
   * @request POST:/application/comment/paged/{customer_id}
   * @secure
   */
  export namespace GetPagedCommentsApplicationCommentPagedCustomerIdPost {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {
      /** Page */
      page?: number | null;
      /**
       * Limit
       * @default 20
       */
      limit?: number;
      /** Newer Than */
      newer_than?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageInternalCommentSSE;
  }

  /**
   * No description
   * @tags Application Meta
   * @name GetPossibleStatusesApplicationPrefsGet
   * @summary Get Possible Statuses
   * @request GET:/application/prefs
   * @secure
   */
  export namespace GetPossibleStatusesApplicationPrefsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PrefsResponse;
  }

  /**
   * No description
   * @tags Application Meta
   * @name UpdateAppPrefsApplicationPrefsProductCountryPost
   * @summary Update App Prefs
   * @request POST:/application/prefs/{product}/{country}
   * @secure
   */
  export namespace UpdateAppPrefsApplicationPrefsProductCountryPost {
    export type RequestParams = {
      product: Product;
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = AppPrefsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PrefsResponse;
  }

  /**
   * No description
   * @tags Application Meta
   * @name GetPossibleLoanTypesApplicationLoanTypesCountryGet
   * @summary Get Possible Loan Types
   * @request GET:/application/loan-types/{country}
   * @secure
   */
  export namespace GetPossibleLoanTypesApplicationLoanTypesCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Application Meta
   * @name SearchBlancoSverkerApplicationBlancoSearchCountryGet
   * @summary Search Blanco Sverker
   * @request GET:/application/blanco/search/{country}
   * @secure
   */
  export namespace SearchBlancoSverkerApplicationBlancoSearchCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {
      /** S */
      s: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SverkerSearchResponse;
  }

  /**
   * No description
   * @tags AML
   * @name AmlReviewApplicationAmlReviewPost
   * @summary Aml Review
   * @request POST:/application/aml/review
   * @secure
   */
  export namespace AmlReviewApplicationAmlReviewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AMLReviewPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ApplicationWithNamesInComments;
  }

  /**
   * No description
   * @tags AML
   * @name GetBlancoAmlApplicationBlancoAmlApplicationIdGet
   * @summary Get Blanco Aml
   * @request GET:/application/blanco/aml/{application_id}
   * @secure
   */
  export namespace GetBlancoAmlApplicationBlancoAmlApplicationIdGet {
    export type RequestParams = {
      /** Application Id */
      applicationId: number;
    };
    export type RequestQuery = {
      country: Country;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AMLBlancoResponse;
  }

  /**
   * No description
   * @tags AML
   * @name PatchBlancoAmlApplicationBlancoAmlApplicationIdPatch
   * @summary Patch Blanco Aml
   * @request PATCH:/application/blanco/aml/{application_id}
   * @secure
   */
  export namespace PatchBlancoAmlApplicationBlancoAmlApplicationIdPatch {
    export type RequestParams = {
      /** Application Id */
      applicationId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = BlancoAMLPatchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AMLBlancoResponse;
  }

  /**
   * No description
   * @tags AML
   * @name ReviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch
   * @summary Review Blanco Aml
   * @request PATCH:/application/blanco/aml/review/{application_id}
   * @secure
   */
  export namespace ReviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch {
    export type RequestParams = {
      /** Application Id */
      applicationId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = BlancoAMLReviewPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags AML
   * @name ReviewOpAmlApplicationOpAmlReviewApplicationIdPatch
   * @summary Review Op Aml
   * @request PATCH:/application/op/aml/review/{application_id}
   * @secure
   */
  export namespace ReviewOpAmlApplicationOpAmlReviewApplicationIdPatch {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = OPAMLReviewPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags AML
   * @name MortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost
   * @summary Mortgage Deactivation Reviews
   * @request POST:/application/deactivation_reviews/mortgage
   * @secure
   */
  export namespace MortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeactivationReviewsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = MortgageDeactivationReviewsResponse;
  }

  /**
   * No description
   * @tags AML
   * @name BlancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost
   * @summary Blanco Deactivation Reviews
   * @request POST:/application/deactivation_reviews/blanco
   * @secure
   */
  export namespace BlancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeactivationReviewsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = DeactivationReviewsResponse;
  }

  /**
   * No description
   * @tags Migrator
   * @name MigrateSverkerTextMessagesApplicationMigratorTextMessagesPost
   * @summary Migrate Sverker Text Messages
   * @request POST:/application/migrator/text-messages
   * @secure
   */
  export namespace MigrateSverkerTextMessagesApplicationMigratorTextMessagesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ZrmTextMessageEvent[];
    export type RequestHeaders = {};
    export type ResponseBody = ZrmMigrationStats;
  }

  /**
   * No description
   * @tags Migrator
   * @name MigrateSverkerApplicationApplicationMigratorAppLabelPost
   * @summary Migrate Sverker Application
   * @request POST:/application/migrator/{app_label}
   * @secure
   */
  export namespace MigrateSverkerApplicationApplicationMigratorAppLabelPost {
    export type RequestParams = {
      /**
       * App Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      appLabel: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ZrmMigratorEvents;
    export type RequestHeaders = {};
    export type ResponseBody = ZrmMigrationStats;
  }
}

export namespace Customer {
  /**
   * No description
   * @tags Customer
   * @name GetCustomerCustomerGetPost
   * @summary Get Customer
   * @request POST:/customer/get
   * @secure
   */
  export namespace GetCustomerCustomerGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      | PniGetCustomerPayload
      | EmailGetCustomerPayload
      | PhoneGetCustomerPayload
      | CustomerIDGetCustomerPayload
      | CustomerIDsGetCustomerPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          country: "SE";
        } & ApplicantSE)
      | ({
          country: "NO";
        } & ApplicantNO);
  }

  /**
   * No description
   * @tags Customer
   * @name GetCustomersCustomerGetsPost
   * @summary Get Customers
   * @request POST:/customer/gets
   * @secure
   */
  export namespace GetCustomersCustomerGetsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CustomerIDsGetCustomerPayload;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | ({
          country: "SE";
        } & ApplicantSE)
      | ({
          country: "NO";
        } & ApplicantNO)
    )[];
  }

  /**
   * No description
   * @tags Customer
   * @name CreateCustomerCustomerCreatePost
   * @summary Create Customer
   * @request POST:/customer/create
   * @secure
   */
  export namespace CreateCustomerCustomerCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCustomerPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          country: "SE";
        } & ApplicantSE)
      | ({
          country: "NO";
        } & ApplicantNO);
  }

  /**
   * No description
   * @tags Customer
   * @name UpdateCustomerCustomerUpdatePost
   * @summary Update Customer
   * @request POST:/customer/update
   * @secure
   */
  export namespace UpdateCustomerCustomerUpdatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCustomerPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          country: "SE";
        } & ApplicantSE)
      | ({
          country: "NO";
        } & ApplicantNO);
  }

  /**
   * No description
   * @tags Customer
   * @name UpdateConsentsCustomerUpdateConsentsPost
   * @summary Update Consents
   * @request POST:/customer/update_consents
   * @secure
   */
  export namespace UpdateConsentsCustomerUpdateConsentsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateCustomerConsentsPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          country: "SE";
        } & ApplicantSE)
      | ({
          country: "NO";
        } & ApplicantNO);
  }

  /**
   * No description
   * @tags Customer
   * @name IdCheckOrGetCustomerCustomerIdCheckPost
   * @summary Id Check Or Get Customer
   * @request POST:/customer/id-check
   * @secure
   */
  export namespace IdCheckOrGetCustomerCustomerIdCheckPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = IDCheckGetCustomerPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (
          | ({
              country: "SE";
            } & ApplicantSE)
          | ({
              country: "NO";
            } & ApplicantNO)
        )
      | IDCheckedPerson
      | null;
  }

  /**
   * No description
   * @tags Customer
   * @name TakeCreditCheckCustomerCreditCheckPost
   * @summary Take Credit Check
   * @request POST:/customer/credit-check
   * @secure
   */
  export namespace TakeCreditCheckCustomerCreditCheckPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TakeCreditCheck;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          country: "SE";
        } & ApplicantSE)
      | ({
          country: "NO";
        } & ApplicantNO);
  }

  /**
   * No description
   * @tags Customer
   * @name GetNameByPniCustomerNameByPniPost
   * @summary Get Name By Pni
   * @request POST:/customer/name/by-pni
   * @secure
   */
  export namespace GetNameByPniCustomerNameByPniPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetNameByPNIPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Name | null;
  }

  /**
   * No description
   * @tags Customer
   * @name GetNameCustomerNameCustomerIdGet
   * @summary Get Name
   * @request GET:/customer/name/{customer_id}
   * @secure
   */
  export namespace GetNameCustomerNameCustomerIdGet {
    export type RequestParams = {
      /** Customer Id */
      customerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Name | null;
  }

  /**
   * No description
   * @tags Customer, Application Meta
   * @name EmploymentTypesCustomerEmploymentTypesCountryGet
   * @summary Employment Types
   * @request GET:/customer/employment-types/{country}
   * @secure
   */
  export namespace EmploymentTypesCustomerEmploymentTypesCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Customer, Application Meta
   * @name HousingTypesCustomerHousingTypesCountryGet
   * @summary Housing Types
   * @request GET:/customer/housing-types/{country}
   * @secure
   */
  export namespace HousingTypesCustomerHousingTypesCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Customer
   * @name GetExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost
   * @summary Get Externally Verified Credits
   * @request POST:/customer/externally-verified-credits
   * @secure
   */
  export namespace GetExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MinimalApplicant[];
    export type RequestHeaders = {};
    export type ResponseBody = LoanAndExternallyVerifiedCredit;
  }

  /**
   * No description
   * @tags Customer
   * @name DebtRegisterRenewCustomerDebtRegisterRenewPost
   * @summary Debt Register Renew
   * @request POST:/customer/debt-register/renew
   * @secure
   */
  export namespace DebtRegisterRenewCustomerDebtRegisterRenewPost {
    export type RequestParams = {};
    export type RequestQuery = {
      country: Country;
    };
    export type RequestBody = MinimalApplicant[];
    export type RequestHeaders = {};
    export type ResponseBody = LoanAndExternallyVerifiedCredit;
  }
}

export namespace Api {
  /**
   * @description Generate a concise summary of applications for a customer. The summary language follows the agent's UI language setting (`user_settings.ui_language`), falling back to the `language` query parameter when no setting is stored. Args: customer_id: The unique identifier of the customer. language: Fallback language for the generated summary (default: Swedish). Returns: A response object containing the generated summary.
   * @tags Application Summarizer
   * @name GetApplicationSummaryApiApplicationSummarizerSummaryCustomerIdGet
   * @summary Get Application Summary
   * @request GET:/api/application-summarizer/summary/{customer_id}
   * @secure
   */
  export namespace GetApplicationSummaryApiApplicationSummarizerSummaryCustomerIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {
      /**
       * Fallback language if the agent has no UI language set
       * @default "sv"
       */
      language?: Language;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SummaryResponse;
  }

  /**
   * @description Upload a file to storage. Send as `multipart/form-data` with a `key` field and a `file` field. Content-type is read from the uploaded file.
   * @tags File Storage
   * @name UploadFileApiFileStorageUploadPost
   * @summary Upload File
   * @request POST:/api/file-storage/upload
   */
  export namespace UploadFileApiFileStorageUploadPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyUploadFileApiFileStorageUploadPost;
    export type RequestHeaders = {};
    export type ResponseBody = UploadResponse;
  }

  /**
   * @description Download a file from storage. Returns the raw file bytes with the original content-type header.
   * @tags File Storage
   * @name DownloadFileApiFileStorageDownloadKeyGet
   * @summary Download File
   * @request GET:/api/file-storage/download/{key}
   */
  export namespace DownloadFileApiFileStorageDownloadKeyGet {
    export type RequestParams = {
      /** Key */
      key: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Generate a pre-signed download URL. The URL is valid for `expires_in` seconds (default 1 hour, max 7 days).
   * @tags File Storage
   * @name PresignedDownloadUrlApiFileStoragePresignedDownloadKeyGet
   * @summary Presigned Download Url
   * @request GET:/api/file-storage/presigned/download/{key}
   */
  export namespace PresignedDownloadUrlApiFileStoragePresignedDownloadKeyGet {
    export type RequestParams = {
      /** Key */
      key: string;
    };
    export type RequestQuery = {
      /**
       * Expires In
       * @min 10
       * @max 604800
       * @default 3600
       */
      expires_in?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PresignedUrlResponse;
  }

  /**
   * @description Delete a file from storage.
   * @tags File Storage
   * @name DeleteFileApiFileStorageKeyDelete
   * @summary Delete File
   * @request DELETE:/api/file-storage/{key}
   */
  export namespace DeleteFileApiFileStorageKeyDelete {
    export type RequestParams = {
      /** Key */
      key: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace CustomerEvents {
  /**
   * No description
   * @tags Customer Event Log
   * @name GetCustomerTimelineCustomerEventsCustomerIdGet
   * @summary Get Customer Timeline
   * @request GET:/customer-events/{customer_id}
   * @secure
   */
  export namespace GetCustomerTimelineCustomerEventsCustomerIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {
      /** Since */
      since?: string | null;
      /** Until */
      until?: string | null;
      /**
       * Limit
       * @min 1
       * @max 500
       * @default 100
       */
      limit?: number;
      /** Cursor */
      cursor?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TimelineResponse;
  }

  /**
   * @description Lazy CloudWatch logs lane for one request tree (Phase 7). Developer-gated; the audited KDLT read writes a DISTINCT access_events row (reason names the root_request_id) and 404s an unknown customer. Bounded to `around ± WINDOW_MINUTES`, PII-redacted, post-filtered to the request root. (Anti-fishing membership — requiring `root_request_id` to appear on an in-scope event — is deferred: v1 is developer-only with full access, and every access is audited. Add it with the agent zoordinates policy.)
   * @tags Customer Event Log
   * @name GetCustomerTimelineLogsCustomerEventsCustomerIdLogsGet
   * @summary Get Customer Timeline Logs
   * @request GET:/customer-events/{customer_id}/logs
   * @secure
   */
  export namespace GetCustomerTimelineLogsCustomerEventsCustomerIdLogsGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {
      /**
       * Around
       * @format date-time
       */
      around: string;
      /**
       * Root Request Id
       * @minLength 1
       * @maxLength 200
       */
      root_request_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LogsResponse;
  }
}

export namespace Search {
  /**
   * No description
   * @tags Search
   * @name SearchSearchPost
   * @summary Search
   * @request POST:/search
   * @secure
   */
  export namespace SearchSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GlobalSearchRequest;
    export type RequestHeaders = {};
    export type ResponseBody = GlobalSearchPage;
  }
}

export namespace AgentAi {
  /**
   * @description Which agent AI features the caller may use. The frontend shows an entry point only when it is true.
   * @tags Agent AI
   * @name GetStatusAgentAiStatusGet
   * @summary Get Status
   * @request GET:/agent-ai/status
   * @secure
   */
  export namespace GetStatusAgentAiStatusGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AgentAiStatus;
  }

  /**
   * @description The agent's SMS in the customer's language, with a back-translation, a reply to the agent's chat message, warnings and SMS parts. Nothing is sent; `translation_id` goes on the send payload.
   * @tags Agent AI
   * @name TranslateAgentAiTranslatePost
   * @summary Translate
   * @request POST:/agent-ai/translate
   * @secure
   */
  export namespace TranslateAgentAiTranslatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TranslateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = TranslateResponse;
  }

  /**
   * @description An incoming SMS of the customer in the agent's language. A machine translation: the UI says so.
   * @tags Agent AI
   * @name TranslateIncomingAgentAiTranslateIncomingPost
   * @summary Translate Incoming
   * @request POST:/agent-ai/translate-incoming
   * @secure
   */
  export namespace TranslateIncomingAgentAiTranslateIncomingPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TranslateIncomingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = TranslateIncomingResponse;
  }

  /**
   * @description The target language to suggest for this customer; the agent always confirms it.
   * @tags Agent AI
   * @name GetDefaultLanguageAgentAiTranslateLanguageCustomerIdGet
   * @summary Get Default Language
   * @request GET:/agent-ai/translate/language/{customer_id}
   * @secure
   */
  export namespace GetDefaultLanguageAgentAiTranslateLanguageCustomerIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DefaultLanguageResponse;
  }

  /**
   * @description A short SMS that explains Lekbanken's figures to the customer, in the case country's language, with the check warnings and SMS parts. Nothing is sent; `draft_id` goes on the send payload as `translation_id`.
   * @tags Agent AI
   * @name DraftPlayBankSmsAgentAiSmsDraftPlayBankPost
   * @summary Draft Play Bank Sms
   * @request POST:/agent-ai/sms-draft/play-bank
   * @secure
   */
  export namespace DraftPlayBankSmsAgentAiSmsDraftPlayBankPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PlayBankSmsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = PlayBankSmsResponse;
  }

  /**
   * @description Ask the AI about the case the agent has open. Plain HTTP errors before the stream: the case is one the Case View opens (422), the agent has access to its product and country (403), no personal number in the question or the earlier turns (422), the AI is set up (503), the application exists (404) and the customer is on it (403). Then the answer streams (`CaseChatEvent`), with pings for the load balancer and Safari.
   * @tags Agent AI
   * @name CaseChatMessageAgentAiCaseCustomerIdApplicationIdMessagePost
   * @summary Case Chat Message
   * @request POST:/agent-ai/case/{customer_id}/{application_id}/message
   * @secure
   */
  export namespace CaseChatMessageAgentAiCaseCustomerIdApplicationIdMessagePost {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CaseChatRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          type: "progress";
        } & CaseChatProgressEvent)
      | ({
          type: "answer";
        } & CaseChatAnswerEvent)
      | ({
          type: "error";
        } & CaseChatErrorEvent);
  }

  /**
   * @description Thumbs up or down on one of the agent's own case chat answers; another agent's row is 404.
   * @tags Agent AI
   * @name SaveCaseChatFeedbackAgentAiTurnsTurnIdFeedbackPost
   * @summary Save Case Chat Feedback
   * @request POST:/agent-ai/turns/{turn_id}/feedback
   * @secure
   */
  export namespace SaveCaseChatFeedbackAgentAiTurnsTurnIdFeedbackPost {
    export type RequestParams = {
      /**
       * Turn Id
       * @format uuid
       */
      turnId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CaseChatFeedbackRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Meeting {
  /**
   * No description
   * @tags Meeting
   * @name GetMeetingMeetingGetMeetingIdGet
   * @summary Get Meeting
   * @request GET:/meeting/get/{meeting_id}
   * @secure
   */
  export namespace GetMeetingMeetingGetMeetingIdGet {
    export type RequestParams = {
      /** Meeting Id */
      meetingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsMeetingModelsMeeting;
  }

  /**
   * No description
   * @tags Meeting
   * @name GetMeetingsMeetingGetPost
   * @summary Get Meetings
   * @request POST:/meeting/get
   * @secure
   */
  export namespace GetMeetingsMeetingGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMeetings;
    export type RequestHeaders = {};
    export type ResponseBody =
      | MeetingWithApp[]
      | MeetingWithHandlerName[]
      | ModelsMeetingModelsMeeting[];
  }

  /**
   * No description
   * @tags Meeting
   * @name GetMyMeetingsMeetingMinePost
   * @summary Get My Meetings
   * @request POST:/meeting/mine
   * @secure
   */
  export namespace GetMyMeetingsMeetingMinePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMyMeetings;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | MeetingWithApp
      | MeetingWithHandlerName
      | ModelsMeetingModelsMeeting
    )[];
  }

  /**
   * No description
   * @tags Meeting
   * @name CreateMeetingMeetingCreatePost
   * @summary Create Meeting
   * @request POST:/meeting/create
   * @secure
   */
  export namespace CreateMeetingMeetingCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateMeetingPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsMeetingModelsMeeting;
  }

  /**
   * No description
   * @tags Meeting
   * @name UpdateMeetingMeetingUpdateMeetingIdPost
   * @summary Update Meeting
   * @request POST:/meeting/update/{meeting_id}
   * @secure
   */
  export namespace UpdateMeetingMeetingUpdateMeetingIdPost {
    export type RequestParams = {
      /** Meeting Id */
      meetingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateMeetingPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsMeetingModelsMeeting;
  }

  /**
   * No description
   * @tags Meeting
   * @name CancelMeetingsMeetingCancelMeetingIdDelete
   * @summary Cancel Meetings
   * @request DELETE:/meeting/cancel/{meeting_id}
   * @secure
   */
  export namespace CancelMeetingsMeetingCancelMeetingIdDelete {
    export type RequestParams = {
      /** Meeting Id */
      meetingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Meeting
   * @name GetBookableTimesMeetingAvailableDayGet
   * @summary Get Bookable Times
   * @request GET:/meeting/available/{day}
   * @secure
   */
  export namespace GetBookableTimesMeetingAvailableDayGet {
    export type RequestParams = {
      /**
       * Day
       * @format date
       */
      day: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /** X-Zoordinates */
      "x-zoordinates": string;
    };
    export type ResponseBody = BookableSlot[];
  }

  /**
   * No description
   * @tags Meeting
   * @name GetBookableTimesV2MeetingV2AvailableDayGet
   * @summary Get Bookable Times V2
   * @request GET:/meeting/v2/available/{day}
   * @secure
   */
  export namespace GetBookableTimesV2MeetingV2AvailableDayGet {
    export type RequestParams = {
      /**
       * Day
       * @format date
       */
      day: string;
    };
    export type RequestQuery = {
      country: Country;
      product: Product;
      /**
       * Include Fully Booked
       * @default false
       */
      include_fully_booked?: boolean;
      /** Handler Id */
      handler_id?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookableSlotV2[];
  }

  /**
   * No description
   * @tags Meeting
   * @name GetClosedWeekdaysV2MeetingV2ClosedWeekdaysGet
   * @summary Get Closed Weekdays V2
   * @request GET:/meeting/v2/closed-weekdays
   * @secure
   */
  export namespace GetClosedWeekdaysV2MeetingV2ClosedWeekdaysGet {
    export type RequestParams = {};
    export type RequestQuery = {
      country: Country;
      product: Product;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = number[];
  }

  /**
   * @description NO blanco meetings booked on an Oslo day (default today), native applications only.
   * @tags Meeting
   * @name GetBookedMeetingsMeetingV2AdminBookedGet
   * @summary Get Booked Meetings
   * @request GET:/meeting/v2/admin/booked
   * @secure
   */
  export namespace GetBookedMeetingsMeetingV2AdminBookedGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Day */
      day?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookedMeetings;
  }

  /**
   * No description
   * @tags Meeting
   * @name CreateV2MeetingV2CreatePost
   * @summary Create V2
   * @request POST:/meeting/v2/create
   * @secure
   */
  export namespace CreateV2MeetingV2CreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateMeetingPayloadV2;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2;
  }

  /**
   * No description
   * @tags Meeting
   * @name UpdateMeetingWithAssignMeetingV2UpdateMeetingIdPost
   * @summary Update Meeting With Assign
   * @request POST:/meeting/v2/update/{meeting_id}
   * @secure
   */
  export namespace UpdateMeetingWithAssignMeetingV2UpdateMeetingIdPost {
    export type RequestParams = {
      /** Meeting Id */
      meetingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateAndAssignPayloadV2;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2;
  }

  /**
   * No description
   * @tags Meeting
   * @name MeetingSuccessfulMeetingV2SuccessPost
   * @summary Meeting Successful
   * @request POST:/meeting/v2/success
   * @secure
   */
  export namespace MeetingSuccessfulMeetingV2SuccessPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Meeting Id */
      meeting_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2;
  }

  /**
   * No description
   * @tags Meeting
   * @name CancelMeetingV2EndpointMeetingV2CancelMeetingIdPost
   * @summary Cancel Meeting V2 Endpoint
   * @request POST:/meeting/v2/cancel/{meeting_id}
   * @secure
   */
  export namespace CancelMeetingV2EndpointMeetingV2CancelMeetingIdPost {
    export type RequestParams = {
      /** Meeting Id */
      meetingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2;
  }

  /**
   * No description
   * @tags Meeting
   * @name SetMeetingCallbackMeetingV2CallbackMeetingIdPost
   * @summary Set Meeting Callback
   * @request POST:/meeting/v2/callback/{meeting_id}
   * @secure
   */
  export namespace SetMeetingCallbackMeetingV2CallbackMeetingIdPost {
    export type RequestParams = {
      /** Meeting Id */
      meetingId: string;
    };
    export type RequestQuery = {
      /** Priority */
      priority?: number | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2;
  }
}

export namespace MeetingDistribution {
  /**
   * No description
   * @tags Meeting
   * @name PreviewDistributionMeetingDistributionPreviewGet
   * @summary Preview Distribution
   * @request GET:/meeting_distribution/preview
   * @secure
   */
  export namespace PreviewDistributionMeetingDistributionPreviewGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, Employee>;
  }

  /**
   * @description The whole plan, not only the assignment map. A separate endpoint rather than a wider `/preview` response: the frontend reads `/preview` as `{meeting_id: Employee}` and changing that shape would break it, while new *payload* fields are additive. This one carries the planner's own output — the `snapshot_revision` a save quotes back, the per-handler load before and after, and why each unplaced candidate was unplaced. Write-free, like `/preview`: nothing here persists a score or touches a meeting.
   * @tags Meeting
   * @name PlanDistributionMeetingDistributionPlanGet
   * @summary Plan Distribution
   * @request GET:/meeting_distribution/plan
   * @secure
   */
  export namespace PlanDistributionMeetingDistributionPlanGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PlanResult;
  }

  /**
   * No description
   * @tags Meeting
   * @name GetAvailableMeetingsMethodMeetingDistributionGetAvailableMeetingsGet
   * @summary Get Available Meetings Method
   * @request GET:/meeting_distribution/get-available-meetings
   * @secure
   */
  export namespace GetAvailableMeetingsMethodMeetingDistributionGetAvailableMeetingsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2[];
  }

  /**
   * No description
   * @tags Meeting
   * @name GetAvailableHandlerMeetingDistributionGetAvailableHandlersGet
   * @summary Get Available Handler
   * @request GET:/meeting_distribution/get-available-handlers
   * @secure
   */
  export namespace GetAvailableHandlerMeetingDistributionGetAvailableHandlersGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Employee[];
  }

  /**
   * No description
   * @tags Meeting
   * @name ResetDevMeetingsMeetingDistributionResetDevMeetingsGet
   * @summary Reset Dev Meetings
   * @request GET:/meeting_distribution/reset-dev-meetings
   * @secure
   */
  export namespace ResetDevMeetingsMeetingDistributionResetDevMeetingsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2[];
  }

  /**
   * No description
   * @tags Meeting
   * @name AssignHandlerToMeetingMeetingDistributionAssignHandlerToMeetingPost
   * @summary Assign Handler To Meeting
   * @request POST:/meeting_distribution/assign-handler-to-meeting
   * @secure
   */
  export namespace AssignHandlerToMeetingMeetingDistributionAssignHandlerToMeetingPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AssignHandlerToMeetingPayload;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingV2;
  }

  /**
   * @description Confirm a revision-fenced batch of real ZRM meeting assignments.
   * @tags Meeting
   * @name SavePreviewAssignmentsMethodMeetingDistributionSavePreviewAssignmentsPost
   * @summary Save Preview Assignments Method
   * @request POST:/meeting_distribution/save-preview-assignments
   * @secure
   */
  export namespace SavePreviewAssignmentsMethodMeetingDistributionSavePreviewAssignmentsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SavePreviewAssignmentsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, number>;
  }

  /**
   * @description The settings in force: multipliers and their level definitions, count band and D-rule. Answers the seeded version 1 while the collection is empty — nothing is written by a read, so "never configured" and "configured back to the defaults" stay distinguishable in the audit trail.
   * @tags Meeting
   * @name GetDistributionSettingsMeetingDistributionSettingsGet
   * @summary Get Distribution Settings
   * @request GET:/meeting_distribution/settings
   * @secure
   */
  export namespace GetDistributionSettingsMeetingDistributionSettingsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingDistributionSettings;
  }

  /**
   * @description Insert a new settings version, carrying the untouched sub-documents forward. Not under `distribution_lock()`: this writes a new document rather than mutating the one a run is reading, and a run that started before the save keeps planning under the version it read — which is exactly what `multipliers_version` on the owner records has to mean.
   * @tags Meeting
   * @name SaveDistributionSettingsMeetingDistributionSettingsPost
   * @summary Save Distribution Settings
   * @request POST:/meeting_distribution/settings
   * @secure
   */
  export namespace SaveDistributionSettingsMeetingDistributionSettingsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MeetingDistributionSettingsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingDistributionSettings;
  }

  /**
   * @description The audit trail, newest first: every saved version with the team lead who saved it. The collection is append-only precisely so that a decision can be read back under the numbers it was made on; without a way to read the trail, "which fit was in force in week 37" needs a Mongo shell. Empty while nothing has been saved — the seeded version 1 `GET /settings` answers with was never written by anybody.
   * @tags Meeting
   * @name GetDistributionSettingsVersionsMeetingDistributionSettingsVersionsGet
   * @summary Get Distribution Settings Versions
   * @request GET:/meeting_distribution/settings/versions
   * @secure
   */
  export namespace GetDistributionSettingsVersionsMeetingDistributionSettingsVersionsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MeetingDistributionSettings[];
  }

  /**
   * @description The newest run report, whichever job wrote it — **counts only**. ``?mode=`` narrows to one writer, and for the by-hand jobs it is the only way to reach their report at all: the D poll stores one every minute, so a refit's candidate (`?mode=refit`, the refit runbook's read) is behind a minute's worth of sweeps within a minute of the run. The stored document carries the per-meeting halves as well (an outcome per meeting id, an exception repr per failed one, the whole candidate list); this answers with their sizes instead, because the question the endpoint is asked is "what did the last run do" and the ids would put meeting identifiers into every cache between here and the browser. They stay in ``meeting_distribution_runs`` for whoever is debugging one run. ``null`` while nothing has run — turned off, the crons return before reading anything, so "no run yet" is the ordinary state rather than an error. The hourly collector is the run that carries the ``health`` section; a 60-second poll's report has its own counters and no population aggregates, which is deliberate.
   * @tags Meeting
   * @name GetLatestRunReportMeetingDistributionReportLatestGet
   * @summary Get Latest Run Report
   * @request GET:/meeting_distribution/report/latest
   * @secure
   */
  export namespace GetLatestRunReportMeetingDistributionReportLatestGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Mode */
      mode?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RunReportDigest | null;
  }

  /**
   * @description Every application line booked to an Oslo accounting day in ``[date_from, date_to]``, with its current and first owner, and each KH's totals over the same rows. One answer for both, so the applications view and the per-KH view cannot disagree. At most 92 days; a period with more lines than the cap is a 422 rather than a partial total. Read-only.
   * @tags Meeting
   * @name GetDistributionDashboardMeetingDistributionDashboardDistributionGet
   * @summary Get Distribution Dashboard
   * @request GET:/meeting_distribution/dashboard/distribution
   * @secure
   */
  export namespace GetDistributionDashboardMeetingDistributionDashboardDistributionGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Date From
       * @format date
       */
      date_from: string;
      /**
       * Date To
       * @format date
       */
      date_to: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DistributionDashboard;
  }

  /**
   * @description Each KH's active meetings in the Oslo days ``[date_from, date_to]`` (at most 31), with the case owner, scheduled hours and absences. ``handler_ids`` (at most 50) defaults to the KH pool (the Employee scheduling roster). Read-only.
   * @tags Meeting
   * @name GetDistributionCalendarMeetingDistributionDashboardCalendarGet
   * @summary Get Distribution Calendar
   * @request GET:/meeting_distribution/dashboard/calendar
   * @secure
   */
  export namespace GetDistributionCalendarMeetingDistributionDashboardCalendarGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Date From
       * @format date
       */
      date_from: string;
      /**
       * Date To
       * @format date
       */
      date_to: string;
      /** Handler Ids */
      handler_ids?: string[] | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DistributionCalendar;
  }

  /**
   * @description The active owner record for one application — what the Freja button renders from. ``null`` rather than a 404 when nobody owns the case: "not handed out yet" is the state the button exists for, and a 404 would have the client tell the two apart by status code.
   * @tags Meeting
   * @name GetCaseOwnerMeetingDistributionCaseApplicationIdGet
   * @summary Get Case Owner
   * @request GET:/meeting_distribution/case/{application_id}
   * @secure
   */
  export namespace GetCaseOwnerMeetingDistributionCaseApplicationIdGet {
    export type RequestParams = {
      /** Application Id */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseOwner | null;
  }

  /**
   * @description Hand this case out now, by the ranking. The same decision a D trigger takes, taken early: if D has not arrived the value is provisional — the amount, the bid picture so far, the stored credit check — and D completes it once, later, in the same accounting week.
   * @tags Meeting
   * @name AssignOwnerMeetingDistributionAssignOwnerPost
   * @summary Assign Owner
   * @request POST:/meeting_distribution/assign-owner
   * @secure
   */
  export namespace AssignOwnerMeetingDistributionAssignOwnerPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AssignOwnerPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CaseOwner;
  }

  /**
   * @description A KA's own choice of handler — the first one, or a change. Every owner change goes through here rather than through a raw handler write, which is what makes the value lines and the case's future meetings follow the owner. A case that has been taken over is refused with a 409 pointing at `override`.
   * @tags Meeting
   * @name AssignOwnerManualMeetingDistributionAssignOwnerManualPost
   * @summary Assign Owner Manual
   * @request POST:/meeting_distribution/assign-owner/manual
   * @secure
   */
  export namespace AssignOwnerManualMeetingDistributionAssignOwnerManualPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AssignOwnerManualPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CaseOwner;
  }

  /**
   * @description The team lead's override, and the manual mortgage takeover. With a `takeover_reason` the new record leaves the blanco pool: its value lines are copied over unchanged so the money stays readable on the case, and the accumulators skip the record rather than any number being nulled.
   * @tags Meeting
   * @name OverrideOwnerMeetingDistributionOverridePost
   * @summary Override Owner
   * @request POST:/meeting_distribution/override
   * @secure
   */
  export namespace OverrideOwnerMeetingDistributionOverridePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OverrideOwnerPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CaseOwner;
  }

  /**
   * @description One meeting to somebody else, the case unchanged. Answers with the case's *owner* record, not with the meeting: what the caller has to see is that the ownership did not move. The mark is what keeps the reconciliation from taking the meeting back (`services/meeting_distribution/handovers.py`).
   * @tags Meeting
   * @name HandOverMeetingMeetingDistributionHandoverPost
   * @summary Hand Over Meeting
   * @request POST:/meeting_distribution/handover
   * @secure
   */
  export namespace HandOverMeetingMeetingDistributionHandoverPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HandoverPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CaseOwner;
  }
}

export namespace Todomaker {
  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name ListTodoTodomakerListGet
   * @summary List Todo
   * @request GET:/todomaker/list
   * @secure
   */
  export namespace ListTodoTodomakerListGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Pool Page
       * The page of the shared pool to send, 1-based.
       * @min 1
       * @default 1
       */
      pool_page?: number;
      /**
       * Pool Size
       * Pool leads per page.
       * @min 1
       * @max 350
       * @default 200
       */
      pool_size?: number;
      /**
       * Pool Campaign Id
       * Page only this campaign's pool. Ignored unless it is one of the caller's active campaigns.
       */
      pool_campaign_id?: string | null;
      /**
       * Pool Show All
       * Every open lead of the campaigns, whoever owns it, read-only. Team leads and developers only.
       * @default false
       */
      pool_show_all?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TodoList;
  }

  /**
   * @description The handler's eligible campaigns with pool counts + paused state (campaign focus).
   * @tags Todomaker, Todomaker
   * @name CampaignsOverviewTodomakerCampaignsGet
   * @summary Campaigns Overview
   * @request GET:/todomaker/campaigns
   * @secure
   */
  export namespace CampaignsOverviewTodomakerCampaignsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TodomakerCampaignList;
  }

  /**
   * @description The customer's applications and live offers, for one expanded row. Per-row rather than on the list: the shared pool carries customers nobody claimed, and folding this into the snapshot would run one apps-mgr read each, every refresh. `current_application_id` is the application the expanded lead is about. The response is capped, and a customer's book can run into the hundreds, so without it the one application the handler is calling about can fall off the end.
   * @tags Todomaker, Todomaker
   * @name CustomerApplicationsTodomakerCustomerApplicationsCustomerIdGet
   * @summary Customer Applications
   * @request GET:/todomaker/customer-applications/{customer_id}
   * @secure
   */
  export namespace CustomerApplicationsTodomakerCustomerApplicationsCustomerIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {
      /**
       * Current Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      current_application_id?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TodoCustomerApplicationList;
  }

  /**
   * @description What else this customer has open in the process campaigns, for one expanded row. One lead per customer, so a case that loses to the lead's campaign has no row of its own; this is where the handler working the lead sees it. Only for a caller who holds a lead on the customer.
   * @tags Todomaker, Todomaker
   * @name OtherCasesTodomakerOtherCasesCustomerIdGet
   * @summary Other Cases
   * @request GET:/todomaker/other-cases/{customer_id}
   * @secure
   */
  export namespace OtherCasesTodomakerOtherCasesCustomerIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TodoOtherCaseList;
  }

  /**
   * @description Pause/resume one eligible campaign for this handler. Pausing hides its pool leads only — claimed leads, callbacks and meetings are unaffected.
   * @tags Todomaker, Todomaker
   * @name SetCampaignPausedTodomakerCampaignsPausePost
   * @summary Set Campaign Paused
   * @request POST:/todomaker/campaigns/pause
   * @secure
   */
  export namespace SetCampaignPausedTodomakerCampaignsPausePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySetCampaignPausedTodomakerCampaignsPausePost;
    export type RequestHeaders = {};
    export type ResponseBody = TodomakerCampaignList;
  }

  /**
   * @description Check in: the handler is active until `active_until`, and any work in ZRM pushes that forward.
   * @tags Todomaker, Todomaker
   * @name CheckInTodomakerCheckInPost
   * @summary Check In
   * @request POST:/todomaker/check-in
   * @secure
   */
  export namespace CheckInTodomakerCheckInPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TodomakerPresence;
  }

  /**
   * @description Check out, giving back the lead they have open. Booked personal callbacks stay theirs.
   * @tags Todomaker, Todomaker
   * @name CheckOutTodomakerCheckOutPost
   * @summary Check Out
   * @request POST:/todomaker/check-out
   * @secure
   */
  export namespace CheckOutTodomakerCheckOutPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TodomakerPresence;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name ClaimTodomakerClaimPost
   * @summary Claim
   * @request POST:/todomaker/claim
   * @secure
   */
  export namespace ClaimTodomakerClaimPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyClaimTodomakerClaimPost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoItem;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name ReleaseTodomakerReleasePost
   * @summary Release
   * @request POST:/todomaker/release
   * @secure
   */
  export namespace ReleaseTodomakerReleasePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyReleaseTodomakerReleasePost;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Per-lead no_contact/failure/discard substatus options for the outcome menus. Ownership-checked — see `Todomaker.outcome_options`. Without it this read would be the one route here with no check at all.
   * @tags Todomaker, Todomaker
   * @name OutcomeOptionsTodomakerOutcomesPost
   * @summary Outcome Options
   * @request POST:/todomaker/outcomes
   * @secure
   */
  export namespace OutcomeOptionsTodomakerOutcomesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyOutcomeOptionsTodomakerOutcomesPost;
    export type RequestHeaders = {};
    export type ResponseBody = Outcomes;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name OutcomeSuccessTodomakerOutcomeSuccessPost
   * @summary Outcome Success
   * @request POST:/todomaker/outcome/success
   * @secure
   */
  export namespace OutcomeSuccessTodomakerOutcomeSuccessPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyOutcomeSuccessTodomakerOutcomeSuccessPost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoItem;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name OutcomeCallBackTodomakerOutcomeCallBackPost
   * @summary Outcome Call Back
   * @request POST:/todomaker/outcome/call_back
   * @secure
   */
  export namespace OutcomeCallBackTodomakerOutcomeCallBackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyOutcomeCallBackTodomakerOutcomeCallBackPost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoItem;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name OutcomePostponeTodomakerOutcomePostponePost
   * @summary Outcome Postpone
   * @request POST:/todomaker/outcome/postpone
   * @secure
   */
  export namespace OutcomePostponeTodomakerOutcomePostponePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyOutcomePostponeTodomakerOutcomePostponePost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoItem;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name OutcomeNoContactTodomakerOutcomeNoContactPost
   * @summary Outcome No Contact
   * @request POST:/todomaker/outcome/no_contact
   * @secure
   */
  export namespace OutcomeNoContactTodomakerOutcomeNoContactPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyOutcomeNoContactTodomakerOutcomeNoContactPost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoItem;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name OutcomeFailureTodomakerOutcomeFailurePost
   * @summary Outcome Failure
   * @request POST:/todomaker/outcome/failure
   * @secure
   */
  export namespace OutcomeFailureTodomakerOutcomeFailurePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyOutcomeFailureTodomakerOutcomeFailurePost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoItem;
  }

  /**
   * No description
   * @tags Todomaker, Todomaker
   * @name OutcomeDiscardTodomakerOutcomeDiscardPost
   * @summary Outcome Discard
   * @request POST:/todomaker/outcome/discard
   * @secure
   */
  export namespace OutcomeDiscardTodomakerOutcomeDiscardPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyOutcomeDiscardTodomakerOutcomeDiscardPost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoItem;
  }

  /**
   * No description
   * @tags Todomaker Admin, Todomaker Admin
   * @name GetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersGet
   * @summary Get Campaign Sellers
   * @request GET:/todomaker/admin/campaigns/{campaign_id}/sellers
   * @secure
   */
  export namespace GetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CampaignSellers;
  }

  /**
   * No description
   * @tags Todomaker Admin, Todomaker Admin
   * @name SetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersPut
   * @summary Set Campaign Sellers
   * @request PUT:/todomaker/admin/campaigns/{campaign_id}/sellers
   * @secure
   */
  export namespace SetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersPut {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      BodySetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersPut;
    export type RequestHeaders = {};
    export type ResponseBody = CampaignSellers;
  }
}

export namespace NotificationRota {
  /**
   * No description
   * @tags Notification Rota, Notification Rota
   * @name GetNotificationRotasNotificationRotaGet
   * @summary Get Notification Rotas
   * @request GET:/notification-rota
   * @secure
   */
  export namespace GetNotificationRotasNotificationRotaGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NotificationRota[];
  }

  /**
   * No description
   * @tags Notification Rota, Notification Rota
   * @name SetNotificationRotaNotificationRotaProductCountryPut
   * @summary Set Notification Rota
   * @request PUT:/notification-rota/{product}/{country}
   * @secure
   */
  export namespace SetNotificationRotaNotificationRotaProductCountryPut {
    export type RequestParams = {
      product: Product;
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = NotificationRotaPayload;
    export type RequestHeaders = {};
    export type ResponseBody = NotificationRota;
  }
}

export namespace MessagingCenter {
  /**
   * @description Live OPEN items in the caller's countries: free ones first, then the oldest last message first.
   * @tags messaging-center
   * @name ListItemsMessagingCenterGet
   * @summary List Items
   * @request GET:/messaging-center
   * @secure
   */
  export namespace ListItemsMessagingCenterGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MessagingCenterListItem[];
  }

  /**
   * No description
   * @tags messaging-center
   * @name GetItemMessagingCenterItemIdGet
   * @summary Get Item
   * @request GET:/messaging-center/{item_id}
   * @secure
   */
  export namespace GetItemMessagingCenterItemIdGet {
    export type RequestParams = {
      /** Item Id */
      itemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MessagingCenterItemDetail;
  }

  /**
   * @description Claim the item, or extend your own claim. 409 names whoever holds it.
   * @tags messaging-center
   * @name ClaimItemMessagingCenterItemIdClaimPost
   * @summary Claim Item
   * @request POST:/messaging-center/{item_id}/claim
   * @secure
   */
  export namespace ClaimItemMessagingCenterItemIdClaimPost {
    export type RequestParams = {
      /** Item Id */
      itemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MessagingCenterListItem;
  }

  /**
   * No description
   * @tags messaging-center
   * @name ReleaseItemMessagingCenterItemIdReleasePost
   * @summary Release Item
   * @request POST:/messaging-center/{item_id}/release
   * @secure
   */
  export namespace ReleaseItemMessagingCenterItemIdReleasePost {
    export type RequestParams = {
      /** Item Id */
      itemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MessagingCenterListItem;
  }

  /**
   * @description Close the item. 409 with `message_count` when a message came in after the client read it.
   * @tags messaging-center
   * @name DoneItemMessagingCenterItemIdDonePost
   * @summary Done Item
   * @request POST:/messaging-center/{item_id}/done
   * @secure
   */
  export namespace DoneItemMessagingCenterItemIdDonePost {
    export type RequestParams = {
      /** Item Id */
      itemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DoneBody;
    export type RequestHeaders = {};
    export type ResponseBody = MessagingCenterListItem;
  }
}

export namespace Document {
  /**
   * No description
   * @tags Document
   * @name GetDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet
   * @summary Get Document Meta
   * @request GET:/document/get/meta/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
      /**
       * Document Id
       * @format uuid
       */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentMeta;
  }

  /**
   * No description
   * @tags Document
   * @name GetDocumentDocumentGetCustomerIdDocumentIdGet
   * @summary Get Document
   * @request GET:/document/get/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentDocumentGetCustomerIdDocumentIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
      /**
       * Document Id
       * @format uuid
       */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerDocument;
  }

  /**
   * No description
   * @tags Document
   * @name CreateDocumentDocumentSavePost
   * @summary Create Document
   * @request POST:/document/save
   * @secure
   */
  export namespace CreateDocumentDocumentSavePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DocumentCreate;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerDocument;
  }

  /**
   * No description
   * @tags Document
   * @name DocumentTypesDocumentTypesGet
   * @summary Document Types
   * @request GET:/document/types
   * @secure
   */
  export namespace DocumentTypesDocumentTypesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentType[];
  }

  /**
   * No description
   * @tags Document
   * @name GetAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet
   * @summary Get Attached Documents Of Application
   * @request GET:/document/attached/{application_id}
   * @secure
   */
  export namespace GetAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentAssignation[];
  }

  /**
   * No description
   * @tags Document
   * @name AttachDocumentToApplicationDocumentAttachApplicationIdPost
   * @summary Attach Document To Application
   * @request POST:/document/attach/{application_id}
   * @secure
   */
  export namespace AttachDocumentToApplicationDocumentAttachApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DocumentAssignation;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentAssignation[];
  }
}

export namespace Banks {
  /**
   * No description
   * @tags Banks
   * @name GetAllCreditorsBanksAllGet
   * @summary Get All Creditors
   * @request GET:/banks/all
   * @secure
   */
  export namespace GetAllCreditorsBanksAllGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Bank[];
  }

  /**
   * No description
   * @tags Banks
   * @name GetCreditorsBanksGetPost
   * @summary Get Creditors
   * @request POST:/banks/get
   * @secure
   */
  export namespace GetCreditorsBanksGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetBanksPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Bank[];
  }

  /**
   * No description
   * @tags Banks
   * @name GetAllIntegrationsBanksAllIntegrationsGet
   * @summary Get All Integrations
   * @request GET:/banks/all_integrations
   * @secure
   */
  export namespace GetAllIntegrationsBanksAllIntegrationsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Integration[];
  }

  /**
   * No description
   * @tags Banks
   * @name GetIntegrationsBanksGetIntegrationsPost
   * @summary Get Integrations
   * @request POST:/banks/get_integrations
   * @secure
   */
  export namespace GetIntegrationsBanksGetIntegrationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = IntegrationQuery;
    export type RequestHeaders = {};
    export type ResponseBody = Integration[];
  }
}

export namespace Creditors {
  /**
   * No description
   * @tags Creditors
   * @name GetAllCreditorsCreditorsAllGet
   * @summary Get All Creditors
   * @request GET:/creditors/all
   * @secure
   */
  export namespace GetAllCreditorsCreditorsAllGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Bank[];
  }

  /**
   * No description
   * @tags Creditors
   * @name GetCreditorsCreditorsGetPost
   * @summary Get Creditors
   * @request POST:/creditors/get
   * @secure
   */
  export namespace GetCreditorsCreditorsGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetBanksPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Bank[];
  }

  /**
   * No description
   * @tags Creditors
   * @name GetAllIntegrationsCreditorsAllIntegrationsGet
   * @summary Get All Integrations
   * @request GET:/creditors/all_integrations
   * @secure
   */
  export namespace GetAllIntegrationsCreditorsAllIntegrationsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Integration[];
  }

  /**
   * No description
   * @tags Creditors
   * @name GetIntegrationsCreditorsGetIntegrationsPost
   * @summary Get Integrations
   * @request POST:/creditors/get_integrations
   * @secure
   */
  export namespace GetIntegrationsCreditorsGetIntegrationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = IntegrationQuery;
    export type RequestHeaders = {};
    export type ResponseBody = Integration[];
  }
}

export namespace Schedule {
  /**
   * No description
   * @tags Advisor Schedule
   * @name ScheduleDaySchedulePost
   * @summary Schedule Day
   * @request POST:/schedule/
   * @secure
   */
  export namespace ScheduleDaySchedulePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DaySlotDocPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Advisor Schedule
   * @name GetScheduleOfDayScheduleDayGet
   * @summary Get Schedule Of Day
   * @request GET:/schedule/{day}
   * @secure
   */
  export namespace GetScheduleOfDayScheduleDayGet {
    export type RequestParams = {
      /**
       * Day
       * @format date
       */
      day: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /** X-Zoordinates */
      "x-zoordinates": string;
    };
    export type ResponseBody = DaySlotDoc;
  }

  /**
   * No description
   * @tags Advisor Schedule
   * @name GetScheduleOfDayByCountryAndProductScheduleDayProductCountryGet
   * @summary Get Schedule Of Day By Country And Product
   * @request GET:/schedule/{day}/{product}/{country}
   * @secure
   */
  export namespace GetScheduleOfDayByCountryAndProductScheduleDayProductCountryGet {
    export type RequestParams = {
      /**
       * Day
       * @format date
       */
      day: string;
      product: Product;
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DaySlotDoc;
  }
}

export namespace EmployeeSchedule {
  /**
   * No description
   * @tags Employee Schedule
   * @name GetOperatingHoursEmployeeScheduleOperatingHoursGet
   * @summary Get Operating Hours
   * @request GET:/employee-schedule/operating-hours
   * @secure
   */
  export namespace GetOperatingHoursEmployeeScheduleOperatingHoursGet {
    export type RequestParams = {};
    export type RequestQuery = {
      product: Product;
      country: Country;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursDoc;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name AppendOperatingHoursEmployeeScheduleOperatingHoursPost
   * @summary Append Operating Hours
   * @request POST:/employee-schedule/operating-hours
   * @secure
   */
  export namespace AppendOperatingHoursEmployeeScheduleOperatingHoursPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OperatingHoursData;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursDoc;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name GetOperatingHoursHistoryEmployeeScheduleOperatingHoursHistoryGet
   * @summary Get Operating Hours History
   * @request GET:/employee-schedule/operating-hours/history
   * @secure
   */
  export namespace GetOperatingHoursHistoryEmployeeScheduleOperatingHoursHistoryGet {
    export type RequestParams = {};
    export type RequestQuery = {
      product: Product;
      country: Country;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursDoc[];
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name GetEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleGet
   * @summary Get Employee Schedule
   * @request GET:/employee-schedule/employees/{employee_user_id}/schedule
   * @secure
   */
  export namespace GetEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleGet {
    export type RequestParams = {
      /** Employee User Id */
      employeeUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (
          | ({
              mode: "STANDARD";
            } & StandardSchedule)
          | ({
              mode: "CUSTOM";
            } & CustomSchedule)
        )
      | null;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name ReplaceEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdSchedulePut
   * @summary Replace Employee Schedule
   * @request PUT:/employee-schedule/employees/{employee_user_id}/schedule
   * @secure
   */
  export namespace ReplaceEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdSchedulePut {
    export type RequestParams = {
      /** Employee User Id */
      employeeUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = StandardScheduleData | CustomScheduleData;
    export type RequestHeaders = {};
    export type ResponseBody = ScheduleResponse;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name DeleteEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleDelete
   * @summary Delete Employee Schedule
   * @request DELETE:/employee-schedule/employees/{employee_user_id}/schedule
   * @secure
   */
  export namespace DeleteEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleDelete {
    export type RequestParams = {
      /** Employee User Id */
      employeeUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Advisory pre-save check: which proposed slots stay open during a standard operating-hours break.
   * @tags Employee Schedule
   * @name GetStandardBreakConflictsEmployeeScheduleEmployeesEmployeeUserIdScheduleStandardBreakConflictsPost
   * @summary Get Standard Break Conflicts
   * @request POST:/employee-schedule/employees/{employee_user_id}/schedule/standard-break-conflicts
   * @secure
   */
  export namespace GetStandardBreakConflictsEmployeeScheduleEmployeesEmployeeUserIdScheduleStandardBreakConflictsPost {
    export type RequestParams = {
      employeeUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = StandardScheduleData | CustomScheduleData;
    export type RequestHeaders = {};
    export type ResponseBody = StandardBreakConflict[];
  }

  /**
   * @description Advisory pre-save check: which proposed slots fall outside (or have no) operating hours.
   * @tags Employee Schedule
   * @name GetOperatingHoursViolationsEmployeeScheduleEmployeesEmployeeUserIdScheduleOperatingHoursViolationsPost
   * @summary Get Operating Hours Violations
   * @request POST:/employee-schedule/employees/{employee_user_id}/schedule/operating-hours-violations
   * @secure
   */
  export namespace GetOperatingHoursViolationsEmployeeScheduleEmployeesEmployeeUserIdScheduleOperatingHoursViolationsPost {
    export type RequestParams = {
      employeeUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = StandardScheduleData | CustomScheduleData;
    export type RequestHeaders = {};
    export type ResponseBody = OperatingHoursViolation[];
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name ListAbsencesEmployeeScheduleAbsencesGet
   * @summary List Absences
   * @request GET:/employee-schedule/absences
   * @secure
   */
  export namespace ListAbsencesEmployeeScheduleAbsencesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** User Id */
      user_id?: string | null;
      /**
       * Include Deleted
       * @default false
       */
      include_deleted?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AbsenceDoc[];
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name CreateAbsenceEmployeeScheduleAbsencesPost
   * @summary Create Absence
   * @request POST:/employee-schedule/absences
   * @secure
   */
  export namespace CreateAbsenceEmployeeScheduleAbsencesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AbsenceData;
    export type RequestHeaders = {};
    export type ResponseBody = AbsenceDoc;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name UpdateAbsenceEmployeeScheduleAbsencesAbsenceIdPut
   * @summary Update Absence
   * @request PUT:/employee-schedule/absences/{absence_id}
   * @secure
   */
  export namespace UpdateAbsenceEmployeeScheduleAbsencesAbsenceIdPut {
    export type RequestParams = {
      /**
       * Absence Id
       * @format uuid
       */
      absenceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = AbsenceData;
    export type RequestHeaders = {};
    export type ResponseBody = AbsenceDoc;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name DeleteAbsenceEmployeeScheduleAbsencesAbsenceIdDelete
   * @summary Delete Absence
   * @request DELETE:/employee-schedule/absences/{absence_id}
   * @secure
   */
  export namespace DeleteAbsenceEmployeeScheduleAbsencesAbsenceIdDelete {
    export type RequestParams = {
      /**
       * Absence Id
       * @format uuid
       */
      absenceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name ListOverridesEmployeeScheduleOverridesGet
   * @summary List Overrides
   * @request GET:/employee-schedule/overrides
   * @secure
   */
  export namespace ListOverridesEmployeeScheduleOverridesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Date From
       * @format date
       */
      date_from: string;
      /**
       * Date To
       * @format date
       */
      date_to: string;
      /** Product */
      product?: Product | null;
      /** Country */
      country?: Country | null;
      /**
       * Include Deleted
       * @default false
       */
      include_deleted?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DayOverride[];
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name CreateOverrideEmployeeScheduleOverridesPost
   * @summary Create Override
   * @request POST:/employee-schedule/overrides
   * @secure
   */
  export namespace CreateOverrideEmployeeScheduleOverridesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DayOverrideData;
    export type RequestHeaders = {};
    export type ResponseBody = DayOverride;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name GetOverrideEmployeeScheduleOverridesOverrideIdGet
   * @summary Get Override
   * @request GET:/employee-schedule/overrides/{override_id}
   * @secure
   */
  export namespace GetOverrideEmployeeScheduleOverridesOverrideIdGet {
    export type RequestParams = {
      /**
       * Override Id
       * @format uuid
       */
      overrideId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DayOverride;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name UpdateOverrideEmployeeScheduleOverridesOverrideIdPut
   * @summary Update Override
   * @request PUT:/employee-schedule/overrides/{override_id}
   * @secure
   */
  export namespace UpdateOverrideEmployeeScheduleOverridesOverrideIdPut {
    export type RequestParams = {
      /**
       * Override Id
       * @format uuid
       */
      overrideId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DayOverrideData;
    export type RequestHeaders = {};
    export type ResponseBody = DayOverride;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name DeleteOverrideEmployeeScheduleOverridesOverrideIdDelete
   * @summary Delete Override
   * @request DELETE:/employee-schedule/overrides/{override_id}
   * @secure
   */
  export namespace DeleteOverrideEmployeeScheduleOverridesOverrideIdDelete {
    export type RequestParams = {
      /**
       * Override Id
       * @format uuid
       */
      overrideId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name GetWorkingEmployeeScheduleWorkingGet
   * @summary Get Working
   * @request GET:/employee-schedule/working
   * @secure
   */
  export namespace GetWorkingEmployeeScheduleWorkingGet {
    export type RequestParams = {};
    export type RequestQuery = {
      product: Product;
      country: Country;
      /** Date */
      date?: string | null;
      /** At */
      at?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WorkingResponse;
  }

  /**
   * @description Everyone in `departments`/`countries` working on `date` (or at the UTC instant `at`). `products` narrows which service lines' schedules are consulted; omitted means every product.
   * @tags Employee Schedule
   * @name GetWorkingInDepartmentsEmployeeScheduleWorkingInDepartmentsGet
   * @summary Get Working In Departments
   * @request GET:/employee-schedule/working-in-departments
   * @secure
   */
  export namespace GetWorkingInDepartmentsEmployeeScheduleWorkingInDepartmentsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Departments */
      departments: ZDepartment[];
      /** Countries */
      countries: Country[];
      /** Products */
      products?: Product[] | null;
      /** Date */
      date?: string | null;
      /** At */
      at?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = WorkingResponse;
  }

  /**
   * No description
   * @tags Employee Schedule
   * @name GetEmployeeAvailabilityEmployeeScheduleWorkingUserIdGet
   * @summary Get Employee Availability
   * @request GET:/employee-schedule/working/{user_id}
   * @secure
   */
  export namespace GetEmployeeAvailabilityEmployeeScheduleWorkingUserIdGet {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {
      /**
       * Start Time
       * @format date-time
       */
      start_time: string;
      /**
       * End Time
       * @format date-time
       */
      end_time: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailabilityWindow[];
  }
}

export namespace Employee {
  /**
   * No description
   * @tags Employee
   * @name GetAllEmployeesEmployeeAllGet
   * @summary Get All Employees
   * @request GET:/employee/all
   * @secure
   */
  export namespace GetAllEmployeesEmployeeAllGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Page */
      page?: number | null;
      /** Limit */
      limit?: number | null;
      /**
       * Without Deactivated
       * @default false
       */
      without_deactivated?: boolean | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Employee[];
  }

  /**
   * No description
   * @tags Employee
   * @name GetSverkerUsersEmployeeGetSverkerUsersGet
   * @summary Get Sverker Users
   * @request GET:/employee/get_sverker_users
   * @secure
   */
  export namespace GetSverkerUsersEmployeeGetSverkerUsersGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** User Name */
      user_name: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Employee
   * @name GetEmployeesByZoordinatesEmployeeByZoordinatesPost
   * @summary Get Employees By Zoordinates
   * @request POST:/employee/by_zoordinates
   * @secure
   */
  export namespace GetEmployeesByZoordinatesEmployeeByZoordinatesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AllOptionalZoordinates;
    export type RequestHeaders = {};
    export type ResponseBody = Employee[];
  }

  /**
   * No description
   * @tags Employee
   * @name GetMyInfoEmployeeMeGet
   * @summary Get My Info
   * @request GET:/employee/me
   * @secure
   */
  export namespace GetMyInfoEmployeeMeGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Employee;
  }

  /**
   * No description
   * @tags Employee
   * @name DeactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch
   * @summary Deactivate User By Id
   * @request PATCH:/employee/actions/block-or-unblock/{user_id}
   * @secure
   */
  export namespace DeactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {
      /**
       * Block
       * @default true
       */
      block?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Employee
   * @name GetAllZoordinatesEmployeeZoordinatesGet
   * @summary Get All Zoordinates
   * @request GET:/employee/zoordinates
   * @secure
   */
  export namespace GetAllZoordinatesEmployeeZoordinatesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Zoordinates[];
  }

  /**
   * No description
   * @tags Employee
   * @name GetAllRolesEmployeeRolesGet
   * @summary Get All Roles
   * @request GET:/employee/roles
   * @secure
   */
  export namespace GetAllRolesEmployeeRolesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RoleType[];
  }

  /**
   * No description
   * @tags Employee
   * @name GetMySettingsEmployeeMySettingsGet
   * @summary Get My Settings
   * @request GET:/employee/my-settings
   * @secure
   */
  export namespace GetMySettingsEmployeeMySettingsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserSettings;
  }

  /**
   * No description
   * @tags Employee
   * @name SaveMySettingsEmployeeMySettingsPost
   * @summary Save My Settings
   * @request POST:/employee/my-settings
   * @secure
   */
  export namespace SaveMySettingsEmployeeMySettingsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UserSettings;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Employee
   * @name CreateEmployeeEmployeePost
   * @summary Create Employee
   * @request POST:/employee/
   * @secure
   */
  export namespace CreateEmployeeEmployeePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateAndUpdateEmployeeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = Employee;
  }

  /**
   * No description
   * @tags Employee
   * @name UpdateEmployeeEmployeeUserIdPut
   * @summary Update Employee
   * @request PUT:/employee/{user_id}
   * @secure
   */
  export namespace UpdateEmployeeEmployeeUserIdPut {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateAndUpdateEmployeeRequest;
    export type RequestHeaders = {};
    export type ResponseBody = Employee;
  }

  /**
   * No description
   * @tags Employee
   * @name GetByIdEmployeeUserIdGet
   * @summary Get By Id
   * @request GET:/employee/{user_id}
   * @secure
   */
  export namespace GetByIdEmployeeUserIdGet {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Employee;
  }

  /**
   * No description
   * @tags Employee
   * @name SearchEmployeeSearchPost
   * @summary Search
   * @request POST:/employee/search
   * @secure
   */
  export namespace SearchEmployeeSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RoutersEmployeeModelsSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Employee[];
  }
}

export namespace Property {
  /**
   * No description
   * @tags Property
   * @name GetPropertyPropertyGetPropertyIdGet
   * @summary Get Property
   * @request GET:/property/get/{property_id}
   * @secure
   */
  export namespace GetPropertyPropertyGetPropertyIdGet {
    export type RequestParams = {
      /** Property Id */
      propertyId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | House
      | VacationHome
      | SharedModelsPropertyCondominium;
  }

  /**
   * No description
   * @tags Property
   * @name GetPartialPropertyPropertyPartialGetPropertyIdGet
   * @summary Get Partial Property
   * @request GET:/property/partial/get/{property_id}
   * @secure
   */
  export namespace GetPartialPropertyPropertyPartialGetPropertyIdGet {
    export type RequestParams = {
      /** Property Id */
      propertyId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PartialProperty;
  }

  /**
   * No description
   * @tags Property
   * @name CreatePropertyPropertyCreateApplicationIdPost
   * @summary Create Property
   * @request POST:/property/create/{application_id}
   * @secure
   */
  export namespace CreatePropertyPropertyCreateApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      | PartialHouse
      | PartialCondominium
      | PartialVacationHome;
    export type RequestHeaders = {};
    export type ResponseBody =
      | House
      | VacationHome
      | SharedModelsPropertyCondominium;
  }

  /**
   * No description
   * @tags Property
   * @name CreatePartialPropertyPropertyPartialCreateApplicationIdPost
   * @summary Create Partial Property
   * @request POST:/property/partial/create/{application_id}
   * @secure
   */
  export namespace CreatePartialPropertyPropertyPartialCreateApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = NewPartialProperty;
    export type RequestHeaders = {};
    export type ResponseBody = PartialProperty;
  }

  /**
   * No description
   * @tags Property
   * @name UpdatePropertyPropertyUpdatePropertyIdPut
   * @summary Update Property
   * @request PUT:/property/update/{property_id}
   * @secure
   */
  export namespace UpdatePropertyPropertyUpdatePropertyIdPut {
    export type RequestParams = {
      /** Property Id */
      propertyId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      | PartialHouse
      | PartialCondominium
      | PartialVacationHome;
    export type RequestHeaders = {};
    export type ResponseBody =
      | House
      | VacationHome
      | SharedModelsPropertyCondominium;
  }

  /**
   * No description
   * @tags Property
   * @name UpdatePartialPropertyPropertyPartialUpdatePropertyIdPut
   * @summary Update Partial Property
   * @request PUT:/property/partial/update/{property_id}
   * @secure
   */
  export namespace UpdatePartialPropertyPropertyPartialUpdatePropertyIdPut {
    export type RequestParams = {
      /** Property Id */
      propertyId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = NewPartialProperty;
    export type RequestHeaders = {};
    export type ResponseBody = PartialProperty;
  }

  /**
   * No description
   * @tags Property Valuation
   * @name SearchPropertyValuationSearchPropertyIdPost
   * @summary Search
   * @request POST:/property/valuation/search/{property_id}
   * @secure
   */
  export namespace SearchPropertyValuationSearchPropertyIdPost {
    export type RequestParams = {
      /** Property Id */
      propertyId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = RoutersPropertyPayloadSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PropertySearchResult[];
  }

  /**
   * No description
   * @tags Property Creation
   * @name SearchForAddressPropertyV2SearchPropertyTypePost
   * @summary Search For Address
   * @request POST:/property/v2/search/{property_type}
   * @secure
   */
  export namespace SearchForAddressPropertyV2SearchPropertyTypePost {
    export type RequestParams = {
      propertyType: MortgagePropertyType;
    };
    export type RequestQuery = {};
    export type RequestBody = RoutersPropertyPayloadSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PropertySearchResult[];
  }

  /**
   * No description
   * @tags Property Creation
   * @name GetPropertyInfoForCreationPropertyV2InfoSearchIdGet
   * @summary Get Property Info For Creation
   * @request GET:/property/v2/info/{search_id}
   * @secure
   */
  export namespace GetPropertyInfoForCreationPropertyV2InfoSearchIdGet {
    export type RequestParams = {
      /** Search Id */
      searchId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PropertyInfo;
  }

  /**
   * No description
   * @tags Property Creation
   * @name GetPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet
   * @summary Get Property Info By External Id
   * @request GET:/property/v2/info-by-external-id/{external_id}
   * @secure
   */
  export namespace GetPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet {
    export type RequestParams = {
      /** External Id */
      externalId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PropertyInfo;
  }

  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyValuationV2PropertyValuationV2Post
   * @summary Get Property Valuation V2
   * @request POST:/property/valuation/v2
   * @secure
   */
  export namespace GetPropertyValuationV2PropertyValuationV2Post {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ValuationPayloadV2;
    export type RequestHeaders = {};
    export type ResponseBody = PropertyValuation;
  }

  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyInfoPropertyValuationInfoSearchIdGet
   * @summary Get Property Info
   * @request GET:/property/valuation/info/{search_id}
   * @secure
   */
  export namespace GetPropertyInfoPropertyValuationInfoSearchIdGet {
    export type RequestParams = {
      /** Search Id */
      searchId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PropertyInfo;
  }

  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyValuationPropertyValuationValuationPost
   * @summary Get Property Valuation
   * @request POST:/property/valuation/valuation
   * @secure
   */
  export namespace GetPropertyValuationPropertyValuationValuationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ValuationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PropertyValuation;
  }

  /**
   * No description
   * @tags Property Creation
   * @name BooliSearchForAddressPropertyV2BooliSearchPost
   * @summary Booli Search For Address
   * @request POST:/property/v2/booli/search
   * @deprecated
   * @secure
   */
  export namespace BooliSearchForAddressPropertyV2BooliSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BooliSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BooliPropertySearchResult[];
  }

  /**
   * No description
   * @tags Property Valuation
   * @name GetPropertyBooliValuationPropertyValuationBooliPost
   * @summary Get Property Booli Valuation
   * @request POST:/property/valuation/booli
   * @deprecated
   * @secure
   */
  export namespace GetPropertyBooliValuationPropertyValuationBooliPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BooliValuationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PropertyValuation;
  }

  /**
   * No description
   * @name GetPropertyByPniPropertyEvcheckCachePost
   * @summary Get Property By Pni
   * @request POST:/property/evcheck/cache
   * @secure
   */
  export namespace GetPropertyByPniPropertyEvcheckCachePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = EvCheckPayload;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | PartialHouse
      | PartialCondominium
      | PartialVacationHome
    )[];
  }
}

export namespace Message {
  /**
   * No description
   * @tags Message
   * @name RemoveTemplateMessageTemplateDelete
   * @summary Remove Template
   * @request DELETE:/message/template/
   * @secure
   */
  export namespace RemoveTemplateMessageTemplateDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetTemplatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Message
   * @name GetOneTemplateMessageTemplateGetPost
   * @summary Get One Template
   * @request POST:/message/template/get
   * @secure
   */
  export namespace GetOneTemplateMessageTemplateGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetTemplatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = RootModelUnionEmailTemplateSmsTemplate;
  }

  /**
   * No description
   * @tags Message
   * @name CreateTemplateMessageTemplateAddPost
   * @summary Create Template
   * @request POST:/message/template/add
   * @secure
   */
  export namespace CreateTemplateMessageTemplateAddPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RootModelUnionEmailTemplateSmsTemplate;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Message
   * @name TemplateListMessageTemplateListMessageTypeGet
   * @summary Template List
   * @request GET:/message/template/list/{message_type}
   * @secure
   */
  export namespace TemplateListMessageTemplateListMessageTypeGet {
    export type RequestParams = {
      messageType: MessageType;
    };
    export type RequestQuery = {
      /** Cutoff Date */
      cutoff_date?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = (EmailTemplate | SmsTemplate)[];
  }

  /**
   * No description
   * @tags Message
   * @name GetSmsLinkVarsMessageLinkVarsSmsTemplateEventProductCountryGet
   * @summary Get Sms Link Vars
   * @request GET:/message/link-vars/SMS/{template_event}/{product}/{country}
   * @secure
   */
  export namespace GetSmsLinkVarsMessageLinkVarsSmsTemplateEventProductCountryGet {
    export type RequestParams = {
      templateEvent: TemplateEvent;
      /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
      product: ExtendedProduct;
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SMSTrackingLinksResponse;
  }

  /**
   * No description
   * @tags Message
   * @name SendTemplateMessageMessageSendTemplateMessageTypeTemplateEventPost
   * @summary Send Template Message
   * @request POST:/message/send/template/{message_type}/{template_event}
   * @secure
   */
  export namespace SendTemplateMessageMessageSendTemplateMessageTypeTemplateEventPost {
    export type RequestParams = {
      messageType: MessageType;
      templateEvent: TemplateEvent;
    };
    export type RequestQuery = {};
    export type RequestBody = SendTemplatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Message
   * @name SendRawMessageMessageSendRawMessageTypePost
   * @summary Send Raw Message
   * @request POST:/message/send/raw/{message_type}
   * @secure
   */
  export namespace SendRawMessageMessageSendRawMessageTypePost {
    export type RequestParams = {
      messageType: MessageType;
    };
    export type RequestQuery = {};
    export type RequestBody = SendRawPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Message
   * @name GetUnknownSenderSmsMessageSmsUnknownSenderPost
   * @summary Get Unknown Sender Sms
   * @request POST:/message/sms/unknown-sender
   * @secure
   */
  export namespace GetUnknownSenderSmsMessageSmsUnknownSenderPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMessagesPayload;
    export type RequestHeaders = {};
    export type ResponseBody = IncomingSMS[];
  }

  /**
   * No description
   * @tags Message
   * @name GetMessagesForUserMessageUserPost
   * @summary Get Messages For User
   * @request POST:/message/user
   * @secure
   */
  export namespace GetMessagesForUserMessageUserPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetUserMessagesPayload;
    export type RequestHeaders = {};
    export type ResponseBody = SavedMessage[];
  }

  /**
   * No description
   * @tags Message
   * @name GetMessagesForApplicationMessageApplicationPost
   * @summary Get Messages For Application
   * @request POST:/message/application
   * @secure
   */
  export namespace GetMessagesForApplicationMessageApplicationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplicationMessagesPayload;
    export type RequestHeaders = {};
    export type ResponseBody = SavedMessage[];
  }

  /**
   * No description
   * @tags Message
   * @name GetMessagesByCustomerIdMessageByCustomerPost
   * @summary Get Messages By Customer Id
   * @request POST:/message/by-customer
   * @secure
   */
  export namespace GetMessagesByCustomerIdMessageByCustomerPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 1
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = GetMessages;
    export type RequestHeaders = {};
    export type ResponseBody = SavedMessageWithName[];
  }

  /**
   * No description
   * @tags Message
   * @name GetConversationsMessageConversationsGet
   * @summary Get Conversations
   * @request GET:/message/conversations
   * @secure
   */
  export namespace GetConversationsMessageConversationsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Conversation[];
  }

  /**
   * No description
   * @tags Message
   * @name SaveConversationsMessageConversationsPost
   * @summary Save Conversations
   * @request POST:/message/conversations
   * @secure
   */
  export namespace SaveConversationsMessageConversationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Conversation[];
    export type RequestHeaders = {};
    export type ResponseBody = Conversation[];
  }

  /**
   * No description
   * @tags Message
   * @name StreamConversationsMessageConversationsStreamGet
   * @summary Stream Conversations
   * @request GET:/message/conversations/stream
   * @secure
   */
  export namespace StreamConversationsMessageConversationsStreamGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Message
   * @name UploadAttachmentMessageAttachmentsUploadPost
   * @summary Upload Attachment
   * @request POST:/message/attachments/upload
   * @secure
   */
  export namespace UploadAttachmentMessageAttachmentsUploadPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyUploadAttachmentMessageAttachmentsUploadPost;
    export type RequestHeaders = {};
    export type ResponseBody = NonEmptyString;
  }

  /**
   * No description
   * @tags Message
   * @name GetAttachmentsMessageAttachmentsAllGet
   * @summary Get Attachments
   * @request GET:/message/attachments/all
   * @secure
   */
  export namespace GetAttachmentsMessageAttachmentsAllGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SavedAttachment[];
  }

  /**
   * No description
   * @tags Message
   * @name SmsStatsMessageStatsSmsPost
   * @summary Sms Stats
   * @request POST:/message/stats/sms
   * @secure
   */
  export namespace SmsStatsMessageStatsSmsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SmsStatsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = SmsStatsBucket[];
  }

  /**
   * No description
   * @tags Message
   * @name SmsTemplateStatsMessageStatsSmsTemplateTemplateEventProductCountryGet
   * @summary Sms Template Stats
   * @request GET:/message/stats/sms/template/{template_event}/{product}/{country}
   * @secure
   */
  export namespace SmsTemplateStatsMessageStatsSmsTemplateTemplateEventProductCountryGet {
    export type RequestParams = {
      templateEvent: TemplateEvent;
      /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
      product: ExtendedProduct;
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SmsTemplateStats;
  }

  /**
   * No description
   * @tags ELK46 Callbacks
   * @name Elk46SmsWebhookMessageElk46ConfirmationPost
   * @summary Elk46 Sms Webhook
   * @request POST:/message/elk46/confirmation
   */
  export namespace Elk46SmsWebhookMessageElk46ConfirmationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * X-Forwarded-For
       * @format ipvanyaddress
       */
      "x-forwarded-for": string;
    };
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags ELK46 Callbacks
   * @name Elk46CallWebhookMessageElk46CallPost
   * @summary Elk46 Call Webhook
   * @request POST:/message/elk46/call
   */
  export namespace Elk46CallWebhookMessageElk46CallPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyElk46CallWebhookMessageElk46CallPost;
    export type RequestHeaders = {};
    export type ResponseBody = Elk46CallResponse;
  }
}

export namespace Mortgage {
  /**
   * No description
   * @tags Mortgage
   * @name GetKalpSettingsMortgageKalpCountryGet
   * @summary Get Kalp Settings
   * @request GET:/mortgage/kalp/{country}
   * @secure
   */
  export namespace GetKalpSettingsMortgageKalpCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = (BankKALP | BankAPIDrivenKALP)[];
  }
}

export namespace Other {
  /**
   * No description
   * @tags Other
   * @name GetAllTaxesForCountryOtherTaxesCountryGet
   * @summary Get All Taxes For Country
   * @request GET:/other/taxes/{country}
   * @secure
   */
  export namespace GetAllTaxesForCountryOtherTaxesCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Tax[];
  }

  /**
   * No description
   * @tags Other
   * @name TaxesForIdentifierOtherTaxesCalculationPost
   * @summary Taxes For Identifier
   * @request POST:/other/taxes/calculation
   * @secure
   */
  export namespace TaxesForIdentifierOtherTaxesCalculationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetTaxPayload;
    export type RequestHeaders = {};
    export type ResponseBody = GetTaxPayloadResponse;
  }

  /**
   * No description
   * @tags Other
   * @name GetAllMunicipalitiesForCountryOtherMunicipalityCountryGet
   * @summary Get All Municipalities For Country
   * @request GET:/other/municipality/{country}
   * @secure
   */
  export namespace GetAllMunicipalitiesForCountryOtherMunicipalityCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Municipality[];
  }

  /**
   * No description
   * @tags Other
   * @name DeactivationReasonsOtherDeactivationReasonsGet
   * @summary Deactivation Reasons
   * @request GET:/other/deactivation-reasons
   * @secure
   */
  export namespace DeactivationReasonsOtherDeactivationReasonsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      product: Product;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Other, websocket
   * @name GetTokenOtherWsTokenForWebsocketGet
   * @summary Get Token
   * @request GET:/other/ws/token-for-websocket
   * @secure
   */
  export namespace GetTokenOtherWsTokenForWebsocketGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TokenResp;
  }
}

export namespace BankId {
  /**
   * No description
   * @tags BankID
   * @name VerifyCustomerBankIdVerifyPost
   * @summary Verify Customer
   * @request POST:/bank-id/verify
   * @secure
   */
  export namespace VerifyCustomerBankIdVerifyPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankIDPayload;
    export type RequestHeaders = {};
    export type ResponseBody = RoutersBankIdModelsBankIDResp;
  }

  /**
   * No description
   * @tags BankID
   * @name CancelVerifyCustomerBankIdCancelDelete
   * @summary Cancel Verify Customer
   * @request DELETE:/bank-id/cancel
   * @secure
   */
  export namespace CancelVerifyCustomerBankIdCancelDelete {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Ticket Id */
      ticket_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags BankID
   * @name IsAlreadyVerifiedBankIdVerifiedPost
   * @summary Is Already Verified
   * @request POST:/bank-id/verified
   * @secure
   */
  export namespace IsAlreadyVerifiedBankIdVerifiedPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankIDPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PollResp;
  }

  /**
   * No description
   * @tags BankID
   * @name GetTicketStatusBankIdVerifyTicketIdGet
   * @summary Get Ticket Status
   * @request GET:/bank-id/verify/{ticket_id}
   * @secure
   */
  export namespace GetTicketStatusBankIdVerifyTicketIdGet {
    export type RequestParams = {
      /** Ticket Id */
      ticketId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PollResp;
  }

  /**
   * No description
   * @tags BankID
   * @name IdKollenRedirectNoBankIdIdKollenCallbackGet
   * @summary Id Kollen Redirect No
   * @request GET:/bank-id/id-kollen/callback
   */
  export namespace IdKollenRedirectNoBankIdIdKollenCallbackGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Refid */
      refId?: string | null;
      /** Id */
      id?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /** User-Agent */
      "user-agent"?: string | null;
    };
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags BankID
   * @name IdKollenCallbackSeBankIdIdKollenCallbackPost
   * @summary Id Kollen Callback Se
   * @request POST:/bank-id/id-kollen/callback
   */
  export namespace IdKollenCallbackSeBankIdIdKollenCallbackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = IDKollenCollectResponse;
    export type RequestHeaders = {
      /** User-Agent */
      "user-agent"?: string | null;
    };
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags BankID
   * @name QrCodeBankIdQrCodeGet
   * @summary Qr Code
   * @request GET:/bank-id/qr-code
   */
  export namespace QrCodeBankIdQrCodeGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Ticket Id */
      ticket_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QRCodeContent;
  }

  /**
   * No description
   * @tags BankID
   * @name RedirectFromAppBankIdRedirectGet
   * @summary Redirect From App
   * @request GET:/bank-id/redirect
   */
  export namespace RedirectFromAppBankIdRedirectGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Ticket Id */
      ticket_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /** User-Agent */
      "user-agent"?: string | null;
    };
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags BankID
   * @name LoginBankIdAuthPost
   * @summary Login
   * @request POST:/bank-id/auth
   */
  export namespace LoginBankIdAuthPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LoginPayload;
    export type RequestHeaders = {
      /** X-Filling-Id */
      "X-Filling-Id"?: string | null;
    };
    export type ResponseBody = RoutersBankIdLoginPayloadBankIDResp;
  }

  /**
   * No description
   * @tags BankID
   * @name ExchangeAuthCodeBankIdTokenPost
   * @summary Exchange Auth Code
   * @request POST:/bank-id/token
   */
  export namespace ExchangeAuthCodeBankIdTokenPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TokenExchangePayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankIDLoginResponse;
  }

  /**
   * No description
   * @tags BankID
   * @name PollTicketBankIdTicketIdGet
   * @summary Poll Ticket
   * @request GET:/bank-id/{ticket_id}
   */
  export namespace PollTicketBankIdTicketIdGet {
    export type RequestParams = {
      /** Ticket Id */
      ticketId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankIDLoginResponse;
  }

  /**
   * @description Development-only endpoint to simulate BankID/Vipps without dependency on third-party services.
   * @tags Simulator
   * @name SimulateLoginBankIdSimulatorAuthPost
   * @summary Simulate Login
   * @request POST:/bank-id/simulator/auth
   */
  export namespace SimulateLoginBankIdSimulatorAuthPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SimulatedLoginPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankIDLoginResponse;
  }
}

export namespace Notification {
  /**
   * No description
   * @tags Notifications
   * @name UserNotificationsNotificationGet
   * @summary User Notifications
   * @request GET:/notification/
   * @secure
   */
  export namespace UserNotificationsNotificationGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Status */
      status?: NotificationEvent[] | null;
      /** Notification Type */
      notification_type?: ModelsNotificationsNotificationTypesNotificationType | null;
      /** Product */
      product?: Product | null;
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 51
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | ({
          type: "SMS_RECEIVED";
        } & SMSReceived)
      | ({
          type: "EMAIL_RECEIVED";
        } & EmailReceived)
      | ({
          type: "BANK_MESSAGE_RECEIVED";
        } & BankMessageReceived)
      | ({
          type: "CUSTOMER_DOCUMENT_RECEIVED";
        } & CustomerDocumentReceived)
      | ({
          type: "OFFER_RECEIVED";
        } & OfferReceived)
      | ({
          type: "INTERNAL_COMMENT_RECEIVED";
        } & ModelsNotificationsNotificationInternalComment)
      | ({
          type: "APPLICATION_ASSIGNED";
        } & ApplicationAssigned)
      | ({
          type: "GENERAL_MESSAGE_RECEIVED";
        } & GeneralMessage)
      | ({
          type: "LEAD_ASSIGNED";
        } & LeadAssigned)
      | ({
          type: "LEAD_COMMENT_RECEIVED";
        } & LeadComment)
      | ({
          type: "APPLICATION_DISBURSED";
        } & ApplicationDisbursed)
      | ({
          type: "INSURANCE_SCHEDULED_CANCELLATION";
        } & InsuranceCancellationQueued)
      | ({
          type: "OFFER_ACCEPTED";
        } & OfferAccepted)
      | ({
          type: "APPLICATION_REJECTED";
        } & ApplicationRejected)
      | ({
          type: "MEETING_REMINDER";
        } & MeetingReminder)
      | ({
          type: "CUSTOMER_PORTAL_LOGIN";
        } & CustomerPortalLogin)
      | ({
          type: "INSURANCE_ACTIVATED";
        } & InsuranceActivated)
      | ({
          type: "OP_POA_RECEIVED";
        } & OPPoaReceived)
      | ({
          type: "OP_RESPONSE_RECEIVED";
        } & OPResponseReceived)
      | ({
          type: "MORTGAGE_COI_FLAGGED";
        } & MortgageCoiFlagged)
    )[];
  }

  /**
   * @description Live notification stream (SSE). Returns immediately so the streamed body is not bound by the 30s TimeoutRoute budget; sse_starlette's built-in ping keeps the connection alive.
   * @tags Notifications
   * @name NotificationStreamNotificationStreamGet
   * @summary Notification Stream
   * @request GET:/notification/stream
   * @secure
   */
  export namespace NotificationStreamNotificationStreamGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Notifications
   * @name GetNotificationNotificationByIdNotificationIdGet
   * @summary Get Notification
   * @request GET:/notification/by-id/{notification_id}
   * @secure
   */
  export namespace GetNotificationNotificationByIdNotificationIdGet {
    export type RequestParams = {
      /** Notification Id */
      notificationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          type: "SMS_RECEIVED";
        } & SMSReceived)
      | ({
          type: "EMAIL_RECEIVED";
        } & EmailReceived)
      | ({
          type: "BANK_MESSAGE_RECEIVED";
        } & BankMessageReceived)
      | ({
          type: "CUSTOMER_DOCUMENT_RECEIVED";
        } & CustomerDocumentReceived)
      | ({
          type: "OFFER_RECEIVED";
        } & OfferReceived)
      | ({
          type: "INTERNAL_COMMENT_RECEIVED";
        } & ModelsNotificationsNotificationInternalComment)
      | ({
          type: "APPLICATION_ASSIGNED";
        } & ApplicationAssigned)
      | ({
          type: "GENERAL_MESSAGE_RECEIVED";
        } & GeneralMessage)
      | ({
          type: "LEAD_ASSIGNED";
        } & LeadAssigned)
      | ({
          type: "LEAD_COMMENT_RECEIVED";
        } & LeadComment)
      | ({
          type: "APPLICATION_DISBURSED";
        } & ApplicationDisbursed)
      | ({
          type: "INSURANCE_SCHEDULED_CANCELLATION";
        } & InsuranceCancellationQueued)
      | ({
          type: "OFFER_ACCEPTED";
        } & OfferAccepted)
      | ({
          type: "APPLICATION_REJECTED";
        } & ApplicationRejected)
      | ({
          type: "MEETING_REMINDER";
        } & MeetingReminder)
      | ({
          type: "CUSTOMER_PORTAL_LOGIN";
        } & CustomerPortalLogin)
      | ({
          type: "INSURANCE_ACTIVATED";
        } & InsuranceActivated)
      | ({
          type: "OP_POA_RECEIVED";
        } & OPPoaReceived)
      | ({
          type: "OP_RESPONSE_RECEIVED";
        } & OPResponseReceived)
      | ({
          type: "MORTGAGE_COI_FLAGGED";
        } & MortgageCoiFlagged);
  }

  /**
   * No description
   * @tags Notifications
   * @name NotifyNotificationNotifyIncomingPost
   * @summary Notify
   * @request POST:/notification/notify/incoming
   * @secure
   */
  export namespace NotifyNotificationNotifyIncomingPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Notification;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Notifications
   * @name NotifyInsuranceNotificationNotifyInsurancePost
   * @summary Notify Insurance
   * @request POST:/notification/notify/insurance
   * @secure
   */
  export namespace NotifyInsuranceNotificationNotifyInsurancePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = InsuranceNotification;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Notifications
   * @name AcknowledgeNotificationNotificationActionPost
   * @summary Acknowledge Notification
   * @request POST:/notification/action
   * @secure
   */
  export namespace AcknowledgeNotificationNotificationActionPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ActionPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Notifications
   * @name MarkAllNotificationsReadNotificationReadAllPost
   * @summary Mark All Notifications Read
   * @request POST:/notification/read-all
   * @secure
   */
  export namespace MarkAllNotificationsReadNotificationReadAllPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Notifications
   * @name CustomAuthUserNotificationsNotificationNotificationIdReceivedPatch
   * @summary Custom Auth User Notifications
   * @request PATCH:/notification/{notification_id}/received
   */
  export namespace CustomAuthUserNotificationsNotificationNotificationIdReceivedPatch {
    export type RequestParams = {
      /** Notification Id */
      notificationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Token
       * @default "Authorization"
       */
      token?: string;
    };
    export type ResponseBody = void;
  }
}

export namespace Ponytail {
  /**
   * No description
   * @tags Ponytail
   * @name GetDisbursedStatsPonytailDisbursedAllPost
   * @summary Get Disbursed Stats
   * @request POST:/ponytail/disbursed/all
   * @secure
   */
  export namespace GetDisbursedStatsPonytailDisbursedAllPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AllDisbursedLoans;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetMyDisbursedPonytailDisbursedMePost
   * @summary Get My Disbursed
   * @request POST:/ponytail/disbursed/me
   * @secure
   */
  export namespace GetMyDisbursedPonytailDisbursedMePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = MyDisbursedLoans;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetAcceptedPonytailAcceptedAllPost
   * @summary Get Accepted
   * @request POST:/ponytail/accepted/all
   * @secure
   */
  export namespace GetAcceptedPonytailAcceptedAllPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AcceptedLoans;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetMyAcceptedPonytailAcceptedMePost
   * @summary Get My Accepted
   * @request POST:/ponytail/accepted/me
   * @secure
   */
  export namespace GetMyAcceptedPonytailAcceptedMePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AcceptedLoans;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetAllInsurancePonytailInsuranceAllPost
   * @summary Get All Insurance
   * @request POST:/ponytail/insurance/all
   * @secure
   */
  export namespace GetAllInsurancePonytailInsuranceAllPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AllInsurances;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetMyInsurancePonytailInsuranceMePost
   * @summary Get My Insurance
   * @request POST:/ponytail/insurance/me
   * @secure
   */
  export namespace GetMyInsurancePonytailInsuranceMePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AllInsurances;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetAllMyStatsPonytailMyStatsPost
   * @summary Get All My Stats
   * @request POST:/ponytail/my-stats
   * @secure
   */
  export namespace GetAllMyStatsPonytailMyStatsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = RootModelUnionMyStatsMyStatsMb;
  }

  /**
   * No description
   * @tags Ponytail
   * @name SummarizedViewPonytailSummarizedPost
   * @summary Summarized View
   * @request POST:/ponytail/summarized
   * @secure
   */
  export namespace SummarizedViewPonytailSummarizedPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = RootModelUnionSummarizedViewMyStatsMb;
  }

  /**
   * @description Per-user stats of native ZRM applications in `[start_date, end_date)`, at most 62 days.
   * @tags Ponytail
   * @name GetNativeStatsPonytailNativeStatsPost
   * @summary Get Native Stats
   * @request POST:/ponytail/native/stats
   * @secure
   */
  export namespace GetNativeStatsPonytailNativeStatsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DashboardPayload;
    export type RequestHeaders = {};
    export type ResponseBody = NativeStatsView;
  }

  /**
   * @description The month's KH or non-KH budget, by the department in `X-Zoordinates`, whole and per seller.
   * @tags Ponytail
   * @name GetNativeBudgetPonytailNativeBudgetGet
   * @summary Get Native Budget
   * @request GET:/ponytail/native/budget
   * @secure
   */
  export namespace GetNativeBudgetPonytailNativeBudgetGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Year */
      year: number;
      /**
       * Month
       * @min 1
       * @max 12
       */
      month: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NativeBudgetView;
  }

  /**
   * @description Set the month's KH or non-KH budget, by the department in `X-Zoordinates`; the newest one wins.
   * @tags Ponytail
   * @name PostNativeBudgetPonytailNativeBudgetCreatePost
   * @summary Post Native Budget
   * @request POST:/ponytail/native/budget/create
   * @secure
   */
  export namespace PostNativeBudgetPonytailNativeBudgetCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = NativeBudgetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = NativeBudget;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetWorkingDaysPonytailWorkingDaysPost
   * @summary Get Working Days
   * @request POST:/ponytail/working-days
   * @secure
   */
  export namespace GetWorkingDaysPonytailWorkingDaysPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GoalPayload;
    export type RequestHeaders = {};
    export type ResponseBody = WorkingDays;
  }

  /**
   * No description
   * @tags Ponytail
   * @name PostBlancoGoalPonytailGoalsCreateBlancoPost
   * @summary Post Blanco Goal
   * @request POST:/ponytail/goals/create/blanco
   * @secure
   */
  export namespace PostBlancoGoalPonytailGoalsCreateBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlancoGoalPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BlancoGoal;
  }

  /**
   * No description
   * @tags Ponytail
   * @name PostBlancoGoalMbPonytailGoalsCreateBlancoMbPost
   * @summary Post Blanco Goal Mb
   * @request POST:/ponytail/goals/create/blanco-mb
   * @secure
   */
  export namespace PostBlancoGoalMbPonytailGoalsCreateBlancoMbPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlancoGoalMbPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BlancoGoalMb;
  }

  /**
   * No description
   * @tags Ponytail
   * @name PostInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost
   * @summary Post Initial Blanco Goal
   * @request POST:/ponytail/goals/create/initial-blanco
   * @secure
   */
  export namespace PostInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlancoGoalPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BlancoGoal;
  }

  /**
   * No description
   * @tags Ponytail
   * @name PostInitialBudgetPonytailGoalsCreateInitialBlancoMbPost
   * @summary Post Initial Budget
   * @request POST:/ponytail/goals/create/initial-blanco-mb
   * @secure
   */
  export namespace PostInitialBudgetPonytailGoalsCreateInitialBlancoMbPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BudgetPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Budget;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetMyGoalsPonytailGoalsPost
   * @summary Get My Goals
   * @request POST:/ponytail/goals
   * @secure
   */
  export namespace GetMyGoalsPonytailGoalsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GoalPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BlancoGoalMb | BlancoGoal | MortgageGoal | null;
  }

  /**
   * No description
   * @tags Ponytail
   * @name GetInitialGoalPonytailGoalsInitialGoalPost
   * @summary Get Initial Goal
   * @request POST:/ponytail/goals/initial-goal
   * @secure
   */
  export namespace GetInitialGoalPonytailGoalsInitialGoalPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GoalPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Budget | BlancoGoal | MortgageGoal | null;
  }
}

export namespace Lead {
  /**
   * No description
   * @tags Lead
   * @name GetLeadLeadGetLeadIdGet
   * @summary Get Lead
   * @request GET:/lead/get/{lead_id}
   * @secure
   */
  export namespace GetLeadLeadGetLeadIdGet {
    export type RequestParams = {
      /** Lead Id */
      leadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Lead;
  }

  /**
   * No description
   * @tags Lead
   * @name GetLeadsLeadListPost
   * @summary Get Leads
   * @request POST:/lead/list
   * @secure
   */
  export namespace GetLeadsLeadListPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetLeads;
    export type RequestHeaders = {};
    export type ResponseBody = Lead[];
  }

  /**
   * No description
   * @tags Lead
   * @name CreateLeadLeadCreatePost
   * @summary Create Lead
   * @request POST:/lead/create
   * @secure
   */
  export namespace CreateLeadLeadCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateLeadPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Lead;
  }

  /**
   * No description
   * @tags Lead
   * @name SearchLeadSearchPost
   * @summary Search
   * @request POST:/lead/search
   * @secure
   */
  export namespace SearchLeadSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RoutersLeadPayloadSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Lead[];
  }

  /**
   * No description
   * @tags Lead
   * @name ConvertAndCloseLeadConvertAndMarkHandledPost
   * @summary Convert And Close
   * @request POST:/lead/convert_and_mark_handled
   * @secure
   */
  export namespace ConvertAndCloseLeadConvertAndMarkHandledPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConvertPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ConvertResult;
  }

  /**
   * No description
   * @tags Lead
   * @name CloseLeadMarkHandledPost
   * @summary Close
   * @request POST:/lead/mark_handled
   * @secure
   */
  export namespace CloseLeadMarkHandledPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LeadHandledPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Lead
   * @name UnhandleLeadLeadUnhandlePost
   * @summary Unhandle Lead
   * @request POST:/lead/unhandle
   * @secure
   */
  export namespace UnhandleLeadLeadUnhandlePost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Lead Id */
      lead_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Lead
   * @name UpdateLeadLeadUpdateLeadIdPost
   * @summary Update Lead
   * @request POST:/lead/update/{lead_id}
   * @secure
   */
  export namespace UpdateLeadLeadUpdateLeadIdPost {
    export type RequestParams = {
      /** Lead Id */
      leadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = LeadUpdatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = Lead;
  }

  /**
   * No description
   * @tags Lead
   * @name ReprocessSubmissionLeadReprocessSubmissionLeadIdPost
   * @summary Reprocess Submission
   * @request POST:/lead/reprocess_submission/{lead_id}
   * @secure
   */
  export namespace ReprocessSubmissionLeadReprocessSubmissionLeadIdPost {
    export type RequestParams = {
      /** Lead Id */
      leadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Lead
   * @name ReprocessSubmissionsLeadReprocessSubmissionsPost
   * @summary Reprocess Submissions
   * @request POST:/lead/reprocess_submissions
   * @secure
   */
  export namespace ReprocessSubmissionsLeadReprocessSubmissionsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReprocessSubmissionPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ReprocessResult[];
  }

  /**
   * No description
   * @tags Lead
   * @name GetCommentsLeadCommentLeadIdGet
   * @summary Get Comments
   * @request GET:/lead/comment/{lead_id}
   * @secure
   */
  export namespace GetCommentsLeadCommentLeadIdGet {
    export type RequestParams = {
      /** Lead Id */
      leadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InternalCommentWithName[];
  }

  /**
   * No description
   * @tags Lead
   * @name AddInternalCommentLeadCommentLeadIdPost
   * @summary Add Internal Comment
   * @request POST:/lead/comment/{lead_id}
   * @secure
   */
  export namespace AddInternalCommentLeadCommentLeadIdPost {
    export type RequestParams = {
      /** Lead Id */
      leadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CommentPayload;
    export type RequestHeaders = {};
    export type ResponseBody = InternalCommentWithName[];
  }

  /**
   * No description
   * @tags Lead
   * @name AssignLeadToHandlerLeadAssignLeadIdPost
   * @summary Assign Lead To Handler
   * @request POST:/lead/assign/{lead_id}
   * @secure
   */
  export namespace AssignLeadToHandlerLeadAssignLeadIdPost {
    export type RequestParams = {
      /** Lead Id */
      leadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = AssignApplicationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Lead
   * @name GetAssignedHandlerLeadAssigneeLeadIdGet
   * @summary Get Assigned Handler
   * @request GET:/lead/assignee/{lead_id}
   * @secure
   */
  export namespace GetAssignedHandlerLeadAssigneeLeadIdGet {
    export type RequestParams = {
      /** Lead Id */
      leadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Assignee;
  }

  /**
   * No description
   * @tags Lead
   * @name GetLeadsLeadListMinePost
   * @summary Get Leads
   * @request POST:/lead/list/mine
   * @secure
   */
  export namespace GetLeadsLeadListMinePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMyLeads;
    export type RequestHeaders = {};
    export type ResponseBody = Lead[];
  }
}

export namespace Formprefs {
  /**
   * No description
   * @tags Jotform
   * @name UpdatePreferenceFormprefsPut
   * @summary Update Preference
   * @request PUT:/formprefs/
   * @secure
   */
  export namespace UpdatePreferenceFormprefsPut {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UpdateFormPreferencePayload;
    export type RequestHeaders = {};
    export type ResponseBody = FormPreferenceExt;
  }

  /**
   * No description
   * @tags Jotform
   * @name CreatePreferenceFormprefsPost
   * @summary Create Preference
   * @request POST:/formprefs/
   * @secure
   */
  export namespace CreatePreferenceFormprefsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = FormPreferencePayload;
    export type RequestHeaders = {};
    export type ResponseBody = FormPreferenceExt;
  }

  /**
   * No description
   * @tags Jotform
   * @name DuplicatePreferenceFormprefsDuplicatePost
   * @summary Duplicate Preference
   * @request POST:/formprefs/duplicate
   * @secure
   */
  export namespace DuplicatePreferenceFormprefsDuplicatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DuplicateFormPreferencePayload;
    export type RequestHeaders = {};
    export type ResponseBody = FormPreferenceExt;
  }

  /**
   * No description
   * @tags Jotform
   * @name ValidatePreferenceFormprefsValidatePost
   * @summary Validate Preference
   * @request POST:/formprefs/validate
   * @secure
   */
  export namespace ValidatePreferenceFormprefsValidatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ValidatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = FormPreferenceExt;
  }

  /**
   * No description
   * @tags Jotform
   * @name GetMappingFormprefsGetMappingPost
   * @summary Get Mapping
   * @request POST:/formprefs/get_mapping
   * @secure
   */
  export namespace GetMappingFormprefsGetMappingPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BaseFormPreferencePayload;
    export type RequestHeaders = {};
    export type ResponseBody = FormMapping;
  }

  /**
   * No description
   * @tags Jotform
   * @name ListPreferencesFormprefsListGet
   * @summary List Preferences
   * @request GET:/formprefs/list
   * @secure
   */
  export namespace ListPreferencesFormprefsListGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FormPreference[];
  }

  /**
   * No description
   * @tags Jotform
   * @name ListPreferencesExtFormprefsListExtGet
   * @summary List Preferences Ext
   * @request GET:/formprefs/list_ext
   * @secure
   */
  export namespace ListPreferencesExtFormprefsListExtGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FormPreferenceExt[];
  }

  /**
   * No description
   * @tags Jotform
   * @name ListFormsFormprefsFormsGet
   * @summary List Forms
   * @request GET:/formprefs/forms
   * @secure
   */
  export namespace ListFormsFormprefsFormsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Form[];
  }

  /**
   * No description
   * @tags Jotform
   * @name CheckAllSubmissionsFormprefsCheckAllGet
   * @summary Check All Submissions
   * @request GET:/formprefs/check-all
   * @secure
   */
  export namespace CheckAllSubmissionsFormprefsCheckAllGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Jotform
   * @name GetAllSubmissionsFormprefsSubmissionsGet
   * @summary Get All Submissions
   * @request GET:/formprefs/submissions
   * @secure
   */
  export namespace GetAllSubmissionsFormprefsSubmissionsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Form Id */
      form_id?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Jotform
   * @name GetFormPreferenceFormprefsFormPreferenceIdGet
   * @summary Get Form Preference
   * @request GET:/formprefs/{form_preference_id}
   * @secure
   */
  export namespace GetFormPreferenceFormprefsFormPreferenceIdGet {
    export type RequestParams = {
      /** Form Preference Id */
      formPreferenceId: string;
    };
    export type RequestQuery = {
      /**
       * Add Defaults
       * @default false
       */
      add_defaults?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = FormPreferenceExt;
  }

  /**
   * No description
   * @tags Jotform
   * @name CreateWebhookFormprefsWebhookPost
   * @summary Create Webhook
   * @request POST:/formprefs/webhook
   * @secure
   */
  export namespace CreateWebhookFormprefsWebhookPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = FormWebhookPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Jotform
   * @name DeleteWebhookFormprefsWebhookDelete
   * @summary Delete Webhook
   * @request DELETE:/formprefs/webhook
   * @secure
   */
  export namespace DeleteWebhookFormprefsWebhookDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = FormWebhookPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Heimdall {
  /**
   * No description
   * @tags Heimdall
   * @name GetAllHeimdallRecordsForDateHeimdallDateGet
   * @summary Get All Heimdall Records For Date
   * @request GET:/heimdall/{date}
   * @secure
   */
  export namespace GetAllHeimdallRecordsForDateHeimdallDateGet {
    export type RequestParams = {
      /**
       * Date
       * @format date
       */
      date: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HeimdallResponse[];
  }

  /**
   * No description
   * @tags Heimdall
   * @name ReportAndVerifyUsageToHeimdallHeimdallUserIdPatch
   * @summary Report And Verify Usage To Heimdall
   * @request PATCH:/heimdall/{user_id}
   * @secure
   */
  export namespace ReportAndVerifyUsageToHeimdallHeimdallUserIdPatch {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = HeimdallReportingPayload;
    export type RequestHeaders = {};
    export type ResponseBody = HeimdallReportingResponse;
  }

  /**
   * No description
   * @tags Heimdall
   * @name ResetHeimdallRateLimitHeimdallUserIdToResetResetPatch
   * @summary Reset Heimdall Rate Limit
   * @request PATCH:/heimdall/{user_id_to_reset}/reset
   * @secure
   */
  export namespace ResetHeimdallRateLimitHeimdallUserIdToResetResetPatch {
    export type RequestParams = {
      /** User Id To Reset */
      userIdToReset: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace LarsMagnus {
  /**
   * No description
   * @tags Lars Magnus
   * @name CheckTelavoxIdsLarsMagnusTelavoxCheckGet
   * @summary Check Telavox Ids
   * @request GET:/lars-magnus/telavox-check
   * @secure
   */
  export namespace CheckTelavoxIdsLarsMagnusTelavoxCheckGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TelavoxMismatch;
  }

  /**
   * No description
   * @tags Lars Magnus
   * @name CurrentTelavoxUserLarsMagnusTelavoxUserGet
   * @summary Current Telavox User
   * @request GET:/lars-magnus/telavox-user
   * @secure
   */
  export namespace CurrentTelavoxUserLarsMagnusTelavoxUserGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TelavoxExtension;
  }
}

export namespace MyPages {
  /**
   * No description
   * @tags My Pages
   * @name ImpersonateCustomerMyPagesImpersonatePost
   * @summary Impersonate Customer
   * @request POST:/my-pages/impersonate
   * @secure
   */
  export namespace ImpersonateCustomerMyPagesImpersonatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ImpersonateCustomerPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankIDLoginResponse;
  }

  /**
   * No description
   * @tags My Pages
   * @name ValidateClearingMyPagesOffersClearingValidateClearingGet
   * @summary Validate Clearing
   * @request GET:/my-pages/offers/clearing/validate/{clearing}
   */
  export namespace ValidateClearingMyPagesOffersClearingValidateClearingGet {
    export type RequestParams = {
      /** Clearing */
      clearing: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }

  /**
   * @description Gather request md and proceed with accepting terms for insurance used for customers that are not authenticated and cannot change the amount
   * @tags My Pages
   * @name ConfirmInsuranceTermsMyPagesInsurancesConfirmPost
   * @summary Confirm Insurance Terms
   * @request POST:/my-pages/insurances/confirm
   */
  export namespace ConfirmInsuranceTermsMyPagesInsurancesConfirmPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Encrypted Insurance Id */
      encrypted_insurance_id: string;
      /** Email */
      email: string;
      /** Phone Number */
      phone_number: string;
      /** Success Url */
      success_url: string;
      /** Fail Url */
      fail_url: string;
      /** Insured Amount */
      insured_amount?: number | null;
      /** Premium */
      premium?: number | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /** User-Agent */
      "user-agent"?: string | null;
      /** Origin */
      origin?: string | null;
    };
    export type ResponseBody = AcceptTermsResponse;
  }

  /**
   * No description
   * @tags My Pages
   * @name GetInsuranceMyPagesInsuranceGet
   * @summary Get Insurance
   * @request GET:/my-pages/insurance
   */
  export namespace GetInsuranceMyPagesInsuranceGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Id */
      id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UnauthenticatedInsurance;
  }

  /**
   * No description
   * @tags My Pages
   * @name GetLatestActiveApplicationsV2MyPagesV2ApplicationsLatestGet
   * @summary Get Latest Active Applications V2
   * @request GET:/my-pages/v2/applications/latest
   * @secure
   */
  export namespace GetLatestActiveApplicationsV2MyPagesV2ApplicationsLatestGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerApplicationV2[];
  }

  /**
   * No description
   * @tags My Pages
   * @name GetLatestActiveApplicationMyPagesApplicationLatestGet
   * @summary Get Latest Active Application
   * @request GET:/my-pages/application/latest
   * @secure
   */
  export namespace GetLatestActiveApplicationMyPagesApplicationLatestGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerApplication | null;
  }

  /**
   * No description
   * @tags My Pages
   * @name GetCreditCardOffersMyPagesCreditCardOffersGet
   * @summary Get Credit Card Offers
   * @request GET:/my-pages/credit_card/offers
   * @secure
   */
  export namespace GetCreditCardOffersMyPagesCreditCardOffersGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      CreditorOfferCreditCardOfferDataCreditCardTerms[];
  }

  /**
   * No description
   * @tags My Pages
   * @name GetApplicantMyPagesApplicantMeGet
   * @summary Get Applicant
   * @request GET:/my-pages/applicant/me
   * @secure
   */
  export namespace GetApplicantMyPagesApplicantMeGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          country: "SE";
        } & ApplicantSE)
      | ({
          country: "NO";
        } & ApplicantNO);
  }

  /**
   * @description A 1-hour link to the Swish pay-now page for the logged-in customer's unpaid insurance invoices. Also under impersonation: the agent can mint the customer a link anyway, and the link opens no payment on its own.
   * @tags My Pages
   * @name GetMyPayNowLinkMyPagesInsurancePayNowLinkGet
   * @summary Get My Pay Now Link
   * @request GET:/my-pages/insurance/pay-now-link
   * @secure
   */
  export namespace GetMyPayNowLinkMyPagesInsurancePayNowLinkGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PayNowLink;
  }

  /**
   * @description The customer's active MONO applications, as applicant or co-applicant, newest first: the cases they can upload documents to.
   * @tags My Pages
   * @name ListMyMortgageApplicationsMyPagesCaseDocumentsApplicationsGet
   * @summary List My Mortgage Applications
   * @request GET:/my-pages/case-documents/applications
   * @secure
   */
  export namespace ListMyMortgageApplicationsMyPagesCaseDocumentsApplicationsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerMortgageApplication[];
  }

  /**
   * @description The documents the customer uploaded to one of their MONO applications, newest first. 404 for an application that is not theirs or not MONO.
   * @tags My Pages
   * @name ListMyCaseDocumentsMyPagesCaseDocumentsApplicationIdGet
   * @summary List My Case Documents
   * @request GET:/my-pages/case-documents/{application_id}
   * @secure
   */
  export namespace ListMyCaseDocumentsMyPagesCaseDocumentsApplicationIdGet {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerCaseDocument[];
  }

  /**
   * @description Upload a document to one of the customer's MONO applications, as applicant or co-applicant (404 otherwise). The agent sees it in Case View; no bank sees it until an agent shares it. At most 20 MB (413, also for a larger Content-Length, before the body is read; 411 without one) and 50 live uploads per application (409); PDF, JPEG, PNG, HEIC, DOCX or XLSX by extension and content (415). 403 for an impersonated session: agents upload in Case View.
   * @tags My Pages
   * @name UploadMyCaseDocumentMyPagesCaseDocumentsApplicationIdPost
   * @summary Upload My Case Document
   * @request POST:/my-pages/case-documents/{application_id}
   * @secure
   */
  export namespace UploadMyCaseDocumentMyPagesCaseDocumentsApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      BodyUploadMyCaseDocumentMyPagesCaseDocumentsApplicationIdPost;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerCaseDocument;
  }

  /**
   * @description Legacy blanco endpoint (Sverker)
   * @tags My Pages
   * @name AcceptOfferLegacyMyPagesOfferAcceptPost
   * @summary Accept Offer Legacy
   * @request POST:/my-pages/offer/accept
   * @secure
   */
  export namespace AcceptOfferLegacyMyPagesOfferAcceptPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RoutersMyPagesPayloadAcceptOfferPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Legacy blanco endpoint (Sverker). An application ZRM owns, ZRM-only (> 1M app id) or legacy moved to ZRM, goes to the v3 (apps-mgr v4 UUID) accept path instead of Sverker.
   * @tags My Pages
   * @name AcceptOfferLegacyV2MyPagesV2OfferAcceptPost
   * @summary Accept Offer Legacy V2
   * @request POST:/my-pages/v2/offer/accept
   * @secure
   */
  export namespace AcceptOfferLegacyV2MyPagesV2OfferAcceptPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOfferPayloadV2;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Latest blanco applications/offers sourced from apps-mgr v4 raw applications (new offer model).
   * @tags My Pages
   * @name GetLatestActiveApplicationsV3MyPagesV3ApplicationsLatestGet
   * @summary Get Latest Active Applications V3
   * @request GET:/my-pages/v3/applications/latest
   * @secure
   */
  export namespace GetLatestActiveApplicationsV3MyPagesV3ApplicationsLatestGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerApplicationV3[];
  }

  /**
   * @description Blanco offer accept via apps-mgr v4 (new offer model). Sources applications/offers from ``get_customer_applications_v3`` (raw apps via apps-mgr v4) and accepts directly by the UUID ``offer_id`` — no Sverker translation.
   * @tags My Pages
   * @name AcceptOfferV3MyPagesV3OfferAcceptPost
   * @summary Accept Offer V3
   * @request POST:/my-pages/v3/offer/accept
   * @secure
   */
  export namespace AcceptOfferV3MyPagesV3OfferAcceptPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOfferPayloadV2;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags My Pages
   * @name AcceptOfferMyPagesOfferAccept2Post
   * @summary Accept Offer
   * @request POST:/my-pages/offer/accept2
   * @secure
   */
  export namespace AcceptOfferMyPagesOfferAccept2Post {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOffer;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags My Pages
   * @name BanksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet
   * @summary Banks To Exclude From Insurance Offering For
   * @request GET:/my-pages/insurances/banks/excluded
   * @deprecated
   * @secure
   */
  export namespace BanksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BanksToExcludeInsuranceOfferingFor;
  }

  /**
   * No description
   * @tags My Pages
   * @name InsurancesRulesMyPagesInsurancesRulesGet
   * @summary Insurances Rules
   * @request GET:/my-pages/insurances/rules
   * @secure
   */
  export namespace InsurancesRulesMyPagesInsurancesRulesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RulesResponse;
  }

  /**
   * No description
   * @tags My Pages
   * @name LoanInsurancesRulesMyPagesInsurancesLoanInsuranceRulesGet
   * @summary Loan Insurances Rules
   * @request GET:/my-pages/insurances/loan-insurance-rules
   * @secure
   */
  export namespace LoanInsurancesRulesMyPagesInsurancesLoanInsuranceRulesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InsuranceTerms;
  }

  /**
   * No description
   * @tags My Pages
   * @name IdCheckMyPagesIdCheckGet
   * @summary Id Check
   * @request GET:/my-pages/id-check
   * @secure
   */
  export namespace IdCheckMyPagesIdCheckGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (
          | ({
              country: "SE";
            } & ApplicantSE)
          | ({
              country: "NO";
            } & ApplicantNO)
        )
      | (
          | ({
              country: "SE";
            } & OptionalApplicantSE)
          | ({
              country: "NO";
            } & OptionalApplicantNO)
        )
      | IDCheckedPerson;
  }

  /**
   * No description
   * @tags My Pages
   * @name ActiveInsuranceByPniMyPagesInsurancesGet
   * @summary Active Insurance By Pni
   * @request GET:/my-pages/insurances
   * @secure
   */
  export namespace ActiveInsuranceByPniMyPagesInsurancesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InsuranceCustomer[];
  }

  /**
   * No description
   * @tags My Pages
   * @name CreateInsuranceV2MyPagesInsurancesV2Post
   * @summary Create Insurance V2
   * @request POST:/my-pages/insurances/v2
   * @secure
   */
  export namespace CreateInsuranceV2MyPagesInsurancesV2Post {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateInsuranceCustomer;
    export type RequestHeaders = {
      /** User-Agent */
      "user-agent"?: string | null;
      /** Origin */
      origin?: string | null;
    };
    export type ResponseBody = AcceptTermsResponseCustomer;
  }

  /**
   * No description
   * @tags My Pages
   * @name DebtRegisterConsentMyPagesDebtRegisterConsentPost
   * @summary Debt Register Consent
   * @request POST:/my-pages/debt-register/consent
   * @secure
   */
  export namespace DebtRegisterConsentMyPagesDebtRegisterConsentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /** User-Agent */
      "user-agent"?: string | null;
      /** Origin */
      origin?: string | null;
    };
    export type ResponseBody =
      | (
          | ({
              country: "SE";
            } & ApplicantSE)
          | ({
              country: "NO";
            } & ApplicantNO)
        )
      | (
          | ({
              country: "SE";
            } & OptionalApplicantSE)
          | ({
              country: "NO";
            } & OptionalApplicantNO)
        );
  }

  /**
   * No description
   * @tags My Pages
   * @name DebtRegisterCheckConsentMyPagesDebtRegisterCheckConsentPost
   * @summary Debt Register Check Consent
   * @request POST:/my-pages/debt-register/check-consent
   * @secure
   */
  export namespace DebtRegisterCheckConsentMyPagesDebtRegisterCheckConsentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (
          | ({
              country: "SE";
            } & ApplicantSE)
          | ({
              country: "NO";
            } & ApplicantNO)
        )
      | (
          | ({
              country: "SE";
            } & OptionalApplicantSE)
          | ({
              country: "NO";
            } & OptionalApplicantNO)
        );
  }

  /**
   * No description
   * @tags My Pages
   * @name DebtRegisterRenewMyPagesDebtRegisterRenewPost
   * @summary Debt Register Renew
   * @request POST:/my-pages/debt-register/renew
   * @secure
   */
  export namespace DebtRegisterRenewMyPagesDebtRegisterRenewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | (
          | ({
              country: "SE";
            } & ApplicantSE)
          | ({
              country: "NO";
            } & ApplicantNO)
        )
      | (
          | ({
              country: "SE";
            } & OptionalApplicantSE)
          | ({
              country: "NO";
            } & OptionalApplicantNO)
        );
  }

  /**
   * @description This is part of the GR first project. And should only be used by GR first customers. otherwise it will cause faulty data to Google Analytics.
   * @tags My Pages
   * @name DebtRegisterWithConsentMyPagesDebtRegisterWithConsentPost
   * @summary Debt Register With Consent
   * @request POST:/my-pages/debt-register/with-consent
   * @secure
   */
  export namespace DebtRegisterWithConsentMyPagesDebtRegisterWithConsentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyDebtRegisterWithConsentMyPagesDebtRegisterWithConsentPost;
    export type RequestHeaders = {
      /** Referer */
      referer?: string | null;
      /** Origin */
      origin?: string | null;
      /** User-Agent */
      "user-agent"?: string | null;
      /** X-Filling-Id */
      "X-Filling-Id"?: string | null;
    };
    export type ResponseBody =
      | (
          | ({
              country: "SE";
            } & ApplicantSE)
          | ({
              country: "NO";
            } & ApplicantNO)
        )
      | (
          | ({
              country: "SE";
            } & OptionalApplicantSE)
          | ({
              country: "NO";
            } & OptionalApplicantNO)
        );
  }

  /**
   * @description Compare-Debt proxy: authenticates the customer via BankID/Vipps and delegates the aggregate lookup to customer-service. Gender is derived server-side in customer-service for bucketing and is never returned in the DTO.
   * @tags My Pages
   * @name DebtCompareMyPagesDebtComparePost
   * @summary Debt Compare
   * @request POST:/my-pages/debt-compare
   * @secure
   */
  export namespace DebtCompareMyPagesDebtComparePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DebtRegisterCompareResponse;
  }

  /**
   * No description
   * @tags My Pages
   * @name UpsertMarketingConsentMyPagesMarketingConsentsPost
   * @summary Upsert Marketing Consent
   * @request POST:/my-pages/marketing-consents
   * @secure
   */
  export namespace UpsertMarketingConsentMyPagesMarketingConsentsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConsentsPayload;
    export type RequestHeaders = {
      /** User-Agent */
      "user-agent"?: string | null;
      /** Origin */
      origin?: string | null;
    };
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags My Pages
   * @name GetTrustlyUrlForNewMandateMyPagesInsurancesTrustlyUrlGet
   * @summary Get Trustly Url For New Mandate
   * @request GET:/my-pages/insurances/trustly-url
   * @secure
   */
  export namespace GetTrustlyUrlForNewMandateMyPagesInsurancesTrustlyUrlGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Id */
      id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Car Evaluation (Bilverdi) — NO only. Returns the vehicles the authenticated customer owns plus each car's valuation and technical stats. PNI comes ONLY from the verified BankID token `sub`; any pni in the body is ignored. customer-service fetches the customer's OWN vehicle list and then the per-car details (no caller-supplied reg-no path), so a customer can never look up another person's car. Reached only after GR consent (every viewer is a known, identified customer).
   * @tags My Pages
   * @name CarEvalWithConsentMyPagesCarEvalWithConsentPost
   * @summary Car Eval With Consent
   * @request POST:/my-pages/car-eval/with-consent
   * @secure
   */
  export namespace CarEvalWithConsentMyPagesCarEvalWithConsentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyCarEvalWithConsentMyPagesCarEvalWithConsentPost;
    export type RequestHeaders = {
      /** Referer */
      referer?: string | null;
      /** Origin */
      origin?: string | null;
      /** User-Agent */
      "user-agent"?: string | null;
      /** X-Filling-Id */
      "X-Filling-Id"?: string | null;
    };
    export type ResponseBody = CarEvalResponse;
  }

  /**
   * @description This is part of the EV first project. And should only be used by EV first customers. otherwise it will cause faulty data to Google Analytics.
   * @tags My Pages
   * @name EvStatesWithConsentMyPagesEiendomsverdieWithConsentPost
   * @summary Ev States With Consent
   * @request POST:/my-pages/eiendomsverdie/with-consent
   * @secure
   */
  export namespace EvStatesWithConsentMyPagesEiendomsverdieWithConsentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyEvStatesWithConsentMyPagesEiendomsverdieWithConsentPost;
    export type RequestHeaders = {
      /** Referer */
      referer?: string | null;
      /** Origin */
      origin?: string | null;
      /** User-Agent */
      "user-agent"?: string | null;
      /** X-Filling-Id */
      "X-Filling-Id"?: string | null;
    };
    export type ResponseBody = EvFirstResponse;
  }

  /**
   * No description
   * @tags My Pages
   * @name CanSignUpMyPagesCanSignUpGet
   * @summary Can Sign Up
   * @request GET:/my-pages/can-sign-up
   * @secure
   */
  export namespace CanSignUpMyPagesCanSignUpGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CanSignupResponse;
  }

  /**
   * No description
   * @tags My Pages
   * @name MyCreditScorePniMyPagesMyCreditScoreByPniPost
   * @summary My Credit Score Pni
   * @request POST:/my-pages/my-credit-score/by-pni
   * @secure
   */
  export namespace MyCreditScorePniMyPagesMyCreditScoreByPniPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Email */
      email: string | null;
      /** Phone Number */
      phone_number: string | null;
    };
    export type RequestBody = Consents | null;
    export type RequestHeaders = {
      /** X-Filling-Id */
      "X-Filling-Id"?: string | null;
      /** Origin */
      origin?: string | null;
      /** Referer */
      referer?: string | null;
      /** User-Agent */
      "User-Agent"?: string | null;
    };
    export type ResponseBody =
      | CreditReport
      | CreditReportUc
      | CreditReportExperian
      | null;
  }
}

export namespace Zms {
  /**
   * No description
   * @tags ZMS
   * @name SaveZmsConfigZmsCountryPost
   * @summary Save Zms Config
   * @request POST:/zms/{country}
   * @secure
   */
  export namespace SaveZmsConfigZmsCountryPost {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = Config;
    export type RequestHeaders = {};
    export type ResponseBody = ZMSConfig;
  }

  /**
   * No description
   * @tags ZMS
   * @name GetZmsConfigZmsCountryGet
   * @summary Get Zms Config
   * @request GET:/zms/{country}
   */
  export namespace GetZmsConfigZmsCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ZMSConfig;
  }

  /**
   * No description
   * @tags ZMS
   * @name GetAllConfigsZmsGet
   * @summary Get All Configs
   * @request GET:/zms
   */
  export namespace GetAllConfigsZmsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ZMSConfig[];
  }
}

export namespace Affiliates {
  /**
   * No description
   * @tags Affiliate
   * @name CreateAffiliateAffiliatesPost
   * @summary Create Affiliate
   * @request POST:/affiliates/
   * @secure
   */
  export namespace CreateAffiliateAffiliatesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AffiliateData;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate;
  }

  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliatesAffiliatesGet
   * @summary Get Affiliates
   * @request GET:/affiliates/
   * @secure
   */
  export namespace GetAffiliatesAffiliatesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
      /** Status */
      status?: string | null;
      /**
       * Network
       * @default false
       */
      network?: boolean | null;
      /**
       * Publisher
       * @default false
       */
      publisher?: boolean | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate[];
  }

  /**
   * No description
   * @tags Affiliate
   * @name SearchAffiliatesAffiliatesSearchGet
   * @summary Search Affiliates
   * @request GET:/affiliates/search
   * @secure
   */
  export namespace SearchAffiliatesAffiliatesSearchGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Keyword */
      keyword: string;
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate[];
  }

  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliateAffiliatesAffiliateIdGet
   * @summary Get Affiliate
   * @request GET:/affiliates/{affiliate_id}
   * @secure
   */
  export namespace GetAffiliateAffiliatesAffiliateIdGet {
    export type RequestParams = {
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate;
  }

  /**
   * No description
   * @tags Affiliate
   * @name UpdateAffiliateAffiliatesAffiliateIdPut
   * @summary Update Affiliate
   * @request PUT:/affiliates/{affiliate_id}
   * @secure
   */
  export namespace UpdateAffiliateAffiliatesAffiliateIdPut {
    export type RequestParams = {
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = AffiliateData;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate;
  }

  /**
   * No description
   * @tags Affiliate
   * @name DeactivateAffiliateAffiliatesAffiliateIdDelete
   * @summary Deactivate Affiliate
   * @request DELETE:/affiliates/{affiliate_id}
   * @secure
   */
  export namespace DeactivateAffiliateAffiliatesAffiliateIdDelete {
    export type RequestParams = {
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NonEmptyString;
  }

  /**
   * No description
   * @tags Affiliate
   * @name CreateCampaignAffiliatesAffiliateIdCampaignsPost
   * @summary Create Campaign
   * @request POST:/affiliates/{affiliate_id}/campaigns
   * @secure
   */
  export namespace CreateCampaignAffiliatesAffiliateIdCampaignsPost {
    export type RequestParams = {
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CampaignData;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate;
  }

  /**
   * No description
   * @tags Affiliate
   * @name GetCampaignsAffiliatesAffiliateIdCampaignsGet
   * @summary Get Campaigns
   * @request GET:/affiliates/{affiliate_id}/campaigns
   * @secure
   */
  export namespace GetCampaignsAffiliatesAffiliateIdCampaignsGet {
    export type RequestParams = {
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsAffiliateAffiliateCampaign[];
  }

  /**
   * No description
   * @tags Affiliate
   * @name UpdateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut
   * @summary Update Campaign
   * @request PUT:/affiliates/{affiliate_id}/campaigns/{campaign_id}
   * @secure
   */
  export namespace UpdateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CampaignData;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate;
  }

  /**
   * No description
   * @tags Affiliate
   * @name RemoveCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete
   * @summary Remove Campaign
   * @request DELETE:/affiliates/{affiliate_id}/campaigns/{campaign_id}
   * @secure
   */
  export namespace RemoveCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Affiliate
   * @name GetPersonEventAffiliatesPersonsZidGet
   * @summary Get Person Event
   * @request GET:/affiliates/persons/{zid}
   * @secure
   */
  export namespace GetPersonEventAffiliatesPersonsZidGet {
    export type RequestParams = {
      /** Zid */
      zid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Person;
  }

  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet
   * @summary Get Affiliate Person Events
   * @request GET:/affiliates/{affiliate_id}/persons
   * @secure
   */
  export namespace GetAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet {
    export type RequestParams = {
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Person[];
  }

  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost
   * @summary Get Affiliate Callbacks
   * @request POST:/affiliates/{affiliate_network_id}/callbacks
   * @secure
   */
  export namespace GetAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost {
    export type RequestParams = {
      /** Affiliate Network Id */
      affiliateNetworkId: string;
    };
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 100
       * @default 50
       */
      limit?: number;
      /** Publisher */
      publisher?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** End Date */
      end_date?: string | null;
    };
    export type RequestBody = AffiliateNetworkCallbackStatus[] | null;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateNetworkCallbackEvent[];
  }

  /**
   * No description
   * @tags Affiliate
   * @name GetAffiliatePublishersAffiliatesAffiliateIdPublishersGet
   * @summary Get Affiliate Publishers
   * @request GET:/affiliates/{affiliate_id}/publishers
   * @secure
   */
  export namespace GetAffiliatePublishersAffiliatesAffiliateIdPublishersGet {
    export type RequestParams = {
      /** Affiliate Id */
      affiliateId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Affiliate[];
  }

  /**
   * No description
   * @tags Affiliate
   * @name AdtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTtGet
   * @summary Adtraction Network Callback
   * @request GET:/affiliates/dev/adtraction/callback/{site}/t/t
   * @secure
   */
  export namespace AdtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTtGet {
    export type RequestParams = {
      /** Site */
      site: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HTTPStatus;
  }

  /**
   * No description
   * @tags Affiliate
   * @name AdserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet
   * @summary Adservice Network Callback
   * @request GET:/affiliates/dev/adservice/callback/cgi-bin/API/ConversionService/Callback
   * @secure
   */
  export namespace AdserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HTTPStatus;
  }

  /**
   * No description
   * @tags Affiliate
   * @name SmartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet
   * @summary Smartresponse Network Callback
   * @request GET:/affiliates/dev/smartresponse/callback/p.ashx
   * @secure
   */
  export namespace SmartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HTTPStatus;
  }
}

export namespace Online {
  /**
   * @description Get all submissions for a country, newest first. Leave `cursor` out for the first page, then pass the `next_cursor` or the `prev_cursor` of the page you are on.
   * @tags Online
   * @name GetAllSubmissionsOnlineSubmissionsGet
   * @summary Get All Submissions
   * @request GET:/online/submissions
   * @secure
   */
  export namespace GetAllSubmissionsOnlineSubmissionsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Failed */
      failed?: boolean | null;
      /** Handled */
      handled?: boolean | null;
      /** Form Validation */
      form_validation?: boolean | null;
      /** Quick Application */
      quick_application?: boolean | null;
      /** Get Customers */
      get_customers?: boolean | null;
      /** Has Recent App Check */
      has_recent_app_check?: boolean | null;
      /** Created Application */
      created_application?: boolean | null;
      /** App Created Hours Ago */
      app_created_hours_ago?: number | null;
      /**
       * Limit
       * @min 1
       * @max 200
       * @default 50
       */
      limit?: number;
      /** Cursor */
      cursor?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SubmissionReviewResponse;
  }

  /**
   * @description Get submission by id
   * @tags Online
   * @name GetASubmissionOnlineSubmissionsSubmissionIdGet
   * @summary Get A Submission
   * @request GET:/online/submissions/{submission_id}
   * @secure
   */
  export namespace GetASubmissionOnlineSubmissionsSubmissionIdGet {
    export type RequestParams = {
      /** Submission Id */
      submissionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SubmissionReview;
  }

  /**
   * @description What the customer applied for in the online form the application came from, for the case view summary: null when it came from no form. Open to the case view departments, unlike the full submission above, because it carries no personal data.
   * @tags Online
   * @name GetOnlineFormRequestOnlineSubmissionsByApplicationLabelGet
   * @summary Get Online Form Request
   * @request GET:/online/submissions/by-application/{label}
   * @secure
   */
  export namespace GetOnlineFormRequestOnlineSubmissionsByApplicationLabelGet {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OnlineFormRequest | null;
  }

  /**
   * @description Retry processing of submissions in case of temporary error
   * @tags Online
   * @name PostReprocessSubmissionsOnlineSubmissionsReprocessPost
   * @summary Post Reprocess Submissions
   * @request POST:/online/submissions/reprocess
   * @secure
   */
  export namespace PostReprocessSubmissionsOnlineSubmissionsReprocessPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = string[];
    export type RequestHeaders = {};
    export type ResponseBody = EnqueuedSubmissionJobResult[];
  }

  /**
   * @description Retry processing of submission in case of temporary error
   * @tags Online
   * @name PostReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost
   * @summary Post Reprocess Submission
   * @request POST:/online/submissions/{submission_id}/reprocess
   * @secure
   */
  export namespace PostReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost {
    export type RequestParams = {
      /** Submission Id */
      submissionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EnqueuedSubmissionJobResult;
  }

  /**
   * No description
   * @tags Online
   * @name PostResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost
   * @summary Post Resubmit Submission
   * @request POST:/online/submissions/{submission_id}/resubmit
   * @secure
   */
  export namespace PostResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost {
    export type RequestParams = {
      submissionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ResubmitPayload;
    export type RequestHeaders = {};
    export type ResponseBody = EnqueuedSubmissionJobResult;
  }

  /**
   * No description
   * @tags Online
   * @name PostReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost
   * @summary Post Review Submission
   * @request POST:/online/submissions/{submission_id}/review
   * @secure
   */
  export namespace PostReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost {
    export type RequestParams = {
      /** Submission Id */
      submissionId: string;
    };
    export type RequestQuery = {
      /**
       * Handled
       * @default true
       */
      handled?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HandledSubmission;
  }

  /**
   * No description
   * @tags Online
   * @name PostReviewSubmissionsOnlineSubmissionsReviewPost
   * @summary Post Review Submissions
   * @request POST:/online/submissions/review
   * @secure
   */
  export namespace PostReviewSubmissionsOnlineSubmissionsReviewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ReviewSubmissions;
    export type RequestHeaders = {};
    export type ResponseBody = HandledSubmission[];
  }

  /**
   * @description Converts a credit card submission to a blanco submission
   * @tags Online
   * @name PostConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost
   * @summary Post Convert To Blanco
   * @request POST:/online/submissions/{submission_id}/convert_to_blanco
   * @secure
   */
  export namespace PostConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost {
    export type RequestParams = {
      /** Submission Id */
      submissionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EnqueuedSubmissionJobResult;
  }

  /**
   * No description
   * @tags Online
   * @name OnlineAppsMessagesOnlineSendBlancoSmsMessagesPost
   * @summary Online Apps Messages
   * @request POST:/online/send_blanco_sms_messages
   * @secure
   */
  export namespace OnlineAppsMessagesOnlineSendBlancoSmsMessagesPost {
    export type RequestParams = {};
    export type RequestQuery = {
      country: Country;
      product: Product;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Online
   * @name WhitelistedPniOnlineTestingPnisGet
   * @summary Whitelisted Pni
   * @request GET:/online/testing-pnis
   * @secure
   */
  export namespace WhitelistedPniOnlineTestingPnisGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OnlineFormsTestingPNIResponse;
  }

  /**
   * No description
   * @tags Online
   * @name GetBookingsOnlineBookingsCountryGet
   * @summary Get Bookings
   * @request GET:/online/bookings/{country}
   */
  export namespace GetBookingsOnlineBookingsCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }

  /**
   * No description
   * @tags Online
   * @name BookMeetingOnlineBookingsCountryPost
   * @summary Book Meeting
   * @request POST:/online/bookings/{country}
   */
  export namespace BookMeetingOnlineBookingsCountryPost {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = BookingPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ServicesSverkerResponsesMeeting;
  }

  /**
   * No description
   * @tags Online
   * @name MortgageRatesOnlineMortgageRatesCountryGet
   * @summary Mortgage Rates
   * @request GET:/online/mortgage-rates/{country}
   */
  export namespace MortgageRatesOnlineMortgageRatesCountryGet {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CompanyMortgageRates[];
  }

  /**
   * No description
   * @tags Online
   * @name ContactFormOnlineContactCountryPost
   * @summary Contact Form
   * @request POST:/online/contact/{country}
   */
  export namespace ContactFormOnlineContactCountryPost {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = ContactFormPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Online
   * @name MortgageFormOnlineMortgageCountryPost
   * @summary Mortgage Form
   * @request POST:/online/mortgage/{country}
   */
  export namespace MortgageFormOnlineMortgageCountryPost {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = MortgageFormPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Online
   * @name BlancoApplicationOnlineBlancoApplicationCountryPost
   * @summary Blanco Application
   * @request POST:/online/blanco-application/{country}
   */
  export namespace BlancoApplicationOnlineBlancoApplicationCountryPost {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {
      /** X-Forwarded-For */
      "x-forwarded-for"?: string | null;
      /** User-Agent */
      "user-agent"?: string | null;
      /** Origin */
      origin?: string | null;
      /** X-Zid */
      "x-zid"?: string | null;
      /** X-S-Zid */
      "x-s-zid"?: string | null;
      /** X-Gid */
      "x-gid"?: string | null;
      /** X-Google-Ids */
      "x-google-ids"?: string | null;
    };
    export type ResponseBody = FormApplicationSubmissionResult;
  }

  /**
   * No description
   * @tags Online
   * @name OnlineQuickCreateOnlineQuickCreatePost
   * @summary Online Quick Create
   * @request POST:/online/quick-create
   */
  export namespace OnlineQuickCreateOnlineQuickCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      | (
          | ({
              product: "blanco";
            } & QuickCreateBlancoApplication)
          | ({
              product: "mortgage";
            } & QuickCreateMortgageApplication)
        )
      | Record<string, any>;
    export type RequestHeaders = {};
    export type ResponseBody = FormApplicationSubmissionResult;
  }

  /**
   * @description Norway only
   * @tags Online
   * @name NorwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost
   * @summary Norwegian Mortgage Application
   * @request POST:/online/norwegian-mortgage-application
   */
  export namespace NorwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {
      /** X-Forwarded-For */
      "x-forwarded-for"?: string | null;
      /** User-Agent */
      "user-agent"?: string | null;
      /** Origin */
      origin?: string | null;
      /** X-Zid */
      "x-zid"?: string | null;
      /** X-Gid */
      "x-gid"?: string | null;
      /** X-S-Zid */
      "x-s-zid"?: string | null;
      /** X-Google-Ids */
      "x-google-ids"?: string | null;
    };
    export type ResponseBody = FormApplicationSubmissionResult;
  }

  /**
   * @description Reusing JotformCCApplicationWithTracking and its existing backend to minimize number of changes
   * @tags Online
   * @name CreditCardApplicationOnlineCreditCardApplicationPost
   * @summary Credit Card Application
   * @request POST:/online/credit-card-application/
   */
  export namespace CreditCardApplicationOnlineCreditCardApplicationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = JotformCCApplicationWithTracking;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Accept a credit card application from the React app, using the internal CC model.
   * @tags Online
   * @name CcApplicationSubmitOnlineCcApplicationPost
   * @summary Cc Application Submit
   * @request POST:/online/cc-application
   */
  export namespace CcApplicationSubmitOnlineCcApplicationPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CCApplicationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = FormApplicationSubmissionResult;
  }
}

export namespace Rq {
  /**
   * No description
   * @tags Monitor
   * @name GetListOfJobsRqJobsGet
   * @summary Get List Of Jobs
   * @request GET:/rq/jobs
   * @secure
   */
  export namespace GetListOfJobsRqJobsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      job_type: JobType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RqJobStatusResponse[];
  }

  /**
   * No description
   * @tags Monitor
   * @name GetFailedJobsRqManualFailGet
   * @summary Get Failed Jobs
   * @request GET:/rq/manual-fail
   * @secure
   */
  export namespace GetFailedJobsRqManualFailGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Monitor
   * @name ClearFailedJobRqDeleteJobJobIdGet
   * @summary Clear Failed Job
   * @request GET:/rq/delete-job/{job_id}
   * @secure
   */
  export namespace ClearFailedJobRqDeleteJobJobIdGet {
    export type RequestParams = {
      /** Job Id */
      jobId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Monitor
   * @name ReScheduleRqReScheduleGet
   * @summary Re Schedule
   * @request GET:/rq/re-schedule
   * @secure
   */
  export namespace ReScheduleRqReScheduleGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Monitor
   * @name GetSingleJobRqJobIdGet
   * @summary Get Single Job
   * @request GET:/rq/{job_id}
   * @secure
   */
  export namespace GetSingleJobRqJobIdGet {
    export type RequestParams = {
      /** Job Id */
      jobId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RqJobStatusResponse | null;
  }
}

export namespace Tv {
  /**
   * No description
   * @tags TV
   * @name PreviewTvPairingTvPairPreviewPost
   * @summary Preview Tv Pairing
   * @request POST:/tv/pair/preview
   * @secure
   */
  export namespace PreviewTvPairingTvPairPreviewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TvPairPreviewRequest;
    export type RequestHeaders = {};
    export type ResponseBody = TvPairingPreview;
  }

  /**
   * No description
   * @tags TV
   * @name ClaimTvPairingTvPairClaimPost
   * @summary Claim Tv Pairing
   * @request POST:/tv/pair/claim
   * @secure
   */
  export namespace ClaimTvPairingTvPairClaimPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TvPairClaimRequest;
    export type RequestHeaders = {};
    export type ResponseBody = TvDevice;
  }

  /**
   * No description
   * @tags TV
   * @name ListTvDevicesTvDevicesGet
   * @summary List Tv Devices
   * @request GET:/tv/devices
   * @secure
   */
  export namespace ListTvDevicesTvDevicesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TvDevice[];
  }

  /**
   * No description
   * @tags TV
   * @name RevokeTvDeviceTvDevicesDeviceIdDelete
   * @summary Revoke Tv Device
   * @request DELETE:/tv/devices/{device_id}
   * @secure
   */
  export namespace RevokeTvDeviceTvDevicesDeviceIdDelete {
    export type RequestParams = {
      /** Device Id */
      deviceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TvDevice;
  }

  /**
   * No description
   * @tags TV
   * @name GetTvGoalsTvGoalsGet
   * @summary Get Tv Goals
   * @request GET:/tv/goals
   * @secure
   */
  export namespace GetTvGoalsTvGoalsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      dashboard: TvDashboard;
      country: Country;
      /**
       * Month
       * @pattern ^\d{4}-(0[1-9]|1[0-2])$
       */
      month: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TvDashboardGoals;
  }

  /**
   * No description
   * @tags TV
   * @name PutTvGoalsTvGoalsPut
   * @summary Put Tv Goals
   * @request PUT:/tv/goals
   * @secure
   */
  export namespace PutTvGoalsTvGoalsPut {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TvDashboardGoals;
    export type RequestHeaders = {};
    export type ResponseBody = TvDashboardGoals;
  }

  /**
   * No description
   * @tags TV
   * @name StartTvPairingTvPairStartPost
   * @summary Start Tv Pairing
   * @request POST:/tv/pair/start
   */
  export namespace StartTvPairingTvPairStartPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TvPairStartRequest;
    export type RequestHeaders = {};
    export type ResponseBody = TvPairStartResponse;
  }

  /**
   * No description
   * @tags TV
   * @name PollTvPairingTvPairPollPost
   * @summary Poll Tv Pairing
   * @request POST:/tv/pair/poll
   */
  export namespace PollTvPairingTvPairPollPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TvPairPollRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          status: "pending";
        } & TvPairPending)
      | ({
          status: "paired";
        } & TvPairPaired);
  }

  /**
   * No description
   * @tags TV
   * @name GetTvMeTvMeGet
   * @summary Get Tv Me
   * @request GET:/tv/me
   * @secure
   */
  export namespace GetTvMeTvMeGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TvDevice;
  }

  /**
   * @description The screen's dashboard as the cron last stored it; null until the first build. Reads only.
   * @tags TV
   * @name GetTvDashboardTvDashboardGet
   * @summary Get Tv Dashboard
   * @request GET:/tv/dashboard
   * @secure
   */
  export namespace GetTvDashboardTvDashboardGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TvDashboardSnapshot | null;
  }
}

export namespace Kdlt {
  /**
   * No description
   * @tags kdlt
   * @name CallbackKdltCallbackPost
   * @summary Callback
   * @request POST:/kdlt/callback
   * @secure
   */
  export namespace CallbackKdltCallbackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = KDLTCallbackPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace DialMaker {
  /**
   * No description
   * @tags Dial Maker
   * @name GetLeadsForCampaignDialMakerTmLeadsCampaignIdPost
   * @summary Get Leads For Campaign
   * @request POST:/dial-maker/tm-leads/{campaign_id}
   * @secure
   */
  export namespace GetLeadsForCampaignDialMakerTmLeadsCampaignIdPost {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = LeadExtractionInput;
    export type RequestHeaders = {};
    export type ResponseBody = TMLeadsJob;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name GetJobStatusOrResultDialMakerJobStatusJobIdGet
   * @summary Get Job Status Or Result
   * @request GET:/dial-maker/job-status/{job_id}
   * @secure
   */
  export namespace GetJobStatusOrResultDialMakerJobStatusJobIdGet {
    export type RequestParams = {
      /** Job Id */
      jobId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TMLeadsExtraction | TMLeadsJob;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name GetDownloadUrlDialMakerJobResultJobIdDownloadUrlGet
   * @summary Get Download Url
   * @request GET:/dial-maker/job-result/{job_id}/download-url
   * @secure
   */
  export namespace GetDownloadUrlDialMakerJobResultJobIdDownloadUrlGet {
    export type RequestParams = {
      /** Job Id */
      jobId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RoutersDialMakerPayloadsSignedUrl;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name GetCampaignsDialMakerCampaignsGet
   * @summary Get Campaigns
   * @request GET:/dial-maker/campaigns
   * @secure
   */
  export namespace GetCampaignsDialMakerCampaignsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Page */
      page: number;
      /** Limit */
      limit: number;
      /** Department */
      department?: ZDepartment | null;
      /** Country */
      country?: Country | null;
      /** Product */
      product?: Product | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TMCampaignList;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name CreateCampaignDialMakerCampaignsPost
   * @summary Create Campaign
   * @request POST:/dial-maker/campaigns
   * @secure
   */
  export namespace CreateCampaignDialMakerCampaignsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateTMCampaign;
    export type RequestHeaders = {};
    export type ResponseBody = TMCampaign;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name UpdateCampaignDialMakerCampaignsCampaignIdPut
   * @summary Update Campaign
   * @request PUT:/dial-maker/campaigns/{campaign_id}
   * @secure
   */
  export namespace UpdateCampaignDialMakerCampaignsCampaignIdPut {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = CreateTMCampaign;
    export type RequestHeaders = {};
    export type ResponseBody = TMCampaign;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name GetCampaignDialMakerCampaignsCampaignIdGet
   * @summary Get Campaign
   * @request GET:/dial-maker/campaigns/{campaign_id}
   * @secure
   */
  export namespace GetCampaignDialMakerCampaignsCampaignIdGet {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TMCampaign;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name DeleteCampaignDialMakerCampaignsCampaignIdDelete
   * @summary Delete Campaign
   * @request DELETE:/dial-maker/campaigns/{campaign_id}
   * @secure
   */
  export namespace DeleteCampaignDialMakerCampaignsCampaignIdDelete {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = boolean;
  }

  /**
   * No description
   * @tags Dial Maker
   * @name GetCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet
   * @summary Get Campaign Extractions
   * @request GET:/dial-maker/campaigns/{campaign_id}/extractions
   * @secure
   */
  export namespace GetCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
    };
    export type RequestQuery = {
      /** Page */
      page: number;
      /** Limit */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TMLeadsExtraction[];
  }

  /**
   * No description
   * @tags Dial Maker
   * @name DownloadXlsxDialMakerDownloadSignatureGet
   * @summary Download Xlsx
   * @request GET:/dial-maker/download/{signature}
   */
  export namespace DownloadXlsxDialMakerDownloadSignatureGet {
    export type RequestParams = {
      /** Signature */
      signature: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Dialmaker {
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetMarketingCountDialmakerCampaignMarketingCountGet
   * @summary Get Marketing Count
   * @request GET:/dialmaker/campaign/marketing-count
   * @secure
   */
  export namespace GetMarketingCountDialmakerCampaignMarketingCountGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MarketingMailsSent[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CreateCampaignDialmakerCampaignPost
   * @summary Create Campaign
   * @request POST:/dialmaker/campaign
   * @secure
   */
  export namespace CreateCampaignDialmakerCampaignPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCampaignData;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name UpdateCampaignDialmakerCampaignCampaignIdPut
   * @summary Update Campaign
   * @request PUT:/dialmaker/campaign/{campaign_id}
   * @secure
   */
  export namespace UpdateCampaignDialmakerCampaignCampaignIdPut {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateCampaignData;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignDialmakerCampaignCampaignIdGet
   * @summary Get Campaign
   * @request GET:/dialmaker/campaign/{campaign_id}
   * @secure
   */
  export namespace GetCampaignDialmakerCampaignCampaignIdGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name UpdateCampaignAutoDialDialmakerCampaignCampaignIdAutoDialPut
   * @summary Update Campaign Auto Dial
   * @request PUT:/dialmaker/campaign/{campaign_id}/auto-dial
   * @secure
   */
  export namespace UpdateCampaignAutoDialDialmakerCampaignCampaignIdAutoDialPut {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {
      /** Auto Dial */
      auto_dial: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignSourceDialmakerCampaignCampaignIdDataSourceGet
   * @summary Get Campaign Source
   * @request GET:/dialmaker/campaign/{campaign_id}/data/source
   * @secure
   */
  export namespace GetCampaignSourceDialmakerCampaignCampaignIdDataSourceGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | SheetCampaignSourceOutput
      | BigQueryCampaignSource
      | ProcessCampaignSource;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet
   * @summary Get Campaign Extractions
   * @request GET:/dialmaker/campaign/{campaign_id}/extractions
   * @secure
   */
  export namespace GetCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageCampaignExtraction;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet
   * @summary Get Campaign Sheets
   * @request GET:/dialmaker/campaign/{campaign_id}/data/sheets
   * @secure
   */
  export namespace GetCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageSheet;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name DeactivateCampaignDialmakerCampaignDeactivatePost
   * @summary Deactivate Campaign
   * @request POST:/dialmaker/campaign/deactivate
   * @secure
   */
  export namespace DeactivateCampaignDialmakerCampaignDeactivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyDeactivateCampaignDialmakerCampaignDeactivatePost;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ActivateCampaignDialmakerCampaignActivatePost
   * @summary Activate Campaign
   * @request POST:/dialmaker/campaign/activate
   * @secure
   */
  export namespace ActivateCampaignDialmakerCampaignActivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyActivateCampaignDialmakerCampaignActivatePost;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ExtractCampaignsDialmakerCampaignExtractPost
   * @summary Extract Campaigns
   * @request POST:/dialmaker/campaign/extract
   * @secure
   */
  export namespace ExtractCampaignsDialmakerCampaignExtractPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyExtractCampaignsDialmakerCampaignExtractPost;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name DeleteExtractionDialmakerCampaignExtractionDelete
   * @summary Delete Extraction
   * @request DELETE:/dialmaker/campaign/extraction
   * @secure
   */
  export namespace DeleteExtractionDialmakerCampaignExtractionDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyDeleteExtractionDialmakerCampaignExtractionDelete;
    export type RequestHeaders = {};
    export type ResponseBody = NonEmptyString;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name FindCampaignsDialmakerCampaignFindPost
   * @summary Find Campaigns
   * @request POST:/dialmaker/campaign/find
   * @secure
   */
  export namespace FindCampaignsDialmakerCampaignFindPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = BodyFindCampaignsDialmakerCampaignFindPost;
    export type RequestHeaders = {};
    export type ResponseBody = PageCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetLeadsDialmakerCampaignLeadsCampaignIdGet
   * @summary Get Leads
   * @request GET:/dialmaker/campaign/leads/{campaign_id}
   * @secure
   */
  export namespace GetLeadsDialmakerCampaignLeadsCampaignIdGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageDMLead;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ImportLeadsDialmakerCampaignImportPost
   * @summary Import Leads
   * @request POST:/dialmaker/campaign/import
   * @secure
   */
  export namespace ImportLeadsDialmakerCampaignImportPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Synchronous
       * Import leads synchronously
       * @default false
       */
      synchronous?: boolean;
    };
    export type RequestBody = BodyImportLeadsDialmakerCampaignImportPost;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ModelsDialMaker2CampaignAggregateCampaign
      | string;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetJobStatusOrResultDialmakerCampaignJobStatusJobIdGet
   * @summary Get Job Status Or Result
   * @request GET:/dialmaker/campaign/job-status/{job_id}
   * @secure
   */
  export namespace GetJobStatusOrResultDialmakerCampaignJobStatusJobIdGet {
    export type RequestParams = {
      /**
       * Job Id
       * @format uuid
       */
      jobId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InterimLeadJob | InterimLead[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name UploadAttachmentDialmakerCampaignImageUploadPost
   * @summary Upload Attachment
   * @request POST:/dialmaker/campaign/image/upload
   * @secure
   */
  export namespace UploadAttachmentDialmakerCampaignImageUploadPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyUploadAttachmentDialmakerCampaignImageUploadPost;
    export type RequestHeaders = {};
    export type ResponseBody = NonEmptyString;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ExportAndExtractLeadsUrlDialmakerCampaignExportPost
   * @summary Export And Extract Leads Url
   * @request POST:/dialmaker/campaign/export
   * @secure
   */
  export namespace ExportAndExtractLeadsUrlDialmakerCampaignExportPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyExportAndExtractLeadsUrlDialmakerCampaignExportPost;
    export type RequestHeaders = {};
    export type ResponseBody = RoutersDialMaker2PayloadsSignedUrl;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost
   * @summary Export And Extract Leads Url Download
   * @request POST:/dialmaker/campaign/extraction/export
   * @secure
   */
  export namespace ExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost;
    export type RequestHeaders = {};
    export type ResponseBody = RoutersDialMaker2PayloadsSignedUrl;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost
   * @summary Get Ongoing Extractions
   * @request POST:/dialmaker/campaign/{campaign_id}/ongoing_extractions
   * @secure
   */
  export namespace GetOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CampaignOngoingExtraction[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOutcomesReportDialmakerCampaignSearchLeadsPost
   * @summary Get Outcomes Report
   * @request POST:/dialmaker/campaign/search-leads
   * @secure
   */
  export namespace GetOutcomesReportDialmakerCampaignSearchLeadsPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = SearchLeadsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = PageDMLead | null;
  }

  /**
   * @description This endpoint is used to get statistics: - Leads with 0 outcomes - Available leads to call - Already extracted count - Leads left to extract (cold campaigns only)
   * @tags Dial Maker 2
   * @name GetExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet
   * @summary Get Extractions Stats
   * @request GET:/dialmaker/campaign/{campaign_id}/extractions_stats
   * @secure
   */
  export namespace GetExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CampaignExtractionsStats;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignsByIdsDialmakerCampaignGetCampaignsByIdsPost
   * @summary Get Campaigns By Ids
   * @request POST:/dialmaker/campaign/get_campaigns_by_ids
   * @secure
   */
  export namespace GetCampaignsByIdsDialmakerCampaignGetCampaignsByIdsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = string[];
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SeedCampaignsDialmakerCampaignProcessSeedPost
   * @summary Seed Campaigns
   * @request POST:/dialmaker/campaign/process/seed
   * @secure
   */
  export namespace SeedCampaignsDialmakerCampaignProcessSeedPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, UpsertCampaignStatus>;
  }

  /**
   * @description Run one product's process-campaign producer now, instead of waiting for its cron. Renamed from `fetch_and_handle_insurances`: it is no longer insurance-only. Nothing calls the generated client method for this route, so the rename costs a line in the next schema regeneration and no caller. The credit-card branch is the only way to run that producer outside production, since its cron is `'dev': 'disabled'`. It respects the per-lane emit flags (`Config.CC_HANDLER_EMIT_LEADS` for the two offer-stage lanes, `Config.CC_DISBURSAL_EMIT_LEADS` for the disbursement chase), so a lane whose flag is off is a dark run that logs what it would escalate and creates nothing.
   * @tags Dial Maker 2
   * @name FetchAndHandleProcessCampaignDialmakerCampaignProcessFetchAndHandlePost
   * @summary Fetch And Handle Process Campaign
   * @request POST:/dialmaker/campaign/process/fetch_and_handle
   * @secure
   */
  export namespace FetchAndHandleProcessCampaignDialmakerCampaignProcessFetchAndHandlePost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
      product: ExtendedProduct;
      country: Country;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetMailStatisticsDialmakerCampaignMailStatisticsPost
   * @summary Get Mail Statistics
   * @request POST:/dialmaker/campaign/mail/statistics
   * @secure
   */
  export namespace GetMailStatisticsDialmakerCampaignMailStatisticsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyGetMailStatisticsDialmakerCampaignMailStatisticsPost;
    export type RequestHeaders = {};
    export type ResponseBody = CampaignMailStats[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetSmsStatisticsDialmakerCampaignSmsStatisticsPost
   * @summary Get Sms Statistics
   * @request POST:/dialmaker/campaign/sms/statistics
   * @secure
   */
  export namespace GetSmsStatisticsDialmakerCampaignSmsStatisticsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyGetSmsStatisticsDialmakerCampaignSmsStatisticsPost;
    export type RequestHeaders = {};
    export type ResponseBody = CampaignSmsStats[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name DryRunMailTemplateDialmakerCampaignCampaignIdMailTemplateSlugDryRunPost
   * @summary Dry Run Mail Template
   * @request POST:/dialmaker/campaign/{campaign_id}/mail/template/{slug}/dry-run
   * @secure
   */
  export namespace DryRunMailTemplateDialmakerCampaignCampaignIdMailTemplateSlugDryRunPost {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
      /** Slug */
      slug: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TemplateDryRunResult;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SendTestMailDialmakerCampaignMailSendTestPost
   * @summary Send Test Mail
   * @request POST:/dialmaker/campaign/mail/send_test
   * @secure
   */
  export namespace SendTestMailDialmakerCampaignMailSendTestPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TestTemplatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = SentMarketingEmailResponse[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetMailLeadsOverviewDialmakerCampaignCampaignIdMailLeadsGet
   * @summary Get Mail Leads Overview
   * @request GET:/dialmaker/campaign/{campaign_id}/mail/leads
   * @secure
   */
  export namespace GetMailLeadsOverviewDialmakerCampaignCampaignIdMailLeadsGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CampaignMailOverview;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CreateCampaignV2DialmakerCampaignV2Post
   * @summary Create Campaign V2
   * @request POST:/dialmaker/campaign/v2
   * @secure
   */
  export namespace CreateCampaignV2DialmakerCampaignV2Post {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateCampaignData;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name UpdateCampaignV2DialmakerCampaignV2CampaignIdPut
   * @summary Update Campaign V2
   * @request PUT:/dialmaker/campaign/v2/{campaign_id}
   * @secure
   */
  export namespace UpdateCampaignV2DialmakerCampaignV2CampaignIdPut {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateCampaignData;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name DeactivateCampaignV2DialmakerCampaignV2DeactivatePost
   * @summary Deactivate Campaign V2
   * @request POST:/dialmaker/campaign/v2/deactivate
   * @secure
   */
  export namespace DeactivateCampaignV2DialmakerCampaignV2DeactivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyDeactivateCampaignV2DialmakerCampaignV2DeactivatePost;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ActivateCampaignV2DialmakerCampaignV2ActivatePost
   * @summary Activate Campaign V2
   * @request POST:/dialmaker/campaign/v2/activate
   * @secure
   */
  export namespace ActivateCampaignV2DialmakerCampaignV2ActivatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyActivateCampaignV2DialmakerCampaignV2ActivatePost;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ExtractCampaignsV2DialmakerCampaignV2ExtractPost
   * @summary Extract Campaigns V2
   * @request POST:/dialmaker/campaign/v2/extract
   * @secure
   */
  export namespace ExtractCampaignsV2DialmakerCampaignV2ExtractPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyExtractCampaignsV2DialmakerCampaignV2ExtractPost;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name DeleteExtractionV2DialmakerCampaignV2ExtractionDelete
   * @summary Delete Extraction V2
   * @request DELETE:/dialmaker/campaign/v2/extraction
   * @secure
   */
  export namespace DeleteExtractionV2DialmakerCampaignV2ExtractionDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyDeleteExtractionV2DialmakerCampaignV2ExtractionDelete;
    export type RequestHeaders = {};
    export type ResponseBody = NonEmptyString;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCampaignV2DialmakerCampaignV2CampaignIdReaggregateGet
   * @summary Get Campaign V2
   * @request GET:/dialmaker/campaign/v2/{campaign_id}/reaggregate
   * @secure
   */
  export namespace GetCampaignV2DialmakerCampaignV2CampaignIdReaggregateGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetUserCampaignsDialmakerCampaignsGet
   * @summary Get User Campaigns
   * @request GET:/dialmaker/campaigns
   * @deprecated
   * @secure
   */
  export namespace GetUserCampaignsDialmakerCampaignsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UserCampaignsExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name AvailableCampaignsDialmakerCampaignsAvailablePost
   * @summary Available Campaigns
   * @request POST:/dialmaker/campaigns/available
   * @secure
   */
  export namespace AvailableCampaignsDialmakerCampaignsAvailablePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Available;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name JoinCampaignDialmakerCampaignsJoinPost
   * @summary Join Campaign
   * @request POST:/dialmaker/campaigns/join
   * @secure
   */
  export namespace JoinCampaignDialmakerCampaignsJoinPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyJoinCampaignDialmakerCampaignsJoinPost;
    export type RequestHeaders = {};
    export type ResponseBody = Available;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name LeaveCampaignDialmakerCampaignsLeavePost
   * @summary Leave Campaign
   * @request POST:/dialmaker/campaigns/leave
   * @secure
   */
  export namespace LeaveCampaignDialmakerCampaignsLeavePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyLeaveCampaignDialmakerCampaignsLeavePost;
    export type RequestHeaders = {};
    export type ResponseBody = Available;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name PlayCampaignDialmakerCampaignsPlayPost
   * @summary Play Campaign
   * @request POST:/dialmaker/campaigns/play
   * @secure
   */
  export namespace PlayCampaignDialmakerCampaignsPlayPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyPlayCampaignDialmakerCampaignsPlayPost;
    export type RequestHeaders = {};
    export type ResponseBody = Available;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name PauseCampaignDialmakerCampaignsPausePost
   * @summary Pause Campaign
   * @request POST:/dialmaker/campaigns/pause
   * @secure
   */
  export namespace PauseCampaignDialmakerCampaignsPausePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyPauseCampaignDialmakerCampaignsPausePost;
    export type RequestHeaders = {};
    export type ResponseBody = Available;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetCardDialmakerCardNextPost
   * @summary Get Card
   * @request POST:/dialmaker/card/next
   * @secure
   */
  export namespace GetCardDialmakerCardNextPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name ViewDialmakerCardViewPost
   * @summary View
   * @request POST:/dialmaker/card/view
   * @secure
   */
  export namespace ViewDialmakerCardViewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyViewDialmakerCardViewPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name UpdateDialmakerCardUpdatePost
   * @summary Update
   * @request POST:/dialmaker/card/update
   * @secure
   */
  export namespace UpdateDialmakerCardUpdatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyUpdateDialmakerCardUpdatePost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLead;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name HangupDialmakerCardHangupPost
   * @summary Hangup
   * @request POST:/dialmaker/card/hangup
   * @secure
   */
  export namespace HangupDialmakerCardHangupPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CallSuccessDialmakerCardOutcomeSuccessPost
   * @summary Call Success
   * @request POST:/dialmaker/card/outcome/success
   * @secure
   */
  export namespace CallSuccessDialmakerCardOutcomeSuccessPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallSuccessDialmakerCardOutcomeSuccessPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CallBackDialmakerCardOutcomeCallBackPost
   * @summary Call Back
   * @request POST:/dialmaker/card/outcome/call_back
   * @secure
   */
  export namespace CallBackDialmakerCardOutcomeCallBackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallBackDialmakerCardOutcomeCallBackPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CallBackDialmakerCardOutcomeLaterPost
   * @summary Call Back
   * @request POST:/dialmaker/card/outcome/later
   * @secure
   */
  export namespace CallBackDialmakerCardOutcomeLaterPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallBackDialmakerCardOutcomeLaterPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CallNoContactDialmakerCardOutcomeNoContactPost
   * @summary Call No Contact
   * @request POST:/dialmaker/card/outcome/no_contact
   * @secure
   */
  export namespace CallNoContactDialmakerCardOutcomeNoContactPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyCallNoContactDialmakerCardOutcomeNoContactPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CallDiscardsDialmakerCardOutcomeDiscardPost
   * @summary Call Discards
   * @request POST:/dialmaker/card/outcome/discard
   * @secure
   */
  export namespace CallDiscardsDialmakerCardOutcomeDiscardPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallDiscardsDialmakerCardOutcomeDiscardPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CallFailureDialmakerCardOutcomeFailurePost
   * @summary Call Failure
   * @request POST:/dialmaker/card/outcome/failure
   * @secure
   */
  export namespace CallFailureDialmakerCardOutcomeFailurePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCallFailureDialmakerCardOutcomeFailurePost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOutcomesDialmakerCardOutcomesPost
   * @summary Get Outcomes
   * @request POST:/dialmaker/card/outcomes
   * @secure
   */
  export namespace GetOutcomesDialmakerCardOutcomesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyGetOutcomesDialmakerCardOutcomesPost;
    export type RequestHeaders = {};
    export type ResponseBody = Outcomes;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SearchDialmakerCardSearchPost
   * @summary Search
   * @request POST:/dialmaker/card/search
   * @secure
   */
  export namespace SearchDialmakerCardSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySearchDialmakerCardSearchPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name LockDialmakerCardLockPost
   * @summary Lock
   * @request POST:/dialmaker/card/lock
   * @secure
   */
  export namespace LockDialmakerCardLockPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyLockDialmakerCardLockPost;
    export type RequestHeaders = {};
    export type ResponseBody = DMLead;
  }

  /**
   * @description "Lock to me" from the case view. No body back: this is open to every department, and the case-view stream carries the new row. Both refusals are 409, since either way the row the viewer pressed is out of date and the stream will bring the current one.
   * @tags Dial Maker 2
   * @name LockFromCaseViewDialmakerCardLockFromCaseViewPost
   * @summary Lock From Case View
   * @request POST:/dialmaker/card/lock-from-case-view
   * @secure
   */
  export namespace LockFromCaseViewDialmakerCardLockFromCaseViewPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyLockFromCaseViewDialmakerCardLockFromCaseViewPost;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name PersonalCallbacksDialmakerCardPersonalCallbacksPost
   * @summary Personal Callbacks
   * @request POST:/dialmaker/card/personal_callbacks
   * @secure
   */
  export namespace PersonalCallbacksDialmakerCardPersonalCallbacksPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DMLeadExt[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetSlotsDialmakerCardSlotsGet
   * @summary Get Slots
   * @request GET:/dialmaker/card/slots
   * @secure
   */
  export namespace GetSlotsDialmakerCardSlotsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Date
       * @format date-time
       */
      date: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BookableSlot[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetPreviousAppsDialmakerCardPreviousAppsPost
   * @summary Get Previous Apps
   * @request POST:/dialmaker/card/previous_apps
   * @secure
   */
  export namespace GetPreviousAppsDialmakerCardPreviousAppsPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Customer Id
       * @format uuid
       */
      customer_id: string;
      country: Country;
      /** Pni */
      pni?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PreviousApplicationsList;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name CustomerApplicationsDialmakerCardCustomerApplicationsPost
   * @summary Customer Applications
   * @request POST:/dialmaker/card/customer_applications
   * @secure
   */
  export namespace CustomerApplicationsDialmakerCardCustomerApplicationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyCustomerApplicationsDialmakerCardCustomerApplicationsPost;
    export type RequestHeaders = {};
    export type ResponseBody = TodoCustomerApplicationList;
  }

  /**
   * @description Get all insurances for a customer, sorted by creation date.
   * @tags Dial Maker 2
   * @name GetCustomerInsurancesDialmakerCardCustomerInsurancesPost
   * @summary Get Customer Insurances
   * @request POST:/dialmaker/card/customer_insurances
   * @secure
   */
  export namespace GetCustomerInsurancesDialmakerCardCustomerInsurancesPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Customer Id
       * @format uuid
       */
      customer_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Insurance[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name MineDialmakerCardOutcomesMineTodayPost
   * @summary Mine
   * @request POST:/dialmaker/card/outcomes/mine_today
   * @secure
   */
  export namespace MineDialmakerCardOutcomesMineTodayPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Start Date
       * @format date-time
       */
      start_date: string;
      /**
       * End Date
       * @format date-time
       */
      end_date: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = OutcomeCount;
  }

  /**
   * @description Upload file and return a preview of sheet, together with the file id needed to import leads. Uploaded file whether it's csv or xlsx should have headers in the first row to be able to map the columns to the lead data model.
   * @tags Dial Maker 2
   * @name UploadDialmakerSheetCampaignIdUploadWithPreviewPost
   * @summary Upload
   * @request POST:/dialmaker/sheet/{campaign_id}/upload_with_preview
   * @secure
   */
  export namespace UploadDialmakerSheetCampaignIdUploadWithPreviewPost {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      BodyUploadDialmakerSheetCampaignIdUploadWithPreviewPost;
    export type RequestHeaders = {};
    export type ResponseBody = SheetPreview;
  }

  /**
   * @description This endpoint is used to import leads from a file to a global leads collection with campaign_id and file_id metadata
   * @tags Dial Maker 2
   * @name ImportFromFileDialmakerSheetCampaignIdImportFromFileIdPost
   * @summary Import From File
   * @request POST:/dialmaker/sheet/{campaign_id}/import_from/{file_id}
   * @secure
   */
  export namespace ImportFromFileDialmakerSheetCampaignIdImportFromFileIdPost {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
      /**
       * File Id
       * @format uuid
       */
      fileId: string;
    };
    export type RequestQuery = {
      /**
       * Synchronous
       * Import leads synchronously
       * @default false
       */
      synchronous?: boolean;
    };
    export type RequestBody = Record<string, string>;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ModelsDialMaker2CampaignAggregateCampaign
      | string;
  }

  /**
   * @description This endpoint is used to delete a file from the database if it was not imported yet
   * @tags Dial Maker 2
   * @name DeleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete
   * @summary Delete Campaign Sheet
   * @request DELETE:/dialmaker/sheet/{campaign_id}/delete_file/{file_id}
   * @secure
   */
  export namespace DeleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
      /**
       * File Id
       * @format uuid
       */
      fileId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign | null;
  }

  /**
   * @description This endpoint is used to delete import of a given sheet_id with all interim leads
   * @tags Dial Maker 2
   * @name DeleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete
   * @summary Delete Interim Leads
   * @request DELETE:/dialmaker/sheet/{campaign_id}/import/{sheet_id}
   * @secure
   */
  export namespace DeleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
      /**
       * Sheet Id
       * @format uuid
       */
      sheetId: string;
    };
    export type RequestQuery = {
      /**
       * Force
       * Force delete import even if status is IN_PROGRESS
       * @default false
       */
      force?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ModelsDialMaker2CampaignAggregateCampaign | null;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetOutcomesDialmakerMiscOutcomesGet
   * @summary Get Outcomes
   * @request GET:/dialmaker/misc/outcomes
   * @secure
   */
  export namespace GetOutcomesDialmakerMiscOutcomesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Todomaker
       * @default false
       */
      todomaker?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Outcomes;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SaveOutcomesDialmakerMiscOutcomesPost
   * @summary Save Outcomes
   * @request POST:/dialmaker/misc/outcomes
   * @secure
   */
  export namespace SaveOutcomesDialmakerMiscOutcomesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySaveOutcomesDialmakerMiscOutcomesPost;
    export type RequestHeaders = {};
    export type ResponseBody = Outcomes;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name AdminDialmakerAdminOutcomesPost
   * @summary Admin
   * @request POST:/dialmaker/admin/outcomes
   * @secure
   */
  export namespace AdminDialmakerAdminOutcomesPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Start Date
       * @format date-time
       */
      start_date: string;
      /**
       * End Date
       * @format date-time
       */
      end_date: string;
    };
    export type RequestBody = BodyAdminDialmakerAdminOutcomesPost;
    export type RequestHeaders = {};
    export type ResponseBody = OutcomeCount;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name BlockFieldsDialmakerAdminBlockPost
   * @summary Block Fields
   * @request POST:/dialmaker/admin/block
   * @secure
   */
  export namespace BlockFieldsDialmakerAdminBlockPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BlockCustomerFieldManuallyPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BlockCustomerFieldManuallyResponse;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name StatsDialmakerAdminOutcomesUsersPost
   * @summary Stats
   * @request POST:/dialmaker/admin/outcomes/users
   * @secure
   */
  export namespace StatsDialmakerAdminOutcomesUsersPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyStatsDialmakerAdminOutcomesUsersPost;
    export type RequestHeaders = {};
    export type ResponseBody = OutcomeCount;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetMailTemplatesDialmakerMailTemplatesAvailableGet
   * @summary Get Mail Templates
   * @request GET:/dialmaker/mail/templates/available
   * @secure
   */
  export namespace GetMailTemplatesDialmakerMailTemplatesAvailableGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MandrillTemplate[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetVariablesTemplateVariablesDialmakerMailTemplateVariablesPost
   * @summary Get Variables Template Variables
   * @request POST:/dialmaker/mail/template/variables
   * @secure
   */
  export namespace GetVariablesTemplateVariablesDialmakerMailTemplateVariablesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyGetVariablesTemplateVariablesDialmakerMailTemplateVariablesPost;
    export type RequestHeaders = {};
    export type ResponseBody = TemplateVariables;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetAvailableTemplateVariablesDialmakerMailTemplateAvailableVariablesGet
   * @summary Get Available Template Variables
   * @request GET:/dialmaker/mail/template/available/variables
   * @secure
   */
  export namespace GetAvailableTemplateVariablesDialmakerMailTemplateAvailableVariablesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      country: Country;
      /** Is Prospect Campaign */
      is_prospect_campaign?: boolean | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name TemplateRenderDialmakerMailTemplateRenderPost
   * @summary Template Render
   * @request POST:/dialmaker/mail/template/render
   * @secure
   */
  export namespace TemplateRenderDialmakerMailTemplateRenderPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RenderTemplatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = NonEmptyString;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SmsTemplateRenderDialmakerSmsTemplateRenderPost
   * @summary Sms Template Render
   * @request POST:/dialmaker/sms/template/render
   * @secure
   */
  export namespace SmsTemplateRenderDialmakerSmsTemplateRenderPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SmsTemplateRenderPayload;
    export type RequestHeaders = {};
    export type ResponseBody = SmsTemplateRenderResponse;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SmsTemplateValidateDialmakerSmsTemplateValidatePost
   * @summary Sms Template Validate
   * @request POST:/dialmaker/sms/template/validate
   * @secure
   */
  export namespace SmsTemplateValidateDialmakerSmsTemplateValidatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SmsTemplateValidatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = SmsTemplateValidateResponse;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetAvailableSmsVariablesDialmakerSmsTemplateAvailableVariablesGet
   * @summary Get Available Sms Variables
   * @request GET:/dialmaker/sms/template/available/variables
   * @secure
   */
  export namespace GetAvailableSmsVariablesDialmakerSmsTemplateAvailableVariablesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      country: Country;
      /** Is Prospect Campaign */
      is_prospect_campaign?: boolean | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetSmsLinkVarsDialmakerSmsTemplateVarsCampaignIdGet
   * @summary Get Sms Link Vars
   * @request GET:/dialmaker/sms/template-vars/{campaign_id}
   * @secure
   */
  export namespace GetSmsLinkVarsDialmakerSmsTemplateVarsCampaignIdGet {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SmsCampaignTemplateVarsResponse;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SendTestSmsDialmakerSmsSendTestPost
   * @summary Send Test Sms
   * @request POST:/dialmaker/sms/send-test
   * @secure
   */
  export namespace SendTestSmsDialmakerSmsSendTestPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TestSmsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = TestSmsResponse;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name SendTestSmsFromCampaignDialmakerSmsSendTestCampaignPost
   * @summary Send Test Sms From Campaign
   * @request POST:/dialmaker/sms/send-test-campaign
   * @secure
   */
  export namespace SendTestSmsFromCampaignDialmakerSmsSendTestCampaignPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SmsCampaignTestPayload;
    export type RequestHeaders = {};
    export type ResponseBody = TestSmsResponse;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name GetSmsMarketingCountDialmakerSmsMarketingCountGet
   * @summary Get Sms Marketing Count
   * @request GET:/dialmaker/sms/marketing-count
   * @secure
   */
  export namespace GetSmsMarketingCountDialmakerSmsMarketingCountGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>[];
  }
}

export namespace UrlTracker {
  /**
   * No description
   * @tags URL Tracker
   * @name CreateUrlUrlTrackerUrlPost
   * @summary Create Url
   * @request POST:/url-tracker/url
   * @secure
   */
  export namespace CreateUrlUrlTrackerUrlPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyCreateUrlUrlTrackerUrlPost;
    export type RequestHeaders = {};
    export type ResponseBody = URL;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name UpdateUrlUrlTrackerUrlKeyPut
   * @summary Update Url
   * @request PUT:/url-tracker/{url_key}
   * @secure
   */
  export namespace UpdateUrlUrlTrackerUrlKeyPut {
    export type RequestParams = {
      /** Url Key */
      urlKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateURL;
    export type RequestHeaders = {};
    export type ResponseBody = URL;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name DeactivateUrlUrlTrackerUrlKeyDelete
   * @summary Deactivate Url
   * @request DELETE:/url-tracker/{url_key}
   * @secure
   */
  export namespace DeactivateUrlUrlTrackerUrlKeyDelete {
    export type RequestParams = {
      /** Url Key */
      urlKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = URL;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name CreateUtmTagsPresetUrlTrackerUtmTagsPresetPost
   * @summary Create Utm Tags Preset
   * @request POST:/url-tracker/utm-tags-preset
   * @secure
   */
  export namespace CreateUtmTagsPresetUrlTrackerUtmTagsPresetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyCreateUtmTagsPresetUrlTrackerUtmTagsPresetPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name GetUtmPresetsUrlTrackerUtmTagsPresetsGet
   * @summary Get Utm Presets
   * @request GET:/url-tracker/utm-tags-presets
   * @secure
   */
  export namespace GetUtmPresetsUrlTrackerUtmTagsPresetsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UtmTagsPreset[];
  }

  /**
   * No description
   * @tags URL Tracker
   * @name UpdateUtmTagsPresetUrlTrackerUtmTagsPresetPresetNamePut
   * @summary Update Utm Tags Preset
   * @request PUT:/url-tracker/utm-tags-preset/{preset_name}
   * @secure
   */
  export namespace UpdateUtmTagsPresetUrlTrackerUtmTagsPresetPresetNamePut {
    export type RequestParams = {
      /** Preset Name */
      presetName: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      BodyUpdateUtmTagsPresetUrlTrackerUtmTagsPresetPresetNamePut;
    export type RequestHeaders = {};
    export type ResponseBody = UtmTagsPreset;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name DeletePresetUtmTagsUrlTrackerUtmTagsPresetPresetNameDelete
   * @summary Delete Preset Utm Tags
   * @request DELETE:/url-tracker/utm-tags-preset/{preset_name}
   * @secure
   */
  export namespace DeletePresetUtmTagsUrlTrackerUtmTagsPresetPresetNameDelete {
    export type RequestParams = {
      /** Preset Name */
      presetName: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name GetAllUrlsUrlTrackerUrlsGet
   * @summary Get All Urls
   * @request GET:/url-tracker/urls
   * @secure
   */
  export namespace GetAllUrlsUrlTrackerUrlsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = URL[];
  }

  /**
   * No description
   * @tags URL Tracker
   * @name GetListOfUrlsUrlTrackerUrlListGet
   * @summary Get List Of Urls
   * @request GET:/url-tracker/url-list
   * @secure
   */
  export namespace GetListOfUrlsUrlTrackerUrlListGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Active */
      active: boolean;
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageURL;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name GetUrlInfoUrlTrackerUrlKeyInfoGet
   * @summary Get Url Info
   * @request GET:/url-tracker/{url_key}/info
   * @secure
   */
  export namespace GetUrlInfoUrlTrackerUrlKeyInfoGet {
    export type RequestParams = {
      /** Url Key */
      urlKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = URL;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name SearchUrlsUrlTrackerSearchGet
   * @summary Search Urls
   * @request GET:/url-tracker/search
   * @secure
   */
  export namespace SearchUrlsUrlTrackerSearchGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Keyword */
      keyword: string;
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageURL;
  }

  /**
   * No description
   * @tags URL Tracker
   * @name GetTrackingUrlUrlTrackerUrlKeyTrackingUrlCountryGet
   * @summary Get Tracking Url
   * @request GET:/url-tracker/{url_key}/tracking-url/{country}
   * @secure
   */
  export namespace GetTrackingUrlUrlTrackerUrlKeyTrackingUrlCountryGet {
    export type RequestParams = {
      /** Url Key */
      urlKey: string;
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NonEmptyString;
  }
}

export namespace Insurance {
  /**
   * No description
   * @tags Insurance
   * @name CreateInsuranceInsuranceInsurancePost
   * @summary Create Insurance
   * @request POST:/insurance/insurance
   * @secure
   */
  export namespace CreateInsuranceInsuranceInsurancePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateInsuranceCustomerV1;
    export type RequestHeaders = {};
    export type ResponseBody = Insurance;
  }
}

export namespace Leadtaker {
  /**
   * @description Upload file and return a preview of sheet, together with the file id needed to import leads. Uploaded file whether it's csv or xlsx should have headers in the first row to be able to map the columns to the lead data model.
   * @tags Lead Taker
   * @name UploadLeadtakerUploadCsvPost
   * @summary Upload
   * @request POST:/leadtaker/upload_csv
   * @secure
   */
  export namespace UploadLeadtakerUploadCsvPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyUploadLeadtakerUploadCsvPost;
    export type RequestHeaders = {};
    export type ResponseBody = SheetPreview;
  }

  /**
   * @description Get file preview from file id
   * @tags Lead Taker
   * @name FilePreviewLeadtakerFilePreviewPost
   * @summary File Preview
   * @request POST:/leadtaker/file_preview
   * @secure
   */
  export namespace FilePreviewLeadtakerFilePreviewPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * File Id
       * @format uuid
       */
      file_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SheetPreview;
  }

  /**
   * @description This endpoint is used to import leads from a file to a global leads collection with file_id metadata, consents country and valid_until are optional if not provided from mapping, if provided they will be used instead of the ones from mapping, globally for all prospects. If file_cost is provided, it will be used to calculate the cost of each prospect.
   * @tags Lead Taker
   * @name ImportFromFileLeadtakerImportFromFileIdPost
   * @summary Import From File
   * @request POST:/leadtaker/import_from/{file_id}
   * @secure
   */
  export namespace ImportFromFileLeadtakerImportFromFileIdPost {
    export type RequestParams = {
      /**
       * File Id
       * @format uuid
       */
      fileId: string;
    };
    export type RequestQuery = {
      /** File Cost */
      file_cost?: number | null;
      /** Country */
      country?: Country | null;
      /** Valid Until */
      valid_until?: string | null;
    };
    export type RequestBody = BodyImportFromFileLeadtakerImportFromFileIdPost;
    export type RequestHeaders = {};
    export type ResponseBody = ProspectsUpsertResponse;
  }

  /**
   * @description This endpoint is used to check the status of the import job
   * @tags Lead Taker
   * @name CheckIfCheckerEnqueuedLeadtakerImportStatusFileIdPost
   * @summary Check If Checker Enqueued
   * @request POST:/leadtaker/import_status/{file_id}
   * @secure
   */
  export namespace CheckIfCheckerEnqueuedLeadtakerImportStatusFileIdPost {
    export type RequestParams = {
      /**
       * File Id
       * @format uuid
       */
      fileId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Get all uploaded files, if imported is True, return only files which were imported if False, return only files which were not imported if None(default), return all files
   * @tags Lead Taker
   * @name GetFilesLeadtakerFilesGet
   * @summary Get Files
   * @request GET:/leadtaker/files
   * @secure
   */
  export namespace GetFilesLeadtakerFilesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Imported */
      imported?: boolean | null;
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageFileDetails;
  }

  /**
   * @description This endpoint is used to delete a file from the database if it was not imported yet
   * @tags Lead Taker
   * @name DeleteFileLeadtakerDeleteFileFileIdDelete
   * @summary Delete File
   * @request DELETE:/leadtaker/delete_file/{file_id}
   * @secure
   */
  export namespace DeleteFileLeadtakerDeleteFileFileIdDelete {
    export type RequestParams = {
      /**
       * File Id
       * @format uuid
       */
      fileId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Get all prospects from KDLT
   * @tags Lead Taker
   * @name ProspectsGetLeadtakerProspectsGet
   * @summary Prospects Get
   * @request GET:/leadtaker/prospects
   * @secure
   */
  export namespace ProspectsGetLeadtakerProspectsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Search String
       * @default ""
       */
      search_string?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Prospect[];
  }

  /**
   * @description Upsert single prospect to KDLT
   * @tags Lead Taker
   * @name ProspectsUpsertionLeadtakerProspectsPost
   * @summary Prospects Upsertion
   * @request POST:/leadtaker/prospects
   * @secure
   */
  export namespace ProspectsUpsertionLeadtakerProspectsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ProspectBase;
    export type RequestHeaders = {};
    export type ResponseBody = ProspectsUpsertResponse;
  }

  /**
   * @description Upsert single prospect to KDLT from online subscription source
   * @tags Lead Taker
   * @name ProspectsOnlineSubscriptionLeadtakerProspectsOnlineSubscriptionPost
   * @summary Prospects Online Subscription
   * @request POST:/leadtaker/prospects/online_subscription
   */
  export namespace ProspectsOnlineSubscriptionLeadtakerProspectsOnlineSubscriptionPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyProspectsOnlineSubscriptionLeadtakerProspectsOnlineSubscriptionPost;
    export type RequestHeaders = {
      /** Origin */
      origin?: string | null;
      /** X-Forwarded-For */
      "x-forwarded-for"?: string | null;
      /** User-Agent */
      "user-agent"?: string | null;
    };
    export type ResponseBody = any;
  }

  /**
   * @description Upsert prospects to KDLT from external source
   * @tags Lead Taker
   * @name ProspectsExternalSourceLeadtakerProspectsExternalSourcePost
   * @summary Prospects External Source
   * @request POST:/leadtaker/prospects/external_source
   */
  export namespace ProspectsExternalSourceLeadtakerProspectsExternalSourcePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ExternalSourcePayload;
    export type RequestHeaders = {
      /** Origin */
      origin?: string | null;
      /** X-Forwarded-For */
      "x-forwarded-for"?: string | null;
      /** User-Agent */
      "user-agent"?: string | null;
    };
    export type ResponseBody = ExternalSourceResponse;
  }
}

export namespace LogSaver {
  /**
   * No description
   * @tags Log Saver
   * @name MailmakerCampaignLogsLogSaverMailmakerCampaignIdPost
   * @summary Mailmaker Campaign Logs
   * @request POST:/log-saver/mailmaker/{campaign_id}
   * @secure
   */
  export namespace MailmakerCampaignLogsLogSaverMailmakerCampaignIdPost {
    export type RequestParams = {
      /**
       * Campaign Id
       * @format uuid
       */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = LogSaverPayload;
    export type RequestHeaders = {};
    export type ResponseBody = LogEntry[];
  }
}

export namespace Sse {
  /**
   * @description SSE endpoint to get applications based on query parameters. `handler_id` narrows today, next shift and all active to one handler. Without `sort_by` each list keeps its own order and `descending` is ignored.
   * @tags SSE
   * @name AdminSseEndpointSseAdminListPageTypeGet
   * @summary Admin Sse Endpoint
   * @request GET:/sse/admin/list/{page_type}
   * @secure
   */
  export namespace AdminSseEndpointSseAdminListPageTypeGet {
    export type RequestParams = {
      pageType: PageType;
    };
    export type RequestQuery = {
      /** Handler Id */
      handler_id?: string | null;
      /** Sort By */
      sort_by?: ListSortBy | null;
      /**
       * Descending
       * @default false
       */
      descending?: boolean;
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description SSE endpoint to get applications based on query parameters. Without `sort_by` each list keeps its own order and `descending` is ignored.
   * @tags SSE
   * @name SseEndpointSseListPageTypeGet
   * @summary Sse Endpoint
   * @request GET:/sse/list/{page_type}
   * @secure
   */
  export namespace SseEndpointSseListPageTypeGet {
    export type RequestParams = {
      pageType: PageType;
    };
    export type RequestQuery = {
      /** Sort By */
      sort_by?: ListSortBy | null;
      /**
       * Descending
       * @default false
       */
      descending?: boolean;
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Per-handler todomaker work-queue stream. Pushes the full TodoList on connect and on every `todomaker_changed_{user_id}` ping (claim/release/outcome/meeting). Open to every department: the pool is scoped by admin campaign assignment, so a handler with none assigned gets an empty queue plus their own callbacks and meetings. The shared pool is paged (`pool_page`, `pool_size`, `pool_campaign_id`); the client moves between pages by reconnecting with new parameters, and every re-snapshot on this connection serves the same page.
   * @tags SSE
   * @name TodomakerStreamSseTodomakerGet
   * @summary Todomaker Stream
   * @request GET:/sse/todomaker
   * @secure
   */
  export namespace TodomakerStreamSseTodomakerGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Pool Page
       * The page of the shared pool to send, 1-based.
       * @min 1
       * @default 1
       */
      pool_page?: number;
      /**
       * Pool Size
       * Pool leads per page.
       * @min 1
       * @max 350
       * @default 200
       */
      pool_size?: number;
      /**
       * Pool Campaign Id
       * Page only this campaign's pool. Ignored unless it is one of the caller's active campaigns.
       */
      pool_campaign_id?: string | null;
      /**
       * Pool Show All
       * Every open lead of the campaigns, whoever owns it, read-only. Team leads and developers only.
       * @default false
       */
      pool_show_all?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags SSE
   * @name LogEndpointSseLogGet
   * @summary Log Endpoint
   * @request GET:/sse/log
   * @secure
   */
  export namespace LogEndpointSseLogGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Manual States */
      manual_states?: ManualApplicationState[] | null;
      /** Sort By */
      sort_by?: ListSortBy | null;
      /**
       * Descending
       * @default false
       */
      descending?: boolean;
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Day-window SSE stream of the unified Customer Event Log (developer-only). The handler does ONLY the fast, side-effect-free, real-HTTP checks and returns the response immediately; scope resolution + the audited KDLT read + the fan-out run inside the SSE body (`_stream_customer_events`) so a slow dependency streams progress instead of hanging the handler into the 30s route timeout. The strict developer gate runs as a dependency, so a non-developer is rejected 403 BEFORE the body (no scope, no audit write). `customer_id: UUID` rejects a non-UUID id with 422 at the edge. A bounded window is REQUIRED (`since`+`until`, `since`<`until`, span <= 90 days) — a missing/inverted/oversized window 422s before any side effect. `lanes` (CSV) optionally narrows lanes; omitted = all. A customer-not-found / lookup timeout is an in-stream `error` message (the response is a 200 stream). No PII is logged (counts only).
   * @tags SSE
   * @name CustomerEventsStreamSseCustomerEventsCustomerIdGet
   * @summary Customer Events Stream
   * @request GET:/sse/customer-events/{customer_id}
   * @secure
   */
  export namespace CustomerEventsStreamSseCustomerEventsCustomerIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {
      /** Since */
      since?: string | null;
      /** Until */
      until?: string | null;
      /** Lanes */
      lanes?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Live SMS/email pings for the insurance page's messenger. An insurance has no application, so the case-view stream cannot serve it.
   * @tags SSE
   * @name InsuranceMessagesStreamSseInsuranceInsuranceIdGet
   * @summary Insurance Messages Stream
   * @request GET:/sse/insurance/{insurance_id}
   * @secure
   */
  export namespace InsuranceMessagesStreamSseInsuranceInsuranceIdGet {
    export type RequestParams = {
      /** Insurance Id */
      insuranceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags SSE
   * @name CaseViewSseCustomerIdApplicationIdGet
   * @summary Case View
   * @request GET:/sse/{customer_id}/{application_id}
   * @secure
   */
  export namespace CaseViewSseCustomerIdApplicationIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags SSE
   * @name CaseViewFinderSseFindCaseGet
   * @summary Case View Finder
   * @request GET:/sse/find-case
   * @secure
   */
  export namespace CaseViewFinderSseFindCaseGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Customer Id */
      customer_id?: string | null;
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      application_id?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags SSE
   * @name SearchSseSearchGet
   * @summary Search
   * @request GET:/sse/search
   * @secure
   */
  export namespace SearchSseSearchGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Search Str */
      search_str: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SearchResultItem[];
  }

  /**
   * @description Help endpoint to test the models
   * @tags SSE
   * @name HelpSseEventsGet
   * @summary Help
   * @request GET:/sse/events
   * @secure
   */
  export namespace HelpSseEventsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SSEEvent;
  }

  /**
   * @description Help endpoint to test the models
   * @tags SSE
   * @name ResponsesSseResponsesGet
   * @summary Responses
   * @request GET:/sse/responses
   * @secure
   */
  export namespace ResponsesSseResponsesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ApplicationResponse
      | InsuranceResponse
      | MeetingsResponse
      | PaginationResponse
      | MessageResponse
      | OutcomesResponse
      | CommentResponse
      | AMLResponse
      | CallsResponse
      | CustomerResponse
      | ApplicationsHistoryResponse
      | ApplicationSummaryResponse
      | ActiveUsersResponse
      | CoApplicantResponse
      | InsuranceRulesResponse
      | InsuranceListResponse
      | CoApplicantInsuranceRulesResponse
      | CoApplicantInsuranceListResponse
      | ZenscriptionResponse
      | BankIDVerifiedResponse
      | MessageSuggestionsResponse
      | ApplicationMapperResponse
      | MultipleApplicationMapperResponse
      | OPAMLResponse
      | ModelsSseModelsInviteZRayResponse
      | SkaImpactResponse
      | TodomakerLeadResponse
      | DialmakerLeadsResponse
      | FullApplicationsHistoryResponse
      | CustomerLoginsResponse
      | CoApplicantCustomerLoginsResponse
      | CaseDocumentsResponse
      | LeftToLiveEstimateChangedResponse
      | DisbursalDatesResponse;
  }
}

export namespace Sidebar {
  /**
   * No description
   * @tags Sidebar
   * @name SidebarCountsSidebarCountsGet
   * @summary Sidebar Counts
   * @request GET:/sidebar/counts
   * @secure
   */
  export namespace SidebarCountsSidebarCountsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SidebarCount;
  }

  /**
   * @description Clear a user's stuck sidebar refresh jobs; the next trigger enqueues a fresh one.
   * @tags Sidebar
   * @name RemoveSidebarRefreshJobsSidebarRefreshJobsUserIdDelete
   * @summary Remove Sidebar Refresh Jobs
   * @request DELETE:/sidebar/refresh-jobs/{user_id}
   * @secure
   */
  export namespace RemoveSidebarRefreshJobsSidebarRefreshJobsUserIdDelete {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, number>;
  }
}

export namespace Snippets {
  /**
   * No description
   * @tags Snippets
   * @name ListRenderedSnippetsSnippetsGet
   * @summary List Rendered Snippets
   * @request GET:/snippets/
   * @secure
   */
  export namespace ListRenderedSnippetsSnippetsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      country: Country;
      /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
      product: ExtendedProduct;
      context: SnippetContext;
      /** Customer Id */
      customer_id: string;
      /** Application Id */
      application_id?: string | null;
      /** Offer Id */
      offer_id?: string | null;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = RenderedSnippet[];
  }

  /**
   * No description
   * @tags Snippets
   * @name CreateSharedSnippetSnippetsPost
   * @summary Create Shared Snippet
   * @request POST:/snippets/
   * @secure
   */
  export namespace CreateSharedSnippetSnippetsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SnippetData;
    export type RequestHeaders = {};
    export type ResponseBody = Snippet;
  }

  /**
   * @description Offers on an application, for the composer's offer picker (`offer_id` on the render endpoint).
   * @tags Snippets
   * @name ListApplicationOffersSnippetsOffersGet
   * @summary List Application Offers
   * @request GET:/snippets/offers
   * @secure
   */
  export namespace ListApplicationOffersSnippetsOffersGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Application Id */
      application_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = (BlancoOfferApp | Offer)[];
  }

  /**
   * No description
   * @tags Snippets
   * @name ListSnippetsSnippetsManageGet
   * @summary List Snippets
   * @request GET:/snippets/manage
   * @secure
   */
  export namespace ListSnippetsSnippetsManageGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Country */
      country?: Country | null;
      /** Product */
      product?: ExtendedProduct | null;
      /** Context */
      context?: SnippetContext | null;
      /**
       * Include Deleted
       * @default false
       */
      include_deleted?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Snippet[];
  }

  /**
   * No description
   * @tags Snippets
   * @name UpdateSharedSnippetSnippetsSnippetIdPut
   * @summary Update Shared Snippet
   * @request PUT:/snippets/{snippet_id}
   * @secure
   */
  export namespace UpdateSharedSnippetSnippetsSnippetIdPut {
    export type RequestParams = {
      /**
       * Snippet Id
       * @format uuid
       */
      snippetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SnippetData;
    export type RequestHeaders = {};
    export type ResponseBody = Snippet;
  }

  /**
   * No description
   * @tags Snippets
   * @name DeleteSharedSnippetSnippetsSnippetIdDelete
   * @summary Delete Shared Snippet
   * @request DELETE:/snippets/{snippet_id}
   * @secure
   */
  export namespace DeleteSharedSnippetSnippetsSnippetIdDelete {
    export type RequestParams = {
      /**
       * Snippet Id
       * @format uuid
       */
      snippetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Snippets
   * @name RestoreSnippetSnippetsSnippetIdRestorePost
   * @summary Restore Snippet
   * @request POST:/snippets/{snippet_id}/restore
   * @secure
   */
  export namespace RestoreSnippetSnippetsSnippetIdRestorePost {
    export type RequestParams = {
      /**
       * Snippet Id
       * @format uuid
       */
      snippetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Snippet;
  }

  /**
   * No description
   * @tags Snippets
   * @name GetSnippetHistorySnippetsSnippetIdHistoryGet
   * @summary Get Snippet History
   * @request GET:/snippets/{snippet_id}/history
   * @secure
   */
  export namespace GetSnippetHistorySnippetsSnippetIdHistoryGet {
    export type RequestParams = {
      /**
       * Snippet Id
       * @format uuid
       */
      snippetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SnippetEvent[];
  }

  /**
   * No description
   * @tags Snippets
   * @name ListSnippetCategoriesSnippetsCategoriesGet
   * @summary List Snippet Categories
   * @request GET:/snippets/categories
   * @secure
   */
  export namespace ListSnippetCategoriesSnippetsCategoriesGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Include Deleted
       * @default false
       */
      include_deleted?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SnippetCategory[];
  }

  /**
   * No description
   * @tags Snippets
   * @name CreateSnippetCategorySnippetsCategoriesPost
   * @summary Create Snippet Category
   * @request POST:/snippets/categories
   * @secure
   */
  export namespace CreateSnippetCategorySnippetsCategoriesPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SnippetCategoryData;
    export type RequestHeaders = {};
    export type ResponseBody = SnippetCategory;
  }

  /**
   * No description
   * @tags Snippets
   * @name UpdateSnippetCategorySnippetsCategoriesCategoryIdPut
   * @summary Update Snippet Category
   * @request PUT:/snippets/categories/{category_id}
   * @secure
   */
  export namespace UpdateSnippetCategorySnippetsCategoriesCategoryIdPut {
    export type RequestParams = {
      /**
       * Category Id
       * @format uuid
       */
      categoryId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SnippetCategoryData;
    export type RequestHeaders = {};
    export type ResponseBody = SnippetCategory;
  }

  /**
   * No description
   * @tags Snippets
   * @name DeleteSnippetCategorySnippetsCategoriesCategoryIdDelete
   * @summary Delete Snippet Category
   * @request DELETE:/snippets/categories/{category_id}
   * @secure
   */
  export namespace DeleteSnippetCategorySnippetsCategoriesCategoryIdDelete {
    export type RequestParams = {
      /**
       * Category Id
       * @format uuid
       */
      categoryId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Zenscriber {
  /**
   * No description
   * @tags Zenscriber
   * @name GetCustomerZenscriptionsZenscriberGet
   * @summary Get Customer Zenscriptions
   * @request GET:/zenscriber/
   * @secure
   */
  export namespace GetCustomerZenscriptionsZenscriberGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Customer Id
       * @format uuid
       */
      customer_id: string;
      /** Newer Than */
      newer_than?: string | null;
      /**
       * Limit
       * @default 2
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Zenscription[];
  }

  /**
   * No description
   * @tags Zenscriber
   * @name GetCustomerContextEndpointZenscriberCustomerContextPost
   * @summary Get Customer Context Endpoint
   * @request POST:/zenscriber/customer-context
   * @secure
   */
  export namespace GetCustomerContextEndpointZenscriberCustomerContextPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RoutersZenscriberSupportRouterPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerContextSlim;
  }
}

export namespace Compliance {
  /**
   * No description
   * @tags Compliance
   * @name GetComplianceQueueComplianceQueueGet
   * @summary Get Compliance Queue
   * @request GET:/compliance/queue
   * @secure
   */
  export namespace GetComplianceQueueComplianceQueueGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Country */
      country?: string | null;
      /** Severity */
      severity?: string | null;
      /**
       * To Review
       * @default false
       */
      to_review?: boolean;
      /**
       * Limit
       * @default 50
       */
      limit?: number;
      /**
       * Skip
       * @default 0
       */
      skip?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ComplianceQueuePage;
  }

  /**
   * No description
   * @tags Compliance
   * @name GetComplianceCallComplianceCallsRecordedCallKeyGet
   * @summary Get Compliance Call
   * @request GET:/compliance/calls/{recorded_call_key}
   * @secure
   */
  export namespace GetComplianceCallComplianceCallsRecordedCallKeyGet {
    export type RequestParams = {
      /** Recorded Call Key */
      recordedCallKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ZenscriptionWithCompliance;
  }

  /**
   * No description
   * @tags Compliance
   * @name GetCustomerComplianceCallsComplianceByCustomerCustomerIdGet
   * @summary Get Customer Compliance Calls
   * @request GET:/compliance/by-customer/{customer_id}
   * @secure
   */
  export namespace GetCustomerComplianceCallsComplianceByCustomerCustomerIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerCompliancePage;
  }

  /**
   * No description
   * @tags Compliance
   * @name ReviewComplianceFlagComplianceCallsRecordedCallKeyReviewPost
   * @summary Review Compliance Flag
   * @request POST:/compliance/calls/{recorded_call_key}/review
   * @secure
   */
  export namespace ReviewComplianceFlagComplianceCallsRecordedCallKeyReviewPost {
    export type RequestParams = {
      /** Recorded Call Key */
      recordedCallKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ComplianceReviewPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ComplianceReviewDecision;
  }

  /**
   * No description
   * @tags Compliance
   * @name ReportManualFlagComplianceCallsRecordedCallKeyManualFlagPost
   * @summary Report Manual Flag
   * @request POST:/compliance/calls/{recorded_call_key}/manual-flag
   * @secure
   */
  export namespace ReportManualFlagComplianceCallsRecordedCallKeyManualFlagPost {
    export type RequestParams = {
      /** Recorded Call Key */
      recordedCallKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ComplianceManualFlagPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ComplianceManualFlag;
  }

  /**
   * @description The call's transcript in English, line by line with the original, translated on first request and stored.
   * @tags Compliance
   * @name TranslateComplianceTranscriptComplianceCallsRecordedCallKeyTranslationPost
   * @summary Translate Compliance Transcript
   * @request POST:/compliance/calls/{recorded_call_key}/translation
   * @secure
   */
  export namespace TranslateComplianceTranscriptComplianceCallsRecordedCallKeyTranslationPost {
    export type RequestParams = {
      /** Recorded Call Key */
      recordedCallKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = TranscriptTranslation;
  }
}

export namespace Op {
  /**
   * No description
   * @tags Occupational pension
   * @name ListApplicationsOpApplicationsGet
   * @summary List Applications
   * @request GET:/op/applications
   * @secure
   */
  export namespace ListApplicationsOpApplicationsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Status */
      status?: OPStatus | null;
      /** Date From */
      date_from?: string | null;
      /** Date To */
      date_to?: string | null;
      /**
       * Page
       * @min 1
       * @default 1
       */
      page?: number;
      /**
       * Size
       * @min 1
       * @max 100000
       * @default 50
       */
      size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PageOPApplicationListItem;
  }

  /**
   * No description
   * @tags Occupational pension
   * @name CreateOpApplicationOpCreatePost
   * @summary Create Op Application
   * @request POST:/op/create
   * @secure
   */
  export namespace CreateOpApplicationOpCreatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OccupationalPensionCreate;
    export type RequestHeaders = {};
    export type ResponseBody = OccupationalPensionResponse;
  }

  /**
   * No description
   * @tags Occupational pension
   * @name DeactivateApplicationOpDeactivateLabelPost
   * @summary Deactivate Application
   * @request POST:/op/deactivate/{label}
   * @secure
   */
  export namespace DeactivateApplicationOpDeactivateLabelPost {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = BodyDeactivateApplicationOpDeactivateLabelPost;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Occupational pension
   * @name SendSmsOpSmsPoaLabelPost
   * @summary Send Sms
   * @request POST:/op/sms/poa/{label}
   * @secure
   */
  export namespace SendSmsOpSmsPoaLabelPost {
    export type RequestParams = {
      /**
       * Label
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      label: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Occupational pension
   * @name RegisterOpRegisterPost
   * @summary Register
   * @request POST:/op/register
   */
  export namespace RegisterOpRegisterPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyRegisterOpRegisterPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description SFB doesn't have a staging environment for occupational pension registrations, so we create a simulator endpoint to test the registration flow. It simply returns back the form data received. So it's displayed in the browser for verification.
   * @tags Occupational pension, Simulator
   * @name SimulateSfbRegistrationOpSimulatorPost
   * @summary Simulate Sfb Registration
   * @request POST:/op/simulator
   */
  export namespace SimulateSfbRegistrationOpSimulatorPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
}

export namespace Push {
  /**
   * No description
   * @tags Push Subscriptions
   * @name SubscribePushSubscribePost
   * @summary Subscribe
   * @request POST:/push/subscribe
   * @secure
   */
  export namespace SubscribePushSubscribePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SubscribePayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Push Subscriptions
   * @name UnsubscribePushUnsubscribeDelete
   * @summary Unsubscribe
   * @request DELETE:/push/unsubscribe
   * @secure
   */
  export namespace UnsubscribePushUnsubscribeDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UnsubscribePayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Push Subscriptions
   * @name VapidPublicKeyPushVapidPublicKeyGet
   * @summary Vapid Public Key
   * @request GET:/push/vapid-public-key
   * @secure
   */
  export namespace VapidPublicKeyPushVapidPublicKeyGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = VapidPublicKeyResponse;
  }
}

export namespace EmailCustomers {
  /**
   * @description List emails for a customer, optionally filtered by thread, application, or status. By default returns lightweight summaries without body content for performance. Pass include_body=true to receive EmailDetail[] with full (decrypted) body content.
   * @tags Email Customers
   * @name ListEmailsEmailCustomersListPost
   * @summary List Emails
   * @request POST:/email-customers/list
   * @secure
   */
  export namespace ListEmailsEmailCustomersListPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ListEmailsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = EmailSummary[] | EmailDetail[];
  }

  /**
   * @description Send an outbound email to a customer via Mandrill. Stores the sent email in email_customers_content with encryption. If thread_id is provided, adds to existing thread; otherwise creates a new one.
   * @tags Email Customers
   * @name SendEmailEmailCustomersSendPost
   * @summary Send Email
   * @request POST:/email-customers/send
   * @secure
   */
  export namespace SendEmailEmailCustomersSendPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SendEmailPayload;
    export type RequestHeaders = {};
    export type ResponseBody = SendEmailResponse;
  }

  /**
   * @description Upload an attachment ahead of email send. The returned attachment_id can be passed to POST /send via the attachment_ids field. Records auto-expire after 24 hours if not consumed.
   * @tags Email Customers
   * @name UploadAttachmentEmailCustomersAttachmentsUploadPost
   * @summary Upload Attachment
   * @request POST:/email-customers/attachments/upload
   * @secure
   */
  export namespace UploadAttachmentEmailCustomersAttachmentsUploadPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      BodyUploadAttachmentEmailCustomersAttachmentsUploadPost;
    export type RequestHeaders = {};
    export type ResponseBody = UploadAttachmentResponse;
  }

  /**
   * @description Download an email attachment by attachment_id. If redirect=true, returns a 302 redirect to a presigned S3 URL (more efficient for large files). Otherwise proxies the binary content through the API.
   * @tags Email Customers
   * @name DownloadAttachmentEmailCustomersAttachmentsAttachmentIdGet
   * @summary Download Attachment
   * @request GET:/email-customers/attachments/{attachment_id}
   * @secure
   */
  export namespace DownloadAttachmentEmailCustomersAttachmentsAttachmentIdGet {
    export type RequestParams = {
      /** Attachment Id */
      attachmentId: string;
    };
    export type RequestQuery = {
      /**
       * Redirect
       * @default false
       */
      redirect?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Get full email content by email_id. Automatically marks the email as read by the requesting agent (first reader wins — read_at and agent_id are only set once and subsequent reads do not overwrite them).
   * @tags Email Customers
   * @name GetEmailEmailCustomersEmailIdGet
   * @summary Get Email
   * @request GET:/email-customers/{email_id}
   * @secure
   */
  export namespace GetEmailEmailCustomersEmailIdGet {
    export type RequestParams = {
      /** Email Id */
      emailId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EmailDetail;
  }

  /**
   * @description Explicitly mark an email as read by the current agent.
   * @tags Email Customers
   * @name MarkReadEmailCustomersMarkReadPost
   * @summary Mark Read
   * @request POST:/email-customers/mark-read
   * @secure
   */
  export namespace MarkReadEmailCustomersMarkReadPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MarkEmailReadPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description List email threads for a customer's inbox view. Returns thread summaries sorted by most recent activity.
   * @tags Email Customers
   * @name ListThreadsEmailCustomersThreadsPost
   * @summary List Threads
   * @request POST:/email-customers/threads
   * @secure
   */
  export namespace ListThreadsEmailCustomersThreadsPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Customer Id */
      customer_id: string;
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 1
       * @max 50
       * @default 20
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ThreadSummary[];
  }

  /**
   * @description Handle Mandrill inbound email webhook for customer email integration. Receives inbound emails from Mandrill, matches the sender to a customer via KDLT email lookup, and stores the email in the email_customers_content collection. All raw webhook payloads are also stored in inbound_emails for audit. Mandrill may retry delivery, so we use a unique index on event_id to ensure idempotency.
   * @tags Email Customers
   * @name EmailCustomersInboundEmailCustomersWebhookInboundPost
   * @summary Email Customers Inbound
   * @request POST:/email-customers/webhook/inbound
   */
  export namespace EmailCustomersInboundEmailCustomersWebhookInboundPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace CaseDocuments {
  /**
   * @description The documents of the case's applicant and co-applicant that are not deleted, newest first, from any of their MONO applications: `application_id` on each is the application it came from.
   * @tags Case Documents
   * @name ListCaseDocumentsCaseDocumentsApplicationIdGet
   * @summary List Case Documents
   * @request GET:/case-documents/{application_id}
   * @secure
   */
  export namespace ListCaseDocumentsCaseDocumentsApplicationIdGet {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CaseDocument[];
  }

  /**
   * @description Upload a file of `customer_id` with the MONO case as its origin. `customer_id` must be the applicant or co-applicant (422). At most 20 MB (413, also for a larger Content-Length, before the body is read; 411 without one); PDF, JPEG, PNG, HEIC, DOCX or XLSX by extension and content (415).
   * @tags Case Documents
   * @name UploadCaseDocumentCaseDocumentsApplicationIdPost
   * @summary Upload Case Document
   * @request POST:/case-documents/{application_id}
   * @secure
   */
  export namespace UploadCaseDocumentCaseDocumentsApplicationIdPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      BodyUploadCaseDocumentCaseDocumentsApplicationIdPost;
    export type RequestHeaders = {};
    export type ResponseBody = CaseDocument;
  }

  /**
   * @description Save a copy of an attachment of a customer email as a document of `customer_id`, with the MONO case as its origin. The email must be on the case or from one of its applicants (403). Saving it again for the same customer, on this or another of their applications, returns the same document; a deleted one comes back with no bank shares. Inline images and attachments sent from a case document get 422; the file rules of an upload apply (413, 415).
   * @tags Case Documents
   * @name SaveEmailAttachmentCaseDocumentsApplicationIdFromEmailPost
   * @summary Save Email Attachment
   * @request POST:/case-documents/{application_id}/from-email
   * @secure
   */
  export namespace SaveEmailAttachmentCaseDocumentsApplicationIdFromEmailPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = SaveEmailAttachmentRequest;
    export type RequestHeaders = {};
    export type ResponseBody = CaseDocument;
  }

  /**
   * @description The file, always as a download with its stored type.
   * @tags Case Documents
   * @name GetCaseDocumentContentCaseDocumentsApplicationIdDocumentIdContentGet
   * @summary Get Case Document Content
   * @request GET:/case-documents/{application_id}/{document_id}/content
   * @secure
   */
  export namespace GetCaseDocumentContentCaseDocumentsApplicationIdDocumentIdContentGet {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
      /** Document Id */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Attach the document to an outgoing email without copying the file: send the returned `attachment_id` in `attachment_ids` of `POST /email-customers/send`, as for an uploaded attachment. Only the same agent can send it. 404 for a deleted document or one of another customer.
   * @tags Case Documents
   * @name AttachCaseDocumentToEmailCaseDocumentsApplicationIdDocumentIdEmailAttachmentPost
   * @summary Attach Case Document To Email
   * @request POST:/case-documents/{application_id}/{document_id}/email-attachment
   * @secure
   */
  export namespace AttachCaseDocumentToEmailCaseDocumentsApplicationIdDocumentIdEmailAttachmentPost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
      /** Document Id */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UploadAttachmentResponse;
  }

  /**
   * @description Soft delete: the document is gone for its customer, on every case and in the bank portal; the file stays in storage.
   * @tags Case Documents
   * @name DeleteCaseDocumentCaseDocumentsApplicationIdDocumentIdDelete
   * @summary Delete Case Document
   * @request DELETE:/case-documents/{application_id}/{document_id}
   * @secure
   */
  export namespace DeleteCaseDocumentCaseDocumentsApplicationIdDocumentIdDelete {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
      /** Document Id */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Share documents of the case's applicants with a bank on this application; the bank reads them in the NO bank portal on this application only, and its portal users get a mail with a link when the call shares at least one document. Only for applications created in ZRM and banks that got the application (422); 404, and nothing shared, when a document is not of an applicant or is deleted. Sharing again on this application keeps one share and sends no mail.
   * @tags Case Documents
   * @name ShareCaseDocumentsCaseDocumentsApplicationIdSharePost
   * @summary Share Case Documents
   * @request POST:/case-documents/{application_id}/share
   * @secure
   */
  export namespace ShareCaseDocumentsCaseDocumentsApplicationIdSharePost {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ShareDocumentsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = ShareDocumentsResult;
  }

  /**
   * @description The bank no longer sees the document in the portal on this application.
   * @tags Case Documents
   * @name UnshareCaseDocumentCaseDocumentsApplicationIdShareBankIdDocumentIdDelete
   * @summary Unshare Case Document
   * @request DELETE:/case-documents/{application_id}/share/{bank_id}/{document_id}
   * @secure
   */
  export namespace UnshareCaseDocumentCaseDocumentsApplicationIdShareBankIdDocumentIdDelete {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
      /** Bank Id */
      bankId: number;
      /** Document Id */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace LeftToLive {
  /**
   * @description Zensum's own estimate of what the household has left to live on per month, computed from the case as it is now. A state of the case not recorded last is recorded. 503 when apps-mgr or KDLT does not answer.
   * @tags LeftToLive
   * @name GetLeftToLiveEstimateLeftToLiveApplicationIdGet
   * @summary Get Left To Live Estimate
   * @request GET:/left-to-live/{application_id}
   * @secure
   */
  export namespace GetLeftToLiveEstimateLeftToLiveApplicationIdGet {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = LeftToLiveEstimateResponse;
  }

  /**
   * @description Change the household or an override line of the application's estimate; returns the estimate with it. A field left out stays, null resets it to its seed from the case (the main applicant's `cars_in_the_household` for the car). An override on housing or existing loans is 422: they are corrected on the case.
   * @tags LeftToLive
   * @name UpdateLeftToLiveHouseholdLeftToLiveApplicationIdHouseholdPatch
   * @summary Update Left To Live Household
   * @request PATCH:/left-to-live/{application_id}/household
   * @secure
   */
  export namespace UpdateLeftToLiveHouseholdLeftToLiveApplicationIdHouseholdPatch {
    export type RequestParams = {
      /**
       * Application Id
       * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
       */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = LeftToLiveEstimateHouseholdPatch;
    export type RequestHeaders = {};
    export type ResponseBody = LeftToLiveEstimateResponse;
  }
}

export namespace Elk46 {
  /**
   * @description Returns the last 100 simulated SMS ordered by newest first.
   * @tags Simulator
   * @name ListSimulatedSmsElk46SimulatorGet
   * @summary List Simulated Sms
   * @request GET:/elk46/simulator
   * @secure
   */
  export namespace ListSimulatedSmsElk46SimulatorGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>[];
  }

  /**
   * @description Accepts the same form payload as 46elks and stores it in the database. Useful for testing and development without sending real SMS. Returns the created document with an assigned ID and status.
   * @tags Simulator
   * @name SimulateSmsElk46SimulatorPost
   * @summary Simulate Sms
   * @request POST:/elk46/simulator
   * @secure
   */
  export namespace SimulateSmsElk46SimulatorPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySimulateSmsElk46SimulatorPost;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
}

export namespace Bank {
  /**
   * No description
   * @tags Bank Login
   * @name LoginBankLoginPost
   * @summary Login
   * @request POST:/bank/login
   */
  export namespace LoginBankLoginPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Login;
    export type RequestHeaders = {};
    export type ResponseBody = LoginResp;
  }

  /**
   * No description
   * @tags Bank Login
   * @name ValidateOtpCodeBankLoginValidatePost
   * @summary Validate Otp Code
   * @request POST:/bank/login/validate
   */
  export namespace ValidateOtpCodeBankLoginValidatePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = OTPValidation;
    export type RequestHeaders = {};
    export type ResponseBody = OTPValidationResp;
  }

  /**
   * No description
   * @tags Bank Login
   * @name SetNewPasswordBankSetPasswordPost
   * @summary Set New Password
   * @request POST:/bank/set-password
   */
  export namespace SetNewPasswordBankSetPasswordPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetPassword;
    export type RequestHeaders = {};
    export type ResponseBody = SetPasswordResp;
  }

  /**
   * No description
   * @tags Bank Login
   * @name RequestNewOtpBankNewOtpPost
   * @summary Request New Otp
   * @request POST:/bank/new-otp
   */
  export namespace RequestNewOtpBankNewOtpPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RequestNewOTP;
    export type RequestHeaders = {};
    export type ResponseBody = SetPasswordResp;
  }

  /**
   * No description
   * @tags Bank User Administration
   * @name CreateNewBankUserBankCreateUserPost
   * @summary Create New Bank User
   * @request POST:/bank/create-user
   * @secure
   */
  export namespace CreateNewBankUserBankCreateUserPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateUser;
    export type RequestHeaders = {};
    export type ResponseBody = CreateUserResp;
  }

  /**
   * No description
   * @tags Bank User Administration
   * @name GetBankUsersBankGetPost
   * @summary Get Bank Users
   * @request POST:/bank/get
   * @secure
   */
  export namespace GetBankUsersBankGetPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetUsersPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankUserWithBankNames[];
  }

  /**
   * No description
   * @tags Bank User Administration
   * @name GetBankUserBankUserIdGet
   * @summary Get Bank User
   * @request GET:/bank/{user_id}
   * @secure
   */
  export namespace GetBankUserBankUserIdGet {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankUserWithBankNames;
  }

  /**
   * No description
   * @tags Bank User Administration
   * @name EditBankUserBankUserIdPut
   * @summary Edit Bank User
   * @request PUT:/bank/{user_id}
   * @secure
   */
  export namespace EditBankUserBankUserIdPut {
    export type RequestParams = {
      /** User Id */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = EditUser;
    export type RequestHeaders = {};
    export type ResponseBody = BankUserWithBankNames;
  }

  /**
   * No description
   * @tags Bank User Administration
   * @name ResetBankUserPasswordBankResetPasswordPost
   * @summary Reset Bank User Password
   * @request POST:/bank/reset-password
   * @secure
   */
  export namespace ResetBankUserPasswordBankResetPasswordPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResetPasswordPayload;
    export type RequestHeaders = {};
    export type ResponseBody = CreateUserResp;
  }

  /**
   * No description
   * @tags Bank User Administration
   * @name DeactivateBankUserBankDeactivatePut
   * @summary Deactivate Bank User
   * @request PUT:/bank/deactivate
   * @secure
   */
  export namespace DeactivateBankUserBankDeactivatePut {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeactivateUserPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Bank
   * @name GetApplicationsBankApplicationsPost
   * @summary Get Applications
   * @request POST:/bank/applications
   * @secure
   */
  export namespace GetApplicationsBankApplicationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetApplications;
    export type RequestHeaders = {};
    export type ResponseBody = BankBaseApp[];
  }

  /**
   * No description
   * @tags Bank
   * @name GetApplicationBankApplicationApplicationIdGet
   * @summary Get Application
   * @request GET:/bank/application/{application_id}
   * @secure
   */
  export namespace GetApplicationBankApplicationApplicationIdGet {
    export type RequestParams = {
      /** Application Id */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankBaseApp;
  }

  /**
   * No description
   * @tags Bank
   * @name GetDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet
   * @summary Get Document Meta
   * @request GET:/bank/document/meta/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid4
       */
      customerId: string;
      /**
       * Document Id
       * @format uuid
       */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DocumentMeta;
  }

  /**
   * No description
   * @tags Bank
   * @name GetDocumentBankGetCustomerIdDocumentIdGet
   * @summary Get Document
   * @request GET:/bank/get/{customer_id}/{document_id}
   * @secure
   */
  export namespace GetDocumentBankGetCustomerIdDocumentIdGet {
    export type RequestParams = {
      /**
       * Customer Id
       * @format uuid
       */
      customerId: string;
      /**
       * Document Id
       * @format uuid
       */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CustomerDocument;
  }

  /**
   * No description
   * @tags Bank
   * @name GetAllBanksBankGetBanksPost
   * @summary Get All Banks
   * @request POST:/bank/get-banks
   * @secure
   */
  export namespace GetAllBanksBankGetBanksPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetBanksPayload;
    export type RequestHeaders = {};
    export type ResponseBody = Bank[];
  }

  /**
   * No description
   * @tags Bank
   * @name GetAppEventsBankGetAppEventsApplicationIdGet
   * @summary Get App Events
   * @request GET:/bank/get_app_events/{application_id}
   * @secure
   */
  export namespace GetAppEventsBankGetAppEventsApplicationIdGet {
    export type RequestParams = {
      /** Application Id */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }

  /**
   * No description
   * @tags Bank
   * @name AddCommentBankCommentPost
   * @summary Add Comment
   * @request POST:/bank/comment
   * @secure
   */
  export namespace AddCommentBankCommentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommentInput;
    export type RequestHeaders = {};
    export type ResponseBody = EventsResponse;
  }

  /**
   * No description
   * @tags Bank
   * @name AddCommentV2BankV2CommentPost
   * @summary Add Comment V2
   * @request POST:/bank/v2/comment
   * @secure
   */
  export namespace AddCommentV2BankV2CommentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommentV2;
    export type RequestHeaders = {};
    export type ResponseBody = Response;
  }

  /**
   * No description
   * @tags Bank
   * @name PostOfferBankOfferPost
   * @summary Post Offer
   * @request POST:/bank/offer
   * @secure
   */
  export namespace PostOfferBankOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankOfferPayload;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Bank, Application
   * @name RejectBankRejectPost
   * @summary Reject
   * @request POST:/bank/reject
   * @secure
   */
  export namespace RejectBankRejectPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankRejectPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Bank, Application
   * @name DisburseBankDisbursePost
   * @summary Disburse
   * @request POST:/bank/disburse
   * @secure
   */
  export namespace DisburseBankDisbursePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankDisbursePayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Bank
   * @name SearchApplicationsBankSearchPost
   * @summary Search Applications
   * @request POST:/bank/search
   * @secure
   */
  export namespace SearchApplicationsBankSearchPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * Limit
       * @min 0
       * @max 50
       * @default 50
       */
      limit?: number;
    };
    export type RequestBody = RoutersBankPayloadsSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankBaseApp[];
  }

  /**
   * No description
   * @tags Bank
   * @name GetApplicationsV2BankV2ApplicationsPost
   * @summary Get Applications V2
   * @request POST:/bank/v2/applications
   * @secure
   */
  export namespace GetApplicationsV2BankV2ApplicationsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyGetApplicationsV2BankV2ApplicationsPost;
    export type RequestHeaders = {};
    export type ResponseBody =
      PageAnnotatedUnionBankBlancoApplicationBankMortgageApplicationBankApplicationCCNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorProduct;
  }

  /**
   * No description
   * @tags Bank
   * @name GetApplicationV2BankV2ApplicationApplicationIdGet
   * @summary Get Application V2
   * @request GET:/bank/v2/application/{application_id}
   * @secure
   */
  export namespace GetApplicationV2BankV2ApplicationApplicationIdGet {
    export type RequestParams = {
      /** Application Id */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ({
          product: "blanco";
        } & BankBlancoApplication)
      | ({
          product: "mortgage";
        } & BankMortgageApplication)
      | ({
          product: "credit_card";
        } & BankApplicationCCNO);
  }

  /**
   * @description The documents that Zensum shared with the caller's bank on a MONO application, newest first.
   * @tags Bank
   * @name ListCaseDocumentsForBankBankV2ApplicationApplicationIdDocumentsGet
   * @summary List Case Documents For Bank
   * @request GET:/bank/v2/application/{application_id}/documents
   * @secure
   */
  export namespace ListCaseDocumentsForBankBankV2ApplicationApplicationIdDocumentsGet {
    export type RequestParams = {
      /** Application Id */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCaseDocument[];
  }

  /**
   * @description Upload a file to a MONO application. It is shared with the caller's bank on this application only, and the case's handler is notified. At most 20 MB (413, also for a larger Content-Length, before the body is read; 411 without one); PDF, JPEG, PNG, HEIC, DOCX or XLSX by extension and content (415).
   * @tags Bank
   * @name UploadCaseDocumentForBankBankV2ApplicationApplicationIdDocumentsPost
   * @summary Upload Case Document For Bank
   * @request POST:/bank/v2/application/{application_id}/documents
   * @secure
   */
  export namespace UploadCaseDocumentForBankBankV2ApplicationApplicationIdDocumentsPost {
    export type RequestParams = {
      /** Application Id */
      applicationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      BodyUploadCaseDocumentForBankBankV2ApplicationApplicationIdDocumentsPost;
    export type RequestHeaders = {};
    export type ResponseBody = BankCaseDocument;
  }

  /**
   * @description The file, always as a download with its stored type. 404 unless it is shared with the caller's bank on this application.
   * @tags Bank
   * @name GetCaseDocumentContentForBankBankV2ApplicationApplicationIdDocumentsDocumentIdContentGet
   * @summary Get Case Document Content For Bank
   * @request GET:/bank/v2/application/{application_id}/documents/{document_id}/content
   * @secure
   */
  export namespace GetCaseDocumentContentForBankBankV2ApplicationApplicationIdDocumentsDocumentIdContentGet {
    export type RequestParams = {
      /** Application Id */
      applicationId: string;
      /** Document Id */
      documentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Find applications by the encoded id the portal shows, or by the applicant's PNI. Access is not decided here: every candidate is read back through the same bank-scoped apps-mgr call the details page uses, which 404s for an application the bank is not on.
   * @tags Bank
   * @name SearchApplicationsV2BankV2SearchPost
   * @summary Search Applications V2
   * @request POST:/bank/v2/search
   * @secure
   */
  export namespace SearchApplicationsV2BankV2SearchPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RoutersBankPayloadsSearchPayload;
    export type RequestHeaders = {};
    export type ResponseBody = (
      | ({
          product: "blanco";
        } & BankBlancoApplication)
      | ({
          product: "mortgage";
        } & BankMortgageApplication)
      | ({
          product: "credit_card";
        } & BankApplicationCCNO)
    )[];
  }
}

export namespace Bankv2 {
  /**
   * No description
   * @tags Bank, Application
   * @name RejectV2Bankv2RejectPost
   * @summary Reject V2
   * @request POST:/bankv2/reject
   * @secure
   */
  export namespace RejectV2Bankv2RejectPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RejectionPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Bank, Application
   * @name DisburseV2Bankv2DisbursePost
   * @summary Disburse V2
   * @request POST:/bankv2/disburse
   * @secure
   */
  export namespace DisburseV2Bankv2DisbursePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DisbursementPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Bank, Application
   * @name AddOfferV2Bankv2AddOfferPost
   * @summary Add Offer V2
   * @request POST:/bankv2/add-offer
   * @secure
   */
  export namespace AddOfferV2Bankv2AddOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AddOfferPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Jotform {
  /**
   * No description
   * @tags Jotform
   * @name SubmissionJotformWebhookFormIdPost
   * @summary Submission
   * @request POST:/jotform/webhook/{form_id}
   */
  export namespace SubmissionJotformWebhookFormIdPost {
    export type RequestParams = {
      /** Form Id */
      formId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = BodySubmissionJotformWebhookFormIdPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Campaign {
  /**
   * No description
   * @tags Affiliate
   * @name CreateCampaignInitializedEventCampaignCampaignIdGet
   * @summary Create Campaign Initialized Event
   * @request GET:/campaign/{campaign_id}
   */
  export namespace CreateCampaignInitializedEventCampaignCampaignIdGet {
    export type RequestParams = {
      /** Campaign Id */
      campaignId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Visit {
  /**
   * No description
   * @tags Affiliate
   * @name CreateVisitEventVisitCountryZidPost
   * @summary Create Visit Event
   * @request POST:/visit/{country}/{zid}
   */
  export namespace CreateVisitEventVisitCountryZidPost {
    export type RequestParams = {
      country: Country;
      /** Zid */
      zid: string;
    };
    export type RequestQuery = {};
    export type RequestBody = WebsiteVisitPayload;
    export type RequestHeaders = {
      /** X-S-Zid */
      "x-s-zid"?: string | null;
      /** X-Gid */
      "x-gid"?: string | null;
      /** X-Forwarded-For */
      "X-Forwarded-For"?: string | null;
    };
    export type ResponseBody = any;
  }
}

export namespace V2 {
  /**
   * No description
   * @tags Affiliate
   * @name CreateWebsiteVisitEventV2VisitCountryPost
   * @summary Create Website Visit Event
   * @request POST:/v2/visit/{country}
   */
  export namespace CreateWebsiteVisitEventV2VisitCountryPost {
    export type RequestParams = {
      country: Country;
    };
    export type RequestQuery = {};
    export type RequestBody = WebsiteVisitPayload;
    export type RequestHeaders = {
      /** X-Forwarded-For */
      "X-Forwarded-For"?: string | null;
    };
    export type ResponseBody = any;
  }
}

export namespace Simulator {
  /**
   * @description Upload test lead data for campaign extraction simulation.
   * @tags Simulator
   * @name UploadLeadsSimulatorBqLeadsPost
   * @summary Upload Leads
   * @request POST:/simulator/bq/leads
   */
  export namespace UploadLeadsSimulatorBqLeadsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UploadLeadsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }

  /**
   * @description List stored simulated leads.
   * @tags Simulator
   * @name ListLeadsSimulatorBqLeadsGet
   * @summary List Leads
   * @request GET:/simulator/bq/leads
   */
  export namespace ListLeadsSimulatorBqLeadsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Dataset
       * @default "simulator"
       */
      dataset?: string;
      /**
       * Limit
       * @max 500
       * @default 50
       */
      limit?: number;
      /**
       * Page
       * @min 0
       * @default 0
       */
      page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any>[];
  }

  /**
   * @description Clear all simulated leads in a dataset.
   * @tags Simulator
   * @name ClearLeadsSimulatorBqLeadsDelete
   * @summary Clear Leads
   * @request DELETE:/simulator/bq/leads
   */
  export namespace ClearLeadsSimulatorBqLeadsDelete {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Dataset
       * @default "simulator"
       */
      dataset?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, string>;
  }

  /**
   * @description Count leads in a dataset.
   * @tags Simulator
   * @name CountLeadsSimulatorBqLeadsCountGet
   * @summary Count Leads
   * @request GET:/simulator/bq/leads/count
   */
  export namespace CountLeadsSimulatorBqLeadsCountGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Dataset
       * @default "simulator"
       */
      dataset?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
}

export namespace Slack {
  /**
   * No description
   * @tags Slack
   * @name SlackCallbackSlackCallbackPost
   * @summary Slack Callback
   * @request POST:/slack/callback
   */
  export namespace SlackCallbackSlackCallbackPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodySlackCallbackSlackCallbackPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Slack Events API receiver for the internal support bot. Must ack within ~3s, so it only does cheap synchronous work: verify the request signature, answer the url_verification challenge, drop ineligible messages, dedupe retries, and enqueue eligible messages for the RQ worker that runs the Claude tool-loop.
   * @tags Slack
   * @name SlackEventsSlackEventsPost
   * @summary Slack Events
   * @request POST:/slack/events
   */
  export namespace SlackEventsSlackEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace DialMaker2 {
  /**
   * No description
   * @tags Dial Maker 2
   * @name GetImageDialMaker2ImageGet
   * @summary Get Image
   * @request GET:/dial-maker2/image
   */
  export namespace GetImageDialMaker2ImageGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** File Id */
      file_id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Dial Maker 2
   * @name DownloadLeadsXlsxDialMaker2ExportDownloadSignatureGet
   * @summary Download Leads Xlsx
   * @request GET:/dial-maker2/export/download/{signature}
   */
  export namespace DownloadLeadsXlsxDialMaker2ExportDownloadSignatureGet {
    export type RequestParams = {
      /** Signature */
      signature: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace WellKnown {
  /**
   * No description
   * @tags Well known
   * @name GetJwksWellKnownJwksJsonGet
   * @summary Get Jwks
   * @request GET:/.well-known/jwks.json
   */
  export namespace GetJwksWellKnownJwksJsonGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BankCommunicationData;
  }
}

export namespace Health {
  /**
   * No description
   * @tags Health
   * @name GetHealthHealthGet
   * @summary Get Health
   * @request GET:/health
   */
  export namespace GetHealthHealthGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Validator {
  /**
   * No description
   * @tags Validator
   * @name ValidateValidatorPost
   * @summary Validate
   * @request POST:/validator/
   */
  export namespace ValidateValidatorPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      | Email
      | PNI
      | ModelsValidatorServicePayloadPhoneNumber
      | BankAccount;
    export type RequestHeaders = {};
    export type ResponseBody = ValidatorServiceResponseModel;
  }

  /**
   * No description
   * @tags Validator
   * @name ValidateValidatorPost2
   * @summary Validate
   * @request POST:/validator
   * @originalName validateValidatorPost
   * @duplicate
   */
  export namespace ValidateValidatorPost2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      | Email
      | PNI
      | ModelsValidatorServicePayloadPhoneNumber
      | BankAccount;
    export type RequestHeaders = {};
    export type ResponseBody = ValidatorServiceResponseModel;
  }

  /**
   * No description
   * @tags Validator
   * @name ValidateSafelyValidatorSafePost
   * @summary Validate Safely
   * @request POST:/validator/safe/
   */
  export namespace ValidateSafelyValidatorSafePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {};
    export type ResponseBody = ValidatorServiceResponseModel;
  }

  /**
   * No description
   * @tags Validator
   * @name ValidateSafelyValidatorSafePost2
   * @summary Validate Safely
   * @request POST:/validator/safe
   * @originalName validateSafelyValidatorSafePost
   * @duplicate
   */
  export namespace ValidateSafelyValidatorSafePost2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {};
    export type ResponseBody = ValidatorServiceResponseModel;
  }
}

export namespace Mandrill {
  /**
   * No description
   * @tags Mail Webhook
   * @name MessageOpenedMandrillWebhookMessagePost
   * @summary Message Opened
   * @request POST:/mandrill/webhook/message
   */
  export namespace MessageOpenedMandrillWebhookMessagePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Mail Webhook
   * @name UnsubscribeMandrillWebhookUnsubscribePost
   * @summary Unsubscribe
   * @request POST:/mandrill/webhook/unsubscribe
   */
  export namespace UnsubscribeMandrillWebhookUnsubscribePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Handle Mandrill inbound email webhook and forward emails. This endpoint receives inbound emails from Mandrill, routes them based on the from_email, appends a datetime to the subject, and forwards them with all attachments included. Later on this can be used to attach customer context to the forwarded emails. But also, to route to a specific handler. All the incoming emails are stored in the 'inbound_emails' collection in MongoDB for future reference. This endpoint process all incoming emails at *@systems.zensum.se. Which are mostly emails generated from 3rd party systems like Telavox voicemails.
   * @tags Mail Webhook
   * @name InboundEmailMandrillWebhookInboundPost
   * @summary Inbound Email
   * @request POST:/mandrill/webhook/inbound
   */
  export namespace InboundEmailMandrillWebhookInboundPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Mail {
  /**
   * No description
   * @tags MailMaker
   * @name UnsubscribeFromMailMarketingMailPublicUnsubscribePost
   * @summary Unsubscribe From Mail Marketing
   * @request POST:/mail/public/unsubscribe
   */
  export namespace UnsubscribeFromMailMarketingMailPublicUnsubscribePost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Mail Key */
      mail_key: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags MailMaker
   * @name UnsubscribeFromSmsMarketingMailPublicUnsubscribeSmsPost
   * @summary Unsubscribe From Sms Marketing
   * @request POST:/mail/public/unsubscribe-sms
   */
  export namespace UnsubscribeFromSmsMarketingMailPublicUnsubscribeSmsPost {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Sms Key */
      sms_key: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace P {
  /**
   * No description
   * @tags URL Tracker
   * @name ForwardToTargetUrlPUrlKeyPathGet
   * @summary Forward To Target Url
   * @request GET:/p/{url_key}/{path}
   */
  export namespace ForwardToTargetUrlPUrlKeyPathGet {
    export type RequestParams = {
      /** Url Key */
      urlKey: string;
      /** Path */
      path: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace T {
  /**
   * No description
   * @tags Transactional URL Tracker
   * @name RedirectToTargetUrlTFullPathGet
   * @summary Redirect To Target Url
   * @request GET:/t/{full_path}
   */
  export namespace RedirectToTargetUrlTFullPathGet {
    export type RequestParams = {
      /** Full Path */
      fullPath: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace U {
  /**
   * No description
   * @tags Unsubscribe marketing
   * @name UnsubscribeEmailUMessageTrackingKeyPost
   * @summary Unsubscribe Email
   * @request POST:/u/{message_tracking_key}
   */
  export namespace UnsubscribeEmailUMessageTrackingKeyPost {
    export type RequestParams = {
      /** Message Tracking Key */
      messageTrackingKey: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace FormAnalytics {
  /**
   * No description
   * @tags Online
   * @name StoreEventsFormAnalyticsStoreEventsPost
   * @summary Store Events
   * @request POST:/form-analytics/store-events
   */
  export namespace StoreEventsFormAnalyticsStoreEventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyStoreEventsFormAnalyticsStoreEventsPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace FormAbandoned {
  /**
   * No description
   * @tags Online
   * @name StoreFormFormAbandonedPost
   * @summary Store Form
   * @request POST:/form-abandoned/
   */
  export namespace StoreFormFormAbandonedPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BodyStoreFormFormAbandonedPost;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags Online
   * @name RestoreFormFormAbandonedRestoreFillingIdGet
   * @summary Restore Form
   * @request GET:/form-abandoned/restore/{filling_id}
   */
  export namespace RestoreFormFormAbandonedRestoreFillingIdGet {
    export type RequestParams = {
      /**
       * Filling Id
       * @format uuid
       */
      fillingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, any> | null;
  }

  /**
   * @description Since the data is not validated when incoming, as fields are optional. We need fallbacks in place for customers to always end up on a marketing page, not a 500 error.
   * @tags Online
   * @name RedirectToProperFormFormAbandonedFillingIdGet
   * @summary Redirect To Proper Form
   * @request GET:/form-abandoned/{filling_id}
   */
  export namespace RedirectToProperFormFormAbandonedFillingIdGet {
    export type RequestParams = {
      /**
       * Filling Id
       * @format uuid
       */
      fillingId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Infra {
  /**
   * No description
   * @tags Other
   * @name Auth0EventsProxyInfraAuth0EventsPost
   * @summary Auth0 Events Proxy
   * @request POST:/infra/auth0/events
   * @secure
   */
  export namespace Auth0EventsProxyInfraAuth0EventsPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = Record<string, any>[];
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Callmaker {
  /**
   * No description
   * @tags Callmaker Callbacks
   * @name GetCallmakerDataCallmakerCallbackCallPost
   * @summary Get Callmaker Data
   * @request POST:/callmaker/callback/call
   * @secure
   */
  export namespace GetCallmakerDataCallmakerCallbackCallPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Callmaker Callbacks
   * @name GetProcessedDataCallmakerCallbackProcessPost
   * @summary Get Processed Data
   * @request POST:/callmaker/callback/process
   * @secure
   */
  export namespace GetProcessedDataCallmakerCallbackProcessPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BankCommunicationData;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace V1 {
  /**
   * No description
   * @tags V1 Affiliate API
   * @name CreateBlancoApplicationV1AffiliateApplicationsBlancoPost
   * @summary Create Blanco Application
   * @request POST:/v1/affiliate/applications/blanco
   * @secure
   */
  export namespace CreateBlancoApplicationV1AffiliateApplicationsBlancoPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AffiliateCreateBlancoApplication;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateResponse;
  }

  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetBookingsBlancoV1AffiliateBookingsBlancoGet
   * @summary Get Bookings Blanco
   * @request GET:/v1/affiliate/bookings/blanco
   * @secure
   */
  export namespace GetBookingsBlancoV1AffiliateBookingsBlancoGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Start Date
       * @format date
       */
      start_date: string;
      /**
       * End Date
       * @format date
       */
      end_date: string;
      country: Country;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailableBookings;
  }

  /**
   * No description
   * @tags V1 Affiliate API
   * @name CreateMortgageLeadV1AffiliateLeadsMortgagePost
   * @summary Create Mortgage Lead
   * @request POST:/v1/affiliate/leads/mortgage
   * @secure
   */
  export namespace CreateMortgageLeadV1AffiliateLeadsMortgagePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AffiliateLeadCreationPayload;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateResponse;
  }

  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetBookingsMortgageV1AffiliateBookingsMortgageGet
   * @summary Get Bookings Mortgage
   * @request GET:/v1/affiliate/bookings/mortgage
   * @secure
   */
  export namespace GetBookingsMortgageV1AffiliateBookingsMortgageGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Start Date
       * @format date
       */
      start_date: string;
      /**
       * End Date
       * @format date
       */
      end_date: string;
      country: Country;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AvailableBookings;
  }

  /**
   * @description Returns all allowed enum values
   * @tags V1 Affiliate API
   * @name GetOptionsV1AffiliateOptionsCountryProductGet
   * @summary Get Options
   * @request GET:/v1/affiliate/options/{country}/{product}
   * @secure
   */
  export namespace GetOptionsV1AffiliateOptionsCountryProductGet {
    export type RequestParams = {
      country: Country;
      product: Product;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateOptionsResponse;
  }

  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet
   * @summary Get Blanco Status
   * @request GET:/v1/affiliate/applications/blanco/{submission_id}
   * @secure
   */
  export namespace GetBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet {
    export type RequestParams = {
      /**
       * Submission Id
       * @format uuid
       */
      submissionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateCallback;
  }

  /**
   * No description
   * @tags V1 Affiliate API
   * @name GetMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet
   * @summary Get Mortgage Status
   * @request GET:/v1/affiliate/leads/mortgage/{submission_id}
   * @secure
   */
  export namespace GetMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet {
    export type RequestParams = {
      /**
       * Submission Id
       * @format uuid
       */
      submissionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AffiliateCallback;
  }
}

export namespace LateRejection {
  /**
   * No description
   * @tags Late Rejection
   * @name IncomingLateRejectionLateRejectionIncomingPost
   * @summary Incoming Late Rejection
   * @request POST:/late-rejection/incoming
   * @secure
   */
  export namespace IncomingLateRejectionLateRejectionIncomingPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = LateRejectionPayload;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }
}

export namespace Zhatter {
  /**
   * @description Send a Zhatter message and receive a streaming SSE response.
   * @tags Zhatter
   * @name SendMessageZhatterMessagePost
   * @summary Send Message
   * @request POST:/zhatter/message
   * @secure
   */
  export namespace SendMessageZhatterMessagePost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ZhatterMessageRequest;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * @description Grant Gjeldsregisteret consent for the current customer.
   * @tags Zhatter
   * @name GrantGrConsentZhatterGrConsentPost
   * @summary Grant Gr Consent
   * @request POST:/zhatter/gr-consent
   * @secure
   */
  export namespace GrantGrConsentZhatterGrConsentPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GrConsentRequest;
    export type RequestHeaders = {};
    export type ResponseBody = GrConsentResponse;
  }

  /**
   * @description Accept a loan offer on behalf of the authenticated customer.
   * @tags Zhatter
   * @name AcceptOfferZhatterAcceptOfferPost
   * @summary Accept Offer
   * @request POST:/zhatter/accept-offer
   * @secure
   */
  export namespace AcceptOfferZhatterAcceptOfferPost {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AcceptOfferRequest;
    export type RequestHeaders = {};
    export type ResponseBody = AcceptOfferResponse;
  }

  /**
   * @description List the customer's recent chat sessions.
   * @tags Zhatter
   * @name ListSessionsZhatterSessionsGet
   * @summary List Sessions
   * @request GET:/zhatter/sessions
   * @secure
   */
  export namespace ListSessionsZhatterSessionsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SessionSummary[];
  }

  /**
   * @description Return the session's chat turns — the bubbles the UI renders, nothing else. `messages` holds the whole model conversation, so it is projected through `session_store.renderable_chat_records` first: tool replies and developer-role UI-action facts are model input and must never leave the backend.
   * @tags Zhatter
   * @name GetSessionMessagesZhatterSessionsSessionIdMessagesGet
   * @summary Get Session Messages
   * @request GET:/zhatter/sessions/{session_id}/messages
   * @secure
   */
  export namespace GetSessionMessagesZhatterSessionsSessionIdMessagesGet {
    export type RequestParams = {
      /** Session Id */
      sessionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StoredMessage[];
  }

  /**
   * @description Help endpoint to list available SSE events.
   * @tags Zhatter
   * @name EventsZhatterEventsGet
   * @summary Events
   * @request GET:/zhatter/events
   * @secure
   */
  export namespace EventsZhatterEventsGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ZhatterSSEEvent;
  }

  /**
   * @description Schema endpoint — exposes SSE response types in OpenAPI spec.
   * @tags Zhatter
   * @name ResponsesZhatterResponsesGet
   * @summary Responses
   * @request GET:/zhatter/responses
   * @secure
   */
  export namespace ResponsesZhatterResponsesGet {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      | ZhatterSessionResponse
      | ZhatterTokenResponse
      | ZhatterToolCallResponse
      | ZhatterToolResultResponse
      | ZhatterActionResponse
      | ZhatterDoneResponse
      | ZhatterErrorResponse;
  }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends globalThis.Response {
  data: D;
  error: E;
  requestId: string;
}

export interface HttpErrorResponse<E> extends globalThis.Response {
  error: E;
  requestId: string;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "include",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  private generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 =
      (typeof performance !== "undefined" &&
        performance.now &&
        performance.now() * 1000) ||
      0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = ((d + r) % 16) | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = ((d2 + r) % 16) | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      },
    );
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    // We need to generate new RequestID for every request
    let requestId = requestParams.headers["X-Request-ID"];
    if (!requestId) {
      requestId = this.generateUUID();
      requestParams.headers["X-Request-ID"] = requestId;
    }

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
          ...(requestParams.headers || {}),
        },
        signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;
      r.requestId = requestId;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data as HttpErrorResponse<E>;
      return data;
    });
  };
}

/**
 * @title The ZRM
 * @version 1.0.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  application = {
    /**
     * No description
     *
     * @tags Application
     * @name QuickCreateApplicationApplicationQuickCreatePost
     * @summary Quick Create Application
     * @request POST:/application/quick-create
     * @secure
     */
    quickCreateApplicationApplicationQuickCreatePost: (
      data:
        | ({
            product: "mortgage";
          } & QuickCreateMortgageApplication)
        | ({
            product: "blanco";
          } & QuickCreateBlancoApplication),
      query?: {
        /**
         * Legacy
         * @default true
         */
        legacy?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApplicationCreatedResponse, HTTPValidationError>({
        path: `/application/quick-create`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name CreateApplicationApplicationCreatePost
     * @summary Create Application
     * @request POST:/application/create
     * @secure
     */
    createApplicationApplicationCreatePost: (
      data: CreateApplicationPayloadExt,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationCreatedResponseExt, HTTPValidationError>({
        path: `/application/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name UpdateApplicationApplicationUpdateApplicationIdPost
     * @summary Update Application
     * @request POST:/application/update/{application_id}
     * @secure
     */
    updateApplicationApplicationUpdateApplicationIdPost: (
      applicationId: string,
      data: UpdateApplicationPayloadExt,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationWithNamesInComments, HTTPValidationError>({
        path: `/application/update/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationApplicationGetPost
     * @summary Get Application
     * @request POST:/application/get
     * @secure
     */
    getApplicationApplicationGetPost: (
      data: GetApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationWithNamesInComments, HTTPValidationError>({
        path: `/application/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationsApplicationGetsPost
     * @summary Get Applications
     * @request POST:/application/gets
     * @deprecated
     * @secure
     */
    getApplicationsApplicationGetsPost: (
      data: GetApplicationsByCustomerIdentifierPayload,
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/gets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationsV2ApplicationV2GetsPost
     * @summary Get Applications V2
     * @request POST:/application/v2/gets
     * @secure
     */
    getApplicationsV2ApplicationV2GetsPost: (
      data: GetApplicationsByCustomerIdentifierPayloadV2,
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/v2/gets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetApplicationsAssignedToMeApplicationGetMinePost
     * @summary Get Applications Assigned To Me
     * @request POST:/application/get/mine
     * @secure
     */
    getApplicationsAssignedToMeApplicationGetMinePost: (
      data: GetMyApplicationsPayload,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/get/mine`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetRecentApplicationsApplicationGetRecentPost
     * @summary Get Recent Applications
     * @request POST:/application/get/recent
     * @secure
     */
    getRecentApplicationsApplicationGetRecentPost: (
      data: GetRecentApplicationsPayload,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/get/recent`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name SearchApplicationsApplicationSearchPost
     * @summary Search Applications
     * @request POST:/application/search
     * @secure
     */
    searchApplicationsApplicationSearchPost: (
      data: RoutersApplicationApplicationPayloadSearchPayload,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Application[], HTTPValidationError>({
        path: `/application/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name SearchApplications2ApplicationSearch2Post
     * @summary Search Applications2
     * @request POST:/application/search2
     * @secure
     */
    searchApplications2ApplicationSearch2Post: (
      data: RoutersApplicationApplicationPayloadSearchPayload,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppsSearchResult, HTTPValidationError>({
        path: `/application/search2`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Duplicate an application. Works for every product apps-mgr serves, not just MOSE: this used to post to the legacy /v1/duplicate, which routed MOSE to the compat layer and everything else to a Flask handler that only ever understood mortgages. Returns apps-mgr's own response, ``customer_id`` included: with ``swap_applicants`` the duplicate's main applicant is a *different person* than the source's, and the caller has no other way to learn who. Narrowing this to the label alone left the case view opening the duplicate as the old main applicant, who is now the co-applicant, so it rendered the same person in both applicant slots.
     *
     * @tags Application
     * @name DuplicateApplicationApplicationDuplicatePost
     * @summary Duplicate Application
     * @request POST:/application/duplicate
     * @secure
     */
    duplicateApplicationApplicationDuplicatePost: (
      data: DuplicateApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationCreatedResponse, HTTPValidationError>({
        path: `/application/duplicate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name DeactivateApplicationApplicationDeactivateProductPost
     * @summary Deactivate Application
     * @request POST:/application/deactivate/{product}
     * @secure
     */
    deactivateApplicationApplicationDeactivateProductPost: (
      product: Product,
      data: MortgageDeactivatePayload | DeactivatePayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/deactivate/${product}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ReactivateApplicationReactivatePost
     * @summary Reactivate
     * @request POST:/application/reactivate
     * @secure
     */
    reactivateApplicationReactivatePost: (
      data: ReactivatePayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/reactivate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetBlancoAppsByPniApplicationGetBlancoByPniPost
     * @summary Get Blanco Apps By Pni
     * @request POST:/application/get/blanco/by_pni
     * @secure
     */
    getBlancoAppsByPniApplicationGetBlancoByPniPost: (
      data: GetBlancoAppsByPni,
      params: RequestParams = {},
    ) =>
      this.request<BlancoApplicationDataSlim[], HTTPValidationError>({
        path: `/application/get/blanco/by_pni`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name GetQcApplicationQuickCreateGetPost
     * @summary Get Qc
     * @request POST:/application/quick-create/get
     * @secure
     */
    getQcApplicationQuickCreateGetPost: (
      data: GetQuickCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            product: "mortgage";
          } & OptionalQuickCreateMortgageApplicationOutput)
        | ({
            product: "blanco";
          } & OptionalQuickCreateBlancoApplicationOutput),
        HTTPValidationError
      >({
        path: `/application/quick-create/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name PatchApplicationFieldsApplicationV2PatchApplicationPost
     * @summary Patch Application Fields
     * @request POST:/application/v2/patch-application
     * @secure
     */
    patchApplicationFieldsApplicationV2PatchApplicationPost: (
      data:
        | ({
            country: "NO";
          } & (
            | ({
                product: "blanco";
              } & BlancoPatchPayloadNO)
            | ({
                product: "credit_card";
              } & CreditCardPatchPayload)
            | ({
                product: "mortgage";
              } & MortgagePatchPayloadNO)
          ))
        | ({
            country: "SE";
          } & BlancoPatchPayloadSE),
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            product: "blanco";
          } & (
            | ({
                country: "SE";
              } & RawBlancoApplicationSE)
            | ({
                country: "NO";
              } & RawBlancoApplicationNO)
          ))
        | ({
            product: "credit_card";
          } & RawCreditCardApplicationNO)
        | ({
            product: "mortgage";
          } & (
            | ({
                country: "SE";
              } & RawMortgageApplicationSE)
            | ({
                country: "NO";
              } & RawMortgageApplicationNO)
          )),
        HTTPValidationError
      >({
        path: `/application/v2/patch-application`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Queue copying `label`'s credits onto `targets` (ZRM-owned apps in the same customer's history). Slow, so it runs in a job; a refused sync is only logged, the case view gets an SSE ping per patched target.
     *
     * @tags Application V2
     * @name SyncCreditsApplicationV2SyncCreditsLabelPost
     * @summary Sync Credits
     * @request POST:/application/v2/sync-credits/{label}
     * @secure
     */
    syncCreditsApplicationV2SyncCreditsLabelPost: (
      label: string,
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/v2/sync-credits/${label}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name DeactivateApplicationApplicationV2DeactivateLabelGet
     * @summary Deactivate Application
     * @request GET:/application/v2/deactivate/{label}
     * @secure
     */
    deactivateApplicationApplicationV2DeactivateLabelGet: (
      label: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/v2/deactivate/${label}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name ReactivateApplicationApplicationV2ReactivateLabelGet
     * @summary Reactivate Application
     * @request GET:/application/v2/reactivate/{label}
     * @secure
     */
    reactivateApplicationApplicationV2ReactivateLabelGet: (
      label: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/v2/reactivate/${label}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name DeactivateMultipleApplicationsApplicationV2DeactivateWithOptionsPost
     * @summary Deactivate Multiple Applications
     * @request POST:/application/v2/deactivate-with-options
     * @secure
     */
    deactivateMultipleApplicationsApplicationV2DeactivateWithOptionsPost: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/v2/deactivate-with-options`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name MortgageCoiDecisionApplicationV2MortgageCoiApplicationIdPost
     * @summary Mortgage Coi Decision
     * @request POST:/application/v2/mortgage-coi/{application_id}
     * @secure
     */
    mortgageCoiDecisionApplicationV2MortgageCoiApplicationIdPost: (
      applicationId: string,
      query: {
        /**
         * Create
         * True to create mortgage application, False to remove tag from tags
         */
        create: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MortgageCoiDecisionResponse, HTTPValidationError>({
        path: `/application/v2/mortgage-coi/${applicationId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name GetMortgageCoiApplicationsApplicationV2MortgageCoiGet
     * @summary Get Mortgage Coi Applications
     * @request GET:/application/v2/mortgage-coi
     * @secure
     */
    getMortgageCoiApplicationsApplicationV2MortgageCoiGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageUnionAnnotatedUnionRawBlancoApplicationSERawBlancoApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountryRawCreditCardApplicationNOAnnotatedUnionRawMortgageApplicationSERawMortgageApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountry,
        HTTPValidationError
      >({
        path: `/application/v2/mortgage-coi`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The queue rows the current user is the mortgage reviewer of.
     *
     * @tags Application V2
     * @name GetMyMortgageCoiApplicationsApplicationV2MortgageCoiMineGet
     * @summary Get My Mortgage Coi Applications
     * @request GET:/application/v2/mortgage-coi/mine
     * @secure
     */
    getMyMortgageCoiApplicationsApplicationV2MortgageCoiMineGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PageUnionAnnotatedUnionRawBlancoApplicationSERawBlancoApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountryRawCreditCardApplicationNOAnnotatedUnionRawMortgageApplicationSERawMortgageApplicationNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorCountry,
        HTTPValidationError
      >({
        path: `/application/v2/mortgage-coi/mine`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name SetManualApplicationStateApplicationV2ApplicationMapperApplicationIdManualStatePost
     * @summary Set Manual Application State
     * @request POST:/application/v2/application-mapper/{application_id}/manual-state
     * @secure
     */
    setManualApplicationStateApplicationV2ApplicationMapperApplicationIdManualStatePost:
      (
        applicationId: string,
        data: ManualStatePayload,
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/application/v2/application-mapper/${applicationId}/manual-state`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Application V2
     * @name ToggleFreeForAllApplicationV2ApplicationMapperApplicationIdFreeForAllPost
     * @summary Toggle Free For All
     * @request POST:/application/v2/application-mapper/{application_id}/free-for-all
     * @secure
     */
    toggleFreeForAllApplicationV2ApplicationMapperApplicationIdFreeForAllPost: (
      applicationId: string,
      data: FreeForAllPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/v2/application-mapper/${applicationId}/free-for-all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Route a case between self-service and advisor-led after creation. Quick-create seeds the flag; this flips it either way afterwards — e.g. a self-serving customer who turns out to need an advisor, or an advisor-led case handed back to My Pages.
     *
     * @tags Application V2
     * @name SetSelfServiceApplicationV2SelfServicePost
     * @summary Set Self Service
     * @request POST:/application/v2/self-service
     * @secure
     */
    setSelfServiceApplicationV2SelfServicePost: (
      data: SelfServicePayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/application/v2/self-service`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name SetHighPrioApplicationV2ApplicationMapperApplicationIdHighPrioPost
     * @summary Set High Prio
     * @request POST:/application/v2/application-mapper/{application_id}/high-prio
     * @secure
     */
    setHighPrioApplicationV2ApplicationMapperApplicationIdHighPrioPost: (
      applicationId: string,
      data: HighPrioPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/v2/application-mapper/${applicationId}/high-prio`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name GetApplicationMapperTagsApplicationV2ApplicationMapperTagsGet
     * @summary Get Application Mapper Tags
     * @request GET:/application/v2/application-mapper-tags
     * @secure
     */
    getApplicationMapperTagsApplicationV2ApplicationMapperTagsGet: (
      params: RequestParams = {},
    ) =>
      this.request<ApplicationMapperTags[], any>({
        path: `/application/v2/application-mapper-tags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name RequestInviteFromBankApplicationV2RequestInvitePost
     * @summary Request Invite From Bank
     * @request POST:/application/v2/request-invite
     * @secure
     */
    requestInviteFromBankApplicationV2RequestInvitePost: (
      data: RequestInvitePayload,
      params: RequestParams = {},
    ) =>
      this.request<EmptyModel, HTTPValidationError>({
        path: `/application/v2/request-invite`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name AcceptOfferApplicationV2AcceptOfferPost
     * @summary Accept Offer
     * @request POST:/application/v2/accept-offer
     * @secure
     */
    acceptOfferApplicationV2AcceptOfferPost: (
      data: SharedModelsApplicationAcceptOfferPayload,
      params: RequestParams = {},
    ) =>
      this.request<EmptyModel, HTTPValidationError>({
        path: `/application/v2/accept-offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application V2
     * @name CancelOfferApplicationV2CancelOfferPost
     * @summary Cancel Offer
     * @request POST:/application/v2/cancel-offer
     * @secure
     */
    cancelOfferApplicationV2CancelOfferPost: (
      data: CancelOfferByOfferIdPayload,
      params: RequestParams = {},
    ) =>
      this.request<EmptyModel, HTTPValidationError>({
        path: `/application/v2/cancel-offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The Case View's "Withdraw acceptance": apps-mgr takes the acceptance back internally, without telling the bank, and keeps the offer acceptable. Forwarded with the handler's token so the event is written as them; apps-mgr's refusals (not ZRM-only, not accepted, accept still being sent, ...) are passed through.
     *
     * @tags Application V2
     * @name WithdrawAcceptApplicationV2WithdrawAcceptPost
     * @summary Withdraw Accept
     * @request POST:/application/v2/withdraw-accept
     * @secure
     */
    withdrawAcceptApplicationV2WithdrawAcceptPost: (
      data: WithdrawAcceptPayload,
      params: RequestParams = {},
    ) =>
      this.request<EmptyModel, HTTPValidationError>({
        path: `/application/v2/withdraw-accept`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description A handler turns the SKA rules off for this application, with a reason. Write-once: 409 when it already has an override (online-first or manual), 403 without access to the application's country and product, 422 for a blank reason or an application that is not native NO blanco or NO mortgage, 502/503 when apps-mgr refuses ZRM or does not answer. The case view reads the result over SSE: the `ska_impact` ping published here.
     *
     * @tags Application V2
     * @name SetSkaOverrideApplicationV2SkaOverrideLabelPost
     * @summary Set Ska Override
     * @request POST:/application/v2/ska-override/{label}
     * @secure
     */
    setSkaOverrideApplicationV2SkaOverrideLabelPost: (
      label: string,
      data: SetSkaOverridePayload,
      params: RequestParams = {},
    ) =>
      this.request<SkaOverride, HTTPValidationError>({
        path: `/application/v2/ska-override/${label}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Whether the user has the `move-to-zrm` or `developer` role, so the case view shows the "Move to ZRM" button only to those who may use it. The move itself checks this again, with the access to each label.
     *
     * @tags Application V2
     * @name MoveToZrmAccessApplicationV2MoveToZrmAccessGet
     * @summary Move To Zrm Access
     * @request GET:/application/v2/move-to-zrm-access
     * @secure
     */
    moveToZrmAccessApplicationV2MoveToZrmAccessGet: (
      params: RequestParams = {},
    ) =>
      this.request<MoveToZrmAccess, any>({
        path: `/application/v2/move-to-zrm-access`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Move a legacy Sverker NO application, with the other label of its Sverker row, to ZRM; one-way. `dry_run` previews it: every label of the row, whether it may move and why not, warnings, and the v1 meetings the move converts. The move itself needs the `reason` and the `labels` the preview showed; apps-mgr refuses it with 409 when the row's labels changed since. 200 is a dry run, this move, or a move made earlier (`already_moved`). A move's 200 also carries the moved labels' mappers, whether ZRM's own steps are done (`post_commit_done`), and every meeting of the row with its conversion outcome and, for a skipped one, the reason (`meetings`). 409 means nothing moved, with apps-mgr's typed reason in `detail`. 403 without the `move-to-zrm` or `developer` role, or without access to the country and product of any label that moves; 422 for a label that is not a legacy NO blanco or mortgage application or a move without reason and labels; 502/503 when apps-mgr refuses ZRM or does not answer.
     *
     * @tags Application V2
     * @name MoveToZrmApplicationV2MoveToZrmLabelPost
     * @summary Move To Zrm
     * @request POST:/application/v2/move-to-zrm/{label}
     * @secure
     */
    moveToZrmApplicationV2MoveToZrmLabelPost: (
      label: string,
      data: MoveToZrmBody,
      params: RequestParams = {},
    ) =>
      this.request<MoveToZrmResult, HTTPValidationError>({
        path: `/application/v2/move-to-zrm/${label}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The case view's "Update Blanco Loans" for a ZRM-only ULNO or MONO application: apps-mgr merges the current Gjeldsregisteret loans into the credits (manual refinance edits preserved); on ULNO it also recalculates desired_loan, on MONO the mortgage's amount and term are left alone. Each product has its own apps-mgr route. Forwarded with the handler's token so the PATCHED event is written as them. apps-mgr's status and reason are passed through (409 = inactive / accepted / disbursed, 423 = a sync already holds the lock, 400 = not a ZRM-only application of that route's product, 404 = unknown label); the detail reads `Error in AppsMgr <path>: <reason>`.
     *
     * @tags Application V2
     * @name SyncGrForAppApplicationV2SyncGrLabelPost
     * @summary Sync Gr For App
     * @request POST:/application/v2/sync-gr/{label}
     * @secure
     */
    syncGrForAppApplicationV2SyncGrLabelPost: (
      label: string,
      params: RequestParams = {},
    ) =>
      this.request<
        GrSyncResponse | MortgageGrSyncResponse,
        HTTPValidationError
      >({
        path: `/application/v2/sync-gr/${label}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name GetApplicationApplicationCcNoGetPost
     * @summary Get Application
     * @request POST:/application/cc/no/get
     * @secure
     */
    getApplicationApplicationCcNoGetPost: (
      data: GetApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        CreditCardApplicationWithNamesInComments,
        HTTPValidationError
      >({
        path: `/application/cc/no/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name CreateApplicationApplicationCcNoCreatePost
     * @summary Create Application
     * @request POST:/application/cc/no/create
     * @secure
     */
    createApplicationApplicationCcNoCreatePost: (
      data: CreateCreditCardApplicationPayloadExt,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationCreatedResponseExt, HTTPValidationError>({
        path: `/application/cc/no/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name UpdateApplicationApplicationCcNoUpdatePost
     * @summary Update Application
     * @request POST:/application/cc/no/update
     * @secure
     */
    updateApplicationApplicationCcNoUpdatePost: (
      data: UpdateCreditCardApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<EmptyModel, HTTPValidationError>({
        path: `/application/cc/no/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name UpdateAndGetApplicationApplicationCcNoUpdateAndGetPost
     * @summary Update And Get Application
     * @request POST:/application/cc/no/update-and-get
     * @secure
     */
    updateAndGetApplicationApplicationCcNoUpdateAndGetPost: (
      data: UpdateCreditCardApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreditCardApplicationExtended, HTTPValidationError>({
        path: `/application/cc/no/update-and-get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name CreateApplicationApplicantApplicationCcNoCreateWithApplicantPost
     * @summary Create Application Applicant
     * @request POST:/application/cc/no/create-with-applicant
     * @secure
     */
    createApplicationApplicantApplicationCcNoCreateWithApplicantPost: (
      data: CreateCreditCardApplicationApplicantPayloadExt,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationCreatedResponseExt, HTTPValidationError>({
        path: `/application/cc/no/create-with-applicant`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name GetRecentApplicationsApplicationCcNoGetRecentPost
     * @summary Get Recent Applications
     * @request POST:/application/cc/no/get_recent
     * @secure
     */
    getRecentApplicationsApplicationCcNoGetRecentPost: (
      data: GetRecentPayload,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageCreditCardApplicationExtended, HTTPValidationError>({
        path: `/application/cc/no/get_recent`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name GetApplicationBankEventsApplicationCcNoBankEventsPost
     * @summary Get Application Bank Events
     * @request POST:/application/cc/no/bank-events
     * @secure
     */
    getApplicationBankEventsApplicationCcNoBankEventsPost: (
      data: ApplicationQuery,
      params: RequestParams = {},
    ) =>
      this.request<CreditCardBankEventsResponse, HTTPValidationError>({
        path: `/application/cc/no/bank-events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name SearchApplicationsApplicationCcNoSearchApplicationsPost
     * @summary Search Applications
     * @request POST:/application/cc/no/search_applications
     * @secure
     */
    searchApplicationsApplicationCcNoSearchApplicationsPost: (
      data: GetApplicationsByApplicantIdentifierPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreditCardApplicationExtended[], HTTPValidationError>({
        path: `/application/cc/no/search_applications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CreditCard Application
     * @name AcceptOfferApplicationCcNoAcceptOfferPost
     * @summary Accept Offer
     * @request POST:/application/cc/no/accept_offer
     * @secure
     */
    acceptOfferApplicationCcNoAcceptOfferPost: (
      data: AcceptOffer,
      params: RequestParams = {},
    ) =>
      this.request<
        CreditorOfferCreditCardOfferDataCreditCardTerms,
        HTTPValidationError
      >({
        path: `/application/cc/no/accept_offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Same body as /accept_offer, and additionally sends the customer the accepted-offer SMS. A 2xx here can still carry sms_sent=false. The offer is accepted either way, and only the message needs retrying. See the service for why that is not an error.
     *
     * @tags CreditCard Application
     * @name AcceptOfferAndInformApplicationCcNoAcceptOfferAndInformPost
     * @summary Accept Offer And Inform
     * @request POST:/application/cc/no/accept_offer_and_inform
     * @secure
     */
    acceptOfferAndInformApplicationCcNoAcceptOfferAndInformPost: (
      data: AcceptOffer,
      params: RequestParams = {},
    ) =>
      this.request<AcceptOfferAndInformResult, HTTPValidationError>({
        path: `/application/cc/no/accept_offer_and_inform`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The next-best remaining offer for the application, plus whether a genuine late denial (accept-confirmed from the bank events) stands behind it. Read-only. Feeds the Todomaker accept-and-inform button: the client must require both a non-null offer AND late_denial_confirmed before offering the action, because the SMS behind it claims a denial of an accepted offer.
     *
     * @tags CreditCard Application
     * @name NextOfferApplicationCcNoNextOfferPost
     * @summary Next Offer
     * @request POST:/application/cc/no/next_offer
     * @secure
     */
    nextOfferApplicationCcNoNextOfferPost: (
      data: GetApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<NextOfferResult, HTTPValidationError>({
        path: `/application/cc/no/next_offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mortgage SE Application
     * @name GetApplicationBankEventsApplicationMoSeBankEventsPost
     * @summary Get Application Bank Events
     * @request POST:/application/mo/se/bank-events
     * @secure
     */
    getApplicationBankEventsApplicationMoSeBankEventsPost: (
      data: ApplicationQuery,
      params: RequestParams = {},
    ) =>
      this.request<MortgageBankEventsResponse, HTTPValidationError>({
        path: `/application/mo/se/bank-events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name InviteApplicationApplicationInvitePost
     * @summary Invite Application
     * @request POST:/application/invite
     * @secure
     */
    inviteApplicationApplicationInvitePost: (
      data: InvitePayloadBase,
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/application/invite`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name InviteApplicationIdApplicationInviteApplicationIdPost
     * @summary Invite Application Id
     * @request POST:/application/invite/{application_id}
     * @secure
     */
    inviteApplicationIdApplicationInviteApplicationIdPost: (
      applicationId: string,
      data: InvitePayloadBase,
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/application/invite/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name GetAppEventsApplicationGetAppEventsApplicationIdGet
     * @summary Get App Events
     * @request GET:/application/get_app_events/{application_id}
     * @secure
     */
    getAppEventsApplicationGetAppEventsApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/get_app_events/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name GetAppEventsOldApplicationGetAppEventsPost
     * @summary Get App Events Old
     * @request POST:/application/get_app_events
     * @secure
     */
    getAppEventsOldApplicationGetAppEventsPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/application/get_app_events`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name SendCommentToIntegrationApplicationCommentToBankPost
     * @summary Send Comment To Integration
     * @request POST:/application/comment_to_bank
     * @secure
     */
    sendCommentToIntegrationApplicationCommentToBankPost: (
      data: BaseComment,
      params: RequestParams = {},
    ) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/comment_to_bank`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name SendCommentV2ApplicationV2CommentPost
     * @summary Send Comment V2
     * @request POST:/application/v2/comment
     * @secure
     */
    sendCommentV2ApplicationV2CommentPost: (
      data: SharedModelsApi2V4ApplicationCommentPayload,
      params: RequestParams = {},
    ) =>
      this.request<Response, HTTPValidationError>({
        path: `/application/v2/comment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name AcceptOfferApplicationAcceptOfferPost
     * @summary Accept Offer
     * @request POST:/application/accept_offer
     * @secure
     */
    acceptOfferApplicationAcceptOfferPost: (
      data: AcceptOffer,
      params: RequestParams = {},
    ) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/accept_offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name CancelApplicationCancelPost
     * @summary Cancel
     * @request POST:/application/cancel
     * @secure
     */
    cancelApplicationCancelPost: (
      data: CancelOfferPayload,
      params: RequestParams = {},
    ) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Communication
     * @name SendDocumentToIntegrationApplicationDocumentToBankPost
     * @summary Send Document To Integration
     * @request POST:/application/document_to_bank
     * @secure
     */
    sendDocumentToIntegrationApplicationDocumentToBankPost: (
      data: DocumentToBank,
      params: RequestParams = {},
    ) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/application/document_to_bank`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name AssignApplicationToHandlerApplicationAssignApplicationIdPost
     * @summary Assign Application To Handler
     * @request POST:/application/assign/{application_id}
     * @secure
     */
    assignApplicationToHandlerApplicationAssignApplicationIdPost: (
      applicationId: string,
      data: AssignApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/application/assign/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name ListInternalCommentsApplicationCommentApplicationIdGet
     * @summary List Internal Comments
     * @request GET:/application/comment/{application_id}
     * @secure
     */
    listInternalCommentsApplicationCommentApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        (BankIDSignedWithNames | InternalCommentWithName)[],
        HTTPValidationError
      >({
        path: `/application/comment/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name AddInternalCommentApplicationCommentApplicationIdPost
     * @summary Add Internal Comment
     * @request POST:/application/comment/{application_id}
     * @secure
     */
    addInternalCommentApplicationCommentApplicationIdPost: (
      applicationId: string,
      data: CommentPayload,
      query?: {
        /** Customer Id */
        customer_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        (BankIDSignedWithNames | InternalCommentWithName)[],
        HTTPValidationError
      >({
        path: `/application/comment/${applicationId}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name GetPagedCommentsApplicationCommentPagedCustomerIdPost
     * @summary Get Paged Comments
     * @request POST:/application/comment/paged/{customer_id}
     * @secure
     */
    getPagedCommentsApplicationCommentPagedCustomerIdPost: (
      customerId: string,
      query?: {
        /** Page */
        page?: number | null;
        /**
         * Limit
         * @default 20
         */
        limit?: number;
        /** Newer Than */
        newer_than?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageInternalCommentSSE, HTTPValidationError>({
        path: `/application/comment/paged/${customerId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name GetPossibleStatusesApplicationPrefsGet
     * @summary Get Possible Statuses
     * @request GET:/application/prefs
     * @secure
     */
    getPossibleStatusesApplicationPrefsGet: (params: RequestParams = {}) =>
      this.request<PrefsResponse, any>({
        path: `/application/prefs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name UpdateAppPrefsApplicationPrefsProductCountryPost
     * @summary Update App Prefs
     * @request POST:/application/prefs/{product}/{country}
     * @secure
     */
    updateAppPrefsApplicationPrefsProductCountryPost: (
      product: Product,
      country: Country,
      data: AppPrefsPayload,
      params: RequestParams = {},
    ) =>
      this.request<PrefsResponse, HTTPValidationError>({
        path: `/application/prefs/${product}/${country}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name GetPossibleLoanTypesApplicationLoanTypesCountryGet
     * @summary Get Possible Loan Types
     * @request GET:/application/loan-types/{country}
     * @secure
     */
    getPossibleLoanTypesApplicationLoanTypesCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<string[], HTTPValidationError>({
        path: `/application/loan-types/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application Meta
     * @name SearchBlancoSverkerApplicationBlancoSearchCountryGet
     * @summary Search Blanco Sverker
     * @request GET:/application/blanco/search/{country}
     * @secure
     */
    searchBlancoSverkerApplicationBlancoSearchCountryGet: (
      country: Country,
      query: {
        /** S */
        s: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SverkerSearchResponse, HTTPValidationError>({
        path: `/application/blanco/search/${country}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name AmlReviewApplicationAmlReviewPost
     * @summary Aml Review
     * @request POST:/application/aml/review
     * @secure
     */
    amlReviewApplicationAmlReviewPost: (
      data: AMLReviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationWithNamesInComments, HTTPValidationError>({
        path: `/application/aml/review`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name GetBlancoAmlApplicationBlancoAmlApplicationIdGet
     * @summary Get Blanco Aml
     * @request GET:/application/blanco/aml/{application_id}
     * @secure
     */
    getBlancoAmlApplicationBlancoAmlApplicationIdGet: (
      applicationId: number,
      query: {
        country: Country;
      },
      params: RequestParams = {},
    ) =>
      this.request<AMLBlancoResponse, HTTPValidationError>({
        path: `/application/blanco/aml/${applicationId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name PatchBlancoAmlApplicationBlancoAmlApplicationIdPatch
     * @summary Patch Blanco Aml
     * @request PATCH:/application/blanco/aml/{application_id}
     * @secure
     */
    patchBlancoAmlApplicationBlancoAmlApplicationIdPatch: (
      applicationId: number,
      data: BlancoAMLPatchPayload,
      params: RequestParams = {},
    ) =>
      this.request<AMLBlancoResponse, HTTPValidationError>({
        path: `/application/blanco/aml/${applicationId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name ReviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch
     * @summary Review Blanco Aml
     * @request PATCH:/application/blanco/aml/review/{application_id}
     * @secure
     */
    reviewBlancoAmlApplicationBlancoAmlReviewApplicationIdPatch: (
      applicationId: number,
      data: BlancoAMLReviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/blanco/aml/review/${applicationId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name ReviewOpAmlApplicationOpAmlReviewApplicationIdPatch
     * @summary Review Op Aml
     * @request PATCH:/application/op/aml/review/{application_id}
     * @secure
     */
    reviewOpAmlApplicationOpAmlReviewApplicationIdPatch: (
      applicationId: string,
      data: OPAMLReviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/application/op/aml/review/${applicationId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name MortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost
     * @summary Mortgage Deactivation Reviews
     * @request POST:/application/deactivation_reviews/mortgage
     * @secure
     */
    mortgageDeactivationReviewsApplicationDeactivationReviewsMortgagePost: (
      data: DeactivationReviewsPayload,
      params: RequestParams = {},
    ) =>
      this.request<MortgageDeactivationReviewsResponse, HTTPValidationError>({
        path: `/application/deactivation_reviews/mortgage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AML
     * @name BlancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost
     * @summary Blanco Deactivation Reviews
     * @request POST:/application/deactivation_reviews/blanco
     * @secure
     */
    blancoDeactivationReviewsApplicationDeactivationReviewsBlancoPost: (
      data: DeactivationReviewsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DeactivationReviewsResponse, HTTPValidationError>({
        path: `/application/deactivation_reviews/blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Migrator
     * @name MigrateSverkerTextMessagesApplicationMigratorTextMessagesPost
     * @summary Migrate Sverker Text Messages
     * @request POST:/application/migrator/text-messages
     * @secure
     */
    migrateSverkerTextMessagesApplicationMigratorTextMessagesPost: (
      data: ZrmTextMessageEvent[],
      params: RequestParams = {},
    ) =>
      this.request<ZrmMigrationStats, HTTPValidationError>({
        path: `/application/migrator/text-messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Migrator
     * @name MigrateSverkerApplicationApplicationMigratorAppLabelPost
     * @summary Migrate Sverker Application
     * @request POST:/application/migrator/{app_label}
     * @secure
     */
    migrateSverkerApplicationApplicationMigratorAppLabelPost: (
      appLabel: string,
      data: ZrmMigratorEvents,
      params: RequestParams = {},
    ) =>
      this.request<ZrmMigrationStats, HTTPValidationError>({
        path: `/application/migrator/${appLabel}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customer = {
    /**
     * No description
     *
     * @tags Customer
     * @name GetCustomerCustomerGetPost
     * @summary Get Customer
     * @request POST:/customer/get
     * @secure
     */
    getCustomerCustomerGetPost: (
      data:
        | PniGetCustomerPayload
        | EmailGetCustomerPayload
        | PhoneGetCustomerPayload
        | CustomerIDGetCustomerPayload
        | CustomerIDsGetCustomerPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            country: "SE";
          } & ApplicantSE)
        | ({
            country: "NO";
          } & ApplicantNO),
        HTTPValidationError
      >({
        path: `/customer/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetCustomersCustomerGetsPost
     * @summary Get Customers
     * @request POST:/customer/gets
     * @secure
     */
    getCustomersCustomerGetsPost: (
      data: CustomerIDsGetCustomerPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        (
          | ({
              country: "SE";
            } & ApplicantSE)
          | ({
              country: "NO";
            } & ApplicantNO)
        )[],
        HTTPValidationError
      >({
        path: `/customer/gets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name CreateCustomerCustomerCreatePost
     * @summary Create Customer
     * @request POST:/customer/create
     * @secure
     */
    createCustomerCustomerCreatePost: (
      data: CreateCustomerPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            country: "SE";
          } & ApplicantSE)
        | ({
            country: "NO";
          } & ApplicantNO),
        HTTPValidationError
      >({
        path: `/customer/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name UpdateCustomerCustomerUpdatePost
     * @summary Update Customer
     * @request POST:/customer/update
     * @secure
     */
    updateCustomerCustomerUpdatePost: (
      data: UpdateCustomerPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            country: "SE";
          } & ApplicantSE)
        | ({
            country: "NO";
          } & ApplicantNO),
        HTTPValidationError
      >({
        path: `/customer/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name UpdateConsentsCustomerUpdateConsentsPost
     * @summary Update Consents
     * @request POST:/customer/update_consents
     * @secure
     */
    updateConsentsCustomerUpdateConsentsPost: (
      data: UpdateCustomerConsentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            country: "SE";
          } & ApplicantSE)
        | ({
            country: "NO";
          } & ApplicantNO),
        HTTPValidationError
      >({
        path: `/customer/update_consents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name IdCheckOrGetCustomerCustomerIdCheckPost
     * @summary Id Check Or Get Customer
     * @request POST:/customer/id-check
     * @secure
     */
    idCheckOrGetCustomerCustomerIdCheckPost: (
      data: IDCheckGetCustomerPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        | (
            | ({
                country: "SE";
              } & ApplicantSE)
            | ({
                country: "NO";
              } & ApplicantNO)
          )
        | IDCheckedPerson
        | null,
        HTTPValidationError
      >({
        path: `/customer/id-check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name TakeCreditCheckCustomerCreditCheckPost
     * @summary Take Credit Check
     * @request POST:/customer/credit-check
     * @secure
     */
    takeCreditCheckCustomerCreditCheckPost: (
      data: TakeCreditCheck,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            country: "SE";
          } & ApplicantSE)
        | ({
            country: "NO";
          } & ApplicantNO),
        HTTPValidationError
      >({
        path: `/customer/credit-check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetNameByPniCustomerNameByPniPost
     * @summary Get Name By Pni
     * @request POST:/customer/name/by-pni
     * @secure
     */
    getNameByPniCustomerNameByPniPost: (
      data: GetNameByPNIPayload,
      params: RequestParams = {},
    ) =>
      this.request<Name | null, HTTPValidationError>({
        path: `/customer/name/by-pni`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetNameCustomerNameCustomerIdGet
     * @summary Get Name
     * @request GET:/customer/name/{customer_id}
     * @secure
     */
    getNameCustomerNameCustomerIdGet: (
      customerId: string,
      params: RequestParams = {},
    ) =>
      this.request<Name | null, HTTPValidationError>({
        path: `/customer/name/${customerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer, Application Meta
     * @name EmploymentTypesCustomerEmploymentTypesCountryGet
     * @summary Employment Types
     * @request GET:/customer/employment-types/{country}
     * @secure
     */
    employmentTypesCustomerEmploymentTypesCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<string[], HTTPValidationError>({
        path: `/customer/employment-types/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer, Application Meta
     * @name HousingTypesCustomerHousingTypesCountryGet
     * @summary Housing Types
     * @request GET:/customer/housing-types/{country}
     * @secure
     */
    housingTypesCustomerHousingTypesCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<string[], HTTPValidationError>({
        path: `/customer/housing-types/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name GetExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost
     * @summary Get Externally Verified Credits
     * @request POST:/customer/externally-verified-credits
     * @secure
     */
    getExternallyVerifiedCreditsCustomerExternallyVerifiedCreditsPost: (
      data: MinimalApplicant[],
      params: RequestParams = {},
    ) =>
      this.request<LoanAndExternallyVerifiedCredit, HTTPValidationError>({
        path: `/customer/externally-verified-credits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer
     * @name DebtRegisterRenewCustomerDebtRegisterRenewPost
     * @summary Debt Register Renew
     * @request POST:/customer/debt-register/renew
     * @secure
     */
    debtRegisterRenewCustomerDebtRegisterRenewPost: (
      query: {
        country: Country;
      },
      data: MinimalApplicant[],
      params: RequestParams = {},
    ) =>
      this.request<LoanAndExternallyVerifiedCredit, HTTPValidationError>({
        path: `/customer/debt-register/renew`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * @description Generate a concise summary of applications for a customer. The summary language follows the agent's UI language setting (`user_settings.ui_language`), falling back to the `language` query parameter when no setting is stored. Args: customer_id: The unique identifier of the customer. language: Fallback language for the generated summary (default: Swedish). Returns: A response object containing the generated summary.
     *
     * @tags Application Summarizer
     * @name GetApplicationSummaryApiApplicationSummarizerSummaryCustomerIdGet
     * @summary Get Application Summary
     * @request GET:/api/application-summarizer/summary/{customer_id}
     * @secure
     */
    getApplicationSummaryApiApplicationSummarizerSummaryCustomerIdGet: (
      customerId: string,
      query?: {
        /**
         * Fallback language if the agent has no UI language set
         * @default "sv"
         */
        language?: Language;
      },
      params: RequestParams = {},
    ) =>
      this.request<SummaryResponse, HTTPValidationError>({
        path: `/api/application-summarizer/summary/${customerId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload a file to storage. Send as `multipart/form-data` with a `key` field and a `file` field. Content-type is read from the uploaded file.
     *
     * @tags File Storage
     * @name UploadFileApiFileStorageUploadPost
     * @summary Upload File
     * @request POST:/api/file-storage/upload
     */
    uploadFileApiFileStorageUploadPost: (
      data: BodyUploadFileApiFileStorageUploadPost,
      params: RequestParams = {},
    ) =>
      this.request<UploadResponse, HTTPValidationError>({
        path: `/api/file-storage/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Download a file from storage. Returns the raw file bytes with the original content-type header.
     *
     * @tags File Storage
     * @name DownloadFileApiFileStorageDownloadKeyGet
     * @summary Download File
     * @request GET:/api/file-storage/download/{key}
     */
    downloadFileApiFileStorageDownloadKeyGet: (
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/file-storage/download/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a pre-signed download URL. The URL is valid for `expires_in` seconds (default 1 hour, max 7 days).
     *
     * @tags File Storage
     * @name PresignedDownloadUrlApiFileStoragePresignedDownloadKeyGet
     * @summary Presigned Download Url
     * @request GET:/api/file-storage/presigned/download/{key}
     */
    presignedDownloadUrlApiFileStoragePresignedDownloadKeyGet: (
      key: string,
      query?: {
        /**
         * Expires In
         * @min 10
         * @max 604800
         * @default 3600
         */
        expires_in?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PresignedUrlResponse, HTTPValidationError>({
        path: `/api/file-storage/presigned/download/${key}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a file from storage.
     *
     * @tags File Storage
     * @name DeleteFileApiFileStorageKeyDelete
     * @summary Delete File
     * @request DELETE:/api/file-storage/{key}
     */
    deleteFileApiFileStorageKeyDelete: (
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/file-storage/${key}`,
        method: "DELETE",
        ...params,
      }),
  };
  customerEvents = {
    /**
     * No description
     *
     * @tags Customer Event Log
     * @name GetCustomerTimelineCustomerEventsCustomerIdGet
     * @summary Get Customer Timeline
     * @request GET:/customer-events/{customer_id}
     * @secure
     */
    getCustomerTimelineCustomerEventsCustomerIdGet: (
      customerId: string,
      query?: {
        /** Since */
        since?: string | null;
        /** Until */
        until?: string | null;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
        /** Cursor */
        cursor?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<TimelineResponse, HTTPValidationError>({
        path: `/customer-events/${customerId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Lazy CloudWatch logs lane for one request tree (Phase 7). Developer-gated; the audited KDLT read writes a DISTINCT access_events row (reason names the root_request_id) and 404s an unknown customer. Bounded to `around ± WINDOW_MINUTES`, PII-redacted, post-filtered to the request root. (Anti-fishing membership — requiring `root_request_id` to appear on an in-scope event — is deferred: v1 is developer-only with full access, and every access is audited. Add it with the agent zoordinates policy.)
     *
     * @tags Customer Event Log
     * @name GetCustomerTimelineLogsCustomerEventsCustomerIdLogsGet
     * @summary Get Customer Timeline Logs
     * @request GET:/customer-events/{customer_id}/logs
     * @secure
     */
    getCustomerTimelineLogsCustomerEventsCustomerIdLogsGet: (
      customerId: string,
      query: {
        /**
         * Around
         * @format date-time
         */
        around: string;
        /**
         * Root Request Id
         * @minLength 1
         * @maxLength 200
         */
        root_request_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<LogsResponse, HTTPValidationError>({
        path: `/customer-events/${customerId}/logs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  search = {
    /**
     * No description
     *
     * @tags Search
     * @name SearchSearchPost
     * @summary Search
     * @request POST:/search
     * @secure
     */
    searchSearchPost: (data: GlobalSearchRequest, params: RequestParams = {}) =>
      this.request<GlobalSearchPage, HTTPValidationError>({
        path: `/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  agentAi = {
    /**
     * @description Which agent AI features the caller may use. The frontend shows an entry point only when it is true.
     *
     * @tags Agent AI
     * @name GetStatusAgentAiStatusGet
     * @summary Get Status
     * @request GET:/agent-ai/status
     * @secure
     */
    getStatusAgentAiStatusGet: (params: RequestParams = {}) =>
      this.request<AgentAiStatus, any>({
        path: `/agent-ai/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The agent's SMS in the customer's language, with a back-translation, a reply to the agent's chat message, warnings and SMS parts. Nothing is sent; `translation_id` goes on the send payload.
     *
     * @tags Agent AI
     * @name TranslateAgentAiTranslatePost
     * @summary Translate
     * @request POST:/agent-ai/translate
     * @secure
     */
    translateAgentAiTranslatePost: (
      data: TranslateRequest,
      params: RequestParams = {},
    ) =>
      this.request<TranslateResponse, HTTPValidationError>({
        path: `/agent-ai/translate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description An incoming SMS of the customer in the agent's language. A machine translation: the UI says so.
     *
     * @tags Agent AI
     * @name TranslateIncomingAgentAiTranslateIncomingPost
     * @summary Translate Incoming
     * @request POST:/agent-ai/translate-incoming
     * @secure
     */
    translateIncomingAgentAiTranslateIncomingPost: (
      data: TranslateIncomingRequest,
      params: RequestParams = {},
    ) =>
      this.request<TranslateIncomingResponse, HTTPValidationError>({
        path: `/agent-ai/translate-incoming`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The target language to suggest for this customer; the agent always confirms it.
     *
     * @tags Agent AI
     * @name GetDefaultLanguageAgentAiTranslateLanguageCustomerIdGet
     * @summary Get Default Language
     * @request GET:/agent-ai/translate/language/{customer_id}
     * @secure
     */
    getDefaultLanguageAgentAiTranslateLanguageCustomerIdGet: (
      customerId: string,
      params: RequestParams = {},
    ) =>
      this.request<DefaultLanguageResponse, HTTPValidationError>({
        path: `/agent-ai/translate/language/${customerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A short SMS that explains Lekbanken's figures to the customer, in the case country's language, with the check warnings and SMS parts. Nothing is sent; `draft_id` goes on the send payload as `translation_id`.
     *
     * @tags Agent AI
     * @name DraftPlayBankSmsAgentAiSmsDraftPlayBankPost
     * @summary Draft Play Bank Sms
     * @request POST:/agent-ai/sms-draft/play-bank
     * @secure
     */
    draftPlayBankSmsAgentAiSmsDraftPlayBankPost: (
      data: PlayBankSmsRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlayBankSmsResponse, HTTPValidationError>({
        path: `/agent-ai/sms-draft/play-bank`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Ask the AI about the case the agent has open. Plain HTTP errors before the stream: the case is one the Case View opens (422), the agent has access to its product and country (403), no personal number in the question or the earlier turns (422), the AI is set up (503), the application exists (404) and the customer is on it (403). Then the answer streams (`CaseChatEvent`), with pings for the load balancer and Safari.
     *
     * @tags Agent AI
     * @name CaseChatMessageAgentAiCaseCustomerIdApplicationIdMessagePost
     * @summary Case Chat Message
     * @request POST:/agent-ai/case/{customer_id}/{application_id}/message
     * @secure
     */
    caseChatMessageAgentAiCaseCustomerIdApplicationIdMessagePost: (
      customerId: string,
      applicationId: string,
      data: CaseChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            type: "progress";
          } & CaseChatProgressEvent)
        | ({
            type: "answer";
          } & CaseChatAnswerEvent)
        | ({
            type: "error";
          } & CaseChatErrorEvent),
        HTTPValidationError
      >({
        path: `/agent-ai/case/${customerId}/${applicationId}/message`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Thumbs up or down on one of the agent's own case chat answers; another agent's row is 404.
     *
     * @tags Agent AI
     * @name SaveCaseChatFeedbackAgentAiTurnsTurnIdFeedbackPost
     * @summary Save Case Chat Feedback
     * @request POST:/agent-ai/turns/{turn_id}/feedback
     * @secure
     */
    saveCaseChatFeedbackAgentAiTurnsTurnIdFeedbackPost: (
      turnId: string,
      data: CaseChatFeedbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/agent-ai/turns/${turnId}/feedback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  meeting = {
    /**
     * No description
     *
     * @tags Meeting
     * @name GetMeetingMeetingGetMeetingIdGet
     * @summary Get Meeting
     * @request GET:/meeting/get/{meeting_id}
     * @secure
     */
    getMeetingMeetingGetMeetingIdGet: (
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<ModelsMeetingModelsMeeting, HTTPValidationError>({
        path: `/meeting/get/${meetingId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetMeetingsMeetingGetPost
     * @summary Get Meetings
     * @request POST:/meeting/get
     * @secure
     */
    getMeetingsMeetingGetPost: (
      data: GetMeetings,
      params: RequestParams = {},
    ) =>
      this.request<
        | MeetingWithApp[]
        | MeetingWithHandlerName[]
        | ModelsMeetingModelsMeeting[],
        HTTPValidationError
      >({
        path: `/meeting/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetMyMeetingsMeetingMinePost
     * @summary Get My Meetings
     * @request POST:/meeting/mine
     * @secure
     */
    getMyMeetingsMeetingMinePost: (
      data: GetMyMeetings,
      params: RequestParams = {},
    ) =>
      this.request<
        (
          | MeetingWithApp
          | MeetingWithHandlerName
          | ModelsMeetingModelsMeeting
        )[],
        HTTPValidationError
      >({
        path: `/meeting/mine`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name CreateMeetingMeetingCreatePost
     * @summary Create Meeting
     * @request POST:/meeting/create
     * @secure
     */
    createMeetingMeetingCreatePost: (
      data: CreateMeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<ModelsMeetingModelsMeeting, HTTPValidationError>({
        path: `/meeting/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name UpdateMeetingMeetingUpdateMeetingIdPost
     * @summary Update Meeting
     * @request POST:/meeting/update/{meeting_id}
     * @secure
     */
    updateMeetingMeetingUpdateMeetingIdPost: (
      meetingId: string,
      data: UpdateMeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<ModelsMeetingModelsMeeting, HTTPValidationError>({
        path: `/meeting/update/${meetingId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name CancelMeetingsMeetingCancelMeetingIdDelete
     * @summary Cancel Meetings
     * @request DELETE:/meeting/cancel/{meeting_id}
     * @secure
     */
    cancelMeetingsMeetingCancelMeetingIdDelete: (
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/meeting/cancel/${meetingId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetBookableTimesMeetingAvailableDayGet
     * @summary Get Bookable Times
     * @request GET:/meeting/available/{day}
     * @secure
     */
    getBookableTimesMeetingAvailableDayGet: (
      day: string,
      params: RequestParams = {},
    ) =>
      this.request<BookableSlot[], HTTPValidationError>({
        path: `/meeting/available/${day}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetBookableTimesV2MeetingV2AvailableDayGet
     * @summary Get Bookable Times V2
     * @request GET:/meeting/v2/available/{day}
     * @secure
     */
    getBookableTimesV2MeetingV2AvailableDayGet: (
      day: string,
      query: {
        country: Country;
        product: Product;
        /**
         * Include Fully Booked
         * @default false
         */
        include_fully_booked?: boolean;
        /** Handler Id */
        handler_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookableSlotV2[], HTTPValidationError>({
        path: `/meeting/v2/available/${day}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetClosedWeekdaysV2MeetingV2ClosedWeekdaysGet
     * @summary Get Closed Weekdays V2
     * @request GET:/meeting/v2/closed-weekdays
     * @secure
     */
    getClosedWeekdaysV2MeetingV2ClosedWeekdaysGet: (
      query: {
        country: Country;
        product: Product;
      },
      params: RequestParams = {},
    ) =>
      this.request<number[], HTTPValidationError>({
        path: `/meeting/v2/closed-weekdays`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description NO blanco meetings booked on an Oslo day (default today), native applications only.
     *
     * @tags Meeting
     * @name GetBookedMeetingsMeetingV2AdminBookedGet
     * @summary Get Booked Meetings
     * @request GET:/meeting/v2/admin/booked
     * @secure
     */
    getBookedMeetingsMeetingV2AdminBookedGet: (
      query?: {
        /** Day */
        day?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookedMeetings, HTTPValidationError>({
        path: `/meeting/v2/admin/booked`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name CreateV2MeetingV2CreatePost
     * @summary Create V2
     * @request POST:/meeting/v2/create
     * @secure
     */
    createV2MeetingV2CreatePost: (
      data: CreateMeetingPayloadV2,
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2, HTTPValidationError>({
        path: `/meeting/v2/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name UpdateMeetingWithAssignMeetingV2UpdateMeetingIdPost
     * @summary Update Meeting With Assign
     * @request POST:/meeting/v2/update/{meeting_id}
     * @secure
     */
    updateMeetingWithAssignMeetingV2UpdateMeetingIdPost: (
      meetingId: string,
      data: UpdateAndAssignPayloadV2,
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2, HTTPValidationError>({
        path: `/meeting/v2/update/${meetingId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name MeetingSuccessfulMeetingV2SuccessPost
     * @summary Meeting Successful
     * @request POST:/meeting/v2/success
     * @secure
     */
    meetingSuccessfulMeetingV2SuccessPost: (
      query: {
        /** Meeting Id */
        meeting_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2, HTTPValidationError>({
        path: `/meeting/v2/success`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name CancelMeetingV2EndpointMeetingV2CancelMeetingIdPost
     * @summary Cancel Meeting V2 Endpoint
     * @request POST:/meeting/v2/cancel/{meeting_id}
     * @secure
     */
    cancelMeetingV2EndpointMeetingV2CancelMeetingIdPost: (
      meetingId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2, HTTPValidationError>({
        path: `/meeting/v2/cancel/${meetingId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name SetMeetingCallbackMeetingV2CallbackMeetingIdPost
     * @summary Set Meeting Callback
     * @request POST:/meeting/v2/callback/{meeting_id}
     * @secure
     */
    setMeetingCallbackMeetingV2CallbackMeetingIdPost: (
      meetingId: string,
      query?: {
        /** Priority */
        priority?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2, HTTPValidationError>({
        path: `/meeting/v2/callback/${meetingId}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  meetingDistribution = {
    /**
     * No description
     *
     * @tags Meeting
     * @name PreviewDistributionMeetingDistributionPreviewGet
     * @summary Preview Distribution
     * @request GET:/meeting_distribution/preview
     * @secure
     */
    previewDistributionMeetingDistributionPreviewGet: (
      params: RequestParams = {},
    ) =>
      this.request<Record<string, Employee>, any>({
        path: `/meeting_distribution/preview`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The whole plan, not only the assignment map. A separate endpoint rather than a wider `/preview` response: the frontend reads `/preview` as `{meeting_id: Employee}` and changing that shape would break it, while new *payload* fields are additive. This one carries the planner's own output — the `snapshot_revision` a save quotes back, the per-handler load before and after, and why each unplaced candidate was unplaced. Write-free, like `/preview`: nothing here persists a score or touches a meeting.
     *
     * @tags Meeting
     * @name PlanDistributionMeetingDistributionPlanGet
     * @summary Plan Distribution
     * @request GET:/meeting_distribution/plan
     * @secure
     */
    planDistributionMeetingDistributionPlanGet: (params: RequestParams = {}) =>
      this.request<PlanResult, any>({
        path: `/meeting_distribution/plan`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetAvailableMeetingsMethodMeetingDistributionGetAvailableMeetingsGet
     * @summary Get Available Meetings Method
     * @request GET:/meeting_distribution/get-available-meetings
     * @secure
     */
    getAvailableMeetingsMethodMeetingDistributionGetAvailableMeetingsGet: (
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2[], any>({
        path: `/meeting_distribution/get-available-meetings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name GetAvailableHandlerMeetingDistributionGetAvailableHandlersGet
     * @summary Get Available Handler
     * @request GET:/meeting_distribution/get-available-handlers
     * @secure
     */
    getAvailableHandlerMeetingDistributionGetAvailableHandlersGet: (
      params: RequestParams = {},
    ) =>
      this.request<Employee[], any>({
        path: `/meeting_distribution/get-available-handlers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name ResetDevMeetingsMeetingDistributionResetDevMeetingsGet
     * @summary Reset Dev Meetings
     * @request GET:/meeting_distribution/reset-dev-meetings
     * @secure
     */
    resetDevMeetingsMeetingDistributionResetDevMeetingsGet: (
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2[], any>({
        path: `/meeting_distribution/reset-dev-meetings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting
     * @name AssignHandlerToMeetingMeetingDistributionAssignHandlerToMeetingPost
     * @summary Assign Handler To Meeting
     * @request POST:/meeting_distribution/assign-handler-to-meeting
     * @secure
     */
    assignHandlerToMeetingMeetingDistributionAssignHandlerToMeetingPost: (
      data: AssignHandlerToMeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<MeetingV2, HTTPValidationError>({
        path: `/meeting_distribution/assign-handler-to-meeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Confirm a revision-fenced batch of real ZRM meeting assignments.
     *
     * @tags Meeting
     * @name SavePreviewAssignmentsMethodMeetingDistributionSavePreviewAssignmentsPost
     * @summary Save Preview Assignments Method
     * @request POST:/meeting_distribution/save-preview-assignments
     * @secure
     */
    savePreviewAssignmentsMethodMeetingDistributionSavePreviewAssignmentsPost: (
      data: SavePreviewAssignmentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, number>, HTTPValidationError>({
        path: `/meeting_distribution/save-preview-assignments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The settings in force: multipliers and their level definitions, count band and D-rule. Answers the seeded version 1 while the collection is empty — nothing is written by a read, so "never configured" and "configured back to the defaults" stay distinguishable in the audit trail.
     *
     * @tags Meeting
     * @name GetDistributionSettingsMeetingDistributionSettingsGet
     * @summary Get Distribution Settings
     * @request GET:/meeting_distribution/settings
     * @secure
     */
    getDistributionSettingsMeetingDistributionSettingsGet: (
      params: RequestParams = {},
    ) =>
      this.request<MeetingDistributionSettings, any>({
        path: `/meeting_distribution/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Insert a new settings version, carrying the untouched sub-documents forward. Not under `distribution_lock()`: this writes a new document rather than mutating the one a run is reading, and a run that started before the save keeps planning under the version it read — which is exactly what `multipliers_version` on the owner records has to mean.
     *
     * @tags Meeting
     * @name SaveDistributionSettingsMeetingDistributionSettingsPost
     * @summary Save Distribution Settings
     * @request POST:/meeting_distribution/settings
     * @secure
     */
    saveDistributionSettingsMeetingDistributionSettingsPost: (
      data: MeetingDistributionSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<MeetingDistributionSettings, HTTPValidationError>({
        path: `/meeting_distribution/settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The audit trail, newest first: every saved version with the team lead who saved it. The collection is append-only precisely so that a decision can be read back under the numbers it was made on; without a way to read the trail, "which fit was in force in week 37" needs a Mongo shell. Empty while nothing has been saved — the seeded version 1 `GET /settings` answers with was never written by anybody.
     *
     * @tags Meeting
     * @name GetDistributionSettingsVersionsMeetingDistributionSettingsVersionsGet
     * @summary Get Distribution Settings Versions
     * @request GET:/meeting_distribution/settings/versions
     * @secure
     */
    getDistributionSettingsVersionsMeetingDistributionSettingsVersionsGet: (
      params: RequestParams = {},
    ) =>
      this.request<MeetingDistributionSettings[], any>({
        path: `/meeting_distribution/settings/versions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The newest run report, whichever job wrote it — **counts only**. ``?mode=`` narrows to one writer, and for the by-hand jobs it is the only way to reach their report at all: the D poll stores one every minute, so a refit's candidate (`?mode=refit`, the refit runbook's read) is behind a minute's worth of sweeps within a minute of the run. The stored document carries the per-meeting halves as well (an outcome per meeting id, an exception repr per failed one, the whole candidate list); this answers with their sizes instead, because the question the endpoint is asked is "what did the last run do" and the ids would put meeting identifiers into every cache between here and the browser. They stay in ``meeting_distribution_runs`` for whoever is debugging one run. ``null`` while nothing has run — turned off, the crons return before reading anything, so "no run yet" is the ordinary state rather than an error. The hourly collector is the run that carries the ``health`` section; a 60-second poll's report has its own counters and no population aggregates, which is deliberate.
     *
     * @tags Meeting
     * @name GetLatestRunReportMeetingDistributionReportLatestGet
     * @summary Get Latest Run Report
     * @request GET:/meeting_distribution/report/latest
     * @secure
     */
    getLatestRunReportMeetingDistributionReportLatestGet: (
      query?: {
        /** Mode */
        mode?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<RunReportDigest | null, HTTPValidationError>({
        path: `/meeting_distribution/report/latest`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Every application line booked to an Oslo accounting day in ``[date_from, date_to]``, with its current and first owner, and each KH's totals over the same rows. One answer for both, so the applications view and the per-KH view cannot disagree. At most 92 days; a period with more lines than the cap is a 422 rather than a partial total. Read-only.
     *
     * @tags Meeting
     * @name GetDistributionDashboardMeetingDistributionDashboardDistributionGet
     * @summary Get Distribution Dashboard
     * @request GET:/meeting_distribution/dashboard/distribution
     * @secure
     */
    getDistributionDashboardMeetingDistributionDashboardDistributionGet: (
      query: {
        /**
         * Date From
         * @format date
         */
        date_from: string;
        /**
         * Date To
         * @format date
         */
        date_to: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DistributionDashboard, HTTPValidationError>({
        path: `/meeting_distribution/dashboard/distribution`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Each KH's active meetings in the Oslo days ``[date_from, date_to]`` (at most 31), with the case owner, scheduled hours and absences. ``handler_ids`` (at most 50) defaults to the KH pool (the Employee scheduling roster). Read-only.
     *
     * @tags Meeting
     * @name GetDistributionCalendarMeetingDistributionDashboardCalendarGet
     * @summary Get Distribution Calendar
     * @request GET:/meeting_distribution/dashboard/calendar
     * @secure
     */
    getDistributionCalendarMeetingDistributionDashboardCalendarGet: (
      query: {
        /**
         * Date From
         * @format date
         */
        date_from: string;
        /**
         * Date To
         * @format date
         */
        date_to: string;
        /** Handler Ids */
        handler_ids?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DistributionCalendar, HTTPValidationError>({
        path: `/meeting_distribution/dashboard/calendar`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The active owner record for one application — what the Freja button renders from. ``null`` rather than a 404 when nobody owns the case: "not handed out yet" is the state the button exists for, and a 404 would have the client tell the two apart by status code.
     *
     * @tags Meeting
     * @name GetCaseOwnerMeetingDistributionCaseApplicationIdGet
     * @summary Get Case Owner
     * @request GET:/meeting_distribution/case/{application_id}
     * @secure
     */
    getCaseOwnerMeetingDistributionCaseApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<CaseOwner | null, HTTPValidationError>({
        path: `/meeting_distribution/case/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Hand this case out now, by the ranking. The same decision a D trigger takes, taken early: if D has not arrived the value is provisional — the amount, the bid picture so far, the stored credit check — and D completes it once, later, in the same accounting week.
     *
     * @tags Meeting
     * @name AssignOwnerMeetingDistributionAssignOwnerPost
     * @summary Assign Owner
     * @request POST:/meeting_distribution/assign-owner
     * @secure
     */
    assignOwnerMeetingDistributionAssignOwnerPost: (
      data: AssignOwnerPayload,
      params: RequestParams = {},
    ) =>
      this.request<CaseOwner, HTTPValidationError>({
        path: `/meeting_distribution/assign-owner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description A KA's own choice of handler — the first one, or a change. Every owner change goes through here rather than through a raw handler write, which is what makes the value lines and the case's future meetings follow the owner. A case that has been taken over is refused with a 409 pointing at `override`.
     *
     * @tags Meeting
     * @name AssignOwnerManualMeetingDistributionAssignOwnerManualPost
     * @summary Assign Owner Manual
     * @request POST:/meeting_distribution/assign-owner/manual
     * @secure
     */
    assignOwnerManualMeetingDistributionAssignOwnerManualPost: (
      data: AssignOwnerManualPayload,
      params: RequestParams = {},
    ) =>
      this.request<CaseOwner, HTTPValidationError>({
        path: `/meeting_distribution/assign-owner/manual`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The team lead's override, and the manual mortgage takeover. With a `takeover_reason` the new record leaves the blanco pool: its value lines are copied over unchanged so the money stays readable on the case, and the accumulators skip the record rather than any number being nulled.
     *
     * @tags Meeting
     * @name OverrideOwnerMeetingDistributionOverridePost
     * @summary Override Owner
     * @request POST:/meeting_distribution/override
     * @secure
     */
    overrideOwnerMeetingDistributionOverridePost: (
      data: OverrideOwnerPayload,
      params: RequestParams = {},
    ) =>
      this.request<CaseOwner, HTTPValidationError>({
        path: `/meeting_distribution/override`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description One meeting to somebody else, the case unchanged. Answers with the case's *owner* record, not with the meeting: what the caller has to see is that the ownership did not move. The mark is what keeps the reconciliation from taking the meeting back (`services/meeting_distribution/handovers.py`).
     *
     * @tags Meeting
     * @name HandOverMeetingMeetingDistributionHandoverPost
     * @summary Hand Over Meeting
     * @request POST:/meeting_distribution/handover
     * @secure
     */
    handOverMeetingMeetingDistributionHandoverPost: (
      data: HandoverPayload,
      params: RequestParams = {},
    ) =>
      this.request<CaseOwner, HTTPValidationError>({
        path: `/meeting_distribution/handover`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  todomaker = {
    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name ListTodoTodomakerListGet
     * @summary List Todo
     * @request GET:/todomaker/list
     * @secure
     */
    listTodoTodomakerListGet: (
      query?: {
        /**
         * Pool Page
         * The page of the shared pool to send, 1-based.
         * @min 1
         * @default 1
         */
        pool_page?: number;
        /**
         * Pool Size
         * Pool leads per page.
         * @min 1
         * @max 350
         * @default 200
         */
        pool_size?: number;
        /**
         * Pool Campaign Id
         * Page only this campaign's pool. Ignored unless it is one of the caller's active campaigns.
         */
        pool_campaign_id?: string | null;
        /**
         * Pool Show All
         * Every open lead of the campaigns, whoever owns it, read-only. Team leads and developers only.
         * @default false
         */
        pool_show_all?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TodoList, HTTPValidationError>({
        path: `/todomaker/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The handler's eligible campaigns with pool counts + paused state (campaign focus).
     *
     * @tags Todomaker, Todomaker
     * @name CampaignsOverviewTodomakerCampaignsGet
     * @summary Campaigns Overview
     * @request GET:/todomaker/campaigns
     * @secure
     */
    campaignsOverviewTodomakerCampaignsGet: (params: RequestParams = {}) =>
      this.request<TodomakerCampaignList, any>({
        path: `/todomaker/campaigns`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The customer's applications and live offers, for one expanded row. Per-row rather than on the list: the shared pool carries customers nobody claimed, and folding this into the snapshot would run one apps-mgr read each, every refresh. `current_application_id` is the application the expanded lead is about. The response is capped, and a customer's book can run into the hundreds, so without it the one application the handler is calling about can fall off the end.
     *
     * @tags Todomaker, Todomaker
     * @name CustomerApplicationsTodomakerCustomerApplicationsCustomerIdGet
     * @summary Customer Applications
     * @request GET:/todomaker/customer-applications/{customer_id}
     * @secure
     */
    customerApplicationsTodomakerCustomerApplicationsCustomerIdGet: (
      customerId: string,
      query?: {
        /**
         * Current Application Id
         * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
         */
        current_application_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<TodoCustomerApplicationList, HTTPValidationError>({
        path: `/todomaker/customer-applications/${customerId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description What else this customer has open in the process campaigns, for one expanded row. One lead per customer, so a case that loses to the lead's campaign has no row of its own; this is where the handler working the lead sees it. Only for a caller who holds a lead on the customer.
     *
     * @tags Todomaker, Todomaker
     * @name OtherCasesTodomakerOtherCasesCustomerIdGet
     * @summary Other Cases
     * @request GET:/todomaker/other-cases/{customer_id}
     * @secure
     */
    otherCasesTodomakerOtherCasesCustomerIdGet: (
      customerId: string,
      params: RequestParams = {},
    ) =>
      this.request<TodoOtherCaseList, HTTPValidationError>({
        path: `/todomaker/other-cases/${customerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pause/resume one eligible campaign for this handler. Pausing hides its pool leads only — claimed leads, callbacks and meetings are unaffected.
     *
     * @tags Todomaker, Todomaker
     * @name SetCampaignPausedTodomakerCampaignsPausePost
     * @summary Set Campaign Paused
     * @request POST:/todomaker/campaigns/pause
     * @secure
     */
    setCampaignPausedTodomakerCampaignsPausePost: (
      data: BodySetCampaignPausedTodomakerCampaignsPausePost,
      params: RequestParams = {},
    ) =>
      this.request<TodomakerCampaignList, HTTPValidationError>({
        path: `/todomaker/campaigns/pause`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Check in: the handler is active until `active_until`, and any work in ZRM pushes that forward.
     *
     * @tags Todomaker, Todomaker
     * @name CheckInTodomakerCheckInPost
     * @summary Check In
     * @request POST:/todomaker/check-in
     * @secure
     */
    checkInTodomakerCheckInPost: (params: RequestParams = {}) =>
      this.request<TodomakerPresence, any>({
        path: `/todomaker/check-in`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Check out, giving back the lead they have open. Booked personal callbacks stay theirs.
     *
     * @tags Todomaker, Todomaker
     * @name CheckOutTodomakerCheckOutPost
     * @summary Check Out
     * @request POST:/todomaker/check-out
     * @secure
     */
    checkOutTodomakerCheckOutPost: (params: RequestParams = {}) =>
      this.request<TodomakerPresence, any>({
        path: `/todomaker/check-out`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name ClaimTodomakerClaimPost
     * @summary Claim
     * @request POST:/todomaker/claim
     * @secure
     */
    claimTodomakerClaimPost: (
      data: BodyClaimTodomakerClaimPost,
      params: RequestParams = {},
    ) =>
      this.request<TodoItem, HTTPValidationError>({
        path: `/todomaker/claim`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name ReleaseTodomakerReleasePost
     * @summary Release
     * @request POST:/todomaker/release
     * @secure
     */
    releaseTodomakerReleasePost: (
      data: BodyReleaseTodomakerReleasePost,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/todomaker/release`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Per-lead no_contact/failure/discard substatus options for the outcome menus. Ownership-checked — see `Todomaker.outcome_options`. Without it this read would be the one route here with no check at all.
     *
     * @tags Todomaker, Todomaker
     * @name OutcomeOptionsTodomakerOutcomesPost
     * @summary Outcome Options
     * @request POST:/todomaker/outcomes
     * @secure
     */
    outcomeOptionsTodomakerOutcomesPost: (
      data: BodyOutcomeOptionsTodomakerOutcomesPost,
      params: RequestParams = {},
    ) =>
      this.request<Outcomes, HTTPValidationError>({
        path: `/todomaker/outcomes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name OutcomeSuccessTodomakerOutcomeSuccessPost
     * @summary Outcome Success
     * @request POST:/todomaker/outcome/success
     * @secure
     */
    outcomeSuccessTodomakerOutcomeSuccessPost: (
      data: BodyOutcomeSuccessTodomakerOutcomeSuccessPost,
      params: RequestParams = {},
    ) =>
      this.request<TodoItem, HTTPValidationError>({
        path: `/todomaker/outcome/success`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name OutcomeCallBackTodomakerOutcomeCallBackPost
     * @summary Outcome Call Back
     * @request POST:/todomaker/outcome/call_back
     * @secure
     */
    outcomeCallBackTodomakerOutcomeCallBackPost: (
      data: BodyOutcomeCallBackTodomakerOutcomeCallBackPost,
      params: RequestParams = {},
    ) =>
      this.request<TodoItem, HTTPValidationError>({
        path: `/todomaker/outcome/call_back`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name OutcomePostponeTodomakerOutcomePostponePost
     * @summary Outcome Postpone
     * @request POST:/todomaker/outcome/postpone
     * @secure
     */
    outcomePostponeTodomakerOutcomePostponePost: (
      data: BodyOutcomePostponeTodomakerOutcomePostponePost,
      params: RequestParams = {},
    ) =>
      this.request<TodoItem, HTTPValidationError>({
        path: `/todomaker/outcome/postpone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name OutcomeNoContactTodomakerOutcomeNoContactPost
     * @summary Outcome No Contact
     * @request POST:/todomaker/outcome/no_contact
     * @secure
     */
    outcomeNoContactTodomakerOutcomeNoContactPost: (
      data: BodyOutcomeNoContactTodomakerOutcomeNoContactPost,
      params: RequestParams = {},
    ) =>
      this.request<TodoItem, HTTPValidationError>({
        path: `/todomaker/outcome/no_contact`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name OutcomeFailureTodomakerOutcomeFailurePost
     * @summary Outcome Failure
     * @request POST:/todomaker/outcome/failure
     * @secure
     */
    outcomeFailureTodomakerOutcomeFailurePost: (
      data: BodyOutcomeFailureTodomakerOutcomeFailurePost,
      params: RequestParams = {},
    ) =>
      this.request<TodoItem, HTTPValidationError>({
        path: `/todomaker/outcome/failure`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker, Todomaker
     * @name OutcomeDiscardTodomakerOutcomeDiscardPost
     * @summary Outcome Discard
     * @request POST:/todomaker/outcome/discard
     * @secure
     */
    outcomeDiscardTodomakerOutcomeDiscardPost: (
      data: BodyOutcomeDiscardTodomakerOutcomeDiscardPost,
      params: RequestParams = {},
    ) =>
      this.request<TodoItem, HTTPValidationError>({
        path: `/todomaker/outcome/discard`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker Admin, Todomaker Admin
     * @name GetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersGet
     * @summary Get Campaign Sellers
     * @request GET:/todomaker/admin/campaigns/{campaign_id}/sellers
     * @secure
     */
    getCampaignSellersTodomakerAdminCampaignsCampaignIdSellersGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignSellers, HTTPValidationError>({
        path: `/todomaker/admin/campaigns/${campaignId}/sellers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Todomaker Admin, Todomaker Admin
     * @name SetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersPut
     * @summary Set Campaign Sellers
     * @request PUT:/todomaker/admin/campaigns/{campaign_id}/sellers
     * @secure
     */
    setCampaignSellersTodomakerAdminCampaignsCampaignIdSellersPut: (
      campaignId: string,
      data: BodySetCampaignSellersTodomakerAdminCampaignsCampaignIdSellersPut,
      params: RequestParams = {},
    ) =>
      this.request<CampaignSellers, HTTPValidationError>({
        path: `/todomaker/admin/campaigns/${campaignId}/sellers`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  notificationRota = {
    /**
     * No description
     *
     * @tags Notification Rota, Notification Rota
     * @name GetNotificationRotasNotificationRotaGet
     * @summary Get Notification Rotas
     * @request GET:/notification-rota
     * @secure
     */
    getNotificationRotasNotificationRotaGet: (params: RequestParams = {}) =>
      this.request<NotificationRota[], any>({
        path: `/notification-rota`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification Rota, Notification Rota
     * @name SetNotificationRotaNotificationRotaProductCountryPut
     * @summary Set Notification Rota
     * @request PUT:/notification-rota/{product}/{country}
     * @secure
     */
    setNotificationRotaNotificationRotaProductCountryPut: (
      product: Product,
      country: Country,
      data: NotificationRotaPayload,
      params: RequestParams = {},
    ) =>
      this.request<NotificationRota, HTTPValidationError>({
        path: `/notification-rota/${product}/${country}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  messagingCenter = {
    /**
     * @description Live OPEN items in the caller's countries: free ones first, then the oldest last message first.
     *
     * @tags messaging-center
     * @name ListItemsMessagingCenterGet
     * @summary List Items
     * @request GET:/messaging-center
     * @secure
     */
    listItemsMessagingCenterGet: (params: RequestParams = {}) =>
      this.request<MessagingCenterListItem[], any>({
        path: `/messaging-center`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messaging-center
     * @name GetItemMessagingCenterItemIdGet
     * @summary Get Item
     * @request GET:/messaging-center/{item_id}
     * @secure
     */
    getItemMessagingCenterItemIdGet: (
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<MessagingCenterItemDetail, HTTPValidationError>({
        path: `/messaging-center/${itemId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Claim the item, or extend your own claim. 409 names whoever holds it.
     *
     * @tags messaging-center
     * @name ClaimItemMessagingCenterItemIdClaimPost
     * @summary Claim Item
     * @request POST:/messaging-center/{item_id}/claim
     * @secure
     */
    claimItemMessagingCenterItemIdClaimPost: (
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<MessagingCenterListItem, HTTPValidationError>({
        path: `/messaging-center/${itemId}/claim`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags messaging-center
     * @name ReleaseItemMessagingCenterItemIdReleasePost
     * @summary Release Item
     * @request POST:/messaging-center/{item_id}/release
     * @secure
     */
    releaseItemMessagingCenterItemIdReleasePost: (
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<MessagingCenterListItem, HTTPValidationError>({
        path: `/messaging-center/${itemId}/release`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Close the item. 409 with `message_count` when a message came in after the client read it.
     *
     * @tags messaging-center
     * @name DoneItemMessagingCenterItemIdDonePost
     * @summary Done Item
     * @request POST:/messaging-center/{item_id}/done
     * @secure
     */
    doneItemMessagingCenterItemIdDonePost: (
      itemId: string,
      data: DoneBody,
      params: RequestParams = {},
    ) =>
      this.request<MessagingCenterListItem, HTTPValidationError>({
        path: `/messaging-center/${itemId}/done`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  document = {
    /**
     * No description
     *
     * @tags Document
     * @name GetDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet
     * @summary Get Document Meta
     * @request GET:/document/get/meta/{customer_id}/{document_id}
     * @secure
     */
    getDocumentMetaDocumentGetMetaCustomerIdDocumentIdGet: (
      customerId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentMeta, HTTPValidationError>({
        path: `/document/get/meta/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name GetDocumentDocumentGetCustomerIdDocumentIdGet
     * @summary Get Document
     * @request GET:/document/get/{customer_id}/{document_id}
     * @secure
     */
    getDocumentDocumentGetCustomerIdDocumentIdGet: (
      customerId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<CustomerDocument, HTTPValidationError>({
        path: `/document/get/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name CreateDocumentDocumentSavePost
     * @summary Create Document
     * @request POST:/document/save
     * @secure
     */
    createDocumentDocumentSavePost: (
      data: DocumentCreate,
      params: RequestParams = {},
    ) =>
      this.request<CustomerDocument, HTTPValidationError>({
        path: `/document/save`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentTypesDocumentTypesGet
     * @summary Document Types
     * @request GET:/document/types
     * @secure
     */
    documentTypesDocumentTypesGet: (params: RequestParams = {}) =>
      this.request<DocumentType[], any>({
        path: `/document/types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name GetAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet
     * @summary Get Attached Documents Of Application
     * @request GET:/document/attached/{application_id}
     * @secure
     */
    getAttachedDocumentsOfApplicationDocumentAttachedApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentAssignation[], HTTPValidationError>({
        path: `/document/attached/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name AttachDocumentToApplicationDocumentAttachApplicationIdPost
     * @summary Attach Document To Application
     * @request POST:/document/attach/{application_id}
     * @secure
     */
    attachDocumentToApplicationDocumentAttachApplicationIdPost: (
      applicationId: string,
      data: DocumentAssignation,
      params: RequestParams = {},
    ) =>
      this.request<DocumentAssignation[], HTTPValidationError>({
        path: `/document/attach/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  banks = {
    /**
     * No description
     *
     * @tags Banks
     * @name GetAllCreditorsBanksAllGet
     * @summary Get All Creditors
     * @request GET:/banks/all
     * @secure
     */
    getAllCreditorsBanksAllGet: (params: RequestParams = {}) =>
      this.request<Bank[], any>({
        path: `/banks/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name GetCreditorsBanksGetPost
     * @summary Get Creditors
     * @request POST:/banks/get
     * @secure
     */
    getCreditorsBanksGetPost: (
      data: GetBanksPayload,
      params: RequestParams = {},
    ) =>
      this.request<Bank[], HTTPValidationError>({
        path: `/banks/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name GetAllIntegrationsBanksAllIntegrationsGet
     * @summary Get All Integrations
     * @request GET:/banks/all_integrations
     * @secure
     */
    getAllIntegrationsBanksAllIntegrationsGet: (params: RequestParams = {}) =>
      this.request<Integration[], any>({
        path: `/banks/all_integrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name GetIntegrationsBanksGetIntegrationsPost
     * @summary Get Integrations
     * @request POST:/banks/get_integrations
     * @secure
     */
    getIntegrationsBanksGetIntegrationsPost: (
      data: IntegrationQuery,
      params: RequestParams = {},
    ) =>
      this.request<Integration[], HTTPValidationError>({
        path: `/banks/get_integrations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  creditors = {
    /**
     * No description
     *
     * @tags Creditors
     * @name GetAllCreditorsCreditorsAllGet
     * @summary Get All Creditors
     * @request GET:/creditors/all
     * @secure
     */
    getAllCreditorsCreditorsAllGet: (params: RequestParams = {}) =>
      this.request<Bank[], any>({
        path: `/creditors/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creditors
     * @name GetCreditorsCreditorsGetPost
     * @summary Get Creditors
     * @request POST:/creditors/get
     * @secure
     */
    getCreditorsCreditorsGetPost: (
      data: GetBanksPayload,
      params: RequestParams = {},
    ) =>
      this.request<Bank[], HTTPValidationError>({
        path: `/creditors/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creditors
     * @name GetAllIntegrationsCreditorsAllIntegrationsGet
     * @summary Get All Integrations
     * @request GET:/creditors/all_integrations
     * @secure
     */
    getAllIntegrationsCreditorsAllIntegrationsGet: (
      params: RequestParams = {},
    ) =>
      this.request<Integration[], any>({
        path: `/creditors/all_integrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Creditors
     * @name GetIntegrationsCreditorsGetIntegrationsPost
     * @summary Get Integrations
     * @request POST:/creditors/get_integrations
     * @secure
     */
    getIntegrationsCreditorsGetIntegrationsPost: (
      data: IntegrationQuery,
      params: RequestParams = {},
    ) =>
      this.request<Integration[], HTTPValidationError>({
        path: `/creditors/get_integrations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  schedule = {
    /**
     * No description
     *
     * @tags Advisor Schedule
     * @name ScheduleDaySchedulePost
     * @summary Schedule Day
     * @request POST:/schedule/
     * @secure
     */
    scheduleDaySchedulePost: (
      data: DaySlotDocPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/schedule/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advisor Schedule
     * @name GetScheduleOfDayScheduleDayGet
     * @summary Get Schedule Of Day
     * @request GET:/schedule/{day}
     * @secure
     */
    getScheduleOfDayScheduleDayGet: (day: string, params: RequestParams = {}) =>
      this.request<DaySlotDoc, HTTPValidationError>({
        path: `/schedule/${day}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advisor Schedule
     * @name GetScheduleOfDayByCountryAndProductScheduleDayProductCountryGet
     * @summary Get Schedule Of Day By Country And Product
     * @request GET:/schedule/{day}/{product}/{country}
     * @secure
     */
    getScheduleOfDayByCountryAndProductScheduleDayProductCountryGet: (
      day: string,
      product: Product,
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<DaySlotDoc, HTTPValidationError>({
        path: `/schedule/${day}/${product}/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  employeeSchedule = {
    /**
     * No description
     *
     * @tags Employee Schedule
     * @name GetOperatingHoursEmployeeScheduleOperatingHoursGet
     * @summary Get Operating Hours
     * @request GET:/employee-schedule/operating-hours
     * @secure
     */
    getOperatingHoursEmployeeScheduleOperatingHoursGet: (
      query: {
        product: Product;
        country: Country;
      },
      params: RequestParams = {},
    ) =>
      this.request<OperatingHoursDoc, HTTPValidationError>({
        path: `/employee-schedule/operating-hours`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name AppendOperatingHoursEmployeeScheduleOperatingHoursPost
     * @summary Append Operating Hours
     * @request POST:/employee-schedule/operating-hours
     * @secure
     */
    appendOperatingHoursEmployeeScheduleOperatingHoursPost: (
      data: OperatingHoursData,
      params: RequestParams = {},
    ) =>
      this.request<OperatingHoursDoc, HTTPValidationError>({
        path: `/employee-schedule/operating-hours`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name GetOperatingHoursHistoryEmployeeScheduleOperatingHoursHistoryGet
     * @summary Get Operating Hours History
     * @request GET:/employee-schedule/operating-hours/history
     * @secure
     */
    getOperatingHoursHistoryEmployeeScheduleOperatingHoursHistoryGet: (
      query: {
        product: Product;
        country: Country;
      },
      params: RequestParams = {},
    ) =>
      this.request<OperatingHoursDoc[], HTTPValidationError>({
        path: `/employee-schedule/operating-hours/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name GetEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleGet
     * @summary Get Employee Schedule
     * @request GET:/employee-schedule/employees/{employee_user_id}/schedule
     * @secure
     */
    getEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleGet: (
      employeeUserId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        | (
            | ({
                mode: "STANDARD";
              } & StandardSchedule)
            | ({
                mode: "CUSTOM";
              } & CustomSchedule)
          )
        | null,
        HTTPValidationError
      >({
        path: `/employee-schedule/employees/${employeeUserId}/schedule`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name ReplaceEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdSchedulePut
     * @summary Replace Employee Schedule
     * @request PUT:/employee-schedule/employees/{employee_user_id}/schedule
     * @secure
     */
    replaceEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdSchedulePut: (
      employeeUserId: string,
      data: StandardScheduleData | CustomScheduleData,
      params: RequestParams = {},
    ) =>
      this.request<ScheduleResponse, HTTPValidationError>({
        path: `/employee-schedule/employees/${employeeUserId}/schedule`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name DeleteEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleDelete
     * @summary Delete Employee Schedule
     * @request DELETE:/employee-schedule/employees/{employee_user_id}/schedule
     * @secure
     */
    deleteEmployeeScheduleEmployeeScheduleEmployeesEmployeeUserIdScheduleDelete:
      (employeeUserId: string, params: RequestParams = {}) =>
        this.request<void, HTTPValidationError>({
          path: `/employee-schedule/employees/${employeeUserId}/schedule`,
          method: "DELETE",
          secure: true,
          ...params,
        }),

    /**
     * @description Advisory pre-save check: which proposed slots stay open during a standard operating-hours break.
     *
     * @tags Employee Schedule
     * @name GetStandardBreakConflictsEmployeeScheduleEmployeesEmployeeUserIdScheduleStandardBreakConflictsPost
     * @summary Get Standard Break Conflicts
     * @request POST:/employee-schedule/employees/{employee_user_id}/schedule/standard-break-conflicts
     * @secure
     */
    getStandardBreakConflictsEmployeeScheduleEmployeesEmployeeUserIdScheduleStandardBreakConflictsPost:
      (
        employeeUserId: string,
        data: StandardScheduleData | CustomScheduleData,
        params: RequestParams = {},
      ) =>
        this.request<StandardBreakConflict[], HTTPValidationError>({
          path: `/employee-schedule/employees/${employeeUserId}/schedule/standard-break-conflicts`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Advisory pre-save check: which proposed slots fall outside (or have no) operating hours.
     *
     * @tags Employee Schedule
     * @name GetOperatingHoursViolationsEmployeeScheduleEmployeesEmployeeUserIdScheduleOperatingHoursViolationsPost
     * @summary Get Operating Hours Violations
     * @request POST:/employee-schedule/employees/{employee_user_id}/schedule/operating-hours-violations
     * @secure
     */
    getOperatingHoursViolationsEmployeeScheduleEmployeesEmployeeUserIdScheduleOperatingHoursViolationsPost:
      (
        employeeUserId: string,
        data: StandardScheduleData | CustomScheduleData,
        params: RequestParams = {},
      ) =>
        this.request<OperatingHoursViolation[], HTTPValidationError>({
          path: `/employee-schedule/employees/${employeeUserId}/schedule/operating-hours-violations`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name ListAbsencesEmployeeScheduleAbsencesGet
     * @summary List Absences
     * @request GET:/employee-schedule/absences
     * @secure
     */
    listAbsencesEmployeeScheduleAbsencesGet: (
      query?: {
        /** User Id */
        user_id?: string | null;
        /**
         * Include Deleted
         * @default false
         */
        include_deleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AbsenceDoc[], HTTPValidationError>({
        path: `/employee-schedule/absences`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name CreateAbsenceEmployeeScheduleAbsencesPost
     * @summary Create Absence
     * @request POST:/employee-schedule/absences
     * @secure
     */
    createAbsenceEmployeeScheduleAbsencesPost: (
      data: AbsenceData,
      params: RequestParams = {},
    ) =>
      this.request<AbsenceDoc, HTTPValidationError>({
        path: `/employee-schedule/absences`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name UpdateAbsenceEmployeeScheduleAbsencesAbsenceIdPut
     * @summary Update Absence
     * @request PUT:/employee-schedule/absences/{absence_id}
     * @secure
     */
    updateAbsenceEmployeeScheduleAbsencesAbsenceIdPut: (
      absenceId: string,
      data: AbsenceData,
      params: RequestParams = {},
    ) =>
      this.request<AbsenceDoc, HTTPValidationError>({
        path: `/employee-schedule/absences/${absenceId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name DeleteAbsenceEmployeeScheduleAbsencesAbsenceIdDelete
     * @summary Delete Absence
     * @request DELETE:/employee-schedule/absences/{absence_id}
     * @secure
     */
    deleteAbsenceEmployeeScheduleAbsencesAbsenceIdDelete: (
      absenceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/employee-schedule/absences/${absenceId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name ListOverridesEmployeeScheduleOverridesGet
     * @summary List Overrides
     * @request GET:/employee-schedule/overrides
     * @secure
     */
    listOverridesEmployeeScheduleOverridesGet: (
      query: {
        /**
         * Date From
         * @format date
         */
        date_from: string;
        /**
         * Date To
         * @format date
         */
        date_to: string;
        /** Product */
        product?: Product | null;
        /** Country */
        country?: Country | null;
        /**
         * Include Deleted
         * @default false
         */
        include_deleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<DayOverride[], HTTPValidationError>({
        path: `/employee-schedule/overrides`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name CreateOverrideEmployeeScheduleOverridesPost
     * @summary Create Override
     * @request POST:/employee-schedule/overrides
     * @secure
     */
    createOverrideEmployeeScheduleOverridesPost: (
      data: DayOverrideData,
      params: RequestParams = {},
    ) =>
      this.request<DayOverride, HTTPValidationError>({
        path: `/employee-schedule/overrides`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name GetOverrideEmployeeScheduleOverridesOverrideIdGet
     * @summary Get Override
     * @request GET:/employee-schedule/overrides/{override_id}
     * @secure
     */
    getOverrideEmployeeScheduleOverridesOverrideIdGet: (
      overrideId: string,
      params: RequestParams = {},
    ) =>
      this.request<DayOverride, HTTPValidationError>({
        path: `/employee-schedule/overrides/${overrideId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name UpdateOverrideEmployeeScheduleOverridesOverrideIdPut
     * @summary Update Override
     * @request PUT:/employee-schedule/overrides/{override_id}
     * @secure
     */
    updateOverrideEmployeeScheduleOverridesOverrideIdPut: (
      overrideId: string,
      data: DayOverrideData,
      params: RequestParams = {},
    ) =>
      this.request<DayOverride, HTTPValidationError>({
        path: `/employee-schedule/overrides/${overrideId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name DeleteOverrideEmployeeScheduleOverridesOverrideIdDelete
     * @summary Delete Override
     * @request DELETE:/employee-schedule/overrides/{override_id}
     * @secure
     */
    deleteOverrideEmployeeScheduleOverridesOverrideIdDelete: (
      overrideId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/employee-schedule/overrides/${overrideId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name GetWorkingEmployeeScheduleWorkingGet
     * @summary Get Working
     * @request GET:/employee-schedule/working
     * @secure
     */
    getWorkingEmployeeScheduleWorkingGet: (
      query: {
        product: Product;
        country: Country;
        /** Date */
        date?: string | null;
        /** At */
        at?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkingResponse, HTTPValidationError>({
        path: `/employee-schedule/working`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Everyone in `departments`/`countries` working on `date` (or at the UTC instant `at`). `products` narrows which service lines' schedules are consulted; omitted means every product.
     *
     * @tags Employee Schedule
     * @name GetWorkingInDepartmentsEmployeeScheduleWorkingInDepartmentsGet
     * @summary Get Working In Departments
     * @request GET:/employee-schedule/working-in-departments
     * @secure
     */
    getWorkingInDepartmentsEmployeeScheduleWorkingInDepartmentsGet: (
      query: {
        /** Departments */
        departments: ZDepartment[];
        /** Countries */
        countries: Country[];
        /** Products */
        products?: Product[] | null;
        /** Date */
        date?: string | null;
        /** At */
        at?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkingResponse, HTTPValidationError>({
        path: `/employee-schedule/working-in-departments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee Schedule
     * @name GetEmployeeAvailabilityEmployeeScheduleWorkingUserIdGet
     * @summary Get Employee Availability
     * @request GET:/employee-schedule/working/{user_id}
     * @secure
     */
    getEmployeeAvailabilityEmployeeScheduleWorkingUserIdGet: (
      userId: string,
      query: {
        /**
         * Start Time
         * @format date-time
         */
        start_time: string;
        /**
         * End Time
         * @format date-time
         */
        end_time: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AvailabilityWindow[], HTTPValidationError>({
        path: `/employee-schedule/working/${userId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  employee = {
    /**
     * No description
     *
     * @tags Employee
     * @name GetAllEmployeesEmployeeAllGet
     * @summary Get All Employees
     * @request GET:/employee/all
     * @secure
     */
    getAllEmployeesEmployeeAllGet: (
      query?: {
        /** Page */
        page?: number | null;
        /** Limit */
        limit?: number | null;
        /**
         * Without Deactivated
         * @default false
         */
        without_deactivated?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<Employee[], HTTPValidationError>({
        path: `/employee/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetSverkerUsersEmployeeGetSverkerUsersGet
     * @summary Get Sverker Users
     * @request GET:/employee/get_sverker_users
     * @secure
     */
    getSverkerUsersEmployeeGetSverkerUsersGet: (
      query: {
        /** User Name */
        user_name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], HTTPValidationError>({
        path: `/employee/get_sverker_users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetEmployeesByZoordinatesEmployeeByZoordinatesPost
     * @summary Get Employees By Zoordinates
     * @request POST:/employee/by_zoordinates
     * @secure
     */
    getEmployeesByZoordinatesEmployeeByZoordinatesPost: (
      data: AllOptionalZoordinates,
      params: RequestParams = {},
    ) =>
      this.request<Employee[], HTTPValidationError>({
        path: `/employee/by_zoordinates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetMyInfoEmployeeMeGet
     * @summary Get My Info
     * @request GET:/employee/me
     * @secure
     */
    getMyInfoEmployeeMeGet: (params: RequestParams = {}) =>
      this.request<Employee, any>({
        path: `/employee/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name DeactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch
     * @summary Deactivate User By Id
     * @request PATCH:/employee/actions/block-or-unblock/{user_id}
     * @secure
     */
    deactivateUserByIdEmployeeActionsBlockOrUnblockUserIdPatch: (
      userId: string,
      query?: {
        /**
         * Block
         * @default true
         */
        block?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/employee/actions/block-or-unblock/${userId}`,
        method: "PATCH",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetAllZoordinatesEmployeeZoordinatesGet
     * @summary Get All Zoordinates
     * @request GET:/employee/zoordinates
     * @secure
     */
    getAllZoordinatesEmployeeZoordinatesGet: (params: RequestParams = {}) =>
      this.request<Zoordinates[], any>({
        path: `/employee/zoordinates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetAllRolesEmployeeRolesGet
     * @summary Get All Roles
     * @request GET:/employee/roles
     * @secure
     */
    getAllRolesEmployeeRolesGet: (params: RequestParams = {}) =>
      this.request<RoleType[], any>({
        path: `/employee/roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetMySettingsEmployeeMySettingsGet
     * @summary Get My Settings
     * @request GET:/employee/my-settings
     * @secure
     */
    getMySettingsEmployeeMySettingsGet: (params: RequestParams = {}) =>
      this.request<UserSettings, any>({
        path: `/employee/my-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name SaveMySettingsEmployeeMySettingsPost
     * @summary Save My Settings
     * @request POST:/employee/my-settings
     * @secure
     */
    saveMySettingsEmployeeMySettingsPost: (
      data: UserSettings,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/employee/my-settings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name CreateEmployeeEmployeePost
     * @summary Create Employee
     * @request POST:/employee/
     * @secure
     */
    createEmployeeEmployeePost: (
      data: CreateAndUpdateEmployeeRequest,
      params: RequestParams = {},
    ) =>
      this.request<Employee, HTTPValidationError>({
        path: `/employee/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name UpdateEmployeeEmployeeUserIdPut
     * @summary Update Employee
     * @request PUT:/employee/{user_id}
     * @secure
     */
    updateEmployeeEmployeeUserIdPut: (
      userId: string,
      data: CreateAndUpdateEmployeeRequest,
      params: RequestParams = {},
    ) =>
      this.request<Employee, HTTPValidationError>({
        path: `/employee/${userId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name GetByIdEmployeeUserIdGet
     * @summary Get By Id
     * @request GET:/employee/{user_id}
     * @secure
     */
    getByIdEmployeeUserIdGet: (userId: string, params: RequestParams = {}) =>
      this.request<Employee, HTTPValidationError>({
        path: `/employee/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name SearchEmployeeSearchPost
     * @summary Search
     * @request POST:/employee/search
     * @secure
     */
    searchEmployeeSearchPost: (
      data: RoutersEmployeeModelsSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<Employee[], HTTPValidationError>({
        path: `/employee/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  property = {
    /**
     * No description
     *
     * @tags Property
     * @name GetPropertyPropertyGetPropertyIdGet
     * @summary Get Property
     * @request GET:/property/get/{property_id}
     * @secure
     */
    getPropertyPropertyGetPropertyIdGet: (
      propertyId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        House | VacationHome | SharedModelsPropertyCondominium,
        HTTPValidationError
      >({
        path: `/property/get/${propertyId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name GetPartialPropertyPropertyPartialGetPropertyIdGet
     * @summary Get Partial Property
     * @request GET:/property/partial/get/{property_id}
     * @secure
     */
    getPartialPropertyPropertyPartialGetPropertyIdGet: (
      propertyId: string,
      params: RequestParams = {},
    ) =>
      this.request<PartialProperty, HTTPValidationError>({
        path: `/property/partial/get/${propertyId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name CreatePropertyPropertyCreateApplicationIdPost
     * @summary Create Property
     * @request POST:/property/create/{application_id}
     * @secure
     */
    createPropertyPropertyCreateApplicationIdPost: (
      applicationId: string,
      data: PartialHouse | PartialCondominium | PartialVacationHome,
      params: RequestParams = {},
    ) =>
      this.request<
        House | VacationHome | SharedModelsPropertyCondominium,
        HTTPValidationError
      >({
        path: `/property/create/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name CreatePartialPropertyPropertyPartialCreateApplicationIdPost
     * @summary Create Partial Property
     * @request POST:/property/partial/create/{application_id}
     * @secure
     */
    createPartialPropertyPropertyPartialCreateApplicationIdPost: (
      applicationId: string,
      data: NewPartialProperty,
      params: RequestParams = {},
    ) =>
      this.request<PartialProperty, HTTPValidationError>({
        path: `/property/partial/create/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name UpdatePropertyPropertyUpdatePropertyIdPut
     * @summary Update Property
     * @request PUT:/property/update/{property_id}
     * @secure
     */
    updatePropertyPropertyUpdatePropertyIdPut: (
      propertyId: string,
      data: PartialHouse | PartialCondominium | PartialVacationHome,
      params: RequestParams = {},
    ) =>
      this.request<
        House | VacationHome | SharedModelsPropertyCondominium,
        HTTPValidationError
      >({
        path: `/property/update/${propertyId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property
     * @name UpdatePartialPropertyPropertyPartialUpdatePropertyIdPut
     * @summary Update Partial Property
     * @request PUT:/property/partial/update/{property_id}
     * @secure
     */
    updatePartialPropertyPropertyPartialUpdatePropertyIdPut: (
      propertyId: string,
      data: NewPartialProperty,
      params: RequestParams = {},
    ) =>
      this.request<PartialProperty, HTTPValidationError>({
        path: `/property/partial/update/${propertyId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name SearchPropertyValuationSearchPropertyIdPost
     * @summary Search
     * @request POST:/property/valuation/search/{property_id}
     * @secure
     */
    searchPropertyValuationSearchPropertyIdPost: (
      propertyId: string,
      data: RoutersPropertyPayloadSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<PropertySearchResult[], HTTPValidationError>({
        path: `/property/valuation/search/${propertyId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name SearchForAddressPropertyV2SearchPropertyTypePost
     * @summary Search For Address
     * @request POST:/property/v2/search/{property_type}
     * @secure
     */
    searchForAddressPropertyV2SearchPropertyTypePost: (
      propertyType: MortgagePropertyType,
      data: RoutersPropertyPayloadSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<PropertySearchResult[], HTTPValidationError>({
        path: `/property/v2/search/${propertyType}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name GetPropertyInfoForCreationPropertyV2InfoSearchIdGet
     * @summary Get Property Info For Creation
     * @request GET:/property/v2/info/{search_id}
     * @secure
     */
    getPropertyInfoForCreationPropertyV2InfoSearchIdGet: (
      searchId: string,
      params: RequestParams = {},
    ) =>
      this.request<PropertyInfo, HTTPValidationError>({
        path: `/property/v2/info/${searchId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name GetPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet
     * @summary Get Property Info By External Id
     * @request GET:/property/v2/info-by-external-id/{external_id}
     * @secure
     */
    getPropertyInfoByExternalIdPropertyV2InfoByExternalIdExternalIdGet: (
      externalId: string,
      params: RequestParams = {},
    ) =>
      this.request<PropertyInfo, HTTPValidationError>({
        path: `/property/v2/info-by-external-id/${externalId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyValuationV2PropertyValuationV2Post
     * @summary Get Property Valuation V2
     * @request POST:/property/valuation/v2
     * @secure
     */
    getPropertyValuationV2PropertyValuationV2Post: (
      data: ValuationPayloadV2,
      params: RequestParams = {},
    ) =>
      this.request<PropertyValuation, HTTPValidationError>({
        path: `/property/valuation/v2`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyInfoPropertyValuationInfoSearchIdGet
     * @summary Get Property Info
     * @request GET:/property/valuation/info/{search_id}
     * @secure
     */
    getPropertyInfoPropertyValuationInfoSearchIdGet: (
      searchId: string,
      params: RequestParams = {},
    ) =>
      this.request<PropertyInfo, HTTPValidationError>({
        path: `/property/valuation/info/${searchId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyValuationPropertyValuationValuationPost
     * @summary Get Property Valuation
     * @request POST:/property/valuation/valuation
     * @secure
     */
    getPropertyValuationPropertyValuationValuationPost: (
      data: ValuationPayload,
      params: RequestParams = {},
    ) =>
      this.request<PropertyValuation, HTTPValidationError>({
        path: `/property/valuation/valuation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Creation
     * @name BooliSearchForAddressPropertyV2BooliSearchPost
     * @summary Booli Search For Address
     * @request POST:/property/v2/booli/search
     * @deprecated
     * @secure
     */
    booliSearchForAddressPropertyV2BooliSearchPost: (
      data: BooliSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<BooliPropertySearchResult[], HTTPValidationError>({
        path: `/property/v2/booli/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Property Valuation
     * @name GetPropertyBooliValuationPropertyValuationBooliPost
     * @summary Get Property Booli Valuation
     * @request POST:/property/valuation/booli
     * @deprecated
     * @secure
     */
    getPropertyBooliValuationPropertyValuationBooliPost: (
      data: BooliValuationPayload,
      params: RequestParams = {},
    ) =>
      this.request<PropertyValuation, HTTPValidationError>({
        path: `/property/valuation/booli`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetPropertyByPniPropertyEvcheckCachePost
     * @summary Get Property By Pni
     * @request POST:/property/evcheck/cache
     * @secure
     */
    getPropertyByPniPropertyEvcheckCachePost: (
      data: EvCheckPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        (PartialHouse | PartialCondominium | PartialVacationHome)[],
        HTTPValidationError
      >({
        path: `/property/evcheck/cache`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  message = {
    /**
     * No description
     *
     * @tags Message
     * @name RemoveTemplateMessageTemplateDelete
     * @summary Remove Template
     * @request DELETE:/message/template/
     * @secure
     */
    removeTemplateMessageTemplateDelete: (
      data: GetTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/message/template/`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetOneTemplateMessageTemplateGetPost
     * @summary Get One Template
     * @request POST:/message/template/get
     * @secure
     */
    getOneTemplateMessageTemplateGetPost: (
      data: GetTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<RootModelUnionEmailTemplateSmsTemplate, HTTPValidationError>(
        {
          path: `/message/template/get`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Message
     * @name CreateTemplateMessageTemplateAddPost
     * @summary Create Template
     * @request POST:/message/template/add
     * @secure
     */
    createTemplateMessageTemplateAddPost: (
      data: RootModelUnionEmailTemplateSmsTemplate,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/message/template/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name TemplateListMessageTemplateListMessageTypeGet
     * @summary Template List
     * @request GET:/message/template/list/{message_type}
     * @secure
     */
    templateListMessageTemplateListMessageTypeGet: (
      messageType: MessageType,
      query?: {
        /** Cutoff Date */
        cutoff_date?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<(EmailTemplate | SmsTemplate)[], HTTPValidationError>({
        path: `/message/template/list/${messageType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetSmsLinkVarsMessageLinkVarsSmsTemplateEventProductCountryGet
     * @summary Get Sms Link Vars
     * @request GET:/message/link-vars/SMS/{template_event}/{product}/{country}
     * @secure
     */
    getSmsLinkVarsMessageLinkVarsSmsTemplateEventProductCountryGet: (
      templateEvent: TemplateEvent,
      product: ExtendedProduct,
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<SMSTrackingLinksResponse, HTTPValidationError>({
        path: `/message/link-vars/SMS/${templateEvent}/${product}/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SendTemplateMessageMessageSendTemplateMessageTypeTemplateEventPost
     * @summary Send Template Message
     * @request POST:/message/send/template/{message_type}/{template_event}
     * @secure
     */
    sendTemplateMessageMessageSendTemplateMessageTypeTemplateEventPost: (
      messageType: MessageType,
      templateEvent: TemplateEvent,
      data: SendTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/message/send/template/${messageType}/${templateEvent}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SendRawMessageMessageSendRawMessageTypePost
     * @summary Send Raw Message
     * @request POST:/message/send/raw/{message_type}
     * @secure
     */
    sendRawMessageMessageSendRawMessageTypePost: (
      messageType: MessageType,
      data: SendRawPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/message/send/raw/${messageType}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetUnknownSenderSmsMessageSmsUnknownSenderPost
     * @summary Get Unknown Sender Sms
     * @request POST:/message/sms/unknown-sender
     * @secure
     */
    getUnknownSenderSmsMessageSmsUnknownSenderPost: (
      data: GetMessagesPayload,
      params: RequestParams = {},
    ) =>
      this.request<IncomingSMS[], HTTPValidationError>({
        path: `/message/sms/unknown-sender`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetMessagesForUserMessageUserPost
     * @summary Get Messages For User
     * @request POST:/message/user
     * @secure
     */
    getMessagesForUserMessageUserPost: (
      data: GetUserMessagesPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavedMessage[], HTTPValidationError>({
        path: `/message/user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetMessagesForApplicationMessageApplicationPost
     * @summary Get Messages For Application
     * @request POST:/message/application
     * @secure
     */
    getMessagesForApplicationMessageApplicationPost: (
      data: GetApplicationMessagesPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavedMessage[], HTTPValidationError>({
        path: `/message/application`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetMessagesByCustomerIdMessageByCustomerPost
     * @summary Get Messages By Customer Id
     * @request POST:/message/by-customer
     * @secure
     */
    getMessagesByCustomerIdMessageByCustomerPost: (
      data: GetMessages,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 1
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SavedMessageWithName[], HTTPValidationError>({
        path: `/message/by-customer`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetConversationsMessageConversationsGet
     * @summary Get Conversations
     * @request GET:/message/conversations
     * @secure
     */
    getConversationsMessageConversationsGet: (params: RequestParams = {}) =>
      this.request<Conversation[], any>({
        path: `/message/conversations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SaveConversationsMessageConversationsPost
     * @summary Save Conversations
     * @request POST:/message/conversations
     * @secure
     */
    saveConversationsMessageConversationsPost: (
      data: Conversation[],
      params: RequestParams = {},
    ) =>
      this.request<Conversation[], HTTPValidationError>({
        path: `/message/conversations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name StreamConversationsMessageConversationsStreamGet
     * @summary Stream Conversations
     * @request GET:/message/conversations/stream
     * @secure
     */
    streamConversationsMessageConversationsStreamGet: (
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/message/conversations/stream`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name UploadAttachmentMessageAttachmentsUploadPost
     * @summary Upload Attachment
     * @request POST:/message/attachments/upload
     * @secure
     */
    uploadAttachmentMessageAttachmentsUploadPost: (
      data: BodyUploadAttachmentMessageAttachmentsUploadPost,
      params: RequestParams = {},
    ) =>
      this.request<NonEmptyString, HTTPValidationError>({
        path: `/message/attachments/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name GetAttachmentsMessageAttachmentsAllGet
     * @summary Get Attachments
     * @request GET:/message/attachments/all
     * @secure
     */
    getAttachmentsMessageAttachmentsAllGet: (params: RequestParams = {}) =>
      this.request<SavedAttachment[], any>({
        path: `/message/attachments/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SmsStatsMessageStatsSmsPost
     * @summary Sms Stats
     * @request POST:/message/stats/sms
     * @secure
     */
    smsStatsMessageStatsSmsPost: (
      data: SmsStatsRequest,
      params: RequestParams = {},
    ) =>
      this.request<SmsStatsBucket[], HTTPValidationError>({
        path: `/message/stats/sms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name SmsTemplateStatsMessageStatsSmsTemplateTemplateEventProductCountryGet
     * @summary Sms Template Stats
     * @request GET:/message/stats/sms/template/{template_event}/{product}/{country}
     * @secure
     */
    smsTemplateStatsMessageStatsSmsTemplateTemplateEventProductCountryGet: (
      templateEvent: TemplateEvent,
      product: ExtendedProduct,
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<SmsTemplateStats, HTTPValidationError>({
        path: `/message/stats/sms/template/${templateEvent}/${product}/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ELK46 Callbacks
     * @name Elk46SmsWebhookMessageElk46ConfirmationPost
     * @summary Elk46 Sms Webhook
     * @request POST:/message/elk46/confirmation
     */
    elk46SmsWebhookMessageElk46ConfirmationPost: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/message/elk46/confirmation`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ELK46 Callbacks
     * @name Elk46CallWebhookMessageElk46CallPost
     * @summary Elk46 Call Webhook
     * @request POST:/message/elk46/call
     */
    elk46CallWebhookMessageElk46CallPost: (
      data: BodyElk46CallWebhookMessageElk46CallPost,
      params: RequestParams = {},
    ) =>
      this.request<Elk46CallResponse, HTTPValidationError>({
        path: `/message/elk46/call`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  mortgage = {
    /**
     * No description
     *
     * @tags Mortgage
     * @name GetKalpSettingsMortgageKalpCountryGet
     * @summary Get Kalp Settings
     * @request GET:/mortgage/kalp/{country}
     * @secure
     */
    getKalpSettingsMortgageKalpCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<(BankKALP | BankAPIDrivenKALP)[], HTTPValidationError>({
        path: `/mortgage/kalp/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  other = {
    /**
     * No description
     *
     * @tags Other
     * @name GetAllTaxesForCountryOtherTaxesCountryGet
     * @summary Get All Taxes For Country
     * @request GET:/other/taxes/{country}
     * @secure
     */
    getAllTaxesForCountryOtherTaxesCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<Tax[], HTTPValidationError>({
        path: `/other/taxes/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other
     * @name TaxesForIdentifierOtherTaxesCalculationPost
     * @summary Taxes For Identifier
     * @request POST:/other/taxes/calculation
     * @secure
     */
    taxesForIdentifierOtherTaxesCalculationPost: (
      data: GetTaxPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetTaxPayloadResponse, HTTPValidationError>({
        path: `/other/taxes/calculation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other
     * @name GetAllMunicipalitiesForCountryOtherMunicipalityCountryGet
     * @summary Get All Municipalities For Country
     * @request GET:/other/municipality/{country}
     * @secure
     */
    getAllMunicipalitiesForCountryOtherMunicipalityCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<Municipality[], HTTPValidationError>({
        path: `/other/municipality/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other
     * @name DeactivationReasonsOtherDeactivationReasonsGet
     * @summary Deactivation Reasons
     * @request GET:/other/deactivation-reasons
     * @secure
     */
    deactivationReasonsOtherDeactivationReasonsGet: (
      query: {
        product: Product;
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], HTTPValidationError>({
        path: `/other/deactivation-reasons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Other, websocket
     * @name GetTokenOtherWsTokenForWebsocketGet
     * @summary Get Token
     * @request GET:/other/ws/token-for-websocket
     * @secure
     */
    getTokenOtherWsTokenForWebsocketGet: (params: RequestParams = {}) =>
      this.request<TokenResp, any>({
        path: `/other/ws/token-for-websocket`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  bankId = {
    /**
     * No description
     *
     * @tags BankID
     * @name VerifyCustomerBankIdVerifyPost
     * @summary Verify Customer
     * @request POST:/bank-id/verify
     * @secure
     */
    verifyCustomerBankIdVerifyPost: (
      data: BankIDPayload,
      params: RequestParams = {},
    ) =>
      this.request<RoutersBankIdModelsBankIDResp, HTTPValidationError>({
        path: `/bank-id/verify`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name CancelVerifyCustomerBankIdCancelDelete
     * @summary Cancel Verify Customer
     * @request DELETE:/bank-id/cancel
     * @secure
     */
    cancelVerifyCustomerBankIdCancelDelete: (
      query: {
        /** Ticket Id */
        ticket_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bank-id/cancel`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name IsAlreadyVerifiedBankIdVerifiedPost
     * @summary Is Already Verified
     * @request POST:/bank-id/verified
     * @secure
     */
    isAlreadyVerifiedBankIdVerifiedPost: (
      data: BankIDPayload,
      params: RequestParams = {},
    ) =>
      this.request<PollResp, HTTPValidationError>({
        path: `/bank-id/verified`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name GetTicketStatusBankIdVerifyTicketIdGet
     * @summary Get Ticket Status
     * @request GET:/bank-id/verify/{ticket_id}
     * @secure
     */
    getTicketStatusBankIdVerifyTicketIdGet: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<PollResp, HTTPValidationError>({
        path: `/bank-id/verify/${ticketId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name IdKollenRedirectNoBankIdIdKollenCallbackGet
     * @summary Id Kollen Redirect No
     * @request GET:/bank-id/id-kollen/callback
     */
    idKollenRedirectNoBankIdIdKollenCallbackGet: (
      query?: {
        /** Refid */
        refId?: string | null;
        /** Id */
        id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bank-id/id-kollen/callback`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name IdKollenCallbackSeBankIdIdKollenCallbackPost
     * @summary Id Kollen Callback Se
     * @request POST:/bank-id/id-kollen/callback
     */
    idKollenCallbackSeBankIdIdKollenCallbackPost: (
      data: IDKollenCollectResponse,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/bank-id/id-kollen/callback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name QrCodeBankIdQrCodeGet
     * @summary Qr Code
     * @request GET:/bank-id/qr-code
     */
    qrCodeBankIdQrCodeGet: (
      query: {
        /** Ticket Id */
        ticket_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QRCodeContent, HTTPValidationError>({
        path: `/bank-id/qr-code`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name RedirectFromAppBankIdRedirectGet
     * @summary Redirect From App
     * @request GET:/bank-id/redirect
     */
    redirectFromAppBankIdRedirectGet: (
      query: {
        /** Ticket Id */
        ticket_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bank-id/redirect`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name LoginBankIdAuthPost
     * @summary Login
     * @request POST:/bank-id/auth
     */
    loginBankIdAuthPost: (data: LoginPayload, params: RequestParams = {}) =>
      this.request<RoutersBankIdLoginPayloadBankIDResp, HTTPValidationError>({
        path: `/bank-id/auth`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name ExchangeAuthCodeBankIdTokenPost
     * @summary Exchange Auth Code
     * @request POST:/bank-id/token
     */
    exchangeAuthCodeBankIdTokenPost: (
      data: TokenExchangePayload,
      params: RequestParams = {},
    ) =>
      this.request<BankIDLoginResponse, HTTPValidationError>({
        path: `/bank-id/token`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankID
     * @name PollTicketBankIdTicketIdGet
     * @summary Poll Ticket
     * @request GET:/bank-id/{ticket_id}
     */
    pollTicketBankIdTicketIdGet: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<BankIDLoginResponse, HTTPValidationError>({
        path: `/bank-id/${ticketId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Development-only endpoint to simulate BankID/Vipps without dependency on third-party services.
     *
     * @tags Simulator
     * @name SimulateLoginBankIdSimulatorAuthPost
     * @summary Simulate Login
     * @request POST:/bank-id/simulator/auth
     */
    simulateLoginBankIdSimulatorAuthPost: (
      data: SimulatedLoginPayload,
      params: RequestParams = {},
    ) =>
      this.request<BankIDLoginResponse, HTTPValidationError>({
        path: `/bank-id/simulator/auth`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notifications
     * @name UserNotificationsNotificationGet
     * @summary User Notifications
     * @request GET:/notification/
     * @secure
     */
    userNotificationsNotificationGet: (
      query?: {
        /** Status */
        status?: NotificationEvent[] | null;
        /** Notification Type */
        notification_type?: ModelsNotificationsNotificationTypesNotificationType | null;
        /** Product */
        product?: Product | null;
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 51
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        (
          | ({
              type: "SMS_RECEIVED";
            } & SMSReceived)
          | ({
              type: "EMAIL_RECEIVED";
            } & EmailReceived)
          | ({
              type: "BANK_MESSAGE_RECEIVED";
            } & BankMessageReceived)
          | ({
              type: "CUSTOMER_DOCUMENT_RECEIVED";
            } & CustomerDocumentReceived)
          | ({
              type: "OFFER_RECEIVED";
            } & OfferReceived)
          | ({
              type: "INTERNAL_COMMENT_RECEIVED";
            } & ModelsNotificationsNotificationInternalComment)
          | ({
              type: "APPLICATION_ASSIGNED";
            } & ApplicationAssigned)
          | ({
              type: "GENERAL_MESSAGE_RECEIVED";
            } & GeneralMessage)
          | ({
              type: "LEAD_ASSIGNED";
            } & LeadAssigned)
          | ({
              type: "LEAD_COMMENT_RECEIVED";
            } & LeadComment)
          | ({
              type: "APPLICATION_DISBURSED";
            } & ApplicationDisbursed)
          | ({
              type: "INSURANCE_SCHEDULED_CANCELLATION";
            } & InsuranceCancellationQueued)
          | ({
              type: "OFFER_ACCEPTED";
            } & OfferAccepted)
          | ({
              type: "APPLICATION_REJECTED";
            } & ApplicationRejected)
          | ({
              type: "MEETING_REMINDER";
            } & MeetingReminder)
          | ({
              type: "CUSTOMER_PORTAL_LOGIN";
            } & CustomerPortalLogin)
          | ({
              type: "INSURANCE_ACTIVATED";
            } & InsuranceActivated)
          | ({
              type: "OP_POA_RECEIVED";
            } & OPPoaReceived)
          | ({
              type: "OP_RESPONSE_RECEIVED";
            } & OPResponseReceived)
          | ({
              type: "MORTGAGE_COI_FLAGGED";
            } & MortgageCoiFlagged)
        )[],
        HTTPValidationError
      >({
        path: `/notification/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Live notification stream (SSE). Returns immediately so the streamed body is not bound by the 30s TimeoutRoute budget; sse_starlette's built-in ping keeps the connection alive.
     *
     * @tags Notifications
     * @name NotificationStreamNotificationStreamGet
     * @summary Notification Stream
     * @request GET:/notification/stream
     * @secure
     */
    notificationStreamNotificationStreamGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/notification/stream`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetNotificationNotificationByIdNotificationIdGet
     * @summary Get Notification
     * @request GET:/notification/by-id/{notification_id}
     * @secure
     */
    getNotificationNotificationByIdNotificationIdGet: (
      notificationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            type: "SMS_RECEIVED";
          } & SMSReceived)
        | ({
            type: "EMAIL_RECEIVED";
          } & EmailReceived)
        | ({
            type: "BANK_MESSAGE_RECEIVED";
          } & BankMessageReceived)
        | ({
            type: "CUSTOMER_DOCUMENT_RECEIVED";
          } & CustomerDocumentReceived)
        | ({
            type: "OFFER_RECEIVED";
          } & OfferReceived)
        | ({
            type: "INTERNAL_COMMENT_RECEIVED";
          } & ModelsNotificationsNotificationInternalComment)
        | ({
            type: "APPLICATION_ASSIGNED";
          } & ApplicationAssigned)
        | ({
            type: "GENERAL_MESSAGE_RECEIVED";
          } & GeneralMessage)
        | ({
            type: "LEAD_ASSIGNED";
          } & LeadAssigned)
        | ({
            type: "LEAD_COMMENT_RECEIVED";
          } & LeadComment)
        | ({
            type: "APPLICATION_DISBURSED";
          } & ApplicationDisbursed)
        | ({
            type: "INSURANCE_SCHEDULED_CANCELLATION";
          } & InsuranceCancellationQueued)
        | ({
            type: "OFFER_ACCEPTED";
          } & OfferAccepted)
        | ({
            type: "APPLICATION_REJECTED";
          } & ApplicationRejected)
        | ({
            type: "MEETING_REMINDER";
          } & MeetingReminder)
        | ({
            type: "CUSTOMER_PORTAL_LOGIN";
          } & CustomerPortalLogin)
        | ({
            type: "INSURANCE_ACTIVATED";
          } & InsuranceActivated)
        | ({
            type: "OP_POA_RECEIVED";
          } & OPPoaReceived)
        | ({
            type: "OP_RESPONSE_RECEIVED";
          } & OPResponseReceived)
        | ({
            type: "MORTGAGE_COI_FLAGGED";
          } & MortgageCoiFlagged),
        HTTPValidationError
      >({
        path: `/notification/by-id/${notificationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotifyNotificationNotifyIncomingPost
     * @summary Notify
     * @request POST:/notification/notify/incoming
     * @secure
     */
    notifyNotificationNotifyIncomingPost: (
      data: Notification,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/notify/incoming`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotifyInsuranceNotificationNotifyInsurancePost
     * @summary Notify Insurance
     * @request POST:/notification/notify/insurance
     * @secure
     */
    notifyInsuranceNotificationNotifyInsurancePost: (
      data: InsuranceNotification,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/notify/insurance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name AcknowledgeNotificationNotificationActionPost
     * @summary Acknowledge Notification
     * @request POST:/notification/action
     * @secure
     */
    acknowledgeNotificationNotificationActionPost: (
      data: ActionPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/action`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name MarkAllNotificationsReadNotificationReadAllPost
     * @summary Mark All Notifications Read
     * @request POST:/notification/read-all
     * @secure
     */
    markAllNotificationsReadNotificationReadAllPost: (
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/notification/read-all`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name CustomAuthUserNotificationsNotificationNotificationIdReceivedPatch
     * @summary Custom Auth User Notifications
     * @request PATCH:/notification/{notification_id}/received
     */
    customAuthUserNotificationsNotificationNotificationIdReceivedPatch: (
      notificationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/notification/${notificationId}/received`,
        method: "PATCH",
        ...params,
      }),
  };
  ponytail = {
    /**
     * No description
     *
     * @tags Ponytail
     * @name GetDisbursedStatsPonytailDisbursedAllPost
     * @summary Get Disbursed Stats
     * @request POST:/ponytail/disbursed/all
     * @secure
     */
    getDisbursedStatsPonytailDisbursedAllPost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<AllDisbursedLoans, HTTPValidationError>({
        path: `/ponytail/disbursed/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyDisbursedPonytailDisbursedMePost
     * @summary Get My Disbursed
     * @request POST:/ponytail/disbursed/me
     * @secure
     */
    getMyDisbursedPonytailDisbursedMePost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<MyDisbursedLoans, HTTPValidationError>({
        path: `/ponytail/disbursed/me`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetAcceptedPonytailAcceptedAllPost
     * @summary Get Accepted
     * @request POST:/ponytail/accepted/all
     * @secure
     */
    getAcceptedPonytailAcceptedAllPost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<AcceptedLoans, HTTPValidationError>({
        path: `/ponytail/accepted/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyAcceptedPonytailAcceptedMePost
     * @summary Get My Accepted
     * @request POST:/ponytail/accepted/me
     * @secure
     */
    getMyAcceptedPonytailAcceptedMePost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<AcceptedLoans, HTTPValidationError>({
        path: `/ponytail/accepted/me`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetAllInsurancePonytailInsuranceAllPost
     * @summary Get All Insurance
     * @request POST:/ponytail/insurance/all
     * @secure
     */
    getAllInsurancePonytailInsuranceAllPost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<AllInsurances, HTTPValidationError>({
        path: `/ponytail/insurance/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyInsurancePonytailInsuranceMePost
     * @summary Get My Insurance
     * @request POST:/ponytail/insurance/me
     * @secure
     */
    getMyInsurancePonytailInsuranceMePost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<AllInsurances, HTTPValidationError>({
        path: `/ponytail/insurance/me`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetAllMyStatsPonytailMyStatsPost
     * @summary Get All My Stats
     * @request POST:/ponytail/my-stats
     * @secure
     */
    getAllMyStatsPonytailMyStatsPost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<RootModelUnionMyStatsMyStatsMb, HTTPValidationError>({
        path: `/ponytail/my-stats`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name SummarizedViewPonytailSummarizedPost
     * @summary Summarized View
     * @request POST:/ponytail/summarized
     * @secure
     */
    summarizedViewPonytailSummarizedPost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<RootModelUnionSummarizedViewMyStatsMb, HTTPValidationError>({
        path: `/ponytail/summarized`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Per-user stats of native ZRM applications in `[start_date, end_date)`, at most 62 days.
     *
     * @tags Ponytail
     * @name GetNativeStatsPonytailNativeStatsPost
     * @summary Get Native Stats
     * @request POST:/ponytail/native/stats
     * @secure
     */
    getNativeStatsPonytailNativeStatsPost: (
      data: DashboardPayload,
      params: RequestParams = {},
    ) =>
      this.request<NativeStatsView, HTTPValidationError>({
        path: `/ponytail/native/stats`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The month's KH or non-KH budget, by the department in `X-Zoordinates`, whole and per seller.
     *
     * @tags Ponytail
     * @name GetNativeBudgetPonytailNativeBudgetGet
     * @summary Get Native Budget
     * @request GET:/ponytail/native/budget
     * @secure
     */
    getNativeBudgetPonytailNativeBudgetGet: (
      query: {
        /** Year */
        year: number;
        /**
         * Month
         * @min 1
         * @max 12
         */
        month: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<NativeBudgetView, HTTPValidationError>({
        path: `/ponytail/native/budget`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Set the month's KH or non-KH budget, by the department in `X-Zoordinates`; the newest one wins.
     *
     * @tags Ponytail
     * @name PostNativeBudgetPonytailNativeBudgetCreatePost
     * @summary Post Native Budget
     * @request POST:/ponytail/native/budget/create
     * @secure
     */
    postNativeBudgetPonytailNativeBudgetCreatePost: (
      data: NativeBudgetPayload,
      params: RequestParams = {},
    ) =>
      this.request<NativeBudget, HTTPValidationError>({
        path: `/ponytail/native/budget/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetWorkingDaysPonytailWorkingDaysPost
     * @summary Get Working Days
     * @request POST:/ponytail/working-days
     * @secure
     */
    getWorkingDaysPonytailWorkingDaysPost: (
      data: GoalPayload,
      params: RequestParams = {},
    ) =>
      this.request<WorkingDays, HTTPValidationError>({
        path: `/ponytail/working-days`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostBlancoGoalPonytailGoalsCreateBlancoPost
     * @summary Post Blanco Goal
     * @request POST:/ponytail/goals/create/blanco
     * @secure
     */
    postBlancoGoalPonytailGoalsCreateBlancoPost: (
      data: BlancoGoalPayload,
      params: RequestParams = {},
    ) =>
      this.request<BlancoGoal, HTTPValidationError>({
        path: `/ponytail/goals/create/blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostBlancoGoalMbPonytailGoalsCreateBlancoMbPost
     * @summary Post Blanco Goal Mb
     * @request POST:/ponytail/goals/create/blanco-mb
     * @secure
     */
    postBlancoGoalMbPonytailGoalsCreateBlancoMbPost: (
      data: BlancoGoalMbPayload,
      params: RequestParams = {},
    ) =>
      this.request<BlancoGoalMb, HTTPValidationError>({
        path: `/ponytail/goals/create/blanco-mb`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost
     * @summary Post Initial Blanco Goal
     * @request POST:/ponytail/goals/create/initial-blanco
     * @secure
     */
    postInitialBlancoGoalPonytailGoalsCreateInitialBlancoPost: (
      data: BlancoGoalPayload,
      params: RequestParams = {},
    ) =>
      this.request<BlancoGoal, HTTPValidationError>({
        path: `/ponytail/goals/create/initial-blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name PostInitialBudgetPonytailGoalsCreateInitialBlancoMbPost
     * @summary Post Initial Budget
     * @request POST:/ponytail/goals/create/initial-blanco-mb
     * @secure
     */
    postInitialBudgetPonytailGoalsCreateInitialBlancoMbPost: (
      data: BudgetPayload,
      params: RequestParams = {},
    ) =>
      this.request<Budget, HTTPValidationError>({
        path: `/ponytail/goals/create/initial-blanco-mb`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetMyGoalsPonytailGoalsPost
     * @summary Get My Goals
     * @request POST:/ponytail/goals
     * @secure
     */
    getMyGoalsPonytailGoalsPost: (
      data: GoalPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        BlancoGoalMb | BlancoGoal | MortgageGoal | null,
        HTTPValidationError
      >({
        path: `/ponytail/goals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ponytail
     * @name GetInitialGoalPonytailGoalsInitialGoalPost
     * @summary Get Initial Goal
     * @request POST:/ponytail/goals/initial-goal
     * @secure
     */
    getInitialGoalPonytailGoalsInitialGoalPost: (
      data: GoalPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        Budget | BlancoGoal | MortgageGoal | null,
        HTTPValidationError
      >({
        path: `/ponytail/goals/initial-goal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lead = {
    /**
     * No description
     *
     * @tags Lead
     * @name GetLeadLeadGetLeadIdGet
     * @summary Get Lead
     * @request GET:/lead/get/{lead_id}
     * @secure
     */
    getLeadLeadGetLeadIdGet: (leadId: string, params: RequestParams = {}) =>
      this.request<Lead, HTTPValidationError>({
        path: `/lead/get/${leadId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetLeadsLeadListPost
     * @summary Get Leads
     * @request POST:/lead/list
     * @secure
     */
    getLeadsLeadListPost: (data: GetLeads, params: RequestParams = {}) =>
      this.request<Lead[], HTTPValidationError>({
        path: `/lead/list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name CreateLeadLeadCreatePost
     * @summary Create Lead
     * @request POST:/lead/create
     * @secure
     */
    createLeadLeadCreatePost: (
      data: CreateLeadPayload,
      params: RequestParams = {},
    ) =>
      this.request<Lead, HTTPValidationError>({
        path: `/lead/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name SearchLeadSearchPost
     * @summary Search
     * @request POST:/lead/search
     * @secure
     */
    searchLeadSearchPost: (
      data: RoutersLeadPayloadSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<Lead[], HTTPValidationError>({
        path: `/lead/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name ConvertAndCloseLeadConvertAndMarkHandledPost
     * @summary Convert And Close
     * @request POST:/lead/convert_and_mark_handled
     * @secure
     */
    convertAndCloseLeadConvertAndMarkHandledPost: (
      data: ConvertPayload,
      params: RequestParams = {},
    ) =>
      this.request<ConvertResult, HTTPValidationError>({
        path: `/lead/convert_and_mark_handled`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name CloseLeadMarkHandledPost
     * @summary Close
     * @request POST:/lead/mark_handled
     * @secure
     */
    closeLeadMarkHandledPost: (
      data: LeadHandledPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/lead/mark_handled`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name UnhandleLeadLeadUnhandlePost
     * @summary Unhandle Lead
     * @request POST:/lead/unhandle
     * @secure
     */
    unhandleLeadLeadUnhandlePost: (
      query: {
        /** Lead Id */
        lead_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/lead/unhandle`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name UpdateLeadLeadUpdateLeadIdPost
     * @summary Update Lead
     * @request POST:/lead/update/{lead_id}
     * @secure
     */
    updateLeadLeadUpdateLeadIdPost: (
      leadId: string,
      data: LeadUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.request<Lead, HTTPValidationError>({
        path: `/lead/update/${leadId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name ReprocessSubmissionLeadReprocessSubmissionLeadIdPost
     * @summary Reprocess Submission
     * @request POST:/lead/reprocess_submission/{lead_id}
     * @secure
     */
    reprocessSubmissionLeadReprocessSubmissionLeadIdPost: (
      leadId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/lead/reprocess_submission/${leadId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name ReprocessSubmissionsLeadReprocessSubmissionsPost
     * @summary Reprocess Submissions
     * @request POST:/lead/reprocess_submissions
     * @secure
     */
    reprocessSubmissionsLeadReprocessSubmissionsPost: (
      data: ReprocessSubmissionPayload,
      params: RequestParams = {},
    ) =>
      this.request<ReprocessResult[], HTTPValidationError>({
        path: `/lead/reprocess_submissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetCommentsLeadCommentLeadIdGet
     * @summary Get Comments
     * @request GET:/lead/comment/{lead_id}
     * @secure
     */
    getCommentsLeadCommentLeadIdGet: (
      leadId: string,
      params: RequestParams = {},
    ) =>
      this.request<InternalCommentWithName[], HTTPValidationError>({
        path: `/lead/comment/${leadId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name AddInternalCommentLeadCommentLeadIdPost
     * @summary Add Internal Comment
     * @request POST:/lead/comment/{lead_id}
     * @secure
     */
    addInternalCommentLeadCommentLeadIdPost: (
      leadId: string,
      data: CommentPayload,
      params: RequestParams = {},
    ) =>
      this.request<InternalCommentWithName[], HTTPValidationError>({
        path: `/lead/comment/${leadId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name AssignLeadToHandlerLeadAssignLeadIdPost
     * @summary Assign Lead To Handler
     * @request POST:/lead/assign/{lead_id}
     * @secure
     */
    assignLeadToHandlerLeadAssignLeadIdPost: (
      leadId: string,
      data: AssignApplicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/lead/assign/${leadId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetAssignedHandlerLeadAssigneeLeadIdGet
     * @summary Get Assigned Handler
     * @request GET:/lead/assignee/{lead_id}
     * @secure
     */
    getAssignedHandlerLeadAssigneeLeadIdGet: (
      leadId: string,
      params: RequestParams = {},
    ) =>
      this.request<Assignee, HTTPValidationError>({
        path: `/lead/assignee/${leadId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lead
     * @name GetLeadsLeadListMinePost
     * @summary Get Leads
     * @request POST:/lead/list/mine
     * @secure
     */
    getLeadsLeadListMinePost: (data: GetMyLeads, params: RequestParams = {}) =>
      this.request<Lead[], HTTPValidationError>({
        path: `/lead/list/mine`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  formprefs = {
    /**
     * No description
     *
     * @tags Jotform
     * @name UpdatePreferenceFormprefsPut
     * @summary Update Preference
     * @request PUT:/formprefs/
     * @secure
     */
    updatePreferenceFormprefsPut: (
      data: UpdateFormPreferencePayload,
      params: RequestParams = {},
    ) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name CreatePreferenceFormprefsPost
     * @summary Create Preference
     * @request POST:/formprefs/
     * @secure
     */
    createPreferenceFormprefsPost: (
      data: FormPreferencePayload,
      params: RequestParams = {},
    ) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name DuplicatePreferenceFormprefsDuplicatePost
     * @summary Duplicate Preference
     * @request POST:/formprefs/duplicate
     * @secure
     */
    duplicatePreferenceFormprefsDuplicatePost: (
      data: DuplicateFormPreferencePayload,
      params: RequestParams = {},
    ) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/duplicate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ValidatePreferenceFormprefsValidatePost
     * @summary Validate Preference
     * @request POST:/formprefs/validate
     * @secure
     */
    validatePreferenceFormprefsValidatePost: (
      data: ValidatePayload,
      params: RequestParams = {},
    ) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name GetMappingFormprefsGetMappingPost
     * @summary Get Mapping
     * @request POST:/formprefs/get_mapping
     * @secure
     */
    getMappingFormprefsGetMappingPost: (
      data: BaseFormPreferencePayload,
      params: RequestParams = {},
    ) =>
      this.request<FormMapping, HTTPValidationError>({
        path: `/formprefs/get_mapping`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ListPreferencesFormprefsListGet
     * @summary List Preferences
     * @request GET:/formprefs/list
     * @secure
     */
    listPreferencesFormprefsListGet: (params: RequestParams = {}) =>
      this.request<FormPreference[], any>({
        path: `/formprefs/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ListPreferencesExtFormprefsListExtGet
     * @summary List Preferences Ext
     * @request GET:/formprefs/list_ext
     * @secure
     */
    listPreferencesExtFormprefsListExtGet: (params: RequestParams = {}) =>
      this.request<FormPreferenceExt[], any>({
        path: `/formprefs/list_ext`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name ListFormsFormprefsFormsGet
     * @summary List Forms
     * @request GET:/formprefs/forms
     * @secure
     */
    listFormsFormprefsFormsGet: (params: RequestParams = {}) =>
      this.request<Form[], any>({
        path: `/formprefs/forms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name CheckAllSubmissionsFormprefsCheckAllGet
     * @summary Check All Submissions
     * @request GET:/formprefs/check-all
     * @secure
     */
    checkAllSubmissionsFormprefsCheckAllGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/formprefs/check-all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name GetAllSubmissionsFormprefsSubmissionsGet
     * @summary Get All Submissions
     * @request GET:/formprefs/submissions
     * @secure
     */
    getAllSubmissionsFormprefsSubmissionsGet: (
      query?: {
        /** Form Id */
        form_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/formprefs/submissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name GetFormPreferenceFormprefsFormPreferenceIdGet
     * @summary Get Form Preference
     * @request GET:/formprefs/{form_preference_id}
     * @secure
     */
    getFormPreferenceFormprefsFormPreferenceIdGet: (
      formPreferenceId: string,
      query?: {
        /**
         * Add Defaults
         * @default false
         */
        add_defaults?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<FormPreferenceExt, HTTPValidationError>({
        path: `/formprefs/${formPreferenceId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name CreateWebhookFormprefsWebhookPost
     * @summary Create Webhook
     * @request POST:/formprefs/webhook
     * @secure
     */
    createWebhookFormprefsWebhookPost: (
      data: FormWebhookPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/formprefs/webhook`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jotform
     * @name DeleteWebhookFormprefsWebhookDelete
     * @summary Delete Webhook
     * @request DELETE:/formprefs/webhook
     * @secure
     */
    deleteWebhookFormprefsWebhookDelete: (
      data: FormWebhookPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/formprefs/webhook`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  heimdall = {
    /**
     * No description
     *
     * @tags Heimdall
     * @name GetAllHeimdallRecordsForDateHeimdallDateGet
     * @summary Get All Heimdall Records For Date
     * @request GET:/heimdall/{date}
     * @secure
     */
    getAllHeimdallRecordsForDateHeimdallDateGet: (
      date: string,
      params: RequestParams = {},
    ) =>
      this.request<HeimdallResponse[], HTTPValidationError>({
        path: `/heimdall/${date}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Heimdall
     * @name ReportAndVerifyUsageToHeimdallHeimdallUserIdPatch
     * @summary Report And Verify Usage To Heimdall
     * @request PATCH:/heimdall/{user_id}
     * @secure
     */
    reportAndVerifyUsageToHeimdallHeimdallUserIdPatch: (
      userId: string,
      data: HeimdallReportingPayload,
      params: RequestParams = {},
    ) =>
      this.request<HeimdallReportingResponse, HTTPValidationError>({
        path: `/heimdall/${userId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Heimdall
     * @name ResetHeimdallRateLimitHeimdallUserIdToResetResetPatch
     * @summary Reset Heimdall Rate Limit
     * @request PATCH:/heimdall/{user_id_to_reset}/reset
     * @secure
     */
    resetHeimdallRateLimitHeimdallUserIdToResetResetPatch: (
      userIdToReset: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/heimdall/${userIdToReset}/reset`,
        method: "PATCH",
        secure: true,
        ...params,
      }),
  };
  larsMagnus = {
    /**
     * No description
     *
     * @tags Lars Magnus
     * @name CheckTelavoxIdsLarsMagnusTelavoxCheckGet
     * @summary Check Telavox Ids
     * @request GET:/lars-magnus/telavox-check
     * @secure
     */
    checkTelavoxIdsLarsMagnusTelavoxCheckGet: (params: RequestParams = {}) =>
      this.request<TelavoxMismatch, any>({
        path: `/lars-magnus/telavox-check`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Lars Magnus
     * @name CurrentTelavoxUserLarsMagnusTelavoxUserGet
     * @summary Current Telavox User
     * @request GET:/lars-magnus/telavox-user
     * @secure
     */
    currentTelavoxUserLarsMagnusTelavoxUserGet: (params: RequestParams = {}) =>
      this.request<TelavoxExtension, any>({
        path: `/lars-magnus/telavox-user`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  myPages = {
    /**
     * No description
     *
     * @tags My Pages
     * @name ImpersonateCustomerMyPagesImpersonatePost
     * @summary Impersonate Customer
     * @request POST:/my-pages/impersonate
     * @secure
     */
    impersonateCustomerMyPagesImpersonatePost: (
      data: ImpersonateCustomerPayload,
      params: RequestParams = {},
    ) =>
      this.request<BankIDLoginResponse, HTTPValidationError>({
        path: `/my-pages/impersonate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name ValidateClearingMyPagesOffersClearingValidateClearingGet
     * @summary Validate Clearing
     * @request GET:/my-pages/offers/clearing/validate/{clearing}
     */
    validateClearingMyPagesOffersClearingValidateClearingGet: (
      clearing: string,
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/my-pages/offers/clearing/validate/${clearing}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Gather request md and proceed with accepting terms for insurance used for customers that are not authenticated and cannot change the amount
     *
     * @tags My Pages
     * @name ConfirmInsuranceTermsMyPagesInsurancesConfirmPost
     * @summary Confirm Insurance Terms
     * @request POST:/my-pages/insurances/confirm
     */
    confirmInsuranceTermsMyPagesInsurancesConfirmPost: (
      query: {
        /** Encrypted Insurance Id */
        encrypted_insurance_id: string;
        /** Email */
        email: string;
        /** Phone Number */
        phone_number: string;
        /** Success Url */
        success_url: string;
        /** Fail Url */
        fail_url: string;
        /** Insured Amount */
        insured_amount?: number | null;
        /** Premium */
        premium?: number | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<AcceptTermsResponse, HTTPValidationError>({
        path: `/my-pages/insurances/confirm`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetInsuranceMyPagesInsuranceGet
     * @summary Get Insurance
     * @request GET:/my-pages/insurance
     */
    getInsuranceMyPagesInsuranceGet: (
      query: {
        /** Id */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UnauthenticatedInsurance, HTTPValidationError>({
        path: `/my-pages/insurance`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetLatestActiveApplicationsV2MyPagesV2ApplicationsLatestGet
     * @summary Get Latest Active Applications V2
     * @request GET:/my-pages/v2/applications/latest
     * @secure
     */
    getLatestActiveApplicationsV2MyPagesV2ApplicationsLatestGet: (
      params: RequestParams = {},
    ) =>
      this.request<CustomerApplicationV2[], any>({
        path: `/my-pages/v2/applications/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetLatestActiveApplicationMyPagesApplicationLatestGet
     * @summary Get Latest Active Application
     * @request GET:/my-pages/application/latest
     * @secure
     */
    getLatestActiveApplicationMyPagesApplicationLatestGet: (
      params: RequestParams = {},
    ) =>
      this.request<CustomerApplication | null, any>({
        path: `/my-pages/application/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetCreditCardOffersMyPagesCreditCardOffersGet
     * @summary Get Credit Card Offers
     * @request GET:/my-pages/credit_card/offers
     * @secure
     */
    getCreditCardOffersMyPagesCreditCardOffersGet: (
      params: RequestParams = {},
    ) =>
      this.request<CreditorOfferCreditCardOfferDataCreditCardTerms[], any>({
        path: `/my-pages/credit_card/offers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetApplicantMyPagesApplicantMeGet
     * @summary Get Applicant
     * @request GET:/my-pages/applicant/me
     * @secure
     */
    getApplicantMyPagesApplicantMeGet: (params: RequestParams = {}) =>
      this.request<
        | ({
            country: "SE";
          } & ApplicantSE)
        | ({
            country: "NO";
          } & ApplicantNO),
        any
      >({
        path: `/my-pages/applicant/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A 1-hour link to the Swish pay-now page for the logged-in customer's unpaid insurance invoices. Also under impersonation: the agent can mint the customer a link anyway, and the link opens no payment on its own.
     *
     * @tags My Pages
     * @name GetMyPayNowLinkMyPagesInsurancePayNowLinkGet
     * @summary Get My Pay Now Link
     * @request GET:/my-pages/insurance/pay-now-link
     * @secure
     */
    getMyPayNowLinkMyPagesInsurancePayNowLinkGet: (
      params: RequestParams = {},
    ) =>
      this.request<PayNowLink, any>({
        path: `/my-pages/insurance/pay-now-link`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The customer's active MONO applications, as applicant or co-applicant, newest first: the cases they can upload documents to.
     *
     * @tags My Pages
     * @name ListMyMortgageApplicationsMyPagesCaseDocumentsApplicationsGet
     * @summary List My Mortgage Applications
     * @request GET:/my-pages/case-documents/applications
     * @secure
     */
    listMyMortgageApplicationsMyPagesCaseDocumentsApplicationsGet: (
      params: RequestParams = {},
    ) =>
      this.request<CustomerMortgageApplication[], any>({
        path: `/my-pages/case-documents/applications`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The documents the customer uploaded to one of their MONO applications, newest first. 404 for an application that is not theirs or not MONO.
     *
     * @tags My Pages
     * @name ListMyCaseDocumentsMyPagesCaseDocumentsApplicationIdGet
     * @summary List My Case Documents
     * @request GET:/my-pages/case-documents/{application_id}
     * @secure
     */
    listMyCaseDocumentsMyPagesCaseDocumentsApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<CustomerCaseDocument[], HTTPValidationError>({
        path: `/my-pages/case-documents/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload a document to one of the customer's MONO applications, as applicant or co-applicant (404 otherwise). The agent sees it in Case View; no bank sees it until an agent shares it. At most 20 MB (413, also for a larger Content-Length, before the body is read; 411 without one) and 50 live uploads per application (409); PDF, JPEG, PNG, HEIC, DOCX or XLSX by extension and content (415). 403 for an impersonated session: agents upload in Case View.
     *
     * @tags My Pages
     * @name UploadMyCaseDocumentMyPagesCaseDocumentsApplicationIdPost
     * @summary Upload My Case Document
     * @request POST:/my-pages/case-documents/{application_id}
     * @secure
     */
    uploadMyCaseDocumentMyPagesCaseDocumentsApplicationIdPost: (
      applicationId: string,
      data: BodyUploadMyCaseDocumentMyPagesCaseDocumentsApplicationIdPost,
      params: RequestParams = {},
    ) =>
      this.request<CustomerCaseDocument, HTTPValidationError>({
        path: `/my-pages/case-documents/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Legacy blanco endpoint (Sverker)
     *
     * @tags My Pages
     * @name AcceptOfferLegacyMyPagesOfferAcceptPost
     * @summary Accept Offer Legacy
     * @request POST:/my-pages/offer/accept
     * @secure
     */
    acceptOfferLegacyMyPagesOfferAcceptPost: (
      data: RoutersMyPagesPayloadAcceptOfferPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/offer/accept`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Legacy blanco endpoint (Sverker). An application ZRM owns, ZRM-only (> 1M app id) or legacy moved to ZRM, goes to the v3 (apps-mgr v4 UUID) accept path instead of Sverker.
     *
     * @tags My Pages
     * @name AcceptOfferLegacyV2MyPagesV2OfferAcceptPost
     * @summary Accept Offer Legacy V2
     * @request POST:/my-pages/v2/offer/accept
     * @secure
     */
    acceptOfferLegacyV2MyPagesV2OfferAcceptPost: (
      data: AcceptOfferPayloadV2,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/v2/offer/accept`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Latest blanco applications/offers sourced from apps-mgr v4 raw applications (new offer model).
     *
     * @tags My Pages
     * @name GetLatestActiveApplicationsV3MyPagesV3ApplicationsLatestGet
     * @summary Get Latest Active Applications V3
     * @request GET:/my-pages/v3/applications/latest
     * @secure
     */
    getLatestActiveApplicationsV3MyPagesV3ApplicationsLatestGet: (
      params: RequestParams = {},
    ) =>
      this.request<CustomerApplicationV3[], any>({
        path: `/my-pages/v3/applications/latest`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Blanco offer accept via apps-mgr v4 (new offer model). Sources applications/offers from ``get_customer_applications_v3`` (raw apps via apps-mgr v4) and accepts directly by the UUID ``offer_id`` — no Sverker translation.
     *
     * @tags My Pages
     * @name AcceptOfferV3MyPagesV3OfferAcceptPost
     * @summary Accept Offer V3
     * @request POST:/my-pages/v3/offer/accept
     * @secure
     */
    acceptOfferV3MyPagesV3OfferAcceptPost: (
      data: AcceptOfferPayloadV2,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/v3/offer/accept`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name AcceptOfferMyPagesOfferAccept2Post
     * @summary Accept Offer
     * @request POST:/my-pages/offer/accept2
     * @secure
     */
    acceptOfferMyPagesOfferAccept2Post: (
      data: AcceptOffer,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/offer/accept2`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name BanksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet
     * @summary Banks To Exclude From Insurance Offering For
     * @request GET:/my-pages/insurances/banks/excluded
     * @deprecated
     * @secure
     */
    banksToExcludeFromInsuranceOfferingForMyPagesInsurancesBanksExcludedGet: (
      params: RequestParams = {},
    ) =>
      this.request<BanksToExcludeInsuranceOfferingFor, any>({
        path: `/my-pages/insurances/banks/excluded`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name InsurancesRulesMyPagesInsurancesRulesGet
     * @summary Insurances Rules
     * @request GET:/my-pages/insurances/rules
     * @secure
     */
    insurancesRulesMyPagesInsurancesRulesGet: (params: RequestParams = {}) =>
      this.request<RulesResponse, any>({
        path: `/my-pages/insurances/rules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name LoanInsurancesRulesMyPagesInsurancesLoanInsuranceRulesGet
     * @summary Loan Insurances Rules
     * @request GET:/my-pages/insurances/loan-insurance-rules
     * @secure
     */
    loanInsurancesRulesMyPagesInsurancesLoanInsuranceRulesGet: (
      params: RequestParams = {},
    ) =>
      this.request<InsuranceTerms, any>({
        path: `/my-pages/insurances/loan-insurance-rules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name IdCheckMyPagesIdCheckGet
     * @summary Id Check
     * @request GET:/my-pages/id-check
     * @secure
     */
    idCheckMyPagesIdCheckGet: (params: RequestParams = {}) =>
      this.request<
        | (
            | ({
                country: "SE";
              } & ApplicantSE)
            | ({
                country: "NO";
              } & ApplicantNO)
          )
        | (
            | ({
                country: "SE";
              } & OptionalApplicantSE)
            | ({
                country: "NO";
              } & OptionalApplicantNO)
          )
        | IDCheckedPerson,
        any
      >({
        path: `/my-pages/id-check`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name ActiveInsuranceByPniMyPagesInsurancesGet
     * @summary Active Insurance By Pni
     * @request GET:/my-pages/insurances
     * @secure
     */
    activeInsuranceByPniMyPagesInsurancesGet: (params: RequestParams = {}) =>
      this.request<InsuranceCustomer[], any>({
        path: `/my-pages/insurances`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name CreateInsuranceV2MyPagesInsurancesV2Post
     * @summary Create Insurance V2
     * @request POST:/my-pages/insurances/v2
     * @secure
     */
    createInsuranceV2MyPagesInsurancesV2Post: (
      data: CreateInsuranceCustomer,
      params: RequestParams = {},
    ) =>
      this.request<AcceptTermsResponseCustomer, HTTPValidationError>({
        path: `/my-pages/insurances/v2`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name DebtRegisterConsentMyPagesDebtRegisterConsentPost
     * @summary Debt Register Consent
     * @request POST:/my-pages/debt-register/consent
     * @secure
     */
    debtRegisterConsentMyPagesDebtRegisterConsentPost: (
      params: RequestParams = {},
    ) =>
      this.request<
        | (
            | ({
                country: "SE";
              } & ApplicantSE)
            | ({
                country: "NO";
              } & ApplicantNO)
          )
        | (
            | ({
                country: "SE";
              } & OptionalApplicantSE)
            | ({
                country: "NO";
              } & OptionalApplicantNO)
          ),
        HTTPValidationError
      >({
        path: `/my-pages/debt-register/consent`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name DebtRegisterCheckConsentMyPagesDebtRegisterCheckConsentPost
     * @summary Debt Register Check Consent
     * @request POST:/my-pages/debt-register/check-consent
     * @secure
     */
    debtRegisterCheckConsentMyPagesDebtRegisterCheckConsentPost: (
      params: RequestParams = {},
    ) =>
      this.request<
        | (
            | ({
                country: "SE";
              } & ApplicantSE)
            | ({
                country: "NO";
              } & ApplicantNO)
          )
        | (
            | ({
                country: "SE";
              } & OptionalApplicantSE)
            | ({
                country: "NO";
              } & OptionalApplicantNO)
          ),
        any
      >({
        path: `/my-pages/debt-register/check-consent`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name DebtRegisterRenewMyPagesDebtRegisterRenewPost
     * @summary Debt Register Renew
     * @request POST:/my-pages/debt-register/renew
     * @secure
     */
    debtRegisterRenewMyPagesDebtRegisterRenewPost: (
      params: RequestParams = {},
    ) =>
      this.request<
        | (
            | ({
                country: "SE";
              } & ApplicantSE)
            | ({
                country: "NO";
              } & ApplicantNO)
          )
        | (
            | ({
                country: "SE";
              } & OptionalApplicantSE)
            | ({
                country: "NO";
              } & OptionalApplicantNO)
          ),
        any
      >({
        path: `/my-pages/debt-register/renew`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This is part of the GR first project. And should only be used by GR first customers. otherwise it will cause faulty data to Google Analytics.
     *
     * @tags My Pages
     * @name DebtRegisterWithConsentMyPagesDebtRegisterWithConsentPost
     * @summary Debt Register With Consent
     * @request POST:/my-pages/debt-register/with-consent
     * @secure
     */
    debtRegisterWithConsentMyPagesDebtRegisterWithConsentPost: (
      data: BodyDebtRegisterWithConsentMyPagesDebtRegisterWithConsentPost,
      params: RequestParams = {},
    ) =>
      this.request<
        | (
            | ({
                country: "SE";
              } & ApplicantSE)
            | ({
                country: "NO";
              } & ApplicantNO)
          )
        | (
            | ({
                country: "SE";
              } & OptionalApplicantSE)
            | ({
                country: "NO";
              } & OptionalApplicantNO)
          ),
        HTTPValidationError
      >({
        path: `/my-pages/debt-register/with-consent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Compare-Debt proxy: authenticates the customer via BankID/Vipps and delegates the aggregate lookup to customer-service. Gender is derived server-side in customer-service for bucketing and is never returned in the DTO.
     *
     * @tags My Pages
     * @name DebtCompareMyPagesDebtComparePost
     * @summary Debt Compare
     * @request POST:/my-pages/debt-compare
     * @secure
     */
    debtCompareMyPagesDebtComparePost: (params: RequestParams = {}) =>
      this.request<DebtRegisterCompareResponse, any>({
        path: `/my-pages/debt-compare`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name UpsertMarketingConsentMyPagesMarketingConsentsPost
     * @summary Upsert Marketing Consent
     * @request POST:/my-pages/marketing-consents
     * @secure
     */
    upsertMarketingConsentMyPagesMarketingConsentsPost: (
      data: ConsentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/marketing-consents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name GetTrustlyUrlForNewMandateMyPagesInsurancesTrustlyUrlGet
     * @summary Get Trustly Url For New Mandate
     * @request GET:/my-pages/insurances/trustly-url
     * @secure
     */
    getTrustlyUrlForNewMandateMyPagesInsurancesTrustlyUrlGet: (
      query: {
        /** Id */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/my-pages/insurances/trustly-url`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Car Evaluation (Bilverdi) — NO only. Returns the vehicles the authenticated customer owns plus each car's valuation and technical stats. PNI comes ONLY from the verified BankID token `sub`; any pni in the body is ignored. customer-service fetches the customer's OWN vehicle list and then the per-car details (no caller-supplied reg-no path), so a customer can never look up another person's car. Reached only after GR consent (every viewer is a known, identified customer).
     *
     * @tags My Pages
     * @name CarEvalWithConsentMyPagesCarEvalWithConsentPost
     * @summary Car Eval With Consent
     * @request POST:/my-pages/car-eval/with-consent
     * @secure
     */
    carEvalWithConsentMyPagesCarEvalWithConsentPost: (
      data: BodyCarEvalWithConsentMyPagesCarEvalWithConsentPost,
      params: RequestParams = {},
    ) =>
      this.request<CarEvalResponse, HTTPValidationError>({
        path: `/my-pages/car-eval/with-consent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This is part of the EV first project. And should only be used by EV first customers. otherwise it will cause faulty data to Google Analytics.
     *
     * @tags My Pages
     * @name EvStatesWithConsentMyPagesEiendomsverdieWithConsentPost
     * @summary Ev States With Consent
     * @request POST:/my-pages/eiendomsverdie/with-consent
     * @secure
     */
    evStatesWithConsentMyPagesEiendomsverdieWithConsentPost: (
      data: BodyEvStatesWithConsentMyPagesEiendomsverdieWithConsentPost,
      params: RequestParams = {},
    ) =>
      this.request<EvFirstResponse, HTTPValidationError>({
        path: `/my-pages/eiendomsverdie/with-consent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name CanSignUpMyPagesCanSignUpGet
     * @summary Can Sign Up
     * @request GET:/my-pages/can-sign-up
     * @secure
     */
    canSignUpMyPagesCanSignUpGet: (params: RequestParams = {}) =>
      this.request<CanSignupResponse, any>({
        path: `/my-pages/can-sign-up`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags My Pages
     * @name MyCreditScorePniMyPagesMyCreditScoreByPniPost
     * @summary My Credit Score Pni
     * @request POST:/my-pages/my-credit-score/by-pni
     * @secure
     */
    myCreditScorePniMyPagesMyCreditScoreByPniPost: (
      query: {
        /** Email */
        email: string | null;
        /** Phone Number */
        phone_number: string | null;
      },
      data: Consents | null,
      params: RequestParams = {},
    ) =>
      this.request<
        CreditReport | CreditReportUc | CreditReportExperian | null,
        HTTPValidationError
      >({
        path: `/my-pages/my-credit-score/by-pni`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  zms = {
    /**
     * No description
     *
     * @tags ZMS
     * @name SaveZmsConfigZmsCountryPost
     * @summary Save Zms Config
     * @request POST:/zms/{country}
     * @secure
     */
    saveZmsConfigZmsCountryPost: (
      country: Country,
      data: Config,
      params: RequestParams = {},
    ) =>
      this.request<ZMSConfig, HTTPValidationError>({
        path: `/zms/${country}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ZMS
     * @name GetZmsConfigZmsCountryGet
     * @summary Get Zms Config
     * @request GET:/zms/{country}
     */
    getZmsConfigZmsCountryGet: (country: Country, params: RequestParams = {}) =>
      this.request<ZMSConfig, HTTPValidationError>({
        path: `/zms/${country}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ZMS
     * @name GetAllConfigsZmsGet
     * @summary Get All Configs
     * @request GET:/zms
     */
    getAllConfigsZmsGet: (params: RequestParams = {}) =>
      this.request<ZMSConfig[], any>({
        path: `/zms`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  affiliates = {
    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateAffiliateAffiliatesPost
     * @summary Create Affiliate
     * @request POST:/affiliates/
     * @secure
     */
    createAffiliateAffiliatesPost: (
      data: AffiliateData,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliatesAffiliatesGet
     * @summary Get Affiliates
     * @request GET:/affiliates/
     * @secure
     */
    getAffiliatesAffiliatesGet: (
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
        /** Status */
        status?: string | null;
        /**
         * Network
         * @default false
         */
        network?: boolean | null;
        /**
         * Publisher
         * @default false
         */
        publisher?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<Affiliate[], HTTPValidationError>({
        path: `/affiliates/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name SearchAffiliatesAffiliatesSearchGet
     * @summary Search Affiliates
     * @request GET:/affiliates/search
     * @secure
     */
    searchAffiliatesAffiliatesSearchGet: (
      query: {
        /** Keyword */
        keyword: string;
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Affiliate[], HTTPValidationError>({
        path: `/affiliates/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliateAffiliatesAffiliateIdGet
     * @summary Get Affiliate
     * @request GET:/affiliates/{affiliate_id}
     * @secure
     */
    getAffiliateAffiliatesAffiliateIdGet: (
      affiliateId: string,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name UpdateAffiliateAffiliatesAffiliateIdPut
     * @summary Update Affiliate
     * @request PUT:/affiliates/{affiliate_id}
     * @secure
     */
    updateAffiliateAffiliatesAffiliateIdPut: (
      affiliateId: string,
      data: AffiliateData,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name DeactivateAffiliateAffiliatesAffiliateIdDelete
     * @summary Deactivate Affiliate
     * @request DELETE:/affiliates/{affiliate_id}
     * @secure
     */
    deactivateAffiliateAffiliatesAffiliateIdDelete: (
      affiliateId: string,
      params: RequestParams = {},
    ) =>
      this.request<NonEmptyString, HTTPValidationError>({
        path: `/affiliates/${affiliateId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateCampaignAffiliatesAffiliateIdCampaignsPost
     * @summary Create Campaign
     * @request POST:/affiliates/{affiliate_id}/campaigns
     * @secure
     */
    createCampaignAffiliatesAffiliateIdCampaignsPost: (
      affiliateId: string,
      data: CampaignData,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetCampaignsAffiliatesAffiliateIdCampaignsGet
     * @summary Get Campaigns
     * @request GET:/affiliates/{affiliate_id}/campaigns
     * @secure
     */
    getCampaignsAffiliatesAffiliateIdCampaignsGet: (
      affiliateId: string,
      params: RequestParams = {},
    ) =>
      this.request<ModelsAffiliateAffiliateCampaign[], HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name UpdateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut
     * @summary Update Campaign
     * @request PUT:/affiliates/{affiliate_id}/campaigns/{campaign_id}
     * @secure
     */
    updateCampaignAffiliatesAffiliateIdCampaignsCampaignIdPut: (
      campaignId: string,
      affiliateId: string,
      data: CampaignData,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate, HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns/${campaignId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name RemoveCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete
     * @summary Remove Campaign
     * @request DELETE:/affiliates/{affiliate_id}/campaigns/{campaign_id}
     * @secure
     */
    removeCampaignAffiliatesAffiliateIdCampaignsCampaignIdDelete: (
      campaignId: string,
      affiliateId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/affiliates/${affiliateId}/campaigns/${campaignId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetPersonEventAffiliatesPersonsZidGet
     * @summary Get Person Event
     * @request GET:/affiliates/persons/{zid}
     * @secure
     */
    getPersonEventAffiliatesPersonsZidGet: (
      zid: string,
      params: RequestParams = {},
    ) =>
      this.request<Person, HTTPValidationError>({
        path: `/affiliates/persons/${zid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet
     * @summary Get Affiliate Person Events
     * @request GET:/affiliates/{affiliate_id}/persons
     * @secure
     */
    getAffiliatePersonEventsAffiliatesAffiliateIdPersonsGet: (
      affiliateId: string,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Person[], HTTPValidationError>({
        path: `/affiliates/${affiliateId}/persons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost
     * @summary Get Affiliate Callbacks
     * @request POST:/affiliates/{affiliate_network_id}/callbacks
     * @secure
     */
    getAffiliateCallbacksAffiliatesAffiliateNetworkIdCallbacksPost: (
      affiliateNetworkId: string,
      data: AffiliateNetworkCallbackStatus[] | null,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 100
         * @default 50
         */
        limit?: number;
        /** Publisher */
        publisher?: string | null;
        /** Start Date */
        start_date?: string | null;
        /** End Date */
        end_date?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<AffiliateNetworkCallbackEvent[], HTTPValidationError>({
        path: `/affiliates/${affiliateNetworkId}/callbacks`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name GetAffiliatePublishersAffiliatesAffiliateIdPublishersGet
     * @summary Get Affiliate Publishers
     * @request GET:/affiliates/{affiliate_id}/publishers
     * @secure
     */
    getAffiliatePublishersAffiliatesAffiliateIdPublishersGet: (
      affiliateId: string,
      params: RequestParams = {},
    ) =>
      this.request<Affiliate[], HTTPValidationError>({
        path: `/affiliates/${affiliateId}/publishers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name AdtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTtGet
     * @summary Adtraction Network Callback
     * @request GET:/affiliates/dev/adtraction/callback/{site}/t/t
     * @secure
     */
    adtractionNetworkCallbackAffiliatesDevAdtractionCallbackSiteTTGet: (
      site: string,
      params: RequestParams = {},
    ) =>
      this.request<HTTPStatus, HTTPValidationError>({
        path: `/affiliates/dev/adtraction/callback/${site}/t/t`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name AdserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet
     * @summary Adservice Network Callback
     * @request GET:/affiliates/dev/adservice/callback/cgi-bin/API/ConversionService/Callback
     * @secure
     */
    adserviceNetworkCallbackAffiliatesDevAdserviceCallbackCgiBinApiConversionServiceCallbackGet:
      (params: RequestParams = {}) =>
        this.request<HTTPStatus, any>({
          path: `/affiliates/dev/adservice/callback/cgi-bin/API/ConversionService/Callback`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Affiliate
     * @name SmartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet
     * @summary Smartresponse Network Callback
     * @request GET:/affiliates/dev/smartresponse/callback/p.ashx
     * @secure
     */
    smartresponseNetworkCallbackAffiliatesDevSmartresponseCallbackPAshxGet: (
      params: RequestParams = {},
    ) =>
      this.request<HTTPStatus, any>({
        path: `/affiliates/dev/smartresponse/callback/p.ashx`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  online = {
    /**
     * @description Get all submissions for a country, newest first. Leave `cursor` out for the first page, then pass the `next_cursor` or the `prev_cursor` of the page you are on.
     *
     * @tags Online
     * @name GetAllSubmissionsOnlineSubmissionsGet
     * @summary Get All Submissions
     * @request GET:/online/submissions
     * @secure
     */
    getAllSubmissionsOnlineSubmissionsGet: (
      query?: {
        /** Failed */
        failed?: boolean | null;
        /** Handled */
        handled?: boolean | null;
        /** Form Validation */
        form_validation?: boolean | null;
        /** Quick Application */
        quick_application?: boolean | null;
        /** Get Customers */
        get_customers?: boolean | null;
        /** Has Recent App Check */
        has_recent_app_check?: boolean | null;
        /** Created Application */
        created_application?: boolean | null;
        /** App Created Hours Ago */
        app_created_hours_ago?: number | null;
        /**
         * Limit
         * @min 1
         * @max 200
         * @default 50
         */
        limit?: number;
        /** Cursor */
        cursor?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SubmissionReviewResponse, HTTPValidationError>({
        path: `/online/submissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get submission by id
     *
     * @tags Online
     * @name GetASubmissionOnlineSubmissionsSubmissionIdGet
     * @summary Get A Submission
     * @request GET:/online/submissions/{submission_id}
     * @secure
     */
    getASubmissionOnlineSubmissionsSubmissionIdGet: (
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SubmissionReview, HTTPValidationError>({
        path: `/online/submissions/${submissionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description What the customer applied for in the online form the application came from, for the case view summary: null when it came from no form. Open to the case view departments, unlike the full submission above, because it carries no personal data.
     *
     * @tags Online
     * @name GetOnlineFormRequestOnlineSubmissionsByApplicationLabelGet
     * @summary Get Online Form Request
     * @request GET:/online/submissions/by-application/{label}
     * @secure
     */
    getOnlineFormRequestOnlineSubmissionsByApplicationLabelGet: (
      label: string,
      params: RequestParams = {},
    ) =>
      this.request<OnlineFormRequest | null, HTTPValidationError>({
        path: `/online/submissions/by-application/${label}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retry processing of submissions in case of temporary error
     *
     * @tags Online
     * @name PostReprocessSubmissionsOnlineSubmissionsReprocessPost
     * @summary Post Reprocess Submissions
     * @request POST:/online/submissions/reprocess
     * @secure
     */
    postReprocessSubmissionsOnlineSubmissionsReprocessPost: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<EnqueuedSubmissionJobResult[], HTTPValidationError>({
        path: `/online/submissions/reprocess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retry processing of submission in case of temporary error
     *
     * @tags Online
     * @name PostReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost
     * @summary Post Reprocess Submission
     * @request POST:/online/submissions/{submission_id}/reprocess
     * @secure
     */
    postReprocessSubmissionOnlineSubmissionsSubmissionIdReprocessPost: (
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<EnqueuedSubmissionJobResult, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/reprocess`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name PostResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost
     * @summary Post Resubmit Submission
     * @request POST:/online/submissions/{submission_id}/resubmit
     * @secure
     */
    postResubmitSubmissionOnlineSubmissionsSubmissionIdResubmitPost: (
      submissionId: string,
      data: ResubmitPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnqueuedSubmissionJobResult, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/resubmit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name PostReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost
     * @summary Post Review Submission
     * @request POST:/online/submissions/{submission_id}/review
     * @secure
     */
    postReviewSubmissionOnlineSubmissionsSubmissionIdReviewPost: (
      submissionId: string,
      query?: {
        /**
         * Handled
         * @default true
         */
        handled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<HandledSubmission, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/review`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name PostReviewSubmissionsOnlineSubmissionsReviewPost
     * @summary Post Review Submissions
     * @request POST:/online/submissions/review
     * @secure
     */
    postReviewSubmissionsOnlineSubmissionsReviewPost: (
      data: ReviewSubmissions,
      params: RequestParams = {},
    ) =>
      this.request<HandledSubmission[], HTTPValidationError>({
        path: `/online/submissions/review`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Converts a credit card submission to a blanco submission
     *
     * @tags Online
     * @name PostConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost
     * @summary Post Convert To Blanco
     * @request POST:/online/submissions/{submission_id}/convert_to_blanco
     * @secure
     */
    postConvertToBlancoOnlineSubmissionsSubmissionIdConvertToBlancoPost: (
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<EnqueuedSubmissionJobResult, HTTPValidationError>({
        path: `/online/submissions/${submissionId}/convert_to_blanco`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name OnlineAppsMessagesOnlineSendBlancoSmsMessagesPost
     * @summary Online Apps Messages
     * @request POST:/online/send_blanco_sms_messages
     * @secure
     */
    onlineAppsMessagesOnlineSendBlancoSmsMessagesPost: (
      query: {
        country: Country;
        product: Product;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/online/send_blanco_sms_messages`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name WhitelistedPniOnlineTestingPnisGet
     * @summary Whitelisted Pni
     * @request GET:/online/testing-pnis
     * @secure
     */
    whitelistedPniOnlineTestingPnisGet: (params: RequestParams = {}) =>
      this.request<OnlineFormsTestingPNIResponse, any>({
        path: `/online/testing-pnis`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name GetBookingsOnlineBookingsCountryGet
     * @summary Get Bookings
     * @request GET:/online/bookings/{country}
     */
    getBookingsOnlineBookingsCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/online/bookings/${country}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name BookMeetingOnlineBookingsCountryPost
     * @summary Book Meeting
     * @request POST:/online/bookings/{country}
     */
    bookMeetingOnlineBookingsCountryPost: (
      country: Country,
      data: BookingPayload,
      params: RequestParams = {},
    ) =>
      this.request<ServicesSverkerResponsesMeeting, HTTPValidationError>({
        path: `/online/bookings/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name MortgageRatesOnlineMortgageRatesCountryGet
     * @summary Mortgage Rates
     * @request GET:/online/mortgage-rates/{country}
     */
    mortgageRatesOnlineMortgageRatesCountryGet: (
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<CompanyMortgageRates[], HTTPValidationError>({
        path: `/online/mortgage-rates/${country}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name ContactFormOnlineContactCountryPost
     * @summary Contact Form
     * @request POST:/online/contact/{country}
     */
    contactFormOnlineContactCountryPost: (
      country: Country,
      data: ContactFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/online/contact/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name MortgageFormOnlineMortgageCountryPost
     * @summary Mortgage Form
     * @request POST:/online/mortgage/{country}
     */
    mortgageFormOnlineMortgageCountryPost: (
      country: Country,
      data: MortgageFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/online/mortgage/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name BlancoApplicationOnlineBlancoApplicationCountryPost
     * @summary Blanco Application
     * @request POST:/online/blanco-application/{country}
     */
    blancoApplicationOnlineBlancoApplicationCountryPost: (
      country: Country,
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<FormApplicationSubmissionResult, HTTPValidationError>({
        path: `/online/blanco-application/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name OnlineQuickCreateOnlineQuickCreatePost
     * @summary Online Quick Create
     * @request POST:/online/quick-create
     */
    onlineQuickCreateOnlineQuickCreatePost: (
      data:
        | (
            | ({
                product: "blanco";
              } & QuickCreateBlancoApplication)
            | ({
                product: "mortgage";
              } & QuickCreateMortgageApplication)
          )
        | Record<string, any>,
      params: RequestParams = {},
    ) =>
      this.request<FormApplicationSubmissionResult, HTTPValidationError>({
        path: `/online/quick-create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Norway only
     *
     * @tags Online
     * @name NorwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost
     * @summary Norwegian Mortgage Application
     * @request POST:/online/norwegian-mortgage-application
     */
    norwegianMortgageApplicationOnlineNorwegianMortgageApplicationPost: (
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<FormApplicationSubmissionResult, HTTPValidationError>({
        path: `/online/norwegian-mortgage-application`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Reusing JotformCCApplicationWithTracking and its existing backend to minimize number of changes
     *
     * @tags Online
     * @name CreditCardApplicationOnlineCreditCardApplicationPost
     * @summary Credit Card Application
     * @request POST:/online/credit-card-application/
     */
    creditCardApplicationOnlineCreditCardApplicationPost: (
      data: JotformCCApplicationWithTracking,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/online/credit-card-application/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Accept a credit card application from the React app, using the internal CC model.
     *
     * @tags Online
     * @name CcApplicationSubmitOnlineCcApplicationPost
     * @summary Cc Application Submit
     * @request POST:/online/cc-application
     */
    ccApplicationSubmitOnlineCcApplicationPost: (
      data: CCApplicationRequest,
      params: RequestParams = {},
    ) =>
      this.request<FormApplicationSubmissionResult, HTTPValidationError>({
        path: `/online/cc-application`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  rq = {
    /**
     * No description
     *
     * @tags Monitor
     * @name GetListOfJobsRqJobsGet
     * @summary Get List Of Jobs
     * @request GET:/rq/jobs
     * @secure
     */
    getListOfJobsRqJobsGet: (
      query: {
        job_type: JobType;
      },
      params: RequestParams = {},
    ) =>
      this.request<RqJobStatusResponse[], HTTPValidationError>({
        path: `/rq/jobs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitor
     * @name GetFailedJobsRqManualFailGet
     * @summary Get Failed Jobs
     * @request GET:/rq/manual-fail
     * @secure
     */
    getFailedJobsRqManualFailGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/rq/manual-fail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitor
     * @name ClearFailedJobRqDeleteJobJobIdGet
     * @summary Clear Failed Job
     * @request GET:/rq/delete-job/{job_id}
     * @secure
     */
    clearFailedJobRqDeleteJobJobIdGet: (
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/rq/delete-job/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitor
     * @name ReScheduleRqReScheduleGet
     * @summary Re Schedule
     * @request GET:/rq/re-schedule
     * @secure
     */
    reScheduleRqReScheduleGet: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/rq/re-schedule`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Monitor
     * @name GetSingleJobRqJobIdGet
     * @summary Get Single Job
     * @request GET:/rq/{job_id}
     * @secure
     */
    getSingleJobRqJobIdGet: (jobId: string, params: RequestParams = {}) =>
      this.request<RqJobStatusResponse | null, HTTPValidationError>({
        path: `/rq/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tv = {
    /**
     * No description
     *
     * @tags TV
     * @name PreviewTvPairingTvPairPreviewPost
     * @summary Preview Tv Pairing
     * @request POST:/tv/pair/preview
     * @secure
     */
    previewTvPairingTvPairPreviewPost: (
      data: TvPairPreviewRequest,
      params: RequestParams = {},
    ) =>
      this.request<TvPairingPreview, HTTPValidationError>({
        path: `/tv/pair/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name ClaimTvPairingTvPairClaimPost
     * @summary Claim Tv Pairing
     * @request POST:/tv/pair/claim
     * @secure
     */
    claimTvPairingTvPairClaimPost: (
      data: TvPairClaimRequest,
      params: RequestParams = {},
    ) =>
      this.request<TvDevice, HTTPValidationError>({
        path: `/tv/pair/claim`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name ListTvDevicesTvDevicesGet
     * @summary List Tv Devices
     * @request GET:/tv/devices
     * @secure
     */
    listTvDevicesTvDevicesGet: (params: RequestParams = {}) =>
      this.request<TvDevice[], any>({
        path: `/tv/devices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name RevokeTvDeviceTvDevicesDeviceIdDelete
     * @summary Revoke Tv Device
     * @request DELETE:/tv/devices/{device_id}
     * @secure
     */
    revokeTvDeviceTvDevicesDeviceIdDelete: (
      deviceId: string,
      params: RequestParams = {},
    ) =>
      this.request<TvDevice, HTTPValidationError>({
        path: `/tv/devices/${deviceId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name GetTvGoalsTvGoalsGet
     * @summary Get Tv Goals
     * @request GET:/tv/goals
     * @secure
     */
    getTvGoalsTvGoalsGet: (
      query: {
        dashboard: TvDashboard;
        country: Country;
        /**
         * Month
         * @pattern ^\d{4}-(0[1-9]|1[0-2])$
         */
        month: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TvDashboardGoals, HTTPValidationError>({
        path: `/tv/goals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name PutTvGoalsTvGoalsPut
     * @summary Put Tv Goals
     * @request PUT:/tv/goals
     * @secure
     */
    putTvGoalsTvGoalsPut: (
      data: TvDashboardGoals,
      params: RequestParams = {},
    ) =>
      this.request<TvDashboardGoals, HTTPValidationError>({
        path: `/tv/goals`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name StartTvPairingTvPairStartPost
     * @summary Start Tv Pairing
     * @request POST:/tv/pair/start
     */
    startTvPairingTvPairStartPost: (
      data: TvPairStartRequest,
      params: RequestParams = {},
    ) =>
      this.request<TvPairStartResponse, HTTPValidationError>({
        path: `/tv/pair/start`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name PollTvPairingTvPairPollPost
     * @summary Poll Tv Pairing
     * @request POST:/tv/pair/poll
     */
    pollTvPairingTvPairPollPost: (
      data: TvPairPollRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            status: "pending";
          } & TvPairPending)
        | ({
            status: "paired";
          } & TvPairPaired),
        HTTPValidationError
      >({
        path: `/tv/pair/poll`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TV
     * @name GetTvMeTvMeGet
     * @summary Get Tv Me
     * @request GET:/tv/me
     * @secure
     */
    getTvMeTvMeGet: (params: RequestParams = {}) =>
      this.request<TvDevice, any>({
        path: `/tv/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The screen's dashboard as the cron last stored it; null until the first build. Reads only.
     *
     * @tags TV
     * @name GetTvDashboardTvDashboardGet
     * @summary Get Tv Dashboard
     * @request GET:/tv/dashboard
     * @secure
     */
    getTvDashboardTvDashboardGet: (params: RequestParams = {}) =>
      this.request<TvDashboardSnapshot | null, any>({
        path: `/tv/dashboard`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  kdlt = {
    /**
     * No description
     *
     * @tags kdlt
     * @name CallbackKdltCallbackPost
     * @summary Callback
     * @request POST:/kdlt/callback
     * @secure
     */
    callbackKdltCallbackPost: (
      data: KDLTCallbackPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/kdlt/callback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dialMaker = {
    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetLeadsForCampaignDialMakerTmLeadsCampaignIdPost
     * @summary Get Leads For Campaign
     * @request POST:/dial-maker/tm-leads/{campaign_id}
     * @secure
     */
    getLeadsForCampaignDialMakerTmLeadsCampaignIdPost: (
      campaignId: string,
      data: LeadExtractionInput,
      params: RequestParams = {},
    ) =>
      this.request<TMLeadsJob, HTTPValidationError>({
        path: `/dial-maker/tm-leads/${campaignId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetJobStatusOrResultDialMakerJobStatusJobIdGet
     * @summary Get Job Status Or Result
     * @request GET:/dial-maker/job-status/{job_id}
     * @secure
     */
    getJobStatusOrResultDialMakerJobStatusJobIdGet: (
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<TMLeadsExtraction | TMLeadsJob, HTTPValidationError>({
        path: `/dial-maker/job-status/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetDownloadUrlDialMakerJobResultJobIdDownloadUrlGet
     * @summary Get Download Url
     * @request GET:/dial-maker/job-result/{job_id}/download-url
     * @secure
     */
    getDownloadUrlDialMakerJobResultJobIdDownloadUrlGet: (
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<RoutersDialMakerPayloadsSignedUrl, HTTPValidationError>({
        path: `/dial-maker/job-result/${jobId}/download-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetCampaignsDialMakerCampaignsGet
     * @summary Get Campaigns
     * @request GET:/dial-maker/campaigns
     * @secure
     */
    getCampaignsDialMakerCampaignsGet: (
      query: {
        /** Page */
        page: number;
        /** Limit */
        limit: number;
        /** Department */
        department?: ZDepartment | null;
        /** Country */
        country?: Country | null;
        /** Product */
        product?: Product | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<TMCampaignList, HTTPValidationError>({
        path: `/dial-maker/campaigns`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name CreateCampaignDialMakerCampaignsPost
     * @summary Create Campaign
     * @request POST:/dial-maker/campaigns
     * @secure
     */
    createCampaignDialMakerCampaignsPost: (
      data: CreateTMCampaign,
      params: RequestParams = {},
    ) =>
      this.request<TMCampaign, HTTPValidationError>({
        path: `/dial-maker/campaigns`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name UpdateCampaignDialMakerCampaignsCampaignIdPut
     * @summary Update Campaign
     * @request PUT:/dial-maker/campaigns/{campaign_id}
     * @secure
     */
    updateCampaignDialMakerCampaignsCampaignIdPut: (
      campaignId: string,
      data: CreateTMCampaign,
      params: RequestParams = {},
    ) =>
      this.request<TMCampaign, HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetCampaignDialMakerCampaignsCampaignIdGet
     * @summary Get Campaign
     * @request GET:/dial-maker/campaigns/{campaign_id}
     * @secure
     */
    getCampaignDialMakerCampaignsCampaignIdGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<TMCampaign, HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name DeleteCampaignDialMakerCampaignsCampaignIdDelete
     * @summary Delete Campaign
     * @request DELETE:/dial-maker/campaigns/{campaign_id}
     * @secure
     */
    deleteCampaignDialMakerCampaignsCampaignIdDelete: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<boolean, HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name GetCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet
     * @summary Get Campaign Extractions
     * @request GET:/dial-maker/campaigns/{campaign_id}/extractions
     * @secure
     */
    getCampaignExtractionsDialMakerCampaignsCampaignIdExtractionsGet: (
      campaignId: string,
      query: {
        /** Page */
        page: number;
        /** Limit */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TMLeadsExtraction[], HTTPValidationError>({
        path: `/dial-maker/campaigns/${campaignId}/extractions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker
     * @name DownloadXlsxDialMakerDownloadSignatureGet
     * @summary Download Xlsx
     * @request GET:/dial-maker/download/{signature}
     */
    downloadXlsxDialMakerDownloadSignatureGet: (
      signature: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/dial-maker/download/${signature}`,
        method: "GET",
        ...params,
      }),
  };
  dialmaker = {
    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetMarketingCountDialmakerCampaignMarketingCountGet
     * @summary Get Marketing Count
     * @request GET:/dialmaker/campaign/marketing-count
     * @secure
     */
    getMarketingCountDialmakerCampaignMarketingCountGet: (
      params: RequestParams = {},
    ) =>
      this.request<MarketingMailsSent[], any>({
        path: `/dialmaker/campaign/marketing-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CreateCampaignDialmakerCampaignPost
     * @summary Create Campaign
     * @request POST:/dialmaker/campaign
     * @secure
     */
    createCampaignDialmakerCampaignPost: (
      data: CreateCampaignData,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UpdateCampaignDialmakerCampaignCampaignIdPut
     * @summary Update Campaign
     * @request PUT:/dialmaker/campaign/{campaign_id}
     * @secure
     */
    updateCampaignDialmakerCampaignCampaignIdPut: (
      campaignId: string,
      data: UpdateCampaignData,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/${campaignId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignDialmakerCampaignCampaignIdGet
     * @summary Get Campaign
     * @request GET:/dialmaker/campaign/{campaign_id}
     * @secure
     */
    getCampaignDialmakerCampaignCampaignIdGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/${campaignId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UpdateCampaignAutoDialDialmakerCampaignCampaignIdAutoDialPut
     * @summary Update Campaign Auto Dial
     * @request PUT:/dialmaker/campaign/{campaign_id}/auto-dial
     * @secure
     */
    updateCampaignAutoDialDialmakerCampaignCampaignIdAutoDialPut: (
      campaignId: string,
      query: {
        /** Auto Dial */
        auto_dial: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/${campaignId}/auto-dial`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignSourceDialmakerCampaignCampaignIdDataSourceGet
     * @summary Get Campaign Source
     * @request GET:/dialmaker/campaign/{campaign_id}/data/source
     * @secure
     */
    getCampaignSourceDialmakerCampaignCampaignIdDataSourceGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        | SheetCampaignSourceOutput
        | BigQueryCampaignSource
        | ProcessCampaignSource,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/${campaignId}/data/source`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet
     * @summary Get Campaign Extractions
     * @request GET:/dialmaker/campaign/{campaign_id}/extractions
     * @secure
     */
    getCampaignExtractionsDialmakerCampaignCampaignIdExtractionsGet: (
      campaignId: string,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageCampaignExtraction, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/extractions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet
     * @summary Get Campaign Sheets
     * @request GET:/dialmaker/campaign/{campaign_id}/data/sheets
     * @secure
     */
    getCampaignSheetsDialmakerCampaignCampaignIdDataSheetsGet: (
      campaignId: string,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageSheet, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/data/sheets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DeactivateCampaignDialmakerCampaignDeactivatePost
     * @summary Deactivate Campaign
     * @request POST:/dialmaker/campaign/deactivate
     * @secure
     */
    deactivateCampaignDialmakerCampaignDeactivatePost: (
      data: BodyDeactivateCampaignDialmakerCampaignDeactivatePost,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/deactivate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ActivateCampaignDialmakerCampaignActivatePost
     * @summary Activate Campaign
     * @request POST:/dialmaker/campaign/activate
     * @secure
     */
    activateCampaignDialmakerCampaignActivatePost: (
      data: BodyActivateCampaignDialmakerCampaignActivatePost,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ExtractCampaignsDialmakerCampaignExtractPost
     * @summary Extract Campaigns
     * @request POST:/dialmaker/campaign/extract
     * @secure
     */
    extractCampaignsDialmakerCampaignExtractPost: (
      data: BodyExtractCampaignsDialmakerCampaignExtractPost,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/extract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DeleteExtractionDialmakerCampaignExtractionDelete
     * @summary Delete Extraction
     * @request DELETE:/dialmaker/campaign/extraction
     * @secure
     */
    deleteExtractionDialmakerCampaignExtractionDelete: (
      data: BodyDeleteExtractionDialmakerCampaignExtractionDelete,
      params: RequestParams = {},
    ) =>
      this.request<NonEmptyString, HTTPValidationError>({
        path: `/dialmaker/campaign/extraction`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name FindCampaignsDialmakerCampaignFindPost
     * @summary Find Campaigns
     * @request POST:/dialmaker/campaign/find
     * @secure
     */
    findCampaignsDialmakerCampaignFindPost: (
      data: BodyFindCampaignsDialmakerCampaignFindPost,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageCampaign, HTTPValidationError>({
        path: `/dialmaker/campaign/find`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetLeadsDialmakerCampaignLeadsCampaignIdGet
     * @summary Get Leads
     * @request GET:/dialmaker/campaign/leads/{campaign_id}
     * @secure
     */
    getLeadsDialmakerCampaignLeadsCampaignIdGet: (
      campaignId: string,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageDMLead, HTTPValidationError>({
        path: `/dialmaker/campaign/leads/${campaignId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ImportLeadsDialmakerCampaignImportPost
     * @summary Import Leads
     * @request POST:/dialmaker/campaign/import
     * @secure
     */
    importLeadsDialmakerCampaignImportPost: (
      data: BodyImportLeadsDialmakerCampaignImportPost,
      query?: {
        /**
         * Synchronous
         * Import leads synchronously
         * @default false
         */
        synchronous?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign | string,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/import`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetJobStatusOrResultDialmakerCampaignJobStatusJobIdGet
     * @summary Get Job Status Or Result
     * @request GET:/dialmaker/campaign/job-status/{job_id}
     * @secure
     */
    getJobStatusOrResultDialmakerCampaignJobStatusJobIdGet: (
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<InterimLeadJob | InterimLead[], HTTPValidationError>({
        path: `/dialmaker/campaign/job-status/${jobId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UploadAttachmentDialmakerCampaignImageUploadPost
     * @summary Upload Attachment
     * @request POST:/dialmaker/campaign/image/upload
     * @secure
     */
    uploadAttachmentDialmakerCampaignImageUploadPost: (
      data: BodyUploadAttachmentDialmakerCampaignImageUploadPost,
      params: RequestParams = {},
    ) =>
      this.request<NonEmptyString, HTTPValidationError>({
        path: `/dialmaker/campaign/image/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ExportAndExtractLeadsUrlDialmakerCampaignExportPost
     * @summary Export And Extract Leads Url
     * @request POST:/dialmaker/campaign/export
     * @secure
     */
    exportAndExtractLeadsUrlDialmakerCampaignExportPost: (
      data: BodyExportAndExtractLeadsUrlDialmakerCampaignExportPost,
      params: RequestParams = {},
    ) =>
      this.request<RoutersDialMaker2PayloadsSignedUrl, HTTPValidationError>({
        path: `/dialmaker/campaign/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost
     * @summary Export And Extract Leads Url Download
     * @request POST:/dialmaker/campaign/extraction/export
     * @secure
     */
    exportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost: (
      data: BodyExportAndExtractLeadsUrlDownloadDialmakerCampaignExtractionExportPost,
      params: RequestParams = {},
    ) =>
      this.request<RoutersDialMaker2PayloadsSignedUrl, HTTPValidationError>({
        path: `/dialmaker/campaign/extraction/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost
     * @summary Get Ongoing Extractions
     * @request POST:/dialmaker/campaign/{campaign_id}/ongoing_extractions
     * @secure
     */
    getOngoingExtractionsDialmakerCampaignCampaignIdOngoingExtractionsPost: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignOngoingExtraction[], HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/ongoing_extractions`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOutcomesReportDialmakerCampaignSearchLeadsPost
     * @summary Get Outcomes Report
     * @request POST:/dialmaker/campaign/search-leads
     * @secure
     */
    getOutcomesReportDialmakerCampaignSearchLeadsPost: (
      data: SearchLeadsPayload,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageDMLead | null, HTTPValidationError>({
        path: `/dialmaker/campaign/search-leads`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to get statistics: - Leads with 0 outcomes - Available leads to call - Already extracted count - Leads left to extract (cold campaigns only)
     *
     * @tags Dial Maker 2
     * @name GetExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet
     * @summary Get Extractions Stats
     * @request GET:/dialmaker/campaign/{campaign_id}/extractions_stats
     * @secure
     */
    getExtractionsStatsDialmakerCampaignCampaignIdExtractionsStatsGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignExtractionsStats, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/extractions_stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignsByIdsDialmakerCampaignGetCampaignsByIdsPost
     * @summary Get Campaigns By Ids
     * @request POST:/dialmaker/campaign/get_campaigns_by_ids
     * @secure
     */
    getCampaignsByIdsDialmakerCampaignGetCampaignsByIdsPost: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign[],
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/get_campaigns_by_ids`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SeedCampaignsDialmakerCampaignProcessSeedPost
     * @summary Seed Campaigns
     * @request POST:/dialmaker/campaign/process/seed
     * @secure
     */
    seedCampaignsDialmakerCampaignProcessSeedPost: (
      params: RequestParams = {},
    ) =>
      this.request<Record<string, UpsertCampaignStatus>, any>({
        path: `/dialmaker/campaign/process/seed`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Run one product's process-campaign producer now, instead of waiting for its cron. Renamed from `fetch_and_handle_insurances`: it is no longer insurance-only. Nothing calls the generated client method for this route, so the rename costs a line in the next schema regeneration and no caller. The credit-card branch is the only way to run that producer outside production, since its cron is `'dev': 'disabled'`. It respects the per-lane emit flags (`Config.CC_HANDLER_EMIT_LEADS` for the two offer-stage lanes, `Config.CC_DISBURSAL_EMIT_LEADS` for the disbursement chase), so a lane whose flag is off is a dark run that logs what it would escalate and creates nothing.
     *
     * @tags Dial Maker 2
     * @name FetchAndHandleProcessCampaignDialmakerCampaignProcessFetchAndHandlePost
     * @summary Fetch And Handle Process Campaign
     * @request POST:/dialmaker/campaign/process/fetch_and_handle
     * @secure
     */
    fetchAndHandleProcessCampaignDialmakerCampaignProcessFetchAndHandlePost: (
      query: {
        /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
        product: ExtendedProduct;
        country: Country;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/dialmaker/campaign/process/fetch_and_handle`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetMailStatisticsDialmakerCampaignMailStatisticsPost
     * @summary Get Mail Statistics
     * @request POST:/dialmaker/campaign/mail/statistics
     * @secure
     */
    getMailStatisticsDialmakerCampaignMailStatisticsPost: (
      data: BodyGetMailStatisticsDialmakerCampaignMailStatisticsPost,
      params: RequestParams = {},
    ) =>
      this.request<CampaignMailStats[], HTTPValidationError>({
        path: `/dialmaker/campaign/mail/statistics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetSmsStatisticsDialmakerCampaignSmsStatisticsPost
     * @summary Get Sms Statistics
     * @request POST:/dialmaker/campaign/sms/statistics
     * @secure
     */
    getSmsStatisticsDialmakerCampaignSmsStatisticsPost: (
      data: BodyGetSmsStatisticsDialmakerCampaignSmsStatisticsPost,
      params: RequestParams = {},
    ) =>
      this.request<CampaignSmsStats[], HTTPValidationError>({
        path: `/dialmaker/campaign/sms/statistics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DryRunMailTemplateDialmakerCampaignCampaignIdMailTemplateSlugDryRunPost
     * @summary Dry Run Mail Template
     * @request POST:/dialmaker/campaign/{campaign_id}/mail/template/{slug}/dry-run
     * @secure
     */
    dryRunMailTemplateDialmakerCampaignCampaignIdMailTemplateSlugDryRunPost: (
      campaignId: string,
      slug: string,
      params: RequestParams = {},
    ) =>
      this.request<TemplateDryRunResult, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/mail/template/${slug}/dry-run`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SendTestMailDialmakerCampaignMailSendTestPost
     * @summary Send Test Mail
     * @request POST:/dialmaker/campaign/mail/send_test
     * @secure
     */
    sendTestMailDialmakerCampaignMailSendTestPost: (
      data: TestTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<SentMarketingEmailResponse[], HTTPValidationError>({
        path: `/dialmaker/campaign/mail/send_test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetMailLeadsOverviewDialmakerCampaignCampaignIdMailLeadsGet
     * @summary Get Mail Leads Overview
     * @request GET:/dialmaker/campaign/{campaign_id}/mail/leads
     * @secure
     */
    getMailLeadsOverviewDialmakerCampaignCampaignIdMailLeadsGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignMailOverview, HTTPValidationError>({
        path: `/dialmaker/campaign/${campaignId}/mail/leads`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CreateCampaignV2DialmakerCampaignV2Post
     * @summary Create Campaign V2
     * @request POST:/dialmaker/campaign/v2
     * @secure
     */
    createCampaignV2DialmakerCampaignV2Post: (
      data: CreateCampaignData,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/v2`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UpdateCampaignV2DialmakerCampaignV2CampaignIdPut
     * @summary Update Campaign V2
     * @request PUT:/dialmaker/campaign/v2/{campaign_id}
     * @secure
     */
    updateCampaignV2DialmakerCampaignV2CampaignIdPut: (
      campaignId: string,
      data: UpdateCampaignData,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/v2/${campaignId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DeactivateCampaignV2DialmakerCampaignV2DeactivatePost
     * @summary Deactivate Campaign V2
     * @request POST:/dialmaker/campaign/v2/deactivate
     * @secure
     */
    deactivateCampaignV2DialmakerCampaignV2DeactivatePost: (
      data: BodyDeactivateCampaignV2DialmakerCampaignV2DeactivatePost,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/v2/deactivate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ActivateCampaignV2DialmakerCampaignV2ActivatePost
     * @summary Activate Campaign V2
     * @request POST:/dialmaker/campaign/v2/activate
     * @secure
     */
    activateCampaignV2DialmakerCampaignV2ActivatePost: (
      data: BodyActivateCampaignV2DialmakerCampaignV2ActivatePost,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/v2/activate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ExtractCampaignsV2DialmakerCampaignV2ExtractPost
     * @summary Extract Campaigns V2
     * @request POST:/dialmaker/campaign/v2/extract
     * @secure
     */
    extractCampaignsV2DialmakerCampaignV2ExtractPost: (
      data: BodyExtractCampaignsV2DialmakerCampaignV2ExtractPost,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/v2/extract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DeleteExtractionV2DialmakerCampaignV2ExtractionDelete
     * @summary Delete Extraction V2
     * @request DELETE:/dialmaker/campaign/v2/extraction
     * @secure
     */
    deleteExtractionV2DialmakerCampaignV2ExtractionDelete: (
      data: BodyDeleteExtractionV2DialmakerCampaignV2ExtractionDelete,
      params: RequestParams = {},
    ) =>
      this.request<NonEmptyString, HTTPValidationError>({
        path: `/dialmaker/campaign/v2/extraction`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCampaignV2DialmakerCampaignV2CampaignIdReaggregateGet
     * @summary Get Campaign V2
     * @request GET:/dialmaker/campaign/v2/{campaign_id}/reaggregate
     * @secure
     */
    getCampaignV2DialmakerCampaignV2CampaignIdReaggregateGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign,
        HTTPValidationError
      >({
        path: `/dialmaker/campaign/v2/${campaignId}/reaggregate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetUserCampaignsDialmakerCampaignsGet
     * @summary Get User Campaigns
     * @request GET:/dialmaker/campaigns
     * @deprecated
     * @secure
     */
    getUserCampaignsDialmakerCampaignsGet: (params: RequestParams = {}) =>
      this.request<UserCampaignsExt | null, any>({
        path: `/dialmaker/campaigns`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name AvailableCampaignsDialmakerCampaignsAvailablePost
     * @summary Available Campaigns
     * @request POST:/dialmaker/campaigns/available
     * @secure
     */
    availableCampaignsDialmakerCampaignsAvailablePost: (
      params: RequestParams = {},
    ) =>
      this.request<Available, any>({
        path: `/dialmaker/campaigns/available`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name JoinCampaignDialmakerCampaignsJoinPost
     * @summary Join Campaign
     * @request POST:/dialmaker/campaigns/join
     * @secure
     */
    joinCampaignDialmakerCampaignsJoinPost: (
      data: BodyJoinCampaignDialmakerCampaignsJoinPost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name LeaveCampaignDialmakerCampaignsLeavePost
     * @summary Leave Campaign
     * @request POST:/dialmaker/campaigns/leave
     * @secure
     */
    leaveCampaignDialmakerCampaignsLeavePost: (
      data: BodyLeaveCampaignDialmakerCampaignsLeavePost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/leave`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name PlayCampaignDialmakerCampaignsPlayPost
     * @summary Play Campaign
     * @request POST:/dialmaker/campaigns/play
     * @secure
     */
    playCampaignDialmakerCampaignsPlayPost: (
      data: BodyPlayCampaignDialmakerCampaignsPlayPost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/play`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name PauseCampaignDialmakerCampaignsPausePost
     * @summary Pause Campaign
     * @request POST:/dialmaker/campaigns/pause
     * @secure
     */
    pauseCampaignDialmakerCampaignsPausePost: (
      data: BodyPauseCampaignDialmakerCampaignsPausePost,
      params: RequestParams = {},
    ) =>
      this.request<Available, HTTPValidationError>({
        path: `/dialmaker/campaigns/pause`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetCardDialmakerCardNextPost
     * @summary Get Card
     * @request POST:/dialmaker/card/next
     * @secure
     */
    getCardDialmakerCardNextPost: (params: RequestParams = {}) =>
      this.request<DMLeadExt | null, any>({
        path: `/dialmaker/card/next`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name ViewDialmakerCardViewPost
     * @summary View
     * @request POST:/dialmaker/card/view
     * @secure
     */
    viewDialmakerCardViewPost: (
      data: BodyViewDialmakerCardViewPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt, HTTPValidationError>({
        path: `/dialmaker/card/view`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name UpdateDialmakerCardUpdatePost
     * @summary Update
     * @request POST:/dialmaker/card/update
     * @secure
     */
    updateDialmakerCardUpdatePost: (
      data: BodyUpdateDialmakerCardUpdatePost,
      params: RequestParams = {},
    ) =>
      this.request<DMLead, HTTPValidationError>({
        path: `/dialmaker/card/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name HangupDialmakerCardHangupPost
     * @summary Hangup
     * @request POST:/dialmaker/card/hangup
     * @secure
     */
    hangupDialmakerCardHangupPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/dialmaker/card/hangup`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallSuccessDialmakerCardOutcomeSuccessPost
     * @summary Call Success
     * @request POST:/dialmaker/card/outcome/success
     * @secure
     */
    callSuccessDialmakerCardOutcomeSuccessPost: (
      data: BodyCallSuccessDialmakerCardOutcomeSuccessPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt | null, HTTPValidationError>({
        path: `/dialmaker/card/outcome/success`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallBackDialmakerCardOutcomeCallBackPost
     * @summary Call Back
     * @request POST:/dialmaker/card/outcome/call_back
     * @secure
     */
    callBackDialmakerCardOutcomeCallBackPost: (
      data: BodyCallBackDialmakerCardOutcomeCallBackPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt | null, HTTPValidationError>({
        path: `/dialmaker/card/outcome/call_back`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallBackDialmakerCardOutcomeLaterPost
     * @summary Call Back
     * @request POST:/dialmaker/card/outcome/later
     * @secure
     */
    callBackDialmakerCardOutcomeLaterPost: (
      data: BodyCallBackDialmakerCardOutcomeLaterPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt | null, HTTPValidationError>({
        path: `/dialmaker/card/outcome/later`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallNoContactDialmakerCardOutcomeNoContactPost
     * @summary Call No Contact
     * @request POST:/dialmaker/card/outcome/no_contact
     * @secure
     */
    callNoContactDialmakerCardOutcomeNoContactPost: (
      data: BodyCallNoContactDialmakerCardOutcomeNoContactPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt | null, HTTPValidationError>({
        path: `/dialmaker/card/outcome/no_contact`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallDiscardsDialmakerCardOutcomeDiscardPost
     * @summary Call Discards
     * @request POST:/dialmaker/card/outcome/discard
     * @secure
     */
    callDiscardsDialmakerCardOutcomeDiscardPost: (
      data: BodyCallDiscardsDialmakerCardOutcomeDiscardPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt | null, HTTPValidationError>({
        path: `/dialmaker/card/outcome/discard`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CallFailureDialmakerCardOutcomeFailurePost
     * @summary Call Failure
     * @request POST:/dialmaker/card/outcome/failure
     * @secure
     */
    callFailureDialmakerCardOutcomeFailurePost: (
      data: BodyCallFailureDialmakerCardOutcomeFailurePost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt | null, HTTPValidationError>({
        path: `/dialmaker/card/outcome/failure`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOutcomesDialmakerCardOutcomesPost
     * @summary Get Outcomes
     * @request POST:/dialmaker/card/outcomes
     * @secure
     */
    getOutcomesDialmakerCardOutcomesPost: (
      data: BodyGetOutcomesDialmakerCardOutcomesPost,
      params: RequestParams = {},
    ) =>
      this.request<Outcomes, HTTPValidationError>({
        path: `/dialmaker/card/outcomes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SearchDialmakerCardSearchPost
     * @summary Search
     * @request POST:/dialmaker/card/search
     * @secure
     */
    searchDialmakerCardSearchPost: (
      data: BodySearchDialmakerCardSearchPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt[], HTTPValidationError>({
        path: `/dialmaker/card/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name LockDialmakerCardLockPost
     * @summary Lock
     * @request POST:/dialmaker/card/lock
     * @secure
     */
    lockDialmakerCardLockPost: (
      data: BodyLockDialmakerCardLockPost,
      params: RequestParams = {},
    ) =>
      this.request<DMLead, HTTPValidationError>({
        path: `/dialmaker/card/lock`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description "Lock to me" from the case view. No body back: this is open to every department, and the case-view stream carries the new row. Both refusals are 409, since either way the row the viewer pressed is out of date and the stream will bring the current one.
     *
     * @tags Dial Maker 2
     * @name LockFromCaseViewDialmakerCardLockFromCaseViewPost
     * @summary Lock From Case View
     * @request POST:/dialmaker/card/lock-from-case-view
     * @secure
     */
    lockFromCaseViewDialmakerCardLockFromCaseViewPost: (
      data: BodyLockFromCaseViewDialmakerCardLockFromCaseViewPost,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/dialmaker/card/lock-from-case-view`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name PersonalCallbacksDialmakerCardPersonalCallbacksPost
     * @summary Personal Callbacks
     * @request POST:/dialmaker/card/personal_callbacks
     * @secure
     */
    personalCallbacksDialmakerCardPersonalCallbacksPost: (
      params: RequestParams = {},
    ) =>
      this.request<DMLeadExt[], any>({
        path: `/dialmaker/card/personal_callbacks`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetSlotsDialmakerCardSlotsGet
     * @summary Get Slots
     * @request GET:/dialmaker/card/slots
     * @secure
     */
    getSlotsDialmakerCardSlotsGet: (
      query: {
        /**
         * Date
         * @format date-time
         */
        date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookableSlot[], HTTPValidationError>({
        path: `/dialmaker/card/slots`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetPreviousAppsDialmakerCardPreviousAppsPost
     * @summary Get Previous Apps
     * @request POST:/dialmaker/card/previous_apps
     * @secure
     */
    getPreviousAppsDialmakerCardPreviousAppsPost: (
      query: {
        /**
         * Customer Id
         * @format uuid
         */
        customer_id: string;
        country: Country;
        /** Pni */
        pni?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<PreviousApplicationsList, HTTPValidationError>({
        path: `/dialmaker/card/previous_apps`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name CustomerApplicationsDialmakerCardCustomerApplicationsPost
     * @summary Customer Applications
     * @request POST:/dialmaker/card/customer_applications
     * @secure
     */
    customerApplicationsDialmakerCardCustomerApplicationsPost: (
      data: BodyCustomerApplicationsDialmakerCardCustomerApplicationsPost,
      params: RequestParams = {},
    ) =>
      this.request<TodoCustomerApplicationList, HTTPValidationError>({
        path: `/dialmaker/card/customer_applications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all insurances for a customer, sorted by creation date.
     *
     * @tags Dial Maker 2
     * @name GetCustomerInsurancesDialmakerCardCustomerInsurancesPost
     * @summary Get Customer Insurances
     * @request POST:/dialmaker/card/customer_insurances
     * @secure
     */
    getCustomerInsurancesDialmakerCardCustomerInsurancesPost: (
      query: {
        /**
         * Customer Id
         * @format uuid
         */
        customer_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Insurance[], HTTPValidationError>({
        path: `/dialmaker/card/customer_insurances`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name MineDialmakerCardOutcomesMineTodayPost
     * @summary Mine
     * @request POST:/dialmaker/card/outcomes/mine_today
     * @secure
     */
    mineDialmakerCardOutcomesMineTodayPost: (
      query: {
        /**
         * Start Date
         * @format date-time
         */
        start_date: string;
        /**
         * End Date
         * @format date-time
         */
        end_date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OutcomeCount, HTTPValidationError>({
        path: `/dialmaker/card/outcomes/mine_today`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload file and return a preview of sheet, together with the file id needed to import leads. Uploaded file whether it's csv or xlsx should have headers in the first row to be able to map the columns to the lead data model.
     *
     * @tags Dial Maker 2
     * @name UploadDialmakerSheetCampaignIdUploadWithPreviewPost
     * @summary Upload
     * @request POST:/dialmaker/sheet/{campaign_id}/upload_with_preview
     * @secure
     */
    uploadDialmakerSheetCampaignIdUploadWithPreviewPost: (
      campaignId: string,
      data: BodyUploadDialmakerSheetCampaignIdUploadWithPreviewPost,
      params: RequestParams = {},
    ) =>
      this.request<SheetPreview, HTTPValidationError>({
        path: `/dialmaker/sheet/${campaignId}/upload_with_preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to import leads from a file to a global leads collection with campaign_id and file_id metadata
     *
     * @tags Dial Maker 2
     * @name ImportFromFileDialmakerSheetCampaignIdImportFromFileIdPost
     * @summary Import From File
     * @request POST:/dialmaker/sheet/{campaign_id}/import_from/{file_id}
     * @secure
     */
    importFromFileDialmakerSheetCampaignIdImportFromFileIdPost: (
      campaignId: string,
      fileId: string,
      data: Record<string, string>,
      query?: {
        /**
         * Synchronous
         * Import leads synchronously
         * @default false
         */
        synchronous?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign | string,
        HTTPValidationError
      >({
        path: `/dialmaker/sheet/${campaignId}/import_from/${fileId}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to delete a file from the database if it was not imported yet
     *
     * @tags Dial Maker 2
     * @name DeleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete
     * @summary Delete Campaign Sheet
     * @request DELETE:/dialmaker/sheet/{campaign_id}/delete_file/{file_id}
     * @secure
     */
    deleteCampaignSheetDialmakerSheetCampaignIdDeleteFileFileIdDelete: (
      campaignId: string,
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign | null,
        HTTPValidationError
      >({
        path: `/dialmaker/sheet/${campaignId}/delete_file/${fileId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to delete import of a given sheet_id with all interim leads
     *
     * @tags Dial Maker 2
     * @name DeleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete
     * @summary Delete Interim Leads
     * @request DELETE:/dialmaker/sheet/{campaign_id}/import/{sheet_id}
     * @secure
     */
    deleteInterimLeadsDialmakerSheetCampaignIdImportSheetIdDelete: (
      campaignId: string,
      sheetId: string,
      query?: {
        /**
         * Force
         * Force delete import even if status is IN_PROGRESS
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ModelsDialMaker2CampaignAggregateCampaign | null,
        HTTPValidationError
      >({
        path: `/dialmaker/sheet/${campaignId}/import/${sheetId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetOutcomesDialmakerMiscOutcomesGet
     * @summary Get Outcomes
     * @request GET:/dialmaker/misc/outcomes
     * @secure
     */
    getOutcomesDialmakerMiscOutcomesGet: (
      query?: {
        /**
         * Todomaker
         * @default false
         */
        todomaker?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Outcomes, HTTPValidationError>({
        path: `/dialmaker/misc/outcomes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SaveOutcomesDialmakerMiscOutcomesPost
     * @summary Save Outcomes
     * @request POST:/dialmaker/misc/outcomes
     * @secure
     */
    saveOutcomesDialmakerMiscOutcomesPost: (
      data: BodySaveOutcomesDialmakerMiscOutcomesPost,
      params: RequestParams = {},
    ) =>
      this.request<Outcomes, HTTPValidationError>({
        path: `/dialmaker/misc/outcomes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name AdminDialmakerAdminOutcomesPost
     * @summary Admin
     * @request POST:/dialmaker/admin/outcomes
     * @secure
     */
    adminDialmakerAdminOutcomesPost: (
      query: {
        /**
         * Start Date
         * @format date-time
         */
        start_date: string;
        /**
         * End Date
         * @format date-time
         */
        end_date: string;
      },
      data: BodyAdminDialmakerAdminOutcomesPost,
      params: RequestParams = {},
    ) =>
      this.request<OutcomeCount, HTTPValidationError>({
        path: `/dialmaker/admin/outcomes`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name BlockFieldsDialmakerAdminBlockPost
     * @summary Block Fields
     * @request POST:/dialmaker/admin/block
     * @secure
     */
    blockFieldsDialmakerAdminBlockPost: (
      data: BlockCustomerFieldManuallyPayload,
      params: RequestParams = {},
    ) =>
      this.request<BlockCustomerFieldManuallyResponse, HTTPValidationError>({
        path: `/dialmaker/admin/block`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name StatsDialmakerAdminOutcomesUsersPost
     * @summary Stats
     * @request POST:/dialmaker/admin/outcomes/users
     * @secure
     */
    statsDialmakerAdminOutcomesUsersPost: (
      data: BodyStatsDialmakerAdminOutcomesUsersPost,
      params: RequestParams = {},
    ) =>
      this.request<OutcomeCount, HTTPValidationError>({
        path: `/dialmaker/admin/outcomes/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetMailTemplatesDialmakerMailTemplatesAvailableGet
     * @summary Get Mail Templates
     * @request GET:/dialmaker/mail/templates/available
     * @secure
     */
    getMailTemplatesDialmakerMailTemplatesAvailableGet: (
      params: RequestParams = {},
    ) =>
      this.request<MandrillTemplate[], any>({
        path: `/dialmaker/mail/templates/available`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetVariablesTemplateVariablesDialmakerMailTemplateVariablesPost
     * @summary Get Variables Template Variables
     * @request POST:/dialmaker/mail/template/variables
     * @secure
     */
    getVariablesTemplateVariablesDialmakerMailTemplateVariablesPost: (
      data: BodyGetVariablesTemplateVariablesDialmakerMailTemplateVariablesPost,
      params: RequestParams = {},
    ) =>
      this.request<TemplateVariables, HTTPValidationError>({
        path: `/dialmaker/mail/template/variables`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetAvailableTemplateVariablesDialmakerMailTemplateAvailableVariablesGet
     * @summary Get Available Template Variables
     * @request GET:/dialmaker/mail/template/available/variables
     * @secure
     */
    getAvailableTemplateVariablesDialmakerMailTemplateAvailableVariablesGet: (
      query: {
        country: Country;
        /** Is Prospect Campaign */
        is_prospect_campaign?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], HTTPValidationError>({
        path: `/dialmaker/mail/template/available/variables`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name TemplateRenderDialmakerMailTemplateRenderPost
     * @summary Template Render
     * @request POST:/dialmaker/mail/template/render
     * @secure
     */
    templateRenderDialmakerMailTemplateRenderPost: (
      data: RenderTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<NonEmptyString, HTTPValidationError>({
        path: `/dialmaker/mail/template/render`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SmsTemplateRenderDialmakerSmsTemplateRenderPost
     * @summary Sms Template Render
     * @request POST:/dialmaker/sms/template/render
     * @secure
     */
    smsTemplateRenderDialmakerSmsTemplateRenderPost: (
      data: SmsTemplateRenderPayload,
      params: RequestParams = {},
    ) =>
      this.request<SmsTemplateRenderResponse, HTTPValidationError>({
        path: `/dialmaker/sms/template/render`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SmsTemplateValidateDialmakerSmsTemplateValidatePost
     * @summary Sms Template Validate
     * @request POST:/dialmaker/sms/template/validate
     * @secure
     */
    smsTemplateValidateDialmakerSmsTemplateValidatePost: (
      data: SmsTemplateValidatePayload,
      params: RequestParams = {},
    ) =>
      this.request<SmsTemplateValidateResponse, HTTPValidationError>({
        path: `/dialmaker/sms/template/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetAvailableSmsVariablesDialmakerSmsTemplateAvailableVariablesGet
     * @summary Get Available Sms Variables
     * @request GET:/dialmaker/sms/template/available/variables
     * @secure
     */
    getAvailableSmsVariablesDialmakerSmsTemplateAvailableVariablesGet: (
      query: {
        country: Country;
        /** Is Prospect Campaign */
        is_prospect_campaign?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], HTTPValidationError>({
        path: `/dialmaker/sms/template/available/variables`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetSmsLinkVarsDialmakerSmsTemplateVarsCampaignIdGet
     * @summary Get Sms Link Vars
     * @request GET:/dialmaker/sms/template-vars/{campaign_id}
     * @secure
     */
    getSmsLinkVarsDialmakerSmsTemplateVarsCampaignIdGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<SmsCampaignTemplateVarsResponse, HTTPValidationError>({
        path: `/dialmaker/sms/template-vars/${campaignId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SendTestSmsDialmakerSmsSendTestPost
     * @summary Send Test Sms
     * @request POST:/dialmaker/sms/send-test
     * @secure
     */
    sendTestSmsDialmakerSmsSendTestPost: (
      data: TestSmsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TestSmsResponse, HTTPValidationError>({
        path: `/dialmaker/sms/send-test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name SendTestSmsFromCampaignDialmakerSmsSendTestCampaignPost
     * @summary Send Test Sms From Campaign
     * @request POST:/dialmaker/sms/send-test-campaign
     * @secure
     */
    sendTestSmsFromCampaignDialmakerSmsSendTestCampaignPost: (
      data: SmsCampaignTestPayload,
      params: RequestParams = {},
    ) =>
      this.request<TestSmsResponse, HTTPValidationError>({
        path: `/dialmaker/sms/send-test-campaign`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetSmsMarketingCountDialmakerSmsMarketingCountGet
     * @summary Get Sms Marketing Count
     * @request GET:/dialmaker/sms/marketing-count
     * @secure
     */
    getSmsMarketingCountDialmakerSmsMarketingCountGet: (
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>[], any>({
        path: `/dialmaker/sms/marketing-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  urlTracker = {
    /**
     * No description
     *
     * @tags URL Tracker
     * @name CreateUrlUrlTrackerUrlPost
     * @summary Create Url
     * @request POST:/url-tracker/url
     * @secure
     */
    createUrlUrlTrackerUrlPost: (
      data: BodyCreateUrlUrlTrackerUrlPost,
      params: RequestParams = {},
    ) =>
      this.request<URL, HTTPValidationError>({
        path: `/url-tracker/url`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name UpdateUrlUrlTrackerUrlKeyPut
     * @summary Update Url
     * @request PUT:/url-tracker/{url_key}
     * @secure
     */
    updateUrlUrlTrackerUrlKeyPut: (
      urlKey: string,
      data: UpdateURL,
      params: RequestParams = {},
    ) =>
      this.request<URL, HTTPValidationError>({
        path: `/url-tracker/${urlKey}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name DeactivateUrlUrlTrackerUrlKeyDelete
     * @summary Deactivate Url
     * @request DELETE:/url-tracker/{url_key}
     * @secure
     */
    deactivateUrlUrlTrackerUrlKeyDelete: (
      urlKey: string,
      params: RequestParams = {},
    ) =>
      this.request<URL, HTTPValidationError>({
        path: `/url-tracker/${urlKey}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name CreateUtmTagsPresetUrlTrackerUtmTagsPresetPost
     * @summary Create Utm Tags Preset
     * @request POST:/url-tracker/utm-tags-preset
     * @secure
     */
    createUtmTagsPresetUrlTrackerUtmTagsPresetPost: (
      data: BodyCreateUtmTagsPresetUrlTrackerUtmTagsPresetPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/url-tracker/utm-tags-preset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name GetUtmPresetsUrlTrackerUtmTagsPresetsGet
     * @summary Get Utm Presets
     * @request GET:/url-tracker/utm-tags-presets
     * @secure
     */
    getUtmPresetsUrlTrackerUtmTagsPresetsGet: (params: RequestParams = {}) =>
      this.request<UtmTagsPreset[], any>({
        path: `/url-tracker/utm-tags-presets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name UpdateUtmTagsPresetUrlTrackerUtmTagsPresetPresetNamePut
     * @summary Update Utm Tags Preset
     * @request PUT:/url-tracker/utm-tags-preset/{preset_name}
     * @secure
     */
    updateUtmTagsPresetUrlTrackerUtmTagsPresetPresetNamePut: (
      presetName: string,
      data: BodyUpdateUtmTagsPresetUrlTrackerUtmTagsPresetPresetNamePut,
      params: RequestParams = {},
    ) =>
      this.request<UtmTagsPreset, HTTPValidationError>({
        path: `/url-tracker/utm-tags-preset/${presetName}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name DeletePresetUtmTagsUrlTrackerUtmTagsPresetPresetNameDelete
     * @summary Delete Preset Utm Tags
     * @request DELETE:/url-tracker/utm-tags-preset/{preset_name}
     * @secure
     */
    deletePresetUtmTagsUrlTrackerUtmTagsPresetPresetNameDelete: (
      presetName: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/url-tracker/utm-tags-preset/${presetName}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name GetAllUrlsUrlTrackerUrlsGet
     * @summary Get All Urls
     * @request GET:/url-tracker/urls
     * @secure
     */
    getAllUrlsUrlTrackerUrlsGet: (params: RequestParams = {}) =>
      this.request<URL[], any>({
        path: `/url-tracker/urls`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name GetListOfUrlsUrlTrackerUrlListGet
     * @summary Get List Of Urls
     * @request GET:/url-tracker/url-list
     * @secure
     */
    getListOfUrlsUrlTrackerUrlListGet: (
      query: {
        /** Active */
        active: boolean;
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageURL, HTTPValidationError>({
        path: `/url-tracker/url-list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name GetUrlInfoUrlTrackerUrlKeyInfoGet
     * @summary Get Url Info
     * @request GET:/url-tracker/{url_key}/info
     * @secure
     */
    getUrlInfoUrlTrackerUrlKeyInfoGet: (
      urlKey: string,
      params: RequestParams = {},
    ) =>
      this.request<URL, HTTPValidationError>({
        path: `/url-tracker/${urlKey}/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name SearchUrlsUrlTrackerSearchGet
     * @summary Search Urls
     * @request GET:/url-tracker/search
     * @secure
     */
    searchUrlsUrlTrackerSearchGet: (
      query: {
        /** Keyword */
        keyword: string;
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageURL, HTTPValidationError>({
        path: `/url-tracker/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags URL Tracker
     * @name GetTrackingUrlUrlTrackerUrlKeyTrackingUrlCountryGet
     * @summary Get Tracking Url
     * @request GET:/url-tracker/{url_key}/tracking-url/{country}
     * @secure
     */
    getTrackingUrlUrlTrackerUrlKeyTrackingUrlCountryGet: (
      urlKey: string,
      country: Country,
      params: RequestParams = {},
    ) =>
      this.request<NonEmptyString, HTTPValidationError>({
        path: `/url-tracker/${urlKey}/tracking-url/${country}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  insurance = {
    /**
     * No description
     *
     * @tags Insurance
     * @name CreateInsuranceInsuranceInsurancePost
     * @summary Create Insurance
     * @request POST:/insurance/insurance
     * @secure
     */
    createInsuranceInsuranceInsurancePost: (
      data: CreateInsuranceCustomerV1,
      params: RequestParams = {},
    ) =>
      this.request<Insurance, HTTPValidationError>({
        path: `/insurance/insurance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  leadtaker = {
    /**
     * @description Upload file and return a preview of sheet, together with the file id needed to import leads. Uploaded file whether it's csv or xlsx should have headers in the first row to be able to map the columns to the lead data model.
     *
     * @tags Lead Taker
     * @name UploadLeadtakerUploadCsvPost
     * @summary Upload
     * @request POST:/leadtaker/upload_csv
     * @secure
     */
    uploadLeadtakerUploadCsvPost: (
      data: BodyUploadLeadtakerUploadCsvPost,
      params: RequestParams = {},
    ) =>
      this.request<SheetPreview, HTTPValidationError>({
        path: `/leadtaker/upload_csv`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Get file preview from file id
     *
     * @tags Lead Taker
     * @name FilePreviewLeadtakerFilePreviewPost
     * @summary File Preview
     * @request POST:/leadtaker/file_preview
     * @secure
     */
    filePreviewLeadtakerFilePreviewPost: (
      query: {
        /**
         * File Id
         * @format uuid
         */
        file_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SheetPreview, HTTPValidationError>({
        path: `/leadtaker/file_preview`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to import leads from a file to a global leads collection with file_id metadata, consents country and valid_until are optional if not provided from mapping, if provided they will be used instead of the ones from mapping, globally for all prospects. If file_cost is provided, it will be used to calculate the cost of each prospect.
     *
     * @tags Lead Taker
     * @name ImportFromFileLeadtakerImportFromFileIdPost
     * @summary Import From File
     * @request POST:/leadtaker/import_from/{file_id}
     * @secure
     */
    importFromFileLeadtakerImportFromFileIdPost: (
      fileId: string,
      data: BodyImportFromFileLeadtakerImportFromFileIdPost,
      query?: {
        /** File Cost */
        file_cost?: number | null;
        /** Country */
        country?: Country | null;
        /** Valid Until */
        valid_until?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProspectsUpsertResponse, HTTPValidationError>({
        path: `/leadtaker/import_from/${fileId}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to check the status of the import job
     *
     * @tags Lead Taker
     * @name CheckIfCheckerEnqueuedLeadtakerImportStatusFileIdPost
     * @summary Check If Checker Enqueued
     * @request POST:/leadtaker/import_status/{file_id}
     * @secure
     */
    checkIfCheckerEnqueuedLeadtakerImportStatusFileIdPost: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/leadtaker/import_status/${fileId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all uploaded files, if imported is True, return only files which were imported if False, return only files which were not imported if None(default), return all files
     *
     * @tags Lead Taker
     * @name GetFilesLeadtakerFilesGet
     * @summary Get Files
     * @request GET:/leadtaker/files
     * @secure
     */
    getFilesLeadtakerFilesGet: (
      query?: {
        /** Imported */
        imported?: boolean | null;
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageFileDetails, HTTPValidationError>({
        path: `/leadtaker/files`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint is used to delete a file from the database if it was not imported yet
     *
     * @tags Lead Taker
     * @name DeleteFileLeadtakerDeleteFileFileIdDelete
     * @summary Delete File
     * @request DELETE:/leadtaker/delete_file/{file_id}
     * @secure
     */
    deleteFileLeadtakerDeleteFileFileIdDelete: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/leadtaker/delete_file/${fileId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all prospects from KDLT
     *
     * @tags Lead Taker
     * @name ProspectsGetLeadtakerProspectsGet
     * @summary Prospects Get
     * @request GET:/leadtaker/prospects
     * @secure
     */
    prospectsGetLeadtakerProspectsGet: (
      query?: {
        /**
         * Search String
         * @default ""
         */
        search_string?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Prospect[], HTTPValidationError>({
        path: `/leadtaker/prospects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upsert single prospect to KDLT
     *
     * @tags Lead Taker
     * @name ProspectsUpsertionLeadtakerProspectsPost
     * @summary Prospects Upsertion
     * @request POST:/leadtaker/prospects
     * @secure
     */
    prospectsUpsertionLeadtakerProspectsPost: (
      data: ProspectBase,
      params: RequestParams = {},
    ) =>
      this.request<ProspectsUpsertResponse, HTTPValidationError>({
        path: `/leadtaker/prospects`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Upsert single prospect to KDLT from online subscription source
     *
     * @tags Lead Taker
     * @name ProspectsOnlineSubscriptionLeadtakerProspectsOnlineSubscriptionPost
     * @summary Prospects Online Subscription
     * @request POST:/leadtaker/prospects/online_subscription
     */
    prospectsOnlineSubscriptionLeadtakerProspectsOnlineSubscriptionPost: (
      data: BodyProspectsOnlineSubscriptionLeadtakerProspectsOnlineSubscriptionPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/leadtaker/prospects/online_subscription`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * @description Upsert prospects to KDLT from external source
     *
     * @tags Lead Taker
     * @name ProspectsExternalSourceLeadtakerProspectsExternalSourcePost
     * @summary Prospects External Source
     * @request POST:/leadtaker/prospects/external_source
     */
    prospectsExternalSourceLeadtakerProspectsExternalSourcePost: (
      data: ExternalSourcePayload,
      params: RequestParams = {},
    ) =>
      this.request<ExternalSourceResponse, HTTPValidationError>({
        path: `/leadtaker/prospects/external_source`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  logSaver = {
    /**
     * No description
     *
     * @tags Log Saver
     * @name MailmakerCampaignLogsLogSaverMailmakerCampaignIdPost
     * @summary Mailmaker Campaign Logs
     * @request POST:/log-saver/mailmaker/{campaign_id}
     * @secure
     */
    mailmakerCampaignLogsLogSaverMailmakerCampaignIdPost: (
      campaignId: string,
      data: LogSaverPayload,
      params: RequestParams = {},
    ) =>
      this.request<LogEntry[], HTTPValidationError>({
        path: `/log-saver/mailmaker/${campaignId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sse = {
    /**
     * @description SSE endpoint to get applications based on query parameters. `handler_id` narrows today, next shift and all active to one handler. Without `sort_by` each list keeps its own order and `descending` is ignored.
     *
     * @tags SSE
     * @name AdminSseEndpointSseAdminListPageTypeGet
     * @summary Admin Sse Endpoint
     * @request GET:/sse/admin/list/{page_type}
     * @secure
     */
    adminSseEndpointSseAdminListPageTypeGet: (
      pageType: PageType,
      query?: {
        /** Handler Id */
        handler_id?: string | null;
        /** Sort By */
        sort_by?: ListSortBy | null;
        /**
         * Descending
         * @default false
         */
        descending?: boolean;
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/admin/list/${pageType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description SSE endpoint to get applications based on query parameters. Without `sort_by` each list keeps its own order and `descending` is ignored.
     *
     * @tags SSE
     * @name SseEndpointSseListPageTypeGet
     * @summary Sse Endpoint
     * @request GET:/sse/list/{page_type}
     * @secure
     */
    sseEndpointSseListPageTypeGet: (
      pageType: PageType,
      query?: {
        /** Sort By */
        sort_by?: ListSortBy | null;
        /**
         * Descending
         * @default false
         */
        descending?: boolean;
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/list/${pageType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Per-handler todomaker work-queue stream. Pushes the full TodoList on connect and on every `todomaker_changed_{user_id}` ping (claim/release/outcome/meeting). Open to every department: the pool is scoped by admin campaign assignment, so a handler with none assigned gets an empty queue plus their own callbacks and meetings. The shared pool is paged (`pool_page`, `pool_size`, `pool_campaign_id`); the client moves between pages by reconnecting with new parameters, and every re-snapshot on this connection serves the same page.
     *
     * @tags SSE
     * @name TodomakerStreamSseTodomakerGet
     * @summary Todomaker Stream
     * @request GET:/sse/todomaker
     * @secure
     */
    todomakerStreamSseTodomakerGet: (
      query?: {
        /**
         * Pool Page
         * The page of the shared pool to send, 1-based.
         * @min 1
         * @default 1
         */
        pool_page?: number;
        /**
         * Pool Size
         * Pool leads per page.
         * @min 1
         * @max 350
         * @default 200
         */
        pool_size?: number;
        /**
         * Pool Campaign Id
         * Page only this campaign's pool. Ignored unless it is one of the caller's active campaigns.
         */
        pool_campaign_id?: string | null;
        /**
         * Pool Show All
         * Every open lead of the campaigns, whoever owns it, read-only. Team leads and developers only.
         * @default false
         */
        pool_show_all?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/todomaker`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SSE
     * @name LogEndpointSseLogGet
     * @summary Log Endpoint
     * @request GET:/sse/log
     * @secure
     */
    logEndpointSseLogGet: (
      query?: {
        /** Manual States */
        manual_states?: ManualApplicationState[] | null;
        /** Sort By */
        sort_by?: ListSortBy | null;
        /**
         * Descending
         * @default false
         */
        descending?: boolean;
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/log`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Day-window SSE stream of the unified Customer Event Log (developer-only). The handler does ONLY the fast, side-effect-free, real-HTTP checks and returns the response immediately; scope resolution + the audited KDLT read + the fan-out run inside the SSE body (`_stream_customer_events`) so a slow dependency streams progress instead of hanging the handler into the 30s route timeout. The strict developer gate runs as a dependency, so a non-developer is rejected 403 BEFORE the body (no scope, no audit write). `customer_id: UUID` rejects a non-UUID id with 422 at the edge. A bounded window is REQUIRED (`since`+`until`, `since`<`until`, span <= 90 days) — a missing/inverted/oversized window 422s before any side effect. `lanes` (CSV) optionally narrows lanes; omitted = all. A customer-not-found / lookup timeout is an in-stream `error` message (the response is a 200 stream). No PII is logged (counts only).
     *
     * @tags SSE
     * @name CustomerEventsStreamSseCustomerEventsCustomerIdGet
     * @summary Customer Events Stream
     * @request GET:/sse/customer-events/{customer_id}
     * @secure
     */
    customerEventsStreamSseCustomerEventsCustomerIdGet: (
      customerId: string,
      query?: {
        /** Since */
        since?: string | null;
        /** Until */
        until?: string | null;
        /** Lanes */
        lanes?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/customer-events/${customerId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Live SMS/email pings for the insurance page's messenger. An insurance has no application, so the case-view stream cannot serve it.
     *
     * @tags SSE
     * @name InsuranceMessagesStreamSseInsuranceInsuranceIdGet
     * @summary Insurance Messages Stream
     * @request GET:/sse/insurance/{insurance_id}
     * @secure
     */
    insuranceMessagesStreamSseInsuranceInsuranceIdGet: (
      insuranceId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/insurance/${insuranceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SSE
     * @name CaseViewSseCustomerIdApplicationIdGet
     * @summary Case View
     * @request GET:/sse/{customer_id}/{application_id}
     * @secure
     */
    caseViewSseCustomerIdApplicationIdGet: (
      customerId: string,
      applicationId: string,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/${customerId}/${applicationId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SSE
     * @name CaseViewFinderSseFindCaseGet
     * @summary Case View Finder
     * @request GET:/sse/find-case
     * @secure
     */
    caseViewFinderSseFindCaseGet: (
      query?: {
        /** Customer Id */
        customer_id?: string | null;
        /**
         * Application Id
         * Identifier for an application. Includes product, country and integer application ID. Integer ID is unique within given product and country. ID part is usually padded with zeroes up to 6 digits.
         */
        application_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/sse/find-case`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SSE
     * @name SearchSseSearchGet
     * @summary Search
     * @request GET:/sse/search
     * @secure
     */
    searchSseSearchGet: (
      query: {
        /** Search Str */
        search_str: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResultItem[], HTTPValidationError>({
        path: `/sse/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Help endpoint to test the models
     *
     * @tags SSE
     * @name HelpSseEventsGet
     * @summary Help
     * @request GET:/sse/events
     * @secure
     */
    helpSseEventsGet: (params: RequestParams = {}) =>
      this.request<SSEEvent, any>({
        path: `/sse/events`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Help endpoint to test the models
     *
     * @tags SSE
     * @name ResponsesSseResponsesGet
     * @summary Responses
     * @request GET:/sse/responses
     * @secure
     */
    responsesSseResponsesGet: (params: RequestParams = {}) =>
      this.request<
        | ApplicationResponse
        | InsuranceResponse
        | MeetingsResponse
        | PaginationResponse
        | MessageResponse
        | OutcomesResponse
        | CommentResponse
        | AMLResponse
        | CallsResponse
        | CustomerResponse
        | ApplicationsHistoryResponse
        | ApplicationSummaryResponse
        | ActiveUsersResponse
        | CoApplicantResponse
        | InsuranceRulesResponse
        | InsuranceListResponse
        | CoApplicantInsuranceRulesResponse
        | CoApplicantInsuranceListResponse
        | ZenscriptionResponse
        | BankIDVerifiedResponse
        | MessageSuggestionsResponse
        | ApplicationMapperResponse
        | MultipleApplicationMapperResponse
        | OPAMLResponse
        | ModelsSseModelsInviteZRayResponse
        | SkaImpactResponse
        | TodomakerLeadResponse
        | DialmakerLeadsResponse
        | FullApplicationsHistoryResponse
        | CustomerLoginsResponse
        | CoApplicantCustomerLoginsResponse
        | CaseDocumentsResponse
        | LeftToLiveEstimateChangedResponse
        | DisbursalDatesResponse,
        any
      >({
        path: `/sse/responses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sidebar = {
    /**
     * No description
     *
     * @tags Sidebar
     * @name SidebarCountsSidebarCountsGet
     * @summary Sidebar Counts
     * @request GET:/sidebar/counts
     * @secure
     */
    sidebarCountsSidebarCountsGet: (params: RequestParams = {}) =>
      this.request<SidebarCount, any>({
        path: `/sidebar/counts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Clear a user's stuck sidebar refresh jobs; the next trigger enqueues a fresh one.
     *
     * @tags Sidebar
     * @name RemoveSidebarRefreshJobsSidebarRefreshJobsUserIdDelete
     * @summary Remove Sidebar Refresh Jobs
     * @request DELETE:/sidebar/refresh-jobs/{user_id}
     * @secure
     */
    removeSidebarRefreshJobsSidebarRefreshJobsUserIdDelete: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, number>, HTTPValidationError>({
        path: `/sidebar/refresh-jobs/${userId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  snippets = {
    /**
     * No description
     *
     * @tags Snippets
     * @name ListRenderedSnippetsSnippetsGet
     * @summary List Rendered Snippets
     * @request GET:/snippets/
     * @secure
     */
    listRenderedSnippetsSnippetsGet: (
      query: {
        country: Country;
        /** Used only for Dial Maker 2.0 for now, but can be used for other non-banking products in the future if needed */
        product: ExtendedProduct;
        context: SnippetContext;
        /** Customer Id */
        customer_id: string;
        /** Application Id */
        application_id?: string | null;
        /** Offer Id */
        offer_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<RenderedSnippet[], HTTPValidationError>({
        path: `/snippets/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name CreateSharedSnippetSnippetsPost
     * @summary Create Shared Snippet
     * @request POST:/snippets/
     * @secure
     */
    createSharedSnippetSnippetsPost: (
      data: SnippetData,
      params: RequestParams = {},
    ) =>
      this.request<Snippet, HTTPValidationError>({
        path: `/snippets/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Offers on an application, for the composer's offer picker (`offer_id` on the render endpoint).
     *
     * @tags Snippets
     * @name ListApplicationOffersSnippetsOffersGet
     * @summary List Application Offers
     * @request GET:/snippets/offers
     * @secure
     */
    listApplicationOffersSnippetsOffersGet: (
      query: {
        /** Application Id */
        application_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<(BlancoOfferApp | Offer)[], HTTPValidationError>({
        path: `/snippets/offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name ListSnippetsSnippetsManageGet
     * @summary List Snippets
     * @request GET:/snippets/manage
     * @secure
     */
    listSnippetsSnippetsManageGet: (
      query?: {
        /** Country */
        country?: Country | null;
        /** Product */
        product?: ExtendedProduct | null;
        /** Context */
        context?: SnippetContext | null;
        /**
         * Include Deleted
         * @default false
         */
        include_deleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Snippet[], HTTPValidationError>({
        path: `/snippets/manage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name UpdateSharedSnippetSnippetsSnippetIdPut
     * @summary Update Shared Snippet
     * @request PUT:/snippets/{snippet_id}
     * @secure
     */
    updateSharedSnippetSnippetsSnippetIdPut: (
      snippetId: string,
      data: SnippetData,
      params: RequestParams = {},
    ) =>
      this.request<Snippet, HTTPValidationError>({
        path: `/snippets/${snippetId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name DeleteSharedSnippetSnippetsSnippetIdDelete
     * @summary Delete Shared Snippet
     * @request DELETE:/snippets/{snippet_id}
     * @secure
     */
    deleteSharedSnippetSnippetsSnippetIdDelete: (
      snippetId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/snippets/${snippetId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name RestoreSnippetSnippetsSnippetIdRestorePost
     * @summary Restore Snippet
     * @request POST:/snippets/{snippet_id}/restore
     * @secure
     */
    restoreSnippetSnippetsSnippetIdRestorePost: (
      snippetId: string,
      params: RequestParams = {},
    ) =>
      this.request<Snippet, HTTPValidationError>({
        path: `/snippets/${snippetId}/restore`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name GetSnippetHistorySnippetsSnippetIdHistoryGet
     * @summary Get Snippet History
     * @request GET:/snippets/{snippet_id}/history
     * @secure
     */
    getSnippetHistorySnippetsSnippetIdHistoryGet: (
      snippetId: string,
      params: RequestParams = {},
    ) =>
      this.request<SnippetEvent[], HTTPValidationError>({
        path: `/snippets/${snippetId}/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name ListSnippetCategoriesSnippetsCategoriesGet
     * @summary List Snippet Categories
     * @request GET:/snippets/categories
     * @secure
     */
    listSnippetCategoriesSnippetsCategoriesGet: (
      query?: {
        /**
         * Include Deleted
         * @default false
         */
        include_deleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SnippetCategory[], HTTPValidationError>({
        path: `/snippets/categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name CreateSnippetCategorySnippetsCategoriesPost
     * @summary Create Snippet Category
     * @request POST:/snippets/categories
     * @secure
     */
    createSnippetCategorySnippetsCategoriesPost: (
      data: SnippetCategoryData,
      params: RequestParams = {},
    ) =>
      this.request<SnippetCategory, HTTPValidationError>({
        path: `/snippets/categories`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name UpdateSnippetCategorySnippetsCategoriesCategoryIdPut
     * @summary Update Snippet Category
     * @request PUT:/snippets/categories/{category_id}
     * @secure
     */
    updateSnippetCategorySnippetsCategoriesCategoryIdPut: (
      categoryId: string,
      data: SnippetCategoryData,
      params: RequestParams = {},
    ) =>
      this.request<SnippetCategory, HTTPValidationError>({
        path: `/snippets/categories/${categoryId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Snippets
     * @name DeleteSnippetCategorySnippetsCategoriesCategoryIdDelete
     * @summary Delete Snippet Category
     * @request DELETE:/snippets/categories/{category_id}
     * @secure
     */
    deleteSnippetCategorySnippetsCategoriesCategoryIdDelete: (
      categoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/snippets/categories/${categoryId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  zenscriber = {
    /**
     * No description
     *
     * @tags Zenscriber
     * @name GetCustomerZenscriptionsZenscriberGet
     * @summary Get Customer Zenscriptions
     * @request GET:/zenscriber/
     * @secure
     */
    getCustomerZenscriptionsZenscriberGet: (
      query: {
        /**
         * Customer Id
         * @format uuid
         */
        customer_id: string;
        /** Newer Than */
        newer_than?: string | null;
        /**
         * Limit
         * @default 2
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Zenscription[], HTTPValidationError>({
        path: `/zenscriber/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zenscriber
     * @name GetCustomerContextEndpointZenscriberCustomerContextPost
     * @summary Get Customer Context Endpoint
     * @request POST:/zenscriber/customer-context
     * @secure
     */
    getCustomerContextEndpointZenscriberCustomerContextPost: (
      data: RoutersZenscriberSupportRouterPayload,
      params: RequestParams = {},
    ) =>
      this.request<CustomerContextSlim, HTTPValidationError>({
        path: `/zenscriber/customer-context`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  compliance = {
    /**
     * No description
     *
     * @tags Compliance
     * @name GetComplianceQueueComplianceQueueGet
     * @summary Get Compliance Queue
     * @request GET:/compliance/queue
     * @secure
     */
    getComplianceQueueComplianceQueueGet: (
      query?: {
        /** Country */
        country?: string | null;
        /** Severity */
        severity?: string | null;
        /**
         * To Review
         * @default false
         */
        to_review?: boolean;
        /**
         * Limit
         * @default 50
         */
        limit?: number;
        /**
         * Skip
         * @default 0
         */
        skip?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ComplianceQueuePage, HTTPValidationError>({
        path: `/compliance/queue`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Compliance
     * @name GetComplianceCallComplianceCallsRecordedCallKeyGet
     * @summary Get Compliance Call
     * @request GET:/compliance/calls/{recorded_call_key}
     * @secure
     */
    getComplianceCallComplianceCallsRecordedCallKeyGet: (
      recordedCallKey: string,
      params: RequestParams = {},
    ) =>
      this.request<ZenscriptionWithCompliance, HTTPValidationError>({
        path: `/compliance/calls/${recordedCallKey}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Compliance
     * @name GetCustomerComplianceCallsComplianceByCustomerCustomerIdGet
     * @summary Get Customer Compliance Calls
     * @request GET:/compliance/by-customer/{customer_id}
     * @secure
     */
    getCustomerComplianceCallsComplianceByCustomerCustomerIdGet: (
      customerId: string,
      params: RequestParams = {},
    ) =>
      this.request<CustomerCompliancePage, HTTPValidationError>({
        path: `/compliance/by-customer/${customerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Compliance
     * @name ReviewComplianceFlagComplianceCallsRecordedCallKeyReviewPost
     * @summary Review Compliance Flag
     * @request POST:/compliance/calls/{recorded_call_key}/review
     * @secure
     */
    reviewComplianceFlagComplianceCallsRecordedCallKeyReviewPost: (
      recordedCallKey: string,
      data: ComplianceReviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<ComplianceReviewDecision, HTTPValidationError>({
        path: `/compliance/calls/${recordedCallKey}/review`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Compliance
     * @name ReportManualFlagComplianceCallsRecordedCallKeyManualFlagPost
     * @summary Report Manual Flag
     * @request POST:/compliance/calls/{recorded_call_key}/manual-flag
     * @secure
     */
    reportManualFlagComplianceCallsRecordedCallKeyManualFlagPost: (
      recordedCallKey: string,
      data: ComplianceManualFlagPayload,
      params: RequestParams = {},
    ) =>
      this.request<ComplianceManualFlag, HTTPValidationError>({
        path: `/compliance/calls/${recordedCallKey}/manual-flag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The call's transcript in English, line by line with the original, translated on first request and stored.
     *
     * @tags Compliance
     * @name TranslateComplianceTranscriptComplianceCallsRecordedCallKeyTranslationPost
     * @summary Translate Compliance Transcript
     * @request POST:/compliance/calls/{recorded_call_key}/translation
     * @secure
     */
    translateComplianceTranscriptComplianceCallsRecordedCallKeyTranslationPost:
      (recordedCallKey: string, params: RequestParams = {}) =>
        this.request<TranscriptTranslation, HTTPValidationError>({
          path: `/compliance/calls/${recordedCallKey}/translation`,
          method: "POST",
          secure: true,
          format: "json",
          ...params,
        }),
  };
  op = {
    /**
     * No description
     *
     * @tags Occupational pension
     * @name ListApplicationsOpApplicationsGet
     * @summary List Applications
     * @request GET:/op/applications
     * @secure
     */
    listApplicationsOpApplicationsGet: (
      query?: {
        /** Status */
        status?: OPStatus | null;
        /** Date From */
        date_from?: string | null;
        /** Date To */
        date_to?: string | null;
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Size
         * @min 1
         * @max 100000
         * @default 50
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PageOPApplicationListItem, HTTPValidationError>({
        path: `/op/applications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Occupational pension
     * @name CreateOpApplicationOpCreatePost
     * @summary Create Op Application
     * @request POST:/op/create
     * @secure
     */
    createOpApplicationOpCreatePost: (
      data: OccupationalPensionCreate,
      params: RequestParams = {},
    ) =>
      this.request<OccupationalPensionResponse, HTTPValidationError>({
        path: `/op/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Occupational pension
     * @name DeactivateApplicationOpDeactivateLabelPost
     * @summary Deactivate Application
     * @request POST:/op/deactivate/{label}
     * @secure
     */
    deactivateApplicationOpDeactivateLabelPost: (
      label: string,
      data: BodyDeactivateApplicationOpDeactivateLabelPost,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/op/deactivate/${label}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Occupational pension
     * @name SendSmsOpSmsPoaLabelPost
     * @summary Send Sms
     * @request POST:/op/sms/poa/{label}
     * @secure
     */
    sendSmsOpSmsPoaLabelPost: (label: string, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/op/sms/poa/${label}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Occupational pension
     * @name RegisterOpRegisterPost
     * @summary Register
     * @request POST:/op/register
     */
    registerOpRegisterPost: (
      data: BodyRegisterOpRegisterPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/op/register`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * @description SFB doesn't have a staging environment for occupational pension registrations, so we create a simulator endpoint to test the registration flow. It simply returns back the form data received. So it's displayed in the browser for verification.
     *
     * @tags Occupational pension, Simulator
     * @name SimulateSfbRegistrationOpSimulatorPost
     * @summary Simulate Sfb Registration
     * @request POST:/op/simulator
     */
    simulateSfbRegistrationOpSimulatorPost: (params: RequestParams = {}) =>
      this.request<BankCommunicationData, any>({
        path: `/op/simulator`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  push = {
    /**
     * No description
     *
     * @tags Push Subscriptions
     * @name SubscribePushSubscribePost
     * @summary Subscribe
     * @request POST:/push/subscribe
     * @secure
     */
    subscribePushSubscribePost: (
      data: SubscribePayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/push/subscribe`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Subscriptions
     * @name UnsubscribePushUnsubscribeDelete
     * @summary Unsubscribe
     * @request DELETE:/push/unsubscribe
     * @secure
     */
    unsubscribePushUnsubscribeDelete: (
      data: UnsubscribePayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/push/unsubscribe`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Subscriptions
     * @name VapidPublicKeyPushVapidPublicKeyGet
     * @summary Vapid Public Key
     * @request GET:/push/vapid-public-key
     * @secure
     */
    vapidPublicKeyPushVapidPublicKeyGet: (params: RequestParams = {}) =>
      this.request<VapidPublicKeyResponse, any>({
        path: `/push/vapid-public-key`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  emailCustomers = {
    /**
     * @description List emails for a customer, optionally filtered by thread, application, or status. By default returns lightweight summaries without body content for performance. Pass include_body=true to receive EmailDetail[] with full (decrypted) body content.
     *
     * @tags Email Customers
     * @name ListEmailsEmailCustomersListPost
     * @summary List Emails
     * @request POST:/email-customers/list
     * @secure
     */
    listEmailsEmailCustomersListPost: (
      data: ListEmailsPayload,
      params: RequestParams = {},
    ) =>
      this.request<EmailSummary[] | EmailDetail[], HTTPValidationError>({
        path: `/email-customers/list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send an outbound email to a customer via Mandrill. Stores the sent email in email_customers_content with encryption. If thread_id is provided, adds to existing thread; otherwise creates a new one.
     *
     * @tags Email Customers
     * @name SendEmailEmailCustomersSendPost
     * @summary Send Email
     * @request POST:/email-customers/send
     * @secure
     */
    sendEmailEmailCustomersSendPost: (
      data: SendEmailPayload,
      params: RequestParams = {},
    ) =>
      this.request<SendEmailResponse, HTTPValidationError>({
        path: `/email-customers/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload an attachment ahead of email send. The returned attachment_id can be passed to POST /send via the attachment_ids field. Records auto-expire after 24 hours if not consumed.
     *
     * @tags Email Customers
     * @name UploadAttachmentEmailCustomersAttachmentsUploadPost
     * @summary Upload Attachment
     * @request POST:/email-customers/attachments/upload
     * @secure
     */
    uploadAttachmentEmailCustomersAttachmentsUploadPost: (
      data: BodyUploadAttachmentEmailCustomersAttachmentsUploadPost,
      params: RequestParams = {},
    ) =>
      this.request<UploadAttachmentResponse, HTTPValidationError>({
        path: `/email-customers/attachments/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Download an email attachment by attachment_id. If redirect=true, returns a 302 redirect to a presigned S3 URL (more efficient for large files). Otherwise proxies the binary content through the API.
     *
     * @tags Email Customers
     * @name DownloadAttachmentEmailCustomersAttachmentsAttachmentIdGet
     * @summary Download Attachment
     * @request GET:/email-customers/attachments/{attachment_id}
     * @secure
     */
    downloadAttachmentEmailCustomersAttachmentsAttachmentIdGet: (
      attachmentId: string,
      query?: {
        /**
         * Redirect
         * @default false
         */
        redirect?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/email-customers/attachments/${attachmentId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get full email content by email_id. Automatically marks the email as read by the requesting agent (first reader wins — read_at and agent_id are only set once and subsequent reads do not overwrite them).
     *
     * @tags Email Customers
     * @name GetEmailEmailCustomersEmailIdGet
     * @summary Get Email
     * @request GET:/email-customers/{email_id}
     * @secure
     */
    getEmailEmailCustomersEmailIdGet: (
      emailId: string,
      params: RequestParams = {},
    ) =>
      this.request<EmailDetail, HTTPValidationError>({
        path: `/email-customers/${emailId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Explicitly mark an email as read by the current agent.
     *
     * @tags Email Customers
     * @name MarkReadEmailCustomersMarkReadPost
     * @summary Mark Read
     * @request POST:/email-customers/mark-read
     * @secure
     */
    markReadEmailCustomersMarkReadPost: (
      data: MarkEmailReadPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/email-customers/mark-read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List email threads for a customer's inbox view. Returns thread summaries sorted by most recent activity.
     *
     * @tags Email Customers
     * @name ListThreadsEmailCustomersThreadsPost
     * @summary List Threads
     * @request POST:/email-customers/threads
     * @secure
     */
    listThreadsEmailCustomersThreadsPost: (
      query: {
        /** Customer Id */
        customer_id: string;
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 1
         * @max 50
         * @default 20
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThreadSummary[], HTTPValidationError>({
        path: `/email-customers/threads`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle Mandrill inbound email webhook for customer email integration. Receives inbound emails from Mandrill, matches the sender to a customer via KDLT email lookup, and stores the email in the email_customers_content collection. All raw webhook payloads are also stored in inbound_emails for audit. Mandrill may retry delivery, so we use a unique index on event_id to ensure idempotency.
     *
     * @tags Email Customers
     * @name EmailCustomersInboundEmailCustomersWebhookInboundPost
     * @summary Email Customers Inbound
     * @request POST:/email-customers/webhook/inbound
     */
    emailCustomersInboundEmailCustomersWebhookInboundPost: (
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/email-customers/webhook/inbound`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  caseDocuments = {
    /**
     * @description The documents of the case's applicant and co-applicant that are not deleted, newest first, from any of their MONO applications: `application_id` on each is the application it came from.
     *
     * @tags Case Documents
     * @name ListCaseDocumentsCaseDocumentsApplicationIdGet
     * @summary List Case Documents
     * @request GET:/case-documents/{application_id}
     * @secure
     */
    listCaseDocumentsCaseDocumentsApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<CaseDocument[], HTTPValidationError>({
        path: `/case-documents/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload a file of `customer_id` with the MONO case as its origin. `customer_id` must be the applicant or co-applicant (422). At most 20 MB (413, also for a larger Content-Length, before the body is read; 411 without one); PDF, JPEG, PNG, HEIC, DOCX or XLSX by extension and content (415).
     *
     * @tags Case Documents
     * @name UploadCaseDocumentCaseDocumentsApplicationIdPost
     * @summary Upload Case Document
     * @request POST:/case-documents/{application_id}
     * @secure
     */
    uploadCaseDocumentCaseDocumentsApplicationIdPost: (
      applicationId: string,
      data: BodyUploadCaseDocumentCaseDocumentsApplicationIdPost,
      params: RequestParams = {},
    ) =>
      this.request<CaseDocument, HTTPValidationError>({
        path: `/case-documents/${applicationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Save a copy of an attachment of a customer email as a document of `customer_id`, with the MONO case as its origin. The email must be on the case or from one of its applicants (403). Saving it again for the same customer, on this or another of their applications, returns the same document; a deleted one comes back with no bank shares. Inline images and attachments sent from a case document get 422; the file rules of an upload apply (413, 415).
     *
     * @tags Case Documents
     * @name SaveEmailAttachmentCaseDocumentsApplicationIdFromEmailPost
     * @summary Save Email Attachment
     * @request POST:/case-documents/{application_id}/from-email
     * @secure
     */
    saveEmailAttachmentCaseDocumentsApplicationIdFromEmailPost: (
      applicationId: string,
      data: SaveEmailAttachmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseDocument, HTTPValidationError>({
        path: `/case-documents/${applicationId}/from-email`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The file, always as a download with its stored type.
     *
     * @tags Case Documents
     * @name GetCaseDocumentContentCaseDocumentsApplicationIdDocumentIdContentGet
     * @summary Get Case Document Content
     * @request GET:/case-documents/{application_id}/{document_id}/content
     * @secure
     */
    getCaseDocumentContentCaseDocumentsApplicationIdDocumentIdContentGet: (
      applicationId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/case-documents/${applicationId}/${documentId}/content`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Attach the document to an outgoing email without copying the file: send the returned `attachment_id` in `attachment_ids` of `POST /email-customers/send`, as for an uploaded attachment. Only the same agent can send it. 404 for a deleted document or one of another customer.
     *
     * @tags Case Documents
     * @name AttachCaseDocumentToEmailCaseDocumentsApplicationIdDocumentIdEmailAttachmentPost
     * @summary Attach Case Document To Email
     * @request POST:/case-documents/{application_id}/{document_id}/email-attachment
     * @secure
     */
    attachCaseDocumentToEmailCaseDocumentsApplicationIdDocumentIdEmailAttachmentPost:
      (applicationId: string, documentId: string, params: RequestParams = {}) =>
        this.request<UploadAttachmentResponse, HTTPValidationError>({
          path: `/case-documents/${applicationId}/${documentId}/email-attachment`,
          method: "POST",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description Soft delete: the document is gone for its customer, on every case and in the bank portal; the file stays in storage.
     *
     * @tags Case Documents
     * @name DeleteCaseDocumentCaseDocumentsApplicationIdDocumentIdDelete
     * @summary Delete Case Document
     * @request DELETE:/case-documents/{application_id}/{document_id}
     * @secure
     */
    deleteCaseDocumentCaseDocumentsApplicationIdDocumentIdDelete: (
      applicationId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/case-documents/${applicationId}/${documentId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Share documents of the case's applicants with a bank on this application; the bank reads them in the NO bank portal on this application only, and its portal users get a mail with a link when the call shares at least one document. Only for applications created in ZRM and banks that got the application (422); 404, and nothing shared, when a document is not of an applicant or is deleted. Sharing again on this application keeps one share and sends no mail.
     *
     * @tags Case Documents
     * @name ShareCaseDocumentsCaseDocumentsApplicationIdSharePost
     * @summary Share Case Documents
     * @request POST:/case-documents/{application_id}/share
     * @secure
     */
    shareCaseDocumentsCaseDocumentsApplicationIdSharePost: (
      applicationId: string,
      data: ShareDocumentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ShareDocumentsResult, HTTPValidationError>({
        path: `/case-documents/${applicationId}/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description The bank no longer sees the document in the portal on this application.
     *
     * @tags Case Documents
     * @name UnshareCaseDocumentCaseDocumentsApplicationIdShareBankIdDocumentIdDelete
     * @summary Unshare Case Document
     * @request DELETE:/case-documents/{application_id}/share/{bank_id}/{document_id}
     * @secure
     */
    unshareCaseDocumentCaseDocumentsApplicationIdShareBankIdDocumentIdDelete: (
      applicationId: string,
      bankId: number,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/case-documents/${applicationId}/share/${bankId}/${documentId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  leftToLive = {
    /**
     * @description Zensum's own estimate of what the household has left to live on per month, computed from the case as it is now. A state of the case not recorded last is recorded. 503 when apps-mgr or KDLT does not answer.
     *
     * @tags LeftToLive
     * @name GetLeftToLiveEstimateLeftToLiveApplicationIdGet
     * @summary Get Left To Live Estimate
     * @request GET:/left-to-live/{application_id}
     * @secure
     */
    getLeftToLiveEstimateLeftToLiveApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<LeftToLiveEstimateResponse, HTTPValidationError>({
        path: `/left-to-live/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Change the household or an override line of the application's estimate; returns the estimate with it. A field left out stays, null resets it to its seed from the case (the main applicant's `cars_in_the_household` for the car). An override on housing or existing loans is 422: they are corrected on the case.
     *
     * @tags LeftToLive
     * @name UpdateLeftToLiveHouseholdLeftToLiveApplicationIdHouseholdPatch
     * @summary Update Left To Live Household
     * @request PATCH:/left-to-live/{application_id}/household
     * @secure
     */
    updateLeftToLiveHouseholdLeftToLiveApplicationIdHouseholdPatch: (
      applicationId: string,
      data: LeftToLiveEstimateHouseholdPatch,
      params: RequestParams = {},
    ) =>
      this.request<LeftToLiveEstimateResponse, HTTPValidationError>({
        path: `/left-to-live/${applicationId}/household`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  elk46 = {
    /**
     * @description Returns the last 100 simulated SMS ordered by newest first.
     *
     * @tags Simulator
     * @name ListSimulatedSmsElk46SimulatorGet
     * @summary List Simulated Sms
     * @request GET:/elk46/simulator
     * @secure
     */
    listSimulatedSmsElk46SimulatorGet: (params: RequestParams = {}) =>
      this.request<Record<string, any>[], any>({
        path: `/elk46/simulator`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Accepts the same form payload as 46elks and stores it in the database. Useful for testing and development without sending real SMS. Returns the created document with an assigned ID and status.
     *
     * @tags Simulator
     * @name SimulateSmsElk46SimulatorPost
     * @summary Simulate Sms
     * @request POST:/elk46/simulator
     * @secure
     */
    simulateSmsElk46SimulatorPost: (
      data: BodySimulateSmsElk46SimulatorPost,
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/elk46/simulator`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  bank = {
    /**
     * No description
     *
     * @tags Bank Login
     * @name LoginBankLoginPost
     * @summary Login
     * @request POST:/bank/login
     */
    loginBankLoginPost: (data: Login, params: RequestParams = {}) =>
      this.request<LoginResp, HTTPValidationError>({
        path: `/bank/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Login
     * @name ValidateOtpCodeBankLoginValidatePost
     * @summary Validate Otp Code
     * @request POST:/bank/login/validate
     */
    validateOtpCodeBankLoginValidatePost: (
      data: OTPValidation,
      params: RequestParams = {},
    ) =>
      this.request<OTPValidationResp, HTTPValidationError>({
        path: `/bank/login/validate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Login
     * @name SetNewPasswordBankSetPasswordPost
     * @summary Set New Password
     * @request POST:/bank/set-password
     */
    setNewPasswordBankSetPasswordPost: (
      data: SetPassword,
      params: RequestParams = {},
    ) =>
      this.request<SetPasswordResp, HTTPValidationError>({
        path: `/bank/set-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank Login
     * @name RequestNewOtpBankNewOtpPost
     * @summary Request New Otp
     * @request POST:/bank/new-otp
     */
    requestNewOtpBankNewOtpPost: (
      data: RequestNewOTP,
      params: RequestParams = {},
    ) =>
      this.request<SetPasswordResp, HTTPValidationError>({
        path: `/bank/new-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name CreateNewBankUserBankCreateUserPost
     * @summary Create New Bank User
     * @request POST:/bank/create-user
     * @secure
     */
    createNewBankUserBankCreateUserPost: (
      data: CreateUser,
      params: RequestParams = {},
    ) =>
      this.request<CreateUserResp, HTTPValidationError>({
        path: `/bank/create-user`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name GetBankUsersBankGetPost
     * @summary Get Bank Users
     * @request POST:/bank/get
     * @secure
     */
    getBankUsersBankGetPost: (
      data: GetUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<BankUserWithBankNames[], HTTPValidationError>({
        path: `/bank/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name GetBankUserBankUserIdGet
     * @summary Get Bank User
     * @request GET:/bank/{user_id}
     * @secure
     */
    getBankUserBankUserIdGet: (userId: string, params: RequestParams = {}) =>
      this.request<BankUserWithBankNames, HTTPValidationError>({
        path: `/bank/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name EditBankUserBankUserIdPut
     * @summary Edit Bank User
     * @request PUT:/bank/{user_id}
     * @secure
     */
    editBankUserBankUserIdPut: (
      userId: string,
      data: EditUser,
      params: RequestParams = {},
    ) =>
      this.request<BankUserWithBankNames, HTTPValidationError>({
        path: `/bank/${userId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name ResetBankUserPasswordBankResetPasswordPost
     * @summary Reset Bank User Password
     * @request POST:/bank/reset-password
     * @secure
     */
    resetBankUserPasswordBankResetPasswordPost: (
      data: ResetPasswordPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreateUserResp, HTTPValidationError>({
        path: `/bank/reset-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank User Administration
     * @name DeactivateBankUserBankDeactivatePut
     * @summary Deactivate Bank User
     * @request PUT:/bank/deactivate
     * @secure
     */
    deactivateBankUserBankDeactivatePut: (
      data: DeactivateUserPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/bank/deactivate`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetApplicationsBankApplicationsPost
     * @summary Get Applications
     * @request POST:/bank/applications
     * @secure
     */
    getApplicationsBankApplicationsPost: (
      data: GetApplications,
      params: RequestParams = {},
    ) =>
      this.request<BankBaseApp[], HTTPValidationError>({
        path: `/bank/applications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetApplicationBankApplicationApplicationIdGet
     * @summary Get Application
     * @request GET:/bank/application/{application_id}
     * @secure
     */
    getApplicationBankApplicationApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<BankBaseApp, HTTPValidationError>({
        path: `/bank/application/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet
     * @summary Get Document Meta
     * @request GET:/bank/document/meta/{customer_id}/{document_id}
     * @secure
     */
    getDocumentMetaBankDocumentMetaCustomerIdDocumentIdGet: (
      customerId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DocumentMeta, HTTPValidationError>({
        path: `/bank/document/meta/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetDocumentBankGetCustomerIdDocumentIdGet
     * @summary Get Document
     * @request GET:/bank/get/{customer_id}/{document_id}
     * @secure
     */
    getDocumentBankGetCustomerIdDocumentIdGet: (
      customerId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<CustomerDocument, HTTPValidationError>({
        path: `/bank/get/${customerId}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetAllBanksBankGetBanksPost
     * @summary Get All Banks
     * @request POST:/bank/get-banks
     * @secure
     */
    getAllBanksBankGetBanksPost: (
      data: GetBanksPayload,
      params: RequestParams = {},
    ) =>
      this.request<Bank[], HTTPValidationError>({
        path: `/bank/get-banks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetAppEventsBankGetAppEventsApplicationIdGet
     * @summary Get App Events
     * @request GET:/bank/get_app_events/{application_id}
     * @secure
     */
    getAppEventsBankGetAppEventsApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/bank/get_app_events/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name AddCommentBankCommentPost
     * @summary Add Comment
     * @request POST:/bank/comment
     * @secure
     */
    addCommentBankCommentPost: (
      data: BankCommentInput,
      params: RequestParams = {},
    ) =>
      this.request<EventsResponse, HTTPValidationError>({
        path: `/bank/comment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name AddCommentV2BankV2CommentPost
     * @summary Add Comment V2
     * @request POST:/bank/v2/comment
     * @secure
     */
    addCommentV2BankV2CommentPost: (
      data: BankCommentV2,
      params: RequestParams = {},
    ) =>
      this.request<Response, HTTPValidationError>({
        path: `/bank/v2/comment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name PostOfferBankOfferPost
     * @summary Post Offer
     * @request POST:/bank/offer
     * @secure
     */
    postOfferBankOfferPost: (
      data: BankOfferPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/bank/offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank, Application
     * @name RejectBankRejectPost
     * @summary Reject
     * @request POST:/bank/reject
     * @secure
     */
    rejectBankRejectPost: (
      data: BankRejectPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bank/reject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank, Application
     * @name DisburseBankDisbursePost
     * @summary Disburse
     * @request POST:/bank/disburse
     * @secure
     */
    disburseBankDisbursePost: (
      data: BankDisbursePayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bank/disburse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name SearchApplicationsBankSearchPost
     * @summary Search Applications
     * @request POST:/bank/search
     * @secure
     */
    searchApplicationsBankSearchPost: (
      data: RoutersBankPayloadsSearchPayload,
      query?: {
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * Limit
         * @min 0
         * @max 50
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BankBaseApp[], HTTPValidationError>({
        path: `/bank/search`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetApplicationsV2BankV2ApplicationsPost
     * @summary Get Applications V2
     * @request POST:/bank/v2/applications
     * @secure
     */
    getApplicationsV2BankV2ApplicationsPost: (
      data: BodyGetApplicationsV2BankV2ApplicationsPost,
      params: RequestParams = {},
    ) =>
      this.request<
        PageAnnotatedUnionBankBlancoApplicationBankMortgageApplicationBankApplicationCCNOFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorProduct,
        HTTPValidationError
      >({
        path: `/bank/v2/applications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank
     * @name GetApplicationV2BankV2ApplicationApplicationIdGet
     * @summary Get Application V2
     * @request GET:/bank/v2/application/{application_id}
     * @secure
     */
    getApplicationV2BankV2ApplicationApplicationIdGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        | ({
            product: "blanco";
          } & BankBlancoApplication)
        | ({
            product: "mortgage";
          } & BankMortgageApplication)
        | ({
            product: "credit_card";
          } & BankApplicationCCNO),
        HTTPValidationError
      >({
        path: `/bank/v2/application/${applicationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The documents that Zensum shared with the caller's bank on a MONO application, newest first.
     *
     * @tags Bank
     * @name ListCaseDocumentsForBankBankV2ApplicationApplicationIdDocumentsGet
     * @summary List Case Documents For Bank
     * @request GET:/bank/v2/application/{application_id}/documents
     * @secure
     */
    listCaseDocumentsForBankBankV2ApplicationApplicationIdDocumentsGet: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<BankCaseDocument[], HTTPValidationError>({
        path: `/bank/v2/application/${applicationId}/documents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload a file to a MONO application. It is shared with the caller's bank on this application only, and the case's handler is notified. At most 20 MB (413, also for a larger Content-Length, before the body is read; 411 without one); PDF, JPEG, PNG, HEIC, DOCX or XLSX by extension and content (415).
     *
     * @tags Bank
     * @name UploadCaseDocumentForBankBankV2ApplicationApplicationIdDocumentsPost
     * @summary Upload Case Document For Bank
     * @request POST:/bank/v2/application/{application_id}/documents
     * @secure
     */
    uploadCaseDocumentForBankBankV2ApplicationApplicationIdDocumentsPost: (
      applicationId: string,
      data: BodyUploadCaseDocumentForBankBankV2ApplicationApplicationIdDocumentsPost,
      params: RequestParams = {},
    ) =>
      this.request<BankCaseDocument, HTTPValidationError>({
        path: `/bank/v2/application/${applicationId}/documents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description The file, always as a download with its stored type. 404 unless it is shared with the caller's bank on this application.
     *
     * @tags Bank
     * @name GetCaseDocumentContentForBankBankV2ApplicationApplicationIdDocumentsDocumentIdContentGet
     * @summary Get Case Document Content For Bank
     * @request GET:/bank/v2/application/{application_id}/documents/{document_id}/content
     * @secure
     */
    getCaseDocumentContentForBankBankV2ApplicationApplicationIdDocumentsDocumentIdContentGet:
      (applicationId: string, documentId: string, params: RequestParams = {}) =>
        this.request<any, HTTPValidationError>({
          path: `/bank/v2/application/${applicationId}/documents/${documentId}/content`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description Find applications by the encoded id the portal shows, or by the applicant's PNI. Access is not decided here: every candidate is read back through the same bank-scoped apps-mgr call the details page uses, which 404s for an application the bank is not on.
     *
     * @tags Bank
     * @name SearchApplicationsV2BankV2SearchPost
     * @summary Search Applications V2
     * @request POST:/bank/v2/search
     * @secure
     */
    searchApplicationsV2BankV2SearchPost: (
      data: RoutersBankPayloadsSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        (
          | ({
              product: "blanco";
            } & BankBlancoApplication)
          | ({
              product: "mortgage";
            } & BankMortgageApplication)
          | ({
              product: "credit_card";
            } & BankApplicationCCNO)
        )[],
        HTTPValidationError
      >({
        path: `/bank/v2/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  bankv2 = {
    /**
     * No description
     *
     * @tags Bank, Application
     * @name RejectV2Bankv2RejectPost
     * @summary Reject V2
     * @request POST:/bankv2/reject
     * @secure
     */
    rejectV2Bankv2RejectPost: (
      data: RejectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bankv2/reject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank, Application
     * @name DisburseV2Bankv2DisbursePost
     * @summary Disburse V2
     * @request POST:/bankv2/disburse
     * @secure
     */
    disburseV2Bankv2DisbursePost: (
      data: DisbursementPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bankv2/disburse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bank, Application
     * @name AddOfferV2Bankv2AddOfferPost
     * @summary Add Offer V2
     * @request POST:/bankv2/add-offer
     * @secure
     */
    addOfferV2Bankv2AddOfferPost: (
      data: AddOfferPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/bankv2/add-offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  jotform = {
    /**
     * No description
     *
     * @tags Jotform
     * @name SubmissionJotformWebhookFormIdPost
     * @summary Submission
     * @request POST:/jotform/webhook/{form_id}
     */
    submissionJotformWebhookFormIdPost: (
      formId: string,
      data: BodySubmissionJotformWebhookFormIdPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/jotform/webhook/${formId}`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  campaign = {
    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateCampaignInitializedEventCampaignCampaignIdGet
     * @summary Create Campaign Initialized Event
     * @request GET:/campaign/{campaign_id}
     */
    createCampaignInitializedEventCampaignCampaignIdGet: (
      campaignId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/campaign/${campaignId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  visit = {
    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateVisitEventVisitCountryZidPost
     * @summary Create Visit Event
     * @request POST:/visit/{country}/{zid}
     */
    createVisitEventVisitCountryZidPost: (
      country: Country,
      zid: string,
      data: WebsiteVisitPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/visit/${country}/${zid}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  v2 = {
    /**
     * No description
     *
     * @tags Affiliate
     * @name CreateWebsiteVisitEventV2VisitCountryPost
     * @summary Create Website Visit Event
     * @request POST:/v2/visit/{country}
     */
    createWebsiteVisitEventV2VisitCountryPost: (
      country: Country,
      data: WebsiteVisitPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/v2/visit/${country}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  simulator = {
    /**
     * @description Upload test lead data for campaign extraction simulation.
     *
     * @tags Simulator
     * @name UploadLeadsSimulatorBqLeadsPost
     * @summary Upload Leads
     * @request POST:/simulator/bq/leads
     */
    uploadLeadsSimulatorBqLeadsPost: (
      data: UploadLeadsPayload,
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/simulator/bq/leads`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List stored simulated leads.
     *
     * @tags Simulator
     * @name ListLeadsSimulatorBqLeadsGet
     * @summary List Leads
     * @request GET:/simulator/bq/leads
     */
    listLeadsSimulatorBqLeadsGet: (
      query?: {
        /**
         * Dataset
         * @default "simulator"
         */
        dataset?: string;
        /**
         * Limit
         * @max 500
         * @default 50
         */
        limit?: number;
        /**
         * Page
         * @min 0
         * @default 0
         */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>[], HTTPValidationError>({
        path: `/simulator/bq/leads`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Clear all simulated leads in a dataset.
     *
     * @tags Simulator
     * @name ClearLeadsSimulatorBqLeadsDelete
     * @summary Clear Leads
     * @request DELETE:/simulator/bq/leads
     */
    clearLeadsSimulatorBqLeadsDelete: (
      query?: {
        /**
         * Dataset
         * @default "simulator"
         */
        dataset?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, string>, HTTPValidationError>({
        path: `/simulator/bq/leads`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Count leads in a dataset.
     *
     * @tags Simulator
     * @name CountLeadsSimulatorBqLeadsCountGet
     * @summary Count Leads
     * @request GET:/simulator/bq/leads/count
     */
    countLeadsSimulatorBqLeadsCountGet: (
      query?: {
        /**
         * Dataset
         * @default "simulator"
         */
        dataset?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BankCommunicationData, HTTPValidationError>({
        path: `/simulator/bq/leads/count`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  slack = {
    /**
     * No description
     *
     * @tags Slack
     * @name SlackCallbackSlackCallbackPost
     * @summary Slack Callback
     * @request POST:/slack/callback
     */
    slackCallbackSlackCallbackPost: (
      data: BodySlackCallbackSlackCallbackPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/slack/callback`,
        method: "POST",
        body: data,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * @description Slack Events API receiver for the internal support bot. Must ack within ~3s, so it only does cheap synchronous work: verify the request signature, answer the url_verification challenge, drop ineligible messages, dedupe retries, and enqueue eligible messages for the RQ worker that runs the Claude tool-loop.
     *
     * @tags Slack
     * @name SlackEventsSlackEventsPost
     * @summary Slack Events
     * @request POST:/slack/events
     */
    slackEventsSlackEventsPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/slack/events`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  dialMaker2 = {
    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name GetImageDialMaker2ImageGet
     * @summary Get Image
     * @request GET:/dial-maker2/image
     */
    getImageDialMaker2ImageGet: (
      query: {
        /** File Id */
        file_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/dial-maker2/image`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dial Maker 2
     * @name DownloadLeadsXlsxDialMaker2ExportDownloadSignatureGet
     * @summary Download Leads Xlsx
     * @request GET:/dial-maker2/export/download/{signature}
     */
    downloadLeadsXlsxDialMaker2ExportDownloadSignatureGet: (
      signature: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/dial-maker2/export/download/${signature}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  wellKnown = {
    /**
     * No description
     *
     * @tags Well known
     * @name GetJwksWellKnownJwksJsonGet
     * @summary Get Jwks
     * @request GET:/.well-known/jwks.json
     */
    getJwksWellKnownJwksJsonGet: (params: RequestParams = {}) =>
      this.request<BankCommunicationData, any>({
        path: `/.well-known/jwks.json`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  health = {
    /**
     * No description
     *
     * @tags Health
     * @name GetHealthHealthGet
     * @summary Get Health
     * @request GET:/health
     */
    getHealthHealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  validator = {
    /**
     * No description
     *
     * @tags Validator
     * @name ValidateValidatorPost
     * @summary Validate
     * @request POST:/validator/
     */
    validateValidatorPost: (
      data:
        | Email
        | PNI
        | ModelsValidatorServicePayloadPhoneNumber
        | BankAccount,
      params: RequestParams = {},
    ) =>
      this.request<ValidatorServiceResponseModel, HTTPValidationError>({
        path: `/validator/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Validator
     * @name ValidateValidatorPost2
     * @summary Validate
     * @request POST:/validator
     * @originalName validateValidatorPost
     * @duplicate
     */
    validateValidatorPost2: (
      data:
        | Email
        | PNI
        | ModelsValidatorServicePayloadPhoneNumber
        | BankAccount,
      params: RequestParams = {},
    ) =>
      this.request<ValidatorServiceResponseModel, HTTPValidationError>({
        path: `/validator`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Validator
     * @name ValidateSafelyValidatorSafePost
     * @summary Validate Safely
     * @request POST:/validator/safe/
     */
    validateSafelyValidatorSafePost: (
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<ValidatorServiceResponseModel, HTTPValidationError>({
        path: `/validator/safe/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Validator
     * @name ValidateSafelyValidatorSafePost2
     * @summary Validate Safely
     * @request POST:/validator/safe
     * @originalName validateSafelyValidatorSafePost
     * @duplicate
     */
    validateSafelyValidatorSafePost2: (
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<ValidatorServiceResponseModel, HTTPValidationError>({
        path: `/validator/safe`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  mandrill = {
    /**
     * No description
     *
     * @tags Mail Webhook
     * @name MessageOpenedMandrillWebhookMessagePost
     * @summary Message Opened
     * @request POST:/mandrill/webhook/message
     */
    messageOpenedMandrillWebhookMessagePost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/mandrill/webhook/message`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mail Webhook
     * @name UnsubscribeMandrillWebhookUnsubscribePost
     * @summary Unsubscribe
     * @request POST:/mandrill/webhook/unsubscribe
     */
    unsubscribeMandrillWebhookUnsubscribePost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/mandrill/webhook/unsubscribe`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Handle Mandrill inbound email webhook and forward emails. This endpoint receives inbound emails from Mandrill, routes them based on the from_email, appends a datetime to the subject, and forwards them with all attachments included. Later on this can be used to attach customer context to the forwarded emails. But also, to route to a specific handler. All the incoming emails are stored in the 'inbound_emails' collection in MongoDB for future reference. This endpoint process all incoming emails at *@systems.zensum.se. Which are mostly emails generated from 3rd party systems like Telavox voicemails.
     *
     * @tags Mail Webhook
     * @name InboundEmailMandrillWebhookInboundPost
     * @summary Inbound Email
     * @request POST:/mandrill/webhook/inbound
     */
    inboundEmailMandrillWebhookInboundPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/mandrill/webhook/inbound`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  mail = {
    /**
     * No description
     *
     * @tags MailMaker
     * @name UnsubscribeFromMailMarketingMailPublicUnsubscribePost
     * @summary Unsubscribe From Mail Marketing
     * @request POST:/mail/public/unsubscribe
     */
    unsubscribeFromMailMarketingMailPublicUnsubscribePost: (
      query: {
        /** Mail Key */
        mail_key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/mail/public/unsubscribe`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MailMaker
     * @name UnsubscribeFromSmsMarketingMailPublicUnsubscribeSmsPost
     * @summary Unsubscribe From Sms Marketing
     * @request POST:/mail/public/unsubscribe-sms
     */
    unsubscribeFromSmsMarketingMailPublicUnsubscribeSmsPost: (
      query: {
        /** Sms Key */
        sms_key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/mail/public/unsubscribe-sms`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),
  };
  p = {
    /**
     * No description
     *
     * @tags URL Tracker
     * @name ForwardToTargetUrlPUrlKeyPathGet
     * @summary Forward To Target Url
     * @request GET:/p/{url_key}/{path}
     */
    forwardToTargetUrlPUrlKeyPathGet: (
      urlKey: string,
      path: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/p/${urlKey}/${path}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  t = {
    /**
     * No description
     *
     * @tags Transactional URL Tracker
     * @name RedirectToTargetUrlTFullPathGet
     * @summary Redirect To Target Url
     * @request GET:/t/{full_path}
     */
    redirectToTargetUrlTFullPathGet: (
      fullPath: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/t/${fullPath}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  u = {
    /**
     * No description
     *
     * @tags Unsubscribe marketing
     * @name UnsubscribeEmailUMessageTrackingKeyPost
     * @summary Unsubscribe Email
     * @request POST:/u/{message_tracking_key}
     */
    unsubscribeEmailUMessageTrackingKeyPost: (
      messageTrackingKey: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/u/${messageTrackingKey}`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  formAnalytics = {
    /**
     * No description
     *
     * @tags Online
     * @name StoreEventsFormAnalyticsStoreEventsPost
     * @summary Store Events
     * @request POST:/form-analytics/store-events
     */
    storeEventsFormAnalyticsStoreEventsPost: (
      data: BodyStoreEventsFormAnalyticsStoreEventsPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/form-analytics/store-events`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  formAbandoned = {
    /**
     * No description
     *
     * @tags Online
     * @name StoreFormFormAbandonedPost
     * @summary Store Form
     * @request POST:/form-abandoned/
     */
    storeFormFormAbandonedPost: (
      data: BodyStoreFormFormAbandonedPost,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/form-abandoned/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Online
     * @name RestoreFormFormAbandonedRestoreFillingIdGet
     * @summary Restore Form
     * @request GET:/form-abandoned/restore/{filling_id}
     */
    restoreFormFormAbandonedRestoreFillingIdGet: (
      fillingId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any> | null, HTTPValidationError>({
        path: `/form-abandoned/restore/${fillingId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Since the data is not validated when incoming, as fields are optional. We need fallbacks in place for customers to always end up on a marketing page, not a 500 error.
     *
     * @tags Online
     * @name RedirectToProperFormFormAbandonedFillingIdGet
     * @summary Redirect To Proper Form
     * @request GET:/form-abandoned/{filling_id}
     */
    redirectToProperFormFormAbandonedFillingIdGet: (
      fillingId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/form-abandoned/${fillingId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  infra = {
    /**
     * No description
     *
     * @tags Other
     * @name Auth0EventsProxyInfraAuth0EventsPost
     * @summary Auth0 Events Proxy
     * @request POST:/infra/auth0/events
     * @secure
     */
    auth0EventsProxyInfraAuth0EventsPost: (
      data: Record<string, any>[],
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/infra/auth0/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  callmaker = {
    /**
     * No description
     *
     * @tags Callmaker Callbacks
     * @name GetCallmakerDataCallmakerCallbackCallPost
     * @summary Get Callmaker Data
     * @request POST:/callmaker/callback/call
     * @secure
     */
    getCallmakerDataCallmakerCallbackCallPost: (
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/callmaker/callback/call`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Callmaker Callbacks
     * @name GetProcessedDataCallmakerCallbackProcessPost
     * @summary Get Processed Data
     * @request POST:/callmaker/callback/process
     * @secure
     */
    getProcessedDataCallmakerCallbackProcessPost: (
      data: BankCommunicationData,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/callmaker/callback/process`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  v1 = {
    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name CreateBlancoApplicationV1AffiliateApplicationsBlancoPost
     * @summary Create Blanco Application
     * @request POST:/v1/affiliate/applications/blanco
     * @secure
     */
    createBlancoApplicationV1AffiliateApplicationsBlancoPost: (
      data: AffiliateCreateBlancoApplication,
      params: RequestParams = {},
    ) =>
      this.request<AffiliateResponse, HTTPValidationError>({
        path: `/v1/affiliate/applications/blanco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetBookingsBlancoV1AffiliateBookingsBlancoGet
     * @summary Get Bookings Blanco
     * @request GET:/v1/affiliate/bookings/blanco
     * @secure
     */
    getBookingsBlancoV1AffiliateBookingsBlancoGet: (
      query: {
        /**
         * Start Date
         * @format date
         */
        start_date: string;
        /**
         * End Date
         * @format date
         */
        end_date: string;
        country: Country;
      },
      params: RequestParams = {},
    ) =>
      this.request<AvailableBookings, HTTPValidationError>({
        path: `/v1/affiliate/bookings/blanco`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name CreateMortgageLeadV1AffiliateLeadsMortgagePost
     * @summary Create Mortgage Lead
     * @request POST:/v1/affiliate/leads/mortgage
     * @secure
     */
    createMortgageLeadV1AffiliateLeadsMortgagePost: (
      data: AffiliateLeadCreationPayload,
      params: RequestParams = {},
    ) =>
      this.request<AffiliateResponse, HTTPValidationError>({
        path: `/v1/affiliate/leads/mortgage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetBookingsMortgageV1AffiliateBookingsMortgageGet
     * @summary Get Bookings Mortgage
     * @request GET:/v1/affiliate/bookings/mortgage
     * @secure
     */
    getBookingsMortgageV1AffiliateBookingsMortgageGet: (
      query: {
        /**
         * Start Date
         * @format date
         */
        start_date: string;
        /**
         * End Date
         * @format date
         */
        end_date: string;
        country: Country;
      },
      params: RequestParams = {},
    ) =>
      this.request<AvailableBookings, HTTPValidationError>({
        path: `/v1/affiliate/bookings/mortgage`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns all allowed enum values
     *
     * @tags V1 Affiliate API
     * @name GetOptionsV1AffiliateOptionsCountryProductGet
     * @summary Get Options
     * @request GET:/v1/affiliate/options/{country}/{product}
     * @secure
     */
    getOptionsV1AffiliateOptionsCountryProductGet: (
      country: Country,
      product: Product,
      params: RequestParams = {},
    ) =>
      this.request<AffiliateOptionsResponse, HTTPValidationError>({
        path: `/v1/affiliate/options/${country}/${product}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet
     * @summary Get Blanco Status
     * @request GET:/v1/affiliate/applications/blanco/{submission_id}
     * @secure
     */
    getBlancoStatusV1AffiliateApplicationsBlancoSubmissionIdGet: (
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<AffiliateCallback, HTTPValidationError>({
        path: `/v1/affiliate/applications/blanco/${submissionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V1 Affiliate API
     * @name GetMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet
     * @summary Get Mortgage Status
     * @request GET:/v1/affiliate/leads/mortgage/{submission_id}
     * @secure
     */
    getMortgageStatusV1AffiliateLeadsMortgageSubmissionIdGet: (
      submissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<AffiliateCallback, HTTPValidationError>({
        path: `/v1/affiliate/leads/mortgage/${submissionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  lateRejection = {
    /**
     * No description
     *
     * @tags Late Rejection
     * @name IncomingLateRejectionLateRejectionIncomingPost
     * @summary Incoming Late Rejection
     * @request POST:/late-rejection/incoming
     * @secure
     */
    incomingLateRejectionLateRejectionIncomingPost: (
      data: LateRejectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/late-rejection/incoming`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  zhatter = {
    /**
     * @description Send a Zhatter message and receive a streaming SSE response.
     *
     * @tags Zhatter
     * @name SendMessageZhatterMessagePost
     * @summary Send Message
     * @request POST:/zhatter/message
     * @secure
     */
    sendMessageZhatterMessagePost: (
      data: ZhatterMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/zhatter/message`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Grant Gjeldsregisteret consent for the current customer.
     *
     * @tags Zhatter
     * @name GrantGrConsentZhatterGrConsentPost
     * @summary Grant Gr Consent
     * @request POST:/zhatter/gr-consent
     * @secure
     */
    grantGrConsentZhatterGrConsentPost: (
      data: GrConsentRequest,
      params: RequestParams = {},
    ) =>
      this.request<GrConsentResponse, HTTPValidationError>({
        path: `/zhatter/gr-consent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Accept a loan offer on behalf of the authenticated customer.
     *
     * @tags Zhatter
     * @name AcceptOfferZhatterAcceptOfferPost
     * @summary Accept Offer
     * @request POST:/zhatter/accept-offer
     * @secure
     */
    acceptOfferZhatterAcceptOfferPost: (
      data: AcceptOfferRequest,
      params: RequestParams = {},
    ) =>
      this.request<AcceptOfferResponse, HTTPValidationError>({
        path: `/zhatter/accept-offer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List the customer's recent chat sessions.
     *
     * @tags Zhatter
     * @name ListSessionsZhatterSessionsGet
     * @summary List Sessions
     * @request GET:/zhatter/sessions
     * @secure
     */
    listSessionsZhatterSessionsGet: (params: RequestParams = {}) =>
      this.request<SessionSummary[], any>({
        path: `/zhatter/sessions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Return the session's chat turns — the bubbles the UI renders, nothing else. `messages` holds the whole model conversation, so it is projected through `session_store.renderable_chat_records` first: tool replies and developer-role UI-action facts are model input and must never leave the backend.
     *
     * @tags Zhatter
     * @name GetSessionMessagesZhatterSessionsSessionIdMessagesGet
     * @summary Get Session Messages
     * @request GET:/zhatter/sessions/{session_id}/messages
     * @secure
     */
    getSessionMessagesZhatterSessionsSessionIdMessagesGet: (
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<StoredMessage[], HTTPValidationError>({
        path: `/zhatter/sessions/${sessionId}/messages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Help endpoint to list available SSE events.
     *
     * @tags Zhatter
     * @name EventsZhatterEventsGet
     * @summary Events
     * @request GET:/zhatter/events
     * @secure
     */
    eventsZhatterEventsGet: (params: RequestParams = {}) =>
      this.request<ZhatterSSEEvent, any>({
        path: `/zhatter/events`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Schema endpoint — exposes SSE response types in OpenAPI spec.
     *
     * @tags Zhatter
     * @name ResponsesZhatterResponsesGet
     * @summary Responses
     * @request GET:/zhatter/responses
     * @secure
     */
    responsesZhatterResponsesGet: (params: RequestParams = {}) =>
      this.request<
        | ZhatterSessionResponse
        | ZhatterTokenResponse
        | ZhatterToolCallResponse
        | ZhatterToolResultResponse
        | ZhatterActionResponse
        | ZhatterDoneResponse
        | ZhatterErrorResponse,
        any
      >({
        path: `/zhatter/responses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
